/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: any;
  date: any;
  json: any;
  jsonb: any;
  numeric: any;
  timestamptz: any;
  uuid: any;
};

export type AdditionalDataInput = {
  ad_id?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country_code?: InputMaybe<Scalars['String']>;
  date_of_birth?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emirates_id?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  pay_source?: InputMaybe<Scalars['String']>;
  payment_system_type?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  request_data?: InputMaybe<RequestDataInput>;
};

export type AdditionalDataWithdrawInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type AnH2HInfoOutput = {
  amount?: Maybe<Scalars['numeric']>;
  confirmed_at?: Maybe<Scalars['String']>;
  currency_id: Scalars['String'];
  expired_at?: Maybe<Scalars['String']>;
  external_id: Scalars['String'];
  iban?: Maybe<Scalars['String']>;
  invoice_id?: Maybe<Scalars['String']>;
  redirect_failed_url?: Maybe<Scalars['String']>;
  redirect_success_url?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  transaction_uid: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type AnInternalBalancesOutput = {
  amount: Scalars['numeric'];
  currency: Scalars['String'];
  holdAmount: Scalars['numeric'];
  inflight: Scalars['numeric'];
};

export type AnP2PRequestOutOutput = {
  amount: Scalars['String'];
  bank_name?: Maybe<Array<Scalars['String']>>;
  currency: Scalars['String'];
};

export type AnalyticsConsolidatedReportApprovedTransactionResponse = {
  amount: Scalars['numeric'];
  count: Scalars['Int'];
};

export type AnalyticsConsolidatedReportChargebackResponse = {
  amount: Scalars['numeric'];
  count: Scalars['Int'];
  fee: Scalars['numeric'];
};

export type AnalyticsConsolidatedReportDeclineTransactionFeesResponse = {
  count: Scalars['Int'];
  fee: Scalars['numeric'];
};

export type AnalyticsConsolidatedReportFailedTransactionResponse = {
  amount: Scalars['numeric'];
  count: Scalars['Int'];
};

export type AnalyticsConsolidatedReportFilterResponse = {
  currency_id: Scalars['String'];
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  gate_group_id?: Maybe<Scalars['String']>;
  gate_id?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
  provider_id?: Maybe<Scalars['String']>;
};

export type AnalyticsConsolidatedReportGeneralCurrencyIdResponse = {
  currency_id: Scalars['String'];
  data?: Maybe<Array<Maybe<AnalyticsConsolidatedReportGeneralGateIdResponse>>>;
};

export type AnalyticsConsolidatedReportGeneralFilterResponse = {
  currency_id?: Maybe<Scalars['String']>;
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  gate_group_id?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
  provider_family_id?: Maybe<Scalars['String']>;
  provider_ids?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AnalyticsConsolidatedReportGeneralGateGroupResponse = {
  gate_group_id: Scalars['String'];
  gate_group_name: Scalars['String'];
  gate_type_id: Scalars['String'];
};

export type AnalyticsConsolidatedReportGeneralGateIdResponse = {
  data?: Maybe<AnalyticsConsolidatedReportGeneralMainDataResponse>;
  gate_group?: Maybe<AnalyticsConsolidatedReportGeneralGateGroupResponse>;
  gate_id: Scalars['String'];
};

export type AnalyticsConsolidatedReportGeneralMainDataApprovedTransactionResponse = {
  amount: Scalars['numeric'];
  count: Scalars['Int'];
};

export type AnalyticsConsolidatedReportGeneralMainDataChargebackResponse = {
  amount: Scalars['numeric'];
  count: Scalars['Int'];
  fee: Scalars['numeric'];
};

export type AnalyticsConsolidatedReportGeneralMainDataDeclineTransactionFeesResponse = {
  count: Scalars['Int'];
  fee: Scalars['numeric'];
};

export type AnalyticsConsolidatedReportGeneralMainDataFailedTransactionResponse = {
  amount: Scalars['numeric'];
  count: Scalars['Int'];
};

export type AnalyticsConsolidatedReportGeneralMainDataProcessingFeesResponse = {
  fee: Scalars['numeric'];
  rate: Scalars['Int'];
};

export type AnalyticsConsolidatedReportGeneralMainDataRefundResponse = {
  amount: Scalars['numeric'];
  count: Scalars['Int'];
  fee: Scalars['numeric'];
};

export type AnalyticsConsolidatedReportGeneralMainDataResponse = {
  approved_transaction: AnalyticsConsolidatedReportGeneralMainDataApprovedTransactionResponse;
  chargeback: AnalyticsConsolidatedReportGeneralMainDataChargebackResponse;
  decline_transaction_fees: AnalyticsConsolidatedReportGeneralMainDataDeclineTransactionFeesResponse;
  failed_transaction: AnalyticsConsolidatedReportGeneralMainDataFailedTransactionResponse;
  processing_fees: AnalyticsConsolidatedReportGeneralMainDataProcessingFeesResponse;
  refund: AnalyticsConsolidatedReportGeneralMainDataRefundResponse;
  rolling_reserve: AnalyticsConsolidatedReportGeneralMainDataRollingReserveResponse;
  rolling_reserve_unhold: AnalyticsConsolidatedReportGeneralMainDataRollingReserveUnholdResponse;
  settlement: AnalyticsConsolidatedReportGeneralMainDataSettlementResponse;
  to_be_settled: AnalyticsConsolidatedReportGeneralMainDataToBeSettledResponse;
  transaction_fees: AnalyticsConsolidatedReportGeneralMainDataTransactionFeesResponse;
  withdraw_approved_transaction: AnalyticsConsolidatedReportGeneralMainDataWithdrawApprovedTransactionResponse;
  withdraw_decline_transaction_fees: AnalyticsConsolidatedReportGeneralMainDataWithdrawDeclineTransactionFeesResponse;
  withdraw_failed_transaction: AnalyticsConsolidatedReportGeneralMainDataWithdrawFailedTransactionResponse;
  withdraw_processing_fees: AnalyticsConsolidatedReportGeneralMainDataWithdrawProcessingFeesResponse;
  withdraw_transaction_fees: AnalyticsConsolidatedReportGeneralMainDataWithdrawTransactionFeesResponse;
};

export type AnalyticsConsolidatedReportGeneralMainDataRollingReserveResponse = {
  rr_percent: Scalars['Int'];
  rr_value: Scalars['numeric'];
};

export type AnalyticsConsolidatedReportGeneralMainDataRollingReserveUnholdResponse = {
  amount: Scalars['numeric'];
};

export type AnalyticsConsolidatedReportGeneralMainDataSettlementResponse = {
  fee: Scalars['numeric'];
  value: Scalars['numeric'];
};

export type AnalyticsConsolidatedReportGeneralMainDataToBeSettledResponse = {
  rate: Scalars['Int'];
  value: Scalars['numeric'];
};

export type AnalyticsConsolidatedReportGeneralMainDataTransactionFeesResponse = {
  count: Scalars['Int'];
  fee: Scalars['numeric'];
};

export type AnalyticsConsolidatedReportGeneralMainDataWithdrawApprovedTransactionResponse = {
  amount: Scalars['numeric'];
  count: Scalars['Int'];
};

export type AnalyticsConsolidatedReportGeneralMainDataWithdrawDeclineTransactionFeesResponse = {
  count: Scalars['Int'];
  fee: Scalars['numeric'];
};

export type AnalyticsConsolidatedReportGeneralMainDataWithdrawFailedTransactionResponse = {
  amount: Scalars['numeric'];
  count: Scalars['Int'];
};

export type AnalyticsConsolidatedReportGeneralMainDataWithdrawProcessingFeesResponse = {
  fee: Scalars['numeric'];
  rate: Scalars['Int'];
};

export type AnalyticsConsolidatedReportGeneralMainDataWithdrawTransactionFeesResponse = {
  count: Scalars['Int'];
  fee: Scalars['numeric'];
};

export type AnalyticsConsolidatedReportGeneralMerchantInfoResponse = {
  company_name: Scalars['String'];
};

export type AnalyticsConsolidatedReportGeneralMerchantResponse = {
  data?: Maybe<Array<Maybe<AnalyticsConsolidatedReportGeneralProviderIdResponse>>>;
  merchant_id: Scalars['Int'];
  merchant_info?: Maybe<AnalyticsConsolidatedReportGeneralMerchantInfoResponse>;
};

export type AnalyticsConsolidatedReportGeneralProviderIdResponse = {
  data?: Maybe<Array<Maybe<AnalyticsConsolidatedReportGeneralCurrencyIdResponse>>>;
  provider_id: Scalars['String'];
};

export type AnalyticsConsolidatedReportGeneralResponse = {
  data?: Maybe<Array<Maybe<AnalyticsConsolidatedReportGeneralMerchantResponse>>>;
  filter: AnalyticsConsolidatedReportGeneralFilterResponse;
};

export type AnalyticsConsolidatedReportProcessingFeesResponse = {
  fee: Scalars['numeric'];
  rate: Scalars['Int'];
};

export type AnalyticsConsolidatedReportRefundResponse = {
  amount: Scalars['numeric'];
  count: Scalars['Int'];
  fee: Scalars['numeric'];
};

export type AnalyticsConsolidatedReportResponse = {
  approved_transaction: AnalyticsConsolidatedReportApprovedTransactionResponse;
  chargeback: AnalyticsConsolidatedReportChargebackResponse;
  decline_transaction_fees: AnalyticsConsolidatedReportDeclineTransactionFeesResponse;
  failed_transaction: AnalyticsConsolidatedReportFailedTransactionResponse;
  filter: AnalyticsConsolidatedReportFilterResponse;
  processing_fees: AnalyticsConsolidatedReportProcessingFeesResponse;
  refund: AnalyticsConsolidatedReportRefundResponse;
  rolling_reserve: AnalyticsConsolidatedReportRollingReserveResponse;
  rolling_reserve_unhold: AnalyticsConsolidatedReportRollingReserveUnholdResponse;
  settlement: AnalyticsConsolidatedReportSettlementResponse;
  to_be_settled: AnalyticsConsolidatedReportToBeSettledResponse;
  transaction_fees: AnalyticsConsolidatedReportTransactionFeesResponse;
  withdraw_approved_transaction: AnalyticsConsolidatedReportWithdrawApprovedTransactionResponse;
  withdraw_decline_transaction_fees: AnalyticsConsolidatedReportWithdrawDeclineTransactionFeesResponse;
  withdraw_failed_transaction: AnalyticsConsolidatedReportWithdrawFailedTransactionResponse;
  withdraw_processing_fees: AnalyticsConsolidatedReportWithdrawProcessingFeesResponse;
  withdraw_transaction_fees: AnalyticsConsolidatedReportWithdrawTransactionFeesResponse;
};

export type AnalyticsConsolidatedReportRollingReserveResponse = {
  rr_percent: Scalars['Int'];
  rr_value: Scalars['numeric'];
};

export type AnalyticsConsolidatedReportRollingReserveUnholdResponse = {
  amount: Scalars['numeric'];
};

export type AnalyticsConsolidatedReportSettlementResponse = {
  fee: Scalars['numeric'];
  value: Scalars['numeric'];
};

export type AnalyticsConsolidatedReportToBeSettledResponse = {
  rate: Scalars['Int'];
  value: Scalars['numeric'];
};

export type AnalyticsConsolidatedReportTransactionFeesResponse = {
  count: Scalars['Int'];
  fee: Scalars['numeric'];
};

export type AnalyticsConsolidatedReportWithdrawApprovedTransactionResponse = {
  amount: Scalars['numeric'];
  count: Scalars['Int'];
};

export type AnalyticsConsolidatedReportWithdrawDeclineTransactionFeesResponse = {
  count: Scalars['Int'];
  fee: Scalars['numeric'];
};

export type AnalyticsConsolidatedReportWithdrawFailedTransactionResponse = {
  amount: Scalars['numeric'];
  count: Scalars['Int'];
};

export type AnalyticsConsolidatedReportWithdrawProcessingFeesResponse = {
  fee: Scalars['numeric'];
  rate: Scalars['Int'];
};

export type AnalyticsConsolidatedReportWithdrawTransactionFeesResponse = {
  count: Scalars['Int'];
  fee: Scalars['numeric'];
};

export type AnalyticsProviderFamilyBalancesAccountsOutput = {
  balance: Scalars['String'];
  hold_balance: Scalars['String'];
  provider_id: Scalars['String'];
};

export type AnalyticsProviderFamilyBalancesAggregateOutput = {
  count: Scalars['Int'];
};

export type AnalyticsProviderFamilyBalancesAnalyticsOutput = {
  currencies?: Maybe<Array<Maybe<AnalyticsProviderFamilyBalancesCurrenciesOutput>>>;
};

export type AnalyticsProviderFamilyBalancesCurrenciesOutput = {
  accounts?: Maybe<Array<Maybe<AnalyticsProviderFamilyBalancesAccountsOutput>>>;
  currency_id: Scalars['String'];
  total_balance: Scalars['String'];
  total_hold_balance: Scalars['String'];
};

export type AnalyticsProviderFamilyBalancesItemOutput = {
  analytics?: Maybe<AnalyticsProviderFamilyBalancesAnalyticsOutput>;
  provider_family_id: Scalars['String'];
};

export type AnalyticsProviderFamilyBalancesOutput = {
  provider_family_balance?: Maybe<Array<Maybe<AnalyticsProviderFamilyBalancesItemOutput>>>;
  provider_family_balance_aggregate: AnalyticsProviderFamilyBalancesAggregateOutput;
};

export type AnalyticsProviderFamilyBalancesWhereInput = {
  currency_id?: InputMaybe<Scalars['String']>;
  merchant_type_id?: InputMaybe<Scalars['String']>;
  provider_family_id?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
};

export type AnalyticsWidgetGeneralInfo = {
  invoice_amount?: Maybe<Scalars['Int']>;
  invoice_profit?: Maybe<Scalars['Int']>;
  withdraw_amount?: Maybe<Scalars['Int']>;
  withdraw_profit?: Maybe<Scalars['Int']>;
};

export type AnalyticsWidgetPaymentAnalytics = {
  averageBill?: Maybe<AnalyticsWidgetPaymentAnalyticsItem>;
  balance?: Maybe<AnalyticsWidgetPaymentAnalyticsItem>;
  count?: Maybe<AnalyticsWidgetPaymentAnalyticsItem>;
  return?: Maybe<AnalyticsWidgetPaymentAnalyticsItem>;
};

export type AnalyticsWidgetPaymentAnalyticsItem = {
  data?: Maybe<Array<Maybe<AnalyticsWidgetPaymentAnalyticsItemData>>>;
  value: Scalars['Int'];
};

export type AnalyticsWidgetPaymentAnalyticsItemData = {
  date: Scalars['date'];
  value: Scalars['Int'];
};

export type ApH2HCreateOutput = {
  invoice_id?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ApH2HCreateQiwiInvoiceOutput = {
  params?: Maybe<ApH2HCreateQiwiInvoiceParams>;
  url: Scalars['String'];
};

export type ApH2HCreateQiwiInvoiceParams = {
  data: Scalars['String'];
  method: Scalars['String'];
  url: Scalars['String'];
};

export type ApH2HInfoOutput = {
  additional_data?: Maybe<Scalars['json']>;
  amount?: Maybe<Scalars['numeric']>;
  confirmed_at?: Maybe<Scalars['String']>;
  currency_id: Scalars['String'];
  expired_at?: Maybe<Scalars['String']>;
  external_id: Scalars['String'];
  invoice_id?: Maybe<Scalars['String']>;
  redirect_failed_url?: Maybe<Scalars['String']>;
  redirect_success_url?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  transaction_uid: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type ApH2HInternalBalancesOutput = {
  balance: Scalars['numeric'];
  currency: Scalars['String'];
  wallet: Scalars['String'];
};

export type ApH2HRequestData = {
  accept_header?: InputMaybe<Scalars['String']>;
  color_depth: Scalars['Int'];
  ip?: InputMaybe<Scalars['String']>;
  java_enabled: Scalars['Boolean'];
  language: Scalars['String'];
  screen_height: Scalars['Int'];
  screen_width: Scalars['Int'];
  time_zone_offset: Scalars['String'];
  user_agent?: InputMaybe<Scalars['String']>;
};

export type AuditFromSentryOutput = {
  events?: Maybe<Array<Scalars['json']>>;
};

export type AuthLoginOutput = {
  access_token?: Maybe<Scalars['String']>;
  error_code?: Maybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type ContactPayInternalBalances = {
  balance: Scalars['Int'];
  currency_id: Scalars['String'];
  frozen_balance: Scalars['Int'];
  hold_balance: Scalars['Int'];
};

export type CpH2HCreateOutput = {
  invoice_id: Scalars['String'];
  payload: Scalars['String'];
  url: Scalars['String'];
};

export type CpH2HInfoOutput = {
  amount?: Maybe<Scalars['numeric']>;
  confirmed_at?: Maybe<Scalars['String']>;
  currency_id: Scalars['String'];
  expired_at?: Maybe<Scalars['String']>;
  external_id: Scalars['String'];
  invoice_id?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['json']>;
  redirect_failed_url?: Maybe<Scalars['String']>;
  redirect_success_url?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  transaction_uid: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type CreateApiTokenOutput = {
  api_token: Scalars['String'];
};

export type CryptoWithdrawRequestComputePayoutDetailsOutput = {
  result: CryptoWithdrawRequestComputePayoutDetailsOutputResult;
};

export type CryptoWithdrawRequestComputePayoutDetailsOutputResult = {
  merchant_settlement_fee_amount: Scalars['numeric'];
  merchant_settlement_fee_percent: Scalars['numeric'];
  payout_amount: Scalars['numeric'];
  profit: Scalars['numeric'];
  provider_settlement_fee_amount: Scalars['numeric'];
  provider_settlement_fee_percent: Scalars['numeric'];
};

export type CryptoWithdrawRequestRejectOutput = {
  result: CryptoWithdrawRequestRejectOutputResult;
};

export type CryptoWithdrawRequestRejectOutputResult = {
  id: Scalars['Int'];
};

export type CsbH2HInfoOutput = {
  amount?: Maybe<Scalars['numeric']>;
  currency_id: Scalars['String'];
  external_id: Scalars['String'];
  invoice_id?: Maybe<Scalars['String']>;
  redirect_failed_url?: Maybe<Scalars['String']>;
  redirect_success_url?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  transaction_uid: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type CsbWithdrawInfoOutput = {
  amount: Scalars['numeric'];
  currency_id: Scalars['String'];
  external_id: Scalars['String'];
  status: Scalars['String'];
  transaction_uid: Scalars['String'];
  url: Scalars['String'];
  withdraw_id: Scalars['String'];
};

export type DashboardBalanceByCurrencyIdOutput = {
  balance?: Maybe<Scalars['String']>;
  currency_id?: Maybe<Scalars['String']>;
};

export type DashboardBalanceInHeaderOutput = {
  balance: Scalars['numeric'];
  currency_id: Scalars['String'];
};

export type DashboardConvertationActiveMerchantOutput = {
  company_name: Scalars['String'];
  id: Scalars['Int'];
};

export type DashboardConvertationBalanceOutput = {
  balance: Scalars['numeric'];
  balance_converted?: Maybe<Scalars['numeric']>;
  currency: Scalars['String'];
  rate?: Maybe<Scalars['numeric']>;
};

export type DashboardConvertationBalanceProviderItem = {
  amount: Scalars['numeric'];
  amount_converted?: Maybe<Scalars['numeric']>;
  currency: Scalars['String'];
};

export type DashboardConvertationBalanceProvidersOutput = {
  balances?: Maybe<Array<Maybe<DashboardConvertationBalanceProviderItem>>>;
  error?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type DashboardConvertationConversionOutput = {
  full_conversion: Scalars['numeric'];
  invoice_conversion: Scalars['numeric'];
  withdraw_conversion: Scalars['numeric'];
};

export type DashboardConvertationProfitByPeriodOutput = {
  compare_prev: Scalars['numeric'];
  currency_id: Scalars['String'];
  period: Scalars['String'];
  profit: Scalars['numeric'];
  profit_converted?: Maybe<Scalars['numeric']>;
};

export type DashboardConvertationProfitByProvidersOutput = {
  currency_id: Scalars['String'];
  profit?: Maybe<Scalars['numeric']>;
  provider_id: Scalars['String'];
};

export type DashboardConvertationProfitOutput = {
  currency: Scalars['String'];
  profit: Scalars['numeric'];
  profit_converted?: Maybe<Scalars['numeric']>;
  rate?: Maybe<Scalars['numeric']>;
  type: Scalars['String'];
};

export type DashboardConvertationTurnoverOutput = {
  amount: Scalars['numeric'];
  amount_converted?: Maybe<Scalars['numeric']>;
  compare_prev: Scalars['numeric'];
  currency_id: Scalars['String'];
  period: Scalars['String'];
};

export type DcH2HCreateInvoiceOutput = {
  invoice_id: Scalars['String'];
  url: Scalars['String'];
};

export type DcH2HInfoOutput = {
  amount?: Maybe<Scalars['numeric']>;
  confirmed_at?: Maybe<Scalars['String']>;
  currency_id: Scalars['String'];
  expired_at?: Maybe<Scalars['String']>;
  external_id: Scalars['String'];
  invoice_id?: Maybe<Scalars['String']>;
  redirect_failed_url?: Maybe<Scalars['String']>;
  redirect_success_url?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  transaction_uid: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type DecardInternalBalancesOutput = {
  balance: Scalars['numeric'];
  currency: Scalars['String'];
};

export type FeeMerchantFeeResult = {
  fee: Scalars['numeric'];
};

export type FindActiveGateGroupAndCurrenciesOutput = {
  currencies: Array<Maybe<Scalars['String']>>;
  gateGroups: Array<Maybe<Scalars['String']>>;
  merchants: Array<Maybe<Scalars['Int']>>;
  providers: Array<Maybe<Scalars['String']>>;
};

export enum FormMethod {
  Apm = 'apm',
  H2h = 'h2h',
  H2hEmail = 'h2h_email',
  P2p = 'p2p',
  Redirect = 'redirect'
}

export type GateAnalyticsBalanceHistoryItemResponse = {
  created_at: Scalars['date'];
  sum: Scalars['numeric'];
};

export type GateAnalyticsBalanceHistoryResponse = {
  invoice?: Maybe<Array<GateAnalyticsBalanceHistoryItemResponse>>;
  withdraw?: Maybe<Array<GateAnalyticsBalanceHistoryItemResponse>>;
};

export type GateAnalyticsConversionLimits = {
  invoice?: Maybe<GateAnalyticsConversionLimitsItem>;
  withdraw?: Maybe<GateAnalyticsConversionLimitsItem>;
};

export type GateAnalyticsConversionLimitsItem = {
  payment_limit_amount: Scalars['numeric'];
  payment_limit_duration: Scalars['Int'];
  payment_limit_reset_date: Scalars['date'];
  processing_amount: Scalars['numeric'];
};

export type GateAnalyticsConversionResponse = {
  count: Scalars['Int'];
  status: Scalars['String'];
  type: Scalars['String'];
};

export type GetInfoOutput = {
  version: Scalars['String'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type InvoiceCreate = {
  invoice_url: Scalars['String'];
};

export type KaH2HInfoOutput = {
  additional_data?: Maybe<Scalars['json']>;
  amount?: Maybe<Scalars['numeric']>;
  confirmed_at?: Maybe<Scalars['String']>;
  currency_id: Scalars['String'];
  expired_at?: Maybe<Scalars['String']>;
  external_id: Scalars['String'];
  invoice_id?: Maybe<Scalars['String']>;
  redirect_failed_url?: Maybe<Scalars['String']>;
  redirect_success_url?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  transaction_uid: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type MerchantTaskCreateReportRejectedTransactionTaskOutput = {
  id: Scalars['String'];
};

export type MerchantTaskCreateReportTransactionManagementTaskOutput = {
  id: Scalars['String'];
};

export type MerchantTaskCreateReportWithdrawalsPayoutTaskOutput = {
  id: Scalars['String'];
};

export type MpcvipInternalBalancesOutput = {
  balance: Scalars['Int'];
  currency: Scalars['String'];
};

export type MvP2PCreateOutput = {
  card_number: Scalars['String'];
  pay_source: Scalars['Int'];
};

export type MvP2PInfoOutput = {
  amount: Scalars['numeric'];
  card_number?: Maybe<Scalars['String']>;
  confirmed_at?: Maybe<Scalars['String']>;
  currency_id: Scalars['String'];
  expired_at?: Maybe<Scalars['String']>;
  pay_source?: Maybe<Scalars['Int']>;
  redirect_failed_url?: Maybe<Scalars['String']>;
  redirect_success_url?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  transaction_uid: Scalars['String'];
};

export type OtpRequestActivateRequest = {
  qr_code_data: Scalars['String'];
};

export type PaylamaClientFetchOrdersOutput = {
  data?: Maybe<Array<Maybe<Scalars['json']>>>;
  totalLen: Scalars['Int'];
};

export type PaylamaInternalBalancesOutput = {
  balance: Scalars['Int'];
  currency: Scalars['String'];
  hold_balance?: Maybe<Scalars['Int']>;
};

export type PctInfoOutput = {
  amount?: Maybe<Scalars['numeric']>;
  confirmed_at?: Maybe<Scalars['String']>;
  currency_id: Scalars['String'];
  expired_at?: Maybe<Scalars['String']>;
  external_id: Scalars['String'];
  invoice_id?: Maybe<Scalars['String']>;
  redirect_failed_url?: Maybe<Scalars['String']>;
  redirect_success_url?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  transaction_uid: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type PdH2hInfoOutput = {
  amount?: Maybe<Scalars['numeric']>;
  confirmed_at?: Maybe<Scalars['String']>;
  currency_id: Scalars['String'];
  expired_at?: Maybe<Scalars['String']>;
  external_id: Scalars['String'];
  invoice_id?: Maybe<Scalars['String']>;
  redirect_failed_url?: Maybe<Scalars['String']>;
  redirect_success_url?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  transaction_uid: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type PncInfoOutput = {
  amount?: Maybe<Scalars['numeric']>;
  confirmed_at?: Maybe<Scalars['String']>;
  currency_id: Scalars['String'];
  expired_at?: Maybe<Scalars['String']>;
  external_id: Scalars['String'];
  invoice_id?: Maybe<Scalars['String']>;
  qr_image?: Maybe<Scalars['String']>;
  qr_link?: Maybe<Scalars['String']>;
  redirect_failed_url?: Maybe<Scalars['String']>;
  redirect_success_url?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  transaction_uid: Scalars['String'];
};

export type PpP2PInfoOutput = {
  account_info?: Maybe<Scalars['String']>;
  account_number?: Maybe<Scalars['String']>;
  account_type?: Maybe<Scalars['String']>;
  address_transfer?: Maybe<Scalars['String']>;
  amount: Scalars['String'];
  bank_name?: Maybe<Scalars['String']>;
  beneficiary_name?: Maybe<Scalars['String']>;
  branch_name?: Maybe<Scalars['String']>;
  canceled_at?: Maybe<Scalars['String']>;
  card_holder?: Maybe<Scalars['String']>;
  card_number?: Maybe<Scalars['String']>;
  checked_at?: Maybe<Scalars['String']>;
  confirmed_at?: Maybe<Scalars['String']>;
  currency_id: Scalars['String'];
  expired_at?: Maybe<Scalars['String']>;
  external_id: Scalars['String'];
  iban?: Maybe<Scalars['String']>;
  ifsc_code?: Maybe<Scalars['String']>;
  mobile_number?: Maybe<Scalars['String']>;
  payment_info?: Maybe<Scalars['String']>;
  payment_system_type?: Maybe<Scalars['String']>;
  redirect_failed_url?: Maybe<Scalars['String']>;
  redirect_success_url?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  swift_code?: Maybe<Scalars['String']>;
  transaction_uid: Scalars['String'];
};

export type PpP2PRequestOutOutput = {
  ad_id: Scalars['String'];
  amount: Scalars['String'];
  bank_name: Scalars['String'];
  currency: Scalars['String'];
  payment_system_type: Scalars['String'];
};

export type PpP2PWithdrawInfoOutput = {
  amount: Scalars['String'];
  bank_name?: Maybe<Scalars['String']>;
  canceled_at?: Maybe<Scalars['String']>;
  card_number?: Maybe<Scalars['String']>;
  checked_at?: Maybe<Scalars['String']>;
  confirmed_at?: Maybe<Scalars['String']>;
  currency_id: Scalars['String'];
  expired_at?: Maybe<Scalars['String']>;
  external_id: Scalars['String'];
  status: Scalars['String'];
  transaction_uid: Scalars['String'];
};

export type PpP2PWithdrawRequestOutput = {
  ad_id: Scalars['String'];
  amount: Scalars['String'];
  bank_name: Scalars['String'];
  currency: Scalars['String'];
};

export type ProviderInvoiceInfoOutput = {
  account_info?: Maybe<Scalars['String']>;
  account_number?: Maybe<Scalars['String']>;
  account_type?: Maybe<Scalars['String']>;
  additional_data?: Maybe<Scalars['json']>;
  address_transfer?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['numeric']>;
  bank_name?: Maybe<Scalars['String']>;
  beneficiary_name?: Maybe<Scalars['String']>;
  branch_name?: Maybe<Scalars['String']>;
  callback_url?: Maybe<Scalars['String']>;
  card_holder?: Maybe<Scalars['String']>;
  card_number?: Maybe<Scalars['String']>;
  code_3ds_sent?: Maybe<Scalars['Boolean']>;
  comment?: Maybe<Scalars['String']>;
  confirmed_at?: Maybe<Scalars['date']>;
  currency_id: Scalars['String'];
  expired_at?: Maybe<Scalars['date']>;
  external_id: Scalars['String'];
  flow_data?: Maybe<Scalars['json']>;
  form_method?: Maybe<FormMethod>;
  iban?: Maybe<Scalars['String']>;
  ifsc_code?: Maybe<Scalars['String']>;
  invoice_id?: Maybe<Scalars['String']>;
  mobile_number?: Maybe<Scalars['String']>;
  pay_source?: Maybe<Scalars['numeric']>;
  payload?: Maybe<Scalars['json']>;
  payment_info?: Maybe<Scalars['String']>;
  payment_system_type?: Maybe<Scalars['String']>;
  provider_payment_system?: Maybe<Scalars['String']>;
  qr_image?: Maybe<Scalars['String']>;
  qr_link?: Maybe<Scalars['String']>;
  redirect_failed_url?: Maybe<Scalars['String']>;
  redirect_success_url?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  swift_code?: Maybe<Scalars['String']>;
  transaction_uid: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type PspInfoOutput = {
  amount?: Maybe<Scalars['numeric']>;
  currency_id: Scalars['String'];
  external_id: Scalars['String'];
  invoice_id?: Maybe<Scalars['String']>;
  payload: FormData;
  redirect_failed_url?: Maybe<Scalars['String']>;
  redirect_success_url?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  transaction_uid: Scalars['String'];
  url: Scalars['String'];
};

export type RefundsFilterOutput = {
  amount: Scalars['numeric'];
  created_at: Scalars['String'];
  currency: Scalars['String'];
  fee: Scalars['numeric'];
  gate_group_name: Scalars['String'];
  invoice_transaction_uid: Scalars['String'];
  refund_id: Scalars['String'];
  withdraw_transaction_uid: Scalars['String'];
};

export type ReportsChargebackDetailsItemOutput = {
  amount: Scalars['Int'];
  chargesName: Scalars['String'];
  counter?: Maybe<Scalars['Int']>;
  rateFee: Scalars['Int'];
  total: Scalars['Int'];
};

export type ReportsChargebackDetailsOutput = {
  items: Array<Maybe<ReportsChargebackDetailsItemOutput>>;
};

export type ReportsChargesDetailsItemOutput = {
  amount: Scalars['Int'];
  chargesName: Scalars['String'];
  counter?: Maybe<Scalars['Int']>;
  rateFee: Scalars['Int'];
  total: Scalars['Int'];
};

export type ReportsChargesDetailsOutput = {
  items: Array<Maybe<ReportsChargesDetailsItemOutput>>;
};

export type ReportsGeneralInfoItemOutput = {
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type ReportsGeneralInfoOutput = {
  items: Array<Maybe<ReportsGeneralInfoItemOutput>>;
};

export type ReportsGeneratedReserveDetailsItemOutput = {
  amount: Scalars['Int'];
  chargesName: Scalars['String'];
  counter?: Maybe<Scalars['Int']>;
  rateFee: Scalars['Int'];
  total: Scalars['Int'];
};

export type ReportsGeneratedReserveDetailsOutput = {
  items: Array<Maybe<ReportsGeneratedReserveDetailsItemOutput>>;
};

export type ReportsRefundDetailsItemOutput = {
  amount: Scalars['Int'];
  chargesName: Scalars['String'];
  counter?: Maybe<Scalars['Int']>;
  rateFee: Scalars['Int'];
  total: Scalars['Int'];
};

export type ReportsRefundDetailsOutput = {
  items: Array<Maybe<ReportsRefundDetailsItemOutput>>;
};

export type ReportsRefundedReserveDetailsItemOutput = {
  amount: Scalars['Int'];
  chargesName: Scalars['String'];
  counter?: Maybe<Scalars['Int']>;
  rateFee: Scalars['Int'];
  total: Scalars['Int'];
};

export type ReportsRefundedReserveDetailsOutput = {
  items: Array<Maybe<ReportsRefundedReserveDetailsItemOutput>>;
};

export type ReportsSummaryItemOutput = {
  key: Scalars['String'];
  value: Scalars['Int'];
};

export type ReportsSummaryOutput = {
  items: Array<Maybe<ReportsSummaryItemOutput>>;
};

export type ReportsTotalItemOutput = {
  amount: Scalars['Int'];
  chargesName: Scalars['String'];
  counter?: Maybe<Scalars['Int']>;
  rateFee: Scalars['Int'];
  total: Scalars['Int'];
};

export type ReportsTotalOutput = {
  items: Array<Maybe<ReportsTotalItemOutput>>;
};

export type ReportsTransactionDetailsItemOutput = {
  amount: Scalars['Int'];
  chargesName: Scalars['String'];
  counter?: Maybe<Scalars['Int']>;
  rateFee: Scalars['Int'];
  total: Scalars['Int'];
};

export type ReportsTransactionDetailsOutput = {
  items: Array<Maybe<ReportsTransactionDetailsItemOutput>>;
};

export type RequestDataInput = {
  accept_header?: InputMaybe<Scalars['String']>;
  browser_accept_header?: InputMaybe<Scalars['String']>;
  browser_color_depth?: InputMaybe<Scalars['String']>;
  browser_java_enabled?: InputMaybe<Scalars['Boolean']>;
  browser_language?: InputMaybe<Scalars['String']>;
  browser_screen_height?: InputMaybe<Scalars['String']>;
  browser_screen_width?: InputMaybe<Scalars['String']>;
  browser_tz?: InputMaybe<Scalars['String']>;
  browser_user_agent?: InputMaybe<Scalars['String']>;
  color_depth?: InputMaybe<Scalars['Int']>;
  ip?: InputMaybe<Scalars['String']>;
  java_enabled?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  screen_height?: InputMaybe<Scalars['Int']>;
  screen_width?: InputMaybe<Scalars['Int']>;
  time_zone_offset?: InputMaybe<Scalars['String']>;
  user_agent?: InputMaybe<Scalars['String']>;
  window_height?: InputMaybe<Scalars['String']>;
  window_width?: InputMaybe<Scalars['String']>;
};

export type ResultOutput = {
  result?: Maybe<Scalars['json']>;
};

export type RqInternalBalancesOutput = {
  balance: Scalars['numeric'];
  name: Scalars['String'];
  prefix: Scalars['String'];
  waiting: Scalars['numeric'];
};

export type RqInvoiceInfoOutput = {
  amount?: Maybe<Scalars['numeric']>;
  card_number?: Maybe<Scalars['String']>;
  confirmed_at?: Maybe<Scalars['String']>;
  currency_id: Scalars['String'];
  expired_at?: Maybe<Scalars['String']>;
  external_id: Scalars['String'];
  invoice_id?: Maybe<Scalars['String']>;
  redirect_failed_url?: Maybe<Scalars['String']>;
  redirect_success_url?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  transaction_uid: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type RqInvoiceRequestOutput = {
  amount: Scalars['String'];
  bank_name?: Maybe<Array<Scalars['String']>>;
  currency: Scalars['String'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringComparisonExp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

export type UsersActivateOutput = {
  access_token: Scalars['String'];
};

export type UsersRegistrationInput = {
  business_address?: InputMaybe<Scalars['String']>;
  chargeback_ratio: Scalars['String'];
  company_name: Scalars['String'];
  company_website: Scalars['String'];
  email: Scalars['String'];
  email_test?: InputMaybe<Scalars['String']>;
  month_turnover: Scalars['String'];
  password: Scalars['String'];
  payments_currencies: Array<Scalars['String']>;
  payments_geo: Scalars['String'];
  phone: Scalars['String'];
  registered_address?: InputMaybe<Scalars['String']>;
  registration_data?: InputMaybe<Scalars['String']>;
  registration_number?: InputMaybe<Scalars['String']>;
  telegram?: InputMaybe<Scalars['String']>;
  whatsapp?: InputMaybe<Scalars['String']>;
};

export type UsersRegistrationOutput = {
  id: Scalars['String'];
};

export type WithdrawMassWithdrawCreateOutput = {
  amount: Scalars['numeric'];
  callback_url?: Maybe<Scalars['String']>;
  card_expires?: Maybe<Scalars['String']>;
  card_holder?: Maybe<Scalars['String']>;
  card_number?: Maybe<Scalars['String']>;
  client_ip?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  currency_id?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
  redirect_failed_url?: Maybe<Scalars['String']>;
  redirect_success_url?: Maybe<Scalars['String']>;
  unlock_after_create_withdraw_db?: Maybe<Scalars['Boolean']>;
  withdraw_url?: Maybe<Scalars['String']>;
};

export type WithdrawReplyOutput = {
  transaction_uid: Scalars['String'];
};

export type WzrdInfoOutput = {
  amount?: Maybe<Scalars['numeric']>;
  confirmed_at?: Maybe<Scalars['String']>;
  currency_id: Scalars['String'];
  expired_at?: Maybe<Scalars['String']>;
  external_id: Scalars['String'];
  flow_data?: Maybe<Scalars['json']>;
  invoice_id?: Maybe<Scalars['String']>;
  redirect_failed_url?: Maybe<Scalars['String']>;
  redirect_success_url?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  transaction_uid: Scalars['String'];
};

export type WzrdRequestData = {
  browser_accept_header: Scalars['String'];
  browser_color_depth: Scalars['String'];
  browser_java_enabled: Scalars['Boolean'];
  browser_language: Scalars['String'];
  browser_screen_height: Scalars['String'];
  browser_screen_width: Scalars['String'];
  browser_tz: Scalars['String'];
  browser_user_agent: Scalars['String'];
  window_height: Scalars['String'];
  window_width: Scalars['String'];
};

export type XpayInternalBalancesOutput = {
  balance?: Maybe<Scalars['json']>;
};

/** columns and relationships of "audit" */
export type Audit = {
  /** Новые значения */
  diff?: Maybe<Scalars['jsonb']>;
  /** Пользователь который изменил запись ссылка на таблицу user */
  edit_user_id?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  merchant_id?: Maybe<Scalars['Int']>;
  /** Предыдущее значение */
  old_value?: Maybe<Scalars['jsonb']>;
  /** Операция которая была произведена над строкой (INSERT, UPDATE, DELETE) */
  operation: Scalars['String'];
  /** Имя пользователя Postgre который подключится к БД и выполнил операцию */
  pg_username: Scalars['String'];
  /** Роль пользователя */
  role_id?: Maybe<Scalars['String']>;
  /** Идентификатор записи в которой были изменения */
  row_id: Scalars['String'];
  /** Таблица в которой были изменения */
  table_name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  user_id?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "audit" */
export type AuditDiffArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "audit" */
export type AuditOldValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "audit" */
export type AuditAggregate = {
  aggregate?: Maybe<AuditAggregateFields>;
  nodes: Array<Audit>;
};

/** aggregate fields of "audit" */
export type AuditAggregateFields = {
  avg?: Maybe<AuditAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AuditMaxFields>;
  min?: Maybe<AuditMinFields>;
  stddev?: Maybe<AuditStddevFields>;
  stddev_pop?: Maybe<AuditStddevPopFields>;
  stddev_samp?: Maybe<AuditStddevSampFields>;
  sum?: Maybe<AuditSumFields>;
  var_pop?: Maybe<AuditVarPopFields>;
  var_samp?: Maybe<AuditVarSampFields>;
  variance?: Maybe<AuditVarianceFields>;
};


/** aggregate fields of "audit" */
export type AuditAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AuditSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AuditAppendInput = {
  /** Новые значения */
  diff?: InputMaybe<Scalars['jsonb']>;
  /** Предыдущее значение */
  old_value?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type AuditAvgFields = {
  /** Пользователь который изменил запись ссылка на таблицу user */
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "audit". All fields are combined with a logical 'AND'. */
export type AuditBoolExp = {
  _and?: InputMaybe<Array<AuditBoolExp>>;
  _not?: InputMaybe<AuditBoolExp>;
  _or?: InputMaybe<Array<AuditBoolExp>>;
  diff?: InputMaybe<JsonbComparisonExp>;
  edit_user_id?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  old_value?: InputMaybe<JsonbComparisonExp>;
  operation?: InputMaybe<StringComparisonExp>;
  pg_username?: InputMaybe<StringComparisonExp>;
  role_id?: InputMaybe<StringComparisonExp>;
  row_id?: InputMaybe<StringComparisonExp>;
  table_name?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "audit" */
export enum AuditConstraint {
  /** unique or primary key constraint on columns "id" */
  AuditPkey = 'audit_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AuditDeleteAtPathInput = {
  /** Новые значения */
  diff?: InputMaybe<Array<Scalars['String']>>;
  /** Предыдущее значение */
  old_value?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AuditDeleteElemInput = {
  /** Новые значения */
  diff?: InputMaybe<Scalars['Int']>;
  /** Предыдущее значение */
  old_value?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AuditDeleteKeyInput = {
  /** Новые значения */
  diff?: InputMaybe<Scalars['String']>;
  /** Предыдущее значение */
  old_value?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "audit" */
export type AuditIncInput = {
  /** Пользователь который изменил запись ссылка на таблицу user */
  edit_user_id?: InputMaybe<Scalars['Int']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "audit" */
export type AuditInsertInput = {
  /** Новые значения */
  diff?: InputMaybe<Scalars['jsonb']>;
  /** Пользователь который изменил запись ссылка на таблицу user */
  edit_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  /** Предыдущее значение */
  old_value?: InputMaybe<Scalars['jsonb']>;
  /** Операция которая была произведена над строкой (INSERT, UPDATE, DELETE) */
  operation?: InputMaybe<Scalars['String']>;
  /** Имя пользователя Postgre который подключится к БД и выполнил операцию */
  pg_username?: InputMaybe<Scalars['String']>;
  /** Роль пользователя */
  role_id?: InputMaybe<Scalars['String']>;
  /** Идентификатор записи в которой были изменения */
  row_id?: InputMaybe<Scalars['String']>;
  /** Таблица в которой были изменения */
  table_name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type AuditMaxFields = {
  /** Пользователь который изменил запись ссылка на таблицу user */
  edit_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  merchant_id?: Maybe<Scalars['Int']>;
  /** Операция которая была произведена над строкой (INSERT, UPDATE, DELETE) */
  operation?: Maybe<Scalars['String']>;
  /** Имя пользователя Postgre который подключится к БД и выполнил операцию */
  pg_username?: Maybe<Scalars['String']>;
  /** Роль пользователя */
  role_id?: Maybe<Scalars['String']>;
  /** Идентификатор записи в которой были изменения */
  row_id?: Maybe<Scalars['String']>;
  /** Таблица в которой были изменения */
  table_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type AuditMinFields = {
  /** Пользователь который изменил запись ссылка на таблицу user */
  edit_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  merchant_id?: Maybe<Scalars['Int']>;
  /** Операция которая была произведена над строкой (INSERT, UPDATE, DELETE) */
  operation?: Maybe<Scalars['String']>;
  /** Имя пользователя Postgre который подключится к БД и выполнил операцию */
  pg_username?: Maybe<Scalars['String']>;
  /** Роль пользователя */
  role_id?: Maybe<Scalars['String']>;
  /** Идентификатор записи в которой были изменения */
  row_id?: Maybe<Scalars['String']>;
  /** Таблица в которой были изменения */
  table_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "audit" */
export type AuditMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Audit>;
};

/** on_conflict condition type for table "audit" */
export type AuditOnConflict = {
  constraint: AuditConstraint;
  update_columns?: Array<AuditUpdateColumn>;
  where?: InputMaybe<AuditBoolExp>;
};

/** Ordering options when selecting data from "audit". */
export type AuditOrderBy = {
  diff?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  old_value?: InputMaybe<OrderBy>;
  operation?: InputMaybe<OrderBy>;
  pg_username?: InputMaybe<OrderBy>;
  role_id?: InputMaybe<OrderBy>;
  row_id?: InputMaybe<OrderBy>;
  table_name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: audit */
export type AuditPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AuditPrependInput = {
  /** Новые значения */
  diff?: InputMaybe<Scalars['jsonb']>;
  /** Предыдущее значение */
  old_value?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "audit" */
export enum AuditSelectColumn {
  /** column name */
  Diff = 'diff',
  /** column name */
  EditUserId = 'edit_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  OldValue = 'old_value',
  /** column name */
  Operation = 'operation',
  /** column name */
  PgUsername = 'pg_username',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  RowId = 'row_id',
  /** column name */
  TableName = 'table_name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "audit" */
export type AuditSetInput = {
  /** Новые значения */
  diff?: InputMaybe<Scalars['jsonb']>;
  /** Пользователь который изменил запись ссылка на таблицу user */
  edit_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  /** Предыдущее значение */
  old_value?: InputMaybe<Scalars['jsonb']>;
  /** Операция которая была произведена над строкой (INSERT, UPDATE, DELETE) */
  operation?: InputMaybe<Scalars['String']>;
  /** Имя пользователя Postgre который подключится к БД и выполнил операцию */
  pg_username?: InputMaybe<Scalars['String']>;
  /** Роль пользователя */
  role_id?: InputMaybe<Scalars['String']>;
  /** Идентификатор записи в которой были изменения */
  row_id?: InputMaybe<Scalars['String']>;
  /** Таблица в которой были изменения */
  table_name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type AuditStddevFields = {
  /** Пользователь который изменил запись ссылка на таблицу user */
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AuditStddevPopFields = {
  /** Пользователь который изменил запись ссылка на таблицу user */
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AuditStddevSampFields = {
  /** Пользователь который изменил запись ссылка на таблицу user */
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type AuditSumFields = {
  /** Пользователь который изменил запись ссылка на таблицу user */
  edit_user_id?: Maybe<Scalars['Int']>;
  merchant_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "audit" */
export enum AuditUpdateColumn {
  /** column name */
  Diff = 'diff',
  /** column name */
  EditUserId = 'edit_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  OldValue = 'old_value',
  /** column name */
  Operation = 'operation',
  /** column name */
  PgUsername = 'pg_username',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  RowId = 'row_id',
  /** column name */
  TableName = 'table_name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type AuditUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AuditAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AuditDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AuditDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AuditDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AuditIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AuditPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuditSetInput>;
  where: AuditBoolExp;
};

/** aggregate var_pop on columns */
export type AuditVarPopFields = {
  /** Пользователь который изменил запись ссылка на таблицу user */
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AuditVarSampFields = {
  /** Пользователь который изменил запись ссылка на таблицу user */
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AuditVarianceFields = {
  /** Пользователь который изменил запись ссылка на таблицу user */
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type BigintComparisonExp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "blacklist" */
export type Blacklist = {
  cardholder?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  last_name?: Maybe<Scalars['String']>;
  sanitized_card?: Maybe<Scalars['String']>;
};

/** aggregated selection of "blacklist" */
export type BlacklistAggregate = {
  aggregate?: Maybe<BlacklistAggregateFields>;
  nodes: Array<Blacklist>;
};

/** aggregate fields of "blacklist" */
export type BlacklistAggregateFields = {
  avg?: Maybe<BlacklistAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BlacklistMaxFields>;
  min?: Maybe<BlacklistMinFields>;
  stddev?: Maybe<BlacklistStddevFields>;
  stddev_pop?: Maybe<BlacklistStddevPopFields>;
  stddev_samp?: Maybe<BlacklistStddevSampFields>;
  sum?: Maybe<BlacklistSumFields>;
  var_pop?: Maybe<BlacklistVarPopFields>;
  var_samp?: Maybe<BlacklistVarSampFields>;
  variance?: Maybe<BlacklistVarianceFields>;
};


/** aggregate fields of "blacklist" */
export type BlacklistAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BlacklistSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type BlacklistAvgFields = {
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "blacklist". All fields are combined with a logical 'AND'. */
export type BlacklistBoolExp = {
  _and?: InputMaybe<Array<BlacklistBoolExp>>;
  _not?: InputMaybe<BlacklistBoolExp>;
  _or?: InputMaybe<Array<BlacklistBoolExp>>;
  cardholder?: InputMaybe<StringComparisonExp>;
  comment?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  first_name?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  last_name?: InputMaybe<StringComparisonExp>;
  sanitized_card?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "blacklist" */
export enum BlacklistConstraint {
  /** unique or primary key constraint on columns "id" */
  BlacklistPkey = 'blacklist_pkey',
  /** unique or primary key constraint on columns "sanitized_card", "cardholder" */
  SanitizedCardCardholder = 'sanitized_card_cardholder'
}

/** input type for incrementing numeric columns in table "blacklist" */
export type BlacklistIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "blacklist" */
export type BlacklistInsertInput = {
  cardholder?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  last_name?: InputMaybe<Scalars['String']>;
  sanitized_card?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BlacklistMaxFields = {
  cardholder?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
  sanitized_card?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BlacklistMinFields = {
  cardholder?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
  sanitized_card?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "blacklist" */
export type BlacklistMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Blacklist>;
};

/** on_conflict condition type for table "blacklist" */
export type BlacklistOnConflict = {
  constraint: BlacklistConstraint;
  update_columns?: Array<BlacklistUpdateColumn>;
  where?: InputMaybe<BlacklistBoolExp>;
};

/** Ordering options when selecting data from "blacklist". */
export type BlacklistOrderBy = {
  cardholder?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  first_name?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_name?: InputMaybe<OrderBy>;
  sanitized_card?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: blacklist */
export type BlacklistPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "blacklist" */
export enum BlacklistSelectColumn {
  /** column name */
  Cardholder = 'cardholder',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  SanitizedCard = 'sanitized_card'
}

/** input type for updating data in table "blacklist" */
export type BlacklistSetInput = {
  cardholder?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  last_name?: InputMaybe<Scalars['String']>;
  sanitized_card?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type BlacklistStddevFields = {
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type BlacklistStddevPopFields = {
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type BlacklistStddevSampFields = {
  id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type BlacklistSumFields = {
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "blacklist" */
export enum BlacklistUpdateColumn {
  /** column name */
  Cardholder = 'cardholder',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  SanitizedCard = 'sanitized_card'
}

export type BlacklistUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BlacklistIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BlacklistSetInput>;
  where: BlacklistBoolExp;
};

/** aggregate var_pop on columns */
export type BlacklistVarPopFields = {
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type BlacklistVarSampFields = {
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type BlacklistVarianceFields = {
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "card_system" */
export type CardSystem = {
  code?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "card_system" */
export type CardSystemAggregate = {
  aggregate?: Maybe<CardSystemAggregateFields>;
  nodes: Array<CardSystem>;
};

/** aggregate fields of "card_system" */
export type CardSystemAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<CardSystemMaxFields>;
  min?: Maybe<CardSystemMinFields>;
};


/** aggregate fields of "card_system" */
export type CardSystemAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CardSystemSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "card_system". All fields are combined with a logical 'AND'. */
export type CardSystemBoolExp = {
  _and?: InputMaybe<Array<CardSystemBoolExp>>;
  _not?: InputMaybe<CardSystemBoolExp>;
  _or?: InputMaybe<Array<CardSystemBoolExp>>;
  code?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "card_system" */
export enum CardSystemConstraint {
  /** unique or primary key constraint on columns "id" */
  CardSystemPkey = 'card_system_pkey'
}

/** input type for inserting data into table "card_system" */
export type CardSystemInsertInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CardSystemMaxFields = {
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CardSystemMinFields = {
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "card_system" */
export type CardSystemMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CardSystem>;
};

/** on_conflict condition type for table "card_system" */
export type CardSystemOnConflict = {
  constraint: CardSystemConstraint;
  update_columns?: Array<CardSystemUpdateColumn>;
  where?: InputMaybe<CardSystemBoolExp>;
};

/** Ordering options when selecting data from "card_system". */
export type CardSystemOrderBy = {
  code?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: card_system */
export type CardSystemPkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "card_system" */
export enum CardSystemSelectColumn {
  /** column name */
  Code = 'code',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "card_system" */
export type CardSystemSetInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "card_system" */
export enum CardSystemUpdateColumn {
  /** column name */
  Code = 'code',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type CardSystemUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CardSystemSetInput>;
  where: CardSystemBoolExp;
};

/** columns and relationships of "cascade_item" */
export type CascadeItem = {
  cascade_id: Scalars['String'];
  created_at: Scalars['timestamptz'];
  gate_group_id: Scalars['String'];
  gate_group_order: Scalars['Int'];
  id: Scalars['String'];
};

/** aggregated selection of "cascade_item" */
export type CascadeItemAggregate = {
  aggregate?: Maybe<CascadeItemAggregateFields>;
  nodes: Array<CascadeItem>;
};

/** aggregate fields of "cascade_item" */
export type CascadeItemAggregateFields = {
  avg?: Maybe<CascadeItemAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CascadeItemMaxFields>;
  min?: Maybe<CascadeItemMinFields>;
  stddev?: Maybe<CascadeItemStddevFields>;
  stddev_pop?: Maybe<CascadeItemStddevPopFields>;
  stddev_samp?: Maybe<CascadeItemStddevSampFields>;
  sum?: Maybe<CascadeItemSumFields>;
  var_pop?: Maybe<CascadeItemVarPopFields>;
  var_samp?: Maybe<CascadeItemVarSampFields>;
  variance?: Maybe<CascadeItemVarianceFields>;
};


/** aggregate fields of "cascade_item" */
export type CascadeItemAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CascadeItemSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CascadeItemAvgFields = {
  gate_group_order?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "cascade_item". All fields are combined with a logical 'AND'. */
export type CascadeItemBoolExp = {
  _and?: InputMaybe<Array<CascadeItemBoolExp>>;
  _not?: InputMaybe<CascadeItemBoolExp>;
  _or?: InputMaybe<Array<CascadeItemBoolExp>>;
  cascade_id?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  gate_group_id?: InputMaybe<StringComparisonExp>;
  gate_group_order?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "cascade_item" */
export enum CascadeItemConstraint {
  /** unique or primary key constraint on columns "id" */
  CascadeItemPkey = 'cascade_item_pkey'
}

/** input type for incrementing numeric columns in table "cascade_item" */
export type CascadeItemIncInput = {
  gate_group_order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "cascade_item" */
export type CascadeItemInsertInput = {
  cascade_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  gate_group_id?: InputMaybe<Scalars['String']>;
  gate_group_order?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CascadeItemMaxFields = {
  cascade_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  gate_group_id?: Maybe<Scalars['String']>;
  gate_group_order?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CascadeItemMinFields = {
  cascade_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  gate_group_id?: Maybe<Scalars['String']>;
  gate_group_order?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "cascade_item" */
export type CascadeItemMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CascadeItem>;
};

/** on_conflict condition type for table "cascade_item" */
export type CascadeItemOnConflict = {
  constraint: CascadeItemConstraint;
  update_columns?: Array<CascadeItemUpdateColumn>;
  where?: InputMaybe<CascadeItemBoolExp>;
};

/** Ordering options when selecting data from "cascade_item". */
export type CascadeItemOrderBy = {
  cascade_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  gate_group_id?: InputMaybe<OrderBy>;
  gate_group_order?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: cascade_item */
export type CascadeItemPkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "cascade_item" */
export enum CascadeItemSelectColumn {
  /** column name */
  CascadeId = 'cascade_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GateGroupId = 'gate_group_id',
  /** column name */
  GateGroupOrder = 'gate_group_order',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "cascade_item" */
export type CascadeItemSetInput = {
  cascade_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  gate_group_id?: InputMaybe<Scalars['String']>;
  gate_group_order?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CascadeItemStddevFields = {
  gate_group_order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CascadeItemStddevPopFields = {
  gate_group_order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CascadeItemStddevSampFields = {
  gate_group_order?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type CascadeItemSumFields = {
  gate_group_order?: Maybe<Scalars['Int']>;
};

/** update columns of table "cascade_item" */
export enum CascadeItemUpdateColumn {
  /** column name */
  CascadeId = 'cascade_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GateGroupId = 'gate_group_id',
  /** column name */
  GateGroupOrder = 'gate_group_order',
  /** column name */
  Id = 'id'
}

export type CascadeItemUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CascadeItemIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CascadeItemSetInput>;
  where: CascadeItemBoolExp;
};

/** aggregate var_pop on columns */
export type CascadeItemVarPopFields = {
  gate_group_order?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CascadeItemVarSampFields = {
  gate_group_order?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CascadeItemVarianceFields = {
  gate_group_order?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "cascade_request" */
export type CascadeRequest = {
  cascade_id: Scalars['String'];
  created_at: Scalars['timestamptz'];
  current_gate_group_order?: Maybe<Scalars['jsonb']>;
  errors?: Maybe<Scalars['jsonb']>;
  id: Scalars['String'];
  is_succeed_cascade_request: Scalars['Boolean'];
  merchant_errors?: Maybe<Scalars['jsonb']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "cascade_request" */
export type CascadeRequestCurrentGateGroupOrderArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "cascade_request" */
export type CascadeRequestErrorsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "cascade_request" */
export type CascadeRequestMerchantErrorsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "cascade_request" */
export type CascadeRequestAggregate = {
  aggregate?: Maybe<CascadeRequestAggregateFields>;
  nodes: Array<CascadeRequest>;
};

/** aggregate fields of "cascade_request" */
export type CascadeRequestAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<CascadeRequestMaxFields>;
  min?: Maybe<CascadeRequestMinFields>;
};


/** aggregate fields of "cascade_request" */
export type CascadeRequestAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CascadeRequestSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CascadeRequestAppendInput = {
  current_gate_group_order?: InputMaybe<Scalars['jsonb']>;
  errors?: InputMaybe<Scalars['jsonb']>;
  merchant_errors?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "cascade_request". All fields are combined with a logical 'AND'. */
export type CascadeRequestBoolExp = {
  _and?: InputMaybe<Array<CascadeRequestBoolExp>>;
  _not?: InputMaybe<CascadeRequestBoolExp>;
  _or?: InputMaybe<Array<CascadeRequestBoolExp>>;
  cascade_id?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  current_gate_group_order?: InputMaybe<JsonbComparisonExp>;
  errors?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  is_succeed_cascade_request?: InputMaybe<BooleanComparisonExp>;
  merchant_errors?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "cascade_request" */
export enum CascadeRequestConstraint {
  /** unique or primary key constraint on columns "id" */
  CascadeRequestPkey = 'cascade_request_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CascadeRequestDeleteAtPathInput = {
  current_gate_group_order?: InputMaybe<Array<Scalars['String']>>;
  errors?: InputMaybe<Array<Scalars['String']>>;
  merchant_errors?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CascadeRequestDeleteElemInput = {
  current_gate_group_order?: InputMaybe<Scalars['Int']>;
  errors?: InputMaybe<Scalars['Int']>;
  merchant_errors?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CascadeRequestDeleteKeyInput = {
  current_gate_group_order?: InputMaybe<Scalars['String']>;
  errors?: InputMaybe<Scalars['String']>;
  merchant_errors?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "cascade_request" */
export type CascadeRequestInsertInput = {
  cascade_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  current_gate_group_order?: InputMaybe<Scalars['jsonb']>;
  errors?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['String']>;
  is_succeed_cascade_request?: InputMaybe<Scalars['Boolean']>;
  merchant_errors?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CascadeRequestMaxFields = {
  cascade_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type CascadeRequestMinFields = {
  cascade_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "cascade_request" */
export type CascadeRequestMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CascadeRequest>;
};

/** on_conflict condition type for table "cascade_request" */
export type CascadeRequestOnConflict = {
  constraint: CascadeRequestConstraint;
  update_columns?: Array<CascadeRequestUpdateColumn>;
  where?: InputMaybe<CascadeRequestBoolExp>;
};

/** Ordering options when selecting data from "cascade_request". */
export type CascadeRequestOrderBy = {
  cascade_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  current_gate_group_order?: InputMaybe<OrderBy>;
  errors?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_succeed_cascade_request?: InputMaybe<OrderBy>;
  merchant_errors?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: cascade_request */
export type CascadeRequestPkColumnsInput = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CascadeRequestPrependInput = {
  current_gate_group_order?: InputMaybe<Scalars['jsonb']>;
  errors?: InputMaybe<Scalars['jsonb']>;
  merchant_errors?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "cascade_request" */
export enum CascadeRequestSelectColumn {
  /** column name */
  CascadeId = 'cascade_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentGateGroupOrder = 'current_gate_group_order',
  /** column name */
  Errors = 'errors',
  /** column name */
  Id = 'id',
  /** column name */
  IsSucceedCascadeRequest = 'is_succeed_cascade_request',
  /** column name */
  MerchantErrors = 'merchant_errors',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "cascade_request" */
export type CascadeRequestSetInput = {
  cascade_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  current_gate_group_order?: InputMaybe<Scalars['jsonb']>;
  errors?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['String']>;
  is_succeed_cascade_request?: InputMaybe<Scalars['Boolean']>;
  merchant_errors?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "cascade_request" */
export enum CascadeRequestUpdateColumn {
  /** column name */
  CascadeId = 'cascade_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentGateGroupOrder = 'current_gate_group_order',
  /** column name */
  Errors = 'errors',
  /** column name */
  Id = 'id',
  /** column name */
  IsSucceedCascadeRequest = 'is_succeed_cascade_request',
  /** column name */
  MerchantErrors = 'merchant_errors',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type CascadeRequestUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CascadeRequestAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CascadeRequestDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CascadeRequestDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CascadeRequestDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CascadeRequestPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CascadeRequestSetInput>;
  where: CascadeRequestBoolExp;
};

/** columns and relationships of "cascades" */
export type Cascades = {
  active?: Maybe<Scalars['Boolean']>;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  merchant_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "cascades" */
export type CascadesAggregate = {
  aggregate?: Maybe<CascadesAggregateFields>;
  nodes: Array<Cascades>;
};

/** aggregate fields of "cascades" */
export type CascadesAggregateFields = {
  avg?: Maybe<CascadesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CascadesMaxFields>;
  min?: Maybe<CascadesMinFields>;
  stddev?: Maybe<CascadesStddevFields>;
  stddev_pop?: Maybe<CascadesStddevPopFields>;
  stddev_samp?: Maybe<CascadesStddevSampFields>;
  sum?: Maybe<CascadesSumFields>;
  var_pop?: Maybe<CascadesVarPopFields>;
  var_samp?: Maybe<CascadesVarSampFields>;
  variance?: Maybe<CascadesVarianceFields>;
};


/** aggregate fields of "cascades" */
export type CascadesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CascadesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CascadesAvgFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "cascades". All fields are combined with a logical 'AND'. */
export type CascadesBoolExp = {
  _and?: InputMaybe<Array<CascadesBoolExp>>;
  _not?: InputMaybe<CascadesBoolExp>;
  _or?: InputMaybe<Array<CascadesBoolExp>>;
  active?: InputMaybe<BooleanComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  edit_user_id?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "cascades" */
export enum CascadesConstraint {
  /** unique or primary key constraint on columns "id" */
  CascadesPkey = 'cascades_pkey'
}

/** input type for incrementing numeric columns in table "cascades" */
export type CascadesIncInput = {
  edit_user_id?: InputMaybe<Scalars['Int']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "cascades" */
export type CascadesInsertInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CascadesMaxFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type CascadesMinFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "cascades" */
export type CascadesMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Cascades>;
};

/** on_conflict condition type for table "cascades" */
export type CascadesOnConflict = {
  constraint: CascadesConstraint;
  update_columns?: Array<CascadesUpdateColumn>;
  where?: InputMaybe<CascadesBoolExp>;
};

/** Ordering options when selecting data from "cascades". */
export type CascadesOrderBy = {
  active?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: cascades */
export type CascadesPkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "cascades" */
export enum CascadesSelectColumn {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EditUserId = 'edit_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "cascades" */
export type CascadesSetInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type CascadesStddevFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CascadesStddevPopFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CascadesStddevSampFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type CascadesSumFields = {
  edit_user_id?: Maybe<Scalars['Int']>;
  merchant_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "cascades" */
export enum CascadesUpdateColumn {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EditUserId = 'edit_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type CascadesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CascadesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CascadesSetInput>;
  where: CascadesBoolExp;
};

/** aggregate var_pop on columns */
export type CascadesVarPopFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CascadesVarSampFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CascadesVarianceFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** Справочник регионов стран */
export type Country = {
  /** An object relationship */
  country_region?: Maybe<CountryRegion>;
  country_region_id?: Maybe<Scalars['String']>;
  /** Тдентификатор региона */
  id: Scalars['String'];
  /** Наименование региона на английском языке */
  name: Scalars['String'];
};

/** aggregated selection of "country" */
export type CountryAggregate = {
  aggregate?: Maybe<CountryAggregateFields>;
  nodes: Array<Country>;
};

/** aggregate fields of "country" */
export type CountryAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<CountryMaxFields>;
  min?: Maybe<CountryMinFields>;
};


/** aggregate fields of "country" */
export type CountryAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CountrySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "country". All fields are combined with a logical 'AND'. */
export type CountryBoolExp = {
  _and?: InputMaybe<Array<CountryBoolExp>>;
  _not?: InputMaybe<CountryBoolExp>;
  _or?: InputMaybe<Array<CountryBoolExp>>;
  country_region?: InputMaybe<CountryRegionBoolExp>;
  country_region_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "country" */
export enum CountryConstraint {
  /** unique or primary key constraint on columns "id" */
  CountryPkey = 'country_pkey'
}

/** input type for inserting data into table "country" */
export type CountryInsertInput = {
  country_region?: InputMaybe<CountryRegionObjRelInsertInput>;
  country_region_id?: InputMaybe<Scalars['String']>;
  /** Тдентификатор региона */
  id?: InputMaybe<Scalars['String']>;
  /** Наименование региона на английском языке */
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CountryMaxFields = {
  country_region_id?: Maybe<Scalars['String']>;
  /** Тдентификатор региона */
  id?: Maybe<Scalars['String']>;
  /** Наименование региона на английском языке */
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CountryMinFields = {
  country_region_id?: Maybe<Scalars['String']>;
  /** Тдентификатор региона */
  id?: Maybe<Scalars['String']>;
  /** Наименование региона на английском языке */
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "country" */
export type CountryMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Country>;
};

/** input type for inserting object relation for remote table "country" */
export type CountryObjRelInsertInput = {
  data: CountryInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CountryOnConflict>;
};

/** on_conflict condition type for table "country" */
export type CountryOnConflict = {
  constraint: CountryConstraint;
  update_columns?: Array<CountryUpdateColumn>;
  where?: InputMaybe<CountryBoolExp>;
};

/** Ordering options when selecting data from "country". */
export type CountryOrderBy = {
  country_region?: InputMaybe<CountryRegionOrderBy>;
  country_region_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: country */
export type CountryPkColumnsInput = {
  /** Тдентификатор региона */
  id: Scalars['String'];
};

/** columns and relationships of "country_region" */
export type CountryRegion = {
  id: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "country_region" */
export type CountryRegionAggregate = {
  aggregate?: Maybe<CountryRegionAggregateFields>;
  nodes: Array<CountryRegion>;
};

/** aggregate fields of "country_region" */
export type CountryRegionAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<CountryRegionMaxFields>;
  min?: Maybe<CountryRegionMinFields>;
};


/** aggregate fields of "country_region" */
export type CountryRegionAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CountryRegionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "country_region". All fields are combined with a logical 'AND'. */
export type CountryRegionBoolExp = {
  _and?: InputMaybe<Array<CountryRegionBoolExp>>;
  _not?: InputMaybe<CountryRegionBoolExp>;
  _or?: InputMaybe<Array<CountryRegionBoolExp>>;
  id?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "country_region" */
export enum CountryRegionConstraint {
  /** unique or primary key constraint on columns "id" */
  CountryRegionPkey = 'country_region_pkey'
}

/** input type for inserting data into table "country_region" */
export type CountryRegionInsertInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CountryRegionMaxFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CountryRegionMinFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "country_region" */
export type CountryRegionMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CountryRegion>;
};

/** input type for inserting object relation for remote table "country_region" */
export type CountryRegionObjRelInsertInput = {
  data: CountryRegionInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CountryRegionOnConflict>;
};

/** on_conflict condition type for table "country_region" */
export type CountryRegionOnConflict = {
  constraint: CountryRegionConstraint;
  update_columns?: Array<CountryRegionUpdateColumn>;
  where?: InputMaybe<CountryRegionBoolExp>;
};

/** Ordering options when selecting data from "country_region". */
export type CountryRegionOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: country_region */
export type CountryRegionPkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "country_region" */
export enum CountryRegionSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "country_region" */
export type CountryRegionSetInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "country_region" */
export enum CountryRegionUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type CountryRegionUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CountryRegionSetInput>;
  where: CountryRegionBoolExp;
};

/** select columns of table "country" */
export enum CountrySelectColumn {
  /** column name */
  CountryRegionId = 'country_region_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "country" */
export type CountrySetInput = {
  country_region_id?: InputMaybe<Scalars['String']>;
  /** Тдентификатор региона */
  id?: InputMaybe<Scalars['String']>;
  /** Наименование региона на английском языке */
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "country" */
export enum CountryUpdateColumn {
  /** column name */
  CountryRegionId = 'country_region_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type CountryUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CountrySetInput>;
  where: CountryBoolExp;
};

export type CryptoWithdrawRequestCancelOutput = {
  result: CryptoWithdrawRequestCancelOutputResult;
};

export type CryptoWithdrawRequestCancelOutputResult = {
  id: Scalars['Int'];
};

export type CryptoWithdrawRequestCreateAdminOutput = {
  result: CryptoWithdrawRequestCreateAdminOutputResult;
};

export type CryptoWithdrawRequestCreateAdminOutputResult = {
  id: Scalars['Int'];
};

export type CryptoWithdrawRequestCreateOutput = {
  result: CryptoWithdrawRequestCreateOutputResult;
};

export type CryptoWithdrawRequestCreateOutputResult = {
  id: Scalars['Int'];
};

export type CryptoWithdrawRequestInProcessOutput = {
  result: CryptoWithdrawRequestInProcessOutputResult;
};

export type CryptoWithdrawRequestInProcessOutputResult = {
  id: Scalars['Int'];
};

export type CryptoWithdrawRequestPayoutOutput = {
  result: CryptoWithdrawRequestPayoutOutputResult;
};

export type CryptoWithdrawRequestPayoutOutputResult = {
  id: Scalars['Int'];
};

/** columns and relationships of "crypto_currency" */
export type CryptoCurrency = {
  id: Scalars['String'];
};

/** aggregated selection of "crypto_currency" */
export type CryptoCurrencyAggregate = {
  aggregate?: Maybe<CryptoCurrencyAggregateFields>;
  nodes: Array<CryptoCurrency>;
};

/** aggregate fields of "crypto_currency" */
export type CryptoCurrencyAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<CryptoCurrencyMaxFields>;
  min?: Maybe<CryptoCurrencyMinFields>;
};


/** aggregate fields of "crypto_currency" */
export type CryptoCurrencyAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CryptoCurrencySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "crypto_currency". All fields are combined with a logical 'AND'. */
export type CryptoCurrencyBoolExp = {
  _and?: InputMaybe<Array<CryptoCurrencyBoolExp>>;
  _not?: InputMaybe<CryptoCurrencyBoolExp>;
  _or?: InputMaybe<Array<CryptoCurrencyBoolExp>>;
  id?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "crypto_currency" */
export enum CryptoCurrencyConstraint {
  /** unique or primary key constraint on columns "id" */
  CryptoCurrencyPkey = 'crypto_currency_pkey'
}

/** input type for inserting data into table "crypto_currency" */
export type CryptoCurrencyInsertInput = {
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CryptoCurrencyMaxFields = {
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CryptoCurrencyMinFields = {
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "crypto_currency" */
export type CryptoCurrencyMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CryptoCurrency>;
};

/** on_conflict condition type for table "crypto_currency" */
export type CryptoCurrencyOnConflict = {
  constraint: CryptoCurrencyConstraint;
  update_columns?: Array<CryptoCurrencyUpdateColumn>;
  where?: InputMaybe<CryptoCurrencyBoolExp>;
};

/** Ordering options when selecting data from "crypto_currency". */
export type CryptoCurrencyOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: crypto_currency */
export type CryptoCurrencyPkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "crypto_currency" */
export enum CryptoCurrencySelectColumn {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "crypto_currency" */
export type CryptoCurrencySetInput = {
  id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "crypto_currency" */
export enum CryptoCurrencyUpdateColumn {
  /** column name */
  Id = 'id'
}

export type CryptoCurrencyUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CryptoCurrencySetInput>;
  where: CryptoCurrencyBoolExp;
};

/** columns and relationships of "crypto_withdraw_request" */
export type CryptoWithdrawRequest = {
  account_number?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  crypto_amount?: Maybe<Scalars['numeric']>;
  crypto_currency_id: Scalars['String'];
  crypto_withdraw_request_status_id: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  fiat_amount: Scalars['numeric'];
  fiat_currency_id: Scalars['String'];
  gate_id?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  key_approve?: Maybe<Scalars['String']>;
  /** An object relationship */
  merchant: Merchant;
  merchant_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_id: Scalars['Int'];
  merchant_settlement_fee_amount: Scalars['numeric'];
  merchant_settlement_fee_percent: Scalars['numeric'];
  payment_source_id: Scalars['String'];
  payout_amount: Scalars['numeric'];
  profit: Scalars['numeric'];
  provider_fee_percent?: Maybe<Scalars['numeric']>;
  provider_settlement_fee_amount: Scalars['numeric'];
  provider_settlement_fee_percent: Scalars['numeric'];
  rate?: Maybe<Scalars['numeric']>;
  transaction_uid?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "crypto_withdraw_request" */
export type CryptoWithdrawRequestAggregate = {
  aggregate?: Maybe<CryptoWithdrawRequestAggregateFields>;
  nodes: Array<CryptoWithdrawRequest>;
};

/** aggregate fields of "crypto_withdraw_request" */
export type CryptoWithdrawRequestAggregateFields = {
  avg?: Maybe<CryptoWithdrawRequestAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CryptoWithdrawRequestMaxFields>;
  min?: Maybe<CryptoWithdrawRequestMinFields>;
  stddev?: Maybe<CryptoWithdrawRequestStddevFields>;
  stddev_pop?: Maybe<CryptoWithdrawRequestStddevPopFields>;
  stddev_samp?: Maybe<CryptoWithdrawRequestStddevSampFields>;
  sum?: Maybe<CryptoWithdrawRequestSumFields>;
  var_pop?: Maybe<CryptoWithdrawRequestVarPopFields>;
  var_samp?: Maybe<CryptoWithdrawRequestVarSampFields>;
  variance?: Maybe<CryptoWithdrawRequestVarianceFields>;
};


/** aggregate fields of "crypto_withdraw_request" */
export type CryptoWithdrawRequestAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CryptoWithdrawRequestSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CryptoWithdrawRequestAvgFields = {
  crypto_amount?: Maybe<Scalars['Float']>;
  fiat_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_fee_amount?: Maybe<Scalars['Float']>;
  merchant_settlement_fee_percent?: Maybe<Scalars['Float']>;
  payout_amount?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  provider_fee_percent?: Maybe<Scalars['Float']>;
  provider_settlement_fee_amount?: Maybe<Scalars['Float']>;
  provider_settlement_fee_percent?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "crypto_withdraw_request". All fields are combined with a logical 'AND'. */
export type CryptoWithdrawRequestBoolExp = {
  _and?: InputMaybe<Array<CryptoWithdrawRequestBoolExp>>;
  _not?: InputMaybe<CryptoWithdrawRequestBoolExp>;
  _or?: InputMaybe<Array<CryptoWithdrawRequestBoolExp>>;
  account_number?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  crypto_amount?: InputMaybe<NumericComparisonExp>;
  crypto_currency_id?: InputMaybe<StringComparisonExp>;
  crypto_withdraw_request_status_id?: InputMaybe<StringComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  fiat_amount?: InputMaybe<NumericComparisonExp>;
  fiat_currency_id?: InputMaybe<StringComparisonExp>;
  gate_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  key_approve?: InputMaybe<StringComparisonExp>;
  merchant?: InputMaybe<MerchantBoolExp>;
  merchant_fee_percent?: InputMaybe<NumericComparisonExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  merchant_settlement_fee_amount?: InputMaybe<NumericComparisonExp>;
  merchant_settlement_fee_percent?: InputMaybe<NumericComparisonExp>;
  payment_source_id?: InputMaybe<StringComparisonExp>;
  payout_amount?: InputMaybe<NumericComparisonExp>;
  profit?: InputMaybe<NumericComparisonExp>;
  provider_fee_percent?: InputMaybe<NumericComparisonExp>;
  provider_settlement_fee_amount?: InputMaybe<NumericComparisonExp>;
  provider_settlement_fee_percent?: InputMaybe<NumericComparisonExp>;
  rate?: InputMaybe<NumericComparisonExp>;
  transaction_uid?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "crypto_withdraw_request" */
export enum CryptoWithdrawRequestConstraint {
  /** unique or primary key constraint on columns "id" */
  CryptoWithdrawRequestPkey = 'crypto_withdraw_request_pkey',
  /** unique or primary key constraint on columns "transaction_uid" */
  CryptoWithdrawRequestTransactionUidKey = 'crypto_withdraw_request_transaction_uid_key'
}

/** input type for incrementing numeric columns in table "crypto_withdraw_request" */
export type CryptoWithdrawRequestIncInput = {
  crypto_amount?: InputMaybe<Scalars['numeric']>;
  fiat_amount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  merchant_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_settlement_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_settlement_fee_percent?: InputMaybe<Scalars['numeric']>;
  payout_amount?: InputMaybe<Scalars['numeric']>;
  profit?: InputMaybe<Scalars['numeric']>;
  provider_fee_percent?: InputMaybe<Scalars['numeric']>;
  provider_settlement_fee_amount?: InputMaybe<Scalars['numeric']>;
  provider_settlement_fee_percent?: InputMaybe<Scalars['numeric']>;
  rate?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "crypto_withdraw_request" */
export type CryptoWithdrawRequestInsertInput = {
  account_number?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  crypto_amount?: InputMaybe<Scalars['numeric']>;
  crypto_currency_id?: InputMaybe<Scalars['String']>;
  crypto_withdraw_request_status_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fiat_amount?: InputMaybe<Scalars['numeric']>;
  fiat_currency_id?: InputMaybe<Scalars['String']>;
  gate_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  key_approve?: InputMaybe<Scalars['String']>;
  merchant?: InputMaybe<MerchantObjRelInsertInput>;
  merchant_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_settlement_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_settlement_fee_percent?: InputMaybe<Scalars['numeric']>;
  payment_source_id?: InputMaybe<Scalars['String']>;
  payout_amount?: InputMaybe<Scalars['numeric']>;
  profit?: InputMaybe<Scalars['numeric']>;
  provider_fee_percent?: InputMaybe<Scalars['numeric']>;
  provider_settlement_fee_amount?: InputMaybe<Scalars['numeric']>;
  provider_settlement_fee_percent?: InputMaybe<Scalars['numeric']>;
  rate?: InputMaybe<Scalars['numeric']>;
  transaction_uid?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CryptoWithdrawRequestMaxFields = {
  account_number?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  crypto_amount?: Maybe<Scalars['numeric']>;
  crypto_currency_id?: Maybe<Scalars['String']>;
  crypto_withdraw_request_status_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fiat_amount?: Maybe<Scalars['numeric']>;
  fiat_currency_id?: Maybe<Scalars['String']>;
  gate_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  key_approve?: Maybe<Scalars['String']>;
  merchant_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_settlement_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_settlement_fee_percent?: Maybe<Scalars['numeric']>;
  payment_source_id?: Maybe<Scalars['String']>;
  payout_amount?: Maybe<Scalars['numeric']>;
  profit?: Maybe<Scalars['numeric']>;
  provider_fee_percent?: Maybe<Scalars['numeric']>;
  provider_settlement_fee_amount?: Maybe<Scalars['numeric']>;
  provider_settlement_fee_percent?: Maybe<Scalars['numeric']>;
  rate?: Maybe<Scalars['numeric']>;
  transaction_uid?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type CryptoWithdrawRequestMinFields = {
  account_number?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  crypto_amount?: Maybe<Scalars['numeric']>;
  crypto_currency_id?: Maybe<Scalars['String']>;
  crypto_withdraw_request_status_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fiat_amount?: Maybe<Scalars['numeric']>;
  fiat_currency_id?: Maybe<Scalars['String']>;
  gate_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  key_approve?: Maybe<Scalars['String']>;
  merchant_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_settlement_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_settlement_fee_percent?: Maybe<Scalars['numeric']>;
  payment_source_id?: Maybe<Scalars['String']>;
  payout_amount?: Maybe<Scalars['numeric']>;
  profit?: Maybe<Scalars['numeric']>;
  provider_fee_percent?: Maybe<Scalars['numeric']>;
  provider_settlement_fee_amount?: Maybe<Scalars['numeric']>;
  provider_settlement_fee_percent?: Maybe<Scalars['numeric']>;
  rate?: Maybe<Scalars['numeric']>;
  transaction_uid?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "crypto_withdraw_request" */
export type CryptoWithdrawRequestMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CryptoWithdrawRequest>;
};

/** on_conflict condition type for table "crypto_withdraw_request" */
export type CryptoWithdrawRequestOnConflict = {
  constraint: CryptoWithdrawRequestConstraint;
  update_columns?: Array<CryptoWithdrawRequestUpdateColumn>;
  where?: InputMaybe<CryptoWithdrawRequestBoolExp>;
};

/** Ordering options when selecting data from "crypto_withdraw_request". */
export type CryptoWithdrawRequestOrderBy = {
  account_number?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  crypto_amount?: InputMaybe<OrderBy>;
  crypto_currency_id?: InputMaybe<OrderBy>;
  crypto_withdraw_request_status_id?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  fiat_amount?: InputMaybe<OrderBy>;
  fiat_currency_id?: InputMaybe<OrderBy>;
  gate_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  key_approve?: InputMaybe<OrderBy>;
  merchant?: InputMaybe<MerchantOrderBy>;
  merchant_fee_percent?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_settlement_fee_amount?: InputMaybe<OrderBy>;
  merchant_settlement_fee_percent?: InputMaybe<OrderBy>;
  payment_source_id?: InputMaybe<OrderBy>;
  payout_amount?: InputMaybe<OrderBy>;
  profit?: InputMaybe<OrderBy>;
  provider_fee_percent?: InputMaybe<OrderBy>;
  provider_settlement_fee_amount?: InputMaybe<OrderBy>;
  provider_settlement_fee_percent?: InputMaybe<OrderBy>;
  rate?: InputMaybe<OrderBy>;
  transaction_uid?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: crypto_withdraw_request */
export type CryptoWithdrawRequestPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "crypto_withdraw_request" */
export enum CryptoWithdrawRequestSelectColumn {
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CryptoAmount = 'crypto_amount',
  /** column name */
  CryptoCurrencyId = 'crypto_currency_id',
  /** column name */
  CryptoWithdrawRequestStatusId = 'crypto_withdraw_request_status_id',
  /** column name */
  Description = 'description',
  /** column name */
  FiatAmount = 'fiat_amount',
  /** column name */
  FiatCurrencyId = 'fiat_currency_id',
  /** column name */
  GateId = 'gate_id',
  /** column name */
  Id = 'id',
  /** column name */
  KeyApprove = 'key_approve',
  /** column name */
  MerchantFeePercent = 'merchant_fee_percent',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MerchantSettlementFeeAmount = 'merchant_settlement_fee_amount',
  /** column name */
  MerchantSettlementFeePercent = 'merchant_settlement_fee_percent',
  /** column name */
  PaymentSourceId = 'payment_source_id',
  /** column name */
  PayoutAmount = 'payout_amount',
  /** column name */
  Profit = 'profit',
  /** column name */
  ProviderFeePercent = 'provider_fee_percent',
  /** column name */
  ProviderSettlementFeeAmount = 'provider_settlement_fee_amount',
  /** column name */
  ProviderSettlementFeePercent = 'provider_settlement_fee_percent',
  /** column name */
  Rate = 'rate',
  /** column name */
  TransactionUid = 'transaction_uid',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "crypto_withdraw_request" */
export type CryptoWithdrawRequestSetInput = {
  account_number?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  crypto_amount?: InputMaybe<Scalars['numeric']>;
  crypto_currency_id?: InputMaybe<Scalars['String']>;
  crypto_withdraw_request_status_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fiat_amount?: InputMaybe<Scalars['numeric']>;
  fiat_currency_id?: InputMaybe<Scalars['String']>;
  gate_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  key_approve?: InputMaybe<Scalars['String']>;
  merchant_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_settlement_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_settlement_fee_percent?: InputMaybe<Scalars['numeric']>;
  payment_source_id?: InputMaybe<Scalars['String']>;
  payout_amount?: InputMaybe<Scalars['numeric']>;
  profit?: InputMaybe<Scalars['numeric']>;
  provider_fee_percent?: InputMaybe<Scalars['numeric']>;
  provider_settlement_fee_amount?: InputMaybe<Scalars['numeric']>;
  provider_settlement_fee_percent?: InputMaybe<Scalars['numeric']>;
  rate?: InputMaybe<Scalars['numeric']>;
  transaction_uid?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "crypto_withdraw_request_status" */
export type CryptoWithdrawRequestStatus = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "crypto_withdraw_request_status" */
export type CryptoWithdrawRequestStatusAggregate = {
  aggregate?: Maybe<CryptoWithdrawRequestStatusAggregateFields>;
  nodes: Array<CryptoWithdrawRequestStatus>;
};

/** aggregate fields of "crypto_withdraw_request_status" */
export type CryptoWithdrawRequestStatusAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<CryptoWithdrawRequestStatusMaxFields>;
  min?: Maybe<CryptoWithdrawRequestStatusMinFields>;
};


/** aggregate fields of "crypto_withdraw_request_status" */
export type CryptoWithdrawRequestStatusAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CryptoWithdrawRequestStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "crypto_withdraw_request_status". All fields are combined with a logical 'AND'. */
export type CryptoWithdrawRequestStatusBoolExp = {
  _and?: InputMaybe<Array<CryptoWithdrawRequestStatusBoolExp>>;
  _not?: InputMaybe<CryptoWithdrawRequestStatusBoolExp>;
  _or?: InputMaybe<Array<CryptoWithdrawRequestStatusBoolExp>>;
  id?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "crypto_withdraw_request_status" */
export enum CryptoWithdrawRequestStatusConstraint {
  /** unique or primary key constraint on columns "id" */
  CryptoWithdrawRequestStatusPkey = 'crypto_withdraw_request_status_pkey'
}

/** input type for inserting data into table "crypto_withdraw_request_status" */
export type CryptoWithdrawRequestStatusInsertInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CryptoWithdrawRequestStatusMaxFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CryptoWithdrawRequestStatusMinFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "crypto_withdraw_request_status" */
export type CryptoWithdrawRequestStatusMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CryptoWithdrawRequestStatus>;
};

/** on_conflict condition type for table "crypto_withdraw_request_status" */
export type CryptoWithdrawRequestStatusOnConflict = {
  constraint: CryptoWithdrawRequestStatusConstraint;
  update_columns?: Array<CryptoWithdrawRequestStatusUpdateColumn>;
  where?: InputMaybe<CryptoWithdrawRequestStatusBoolExp>;
};

/** Ordering options when selecting data from "crypto_withdraw_request_status". */
export type CryptoWithdrawRequestStatusOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: crypto_withdraw_request_status */
export type CryptoWithdrawRequestStatusPkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "crypto_withdraw_request_status" */
export enum CryptoWithdrawRequestStatusSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "crypto_withdraw_request_status" */
export type CryptoWithdrawRequestStatusSetInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "crypto_withdraw_request_status" */
export enum CryptoWithdrawRequestStatusUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type CryptoWithdrawRequestStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CryptoWithdrawRequestStatusSetInput>;
  where: CryptoWithdrawRequestStatusBoolExp;
};

/** aggregate stddev on columns */
export type CryptoWithdrawRequestStddevFields = {
  crypto_amount?: Maybe<Scalars['Float']>;
  fiat_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_fee_amount?: Maybe<Scalars['Float']>;
  merchant_settlement_fee_percent?: Maybe<Scalars['Float']>;
  payout_amount?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  provider_fee_percent?: Maybe<Scalars['Float']>;
  provider_settlement_fee_amount?: Maybe<Scalars['Float']>;
  provider_settlement_fee_percent?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CryptoWithdrawRequestStddevPopFields = {
  crypto_amount?: Maybe<Scalars['Float']>;
  fiat_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_fee_amount?: Maybe<Scalars['Float']>;
  merchant_settlement_fee_percent?: Maybe<Scalars['Float']>;
  payout_amount?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  provider_fee_percent?: Maybe<Scalars['Float']>;
  provider_settlement_fee_amount?: Maybe<Scalars['Float']>;
  provider_settlement_fee_percent?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CryptoWithdrawRequestStddevSampFields = {
  crypto_amount?: Maybe<Scalars['Float']>;
  fiat_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_fee_amount?: Maybe<Scalars['Float']>;
  merchant_settlement_fee_percent?: Maybe<Scalars['Float']>;
  payout_amount?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  provider_fee_percent?: Maybe<Scalars['Float']>;
  provider_settlement_fee_amount?: Maybe<Scalars['Float']>;
  provider_settlement_fee_percent?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type CryptoWithdrawRequestSumFields = {
  crypto_amount?: Maybe<Scalars['numeric']>;
  fiat_amount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  merchant_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_settlement_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_settlement_fee_percent?: Maybe<Scalars['numeric']>;
  payout_amount?: Maybe<Scalars['numeric']>;
  profit?: Maybe<Scalars['numeric']>;
  provider_fee_percent?: Maybe<Scalars['numeric']>;
  provider_settlement_fee_amount?: Maybe<Scalars['numeric']>;
  provider_settlement_fee_percent?: Maybe<Scalars['numeric']>;
  rate?: Maybe<Scalars['numeric']>;
};

/** update columns of table "crypto_withdraw_request" */
export enum CryptoWithdrawRequestUpdateColumn {
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CryptoAmount = 'crypto_amount',
  /** column name */
  CryptoCurrencyId = 'crypto_currency_id',
  /** column name */
  CryptoWithdrawRequestStatusId = 'crypto_withdraw_request_status_id',
  /** column name */
  Description = 'description',
  /** column name */
  FiatAmount = 'fiat_amount',
  /** column name */
  FiatCurrencyId = 'fiat_currency_id',
  /** column name */
  GateId = 'gate_id',
  /** column name */
  Id = 'id',
  /** column name */
  KeyApprove = 'key_approve',
  /** column name */
  MerchantFeePercent = 'merchant_fee_percent',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MerchantSettlementFeeAmount = 'merchant_settlement_fee_amount',
  /** column name */
  MerchantSettlementFeePercent = 'merchant_settlement_fee_percent',
  /** column name */
  PaymentSourceId = 'payment_source_id',
  /** column name */
  PayoutAmount = 'payout_amount',
  /** column name */
  Profit = 'profit',
  /** column name */
  ProviderFeePercent = 'provider_fee_percent',
  /** column name */
  ProviderSettlementFeeAmount = 'provider_settlement_fee_amount',
  /** column name */
  ProviderSettlementFeePercent = 'provider_settlement_fee_percent',
  /** column name */
  Rate = 'rate',
  /** column name */
  TransactionUid = 'transaction_uid',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type CryptoWithdrawRequestUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CryptoWithdrawRequestIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CryptoWithdrawRequestSetInput>;
  where: CryptoWithdrawRequestBoolExp;
};

/** aggregate var_pop on columns */
export type CryptoWithdrawRequestVarPopFields = {
  crypto_amount?: Maybe<Scalars['Float']>;
  fiat_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_fee_amount?: Maybe<Scalars['Float']>;
  merchant_settlement_fee_percent?: Maybe<Scalars['Float']>;
  payout_amount?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  provider_fee_percent?: Maybe<Scalars['Float']>;
  provider_settlement_fee_amount?: Maybe<Scalars['Float']>;
  provider_settlement_fee_percent?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CryptoWithdrawRequestVarSampFields = {
  crypto_amount?: Maybe<Scalars['Float']>;
  fiat_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_fee_amount?: Maybe<Scalars['Float']>;
  merchant_settlement_fee_percent?: Maybe<Scalars['Float']>;
  payout_amount?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  provider_fee_percent?: Maybe<Scalars['Float']>;
  provider_settlement_fee_amount?: Maybe<Scalars['Float']>;
  provider_settlement_fee_percent?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CryptoWithdrawRequestVarianceFields = {
  crypto_amount?: Maybe<Scalars['Float']>;
  fiat_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_fee_amount?: Maybe<Scalars['Float']>;
  merchant_settlement_fee_percent?: Maybe<Scalars['Float']>;
  payout_amount?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  provider_fee_percent?: Maybe<Scalars['Float']>;
  provider_settlement_fee_amount?: Maybe<Scalars['Float']>;
  provider_settlement_fee_percent?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "currency" */
export type Currency = {
  color?: Maybe<Scalars['String']>;
  /** An array relationship */
  gates: Array<Gate>;
  /** An aggregate relationship */
  gates_aggregate: GateAggregate;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** An array relationship */
  invoices: Array<Invoice>;
  /** An aggregate relationship */
  invoices_aggregate: InvoiceAggregate;
  /** An array relationship */
  merchant_balances: Array<MerchantBalance>;
  /** An aggregate relationship */
  merchant_balances_aggregate: MerchantBalanceAggregate;
  /** An array relationship */
  merchant_currencies: Array<MerchantCurrency>;
  /** An aggregate relationship */
  merchant_currencies_aggregate: MerchantCurrencyAggregate;
  /** An array relationship */
  merchant_fees: Array<MerchantFee>;
  /** An aggregate relationship */
  merchant_fees_aggregate: MerchantFeeAggregate;
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  provider_fees: Array<ProviderFee>;
  /** An aggregate relationship */
  provider_fees_aggregate: ProviderFeeAggregate;
  /** An array relationship */
  provider_limits: Array<ProviderLimit>;
  /** An aggregate relationship */
  provider_limits_aggregate: ProviderLimitAggregate;
  /** An array relationship */
  transaction_histories: Array<TransactionHistory>;
  /** An aggregate relationship */
  transaction_histories_aggregate: TransactionHistoryAggregate;
  /** An array relationship */
  withdraw_requests: Array<WithdrawRequest>;
  /** An aggregate relationship */
  withdraw_requests_aggregate: WithdrawRequestAggregate;
  /** An array relationship */
  withdraws: Array<Withdraw>;
  /** An aggregate relationship */
  withdraws_aggregate: WithdrawAggregate;
};


/** columns and relationships of "currency" */
export type CurrencyGatesArgs = {
  distinct_on?: InputMaybe<Array<GateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GateOrderBy>>;
  where?: InputMaybe<GateBoolExp>;
};


/** columns and relationships of "currency" */
export type CurrencyGatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<GateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GateOrderBy>>;
  where?: InputMaybe<GateBoolExp>;
};


/** columns and relationships of "currency" */
export type CurrencyInvoicesArgs = {
  distinct_on?: InputMaybe<Array<InvoiceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InvoiceOrderBy>>;
  where?: InputMaybe<InvoiceBoolExp>;
};


/** columns and relationships of "currency" */
export type CurrencyInvoicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<InvoiceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InvoiceOrderBy>>;
  where?: InputMaybe<InvoiceBoolExp>;
};


/** columns and relationships of "currency" */
export type CurrencyMerchantBalancesArgs = {
  distinct_on?: InputMaybe<Array<MerchantBalanceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantBalanceOrderBy>>;
  where?: InputMaybe<MerchantBalanceBoolExp>;
};


/** columns and relationships of "currency" */
export type CurrencyMerchantBalancesAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantBalanceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantBalanceOrderBy>>;
  where?: InputMaybe<MerchantBalanceBoolExp>;
};


/** columns and relationships of "currency" */
export type CurrencyMerchantCurrenciesArgs = {
  distinct_on?: InputMaybe<Array<MerchantCurrencySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantCurrencyOrderBy>>;
  where?: InputMaybe<MerchantCurrencyBoolExp>;
};


/** columns and relationships of "currency" */
export type CurrencyMerchantCurrenciesAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantCurrencySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantCurrencyOrderBy>>;
  where?: InputMaybe<MerchantCurrencyBoolExp>;
};


/** columns and relationships of "currency" */
export type CurrencyMerchantFeesArgs = {
  distinct_on?: InputMaybe<Array<MerchantFeeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantFeeOrderBy>>;
  where?: InputMaybe<MerchantFeeBoolExp>;
};


/** columns and relationships of "currency" */
export type CurrencyMerchantFeesAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantFeeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantFeeOrderBy>>;
  where?: InputMaybe<MerchantFeeBoolExp>;
};


/** columns and relationships of "currency" */
export type CurrencyProviderFeesArgs = {
  distinct_on?: InputMaybe<Array<ProviderFeeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderFeeOrderBy>>;
  where?: InputMaybe<ProviderFeeBoolExp>;
};


/** columns and relationships of "currency" */
export type CurrencyProviderFeesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderFeeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderFeeOrderBy>>;
  where?: InputMaybe<ProviderFeeBoolExp>;
};


/** columns and relationships of "currency" */
export type CurrencyProviderLimitsArgs = {
  distinct_on?: InputMaybe<Array<ProviderLimitSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderLimitOrderBy>>;
  where?: InputMaybe<ProviderLimitBoolExp>;
};


/** columns and relationships of "currency" */
export type CurrencyProviderLimitsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderLimitSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderLimitOrderBy>>;
  where?: InputMaybe<ProviderLimitBoolExp>;
};


/** columns and relationships of "currency" */
export type CurrencyTransactionHistoriesArgs = {
  distinct_on?: InputMaybe<Array<TransactionHistorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TransactionHistoryOrderBy>>;
  where?: InputMaybe<TransactionHistoryBoolExp>;
};


/** columns and relationships of "currency" */
export type CurrencyTransactionHistoriesAggregateArgs = {
  distinct_on?: InputMaybe<Array<TransactionHistorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TransactionHistoryOrderBy>>;
  where?: InputMaybe<TransactionHistoryBoolExp>;
};


/** columns and relationships of "currency" */
export type CurrencyWithdrawRequestsArgs = {
  distinct_on?: InputMaybe<Array<WithdrawRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WithdrawRequestOrderBy>>;
  where?: InputMaybe<WithdrawRequestBoolExp>;
};


/** columns and relationships of "currency" */
export type CurrencyWithdrawRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<WithdrawRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WithdrawRequestOrderBy>>;
  where?: InputMaybe<WithdrawRequestBoolExp>;
};


/** columns and relationships of "currency" */
export type CurrencyWithdrawsArgs = {
  distinct_on?: InputMaybe<Array<WithdrawSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WithdrawOrderBy>>;
  where?: InputMaybe<WithdrawBoolExp>;
};


/** columns and relationships of "currency" */
export type CurrencyWithdrawsAggregateArgs = {
  distinct_on?: InputMaybe<Array<WithdrawSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WithdrawOrderBy>>;
  where?: InputMaybe<WithdrawBoolExp>;
};

/** aggregated selection of "currency" */
export type CurrencyAggregate = {
  aggregate?: Maybe<CurrencyAggregateFields>;
  nodes: Array<Currency>;
};

/** aggregate fields of "currency" */
export type CurrencyAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<CurrencyMaxFields>;
  min?: Maybe<CurrencyMinFields>;
};


/** aggregate fields of "currency" */
export type CurrencyAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CurrencySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "currency". All fields are combined with a logical 'AND'. */
export type CurrencyBoolExp = {
  _and?: InputMaybe<Array<CurrencyBoolExp>>;
  _not?: InputMaybe<CurrencyBoolExp>;
  _or?: InputMaybe<Array<CurrencyBoolExp>>;
  color?: InputMaybe<StringComparisonExp>;
  gates?: InputMaybe<GateBoolExp>;
  icon?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  invoices?: InputMaybe<InvoiceBoolExp>;
  merchant_balances?: InputMaybe<MerchantBalanceBoolExp>;
  merchant_currencies?: InputMaybe<MerchantCurrencyBoolExp>;
  merchant_fees?: InputMaybe<MerchantFeeBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  provider_fees?: InputMaybe<ProviderFeeBoolExp>;
  provider_limits?: InputMaybe<ProviderLimitBoolExp>;
  transaction_histories?: InputMaybe<TransactionHistoryBoolExp>;
  withdraw_requests?: InputMaybe<WithdrawRequestBoolExp>;
  withdraws?: InputMaybe<WithdrawBoolExp>;
};

/** unique or primary key constraints on table "currency" */
export enum CurrencyConstraint {
  /** unique or primary key constraint on columns "id" */
  CurrencyPkey = 'currency_pkey'
}

/** input type for inserting data into table "currency" */
export type CurrencyInsertInput = {
  color?: InputMaybe<Scalars['String']>;
  gates?: InputMaybe<GateArrRelInsertInput>;
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  invoices?: InputMaybe<InvoiceArrRelInsertInput>;
  merchant_balances?: InputMaybe<MerchantBalanceArrRelInsertInput>;
  merchant_currencies?: InputMaybe<MerchantCurrencyArrRelInsertInput>;
  merchant_fees?: InputMaybe<MerchantFeeArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  provider_fees?: InputMaybe<ProviderFeeArrRelInsertInput>;
  provider_limits?: InputMaybe<ProviderLimitArrRelInsertInput>;
  transaction_histories?: InputMaybe<TransactionHistoryArrRelInsertInput>;
  withdraw_requests?: InputMaybe<WithdrawRequestArrRelInsertInput>;
  withdraws?: InputMaybe<WithdrawArrRelInsertInput>;
};

/** aggregate max on columns */
export type CurrencyMaxFields = {
  color?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CurrencyMinFields = {
  color?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "currency" */
export type CurrencyMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Currency>;
};

/** input type for inserting object relation for remote table "currency" */
export type CurrencyObjRelInsertInput = {
  data: CurrencyInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CurrencyOnConflict>;
};

/** on_conflict condition type for table "currency" */
export type CurrencyOnConflict = {
  constraint: CurrencyConstraint;
  update_columns?: Array<CurrencyUpdateColumn>;
  where?: InputMaybe<CurrencyBoolExp>;
};

/** Ordering options when selecting data from "currency". */
export type CurrencyOrderBy = {
  color?: InputMaybe<OrderBy>;
  gates_aggregate?: InputMaybe<GateAggregateOrderBy>;
  icon?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoices_aggregate?: InputMaybe<InvoiceAggregateOrderBy>;
  merchant_balances_aggregate?: InputMaybe<MerchantBalanceAggregateOrderBy>;
  merchant_currencies_aggregate?: InputMaybe<MerchantCurrencyAggregateOrderBy>;
  merchant_fees_aggregate?: InputMaybe<MerchantFeeAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  provider_fees_aggregate?: InputMaybe<ProviderFeeAggregateOrderBy>;
  provider_limits_aggregate?: InputMaybe<ProviderLimitAggregateOrderBy>;
  transaction_histories_aggregate?: InputMaybe<TransactionHistoryAggregateOrderBy>;
  withdraw_requests_aggregate?: InputMaybe<WithdrawRequestAggregateOrderBy>;
  withdraws_aggregate?: InputMaybe<WithdrawAggregateOrderBy>;
};

/** primary key columns input for table: currency */
export type CurrencyPkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "currency" */
export enum CurrencySelectColumn {
  /** column name */
  Color = 'color',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "currency" */
export type CurrencySetInput = {
  color?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "currency" */
export enum CurrencyUpdateColumn {
  /** column name */
  Color = 'color',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type CurrencyUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CurrencySetInput>;
  where: CurrencyBoolExp;
};

export type DashboardConvertationMerchantCountOutput = {
  merchant_count: Scalars['Int'];
};

export type DashboardConvertationProviderCountOutput = {
  provider_count: Scalars['Int'];
};

export type DashboardSalesChart = {
  amount: Scalars['numeric'];
  date: Scalars['date'];
};

export type DashboardWidgetsCreatingPaymentOutput = {
  count: Scalars['Int'];
  payment_source_id: Scalars['String'];
  percent: Scalars['Int'];
};

export type DashboardWidgetsInvoiceChartItemOutput = {
  _count: Scalars['Int'];
  percent: Scalars['Int'];
  status: Scalars['String'];
};

export type DashboardWidgetsInvoiceChartOutput = {
  data?: Maybe<Array<Maybe<DashboardWidgetsInvoiceChartItemOutput>>>;
};

export type DashboardWidgetsPaymentMethodsOutput = {
  count: Scalars['Int'];
  payment_system_id?: Maybe<Scalars['String']>;
  percent: Scalars['Int'];
};

export type DashboardWidgetsRevenueChart = {
  month?: Maybe<Scalars['json']>;
  week?: Maybe<Scalars['json']>;
  year?: Maybe<Scalars['json']>;
};

export type DashboardWidgetsSalesChart = {
  last_week?: Maybe<Array<DashboardSalesChart>>;
  this_week?: Maybe<Array<DashboardSalesChart>>;
};

export type DashboardWidgetsStatusChart = {
  count: Scalars['Int'];
  status: Scalars['String'];
};

export type DashboardWidgetsWallet = {
  currency_id?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['String']>;
};

export type DashboardWidgetsWithdrawlChartDataItemOutput = {
  _count: Scalars['Int'];
  percent: Scalars['Int'];
  status: Scalars['String'];
};

export type DashboardWidgetsWithdrawlChartOutput = {
  data?: Maybe<Array<Maybe<DashboardWidgetsWithdrawlChartDataItemOutput>>>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type DateComparisonExp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

export type FormData = {
  cancelURL: Scalars['String'];
  companyID: Scalars['Int'];
  currentDate: Scalars['String'];
  email: Scalars['String'];
  errorURL: Scalars['String'];
  hash: Scalars['String'];
  language: Scalars['Int'];
  merchantCurrencyCode: Scalars['Int'];
  merchantOrderAmount: Scalars['numeric'];
  merchantOrderID: Scalars['Int'];
  requestType: Scalars['Int'];
  rnd: Scalars['String'];
  successURL: Scalars['String'];
};

/** columns and relationships of "gate" */
export type Gate = {
  /** An object relationship */
  active_gate?: Maybe<VActiveGate>;
  /** An object relationship */
  admin_gate_list?: Maybe<VAdminGateList>;
  alias?: Maybe<Scalars['String']>;
  blocked_at?: Maybe<Scalars['timestamptz']>;
  calculated_balance: Scalars['numeric'];
  can_recurrent?: Maybe<Scalars['Boolean']>;
  card_system?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  currency_id: Scalars['String'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  gate_group?: Maybe<GateGroup>;
  gate_group_id?: Maybe<Scalars['String']>;
  gate_type_id: Scalars['String'];
  id: Scalars['String'];
  input_currency_id?: Maybe<Scalars['String']>;
  merchant_constant_fee?: Maybe<Scalars['numeric']>;
  merchant_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_id: Scalars['Int'];
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_transaction_decline_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  payment_limit_amount?: Maybe<Scalars['numeric']>;
  payment_limit_duration?: Maybe<Scalars['Int']>;
  payment_system?: Maybe<Scalars['String']>;
  provider_id: Scalars['String'];
  published_at?: Maybe<Scalars['timestamptz']>;
  refund_fee_amount?: Maybe<Scalars['numeric']>;
  rolling_reserve_duration?: Maybe<Scalars['Int']>;
  rolling_reserve_percent?: Maybe<Scalars['numeric']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  sort?: Maybe<Scalars['Int']>;
  traffic_type_id?: Maybe<Scalars['String']>;
  transaction_fee_amount?: Maybe<Scalars['numeric']>;
  unlocked_at?: Maybe<Scalars['timestamptz']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "gate" */
export type GateCardSystemArgs = {
  path?: InputMaybe<Scalars['String']>;
};

export type GatePaymentLimitValueOutput = {
  payment_limit?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "gate" */
export type GateAggregate = {
  aggregate?: Maybe<GateAggregateFields>;
  nodes: Array<Gate>;
};

/** aggregate fields of "gate" */
export type GateAggregateFields = {
  avg?: Maybe<GateAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<GateMaxFields>;
  min?: Maybe<GateMinFields>;
  stddev?: Maybe<GateStddevFields>;
  stddev_pop?: Maybe<GateStddevPopFields>;
  stddev_samp?: Maybe<GateStddevSampFields>;
  sum?: Maybe<GateSumFields>;
  var_pop?: Maybe<GateVarPopFields>;
  var_samp?: Maybe<GateVarSampFields>;
  variance?: Maybe<GateVarianceFields>;
};


/** aggregate fields of "gate" */
export type GateAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GateSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "gate" */
export type GateAggregateOrderBy = {
  avg?: InputMaybe<GateAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GateMaxOrderBy>;
  min?: InputMaybe<GateMinOrderBy>;
  stddev?: InputMaybe<GateStddevOrderBy>;
  stddev_pop?: InputMaybe<GateStddevPopOrderBy>;
  stddev_samp?: InputMaybe<GateStddevSampOrderBy>;
  sum?: InputMaybe<GateSumOrderBy>;
  var_pop?: InputMaybe<GateVarPopOrderBy>;
  var_samp?: InputMaybe<GateVarSampOrderBy>;
  variance?: InputMaybe<GateVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type GateAppendInput = {
  card_system?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "gate" */
export type GateArrRelInsertInput = {
  data: Array<GateInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<GateOnConflict>;
};

/** aggregate avg on columns */
export type GateAvgFields = {
  calculated_balance?: Maybe<Scalars['Float']>;
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_decline_fee_amount?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
  payment_limit_amount?: Maybe<Scalars['Float']>;
  payment_limit_duration?: Maybe<Scalars['Float']>;
  refund_fee_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "gate" */
export type GateAvgOrderBy = {
  calculated_balance?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  merchant_constant_fee?: InputMaybe<OrderBy>;
  merchant_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_fee_percent?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_transaction_decline_fee_amount?: InputMaybe<OrderBy>;
  merchant_transaction_fee_amount?: InputMaybe<OrderBy>;
  payment_limit_amount?: InputMaybe<OrderBy>;
  payment_limit_duration?: InputMaybe<OrderBy>;
  refund_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
  transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "gate". All fields are combined with a logical 'AND'. */
export type GateBoolExp = {
  _and?: InputMaybe<Array<GateBoolExp>>;
  _not?: InputMaybe<GateBoolExp>;
  _or?: InputMaybe<Array<GateBoolExp>>;
  active_gate?: InputMaybe<VActiveGateBoolExp>;
  admin_gate_list?: InputMaybe<VAdminGateListBoolExp>;
  alias?: InputMaybe<StringComparisonExp>;
  blocked_at?: InputMaybe<TimestamptzComparisonExp>;
  calculated_balance?: InputMaybe<NumericComparisonExp>;
  can_recurrent?: InputMaybe<BooleanComparisonExp>;
  card_system?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  currency_id?: InputMaybe<StringComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  edit_user_id?: InputMaybe<IntComparisonExp>;
  gate_group?: InputMaybe<GateGroupBoolExp>;
  gate_group_id?: InputMaybe<StringComparisonExp>;
  gate_type_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  input_currency_id?: InputMaybe<StringComparisonExp>;
  merchant_constant_fee?: InputMaybe<NumericComparisonExp>;
  merchant_fee_min_amount?: InputMaybe<NumericComparisonExp>;
  merchant_fee_percent?: InputMaybe<NumericComparisonExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<NumericComparisonExp>;
  merchant_transaction_decline_fee_amount?: InputMaybe<NumericComparisonExp>;
  merchant_transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
  payment_limit_amount?: InputMaybe<NumericComparisonExp>;
  payment_limit_duration?: InputMaybe<IntComparisonExp>;
  payment_system?: InputMaybe<StringComparisonExp>;
  provider_id?: InputMaybe<StringComparisonExp>;
  published_at?: InputMaybe<TimestamptzComparisonExp>;
  refund_fee_amount?: InputMaybe<NumericComparisonExp>;
  rolling_reserve_duration?: InputMaybe<IntComparisonExp>;
  rolling_reserve_percent?: InputMaybe<NumericComparisonExp>;
  settlement_usdt_fee_percent?: InputMaybe<NumericComparisonExp>;
  sort?: InputMaybe<IntComparisonExp>;
  traffic_type_id?: InputMaybe<StringComparisonExp>;
  transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
  unlocked_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "gate" */
export enum GateConstraint {
  /** unique or primary key constraint on columns "gate_type_id", "gate_group_id" */
  GateGateTypeIdGateGroupIdConstraint = 'gate_gate_type_id_gate_group_id_constraint',
  /** unique or primary key constraint on columns "id" */
  GatePkey = 'gate_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type GateDeleteAtPathInput = {
  card_system?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type GateDeleteElemInput = {
  card_system?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type GateDeleteKeyInput = {
  card_system?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "gate_group" */
export type GateGroup = {
  /** An array relationship */
  active_gate: Array<VActiveGate>;
  /** An aggregate relationship */
  active_gate_aggregate: VActiveGateAggregate;
  /** An object relationship */
  balance?: Maybe<VGateGroupBalance>;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  gate: Array<Gate>;
  /** An aggregate relationship */
  gate_aggregate: GateAggregate;
  id: Scalars['String'];
  /** An object relationship */
  merchant: Merchant;
  merchant_id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  provider_family?: Maybe<Scalars['String']>;
  /** An object relationship */
  provider_family_object?: Maybe<ProviderFamily>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "gate_group" */
export type GateGroupActiveGateArgs = {
  distinct_on?: InputMaybe<Array<VActiveGateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VActiveGateOrderBy>>;
  where?: InputMaybe<VActiveGateBoolExp>;
};


/** columns and relationships of "gate_group" */
export type GateGroupActiveGateAggregateArgs = {
  distinct_on?: InputMaybe<Array<VActiveGateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VActiveGateOrderBy>>;
  where?: InputMaybe<VActiveGateBoolExp>;
};


/** columns and relationships of "gate_group" */
export type GateGroupGateArgs = {
  distinct_on?: InputMaybe<Array<GateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GateOrderBy>>;
  where?: InputMaybe<GateBoolExp>;
};


/** columns and relationships of "gate_group" */
export type GateGroupGateAggregateArgs = {
  distinct_on?: InputMaybe<Array<GateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GateOrderBy>>;
  where?: InputMaybe<GateBoolExp>;
};

/** aggregated selection of "gate_group" */
export type GateGroupAggregate = {
  aggregate?: Maybe<GateGroupAggregateFields>;
  nodes: Array<GateGroup>;
};

/** aggregate fields of "gate_group" */
export type GateGroupAggregateFields = {
  avg?: Maybe<GateGroupAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<GateGroupMaxFields>;
  min?: Maybe<GateGroupMinFields>;
  stddev?: Maybe<GateGroupStddevFields>;
  stddev_pop?: Maybe<GateGroupStddevPopFields>;
  stddev_samp?: Maybe<GateGroupStddevSampFields>;
  sum?: Maybe<GateGroupSumFields>;
  var_pop?: Maybe<GateGroupVarPopFields>;
  var_samp?: Maybe<GateGroupVarSampFields>;
  variance?: Maybe<GateGroupVarianceFields>;
};


/** aggregate fields of "gate_group" */
export type GateGroupAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GateGroupSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "gate_group" */
export type GateGroupAggregateOrderBy = {
  avg?: InputMaybe<GateGroupAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GateGroupMaxOrderBy>;
  min?: InputMaybe<GateGroupMinOrderBy>;
  stddev?: InputMaybe<GateGroupStddevOrderBy>;
  stddev_pop?: InputMaybe<GateGroupStddevPopOrderBy>;
  stddev_samp?: InputMaybe<GateGroupStddevSampOrderBy>;
  sum?: InputMaybe<GateGroupSumOrderBy>;
  var_pop?: InputMaybe<GateGroupVarPopOrderBy>;
  var_samp?: InputMaybe<GateGroupVarSampOrderBy>;
  variance?: InputMaybe<GateGroupVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "gate_group" */
export type GateGroupArrRelInsertInput = {
  data: Array<GateGroupInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<GateGroupOnConflict>;
};

/** aggregate avg on columns */
export type GateGroupAvgFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "gate_group" */
export type GateGroupAvgOrderBy = {
  merchant_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "gate_group". All fields are combined with a logical 'AND'. */
export type GateGroupBoolExp = {
  _and?: InputMaybe<Array<GateGroupBoolExp>>;
  _not?: InputMaybe<GateGroupBoolExp>;
  _or?: InputMaybe<Array<GateGroupBoolExp>>;
  active_gate?: InputMaybe<VActiveGateBoolExp>;
  balance?: InputMaybe<VGateGroupBalanceBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  gate?: InputMaybe<GateBoolExp>;
  id?: InputMaybe<StringComparisonExp>;
  merchant?: InputMaybe<MerchantBoolExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  provider_family?: InputMaybe<StringComparisonExp>;
  provider_family_object?: InputMaybe<ProviderFamilyBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "gate_group" */
export enum GateGroupConstraint {
  /** unique or primary key constraint on columns "id" */
  GateGroupPkey = 'gate_group_pkey'
}

/** input type for incrementing numeric columns in table "gate_group" */
export type GateGroupIncInput = {
  merchant_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "gate_group" */
export type GateGroupInsertInput = {
  active_gate?: InputMaybe<VActiveGateArrRelInsertInput>;
  balance?: InputMaybe<VGateGroupBalanceObjRelInsertInput>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  gate?: InputMaybe<GateArrRelInsertInput>;
  id?: InputMaybe<Scalars['String']>;
  merchant?: InputMaybe<MerchantObjRelInsertInput>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  provider_family?: InputMaybe<Scalars['String']>;
  provider_family_object?: InputMaybe<ProviderFamilyObjRelInsertInput>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type GateGroupMaxFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  provider_family?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "gate_group" */
export type GateGroupMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  provider_family?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type GateGroupMinFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  provider_family?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "gate_group" */
export type GateGroupMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  provider_family?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "gate_group" */
export type GateGroupMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GateGroup>;
};

/** input type for inserting object relation for remote table "gate_group" */
export type GateGroupObjRelInsertInput = {
  data: GateGroupInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<GateGroupOnConflict>;
};

/** on_conflict condition type for table "gate_group" */
export type GateGroupOnConflict = {
  constraint: GateGroupConstraint;
  update_columns?: Array<GateGroupUpdateColumn>;
  where?: InputMaybe<GateGroupBoolExp>;
};

/** Ordering options when selecting data from "gate_group". */
export type GateGroupOrderBy = {
  active_gate_aggregate?: InputMaybe<VActiveGateAggregateOrderBy>;
  balance?: InputMaybe<VGateGroupBalanceOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  gate_aggregate?: InputMaybe<GateAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant?: InputMaybe<MerchantOrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  provider_family?: InputMaybe<OrderBy>;
  provider_family_object?: InputMaybe<ProviderFamilyOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: gate_group */
export type GateGroupPkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "gate_group" */
export enum GateGroupSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  Name = 'name',
  /** column name */
  ProviderFamily = 'provider_family',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "gate_group" */
export type GateGroupSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  provider_family?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type GateGroupStddevFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "gate_group" */
export type GateGroupStddevOrderBy = {
  merchant_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type GateGroupStddevPopFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "gate_group" */
export type GateGroupStddevPopOrderBy = {
  merchant_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type GateGroupStddevSampFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "gate_group" */
export type GateGroupStddevSampOrderBy = {
  merchant_id?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type GateGroupSumFields = {
  merchant_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "gate_group" */
export type GateGroupSumOrderBy = {
  merchant_id?: InputMaybe<OrderBy>;
};

/** update columns of table "gate_group" */
export enum GateGroupUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  Name = 'name',
  /** column name */
  ProviderFamily = 'provider_family',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type GateGroupUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<GateGroupIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GateGroupSetInput>;
  where: GateGroupBoolExp;
};

/** aggregate var_pop on columns */
export type GateGroupVarPopFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "gate_group" */
export type GateGroupVarPopOrderBy = {
  merchant_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type GateGroupVarSampFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "gate_group" */
export type GateGroupVarSampOrderBy = {
  merchant_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type GateGroupVarianceFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "gate_group" */
export type GateGroupVarianceOrderBy = {
  merchant_id?: InputMaybe<OrderBy>;
};

/** input type for incrementing numeric columns in table "gate" */
export type GateIncInput = {
  calculated_balance?: InputMaybe<Scalars['numeric']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  merchant_constant_fee?: InputMaybe<Scalars['numeric']>;
  merchant_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_transaction_decline_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  payment_limit_amount?: InputMaybe<Scalars['numeric']>;
  payment_limit_duration?: InputMaybe<Scalars['Int']>;
  refund_fee_amount?: InputMaybe<Scalars['numeric']>;
  rolling_reserve_duration?: InputMaybe<Scalars['Int']>;
  rolling_reserve_percent?: InputMaybe<Scalars['numeric']>;
  settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  sort?: InputMaybe<Scalars['Int']>;
  transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "gate" */
export type GateInsertInput = {
  active_gate?: InputMaybe<VActiveGateObjRelInsertInput>;
  admin_gate_list?: InputMaybe<VAdminGateListObjRelInsertInput>;
  alias?: InputMaybe<Scalars['String']>;
  blocked_at?: InputMaybe<Scalars['timestamptz']>;
  calculated_balance?: InputMaybe<Scalars['numeric']>;
  can_recurrent?: InputMaybe<Scalars['Boolean']>;
  card_system?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency_id?: InputMaybe<Scalars['String']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  gate_group?: InputMaybe<GateGroupObjRelInsertInput>;
  gate_group_id?: InputMaybe<Scalars['String']>;
  gate_type_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  input_currency_id?: InputMaybe<Scalars['String']>;
  merchant_constant_fee?: InputMaybe<Scalars['numeric']>;
  merchant_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_transaction_decline_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  payment_limit_amount?: InputMaybe<Scalars['numeric']>;
  payment_limit_duration?: InputMaybe<Scalars['Int']>;
  payment_system?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['timestamptz']>;
  refund_fee_amount?: InputMaybe<Scalars['numeric']>;
  rolling_reserve_duration?: InputMaybe<Scalars['Int']>;
  rolling_reserve_percent?: InputMaybe<Scalars['numeric']>;
  settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  sort?: InputMaybe<Scalars['Int']>;
  traffic_type_id?: InputMaybe<Scalars['String']>;
  transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  unlocked_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type GateMaxFields = {
  alias?: Maybe<Scalars['String']>;
  blocked_at?: Maybe<Scalars['timestamptz']>;
  calculated_balance?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  gate_group_id?: Maybe<Scalars['String']>;
  gate_type_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  input_currency_id?: Maybe<Scalars['String']>;
  merchant_constant_fee?: Maybe<Scalars['numeric']>;
  merchant_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_transaction_decline_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  payment_limit_amount?: Maybe<Scalars['numeric']>;
  payment_limit_duration?: Maybe<Scalars['Int']>;
  payment_system?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['timestamptz']>;
  refund_fee_amount?: Maybe<Scalars['numeric']>;
  rolling_reserve_duration?: Maybe<Scalars['Int']>;
  rolling_reserve_percent?: Maybe<Scalars['numeric']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  sort?: Maybe<Scalars['Int']>;
  traffic_type_id?: Maybe<Scalars['String']>;
  transaction_fee_amount?: Maybe<Scalars['numeric']>;
  unlocked_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "gate" */
export type GateMaxOrderBy = {
  alias?: InputMaybe<OrderBy>;
  blocked_at?: InputMaybe<OrderBy>;
  calculated_balance?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  gate_group_id?: InputMaybe<OrderBy>;
  gate_type_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_id?: InputMaybe<OrderBy>;
  merchant_constant_fee?: InputMaybe<OrderBy>;
  merchant_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_fee_percent?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_transaction_decline_fee_amount?: InputMaybe<OrderBy>;
  merchant_transaction_fee_amount?: InputMaybe<OrderBy>;
  payment_limit_amount?: InputMaybe<OrderBy>;
  payment_limit_duration?: InputMaybe<OrderBy>;
  payment_system?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  published_at?: InputMaybe<OrderBy>;
  refund_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
  traffic_type_id?: InputMaybe<OrderBy>;
  transaction_fee_amount?: InputMaybe<OrderBy>;
  unlocked_at?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type GateMinFields = {
  alias?: Maybe<Scalars['String']>;
  blocked_at?: Maybe<Scalars['timestamptz']>;
  calculated_balance?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  gate_group_id?: Maybe<Scalars['String']>;
  gate_type_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  input_currency_id?: Maybe<Scalars['String']>;
  merchant_constant_fee?: Maybe<Scalars['numeric']>;
  merchant_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_transaction_decline_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  payment_limit_amount?: Maybe<Scalars['numeric']>;
  payment_limit_duration?: Maybe<Scalars['Int']>;
  payment_system?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['timestamptz']>;
  refund_fee_amount?: Maybe<Scalars['numeric']>;
  rolling_reserve_duration?: Maybe<Scalars['Int']>;
  rolling_reserve_percent?: Maybe<Scalars['numeric']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  sort?: Maybe<Scalars['Int']>;
  traffic_type_id?: Maybe<Scalars['String']>;
  transaction_fee_amount?: Maybe<Scalars['numeric']>;
  unlocked_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "gate" */
export type GateMinOrderBy = {
  alias?: InputMaybe<OrderBy>;
  blocked_at?: InputMaybe<OrderBy>;
  calculated_balance?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  gate_group_id?: InputMaybe<OrderBy>;
  gate_type_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_id?: InputMaybe<OrderBy>;
  merchant_constant_fee?: InputMaybe<OrderBy>;
  merchant_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_fee_percent?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_transaction_decline_fee_amount?: InputMaybe<OrderBy>;
  merchant_transaction_fee_amount?: InputMaybe<OrderBy>;
  payment_limit_amount?: InputMaybe<OrderBy>;
  payment_limit_duration?: InputMaybe<OrderBy>;
  payment_system?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  published_at?: InputMaybe<OrderBy>;
  refund_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
  traffic_type_id?: InputMaybe<OrderBy>;
  transaction_fee_amount?: InputMaybe<OrderBy>;
  unlocked_at?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "gate" */
export type GateMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Gate>;
};

/** input type for inserting object relation for remote table "gate" */
export type GateObjRelInsertInput = {
  data: GateInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<GateOnConflict>;
};

/** on_conflict condition type for table "gate" */
export type GateOnConflict = {
  constraint: GateConstraint;
  update_columns?: Array<GateUpdateColumn>;
  where?: InputMaybe<GateBoolExp>;
};

/** Ordering options when selecting data from "gate". */
export type GateOrderBy = {
  active_gate?: InputMaybe<VActiveGateOrderBy>;
  admin_gate_list?: InputMaybe<VAdminGateListOrderBy>;
  alias?: InputMaybe<OrderBy>;
  blocked_at?: InputMaybe<OrderBy>;
  calculated_balance?: InputMaybe<OrderBy>;
  can_recurrent?: InputMaybe<OrderBy>;
  card_system?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  gate_group?: InputMaybe<GateGroupOrderBy>;
  gate_group_id?: InputMaybe<OrderBy>;
  gate_type_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_id?: InputMaybe<OrderBy>;
  merchant_constant_fee?: InputMaybe<OrderBy>;
  merchant_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_fee_percent?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_transaction_decline_fee_amount?: InputMaybe<OrderBy>;
  merchant_transaction_fee_amount?: InputMaybe<OrderBy>;
  payment_limit_amount?: InputMaybe<OrderBy>;
  payment_limit_duration?: InputMaybe<OrderBy>;
  payment_system?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  published_at?: InputMaybe<OrderBy>;
  refund_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
  traffic_type_id?: InputMaybe<OrderBy>;
  transaction_fee_amount?: InputMaybe<OrderBy>;
  unlocked_at?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: gate */
export type GatePkColumnsInput = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type GatePrependInput = {
  card_system?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "gate" */
export enum GateSelectColumn {
  /** column name */
  Alias = 'alias',
  /** column name */
  BlockedAt = 'blocked_at',
  /** column name */
  CalculatedBalance = 'calculated_balance',
  /** column name */
  CanRecurrent = 'can_recurrent',
  /** column name */
  CardSystem = 'card_system',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EditUserId = 'edit_user_id',
  /** column name */
  GateGroupId = 'gate_group_id',
  /** column name */
  GateTypeId = 'gate_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  InputCurrencyId = 'input_currency_id',
  /** column name */
  MerchantConstantFee = 'merchant_constant_fee',
  /** column name */
  MerchantFeeMinAmount = 'merchant_fee_min_amount',
  /** column name */
  MerchantFeePercent = 'merchant_fee_percent',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MerchantSettlementUsdtFeePercent = 'merchant_settlement_usdt_fee_percent',
  /** column name */
  MerchantTransactionDeclineFeeAmount = 'merchant_transaction_decline_fee_amount',
  /** column name */
  MerchantTransactionFeeAmount = 'merchant_transaction_fee_amount',
  /** column name */
  PaymentLimitAmount = 'payment_limit_amount',
  /** column name */
  PaymentLimitDuration = 'payment_limit_duration',
  /** column name */
  PaymentSystem = 'payment_system',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  PublishedAt = 'published_at',
  /** column name */
  RefundFeeAmount = 'refund_fee_amount',
  /** column name */
  RollingReserveDuration = 'rolling_reserve_duration',
  /** column name */
  RollingReservePercent = 'rolling_reserve_percent',
  /** column name */
  SettlementUsdtFeePercent = 'settlement_usdt_fee_percent',
  /** column name */
  Sort = 'sort',
  /** column name */
  TrafficTypeId = 'traffic_type_id',
  /** column name */
  TransactionFeeAmount = 'transaction_fee_amount',
  /** column name */
  UnlockedAt = 'unlocked_at',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "gate" */
export type GateSetInput = {
  alias?: InputMaybe<Scalars['String']>;
  blocked_at?: InputMaybe<Scalars['timestamptz']>;
  calculated_balance?: InputMaybe<Scalars['numeric']>;
  can_recurrent?: InputMaybe<Scalars['Boolean']>;
  card_system?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency_id?: InputMaybe<Scalars['String']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  gate_group_id?: InputMaybe<Scalars['String']>;
  gate_type_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  input_currency_id?: InputMaybe<Scalars['String']>;
  merchant_constant_fee?: InputMaybe<Scalars['numeric']>;
  merchant_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_transaction_decline_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  payment_limit_amount?: InputMaybe<Scalars['numeric']>;
  payment_limit_duration?: InputMaybe<Scalars['Int']>;
  payment_system?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['timestamptz']>;
  refund_fee_amount?: InputMaybe<Scalars['numeric']>;
  rolling_reserve_duration?: InputMaybe<Scalars['Int']>;
  rolling_reserve_percent?: InputMaybe<Scalars['numeric']>;
  settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  sort?: InputMaybe<Scalars['Int']>;
  traffic_type_id?: InputMaybe<Scalars['String']>;
  transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  unlocked_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type GateStddevFields = {
  calculated_balance?: Maybe<Scalars['Float']>;
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_decline_fee_amount?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
  payment_limit_amount?: Maybe<Scalars['Float']>;
  payment_limit_duration?: Maybe<Scalars['Float']>;
  refund_fee_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "gate" */
export type GateStddevOrderBy = {
  calculated_balance?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  merchant_constant_fee?: InputMaybe<OrderBy>;
  merchant_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_fee_percent?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_transaction_decline_fee_amount?: InputMaybe<OrderBy>;
  merchant_transaction_fee_amount?: InputMaybe<OrderBy>;
  payment_limit_amount?: InputMaybe<OrderBy>;
  payment_limit_duration?: InputMaybe<OrderBy>;
  refund_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
  transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type GateStddevPopFields = {
  calculated_balance?: Maybe<Scalars['Float']>;
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_decline_fee_amount?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
  payment_limit_amount?: Maybe<Scalars['Float']>;
  payment_limit_duration?: Maybe<Scalars['Float']>;
  refund_fee_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "gate" */
export type GateStddevPopOrderBy = {
  calculated_balance?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  merchant_constant_fee?: InputMaybe<OrderBy>;
  merchant_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_fee_percent?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_transaction_decline_fee_amount?: InputMaybe<OrderBy>;
  merchant_transaction_fee_amount?: InputMaybe<OrderBy>;
  payment_limit_amount?: InputMaybe<OrderBy>;
  payment_limit_duration?: InputMaybe<OrderBy>;
  refund_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
  transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type GateStddevSampFields = {
  calculated_balance?: Maybe<Scalars['Float']>;
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_decline_fee_amount?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
  payment_limit_amount?: Maybe<Scalars['Float']>;
  payment_limit_duration?: Maybe<Scalars['Float']>;
  refund_fee_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "gate" */
export type GateStddevSampOrderBy = {
  calculated_balance?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  merchant_constant_fee?: InputMaybe<OrderBy>;
  merchant_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_fee_percent?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_transaction_decline_fee_amount?: InputMaybe<OrderBy>;
  merchant_transaction_fee_amount?: InputMaybe<OrderBy>;
  payment_limit_amount?: InputMaybe<OrderBy>;
  payment_limit_duration?: InputMaybe<OrderBy>;
  refund_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
  transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type GateSumFields = {
  calculated_balance?: Maybe<Scalars['numeric']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  merchant_constant_fee?: Maybe<Scalars['numeric']>;
  merchant_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_transaction_decline_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  payment_limit_amount?: Maybe<Scalars['numeric']>;
  payment_limit_duration?: Maybe<Scalars['Int']>;
  refund_fee_amount?: Maybe<Scalars['numeric']>;
  rolling_reserve_duration?: Maybe<Scalars['Int']>;
  rolling_reserve_percent?: Maybe<Scalars['numeric']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  sort?: Maybe<Scalars['Int']>;
  transaction_fee_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "gate" */
export type GateSumOrderBy = {
  calculated_balance?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  merchant_constant_fee?: InputMaybe<OrderBy>;
  merchant_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_fee_percent?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_transaction_decline_fee_amount?: InputMaybe<OrderBy>;
  merchant_transaction_fee_amount?: InputMaybe<OrderBy>;
  payment_limit_amount?: InputMaybe<OrderBy>;
  payment_limit_duration?: InputMaybe<OrderBy>;
  refund_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
  transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "gate_type" */
export type GateType = {
  created_at: Scalars['timestamptz'];
  id: Scalars['String'];
};

/** aggregated selection of "gate_type" */
export type GateTypeAggregate = {
  aggregate?: Maybe<GateTypeAggregateFields>;
  nodes: Array<GateType>;
};

/** aggregate fields of "gate_type" */
export type GateTypeAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<GateTypeMaxFields>;
  min?: Maybe<GateTypeMinFields>;
};


/** aggregate fields of "gate_type" */
export type GateTypeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GateTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "gate_type". All fields are combined with a logical 'AND'. */
export type GateTypeBoolExp = {
  _and?: InputMaybe<Array<GateTypeBoolExp>>;
  _not?: InputMaybe<GateTypeBoolExp>;
  _or?: InputMaybe<Array<GateTypeBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "gate_type" */
export enum GateTypeConstraint {
  /** unique or primary key constraint on columns "id" */
  GateTypePkey = 'gate_type_pkey'
}

/** input type for inserting data into table "gate_type" */
export type GateTypeInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GateTypeMaxFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type GateTypeMinFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "gate_type" */
export type GateTypeMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GateType>;
};

/** on_conflict condition type for table "gate_type" */
export type GateTypeOnConflict = {
  constraint: GateTypeConstraint;
  update_columns?: Array<GateTypeUpdateColumn>;
  where?: InputMaybe<GateTypeBoolExp>;
};

/** Ordering options when selecting data from "gate_type". */
export type GateTypeOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: gate_type */
export type GateTypePkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "gate_type" */
export enum GateTypeSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "gate_type" */
export type GateTypeSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "gate_type" */
export enum GateTypeUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id'
}

export type GateTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GateTypeSetInput>;
  where: GateTypeBoolExp;
};

/** update columns of table "gate" */
export enum GateUpdateColumn {
  /** column name */
  Alias = 'alias',
  /** column name */
  BlockedAt = 'blocked_at',
  /** column name */
  CalculatedBalance = 'calculated_balance',
  /** column name */
  CanRecurrent = 'can_recurrent',
  /** column name */
  CardSystem = 'card_system',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EditUserId = 'edit_user_id',
  /** column name */
  GateGroupId = 'gate_group_id',
  /** column name */
  GateTypeId = 'gate_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  InputCurrencyId = 'input_currency_id',
  /** column name */
  MerchantConstantFee = 'merchant_constant_fee',
  /** column name */
  MerchantFeeMinAmount = 'merchant_fee_min_amount',
  /** column name */
  MerchantFeePercent = 'merchant_fee_percent',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MerchantSettlementUsdtFeePercent = 'merchant_settlement_usdt_fee_percent',
  /** column name */
  MerchantTransactionDeclineFeeAmount = 'merchant_transaction_decline_fee_amount',
  /** column name */
  MerchantTransactionFeeAmount = 'merchant_transaction_fee_amount',
  /** column name */
  PaymentLimitAmount = 'payment_limit_amount',
  /** column name */
  PaymentLimitDuration = 'payment_limit_duration',
  /** column name */
  PaymentSystem = 'payment_system',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  PublishedAt = 'published_at',
  /** column name */
  RefundFeeAmount = 'refund_fee_amount',
  /** column name */
  RollingReserveDuration = 'rolling_reserve_duration',
  /** column name */
  RollingReservePercent = 'rolling_reserve_percent',
  /** column name */
  SettlementUsdtFeePercent = 'settlement_usdt_fee_percent',
  /** column name */
  Sort = 'sort',
  /** column name */
  TrafficTypeId = 'traffic_type_id',
  /** column name */
  TransactionFeeAmount = 'transaction_fee_amount',
  /** column name */
  UnlockedAt = 'unlocked_at',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type GateUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<GateAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<GateDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<GateDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<GateDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<GateIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<GatePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GateSetInput>;
  where: GateBoolExp;
};

/** aggregate var_pop on columns */
export type GateVarPopFields = {
  calculated_balance?: Maybe<Scalars['Float']>;
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_decline_fee_amount?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
  payment_limit_amount?: Maybe<Scalars['Float']>;
  payment_limit_duration?: Maybe<Scalars['Float']>;
  refund_fee_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "gate" */
export type GateVarPopOrderBy = {
  calculated_balance?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  merchant_constant_fee?: InputMaybe<OrderBy>;
  merchant_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_fee_percent?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_transaction_decline_fee_amount?: InputMaybe<OrderBy>;
  merchant_transaction_fee_amount?: InputMaybe<OrderBy>;
  payment_limit_amount?: InputMaybe<OrderBy>;
  payment_limit_duration?: InputMaybe<OrderBy>;
  refund_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
  transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type GateVarSampFields = {
  calculated_balance?: Maybe<Scalars['Float']>;
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_decline_fee_amount?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
  payment_limit_amount?: Maybe<Scalars['Float']>;
  payment_limit_duration?: Maybe<Scalars['Float']>;
  refund_fee_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "gate" */
export type GateVarSampOrderBy = {
  calculated_balance?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  merchant_constant_fee?: InputMaybe<OrderBy>;
  merchant_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_fee_percent?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_transaction_decline_fee_amount?: InputMaybe<OrderBy>;
  merchant_transaction_fee_amount?: InputMaybe<OrderBy>;
  payment_limit_amount?: InputMaybe<OrderBy>;
  payment_limit_duration?: InputMaybe<OrderBy>;
  refund_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
  transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type GateVarianceFields = {
  calculated_balance?: Maybe<Scalars['Float']>;
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_decline_fee_amount?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
  payment_limit_amount?: Maybe<Scalars['Float']>;
  payment_limit_duration?: Maybe<Scalars['Float']>;
  refund_fee_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "gate" */
export type GateVarianceOrderBy = {
  calculated_balance?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  merchant_constant_fee?: InputMaybe<OrderBy>;
  merchant_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_fee_percent?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_transaction_decline_fee_amount?: InputMaybe<OrderBy>;
  merchant_transaction_fee_amount?: InputMaybe<OrderBy>;
  payment_limit_amount?: InputMaybe<OrderBy>;
  payment_limit_duration?: InputMaybe<OrderBy>;
  refund_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
  transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "gender" */
export type Gender = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "gender" */
export type GenderAggregate = {
  aggregate?: Maybe<GenderAggregateFields>;
  nodes: Array<Gender>;
};

/** aggregate fields of "gender" */
export type GenderAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<GenderMaxFields>;
  min?: Maybe<GenderMinFields>;
};


/** aggregate fields of "gender" */
export type GenderAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GenderSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "gender". All fields are combined with a logical 'AND'. */
export type GenderBoolExp = {
  _and?: InputMaybe<Array<GenderBoolExp>>;
  _not?: InputMaybe<GenderBoolExp>;
  _or?: InputMaybe<Array<GenderBoolExp>>;
  id?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "gender" */
export enum GenderConstraint {
  /** unique or primary key constraint on columns "id" */
  GenderPkey = 'gender_pkey'
}

/** input type for inserting data into table "gender" */
export type GenderInsertInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GenderMaxFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type GenderMinFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "gender" */
export type GenderMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Gender>;
};

/** on_conflict condition type for table "gender" */
export type GenderOnConflict = {
  constraint: GenderConstraint;
  update_columns?: Array<GenderUpdateColumn>;
  where?: InputMaybe<GenderBoolExp>;
};

/** Ordering options when selecting data from "gender". */
export type GenderOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: gender */
export type GenderPkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "gender" */
export enum GenderSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "gender" */
export type GenderSetInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "gender" */
export enum GenderUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type GenderUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GenderSetInput>;
  where: GenderBoolExp;
};

/** columns and relationships of "help" */
export type Help = {
  answer: Scalars['String'];
  /** An object relationship */
  help_section: HelpSection;
  help_section_id: Scalars['String'];
  id: Scalars['Int'];
  question: Scalars['String'];
};

/** aggregated selection of "help" */
export type HelpAggregate = {
  aggregate?: Maybe<HelpAggregateFields>;
  nodes: Array<Help>;
};

/** aggregate fields of "help" */
export type HelpAggregateFields = {
  avg?: Maybe<HelpAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<HelpMaxFields>;
  min?: Maybe<HelpMinFields>;
  stddev?: Maybe<HelpStddevFields>;
  stddev_pop?: Maybe<HelpStddevPopFields>;
  stddev_samp?: Maybe<HelpStddevSampFields>;
  sum?: Maybe<HelpSumFields>;
  var_pop?: Maybe<HelpVarPopFields>;
  var_samp?: Maybe<HelpVarSampFields>;
  variance?: Maybe<HelpVarianceFields>;
};


/** aggregate fields of "help" */
export type HelpAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<HelpSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type HelpAvgFields = {
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "help". All fields are combined with a logical 'AND'. */
export type HelpBoolExp = {
  _and?: InputMaybe<Array<HelpBoolExp>>;
  _not?: InputMaybe<HelpBoolExp>;
  _or?: InputMaybe<Array<HelpBoolExp>>;
  answer?: InputMaybe<StringComparisonExp>;
  help_section?: InputMaybe<HelpSectionBoolExp>;
  help_section_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  question?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "help" */
export enum HelpConstraint {
  /** unique or primary key constraint on columns "id" */
  HelpPkey = 'help_pkey'
}

/** input type for incrementing numeric columns in table "help" */
export type HelpIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "help" */
export type HelpInsertInput = {
  answer?: InputMaybe<Scalars['String']>;
  help_section?: InputMaybe<HelpSectionObjRelInsertInput>;
  help_section_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type HelpMaxFields = {
  answer?: Maybe<Scalars['String']>;
  help_section_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  question?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type HelpMinFields = {
  answer?: Maybe<Scalars['String']>;
  help_section_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  question?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "help" */
export type HelpMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Help>;
};

/** on_conflict condition type for table "help" */
export type HelpOnConflict = {
  constraint: HelpConstraint;
  update_columns?: Array<HelpUpdateColumn>;
  where?: InputMaybe<HelpBoolExp>;
};

/** Ordering options when selecting data from "help". */
export type HelpOrderBy = {
  answer?: InputMaybe<OrderBy>;
  help_section?: InputMaybe<HelpSectionOrderBy>;
  help_section_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  question?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: help */
export type HelpPkColumnsInput = {
  id: Scalars['Int'];
};

/** columns and relationships of "help_section" */
export type HelpSection = {
  id: Scalars['String'];
  language_id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "help_section" */
export type HelpSectionAggregate = {
  aggregate?: Maybe<HelpSectionAggregateFields>;
  nodes: Array<HelpSection>;
};

/** aggregate fields of "help_section" */
export type HelpSectionAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<HelpSectionMaxFields>;
  min?: Maybe<HelpSectionMinFields>;
};


/** aggregate fields of "help_section" */
export type HelpSectionAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<HelpSectionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "help_section". All fields are combined with a logical 'AND'. */
export type HelpSectionBoolExp = {
  _and?: InputMaybe<Array<HelpSectionBoolExp>>;
  _not?: InputMaybe<HelpSectionBoolExp>;
  _or?: InputMaybe<Array<HelpSectionBoolExp>>;
  id?: InputMaybe<StringComparisonExp>;
  language_id?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "help_section" */
export enum HelpSectionConstraint {
  /** unique or primary key constraint on columns "id" */
  HelpSectionPkey = 'help_section_pkey'
}

/** input type for inserting data into table "help_section" */
export type HelpSectionInsertInput = {
  id?: InputMaybe<Scalars['String']>;
  language_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type HelpSectionMaxFields = {
  id?: Maybe<Scalars['String']>;
  language_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type HelpSectionMinFields = {
  id?: Maybe<Scalars['String']>;
  language_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "help_section" */
export type HelpSectionMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<HelpSection>;
};

/** input type for inserting object relation for remote table "help_section" */
export type HelpSectionObjRelInsertInput = {
  data: HelpSectionInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<HelpSectionOnConflict>;
};

/** on_conflict condition type for table "help_section" */
export type HelpSectionOnConflict = {
  constraint: HelpSectionConstraint;
  update_columns?: Array<HelpSectionUpdateColumn>;
  where?: InputMaybe<HelpSectionBoolExp>;
};

/** Ordering options when selecting data from "help_section". */
export type HelpSectionOrderBy = {
  id?: InputMaybe<OrderBy>;
  language_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: help_section */
export type HelpSectionPkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "help_section" */
export enum HelpSectionSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "help_section" */
export type HelpSectionSetInput = {
  id?: InputMaybe<Scalars['String']>;
  language_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "help_section" */
export enum HelpSectionUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  Name = 'name'
}

export type HelpSectionUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<HelpSectionSetInput>;
  where: HelpSectionBoolExp;
};

/** select columns of table "help" */
export enum HelpSelectColumn {
  /** column name */
  Answer = 'answer',
  /** column name */
  HelpSectionId = 'help_section_id',
  /** column name */
  Id = 'id',
  /** column name */
  Question = 'question'
}

/** input type for updating data in table "help" */
export type HelpSetInput = {
  answer?: InputMaybe<Scalars['String']>;
  help_section_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type HelpStddevFields = {
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type HelpStddevPopFields = {
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type HelpStddevSampFields = {
  id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type HelpSumFields = {
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "help" */
export enum HelpUpdateColumn {
  /** column name */
  Answer = 'answer',
  /** column name */
  HelpSectionId = 'help_section_id',
  /** column name */
  Id = 'id',
  /** column name */
  Question = 'question'
}

export type HelpUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<HelpIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<HelpSetInput>;
  where: HelpBoolExp;
};

/** aggregate var_pop on columns */
export type HelpVarPopFields = {
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type HelpVarSampFields = {
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type HelpVarianceFields = {
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "invoice" */
export type Invoice = {
  additional_data?: Maybe<Scalars['jsonb']>;
  amount: Scalars['numeric'];
  bank_id?: Maybe<Scalars['String']>;
  callback_url?: Maybe<Scalars['String']>;
  card_system_id?: Maybe<Scalars['String']>;
  cascade_request_id?: Maybe<Scalars['String']>;
  client_ip?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  constant_invoice_fee?: Maybe<Scalars['numeric']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  currency: Currency;
  currency_id: Scalars['String'];
  currency_rate: Scalars['numeric'];
  external_id?: Maybe<Scalars['String']>;
  form_method?: Maybe<Scalars['String']>;
  /** An object relationship */
  gate?: Maybe<Gate>;
  gate_id?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  input_currency_id?: Maybe<Scalars['String']>;
  invoice_3ds_url?: Maybe<Scalars['String']>;
  invoice_transaction_fee_amount: Scalars['numeric'];
  invoice_url?: Maybe<Scalars['String']>;
  is_chargeback: Scalars['Boolean'];
  is_manual: Scalars['Boolean'];
  is_recurrent?: Maybe<Scalars['Boolean']>;
  is_refund: Scalars['Boolean'];
  is_unhold: Scalars['Boolean'];
  issue_payment_token?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  merchant: Merchant;
  merchant_constant_invoice_fee?: Maybe<Scalars['numeric']>;
  merchant_id: Scalars['Int'];
  merchant_invoice_decline_transaction_fee_amount: Scalars['numeric'];
  merchant_invoice_decline_transaction_fee_is_payed: Scalars['Boolean'];
  merchant_invoice_fee: Scalars['numeric'];
  merchant_invoice_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount: Scalars['numeric'];
  merchant_invoice_transaction_fee_is_payed: Scalars['Boolean'];
  payment_source_id: Scalars['String'];
  payment_system?: Maybe<Scalars['String']>;
  personal_data?: Maybe<Scalars['jsonb']>;
  profit: Scalars['numeric'];
  /** An object relationship */
  provider: Provider;
  provider_amount: Scalars['numeric'];
  provider_id: Scalars['String'];
  provider_invoice_fee: Scalars['numeric'];
  provider_invoice_fee_percent: Scalars['numeric'];
  provider_invoice_id?: Maybe<Scalars['String']>;
  provider_payment_system?: Maybe<Scalars['String']>;
  provider_status?: Maybe<Scalars['String']>;
  provider_transaction_uid?: Maybe<Scalars['String']>;
  recalculated: Scalars['Boolean'];
  recalculated_at?: Maybe<Scalars['timestamptz']>;
  reconciliated_at?: Maybe<Scalars['timestamptz']>;
  recurrent_token?: Maybe<Scalars['String']>;
  redirect_failed_url?: Maybe<Scalars['String']>;
  redirect_success_url?: Maybe<Scalars['String']>;
  refund: Scalars['Boolean'];
  refund_amount?: Maybe<Scalars['numeric']>;
  remark?: Maybe<Scalars['String']>;
  rolling_reserve_amount?: Maybe<Scalars['numeric']>;
  rolling_reserve_expired_at?: Maybe<Scalars['timestamptz']>;
  rolling_reserve_unhold_at?: Maybe<Scalars['timestamptz']>;
  sanitized_mask?: Maybe<Scalars['String']>;
  smart_remark?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  status_updated_at: Scalars['timestamptz'];
  /** An array relationship */
  transaction_histories: Array<TransactionHistory>;
  /** An aggregate relationship */
  transaction_histories_aggregate: TransactionHistoryAggregate;
  transaction_uid?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "invoice" */
export type InvoiceAdditionalDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "invoice" */
export type InvoicePersonalDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "invoice" */
export type InvoiceTransactionHistoriesArgs = {
  distinct_on?: InputMaybe<Array<TransactionHistorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TransactionHistoryOrderBy>>;
  where?: InputMaybe<TransactionHistoryBoolExp>;
};


/** columns and relationships of "invoice" */
export type InvoiceTransactionHistoriesAggregateArgs = {
  distinct_on?: InputMaybe<Array<TransactionHistorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TransactionHistoryOrderBy>>;
  where?: InputMaybe<TransactionHistoryBoolExp>;
};

/** aggregated selection of "invoice" */
export type InvoiceAggregate = {
  aggregate?: Maybe<InvoiceAggregateFields>;
  nodes: Array<Invoice>;
};

/** aggregate fields of "invoice" */
export type InvoiceAggregateFields = {
  avg?: Maybe<InvoiceAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<InvoiceMaxFields>;
  min?: Maybe<InvoiceMinFields>;
  stddev?: Maybe<InvoiceStddevFields>;
  stddev_pop?: Maybe<InvoiceStddevPopFields>;
  stddev_samp?: Maybe<InvoiceStddevSampFields>;
  sum?: Maybe<InvoiceSumFields>;
  var_pop?: Maybe<InvoiceVarPopFields>;
  var_samp?: Maybe<InvoiceVarSampFields>;
  variance?: Maybe<InvoiceVarianceFields>;
};


/** aggregate fields of "invoice" */
export type InvoiceAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InvoiceSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "invoice" */
export type InvoiceAggregateOrderBy = {
  avg?: InputMaybe<InvoiceAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<InvoiceMaxOrderBy>;
  min?: InputMaybe<InvoiceMinOrderBy>;
  stddev?: InputMaybe<InvoiceStddevOrderBy>;
  stddev_pop?: InputMaybe<InvoiceStddevPopOrderBy>;
  stddev_samp?: InputMaybe<InvoiceStddevSampOrderBy>;
  sum?: InputMaybe<InvoiceSumOrderBy>;
  var_pop?: InputMaybe<InvoiceVarPopOrderBy>;
  var_samp?: InputMaybe<InvoiceVarSampOrderBy>;
  variance?: InputMaybe<InvoiceVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type InvoiceAppendInput = {
  additional_data?: InputMaybe<Scalars['jsonb']>;
  personal_data?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "invoice" */
export type InvoiceArrRelInsertInput = {
  data: Array<InvoiceInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<InvoiceOnConflict>;
};

/** aggregate avg on columns */
export type InvoiceAvgFields = {
  amount?: Maybe<Scalars['Float']>;
  constant_invoice_fee?: Maybe<Scalars['Float']>;
  currency_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  provider_amount?: Maybe<Scalars['Float']>;
  provider_invoice_fee?: Maybe<Scalars['Float']>;
  provider_invoice_fee_percent?: Maybe<Scalars['Float']>;
  refund_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "invoice" */
export type InvoiceAvgOrderBy = {
  amount?: InputMaybe<OrderBy>;
  constant_invoice_fee?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  profit?: InputMaybe<OrderBy>;
  provider_amount?: InputMaybe<OrderBy>;
  provider_invoice_fee?: InputMaybe<OrderBy>;
  provider_invoice_fee_percent?: InputMaybe<OrderBy>;
  refund_amount?: InputMaybe<OrderBy>;
  rolling_reserve_amount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "invoice". All fields are combined with a logical 'AND'. */
export type InvoiceBoolExp = {
  _and?: InputMaybe<Array<InvoiceBoolExp>>;
  _not?: InputMaybe<InvoiceBoolExp>;
  _or?: InputMaybe<Array<InvoiceBoolExp>>;
  additional_data?: InputMaybe<JsonbComparisonExp>;
  amount?: InputMaybe<NumericComparisonExp>;
  bank_id?: InputMaybe<StringComparisonExp>;
  callback_url?: InputMaybe<StringComparisonExp>;
  card_system_id?: InputMaybe<StringComparisonExp>;
  cascade_request_id?: InputMaybe<StringComparisonExp>;
  client_ip?: InputMaybe<StringComparisonExp>;
  comment?: InputMaybe<StringComparisonExp>;
  constant_invoice_fee?: InputMaybe<NumericComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<CurrencyBoolExp>;
  currency_id?: InputMaybe<StringComparisonExp>;
  currency_rate?: InputMaybe<NumericComparisonExp>;
  external_id?: InputMaybe<StringComparisonExp>;
  form_method?: InputMaybe<StringComparisonExp>;
  gate?: InputMaybe<GateBoolExp>;
  gate_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  input_currency_id?: InputMaybe<StringComparisonExp>;
  invoice_3ds_url?: InputMaybe<StringComparisonExp>;
  invoice_transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
  invoice_url?: InputMaybe<StringComparisonExp>;
  is_chargeback?: InputMaybe<BooleanComparisonExp>;
  is_manual?: InputMaybe<BooleanComparisonExp>;
  is_recurrent?: InputMaybe<BooleanComparisonExp>;
  is_refund?: InputMaybe<BooleanComparisonExp>;
  is_unhold?: InputMaybe<BooleanComparisonExp>;
  issue_payment_token?: InputMaybe<BooleanComparisonExp>;
  merchant?: InputMaybe<MerchantBoolExp>;
  merchant_constant_invoice_fee?: InputMaybe<NumericComparisonExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
  merchant_invoice_decline_transaction_fee_is_payed?: InputMaybe<BooleanComparisonExp>;
  merchant_invoice_fee?: InputMaybe<NumericComparisonExp>;
  merchant_invoice_fee_min_amount?: InputMaybe<NumericComparisonExp>;
  merchant_invoice_fee_percent?: InputMaybe<NumericComparisonExp>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
  merchant_invoice_transaction_fee_is_payed?: InputMaybe<BooleanComparisonExp>;
  payment_source_id?: InputMaybe<StringComparisonExp>;
  payment_system?: InputMaybe<StringComparisonExp>;
  personal_data?: InputMaybe<JsonbComparisonExp>;
  profit?: InputMaybe<NumericComparisonExp>;
  provider?: InputMaybe<ProviderBoolExp>;
  provider_amount?: InputMaybe<NumericComparisonExp>;
  provider_id?: InputMaybe<StringComparisonExp>;
  provider_invoice_fee?: InputMaybe<NumericComparisonExp>;
  provider_invoice_fee_percent?: InputMaybe<NumericComparisonExp>;
  provider_invoice_id?: InputMaybe<StringComparisonExp>;
  provider_payment_system?: InputMaybe<StringComparisonExp>;
  provider_status?: InputMaybe<StringComparisonExp>;
  provider_transaction_uid?: InputMaybe<StringComparisonExp>;
  recalculated?: InputMaybe<BooleanComparisonExp>;
  recalculated_at?: InputMaybe<TimestamptzComparisonExp>;
  reconciliated_at?: InputMaybe<TimestamptzComparisonExp>;
  recurrent_token?: InputMaybe<StringComparisonExp>;
  redirect_failed_url?: InputMaybe<StringComparisonExp>;
  redirect_success_url?: InputMaybe<StringComparisonExp>;
  refund?: InputMaybe<BooleanComparisonExp>;
  refund_amount?: InputMaybe<NumericComparisonExp>;
  remark?: InputMaybe<StringComparisonExp>;
  rolling_reserve_amount?: InputMaybe<NumericComparisonExp>;
  rolling_reserve_expired_at?: InputMaybe<TimestamptzComparisonExp>;
  rolling_reserve_unhold_at?: InputMaybe<TimestamptzComparisonExp>;
  sanitized_mask?: InputMaybe<StringComparisonExp>;
  smart_remark?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  status_updated_at?: InputMaybe<TimestamptzComparisonExp>;
  transaction_histories?: InputMaybe<TransactionHistoryBoolExp>;
  transaction_uid?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "invoice" */
export enum InvoiceConstraint {
  /** unique or primary key constraint on columns "external_id", "merchant_id", "gate_id" */
  InvoiceMerchantIdExternalIdGateIdKey = 'invoice_merchant_id_external_id_gate_id_key',
  /** unique or primary key constraint on columns "id" */
  InvoicePkey = 'invoice_pkey',
  /** unique or primary key constraint on columns "provider_transaction_uid" */
  InvoiceUidKey = 'invoice_uid_key',
  /** unique or primary key constraint on columns "transaction_uid" */
  TransactionUidKey = 'transaction_uid_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type InvoiceDeleteAtPathInput = {
  additional_data?: InputMaybe<Array<Scalars['String']>>;
  personal_data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type InvoiceDeleteElemInput = {
  additional_data?: InputMaybe<Scalars['Int']>;
  personal_data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type InvoiceDeleteKeyInput = {
  additional_data?: InputMaybe<Scalars['String']>;
  personal_data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "invoice" */
export type InvoiceIncInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  constant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  currency_rate?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  invoice_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_constant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  profit?: InputMaybe<Scalars['numeric']>;
  provider_amount?: InputMaybe<Scalars['numeric']>;
  provider_invoice_fee?: InputMaybe<Scalars['numeric']>;
  provider_invoice_fee_percent?: InputMaybe<Scalars['numeric']>;
  refund_amount?: InputMaybe<Scalars['numeric']>;
  rolling_reserve_amount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "invoice" */
export type InvoiceInsertInput = {
  additional_data?: InputMaybe<Scalars['jsonb']>;
  amount?: InputMaybe<Scalars['numeric']>;
  bank_id?: InputMaybe<Scalars['String']>;
  callback_url?: InputMaybe<Scalars['String']>;
  card_system_id?: InputMaybe<Scalars['String']>;
  cascade_request_id?: InputMaybe<Scalars['String']>;
  client_ip?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  constant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<CurrencyObjRelInsertInput>;
  currency_id?: InputMaybe<Scalars['String']>;
  currency_rate?: InputMaybe<Scalars['numeric']>;
  external_id?: InputMaybe<Scalars['String']>;
  form_method?: InputMaybe<Scalars['String']>;
  gate?: InputMaybe<GateObjRelInsertInput>;
  gate_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  input_currency_id?: InputMaybe<Scalars['String']>;
  invoice_3ds_url?: InputMaybe<Scalars['String']>;
  invoice_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  invoice_url?: InputMaybe<Scalars['String']>;
  is_chargeback?: InputMaybe<Scalars['Boolean']>;
  is_manual?: InputMaybe<Scalars['Boolean']>;
  is_recurrent?: InputMaybe<Scalars['Boolean']>;
  is_refund?: InputMaybe<Scalars['Boolean']>;
  is_unhold?: InputMaybe<Scalars['Boolean']>;
  issue_payment_token?: InputMaybe<Scalars['Boolean']>;
  merchant?: InputMaybe<MerchantObjRelInsertInput>;
  merchant_constant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_decline_transaction_fee_is_payed?: InputMaybe<Scalars['Boolean']>;
  merchant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_is_payed?: InputMaybe<Scalars['Boolean']>;
  payment_source_id?: InputMaybe<Scalars['String']>;
  payment_system?: InputMaybe<Scalars['String']>;
  personal_data?: InputMaybe<Scalars['jsonb']>;
  profit?: InputMaybe<Scalars['numeric']>;
  provider?: InputMaybe<ProviderObjRelInsertInput>;
  provider_amount?: InputMaybe<Scalars['numeric']>;
  provider_id?: InputMaybe<Scalars['String']>;
  provider_invoice_fee?: InputMaybe<Scalars['numeric']>;
  provider_invoice_fee_percent?: InputMaybe<Scalars['numeric']>;
  provider_invoice_id?: InputMaybe<Scalars['String']>;
  provider_payment_system?: InputMaybe<Scalars['String']>;
  provider_status?: InputMaybe<Scalars['String']>;
  provider_transaction_uid?: InputMaybe<Scalars['String']>;
  recalculated?: InputMaybe<Scalars['Boolean']>;
  recalculated_at?: InputMaybe<Scalars['timestamptz']>;
  reconciliated_at?: InputMaybe<Scalars['timestamptz']>;
  recurrent_token?: InputMaybe<Scalars['String']>;
  redirect_failed_url?: InputMaybe<Scalars['String']>;
  redirect_success_url?: InputMaybe<Scalars['String']>;
  refund?: InputMaybe<Scalars['Boolean']>;
  refund_amount?: InputMaybe<Scalars['numeric']>;
  remark?: InputMaybe<Scalars['String']>;
  rolling_reserve_amount?: InputMaybe<Scalars['numeric']>;
  rolling_reserve_expired_at?: InputMaybe<Scalars['timestamptz']>;
  rolling_reserve_unhold_at?: InputMaybe<Scalars['timestamptz']>;
  sanitized_mask?: InputMaybe<Scalars['String']>;
  smart_remark?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_updated_at?: InputMaybe<Scalars['timestamptz']>;
  transaction_histories?: InputMaybe<TransactionHistoryArrRelInsertInput>;
  transaction_uid?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type InvoiceMaxFields = {
  amount?: Maybe<Scalars['numeric']>;
  bank_id?: Maybe<Scalars['String']>;
  callback_url?: Maybe<Scalars['String']>;
  card_system_id?: Maybe<Scalars['String']>;
  cascade_request_id?: Maybe<Scalars['String']>;
  client_ip?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  constant_invoice_fee?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  currency_rate?: Maybe<Scalars['numeric']>;
  external_id?: Maybe<Scalars['String']>;
  form_method?: Maybe<Scalars['String']>;
  gate_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  input_currency_id?: Maybe<Scalars['String']>;
  invoice_3ds_url?: Maybe<Scalars['String']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  invoice_url?: Maybe<Scalars['String']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  payment_source_id?: Maybe<Scalars['String']>;
  payment_system?: Maybe<Scalars['String']>;
  profit?: Maybe<Scalars['numeric']>;
  provider_amount?: Maybe<Scalars['numeric']>;
  provider_id?: Maybe<Scalars['String']>;
  provider_invoice_fee?: Maybe<Scalars['numeric']>;
  provider_invoice_fee_percent?: Maybe<Scalars['numeric']>;
  provider_invoice_id?: Maybe<Scalars['String']>;
  provider_payment_system?: Maybe<Scalars['String']>;
  provider_status?: Maybe<Scalars['String']>;
  provider_transaction_uid?: Maybe<Scalars['String']>;
  recalculated_at?: Maybe<Scalars['timestamptz']>;
  reconciliated_at?: Maybe<Scalars['timestamptz']>;
  recurrent_token?: Maybe<Scalars['String']>;
  redirect_failed_url?: Maybe<Scalars['String']>;
  redirect_success_url?: Maybe<Scalars['String']>;
  refund_amount?: Maybe<Scalars['numeric']>;
  remark?: Maybe<Scalars['String']>;
  rolling_reserve_amount?: Maybe<Scalars['numeric']>;
  rolling_reserve_expired_at?: Maybe<Scalars['timestamptz']>;
  rolling_reserve_unhold_at?: Maybe<Scalars['timestamptz']>;
  sanitized_mask?: Maybe<Scalars['String']>;
  smart_remark?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  status_updated_at?: Maybe<Scalars['timestamptz']>;
  transaction_uid?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "invoice" */
export type InvoiceMaxOrderBy = {
  amount?: InputMaybe<OrderBy>;
  bank_id?: InputMaybe<OrderBy>;
  callback_url?: InputMaybe<OrderBy>;
  card_system_id?: InputMaybe<OrderBy>;
  cascade_request_id?: InputMaybe<OrderBy>;
  client_ip?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  constant_invoice_fee?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  external_id?: InputMaybe<OrderBy>;
  form_method?: InputMaybe<OrderBy>;
  gate_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_id?: InputMaybe<OrderBy>;
  invoice_3ds_url?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  invoice_url?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  payment_source_id?: InputMaybe<OrderBy>;
  payment_system?: InputMaybe<OrderBy>;
  profit?: InputMaybe<OrderBy>;
  provider_amount?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  provider_invoice_fee?: InputMaybe<OrderBy>;
  provider_invoice_fee_percent?: InputMaybe<OrderBy>;
  provider_invoice_id?: InputMaybe<OrderBy>;
  provider_payment_system?: InputMaybe<OrderBy>;
  provider_status?: InputMaybe<OrderBy>;
  provider_transaction_uid?: InputMaybe<OrderBy>;
  recalculated_at?: InputMaybe<OrderBy>;
  reconciliated_at?: InputMaybe<OrderBy>;
  recurrent_token?: InputMaybe<OrderBy>;
  redirect_failed_url?: InputMaybe<OrderBy>;
  redirect_success_url?: InputMaybe<OrderBy>;
  refund_amount?: InputMaybe<OrderBy>;
  remark?: InputMaybe<OrderBy>;
  rolling_reserve_amount?: InputMaybe<OrderBy>;
  rolling_reserve_expired_at?: InputMaybe<OrderBy>;
  rolling_reserve_unhold_at?: InputMaybe<OrderBy>;
  sanitized_mask?: InputMaybe<OrderBy>;
  smart_remark?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  status_updated_at?: InputMaybe<OrderBy>;
  transaction_uid?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type InvoiceMinFields = {
  amount?: Maybe<Scalars['numeric']>;
  bank_id?: Maybe<Scalars['String']>;
  callback_url?: Maybe<Scalars['String']>;
  card_system_id?: Maybe<Scalars['String']>;
  cascade_request_id?: Maybe<Scalars['String']>;
  client_ip?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  constant_invoice_fee?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  currency_rate?: Maybe<Scalars['numeric']>;
  external_id?: Maybe<Scalars['String']>;
  form_method?: Maybe<Scalars['String']>;
  gate_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  input_currency_id?: Maybe<Scalars['String']>;
  invoice_3ds_url?: Maybe<Scalars['String']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  invoice_url?: Maybe<Scalars['String']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  payment_source_id?: Maybe<Scalars['String']>;
  payment_system?: Maybe<Scalars['String']>;
  profit?: Maybe<Scalars['numeric']>;
  provider_amount?: Maybe<Scalars['numeric']>;
  provider_id?: Maybe<Scalars['String']>;
  provider_invoice_fee?: Maybe<Scalars['numeric']>;
  provider_invoice_fee_percent?: Maybe<Scalars['numeric']>;
  provider_invoice_id?: Maybe<Scalars['String']>;
  provider_payment_system?: Maybe<Scalars['String']>;
  provider_status?: Maybe<Scalars['String']>;
  provider_transaction_uid?: Maybe<Scalars['String']>;
  recalculated_at?: Maybe<Scalars['timestamptz']>;
  reconciliated_at?: Maybe<Scalars['timestamptz']>;
  recurrent_token?: Maybe<Scalars['String']>;
  redirect_failed_url?: Maybe<Scalars['String']>;
  redirect_success_url?: Maybe<Scalars['String']>;
  refund_amount?: Maybe<Scalars['numeric']>;
  remark?: Maybe<Scalars['String']>;
  rolling_reserve_amount?: Maybe<Scalars['numeric']>;
  rolling_reserve_expired_at?: Maybe<Scalars['timestamptz']>;
  rolling_reserve_unhold_at?: Maybe<Scalars['timestamptz']>;
  sanitized_mask?: Maybe<Scalars['String']>;
  smart_remark?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  status_updated_at?: Maybe<Scalars['timestamptz']>;
  transaction_uid?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "invoice" */
export type InvoiceMinOrderBy = {
  amount?: InputMaybe<OrderBy>;
  bank_id?: InputMaybe<OrderBy>;
  callback_url?: InputMaybe<OrderBy>;
  card_system_id?: InputMaybe<OrderBy>;
  cascade_request_id?: InputMaybe<OrderBy>;
  client_ip?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  constant_invoice_fee?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  external_id?: InputMaybe<OrderBy>;
  form_method?: InputMaybe<OrderBy>;
  gate_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_id?: InputMaybe<OrderBy>;
  invoice_3ds_url?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  invoice_url?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  payment_source_id?: InputMaybe<OrderBy>;
  payment_system?: InputMaybe<OrderBy>;
  profit?: InputMaybe<OrderBy>;
  provider_amount?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  provider_invoice_fee?: InputMaybe<OrderBy>;
  provider_invoice_fee_percent?: InputMaybe<OrderBy>;
  provider_invoice_id?: InputMaybe<OrderBy>;
  provider_payment_system?: InputMaybe<OrderBy>;
  provider_status?: InputMaybe<OrderBy>;
  provider_transaction_uid?: InputMaybe<OrderBy>;
  recalculated_at?: InputMaybe<OrderBy>;
  reconciliated_at?: InputMaybe<OrderBy>;
  recurrent_token?: InputMaybe<OrderBy>;
  redirect_failed_url?: InputMaybe<OrderBy>;
  redirect_success_url?: InputMaybe<OrderBy>;
  refund_amount?: InputMaybe<OrderBy>;
  remark?: InputMaybe<OrderBy>;
  rolling_reserve_amount?: InputMaybe<OrderBy>;
  rolling_reserve_expired_at?: InputMaybe<OrderBy>;
  rolling_reserve_unhold_at?: InputMaybe<OrderBy>;
  sanitized_mask?: InputMaybe<OrderBy>;
  smart_remark?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  status_updated_at?: InputMaybe<OrderBy>;
  transaction_uid?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "invoice" */
export type InvoiceMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Invoice>;
};

/** input type for inserting object relation for remote table "invoice" */
export type InvoiceObjRelInsertInput = {
  data: InvoiceInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<InvoiceOnConflict>;
};

/** on_conflict condition type for table "invoice" */
export type InvoiceOnConflict = {
  constraint: InvoiceConstraint;
  update_columns?: Array<InvoiceUpdateColumn>;
  where?: InputMaybe<InvoiceBoolExp>;
};

/** Ordering options when selecting data from "invoice". */
export type InvoiceOrderBy = {
  additional_data?: InputMaybe<OrderBy>;
  amount?: InputMaybe<OrderBy>;
  bank_id?: InputMaybe<OrderBy>;
  callback_url?: InputMaybe<OrderBy>;
  card_system_id?: InputMaybe<OrderBy>;
  cascade_request_id?: InputMaybe<OrderBy>;
  client_ip?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  constant_invoice_fee?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency?: InputMaybe<CurrencyOrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  external_id?: InputMaybe<OrderBy>;
  form_method?: InputMaybe<OrderBy>;
  gate?: InputMaybe<GateOrderBy>;
  gate_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_id?: InputMaybe<OrderBy>;
  invoice_3ds_url?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  invoice_url?: InputMaybe<OrderBy>;
  is_chargeback?: InputMaybe<OrderBy>;
  is_manual?: InputMaybe<OrderBy>;
  is_recurrent?: InputMaybe<OrderBy>;
  is_refund?: InputMaybe<OrderBy>;
  is_unhold?: InputMaybe<OrderBy>;
  issue_payment_token?: InputMaybe<OrderBy>;
  merchant?: InputMaybe<MerchantOrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_is_payed?: InputMaybe<OrderBy>;
  merchant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_is_payed?: InputMaybe<OrderBy>;
  payment_source_id?: InputMaybe<OrderBy>;
  payment_system?: InputMaybe<OrderBy>;
  personal_data?: InputMaybe<OrderBy>;
  profit?: InputMaybe<OrderBy>;
  provider?: InputMaybe<ProviderOrderBy>;
  provider_amount?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  provider_invoice_fee?: InputMaybe<OrderBy>;
  provider_invoice_fee_percent?: InputMaybe<OrderBy>;
  provider_invoice_id?: InputMaybe<OrderBy>;
  provider_payment_system?: InputMaybe<OrderBy>;
  provider_status?: InputMaybe<OrderBy>;
  provider_transaction_uid?: InputMaybe<OrderBy>;
  recalculated?: InputMaybe<OrderBy>;
  recalculated_at?: InputMaybe<OrderBy>;
  reconciliated_at?: InputMaybe<OrderBy>;
  recurrent_token?: InputMaybe<OrderBy>;
  redirect_failed_url?: InputMaybe<OrderBy>;
  redirect_success_url?: InputMaybe<OrderBy>;
  refund?: InputMaybe<OrderBy>;
  refund_amount?: InputMaybe<OrderBy>;
  remark?: InputMaybe<OrderBy>;
  rolling_reserve_amount?: InputMaybe<OrderBy>;
  rolling_reserve_expired_at?: InputMaybe<OrderBy>;
  rolling_reserve_unhold_at?: InputMaybe<OrderBy>;
  sanitized_mask?: InputMaybe<OrderBy>;
  smart_remark?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  status_updated_at?: InputMaybe<OrderBy>;
  transaction_histories_aggregate?: InputMaybe<TransactionHistoryAggregateOrderBy>;
  transaction_uid?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: invoice */
export type InvoicePkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type InvoicePrependInput = {
  additional_data?: InputMaybe<Scalars['jsonb']>;
  personal_data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "invoice" */
export enum InvoiceSelectColumn {
  /** column name */
  AdditionalData = 'additional_data',
  /** column name */
  Amount = 'amount',
  /** column name */
  BankId = 'bank_id',
  /** column name */
  CallbackUrl = 'callback_url',
  /** column name */
  CardSystemId = 'card_system_id',
  /** column name */
  CascadeRequestId = 'cascade_request_id',
  /** column name */
  ClientIp = 'client_ip',
  /** column name */
  Comment = 'comment',
  /** column name */
  ConstantInvoiceFee = 'constant_invoice_fee',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  CurrencyRate = 'currency_rate',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  FormMethod = 'form_method',
  /** column name */
  GateId = 'gate_id',
  /** column name */
  Id = 'id',
  /** column name */
  InputCurrencyId = 'input_currency_id',
  /** column name */
  Invoice_3dsUrl = 'invoice_3ds_url',
  /** column name */
  InvoiceTransactionFeeAmount = 'invoice_transaction_fee_amount',
  /** column name */
  InvoiceUrl = 'invoice_url',
  /** column name */
  IsChargeback = 'is_chargeback',
  /** column name */
  IsManual = 'is_manual',
  /** column name */
  IsRecurrent = 'is_recurrent',
  /** column name */
  IsRefund = 'is_refund',
  /** column name */
  IsUnhold = 'is_unhold',
  /** column name */
  IssuePaymentToken = 'issue_payment_token',
  /** column name */
  MerchantConstantInvoiceFee = 'merchant_constant_invoice_fee',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MerchantInvoiceDeclineTransactionFeeAmount = 'merchant_invoice_decline_transaction_fee_amount',
  /** column name */
  MerchantInvoiceDeclineTransactionFeeIsPayed = 'merchant_invoice_decline_transaction_fee_is_payed',
  /** column name */
  MerchantInvoiceFee = 'merchant_invoice_fee',
  /** column name */
  MerchantInvoiceFeeMinAmount = 'merchant_invoice_fee_min_amount',
  /** column name */
  MerchantInvoiceFeePercent = 'merchant_invoice_fee_percent',
  /** column name */
  MerchantInvoiceTransactionFeeAmount = 'merchant_invoice_transaction_fee_amount',
  /** column name */
  MerchantInvoiceTransactionFeeIsPayed = 'merchant_invoice_transaction_fee_is_payed',
  /** column name */
  PaymentSourceId = 'payment_source_id',
  /** column name */
  PaymentSystem = 'payment_system',
  /** column name */
  PersonalData = 'personal_data',
  /** column name */
  Profit = 'profit',
  /** column name */
  ProviderAmount = 'provider_amount',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  ProviderInvoiceFee = 'provider_invoice_fee',
  /** column name */
  ProviderInvoiceFeePercent = 'provider_invoice_fee_percent',
  /** column name */
  ProviderInvoiceId = 'provider_invoice_id',
  /** column name */
  ProviderPaymentSystem = 'provider_payment_system',
  /** column name */
  ProviderStatus = 'provider_status',
  /** column name */
  ProviderTransactionUid = 'provider_transaction_uid',
  /** column name */
  Recalculated = 'recalculated',
  /** column name */
  RecalculatedAt = 'recalculated_at',
  /** column name */
  ReconciliatedAt = 'reconciliated_at',
  /** column name */
  RecurrentToken = 'recurrent_token',
  /** column name */
  RedirectFailedUrl = 'redirect_failed_url',
  /** column name */
  RedirectSuccessUrl = 'redirect_success_url',
  /** column name */
  Refund = 'refund',
  /** column name */
  RefundAmount = 'refund_amount',
  /** column name */
  Remark = 'remark',
  /** column name */
  RollingReserveAmount = 'rolling_reserve_amount',
  /** column name */
  RollingReserveExpiredAt = 'rolling_reserve_expired_at',
  /** column name */
  RollingReserveUnholdAt = 'rolling_reserve_unhold_at',
  /** column name */
  SanitizedMask = 'sanitized_mask',
  /** column name */
  SmartRemark = 'smart_remark',
  /** column name */
  Status = 'status',
  /** column name */
  StatusUpdatedAt = 'status_updated_at',
  /** column name */
  TransactionUid = 'transaction_uid',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "invoice" */
export type InvoiceSetInput = {
  additional_data?: InputMaybe<Scalars['jsonb']>;
  amount?: InputMaybe<Scalars['numeric']>;
  bank_id?: InputMaybe<Scalars['String']>;
  callback_url?: InputMaybe<Scalars['String']>;
  card_system_id?: InputMaybe<Scalars['String']>;
  cascade_request_id?: InputMaybe<Scalars['String']>;
  client_ip?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  constant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency_id?: InputMaybe<Scalars['String']>;
  currency_rate?: InputMaybe<Scalars['numeric']>;
  external_id?: InputMaybe<Scalars['String']>;
  form_method?: InputMaybe<Scalars['String']>;
  gate_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  input_currency_id?: InputMaybe<Scalars['String']>;
  invoice_3ds_url?: InputMaybe<Scalars['String']>;
  invoice_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  invoice_url?: InputMaybe<Scalars['String']>;
  is_chargeback?: InputMaybe<Scalars['Boolean']>;
  is_manual?: InputMaybe<Scalars['Boolean']>;
  is_recurrent?: InputMaybe<Scalars['Boolean']>;
  is_refund?: InputMaybe<Scalars['Boolean']>;
  is_unhold?: InputMaybe<Scalars['Boolean']>;
  issue_payment_token?: InputMaybe<Scalars['Boolean']>;
  merchant_constant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_decline_transaction_fee_is_payed?: InputMaybe<Scalars['Boolean']>;
  merchant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_is_payed?: InputMaybe<Scalars['Boolean']>;
  payment_source_id?: InputMaybe<Scalars['String']>;
  payment_system?: InputMaybe<Scalars['String']>;
  personal_data?: InputMaybe<Scalars['jsonb']>;
  profit?: InputMaybe<Scalars['numeric']>;
  provider_amount?: InputMaybe<Scalars['numeric']>;
  provider_id?: InputMaybe<Scalars['String']>;
  provider_invoice_fee?: InputMaybe<Scalars['numeric']>;
  provider_invoice_fee_percent?: InputMaybe<Scalars['numeric']>;
  provider_invoice_id?: InputMaybe<Scalars['String']>;
  provider_payment_system?: InputMaybe<Scalars['String']>;
  provider_status?: InputMaybe<Scalars['String']>;
  provider_transaction_uid?: InputMaybe<Scalars['String']>;
  recalculated?: InputMaybe<Scalars['Boolean']>;
  recalculated_at?: InputMaybe<Scalars['timestamptz']>;
  reconciliated_at?: InputMaybe<Scalars['timestamptz']>;
  recurrent_token?: InputMaybe<Scalars['String']>;
  redirect_failed_url?: InputMaybe<Scalars['String']>;
  redirect_success_url?: InputMaybe<Scalars['String']>;
  refund?: InputMaybe<Scalars['Boolean']>;
  refund_amount?: InputMaybe<Scalars['numeric']>;
  remark?: InputMaybe<Scalars['String']>;
  rolling_reserve_amount?: InputMaybe<Scalars['numeric']>;
  rolling_reserve_expired_at?: InputMaybe<Scalars['timestamptz']>;
  rolling_reserve_unhold_at?: InputMaybe<Scalars['timestamptz']>;
  sanitized_mask?: InputMaybe<Scalars['String']>;
  smart_remark?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_updated_at?: InputMaybe<Scalars['timestamptz']>;
  transaction_uid?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type InvoiceStddevFields = {
  amount?: Maybe<Scalars['Float']>;
  constant_invoice_fee?: Maybe<Scalars['Float']>;
  currency_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  provider_amount?: Maybe<Scalars['Float']>;
  provider_invoice_fee?: Maybe<Scalars['Float']>;
  provider_invoice_fee_percent?: Maybe<Scalars['Float']>;
  refund_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "invoice" */
export type InvoiceStddevOrderBy = {
  amount?: InputMaybe<OrderBy>;
  constant_invoice_fee?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  profit?: InputMaybe<OrderBy>;
  provider_amount?: InputMaybe<OrderBy>;
  provider_invoice_fee?: InputMaybe<OrderBy>;
  provider_invoice_fee_percent?: InputMaybe<OrderBy>;
  refund_amount?: InputMaybe<OrderBy>;
  rolling_reserve_amount?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type InvoiceStddevPopFields = {
  amount?: Maybe<Scalars['Float']>;
  constant_invoice_fee?: Maybe<Scalars['Float']>;
  currency_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  provider_amount?: Maybe<Scalars['Float']>;
  provider_invoice_fee?: Maybe<Scalars['Float']>;
  provider_invoice_fee_percent?: Maybe<Scalars['Float']>;
  refund_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "invoice" */
export type InvoiceStddevPopOrderBy = {
  amount?: InputMaybe<OrderBy>;
  constant_invoice_fee?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  profit?: InputMaybe<OrderBy>;
  provider_amount?: InputMaybe<OrderBy>;
  provider_invoice_fee?: InputMaybe<OrderBy>;
  provider_invoice_fee_percent?: InputMaybe<OrderBy>;
  refund_amount?: InputMaybe<OrderBy>;
  rolling_reserve_amount?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type InvoiceStddevSampFields = {
  amount?: Maybe<Scalars['Float']>;
  constant_invoice_fee?: Maybe<Scalars['Float']>;
  currency_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  provider_amount?: Maybe<Scalars['Float']>;
  provider_invoice_fee?: Maybe<Scalars['Float']>;
  provider_invoice_fee_percent?: Maybe<Scalars['Float']>;
  refund_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "invoice" */
export type InvoiceStddevSampOrderBy = {
  amount?: InputMaybe<OrderBy>;
  constant_invoice_fee?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  profit?: InputMaybe<OrderBy>;
  provider_amount?: InputMaybe<OrderBy>;
  provider_invoice_fee?: InputMaybe<OrderBy>;
  provider_invoice_fee_percent?: InputMaybe<OrderBy>;
  refund_amount?: InputMaybe<OrderBy>;
  rolling_reserve_amount?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type InvoiceSumFields = {
  amount?: Maybe<Scalars['numeric']>;
  constant_invoice_fee?: Maybe<Scalars['numeric']>;
  currency_rate?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  profit?: Maybe<Scalars['numeric']>;
  provider_amount?: Maybe<Scalars['numeric']>;
  provider_invoice_fee?: Maybe<Scalars['numeric']>;
  provider_invoice_fee_percent?: Maybe<Scalars['numeric']>;
  refund_amount?: Maybe<Scalars['numeric']>;
  rolling_reserve_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "invoice" */
export type InvoiceSumOrderBy = {
  amount?: InputMaybe<OrderBy>;
  constant_invoice_fee?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  profit?: InputMaybe<OrderBy>;
  provider_amount?: InputMaybe<OrderBy>;
  provider_invoice_fee?: InputMaybe<OrderBy>;
  provider_invoice_fee_percent?: InputMaybe<OrderBy>;
  refund_amount?: InputMaybe<OrderBy>;
  rolling_reserve_amount?: InputMaybe<OrderBy>;
};

/** update columns of table "invoice" */
export enum InvoiceUpdateColumn {
  /** column name */
  AdditionalData = 'additional_data',
  /** column name */
  Amount = 'amount',
  /** column name */
  BankId = 'bank_id',
  /** column name */
  CallbackUrl = 'callback_url',
  /** column name */
  CardSystemId = 'card_system_id',
  /** column name */
  CascadeRequestId = 'cascade_request_id',
  /** column name */
  ClientIp = 'client_ip',
  /** column name */
  Comment = 'comment',
  /** column name */
  ConstantInvoiceFee = 'constant_invoice_fee',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  CurrencyRate = 'currency_rate',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  FormMethod = 'form_method',
  /** column name */
  GateId = 'gate_id',
  /** column name */
  Id = 'id',
  /** column name */
  InputCurrencyId = 'input_currency_id',
  /** column name */
  Invoice_3dsUrl = 'invoice_3ds_url',
  /** column name */
  InvoiceTransactionFeeAmount = 'invoice_transaction_fee_amount',
  /** column name */
  InvoiceUrl = 'invoice_url',
  /** column name */
  IsChargeback = 'is_chargeback',
  /** column name */
  IsManual = 'is_manual',
  /** column name */
  IsRecurrent = 'is_recurrent',
  /** column name */
  IsRefund = 'is_refund',
  /** column name */
  IsUnhold = 'is_unhold',
  /** column name */
  IssuePaymentToken = 'issue_payment_token',
  /** column name */
  MerchantConstantInvoiceFee = 'merchant_constant_invoice_fee',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MerchantInvoiceDeclineTransactionFeeAmount = 'merchant_invoice_decline_transaction_fee_amount',
  /** column name */
  MerchantInvoiceDeclineTransactionFeeIsPayed = 'merchant_invoice_decline_transaction_fee_is_payed',
  /** column name */
  MerchantInvoiceFee = 'merchant_invoice_fee',
  /** column name */
  MerchantInvoiceFeeMinAmount = 'merchant_invoice_fee_min_amount',
  /** column name */
  MerchantInvoiceFeePercent = 'merchant_invoice_fee_percent',
  /** column name */
  MerchantInvoiceTransactionFeeAmount = 'merchant_invoice_transaction_fee_amount',
  /** column name */
  MerchantInvoiceTransactionFeeIsPayed = 'merchant_invoice_transaction_fee_is_payed',
  /** column name */
  PaymentSourceId = 'payment_source_id',
  /** column name */
  PaymentSystem = 'payment_system',
  /** column name */
  PersonalData = 'personal_data',
  /** column name */
  Profit = 'profit',
  /** column name */
  ProviderAmount = 'provider_amount',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  ProviderInvoiceFee = 'provider_invoice_fee',
  /** column name */
  ProviderInvoiceFeePercent = 'provider_invoice_fee_percent',
  /** column name */
  ProviderInvoiceId = 'provider_invoice_id',
  /** column name */
  ProviderPaymentSystem = 'provider_payment_system',
  /** column name */
  ProviderStatus = 'provider_status',
  /** column name */
  ProviderTransactionUid = 'provider_transaction_uid',
  /** column name */
  Recalculated = 'recalculated',
  /** column name */
  RecalculatedAt = 'recalculated_at',
  /** column name */
  ReconciliatedAt = 'reconciliated_at',
  /** column name */
  RecurrentToken = 'recurrent_token',
  /** column name */
  RedirectFailedUrl = 'redirect_failed_url',
  /** column name */
  RedirectSuccessUrl = 'redirect_success_url',
  /** column name */
  Refund = 'refund',
  /** column name */
  RefundAmount = 'refund_amount',
  /** column name */
  Remark = 'remark',
  /** column name */
  RollingReserveAmount = 'rolling_reserve_amount',
  /** column name */
  RollingReserveExpiredAt = 'rolling_reserve_expired_at',
  /** column name */
  RollingReserveUnholdAt = 'rolling_reserve_unhold_at',
  /** column name */
  SanitizedMask = 'sanitized_mask',
  /** column name */
  SmartRemark = 'smart_remark',
  /** column name */
  Status = 'status',
  /** column name */
  StatusUpdatedAt = 'status_updated_at',
  /** column name */
  TransactionUid = 'transaction_uid',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InvoiceUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<InvoiceAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<InvoiceDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<InvoiceDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<InvoiceDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<InvoiceIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<InvoicePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InvoiceSetInput>;
  where: InvoiceBoolExp;
};

/** aggregate var_pop on columns */
export type InvoiceVarPopFields = {
  amount?: Maybe<Scalars['Float']>;
  constant_invoice_fee?: Maybe<Scalars['Float']>;
  currency_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  provider_amount?: Maybe<Scalars['Float']>;
  provider_invoice_fee?: Maybe<Scalars['Float']>;
  provider_invoice_fee_percent?: Maybe<Scalars['Float']>;
  refund_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "invoice" */
export type InvoiceVarPopOrderBy = {
  amount?: InputMaybe<OrderBy>;
  constant_invoice_fee?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  profit?: InputMaybe<OrderBy>;
  provider_amount?: InputMaybe<OrderBy>;
  provider_invoice_fee?: InputMaybe<OrderBy>;
  provider_invoice_fee_percent?: InputMaybe<OrderBy>;
  refund_amount?: InputMaybe<OrderBy>;
  rolling_reserve_amount?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type InvoiceVarSampFields = {
  amount?: Maybe<Scalars['Float']>;
  constant_invoice_fee?: Maybe<Scalars['Float']>;
  currency_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  provider_amount?: Maybe<Scalars['Float']>;
  provider_invoice_fee?: Maybe<Scalars['Float']>;
  provider_invoice_fee_percent?: Maybe<Scalars['Float']>;
  refund_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "invoice" */
export type InvoiceVarSampOrderBy = {
  amount?: InputMaybe<OrderBy>;
  constant_invoice_fee?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  profit?: InputMaybe<OrderBy>;
  provider_amount?: InputMaybe<OrderBy>;
  provider_invoice_fee?: InputMaybe<OrderBy>;
  provider_invoice_fee_percent?: InputMaybe<OrderBy>;
  refund_amount?: InputMaybe<OrderBy>;
  rolling_reserve_amount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type InvoiceVarianceFields = {
  amount?: Maybe<Scalars['Float']>;
  constant_invoice_fee?: Maybe<Scalars['Float']>;
  currency_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  provider_amount?: Maybe<Scalars['Float']>;
  provider_invoice_fee?: Maybe<Scalars['Float']>;
  provider_invoice_fee_percent?: Maybe<Scalars['Float']>;
  refund_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "invoice" */
export type InvoiceVarianceOrderBy = {
  amount?: InputMaybe<OrderBy>;
  constant_invoice_fee?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  profit?: InputMaybe<OrderBy>;
  provider_amount?: InputMaybe<OrderBy>;
  provider_invoice_fee?: InputMaybe<OrderBy>;
  provider_invoice_fee_percent?: InputMaybe<OrderBy>;
  refund_amount?: InputMaybe<OrderBy>;
  rolling_reserve_amount?: InputMaybe<OrderBy>;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type JsonComparisonExp = {
  _eq?: InputMaybe<Scalars['json']>;
  _gt?: InputMaybe<Scalars['json']>;
  _gte?: InputMaybe<Scalars['json']>;
  _in?: InputMaybe<Array<Scalars['json']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['json']>;
  _lte?: InputMaybe<Scalars['json']>;
  _neq?: InputMaybe<Scalars['json']>;
  _nin?: InputMaybe<Array<Scalars['json']>>;
};

export type JsonbCastExp = {
  String?: InputMaybe<StringComparisonExp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type JsonbComparisonExp = {
  _cast?: InputMaybe<JsonbCastExp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "language" */
export type Language = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "language" */
export type LanguageAggregate = {
  aggregate?: Maybe<LanguageAggregateFields>;
  nodes: Array<Language>;
};

/** aggregate fields of "language" */
export type LanguageAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<LanguageMaxFields>;
  min?: Maybe<LanguageMinFields>;
};


/** aggregate fields of "language" */
export type LanguageAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LanguageSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "language". All fields are combined with a logical 'AND'. */
export type LanguageBoolExp = {
  _and?: InputMaybe<Array<LanguageBoolExp>>;
  _not?: InputMaybe<LanguageBoolExp>;
  _or?: InputMaybe<Array<LanguageBoolExp>>;
  id?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "language" */
export enum LanguageConstraint {
  /** unique or primary key constraint on columns "id" */
  LanguagePkey = 'language_pkey'
}

/** input type for inserting data into table "language" */
export type LanguageInsertInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type LanguageMaxFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type LanguageMinFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "language" */
export type LanguageMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Language>;
};

/** on_conflict condition type for table "language" */
export type LanguageOnConflict = {
  constraint: LanguageConstraint;
  update_columns?: Array<LanguageUpdateColumn>;
  where?: InputMaybe<LanguageBoolExp>;
};

/** Ordering options when selecting data from "language". */
export type LanguageOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: language */
export type LanguagePkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "language" */
export enum LanguageSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "language" */
export type LanguageSetInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "language" */
export enum LanguageUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type LanguageUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LanguageSetInput>;
  where: LanguageBoolExp;
};

/** columns and relationships of "merchant" */
export type Merchant = {
  api_token?: Maybe<Scalars['String']>;
  balance: Scalars['numeric'];
  created_at: Scalars['timestamptz'];
  current_provider_id?: Maybe<Scalars['String']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  gate_groups: Array<GateGroup>;
  /** An aggregate relationship */
  gate_groups_aggregate: GateGroupAggregate;
  hold_balance: Scalars['numeric'];
  id: Scalars['Int'];
  invoice_callback_url?: Maybe<Scalars['String']>;
  invoice_enabled: Scalars['Boolean'];
  invoice_fee_percent: Scalars['numeric'];
  invoice_h2h_enabled: Scalars['Boolean'];
  invoice_qiwi_enabled: Scalars['Boolean'];
  invoice_s2p_enabled: Scalars['Boolean'];
  /** An array relationship */
  invoices: Array<Invoice>;
  /** An aggregate relationship */
  invoices_aggregate: InvoiceAggregate;
  mass_withdraw_enabled: Scalars['Boolean'];
  /** An array relationship */
  merchant_balances: Array<MerchantBalance>;
  /** An aggregate relationship */
  merchant_balances_aggregate: MerchantBalanceAggregate;
  /** An array relationship */
  merchant_currencies: Array<MerchantCurrency>;
  /** An aggregate relationship */
  merchant_currencies_aggregate: MerchantCurrencyAggregate;
  /** An array relationship */
  merchant_fees: Array<MerchantFee>;
  /** An aggregate relationship */
  merchant_fees_aggregate: MerchantFeeAggregate;
  /** An object relationship */
  merchant_info?: Maybe<MerchantInfo>;
  merchant_status_id: Scalars['String'];
  merchant_type_id: Scalars['String'];
  /** An array relationship */
  merchant_users: Array<MerchantUser>;
  /** An aggregate relationship */
  merchant_users_aggregate: MerchantUserAggregate;
  /** An array relationship */
  merchant_widgets: Array<MerchantWidget>;
  /** An aggregate relationship */
  merchant_widgets_aggregate: MerchantWidgetAggregate;
  /** An array relationship */
  permissions: Array<VHasuraPermission>;
  /** An aggregate relationship */
  permissions_aggregate: VHasuraPermissionAggregate;
  /** An object relationship */
  provider?: Maybe<Provider>;
  qiwi_mass_withdraw_enabled: Scalars['Boolean'];
  redirect_failed_url?: Maybe<Scalars['String']>;
  redirect_success_url?: Maybe<Scalars['String']>;
  refund_enabled: Scalars['Boolean'];
  rolling_reserve_duration: Scalars['Int'];
  rolling_reserve_percent: Scalars['numeric'];
  s2p_withdraw_enabled: Scalars['Boolean'];
  secret_key?: Maybe<Scalars['String']>;
  telegram_notification_chat_id?: Maybe<Scalars['String']>;
  telegram_notification_enabled: Scalars['Boolean'];
  /** An array relationship */
  transaction_histories: Array<TransactionHistory>;
  /** An aggregate relationship */
  transaction_histories_aggregate: TransactionHistoryAggregate;
  updated_at: Scalars['timestamptz'];
  withdraw_callback_url?: Maybe<Scalars['String']>;
  withdraw_enabled?: Maybe<Scalars['Boolean']>;
  withdraw_fee_percent: Scalars['numeric'];
  /** An array relationship */
  withdraw_requests: Array<WithdrawRequest>;
  /** An aggregate relationship */
  withdraw_requests_aggregate: WithdrawRequestAggregate;
  /** An array relationship */
  withdraws: Array<Withdraw>;
  /** An aggregate relationship */
  withdraws_aggregate: WithdrawAggregate;
};


/** columns and relationships of "merchant" */
export type MerchantGateGroupsArgs = {
  distinct_on?: InputMaybe<Array<GateGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GateGroupOrderBy>>;
  where?: InputMaybe<GateGroupBoolExp>;
};


/** columns and relationships of "merchant" */
export type MerchantGateGroupsAggregateArgs = {
  distinct_on?: InputMaybe<Array<GateGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GateGroupOrderBy>>;
  where?: InputMaybe<GateGroupBoolExp>;
};


/** columns and relationships of "merchant" */
export type MerchantInvoicesArgs = {
  distinct_on?: InputMaybe<Array<InvoiceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InvoiceOrderBy>>;
  where?: InputMaybe<InvoiceBoolExp>;
};


/** columns and relationships of "merchant" */
export type MerchantInvoicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<InvoiceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InvoiceOrderBy>>;
  where?: InputMaybe<InvoiceBoolExp>;
};


/** columns and relationships of "merchant" */
export type MerchantMerchantBalancesArgs = {
  distinct_on?: InputMaybe<Array<MerchantBalanceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantBalanceOrderBy>>;
  where?: InputMaybe<MerchantBalanceBoolExp>;
};


/** columns and relationships of "merchant" */
export type MerchantMerchantBalancesAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantBalanceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantBalanceOrderBy>>;
  where?: InputMaybe<MerchantBalanceBoolExp>;
};


/** columns and relationships of "merchant" */
export type MerchantMerchantCurrenciesArgs = {
  distinct_on?: InputMaybe<Array<MerchantCurrencySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantCurrencyOrderBy>>;
  where?: InputMaybe<MerchantCurrencyBoolExp>;
};


/** columns and relationships of "merchant" */
export type MerchantMerchantCurrenciesAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantCurrencySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantCurrencyOrderBy>>;
  where?: InputMaybe<MerchantCurrencyBoolExp>;
};


/** columns and relationships of "merchant" */
export type MerchantMerchantFeesArgs = {
  distinct_on?: InputMaybe<Array<MerchantFeeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantFeeOrderBy>>;
  where?: InputMaybe<MerchantFeeBoolExp>;
};


/** columns and relationships of "merchant" */
export type MerchantMerchantFeesAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantFeeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantFeeOrderBy>>;
  where?: InputMaybe<MerchantFeeBoolExp>;
};


/** columns and relationships of "merchant" */
export type MerchantMerchantUsersArgs = {
  distinct_on?: InputMaybe<Array<MerchantUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantUserOrderBy>>;
  where?: InputMaybe<MerchantUserBoolExp>;
};


/** columns and relationships of "merchant" */
export type MerchantMerchantUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantUserOrderBy>>;
  where?: InputMaybe<MerchantUserBoolExp>;
};


/** columns and relationships of "merchant" */
export type MerchantMerchantWidgetsArgs = {
  distinct_on?: InputMaybe<Array<MerchantWidgetSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantWidgetOrderBy>>;
  where?: InputMaybe<MerchantWidgetBoolExp>;
};


/** columns and relationships of "merchant" */
export type MerchantMerchantWidgetsAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantWidgetSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantWidgetOrderBy>>;
  where?: InputMaybe<MerchantWidgetBoolExp>;
};


/** columns and relationships of "merchant" */
export type MerchantPermissionsArgs = {
  distinct_on?: InputMaybe<Array<VHasuraPermissionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VHasuraPermissionOrderBy>>;
  where?: InputMaybe<VHasuraPermissionBoolExp>;
};


/** columns and relationships of "merchant" */
export type MerchantPermissionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<VHasuraPermissionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VHasuraPermissionOrderBy>>;
  where?: InputMaybe<VHasuraPermissionBoolExp>;
};


/** columns and relationships of "merchant" */
export type MerchantTransactionHistoriesArgs = {
  distinct_on?: InputMaybe<Array<TransactionHistorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TransactionHistoryOrderBy>>;
  where?: InputMaybe<TransactionHistoryBoolExp>;
};


/** columns and relationships of "merchant" */
export type MerchantTransactionHistoriesAggregateArgs = {
  distinct_on?: InputMaybe<Array<TransactionHistorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TransactionHistoryOrderBy>>;
  where?: InputMaybe<TransactionHistoryBoolExp>;
};


/** columns and relationships of "merchant" */
export type MerchantWithdrawRequestsArgs = {
  distinct_on?: InputMaybe<Array<WithdrawRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WithdrawRequestOrderBy>>;
  where?: InputMaybe<WithdrawRequestBoolExp>;
};


/** columns and relationships of "merchant" */
export type MerchantWithdrawRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<WithdrawRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WithdrawRequestOrderBy>>;
  where?: InputMaybe<WithdrawRequestBoolExp>;
};


/** columns and relationships of "merchant" */
export type MerchantWithdrawsArgs = {
  distinct_on?: InputMaybe<Array<WithdrawSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WithdrawOrderBy>>;
  where?: InputMaybe<WithdrawBoolExp>;
};


/** columns and relationships of "merchant" */
export type MerchantWithdrawsAggregateArgs = {
  distinct_on?: InputMaybe<Array<WithdrawSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WithdrawOrderBy>>;
  where?: InputMaybe<WithdrawBoolExp>;
};

/** aggregated selection of "merchant" */
export type MerchantAggregate = {
  aggregate?: Maybe<MerchantAggregateFields>;
  nodes: Array<Merchant>;
};

/** aggregate fields of "merchant" */
export type MerchantAggregateFields = {
  avg?: Maybe<MerchantAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MerchantMaxFields>;
  min?: Maybe<MerchantMinFields>;
  stddev?: Maybe<MerchantStddevFields>;
  stddev_pop?: Maybe<MerchantStddevPopFields>;
  stddev_samp?: Maybe<MerchantStddevSampFields>;
  sum?: Maybe<MerchantSumFields>;
  var_pop?: Maybe<MerchantVarPopFields>;
  var_samp?: Maybe<MerchantVarSampFields>;
  variance?: Maybe<MerchantVarianceFields>;
};


/** aggregate fields of "merchant" */
export type MerchantAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MerchantSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "merchant" */
export type MerchantAggregateOrderBy = {
  avg?: InputMaybe<MerchantAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MerchantMaxOrderBy>;
  min?: InputMaybe<MerchantMinOrderBy>;
  stddev?: InputMaybe<MerchantStddevOrderBy>;
  stddev_pop?: InputMaybe<MerchantStddevPopOrderBy>;
  stddev_samp?: InputMaybe<MerchantStddevSampOrderBy>;
  sum?: InputMaybe<MerchantSumOrderBy>;
  var_pop?: InputMaybe<MerchantVarPopOrderBy>;
  var_samp?: InputMaybe<MerchantVarSampOrderBy>;
  variance?: InputMaybe<MerchantVarianceOrderBy>;
};

/** columns and relationships of "merchant_api_token" */
export type MerchantApiToken = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  merchant: Merchant;
  merchant_id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  token: Scalars['String'];
};

/** aggregated selection of "merchant_api_token" */
export type MerchantApiTokenAggregate = {
  aggregate?: Maybe<MerchantApiTokenAggregateFields>;
  nodes: Array<MerchantApiToken>;
};

/** aggregate fields of "merchant_api_token" */
export type MerchantApiTokenAggregateFields = {
  avg?: Maybe<MerchantApiTokenAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MerchantApiTokenMaxFields>;
  min?: Maybe<MerchantApiTokenMinFields>;
  stddev?: Maybe<MerchantApiTokenStddevFields>;
  stddev_pop?: Maybe<MerchantApiTokenStddevPopFields>;
  stddev_samp?: Maybe<MerchantApiTokenStddevSampFields>;
  sum?: Maybe<MerchantApiTokenSumFields>;
  var_pop?: Maybe<MerchantApiTokenVarPopFields>;
  var_samp?: Maybe<MerchantApiTokenVarSampFields>;
  variance?: Maybe<MerchantApiTokenVarianceFields>;
};


/** aggregate fields of "merchant_api_token" */
export type MerchantApiTokenAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MerchantApiTokenSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type MerchantApiTokenAvgFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "merchant_api_token". All fields are combined with a logical 'AND'. */
export type MerchantApiTokenBoolExp = {
  _and?: InputMaybe<Array<MerchantApiTokenBoolExp>>;
  _not?: InputMaybe<MerchantApiTokenBoolExp>;
  _or?: InputMaybe<Array<MerchantApiTokenBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  merchant?: InputMaybe<MerchantBoolExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  token?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "merchant_api_token" */
export enum MerchantApiTokenConstraint {
  /** unique or primary key constraint on columns "id" */
  MerchantApiTokenPkey = 'merchant_api_token_pkey',
  /** unique or primary key constraint on columns "token" */
  MerchantApiTokenTokenKey = 'merchant_api_token_token_key'
}

/** input type for incrementing numeric columns in table "merchant_api_token" */
export type MerchantApiTokenIncInput = {
  merchant_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "merchant_api_token" */
export type MerchantApiTokenInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  merchant?: InputMaybe<MerchantObjRelInsertInput>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type MerchantApiTokenMaxFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  merchant_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type MerchantApiTokenMinFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  merchant_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "merchant_api_token" */
export type MerchantApiTokenMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MerchantApiToken>;
};

/** on_conflict condition type for table "merchant_api_token" */
export type MerchantApiTokenOnConflict = {
  constraint: MerchantApiTokenConstraint;
  update_columns?: Array<MerchantApiTokenUpdateColumn>;
  where?: InputMaybe<MerchantApiTokenBoolExp>;
};

/** Ordering options when selecting data from "merchant_api_token". */
export type MerchantApiTokenOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant?: InputMaybe<MerchantOrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  token?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: merchant_api_token */
export type MerchantApiTokenPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "merchant_api_token" */
export enum MerchantApiTokenSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  Name = 'name',
  /** column name */
  Token = 'token'
}

/** input type for updating data in table "merchant_api_token" */
export type MerchantApiTokenSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type MerchantApiTokenStddevFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type MerchantApiTokenStddevPopFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type MerchantApiTokenStddevSampFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type MerchantApiTokenSumFields = {
  merchant_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "merchant_api_token" */
export enum MerchantApiTokenUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  Name = 'name',
  /** column name */
  Token = 'token'
}

export type MerchantApiTokenUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MerchantApiTokenIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MerchantApiTokenSetInput>;
  where: MerchantApiTokenBoolExp;
};

/** aggregate var_pop on columns */
export type MerchantApiTokenVarPopFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type MerchantApiTokenVarSampFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type MerchantApiTokenVarianceFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** input type for inserting array relation for remote table "merchant" */
export type MerchantArrRelInsertInput = {
  data: Array<MerchantInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<MerchantOnConflict>;
};

/** aggregate avg on columns */
export type MerchantAvgFields = {
  balance?: Maybe<Scalars['Float']>;
  edit_user_id?: Maybe<Scalars['Float']>;
  hold_balance?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_fee_percent?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  withdraw_fee_percent?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "merchant" */
export type MerchantAvgOrderBy = {
  balance?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_fee_percent?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  withdraw_fee_percent?: InputMaybe<OrderBy>;
};

/** columns and relationships of "merchant_balance" */
export type MerchantBalance = {
  balance: Scalars['numeric'];
  calculated_balance: Scalars['numeric'];
  calculated_hold_balance: Scalars['numeric'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  currency: Currency;
  currency_id: Scalars['String'];
  frozen_withdraw_balance: Scalars['numeric'];
  hold_balance: Scalars['numeric'];
  id: Scalars['Int'];
  is_total: Scalars['Boolean'];
  /** An object relationship */
  merchant: Merchant;
  merchant_id: Scalars['Int'];
  /** An object relationship */
  provider?: Maybe<Provider>;
  provider_id?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "merchant_balance" */
export type MerchantBalanceAggregate = {
  aggregate?: Maybe<MerchantBalanceAggregateFields>;
  nodes: Array<MerchantBalance>;
};

/** aggregate fields of "merchant_balance" */
export type MerchantBalanceAggregateFields = {
  avg?: Maybe<MerchantBalanceAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MerchantBalanceMaxFields>;
  min?: Maybe<MerchantBalanceMinFields>;
  stddev?: Maybe<MerchantBalanceStddevFields>;
  stddev_pop?: Maybe<MerchantBalanceStddevPopFields>;
  stddev_samp?: Maybe<MerchantBalanceStddevSampFields>;
  sum?: Maybe<MerchantBalanceSumFields>;
  var_pop?: Maybe<MerchantBalanceVarPopFields>;
  var_samp?: Maybe<MerchantBalanceVarSampFields>;
  variance?: Maybe<MerchantBalanceVarianceFields>;
};


/** aggregate fields of "merchant_balance" */
export type MerchantBalanceAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MerchantBalanceSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "merchant_balance" */
export type MerchantBalanceAggregateOrderBy = {
  avg?: InputMaybe<MerchantBalanceAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MerchantBalanceMaxOrderBy>;
  min?: InputMaybe<MerchantBalanceMinOrderBy>;
  stddev?: InputMaybe<MerchantBalanceStddevOrderBy>;
  stddev_pop?: InputMaybe<MerchantBalanceStddevPopOrderBy>;
  stddev_samp?: InputMaybe<MerchantBalanceStddevSampOrderBy>;
  sum?: InputMaybe<MerchantBalanceSumOrderBy>;
  var_pop?: InputMaybe<MerchantBalanceVarPopOrderBy>;
  var_samp?: InputMaybe<MerchantBalanceVarSampOrderBy>;
  variance?: InputMaybe<MerchantBalanceVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "merchant_balance" */
export type MerchantBalanceArrRelInsertInput = {
  data: Array<MerchantBalanceInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<MerchantBalanceOnConflict>;
};

/** aggregate avg on columns */
export type MerchantBalanceAvgFields = {
  balance?: Maybe<Scalars['Float']>;
  calculated_balance?: Maybe<Scalars['Float']>;
  calculated_hold_balance?: Maybe<Scalars['Float']>;
  frozen_withdraw_balance?: Maybe<Scalars['Float']>;
  hold_balance?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "merchant_balance" */
export type MerchantBalanceAvgOrderBy = {
  balance?: InputMaybe<OrderBy>;
  calculated_balance?: InputMaybe<OrderBy>;
  calculated_hold_balance?: InputMaybe<OrderBy>;
  frozen_withdraw_balance?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "merchant_balance". All fields are combined with a logical 'AND'. */
export type MerchantBalanceBoolExp = {
  _and?: InputMaybe<Array<MerchantBalanceBoolExp>>;
  _not?: InputMaybe<MerchantBalanceBoolExp>;
  _or?: InputMaybe<Array<MerchantBalanceBoolExp>>;
  balance?: InputMaybe<NumericComparisonExp>;
  calculated_balance?: InputMaybe<NumericComparisonExp>;
  calculated_hold_balance?: InputMaybe<NumericComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<CurrencyBoolExp>;
  currency_id?: InputMaybe<StringComparisonExp>;
  frozen_withdraw_balance?: InputMaybe<NumericComparisonExp>;
  hold_balance?: InputMaybe<NumericComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  is_total?: InputMaybe<BooleanComparisonExp>;
  merchant?: InputMaybe<MerchantBoolExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  provider?: InputMaybe<ProviderBoolExp>;
  provider_id?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "merchant_balance" */
export enum MerchantBalanceConstraint {
  /** unique or primary key constraint on columns "provider_id", "is_total", "currency_id", "merchant_id" */
  MerchantBalanceMerchantIdCurrencyIdProviderIdIsTotalK = 'merchant_balance_merchant_id_currency_id_provider_id_is_total_k',
  /** unique or primary key constraint on columns "id" */
  MerchantBalancePkey = 'merchant_balance_pkey'
}

/** input type for incrementing numeric columns in table "merchant_balance" */
export type MerchantBalanceIncInput = {
  balance?: InputMaybe<Scalars['numeric']>;
  calculated_balance?: InputMaybe<Scalars['numeric']>;
  calculated_hold_balance?: InputMaybe<Scalars['numeric']>;
  frozen_withdraw_balance?: InputMaybe<Scalars['numeric']>;
  hold_balance?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "merchant_balance" */
export type MerchantBalanceInsertInput = {
  balance?: InputMaybe<Scalars['numeric']>;
  calculated_balance?: InputMaybe<Scalars['numeric']>;
  calculated_hold_balance?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<CurrencyObjRelInsertInput>;
  currency_id?: InputMaybe<Scalars['String']>;
  frozen_withdraw_balance?: InputMaybe<Scalars['numeric']>;
  hold_balance?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  is_total?: InputMaybe<Scalars['Boolean']>;
  merchant?: InputMaybe<MerchantObjRelInsertInput>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  provider?: InputMaybe<ProviderObjRelInsertInput>;
  provider_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type MerchantBalanceMaxFields = {
  balance?: Maybe<Scalars['numeric']>;
  calculated_balance?: Maybe<Scalars['numeric']>;
  calculated_hold_balance?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  frozen_withdraw_balance?: Maybe<Scalars['numeric']>;
  hold_balance?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  merchant_id?: Maybe<Scalars['Int']>;
  provider_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "merchant_balance" */
export type MerchantBalanceMaxOrderBy = {
  balance?: InputMaybe<OrderBy>;
  calculated_balance?: InputMaybe<OrderBy>;
  calculated_hold_balance?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  frozen_withdraw_balance?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MerchantBalanceMinFields = {
  balance?: Maybe<Scalars['numeric']>;
  calculated_balance?: Maybe<Scalars['numeric']>;
  calculated_hold_balance?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  frozen_withdraw_balance?: Maybe<Scalars['numeric']>;
  hold_balance?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  merchant_id?: Maybe<Scalars['Int']>;
  provider_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "merchant_balance" */
export type MerchantBalanceMinOrderBy = {
  balance?: InputMaybe<OrderBy>;
  calculated_balance?: InputMaybe<OrderBy>;
  calculated_hold_balance?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  frozen_withdraw_balance?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "merchant_balance" */
export type MerchantBalanceMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MerchantBalance>;
};

/** on_conflict condition type for table "merchant_balance" */
export type MerchantBalanceOnConflict = {
  constraint: MerchantBalanceConstraint;
  update_columns?: Array<MerchantBalanceUpdateColumn>;
  where?: InputMaybe<MerchantBalanceBoolExp>;
};

/** Ordering options when selecting data from "merchant_balance". */
export type MerchantBalanceOrderBy = {
  balance?: InputMaybe<OrderBy>;
  calculated_balance?: InputMaybe<OrderBy>;
  calculated_hold_balance?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency?: InputMaybe<CurrencyOrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  frozen_withdraw_balance?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_total?: InputMaybe<OrderBy>;
  merchant?: InputMaybe<MerchantOrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  provider?: InputMaybe<ProviderOrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: merchant_balance */
export type MerchantBalancePkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "merchant_balance" */
export enum MerchantBalanceSelectColumn {
  /** column name */
  Balance = 'balance',
  /** column name */
  CalculatedBalance = 'calculated_balance',
  /** column name */
  CalculatedHoldBalance = 'calculated_hold_balance',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  FrozenWithdrawBalance = 'frozen_withdraw_balance',
  /** column name */
  HoldBalance = 'hold_balance',
  /** column name */
  Id = 'id',
  /** column name */
  IsTotal = 'is_total',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "merchant_balance" */
export type MerchantBalanceSetInput = {
  balance?: InputMaybe<Scalars['numeric']>;
  calculated_balance?: InputMaybe<Scalars['numeric']>;
  calculated_hold_balance?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency_id?: InputMaybe<Scalars['String']>;
  frozen_withdraw_balance?: InputMaybe<Scalars['numeric']>;
  hold_balance?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  is_total?: InputMaybe<Scalars['Boolean']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  provider_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type MerchantBalanceStddevFields = {
  balance?: Maybe<Scalars['Float']>;
  calculated_balance?: Maybe<Scalars['Float']>;
  calculated_hold_balance?: Maybe<Scalars['Float']>;
  frozen_withdraw_balance?: Maybe<Scalars['Float']>;
  hold_balance?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "merchant_balance" */
export type MerchantBalanceStddevOrderBy = {
  balance?: InputMaybe<OrderBy>;
  calculated_balance?: InputMaybe<OrderBy>;
  calculated_hold_balance?: InputMaybe<OrderBy>;
  frozen_withdraw_balance?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type MerchantBalanceStddevPopFields = {
  balance?: Maybe<Scalars['Float']>;
  calculated_balance?: Maybe<Scalars['Float']>;
  calculated_hold_balance?: Maybe<Scalars['Float']>;
  frozen_withdraw_balance?: Maybe<Scalars['Float']>;
  hold_balance?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "merchant_balance" */
export type MerchantBalanceStddevPopOrderBy = {
  balance?: InputMaybe<OrderBy>;
  calculated_balance?: InputMaybe<OrderBy>;
  calculated_hold_balance?: InputMaybe<OrderBy>;
  frozen_withdraw_balance?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type MerchantBalanceStddevSampFields = {
  balance?: Maybe<Scalars['Float']>;
  calculated_balance?: Maybe<Scalars['Float']>;
  calculated_hold_balance?: Maybe<Scalars['Float']>;
  frozen_withdraw_balance?: Maybe<Scalars['Float']>;
  hold_balance?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "merchant_balance" */
export type MerchantBalanceStddevSampOrderBy = {
  balance?: InputMaybe<OrderBy>;
  calculated_balance?: InputMaybe<OrderBy>;
  calculated_hold_balance?: InputMaybe<OrderBy>;
  frozen_withdraw_balance?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type MerchantBalanceSumFields = {
  balance?: Maybe<Scalars['numeric']>;
  calculated_balance?: Maybe<Scalars['numeric']>;
  calculated_hold_balance?: Maybe<Scalars['numeric']>;
  frozen_withdraw_balance?: Maybe<Scalars['numeric']>;
  hold_balance?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  merchant_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "merchant_balance" */
export type MerchantBalanceSumOrderBy = {
  balance?: InputMaybe<OrderBy>;
  calculated_balance?: InputMaybe<OrderBy>;
  calculated_hold_balance?: InputMaybe<OrderBy>;
  frozen_withdraw_balance?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
};

/** update columns of table "merchant_balance" */
export enum MerchantBalanceUpdateColumn {
  /** column name */
  Balance = 'balance',
  /** column name */
  CalculatedBalance = 'calculated_balance',
  /** column name */
  CalculatedHoldBalance = 'calculated_hold_balance',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  FrozenWithdrawBalance = 'frozen_withdraw_balance',
  /** column name */
  HoldBalance = 'hold_balance',
  /** column name */
  Id = 'id',
  /** column name */
  IsTotal = 'is_total',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type MerchantBalanceUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MerchantBalanceIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MerchantBalanceSetInput>;
  where: MerchantBalanceBoolExp;
};

/** aggregate var_pop on columns */
export type MerchantBalanceVarPopFields = {
  balance?: Maybe<Scalars['Float']>;
  calculated_balance?: Maybe<Scalars['Float']>;
  calculated_hold_balance?: Maybe<Scalars['Float']>;
  frozen_withdraw_balance?: Maybe<Scalars['Float']>;
  hold_balance?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "merchant_balance" */
export type MerchantBalanceVarPopOrderBy = {
  balance?: InputMaybe<OrderBy>;
  calculated_balance?: InputMaybe<OrderBy>;
  calculated_hold_balance?: InputMaybe<OrderBy>;
  frozen_withdraw_balance?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type MerchantBalanceVarSampFields = {
  balance?: Maybe<Scalars['Float']>;
  calculated_balance?: Maybe<Scalars['Float']>;
  calculated_hold_balance?: Maybe<Scalars['Float']>;
  frozen_withdraw_balance?: Maybe<Scalars['Float']>;
  hold_balance?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "merchant_balance" */
export type MerchantBalanceVarSampOrderBy = {
  balance?: InputMaybe<OrderBy>;
  calculated_balance?: InputMaybe<OrderBy>;
  calculated_hold_balance?: InputMaybe<OrderBy>;
  frozen_withdraw_balance?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type MerchantBalanceVarianceFields = {
  balance?: Maybe<Scalars['Float']>;
  calculated_balance?: Maybe<Scalars['Float']>;
  calculated_hold_balance?: Maybe<Scalars['Float']>;
  frozen_withdraw_balance?: Maybe<Scalars['Float']>;
  hold_balance?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "merchant_balance" */
export type MerchantBalanceVarianceOrderBy = {
  balance?: InputMaybe<OrderBy>;
  calculated_balance?: InputMaybe<OrderBy>;
  calculated_hold_balance?: InputMaybe<OrderBy>;
  frozen_withdraw_balance?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "merchant". All fields are combined with a logical 'AND'. */
export type MerchantBoolExp = {
  _and?: InputMaybe<Array<MerchantBoolExp>>;
  _not?: InputMaybe<MerchantBoolExp>;
  _or?: InputMaybe<Array<MerchantBoolExp>>;
  api_token?: InputMaybe<StringComparisonExp>;
  balance?: InputMaybe<NumericComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  current_provider_id?: InputMaybe<StringComparisonExp>;
  edit_user_id?: InputMaybe<IntComparisonExp>;
  gate_groups?: InputMaybe<GateGroupBoolExp>;
  hold_balance?: InputMaybe<NumericComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  invoice_callback_url?: InputMaybe<StringComparisonExp>;
  invoice_enabled?: InputMaybe<BooleanComparisonExp>;
  invoice_fee_percent?: InputMaybe<NumericComparisonExp>;
  invoice_h2h_enabled?: InputMaybe<BooleanComparisonExp>;
  invoice_qiwi_enabled?: InputMaybe<BooleanComparisonExp>;
  invoice_s2p_enabled?: InputMaybe<BooleanComparisonExp>;
  invoices?: InputMaybe<InvoiceBoolExp>;
  mass_withdraw_enabled?: InputMaybe<BooleanComparisonExp>;
  merchant_balances?: InputMaybe<MerchantBalanceBoolExp>;
  merchant_currencies?: InputMaybe<MerchantCurrencyBoolExp>;
  merchant_fees?: InputMaybe<MerchantFeeBoolExp>;
  merchant_info?: InputMaybe<MerchantInfoBoolExp>;
  merchant_status_id?: InputMaybe<StringComparisonExp>;
  merchant_type_id?: InputMaybe<StringComparisonExp>;
  merchant_users?: InputMaybe<MerchantUserBoolExp>;
  merchant_widgets?: InputMaybe<MerchantWidgetBoolExp>;
  permissions?: InputMaybe<VHasuraPermissionBoolExp>;
  provider?: InputMaybe<ProviderBoolExp>;
  qiwi_mass_withdraw_enabled?: InputMaybe<BooleanComparisonExp>;
  redirect_failed_url?: InputMaybe<StringComparisonExp>;
  redirect_success_url?: InputMaybe<StringComparisonExp>;
  refund_enabled?: InputMaybe<BooleanComparisonExp>;
  rolling_reserve_duration?: InputMaybe<IntComparisonExp>;
  rolling_reserve_percent?: InputMaybe<NumericComparisonExp>;
  s2p_withdraw_enabled?: InputMaybe<BooleanComparisonExp>;
  secret_key?: InputMaybe<StringComparisonExp>;
  telegram_notification_chat_id?: InputMaybe<StringComparisonExp>;
  telegram_notification_enabled?: InputMaybe<BooleanComparisonExp>;
  transaction_histories?: InputMaybe<TransactionHistoryBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  withdraw_callback_url?: InputMaybe<StringComparisonExp>;
  withdraw_enabled?: InputMaybe<BooleanComparisonExp>;
  withdraw_fee_percent?: InputMaybe<NumericComparisonExp>;
  withdraw_requests?: InputMaybe<WithdrawRequestBoolExp>;
  withdraws?: InputMaybe<WithdrawBoolExp>;
};

/** unique or primary key constraints on table "merchant" */
export enum MerchantConstraint {
  /** unique or primary key constraint on columns "api_token" */
  MerchantApiTokenKey = 'merchant_api_token_key',
  /** unique or primary key constraint on columns "id" */
  MerchantPkey = 'merchant_pkey',
  /** unique or primary key constraint on columns "secret_key" */
  MerchantSecretKeyKey = 'merchant_secret_key_key'
}

/** columns and relationships of "merchant_currency" */
export type MerchantCurrency = {
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  currency: Currency;
  currency_id: Scalars['String'];
  edit_user_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  /** An object relationship */
  merchant: Merchant;
  merchant_id: Scalars['Int'];
  show_in_header?: Maybe<Scalars['Boolean']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "merchant_currency" */
export type MerchantCurrencyAggregate = {
  aggregate?: Maybe<MerchantCurrencyAggregateFields>;
  nodes: Array<MerchantCurrency>;
};

/** aggregate fields of "merchant_currency" */
export type MerchantCurrencyAggregateFields = {
  avg?: Maybe<MerchantCurrencyAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MerchantCurrencyMaxFields>;
  min?: Maybe<MerchantCurrencyMinFields>;
  stddev?: Maybe<MerchantCurrencyStddevFields>;
  stddev_pop?: Maybe<MerchantCurrencyStddevPopFields>;
  stddev_samp?: Maybe<MerchantCurrencyStddevSampFields>;
  sum?: Maybe<MerchantCurrencySumFields>;
  var_pop?: Maybe<MerchantCurrencyVarPopFields>;
  var_samp?: Maybe<MerchantCurrencyVarSampFields>;
  variance?: Maybe<MerchantCurrencyVarianceFields>;
};


/** aggregate fields of "merchant_currency" */
export type MerchantCurrencyAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MerchantCurrencySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "merchant_currency" */
export type MerchantCurrencyAggregateOrderBy = {
  avg?: InputMaybe<MerchantCurrencyAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MerchantCurrencyMaxOrderBy>;
  min?: InputMaybe<MerchantCurrencyMinOrderBy>;
  stddev?: InputMaybe<MerchantCurrencyStddevOrderBy>;
  stddev_pop?: InputMaybe<MerchantCurrencyStddevPopOrderBy>;
  stddev_samp?: InputMaybe<MerchantCurrencyStddevSampOrderBy>;
  sum?: InputMaybe<MerchantCurrencySumOrderBy>;
  var_pop?: InputMaybe<MerchantCurrencyVarPopOrderBy>;
  var_samp?: InputMaybe<MerchantCurrencyVarSampOrderBy>;
  variance?: InputMaybe<MerchantCurrencyVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "merchant_currency" */
export type MerchantCurrencyArrRelInsertInput = {
  data: Array<MerchantCurrencyInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<MerchantCurrencyOnConflict>;
};

/** aggregate avg on columns */
export type MerchantCurrencyAvgFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "merchant_currency" */
export type MerchantCurrencyAvgOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "merchant_currency". All fields are combined with a logical 'AND'. */
export type MerchantCurrencyBoolExp = {
  _and?: InputMaybe<Array<MerchantCurrencyBoolExp>>;
  _not?: InputMaybe<MerchantCurrencyBoolExp>;
  _or?: InputMaybe<Array<MerchantCurrencyBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<CurrencyBoolExp>;
  currency_id?: InputMaybe<StringComparisonExp>;
  edit_user_id?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  merchant?: InputMaybe<MerchantBoolExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  show_in_header?: InputMaybe<BooleanComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "merchant_currency" */
export enum MerchantCurrencyConstraint {
  /** unique or primary key constraint on columns "currency_id", "merchant_id" */
  MerchantCurrencyMerchantIdCurrencyIdKey = 'merchant_currency_merchant_id_currency_id_key',
  /** unique or primary key constraint on columns "id" */
  MerchantCurrencyPkey = 'merchant_currency_pkey'
}

/** input type for incrementing numeric columns in table "merchant_currency" */
export type MerchantCurrencyIncInput = {
  edit_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "merchant_currency" */
export type MerchantCurrencyInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<CurrencyObjRelInsertInput>;
  currency_id?: InputMaybe<Scalars['String']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  merchant?: InputMaybe<MerchantObjRelInsertInput>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  show_in_header?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type MerchantCurrencyMaxFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  merchant_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "merchant_currency" */
export type MerchantCurrencyMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MerchantCurrencyMinFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  merchant_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "merchant_currency" */
export type MerchantCurrencyMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "merchant_currency" */
export type MerchantCurrencyMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MerchantCurrency>;
};

/** on_conflict condition type for table "merchant_currency" */
export type MerchantCurrencyOnConflict = {
  constraint: MerchantCurrencyConstraint;
  update_columns?: Array<MerchantCurrencyUpdateColumn>;
  where?: InputMaybe<MerchantCurrencyBoolExp>;
};

/** Ordering options when selecting data from "merchant_currency". */
export type MerchantCurrencyOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  currency?: InputMaybe<CurrencyOrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant?: InputMaybe<MerchantOrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  show_in_header?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: merchant_currency */
export type MerchantCurrencyPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "merchant_currency" */
export enum MerchantCurrencySelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  EditUserId = 'edit_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  ShowInHeader = 'show_in_header',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "merchant_currency" */
export type MerchantCurrencySetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency_id?: InputMaybe<Scalars['String']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  show_in_header?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type MerchantCurrencyStddevFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "merchant_currency" */
export type MerchantCurrencyStddevOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type MerchantCurrencyStddevPopFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "merchant_currency" */
export type MerchantCurrencyStddevPopOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type MerchantCurrencyStddevSampFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "merchant_currency" */
export type MerchantCurrencyStddevSampOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type MerchantCurrencySumFields = {
  edit_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  merchant_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "merchant_currency" */
export type MerchantCurrencySumOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
};

/** update columns of table "merchant_currency" */
export enum MerchantCurrencyUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  EditUserId = 'edit_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  ShowInHeader = 'show_in_header',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type MerchantCurrencyUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MerchantCurrencyIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MerchantCurrencySetInput>;
  where: MerchantCurrencyBoolExp;
};

/** aggregate var_pop on columns */
export type MerchantCurrencyVarPopFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "merchant_currency" */
export type MerchantCurrencyVarPopOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type MerchantCurrencyVarSampFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "merchant_currency" */
export type MerchantCurrencyVarSampOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type MerchantCurrencyVarianceFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "merchant_currency" */
export type MerchantCurrencyVarianceOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "merchant_fee" */
export type MerchantFee = {
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  currency: Currency;
  currency_id: Scalars['String'];
  edit_user_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  invoice_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  merchant: Merchant;
  merchant_constant_invoice_fee: Scalars['numeric'];
  merchant_constant_withdraw_fee: Scalars['numeric'];
  merchant_id: Scalars['Int'];
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee_min_amount: Scalars['numeric'];
  merchant_invoice_fee_percent: Scalars['numeric'];
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount: Scalars['numeric'];
  merchant_withdraw_fee_percent: Scalars['numeric'];
  merchant_withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  provider?: Maybe<Provider>;
  provider_id?: Maybe<Scalars['String']>;
  rolling_reserve_duration: Scalars['Int'];
  rolling_reserve_percent: Scalars['numeric'];
  updated_at: Scalars['timestamptz'];
  withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "merchant_fee" */
export type MerchantFeeAggregate = {
  aggregate?: Maybe<MerchantFeeAggregateFields>;
  nodes: Array<MerchantFee>;
};

/** aggregate fields of "merchant_fee" */
export type MerchantFeeAggregateFields = {
  avg?: Maybe<MerchantFeeAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MerchantFeeMaxFields>;
  min?: Maybe<MerchantFeeMinFields>;
  stddev?: Maybe<MerchantFeeStddevFields>;
  stddev_pop?: Maybe<MerchantFeeStddevPopFields>;
  stddev_samp?: Maybe<MerchantFeeStddevSampFields>;
  sum?: Maybe<MerchantFeeSumFields>;
  var_pop?: Maybe<MerchantFeeVarPopFields>;
  var_samp?: Maybe<MerchantFeeVarSampFields>;
  variance?: Maybe<MerchantFeeVarianceFields>;
};


/** aggregate fields of "merchant_fee" */
export type MerchantFeeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MerchantFeeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "merchant_fee" */
export type MerchantFeeAggregateOrderBy = {
  avg?: InputMaybe<MerchantFeeAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MerchantFeeMaxOrderBy>;
  min?: InputMaybe<MerchantFeeMinOrderBy>;
  stddev?: InputMaybe<MerchantFeeStddevOrderBy>;
  stddev_pop?: InputMaybe<MerchantFeeStddevPopOrderBy>;
  stddev_samp?: InputMaybe<MerchantFeeStddevSampOrderBy>;
  sum?: InputMaybe<MerchantFeeSumOrderBy>;
  var_pop?: InputMaybe<MerchantFeeVarPopOrderBy>;
  var_samp?: InputMaybe<MerchantFeeVarSampOrderBy>;
  variance?: InputMaybe<MerchantFeeVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "merchant_fee" */
export type MerchantFeeArrRelInsertInput = {
  data: Array<MerchantFeeInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<MerchantFeeOnConflict>;
};

/** aggregate avg on columns */
export type MerchantFeeAvgFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "merchant_fee" */
export type MerchantFeeAvgOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "merchant_fee". All fields are combined with a logical 'AND'. */
export type MerchantFeeBoolExp = {
  _and?: InputMaybe<Array<MerchantFeeBoolExp>>;
  _not?: InputMaybe<MerchantFeeBoolExp>;
  _or?: InputMaybe<Array<MerchantFeeBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<CurrencyBoolExp>;
  currency_id?: InputMaybe<StringComparisonExp>;
  edit_user_id?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  invoice_transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
  merchant?: InputMaybe<MerchantBoolExp>;
  merchant_constant_invoice_fee?: InputMaybe<NumericComparisonExp>;
  merchant_constant_withdraw_fee?: InputMaybe<NumericComparisonExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
  merchant_invoice_fee_min_amount?: InputMaybe<NumericComparisonExp>;
  merchant_invoice_fee_percent?: InputMaybe<NumericComparisonExp>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
  merchant_withdraw_fee_min_amount?: InputMaybe<NumericComparisonExp>;
  merchant_withdraw_fee_percent?: InputMaybe<NumericComparisonExp>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<NumericComparisonExp>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
  provider?: InputMaybe<ProviderBoolExp>;
  provider_id?: InputMaybe<StringComparisonExp>;
  rolling_reserve_duration?: InputMaybe<IntComparisonExp>;
  rolling_reserve_percent?: InputMaybe<NumericComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<NumericComparisonExp>;
  withdraw_transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
};

/** unique or primary key constraints on table "merchant_fee" */
export enum MerchantFeeConstraint {
  /** unique or primary key constraint on columns "provider_id", "currency_id", "merchant_id" */
  MerchantFeeMerchantIdCurrencyIdProviderIdKey = 'merchant_fee_merchant_id_currency_id_provider_id_key',
  /** unique or primary key constraint on columns "id" */
  MerchantFeePkey = 'merchant_fee_pkey'
}

/** input type for incrementing numeric columns in table "merchant_fee" */
export type MerchantFeeIncInput = {
  edit_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  invoice_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_constant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  merchant_constant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  rolling_reserve_duration?: InputMaybe<Scalars['Int']>;
  rolling_reserve_percent?: InputMaybe<Scalars['numeric']>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  withdraw_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "merchant_fee" */
export type MerchantFeeInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<CurrencyObjRelInsertInput>;
  currency_id?: InputMaybe<Scalars['String']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  invoice_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant?: InputMaybe<MerchantObjRelInsertInput>;
  merchant_constant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  merchant_constant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  provider?: InputMaybe<ProviderObjRelInsertInput>;
  provider_id?: InputMaybe<Scalars['String']>;
  rolling_reserve_duration?: InputMaybe<Scalars['Int']>;
  rolling_reserve_percent?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  withdraw_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type MerchantFeeMaxFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['numeric']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  provider_id?: Maybe<Scalars['String']>;
  rolling_reserve_duration?: Maybe<Scalars['Int']>;
  rolling_reserve_percent?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "merchant_fee" */
export type MerchantFeeMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MerchantFeeMinFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['numeric']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  provider_id?: Maybe<Scalars['String']>;
  rolling_reserve_duration?: Maybe<Scalars['Int']>;
  rolling_reserve_percent?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "merchant_fee" */
export type MerchantFeeMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "merchant_fee" */
export type MerchantFeeMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MerchantFee>;
};

/** on_conflict condition type for table "merchant_fee" */
export type MerchantFeeOnConflict = {
  constraint: MerchantFeeConstraint;
  update_columns?: Array<MerchantFeeUpdateColumn>;
  where?: InputMaybe<MerchantFeeBoolExp>;
};

/** Ordering options when selecting data from "merchant_fee". */
export type MerchantFeeOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  currency?: InputMaybe<CurrencyOrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant?: InputMaybe<MerchantOrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  provider?: InputMaybe<ProviderOrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: merchant_fee */
export type MerchantFeePkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "merchant_fee" */
export enum MerchantFeeSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  EditUserId = 'edit_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceTransactionFeeAmount = 'invoice_transaction_fee_amount',
  /** column name */
  MerchantConstantInvoiceFee = 'merchant_constant_invoice_fee',
  /** column name */
  MerchantConstantWithdrawFee = 'merchant_constant_withdraw_fee',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MerchantInvoiceDeclineTransactionFeeAmount = 'merchant_invoice_decline_transaction_fee_amount',
  /** column name */
  MerchantInvoiceFeeMinAmount = 'merchant_invoice_fee_min_amount',
  /** column name */
  MerchantInvoiceFeePercent = 'merchant_invoice_fee_percent',
  /** column name */
  MerchantInvoiceTransactionFeeAmount = 'merchant_invoice_transaction_fee_amount',
  /** column name */
  MerchantWithdrawDeclineTransactionFeeAmount = 'merchant_withdraw_decline_transaction_fee_amount',
  /** column name */
  MerchantWithdrawFeeMinAmount = 'merchant_withdraw_fee_min_amount',
  /** column name */
  MerchantWithdrawFeePercent = 'merchant_withdraw_fee_percent',
  /** column name */
  MerchantWithdrawSettlementUsdtFeePercent = 'merchant_withdraw_settlement_usdt_fee_percent',
  /** column name */
  MerchantWithdrawTransactionFeeAmount = 'merchant_withdraw_transaction_fee_amount',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  RollingReserveDuration = 'rolling_reserve_duration',
  /** column name */
  RollingReservePercent = 'rolling_reserve_percent',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WithdrawSettlementUsdtFeePercent = 'withdraw_settlement_usdt_fee_percent',
  /** column name */
  WithdrawTransactionFeeAmount = 'withdraw_transaction_fee_amount'
}

/** input type for updating data in table "merchant_fee" */
export type MerchantFeeSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency_id?: InputMaybe<Scalars['String']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  invoice_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_constant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  merchant_constant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  provider_id?: InputMaybe<Scalars['String']>;
  rolling_reserve_duration?: InputMaybe<Scalars['Int']>;
  rolling_reserve_percent?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  withdraw_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type MerchantFeeStddevFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "merchant_fee" */
export type MerchantFeeStddevOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type MerchantFeeStddevPopFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "merchant_fee" */
export type MerchantFeeStddevPopOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type MerchantFeeStddevSampFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "merchant_fee" */
export type MerchantFeeStddevSampOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type MerchantFeeSumFields = {
  edit_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['numeric']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  rolling_reserve_duration?: Maybe<Scalars['Int']>;
  rolling_reserve_percent?: Maybe<Scalars['numeric']>;
  withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "merchant_fee" */
export type MerchantFeeSumOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** update columns of table "merchant_fee" */
export enum MerchantFeeUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  EditUserId = 'edit_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceTransactionFeeAmount = 'invoice_transaction_fee_amount',
  /** column name */
  MerchantConstantInvoiceFee = 'merchant_constant_invoice_fee',
  /** column name */
  MerchantConstantWithdrawFee = 'merchant_constant_withdraw_fee',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MerchantInvoiceDeclineTransactionFeeAmount = 'merchant_invoice_decline_transaction_fee_amount',
  /** column name */
  MerchantInvoiceFeeMinAmount = 'merchant_invoice_fee_min_amount',
  /** column name */
  MerchantInvoiceFeePercent = 'merchant_invoice_fee_percent',
  /** column name */
  MerchantInvoiceTransactionFeeAmount = 'merchant_invoice_transaction_fee_amount',
  /** column name */
  MerchantWithdrawDeclineTransactionFeeAmount = 'merchant_withdraw_decline_transaction_fee_amount',
  /** column name */
  MerchantWithdrawFeeMinAmount = 'merchant_withdraw_fee_min_amount',
  /** column name */
  MerchantWithdrawFeePercent = 'merchant_withdraw_fee_percent',
  /** column name */
  MerchantWithdrawSettlementUsdtFeePercent = 'merchant_withdraw_settlement_usdt_fee_percent',
  /** column name */
  MerchantWithdrawTransactionFeeAmount = 'merchant_withdraw_transaction_fee_amount',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  RollingReserveDuration = 'rolling_reserve_duration',
  /** column name */
  RollingReservePercent = 'rolling_reserve_percent',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WithdrawSettlementUsdtFeePercent = 'withdraw_settlement_usdt_fee_percent',
  /** column name */
  WithdrawTransactionFeeAmount = 'withdraw_transaction_fee_amount'
}

export type MerchantFeeUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MerchantFeeIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MerchantFeeSetInput>;
  where: MerchantFeeBoolExp;
};

/** aggregate var_pop on columns */
export type MerchantFeeVarPopFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "merchant_fee" */
export type MerchantFeeVarPopOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type MerchantFeeVarSampFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "merchant_fee" */
export type MerchantFeeVarSampOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type MerchantFeeVarianceFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "merchant_fee" */
export type MerchantFeeVarianceOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "merchant_file" */
export type MerchantFile = {
  created_at: Scalars['timestamptz'];
  file_path?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An object relationship */
  merchant: Merchant;
  merchant_id: Scalars['Int'];
  /** An object relationship */
  merchant_task?: Maybe<MerchantTask>;
  /** Link to task where file was generated */
  merchant_task_id?: Maybe<Scalars['uuid']>;
  status: Scalars['String'];
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  upload_file_name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "merchant_file" */
export type MerchantFileAggregate = {
  aggregate?: Maybe<MerchantFileAggregateFields>;
  nodes: Array<MerchantFile>;
};

/** aggregate fields of "merchant_file" */
export type MerchantFileAggregateFields = {
  avg?: Maybe<MerchantFileAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MerchantFileMaxFields>;
  min?: Maybe<MerchantFileMinFields>;
  stddev?: Maybe<MerchantFileStddevFields>;
  stddev_pop?: Maybe<MerchantFileStddevPopFields>;
  stddev_samp?: Maybe<MerchantFileStddevSampFields>;
  sum?: Maybe<MerchantFileSumFields>;
  var_pop?: Maybe<MerchantFileVarPopFields>;
  var_samp?: Maybe<MerchantFileVarSampFields>;
  variance?: Maybe<MerchantFileVarianceFields>;
};


/** aggregate fields of "merchant_file" */
export type MerchantFileAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MerchantFileSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type MerchantFileAvgFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "merchant_file". All fields are combined with a logical 'AND'. */
export type MerchantFileBoolExp = {
  _and?: InputMaybe<Array<MerchantFileBoolExp>>;
  _not?: InputMaybe<MerchantFileBoolExp>;
  _or?: InputMaybe<Array<MerchantFileBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  file_path?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  merchant?: InputMaybe<MerchantBoolExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  merchant_task?: InputMaybe<MerchantTaskBoolExp>;
  merchant_task_id?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  upload_file_name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "merchant_file" */
export enum MerchantFileConstraint {
  /** unique or primary key constraint on columns "id" */
  MerchantFilePkey = 'merchant_file_pkey'
}

/** input type for incrementing numeric columns in table "merchant_file" */
export type MerchantFileIncInput = {
  merchant_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "merchant_file" */
export type MerchantFileInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  file_path?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  merchant?: InputMaybe<MerchantObjRelInsertInput>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_task?: InputMaybe<MerchantTaskObjRelInsertInput>;
  /** Link to task where file was generated */
  merchant_task_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  upload_file_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type MerchantFileMaxFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  file_path?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  merchant_id?: Maybe<Scalars['Int']>;
  /** Link to task where file was generated */
  merchant_task_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  upload_file_name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type MerchantFileMinFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  file_path?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  merchant_id?: Maybe<Scalars['Int']>;
  /** Link to task where file was generated */
  merchant_task_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  upload_file_name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "merchant_file" */
export type MerchantFileMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MerchantFile>;
};

/** on_conflict condition type for table "merchant_file" */
export type MerchantFileOnConflict = {
  constraint: MerchantFileConstraint;
  update_columns?: Array<MerchantFileUpdateColumn>;
  where?: InputMaybe<MerchantFileBoolExp>;
};

/** Ordering options when selecting data from "merchant_file". */
export type MerchantFileOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  file_path?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant?: InputMaybe<MerchantOrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_task?: InputMaybe<MerchantTaskOrderBy>;
  merchant_task_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  upload_file_name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: merchant_file */
export type MerchantFilePkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "merchant_file" */
export enum MerchantFileSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FilePath = 'file_path',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MerchantTaskId = 'merchant_task_id',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UploadFileName = 'upload_file_name'
}

/** input type for updating data in table "merchant_file" */
export type MerchantFileSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  file_path?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  /** Link to task where file was generated */
  merchant_task_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  upload_file_name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type MerchantFileStddevFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type MerchantFileStddevPopFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type MerchantFileStddevSampFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type MerchantFileSumFields = {
  merchant_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "merchant_file" */
export enum MerchantFileUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FilePath = 'file_path',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MerchantTaskId = 'merchant_task_id',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UploadFileName = 'upload_file_name'
}

export type MerchantFileUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MerchantFileIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MerchantFileSetInput>;
  where: MerchantFileBoolExp;
};

/** aggregate var_pop on columns */
export type MerchantFileVarPopFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type MerchantFileVarSampFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type MerchantFileVarianceFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** input type for incrementing numeric columns in table "merchant" */
export type MerchantIncInput = {
  balance?: InputMaybe<Scalars['numeric']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  hold_balance?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  invoice_fee_percent?: InputMaybe<Scalars['numeric']>;
  rolling_reserve_duration?: InputMaybe<Scalars['Int']>;
  rolling_reserve_percent?: InputMaybe<Scalars['numeric']>;
  withdraw_fee_percent?: InputMaybe<Scalars['numeric']>;
};

/** columns and relationships of "merchant_info" */
export type MerchantInfo = {
  business_address?: Maybe<Scalars['String']>;
  chargeback_ratio?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  company_website?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  edit_user_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  /** An object relationship */
  merchant: Merchant;
  merchant_id: Scalars['Int'];
  month_turnover?: Maybe<Scalars['String']>;
  payments_geo?: Maybe<Scalars['String']>;
  registered_address?: Maybe<Scalars['String']>;
  registration_data?: Maybe<Scalars['date']>;
  registration_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "merchant_info" */
export type MerchantInfoAggregate = {
  aggregate?: Maybe<MerchantInfoAggregateFields>;
  nodes: Array<MerchantInfo>;
};

/** aggregate fields of "merchant_info" */
export type MerchantInfoAggregateFields = {
  avg?: Maybe<MerchantInfoAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MerchantInfoMaxFields>;
  min?: Maybe<MerchantInfoMinFields>;
  stddev?: Maybe<MerchantInfoStddevFields>;
  stddev_pop?: Maybe<MerchantInfoStddevPopFields>;
  stddev_samp?: Maybe<MerchantInfoStddevSampFields>;
  sum?: Maybe<MerchantInfoSumFields>;
  var_pop?: Maybe<MerchantInfoVarPopFields>;
  var_samp?: Maybe<MerchantInfoVarSampFields>;
  variance?: Maybe<MerchantInfoVarianceFields>;
};


/** aggregate fields of "merchant_info" */
export type MerchantInfoAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MerchantInfoSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type MerchantInfoAvgFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "merchant_info". All fields are combined with a logical 'AND'. */
export type MerchantInfoBoolExp = {
  _and?: InputMaybe<Array<MerchantInfoBoolExp>>;
  _not?: InputMaybe<MerchantInfoBoolExp>;
  _or?: InputMaybe<Array<MerchantInfoBoolExp>>;
  business_address?: InputMaybe<StringComparisonExp>;
  chargeback_ratio?: InputMaybe<StringComparisonExp>;
  comment?: InputMaybe<StringComparisonExp>;
  company_name?: InputMaybe<StringComparisonExp>;
  company_website?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  edit_user_id?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  merchant?: InputMaybe<MerchantBoolExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  month_turnover?: InputMaybe<StringComparisonExp>;
  payments_geo?: InputMaybe<StringComparisonExp>;
  registered_address?: InputMaybe<StringComparisonExp>;
  registration_data?: InputMaybe<DateComparisonExp>;
  registration_number?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "merchant_info" */
export enum MerchantInfoConstraint {
  /** unique or primary key constraint on columns "merchant_id" */
  MerchantInfoPkey = 'merchant_info_pkey'
}

/** input type for incrementing numeric columns in table "merchant_info" */
export type MerchantInfoIncInput = {
  edit_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "merchant_info" */
export type MerchantInfoInsertInput = {
  business_address?: InputMaybe<Scalars['String']>;
  chargeback_ratio?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  company_website?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  merchant?: InputMaybe<MerchantObjRelInsertInput>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  month_turnover?: InputMaybe<Scalars['String']>;
  payments_geo?: InputMaybe<Scalars['String']>;
  registered_address?: InputMaybe<Scalars['String']>;
  registration_data?: InputMaybe<Scalars['date']>;
  registration_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type MerchantInfoMaxFields = {
  business_address?: Maybe<Scalars['String']>;
  chargeback_ratio?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  company_website?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  merchant_id?: Maybe<Scalars['Int']>;
  month_turnover?: Maybe<Scalars['String']>;
  payments_geo?: Maybe<Scalars['String']>;
  registered_address?: Maybe<Scalars['String']>;
  registration_data?: Maybe<Scalars['date']>;
  registration_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type MerchantInfoMinFields = {
  business_address?: Maybe<Scalars['String']>;
  chargeback_ratio?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  company_website?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  merchant_id?: Maybe<Scalars['Int']>;
  month_turnover?: Maybe<Scalars['String']>;
  payments_geo?: Maybe<Scalars['String']>;
  registered_address?: Maybe<Scalars['String']>;
  registration_data?: Maybe<Scalars['date']>;
  registration_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "merchant_info" */
export type MerchantInfoMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MerchantInfo>;
};

/** input type for inserting object relation for remote table "merchant_info" */
export type MerchantInfoObjRelInsertInput = {
  data: MerchantInfoInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<MerchantInfoOnConflict>;
};

/** on_conflict condition type for table "merchant_info" */
export type MerchantInfoOnConflict = {
  constraint: MerchantInfoConstraint;
  update_columns?: Array<MerchantInfoUpdateColumn>;
  where?: InputMaybe<MerchantInfoBoolExp>;
};

/** Ordering options when selecting data from "merchant_info". */
export type MerchantInfoOrderBy = {
  business_address?: InputMaybe<OrderBy>;
  chargeback_ratio?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  company_name?: InputMaybe<OrderBy>;
  company_website?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant?: InputMaybe<MerchantOrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  month_turnover?: InputMaybe<OrderBy>;
  payments_geo?: InputMaybe<OrderBy>;
  registered_address?: InputMaybe<OrderBy>;
  registration_data?: InputMaybe<OrderBy>;
  registration_number?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: merchant_info */
export type MerchantInfoPkColumnsInput = {
  merchant_id: Scalars['Int'];
};

/** select columns of table "merchant_info" */
export enum MerchantInfoSelectColumn {
  /** column name */
  BusinessAddress = 'business_address',
  /** column name */
  ChargebackRatio = 'chargeback_ratio',
  /** column name */
  Comment = 'comment',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  CompanyWebsite = 'company_website',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EditUserId = 'edit_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MonthTurnover = 'month_turnover',
  /** column name */
  PaymentsGeo = 'payments_geo',
  /** column name */
  RegisteredAddress = 'registered_address',
  /** column name */
  RegistrationData = 'registration_data',
  /** column name */
  RegistrationNumber = 'registration_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "merchant_info" */
export type MerchantInfoSetInput = {
  business_address?: InputMaybe<Scalars['String']>;
  chargeback_ratio?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  company_website?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  month_turnover?: InputMaybe<Scalars['String']>;
  payments_geo?: InputMaybe<Scalars['String']>;
  registered_address?: InputMaybe<Scalars['String']>;
  registration_data?: InputMaybe<Scalars['date']>;
  registration_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type MerchantInfoStddevFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type MerchantInfoStddevPopFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type MerchantInfoStddevSampFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type MerchantInfoSumFields = {
  edit_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  merchant_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "merchant_info" */
export enum MerchantInfoUpdateColumn {
  /** column name */
  BusinessAddress = 'business_address',
  /** column name */
  ChargebackRatio = 'chargeback_ratio',
  /** column name */
  Comment = 'comment',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  CompanyWebsite = 'company_website',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EditUserId = 'edit_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MonthTurnover = 'month_turnover',
  /** column name */
  PaymentsGeo = 'payments_geo',
  /** column name */
  RegisteredAddress = 'registered_address',
  /** column name */
  RegistrationData = 'registration_data',
  /** column name */
  RegistrationNumber = 'registration_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type MerchantInfoUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MerchantInfoIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MerchantInfoSetInput>;
  where: MerchantInfoBoolExp;
};

/** aggregate var_pop on columns */
export type MerchantInfoVarPopFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type MerchantInfoVarSampFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type MerchantInfoVarianceFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** input type for inserting data into table "merchant" */
export type MerchantInsertInput = {
  api_token?: InputMaybe<Scalars['String']>;
  balance?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  current_provider_id?: InputMaybe<Scalars['String']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  gate_groups?: InputMaybe<GateGroupArrRelInsertInput>;
  hold_balance?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  invoice_callback_url?: InputMaybe<Scalars['String']>;
  invoice_enabled?: InputMaybe<Scalars['Boolean']>;
  invoice_fee_percent?: InputMaybe<Scalars['numeric']>;
  invoice_h2h_enabled?: InputMaybe<Scalars['Boolean']>;
  invoice_qiwi_enabled?: InputMaybe<Scalars['Boolean']>;
  invoice_s2p_enabled?: InputMaybe<Scalars['Boolean']>;
  invoices?: InputMaybe<InvoiceArrRelInsertInput>;
  mass_withdraw_enabled?: InputMaybe<Scalars['Boolean']>;
  merchant_balances?: InputMaybe<MerchantBalanceArrRelInsertInput>;
  merchant_currencies?: InputMaybe<MerchantCurrencyArrRelInsertInput>;
  merchant_fees?: InputMaybe<MerchantFeeArrRelInsertInput>;
  merchant_info?: InputMaybe<MerchantInfoObjRelInsertInput>;
  merchant_status_id?: InputMaybe<Scalars['String']>;
  merchant_type_id?: InputMaybe<Scalars['String']>;
  merchant_users?: InputMaybe<MerchantUserArrRelInsertInput>;
  merchant_widgets?: InputMaybe<MerchantWidgetArrRelInsertInput>;
  permissions?: InputMaybe<VHasuraPermissionArrRelInsertInput>;
  provider?: InputMaybe<ProviderObjRelInsertInput>;
  qiwi_mass_withdraw_enabled?: InputMaybe<Scalars['Boolean']>;
  redirect_failed_url?: InputMaybe<Scalars['String']>;
  redirect_success_url?: InputMaybe<Scalars['String']>;
  refund_enabled?: InputMaybe<Scalars['Boolean']>;
  rolling_reserve_duration?: InputMaybe<Scalars['Int']>;
  rolling_reserve_percent?: InputMaybe<Scalars['numeric']>;
  s2p_withdraw_enabled?: InputMaybe<Scalars['Boolean']>;
  secret_key?: InputMaybe<Scalars['String']>;
  telegram_notification_chat_id?: InputMaybe<Scalars['String']>;
  telegram_notification_enabled?: InputMaybe<Scalars['Boolean']>;
  transaction_histories?: InputMaybe<TransactionHistoryArrRelInsertInput>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  withdraw_callback_url?: InputMaybe<Scalars['String']>;
  withdraw_enabled?: InputMaybe<Scalars['Boolean']>;
  withdraw_fee_percent?: InputMaybe<Scalars['numeric']>;
  withdraw_requests?: InputMaybe<WithdrawRequestArrRelInsertInput>;
  withdraws?: InputMaybe<WithdrawArrRelInsertInput>;
};

/** aggregate max on columns */
export type MerchantMaxFields = {
  api_token?: Maybe<Scalars['String']>;
  balance?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  current_provider_id?: Maybe<Scalars['String']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  hold_balance?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  invoice_callback_url?: Maybe<Scalars['String']>;
  invoice_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_status_id?: Maybe<Scalars['String']>;
  merchant_type_id?: Maybe<Scalars['String']>;
  redirect_failed_url?: Maybe<Scalars['String']>;
  redirect_success_url?: Maybe<Scalars['String']>;
  rolling_reserve_duration?: Maybe<Scalars['Int']>;
  rolling_reserve_percent?: Maybe<Scalars['numeric']>;
  secret_key?: Maybe<Scalars['String']>;
  telegram_notification_chat_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  withdraw_callback_url?: Maybe<Scalars['String']>;
  withdraw_fee_percent?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "merchant" */
export type MerchantMaxOrderBy = {
  api_token?: InputMaybe<OrderBy>;
  balance?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  current_provider_id?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_callback_url?: InputMaybe<OrderBy>;
  invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_status_id?: InputMaybe<OrderBy>;
  merchant_type_id?: InputMaybe<OrderBy>;
  redirect_failed_url?: InputMaybe<OrderBy>;
  redirect_success_url?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  secret_key?: InputMaybe<OrderBy>;
  telegram_notification_chat_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  withdraw_callback_url?: InputMaybe<OrderBy>;
  withdraw_fee_percent?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MerchantMinFields = {
  api_token?: Maybe<Scalars['String']>;
  balance?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  current_provider_id?: Maybe<Scalars['String']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  hold_balance?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  invoice_callback_url?: Maybe<Scalars['String']>;
  invoice_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_status_id?: Maybe<Scalars['String']>;
  merchant_type_id?: Maybe<Scalars['String']>;
  redirect_failed_url?: Maybe<Scalars['String']>;
  redirect_success_url?: Maybe<Scalars['String']>;
  rolling_reserve_duration?: Maybe<Scalars['Int']>;
  rolling_reserve_percent?: Maybe<Scalars['numeric']>;
  secret_key?: Maybe<Scalars['String']>;
  telegram_notification_chat_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  withdraw_callback_url?: Maybe<Scalars['String']>;
  withdraw_fee_percent?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "merchant" */
export type MerchantMinOrderBy = {
  api_token?: InputMaybe<OrderBy>;
  balance?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  current_provider_id?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_callback_url?: InputMaybe<OrderBy>;
  invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_status_id?: InputMaybe<OrderBy>;
  merchant_type_id?: InputMaybe<OrderBy>;
  redirect_failed_url?: InputMaybe<OrderBy>;
  redirect_success_url?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  secret_key?: InputMaybe<OrderBy>;
  telegram_notification_chat_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  withdraw_callback_url?: InputMaybe<OrderBy>;
  withdraw_fee_percent?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "merchant" */
export type MerchantMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Merchant>;
};

/** columns and relationships of "merchant_notification" */
export type MerchantNotification = {
  active?: Maybe<Scalars['Boolean']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  /** An object relationship */
  merchant?: Maybe<Merchant>;
  merchant_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  notification_type?: Maybe<NotificationType>;
  notification_type_id?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  value?: Maybe<Scalars['String']>;
};

/** aggregated selection of "merchant_notification" */
export type MerchantNotificationAggregate = {
  aggregate?: Maybe<MerchantNotificationAggregateFields>;
  nodes: Array<MerchantNotification>;
};

/** aggregate fields of "merchant_notification" */
export type MerchantNotificationAggregateFields = {
  avg?: Maybe<MerchantNotificationAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MerchantNotificationMaxFields>;
  min?: Maybe<MerchantNotificationMinFields>;
  stddev?: Maybe<MerchantNotificationStddevFields>;
  stddev_pop?: Maybe<MerchantNotificationStddevPopFields>;
  stddev_samp?: Maybe<MerchantNotificationStddevSampFields>;
  sum?: Maybe<MerchantNotificationSumFields>;
  var_pop?: Maybe<MerchantNotificationVarPopFields>;
  var_samp?: Maybe<MerchantNotificationVarSampFields>;
  variance?: Maybe<MerchantNotificationVarianceFields>;
};


/** aggregate fields of "merchant_notification" */
export type MerchantNotificationAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MerchantNotificationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type MerchantNotificationAvgFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "merchant_notification". All fields are combined with a logical 'AND'. */
export type MerchantNotificationBoolExp = {
  _and?: InputMaybe<Array<MerchantNotificationBoolExp>>;
  _not?: InputMaybe<MerchantNotificationBoolExp>;
  _or?: InputMaybe<Array<MerchantNotificationBoolExp>>;
  active?: InputMaybe<BooleanComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  merchant?: InputMaybe<MerchantBoolExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  notification_type?: InputMaybe<NotificationTypeBoolExp>;
  notification_type_id?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "merchant_notification" */
export enum MerchantNotificationConstraint {
  /** unique or primary key constraint on columns "id" */
  MerchantNotificationPkey = 'merchant_notification_pkey'
}

/** input type for incrementing numeric columns in table "merchant_notification" */
export type MerchantNotificationIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "merchant_notification" */
export type MerchantNotificationInsertInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  merchant?: InputMaybe<MerchantObjRelInsertInput>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  notification_type?: InputMaybe<NotificationTypeObjRelInsertInput>;
  notification_type_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type MerchantNotificationMaxFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  merchant_id?: Maybe<Scalars['Int']>;
  notification_type_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type MerchantNotificationMinFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  merchant_id?: Maybe<Scalars['Int']>;
  notification_type_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "merchant_notification" */
export type MerchantNotificationMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MerchantNotification>;
};

/** on_conflict condition type for table "merchant_notification" */
export type MerchantNotificationOnConflict = {
  constraint: MerchantNotificationConstraint;
  update_columns?: Array<MerchantNotificationUpdateColumn>;
  where?: InputMaybe<MerchantNotificationBoolExp>;
};

/** Ordering options when selecting data from "merchant_notification". */
export type MerchantNotificationOrderBy = {
  active?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant?: InputMaybe<MerchantOrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  notification_type?: InputMaybe<NotificationTypeOrderBy>;
  notification_type_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: merchant_notification */
export type MerchantNotificationPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "merchant_notification" */
export enum MerchantNotificationSelectColumn {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  NotificationTypeId = 'notification_type_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "merchant_notification" */
export type MerchantNotificationSetInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  notification_type_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type MerchantNotificationStddevFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type MerchantNotificationStddevPopFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type MerchantNotificationStddevSampFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type MerchantNotificationSumFields = {
  id?: Maybe<Scalars['Int']>;
  merchant_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "merchant_notification" */
export enum MerchantNotificationUpdateColumn {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  NotificationTypeId = 'notification_type_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type MerchantNotificationUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MerchantNotificationIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MerchantNotificationSetInput>;
  where: MerchantNotificationBoolExp;
};

/** aggregate var_pop on columns */
export type MerchantNotificationVarPopFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type MerchantNotificationVarSampFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type MerchantNotificationVarianceFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** input type for inserting object relation for remote table "merchant" */
export type MerchantObjRelInsertInput = {
  data: MerchantInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<MerchantOnConflict>;
};

/** on_conflict condition type for table "merchant" */
export type MerchantOnConflict = {
  constraint: MerchantConstraint;
  update_columns?: Array<MerchantUpdateColumn>;
  where?: InputMaybe<MerchantBoolExp>;
};

/** Ordering options when selecting data from "merchant". */
export type MerchantOrderBy = {
  api_token?: InputMaybe<OrderBy>;
  balance?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  current_provider_id?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  gate_groups_aggregate?: InputMaybe<GateGroupAggregateOrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_callback_url?: InputMaybe<OrderBy>;
  invoice_enabled?: InputMaybe<OrderBy>;
  invoice_fee_percent?: InputMaybe<OrderBy>;
  invoice_h2h_enabled?: InputMaybe<OrderBy>;
  invoice_qiwi_enabled?: InputMaybe<OrderBy>;
  invoice_s2p_enabled?: InputMaybe<OrderBy>;
  invoices_aggregate?: InputMaybe<InvoiceAggregateOrderBy>;
  mass_withdraw_enabled?: InputMaybe<OrderBy>;
  merchant_balances_aggregate?: InputMaybe<MerchantBalanceAggregateOrderBy>;
  merchant_currencies_aggregate?: InputMaybe<MerchantCurrencyAggregateOrderBy>;
  merchant_fees_aggregate?: InputMaybe<MerchantFeeAggregateOrderBy>;
  merchant_info?: InputMaybe<MerchantInfoOrderBy>;
  merchant_status_id?: InputMaybe<OrderBy>;
  merchant_type_id?: InputMaybe<OrderBy>;
  merchant_users_aggregate?: InputMaybe<MerchantUserAggregateOrderBy>;
  merchant_widgets_aggregate?: InputMaybe<MerchantWidgetAggregateOrderBy>;
  permissions_aggregate?: InputMaybe<VHasuraPermissionAggregateOrderBy>;
  provider?: InputMaybe<ProviderOrderBy>;
  qiwi_mass_withdraw_enabled?: InputMaybe<OrderBy>;
  redirect_failed_url?: InputMaybe<OrderBy>;
  redirect_success_url?: InputMaybe<OrderBy>;
  refund_enabled?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  s2p_withdraw_enabled?: InputMaybe<OrderBy>;
  secret_key?: InputMaybe<OrderBy>;
  telegram_notification_chat_id?: InputMaybe<OrderBy>;
  telegram_notification_enabled?: InputMaybe<OrderBy>;
  transaction_histories_aggregate?: InputMaybe<TransactionHistoryAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  withdraw_callback_url?: InputMaybe<OrderBy>;
  withdraw_enabled?: InputMaybe<OrderBy>;
  withdraw_fee_percent?: InputMaybe<OrderBy>;
  withdraw_requests_aggregate?: InputMaybe<WithdrawRequestAggregateOrderBy>;
  withdraws_aggregate?: InputMaybe<WithdrawAggregateOrderBy>;
};

/** primary key columns input for table: merchant */
export type MerchantPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "merchant" */
export enum MerchantSelectColumn {
  /** column name */
  ApiToken = 'api_token',
  /** column name */
  Balance = 'balance',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentProviderId = 'current_provider_id',
  /** column name */
  EditUserId = 'edit_user_id',
  /** column name */
  HoldBalance = 'hold_balance',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceCallbackUrl = 'invoice_callback_url',
  /** column name */
  InvoiceEnabled = 'invoice_enabled',
  /** column name */
  InvoiceFeePercent = 'invoice_fee_percent',
  /** column name */
  InvoiceH2hEnabled = 'invoice_h2h_enabled',
  /** column name */
  InvoiceQiwiEnabled = 'invoice_qiwi_enabled',
  /** column name */
  InvoiceS2pEnabled = 'invoice_s2p_enabled',
  /** column name */
  MassWithdrawEnabled = 'mass_withdraw_enabled',
  /** column name */
  MerchantStatusId = 'merchant_status_id',
  /** column name */
  MerchantTypeId = 'merchant_type_id',
  /** column name */
  QiwiMassWithdrawEnabled = 'qiwi_mass_withdraw_enabled',
  /** column name */
  RedirectFailedUrl = 'redirect_failed_url',
  /** column name */
  RedirectSuccessUrl = 'redirect_success_url',
  /** column name */
  RefundEnabled = 'refund_enabled',
  /** column name */
  RollingReserveDuration = 'rolling_reserve_duration',
  /** column name */
  RollingReservePercent = 'rolling_reserve_percent',
  /** column name */
  S2pWithdrawEnabled = 's2p_withdraw_enabled',
  /** column name */
  SecretKey = 'secret_key',
  /** column name */
  TelegramNotificationChatId = 'telegram_notification_chat_id',
  /** column name */
  TelegramNotificationEnabled = 'telegram_notification_enabled',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WithdrawCallbackUrl = 'withdraw_callback_url',
  /** column name */
  WithdrawEnabled = 'withdraw_enabled',
  /** column name */
  WithdrawFeePercent = 'withdraw_fee_percent'
}

/** input type for updating data in table "merchant" */
export type MerchantSetInput = {
  api_token?: InputMaybe<Scalars['String']>;
  balance?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  current_provider_id?: InputMaybe<Scalars['String']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  hold_balance?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  invoice_callback_url?: InputMaybe<Scalars['String']>;
  invoice_enabled?: InputMaybe<Scalars['Boolean']>;
  invoice_fee_percent?: InputMaybe<Scalars['numeric']>;
  invoice_h2h_enabled?: InputMaybe<Scalars['Boolean']>;
  invoice_qiwi_enabled?: InputMaybe<Scalars['Boolean']>;
  invoice_s2p_enabled?: InputMaybe<Scalars['Boolean']>;
  mass_withdraw_enabled?: InputMaybe<Scalars['Boolean']>;
  merchant_status_id?: InputMaybe<Scalars['String']>;
  merchant_type_id?: InputMaybe<Scalars['String']>;
  qiwi_mass_withdraw_enabled?: InputMaybe<Scalars['Boolean']>;
  redirect_failed_url?: InputMaybe<Scalars['String']>;
  redirect_success_url?: InputMaybe<Scalars['String']>;
  refund_enabled?: InputMaybe<Scalars['Boolean']>;
  rolling_reserve_duration?: InputMaybe<Scalars['Int']>;
  rolling_reserve_percent?: InputMaybe<Scalars['numeric']>;
  s2p_withdraw_enabled?: InputMaybe<Scalars['Boolean']>;
  secret_key?: InputMaybe<Scalars['String']>;
  telegram_notification_chat_id?: InputMaybe<Scalars['String']>;
  telegram_notification_enabled?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  withdraw_callback_url?: InputMaybe<Scalars['String']>;
  withdraw_enabled?: InputMaybe<Scalars['Boolean']>;
  withdraw_fee_percent?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type MerchantStddevFields = {
  balance?: Maybe<Scalars['Float']>;
  edit_user_id?: Maybe<Scalars['Float']>;
  hold_balance?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_fee_percent?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  withdraw_fee_percent?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "merchant" */
export type MerchantStddevOrderBy = {
  balance?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_fee_percent?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  withdraw_fee_percent?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type MerchantStddevPopFields = {
  balance?: Maybe<Scalars['Float']>;
  edit_user_id?: Maybe<Scalars['Float']>;
  hold_balance?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_fee_percent?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  withdraw_fee_percent?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "merchant" */
export type MerchantStddevPopOrderBy = {
  balance?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_fee_percent?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  withdraw_fee_percent?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type MerchantStddevSampFields = {
  balance?: Maybe<Scalars['Float']>;
  edit_user_id?: Maybe<Scalars['Float']>;
  hold_balance?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_fee_percent?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  withdraw_fee_percent?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "merchant" */
export type MerchantStddevSampOrderBy = {
  balance?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_fee_percent?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  withdraw_fee_percent?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type MerchantSumFields = {
  balance?: Maybe<Scalars['numeric']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  hold_balance?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  invoice_fee_percent?: Maybe<Scalars['numeric']>;
  rolling_reserve_duration?: Maybe<Scalars['Int']>;
  rolling_reserve_percent?: Maybe<Scalars['numeric']>;
  withdraw_fee_percent?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "merchant" */
export type MerchantSumOrderBy = {
  balance?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_fee_percent?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  withdraw_fee_percent?: InputMaybe<OrderBy>;
};

/** columns and relationships of "merchant_task" */
export type MerchantTask = {
  created_at: Scalars['timestamptz'];
  delivered_at?: Maybe<Scalars['timestamptz']>;
  error?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  merchant_id: Scalars['Int'];
  /** An object relationship */
  merchant_task_status: MerchantTaskStatus;
  merchant_task_status_id: Scalars['String'];
  /** An object relationship */
  merchant_task_type: MerchantTaskType;
  merchant_task_type_id: Scalars['String'];
  payload?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  permissions: Array<VHasuraPermission>;
  /** An aggregate relationship */
  permissions_aggregate: VHasuraPermissionAggregate;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "merchant_task" */
export type MerchantTaskErrorArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "merchant_task" */
export type MerchantTaskPayloadArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "merchant_task" */
export type MerchantTaskPermissionsArgs = {
  distinct_on?: InputMaybe<Array<VHasuraPermissionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VHasuraPermissionOrderBy>>;
  where?: InputMaybe<VHasuraPermissionBoolExp>;
};


/** columns and relationships of "merchant_task" */
export type MerchantTaskPermissionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<VHasuraPermissionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VHasuraPermissionOrderBy>>;
  where?: InputMaybe<VHasuraPermissionBoolExp>;
};

/** aggregated selection of "merchant_task" */
export type MerchantTaskAggregate = {
  aggregate?: Maybe<MerchantTaskAggregateFields>;
  nodes: Array<MerchantTask>;
};

/** aggregate fields of "merchant_task" */
export type MerchantTaskAggregateFields = {
  avg?: Maybe<MerchantTaskAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MerchantTaskMaxFields>;
  min?: Maybe<MerchantTaskMinFields>;
  stddev?: Maybe<MerchantTaskStddevFields>;
  stddev_pop?: Maybe<MerchantTaskStddevPopFields>;
  stddev_samp?: Maybe<MerchantTaskStddevSampFields>;
  sum?: Maybe<MerchantTaskSumFields>;
  var_pop?: Maybe<MerchantTaskVarPopFields>;
  var_samp?: Maybe<MerchantTaskVarSampFields>;
  variance?: Maybe<MerchantTaskVarianceFields>;
};


/** aggregate fields of "merchant_task" */
export type MerchantTaskAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MerchantTaskSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type MerchantTaskAppendInput = {
  error?: InputMaybe<Scalars['jsonb']>;
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type MerchantTaskAvgFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "merchant_task". All fields are combined with a logical 'AND'. */
export type MerchantTaskBoolExp = {
  _and?: InputMaybe<Array<MerchantTaskBoolExp>>;
  _not?: InputMaybe<MerchantTaskBoolExp>;
  _or?: InputMaybe<Array<MerchantTaskBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  delivered_at?: InputMaybe<TimestamptzComparisonExp>;
  error?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  merchant_task_status?: InputMaybe<MerchantTaskStatusBoolExp>;
  merchant_task_status_id?: InputMaybe<StringComparisonExp>;
  merchant_task_type?: InputMaybe<MerchantTaskTypeBoolExp>;
  merchant_task_type_id?: InputMaybe<StringComparisonExp>;
  payload?: InputMaybe<JsonbComparisonExp>;
  permissions?: InputMaybe<VHasuraPermissionBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "merchant_task" */
export enum MerchantTaskConstraint {
  /** unique or primary key constraint on columns "id" */
  MerchantTaskPkey = 'merchant_task_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type MerchantTaskDeleteAtPathInput = {
  error?: InputMaybe<Array<Scalars['String']>>;
  payload?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type MerchantTaskDeleteElemInput = {
  error?: InputMaybe<Scalars['Int']>;
  payload?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type MerchantTaskDeleteKeyInput = {
  error?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "merchant_task" */
export type MerchantTaskIncInput = {
  merchant_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "merchant_task" */
export type MerchantTaskInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  delivered_at?: InputMaybe<Scalars['timestamptz']>;
  error?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_task_status?: InputMaybe<MerchantTaskStatusObjRelInsertInput>;
  merchant_task_status_id?: InputMaybe<Scalars['String']>;
  merchant_task_type?: InputMaybe<MerchantTaskTypeObjRelInsertInput>;
  merchant_task_type_id?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  permissions?: InputMaybe<VHasuraPermissionArrRelInsertInput>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type MerchantTaskMaxFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  delivered_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_task_status_id?: Maybe<Scalars['String']>;
  merchant_task_type_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type MerchantTaskMinFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  delivered_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_task_status_id?: Maybe<Scalars['String']>;
  merchant_task_type_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "merchant_task" */
export type MerchantTaskMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MerchantTask>;
};

/** input type for inserting object relation for remote table "merchant_task" */
export type MerchantTaskObjRelInsertInput = {
  data: MerchantTaskInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<MerchantTaskOnConflict>;
};

/** on_conflict condition type for table "merchant_task" */
export type MerchantTaskOnConflict = {
  constraint: MerchantTaskConstraint;
  update_columns?: Array<MerchantTaskUpdateColumn>;
  where?: InputMaybe<MerchantTaskBoolExp>;
};

/** Ordering options when selecting data from "merchant_task". */
export type MerchantTaskOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  delivered_at?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_task_status?: InputMaybe<MerchantTaskStatusOrderBy>;
  merchant_task_status_id?: InputMaybe<OrderBy>;
  merchant_task_type?: InputMaybe<MerchantTaskTypeOrderBy>;
  merchant_task_type_id?: InputMaybe<OrderBy>;
  payload?: InputMaybe<OrderBy>;
  permissions_aggregate?: InputMaybe<VHasuraPermissionAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: merchant_task */
export type MerchantTaskPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type MerchantTaskPrependInput = {
  error?: InputMaybe<Scalars['jsonb']>;
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "merchant_task" */
export enum MerchantTaskSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeliveredAt = 'delivered_at',
  /** column name */
  Error = 'error',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MerchantTaskStatusId = 'merchant_task_status_id',
  /** column name */
  MerchantTaskTypeId = 'merchant_task_type_id',
  /** column name */
  Payload = 'payload',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "merchant_task" */
export type MerchantTaskSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  delivered_at?: InputMaybe<Scalars['timestamptz']>;
  error?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_task_status_id?: InputMaybe<Scalars['String']>;
  merchant_task_type_id?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "merchant_task_status" */
export type MerchantTaskStatus = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "merchant_task_status" */
export type MerchantTaskStatusAggregate = {
  aggregate?: Maybe<MerchantTaskStatusAggregateFields>;
  nodes: Array<MerchantTaskStatus>;
};

/** aggregate fields of "merchant_task_status" */
export type MerchantTaskStatusAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<MerchantTaskStatusMaxFields>;
  min?: Maybe<MerchantTaskStatusMinFields>;
};


/** aggregate fields of "merchant_task_status" */
export type MerchantTaskStatusAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MerchantTaskStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "merchant_task_status". All fields are combined with a logical 'AND'. */
export type MerchantTaskStatusBoolExp = {
  _and?: InputMaybe<Array<MerchantTaskStatusBoolExp>>;
  _not?: InputMaybe<MerchantTaskStatusBoolExp>;
  _or?: InputMaybe<Array<MerchantTaskStatusBoolExp>>;
  id?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "merchant_task_status" */
export enum MerchantTaskStatusConstraint {
  /** unique or primary key constraint on columns "id" */
  MerchantTaskStatusPkey = 'merchant_task_status_pkey'
}

/** input type for inserting data into table "merchant_task_status" */
export type MerchantTaskStatusInsertInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type MerchantTaskStatusMaxFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type MerchantTaskStatusMinFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "merchant_task_status" */
export type MerchantTaskStatusMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MerchantTaskStatus>;
};

/** input type for inserting object relation for remote table "merchant_task_status" */
export type MerchantTaskStatusObjRelInsertInput = {
  data: MerchantTaskStatusInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<MerchantTaskStatusOnConflict>;
};

/** on_conflict condition type for table "merchant_task_status" */
export type MerchantTaskStatusOnConflict = {
  constraint: MerchantTaskStatusConstraint;
  update_columns?: Array<MerchantTaskStatusUpdateColumn>;
  where?: InputMaybe<MerchantTaskStatusBoolExp>;
};

/** Ordering options when selecting data from "merchant_task_status". */
export type MerchantTaskStatusOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: merchant_task_status */
export type MerchantTaskStatusPkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "merchant_task_status" */
export enum MerchantTaskStatusSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "merchant_task_status" */
export type MerchantTaskStatusSetInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "merchant_task_status" */
export enum MerchantTaskStatusUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type MerchantTaskStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MerchantTaskStatusSetInput>;
  where: MerchantTaskStatusBoolExp;
};

/** aggregate stddev on columns */
export type MerchantTaskStddevFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type MerchantTaskStddevPopFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type MerchantTaskStddevSampFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type MerchantTaskSumFields = {
  merchant_id?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "merchant_task_type" */
export type MerchantTaskType = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "merchant_task_type" */
export type MerchantTaskTypeAggregate = {
  aggregate?: Maybe<MerchantTaskTypeAggregateFields>;
  nodes: Array<MerchantTaskType>;
};

/** aggregate fields of "merchant_task_type" */
export type MerchantTaskTypeAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<MerchantTaskTypeMaxFields>;
  min?: Maybe<MerchantTaskTypeMinFields>;
};


/** aggregate fields of "merchant_task_type" */
export type MerchantTaskTypeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MerchantTaskTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "merchant_task_type". All fields are combined with a logical 'AND'. */
export type MerchantTaskTypeBoolExp = {
  _and?: InputMaybe<Array<MerchantTaskTypeBoolExp>>;
  _not?: InputMaybe<MerchantTaskTypeBoolExp>;
  _or?: InputMaybe<Array<MerchantTaskTypeBoolExp>>;
  id?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "merchant_task_type" */
export enum MerchantTaskTypeConstraint {
  /** unique or primary key constraint on columns "id" */
  MerchantTaskTypePkey = 'merchant_task_type_pkey'
}

/** input type for inserting data into table "merchant_task_type" */
export type MerchantTaskTypeInsertInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type MerchantTaskTypeMaxFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type MerchantTaskTypeMinFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "merchant_task_type" */
export type MerchantTaskTypeMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MerchantTaskType>;
};

/** input type for inserting object relation for remote table "merchant_task_type" */
export type MerchantTaskTypeObjRelInsertInput = {
  data: MerchantTaskTypeInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<MerchantTaskTypeOnConflict>;
};

/** on_conflict condition type for table "merchant_task_type" */
export type MerchantTaskTypeOnConflict = {
  constraint: MerchantTaskTypeConstraint;
  update_columns?: Array<MerchantTaskTypeUpdateColumn>;
  where?: InputMaybe<MerchantTaskTypeBoolExp>;
};

/** Ordering options when selecting data from "merchant_task_type". */
export type MerchantTaskTypeOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: merchant_task_type */
export type MerchantTaskTypePkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "merchant_task_type" */
export enum MerchantTaskTypeSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "merchant_task_type" */
export type MerchantTaskTypeSetInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "merchant_task_type" */
export enum MerchantTaskTypeUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type MerchantTaskTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MerchantTaskTypeSetInput>;
  where: MerchantTaskTypeBoolExp;
};

/** update columns of table "merchant_task" */
export enum MerchantTaskUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeliveredAt = 'delivered_at',
  /** column name */
  Error = 'error',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MerchantTaskStatusId = 'merchant_task_status_id',
  /** column name */
  MerchantTaskTypeId = 'merchant_task_type_id',
  /** column name */
  Payload = 'payload',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type MerchantTaskUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<MerchantTaskAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<MerchantTaskDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<MerchantTaskDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<MerchantTaskDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MerchantTaskIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<MerchantTaskPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MerchantTaskSetInput>;
  where: MerchantTaskBoolExp;
};

/** aggregate var_pop on columns */
export type MerchantTaskVarPopFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type MerchantTaskVarSampFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type MerchantTaskVarianceFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "merchant_type" */
export type MerchantType = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "merchant_type" */
export type MerchantTypeAggregate = {
  aggregate?: Maybe<MerchantTypeAggregateFields>;
  nodes: Array<MerchantType>;
};

/** aggregate fields of "merchant_type" */
export type MerchantTypeAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<MerchantTypeMaxFields>;
  min?: Maybe<MerchantTypeMinFields>;
};


/** aggregate fields of "merchant_type" */
export type MerchantTypeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MerchantTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "merchant_type". All fields are combined with a logical 'AND'. */
export type MerchantTypeBoolExp = {
  _and?: InputMaybe<Array<MerchantTypeBoolExp>>;
  _not?: InputMaybe<MerchantTypeBoolExp>;
  _or?: InputMaybe<Array<MerchantTypeBoolExp>>;
  id?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "merchant_type" */
export enum MerchantTypeConstraint {
  /** unique or primary key constraint on columns "id" */
  MerchantTypePkey = 'merchant_type_pkey'
}

/** input type for inserting data into table "merchant_type" */
export type MerchantTypeInsertInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type MerchantTypeMaxFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type MerchantTypeMinFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "merchant_type" */
export type MerchantTypeMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MerchantType>;
};

/** on_conflict condition type for table "merchant_type" */
export type MerchantTypeOnConflict = {
  constraint: MerchantTypeConstraint;
  update_columns?: Array<MerchantTypeUpdateColumn>;
  where?: InputMaybe<MerchantTypeBoolExp>;
};

/** Ordering options when selecting data from "merchant_type". */
export type MerchantTypeOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: merchant_type */
export type MerchantTypePkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "merchant_type" */
export enum MerchantTypeSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "merchant_type" */
export type MerchantTypeSetInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "merchant_type" */
export enum MerchantTypeUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type MerchantTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MerchantTypeSetInput>;
  where: MerchantTypeBoolExp;
};

/** update columns of table "merchant" */
export enum MerchantUpdateColumn {
  /** column name */
  ApiToken = 'api_token',
  /** column name */
  Balance = 'balance',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentProviderId = 'current_provider_id',
  /** column name */
  EditUserId = 'edit_user_id',
  /** column name */
  HoldBalance = 'hold_balance',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceCallbackUrl = 'invoice_callback_url',
  /** column name */
  InvoiceEnabled = 'invoice_enabled',
  /** column name */
  InvoiceFeePercent = 'invoice_fee_percent',
  /** column name */
  InvoiceH2hEnabled = 'invoice_h2h_enabled',
  /** column name */
  InvoiceQiwiEnabled = 'invoice_qiwi_enabled',
  /** column name */
  InvoiceS2pEnabled = 'invoice_s2p_enabled',
  /** column name */
  MassWithdrawEnabled = 'mass_withdraw_enabled',
  /** column name */
  MerchantStatusId = 'merchant_status_id',
  /** column name */
  MerchantTypeId = 'merchant_type_id',
  /** column name */
  QiwiMassWithdrawEnabled = 'qiwi_mass_withdraw_enabled',
  /** column name */
  RedirectFailedUrl = 'redirect_failed_url',
  /** column name */
  RedirectSuccessUrl = 'redirect_success_url',
  /** column name */
  RefundEnabled = 'refund_enabled',
  /** column name */
  RollingReserveDuration = 'rolling_reserve_duration',
  /** column name */
  RollingReservePercent = 'rolling_reserve_percent',
  /** column name */
  S2pWithdrawEnabled = 's2p_withdraw_enabled',
  /** column name */
  SecretKey = 'secret_key',
  /** column name */
  TelegramNotificationChatId = 'telegram_notification_chat_id',
  /** column name */
  TelegramNotificationEnabled = 'telegram_notification_enabled',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WithdrawCallbackUrl = 'withdraw_callback_url',
  /** column name */
  WithdrawEnabled = 'withdraw_enabled',
  /** column name */
  WithdrawFeePercent = 'withdraw_fee_percent'
}

export type MerchantUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MerchantIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MerchantSetInput>;
  where: MerchantBoolExp;
};

/** columns and relationships of "merchant_user" */
export type MerchantUser = {
  created_at: Scalars['timestamptz'];
  edit_user_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  /** An object relationship */
  merchant?: Maybe<Merchant>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_user_role_id: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "merchant_user" */
export type MerchantUserAggregate = {
  aggregate?: Maybe<MerchantUserAggregateFields>;
  nodes: Array<MerchantUser>;
};

/** aggregate fields of "merchant_user" */
export type MerchantUserAggregateFields = {
  avg?: Maybe<MerchantUserAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MerchantUserMaxFields>;
  min?: Maybe<MerchantUserMinFields>;
  stddev?: Maybe<MerchantUserStddevFields>;
  stddev_pop?: Maybe<MerchantUserStddevPopFields>;
  stddev_samp?: Maybe<MerchantUserStddevSampFields>;
  sum?: Maybe<MerchantUserSumFields>;
  var_pop?: Maybe<MerchantUserVarPopFields>;
  var_samp?: Maybe<MerchantUserVarSampFields>;
  variance?: Maybe<MerchantUserVarianceFields>;
};


/** aggregate fields of "merchant_user" */
export type MerchantUserAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MerchantUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "merchant_user" */
export type MerchantUserAggregateOrderBy = {
  avg?: InputMaybe<MerchantUserAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MerchantUserMaxOrderBy>;
  min?: InputMaybe<MerchantUserMinOrderBy>;
  stddev?: InputMaybe<MerchantUserStddevOrderBy>;
  stddev_pop?: InputMaybe<MerchantUserStddevPopOrderBy>;
  stddev_samp?: InputMaybe<MerchantUserStddevSampOrderBy>;
  sum?: InputMaybe<MerchantUserSumOrderBy>;
  var_pop?: InputMaybe<MerchantUserVarPopOrderBy>;
  var_samp?: InputMaybe<MerchantUserVarSampOrderBy>;
  variance?: InputMaybe<MerchantUserVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "merchant_user" */
export type MerchantUserArrRelInsertInput = {
  data: Array<MerchantUserInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<MerchantUserOnConflict>;
};

/** aggregate avg on columns */
export type MerchantUserAvgFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "merchant_user" */
export type MerchantUserAvgOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "merchant_user". All fields are combined with a logical 'AND'. */
export type MerchantUserBoolExp = {
  _and?: InputMaybe<Array<MerchantUserBoolExp>>;
  _not?: InputMaybe<MerchantUserBoolExp>;
  _or?: InputMaybe<Array<MerchantUserBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  edit_user_id?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  merchant?: InputMaybe<MerchantBoolExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  merchant_user_role_id?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UserBoolExp>;
  user_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "merchant_user" */
export enum MerchantUserConstraint {
  /** unique or primary key constraint on columns "id" */
  MerchantUserPkey = 'merchant_user_pkey',
  /** unique or primary key constraint on columns "user_id" */
  UserIdKey = 'user_id_key'
}

/** input type for incrementing numeric columns in table "merchant_user" */
export type MerchantUserIncInput = {
  edit_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "merchant_user" */
export type MerchantUserInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  merchant?: InputMaybe<MerchantObjRelInsertInput>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_user_role_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UserObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type MerchantUserMaxFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_user_role_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "merchant_user" */
export type MerchantUserMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_user_role_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MerchantUserMinFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_user_role_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "merchant_user" */
export type MerchantUserMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_user_role_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "merchant_user" */
export type MerchantUserMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MerchantUser>;
};

/** input type for inserting object relation for remote table "merchant_user" */
export type MerchantUserObjRelInsertInput = {
  data: MerchantUserInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<MerchantUserOnConflict>;
};

/** on_conflict condition type for table "merchant_user" */
export type MerchantUserOnConflict = {
  constraint: MerchantUserConstraint;
  update_columns?: Array<MerchantUserUpdateColumn>;
  where?: InputMaybe<MerchantUserBoolExp>;
};

/** Ordering options when selecting data from "merchant_user". */
export type MerchantUserOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant?: InputMaybe<MerchantOrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_user_role_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user?: InputMaybe<UserOrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: merchant_user */
export type MerchantUserPkColumnsInput = {
  id: Scalars['Int'];
};

/** columns and relationships of "merchant_user_role" */
export type MerchantUserRole = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "merchant_user_role" */
export type MerchantUserRoleAggregate = {
  aggregate?: Maybe<MerchantUserRoleAggregateFields>;
  nodes: Array<MerchantUserRole>;
};

/** aggregate fields of "merchant_user_role" */
export type MerchantUserRoleAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<MerchantUserRoleMaxFields>;
  min?: Maybe<MerchantUserRoleMinFields>;
};


/** aggregate fields of "merchant_user_role" */
export type MerchantUserRoleAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MerchantUserRoleSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "merchant_user_role". All fields are combined with a logical 'AND'. */
export type MerchantUserRoleBoolExp = {
  _and?: InputMaybe<Array<MerchantUserRoleBoolExp>>;
  _not?: InputMaybe<MerchantUserRoleBoolExp>;
  _or?: InputMaybe<Array<MerchantUserRoleBoolExp>>;
  id?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "merchant_user_role" */
export enum MerchantUserRoleConstraint {
  /** unique or primary key constraint on columns "id" */
  MerchantUserRolePkey = 'merchant_user_role_pkey'
}

/** input type for inserting data into table "merchant_user_role" */
export type MerchantUserRoleInsertInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type MerchantUserRoleMaxFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type MerchantUserRoleMinFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "merchant_user_role" */
export type MerchantUserRoleMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MerchantUserRole>;
};

/** on_conflict condition type for table "merchant_user_role" */
export type MerchantUserRoleOnConflict = {
  constraint: MerchantUserRoleConstraint;
  update_columns?: Array<MerchantUserRoleUpdateColumn>;
  where?: InputMaybe<MerchantUserRoleBoolExp>;
};

/** Ordering options when selecting data from "merchant_user_role". */
export type MerchantUserRoleOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: merchant_user_role */
export type MerchantUserRolePkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "merchant_user_role" */
export enum MerchantUserRoleSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "merchant_user_role" */
export type MerchantUserRoleSetInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "merchant_user_role" */
export enum MerchantUserRoleUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type MerchantUserRoleUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MerchantUserRoleSetInput>;
  where: MerchantUserRoleBoolExp;
};

/** select columns of table "merchant_user" */
export enum MerchantUserSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EditUserId = 'edit_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MerchantUserRoleId = 'merchant_user_role_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "merchant_user" */
export type MerchantUserSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_user_role_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type MerchantUserStddevFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "merchant_user" */
export type MerchantUserStddevOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type MerchantUserStddevPopFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "merchant_user" */
export type MerchantUserStddevPopOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type MerchantUserStddevSampFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "merchant_user" */
export type MerchantUserStddevSampOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type MerchantUserSumFields = {
  edit_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  merchant_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "merchant_user" */
export type MerchantUserSumOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** update columns of table "merchant_user" */
export enum MerchantUserUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EditUserId = 'edit_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MerchantUserRoleId = 'merchant_user_role_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type MerchantUserUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MerchantUserIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MerchantUserSetInput>;
  where: MerchantUserBoolExp;
};

/** aggregate var_pop on columns */
export type MerchantUserVarPopFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "merchant_user" */
export type MerchantUserVarPopOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type MerchantUserVarSampFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "merchant_user" */
export type MerchantUserVarSampOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type MerchantUserVarianceFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "merchant_user" */
export type MerchantUserVarianceOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type MerchantVarPopFields = {
  balance?: Maybe<Scalars['Float']>;
  edit_user_id?: Maybe<Scalars['Float']>;
  hold_balance?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_fee_percent?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  withdraw_fee_percent?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "merchant" */
export type MerchantVarPopOrderBy = {
  balance?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_fee_percent?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  withdraw_fee_percent?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type MerchantVarSampFields = {
  balance?: Maybe<Scalars['Float']>;
  edit_user_id?: Maybe<Scalars['Float']>;
  hold_balance?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_fee_percent?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  withdraw_fee_percent?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "merchant" */
export type MerchantVarSampOrderBy = {
  balance?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_fee_percent?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  withdraw_fee_percent?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type MerchantVarianceFields = {
  balance?: Maybe<Scalars['Float']>;
  edit_user_id?: Maybe<Scalars['Float']>;
  hold_balance?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_fee_percent?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  withdraw_fee_percent?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "merchant" */
export type MerchantVarianceOrderBy = {
  balance?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_fee_percent?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  withdraw_fee_percent?: InputMaybe<OrderBy>;
};

/** columns and relationships of "merchant_widget" */
export type MerchantWidget = {
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  merchant?: Maybe<Merchant>;
  merchant_id?: Maybe<Scalars['Int']>;
  params: Scalars['jsonb'];
  sort?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  widgetTypeByWidgetType?: Maybe<WidgetType>;
  widget_type?: Maybe<Scalars['String']>;
};


/** columns and relationships of "merchant_widget" */
export type MerchantWidgetParamsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "merchant_widget" */
export type MerchantWidgetAggregate = {
  aggregate?: Maybe<MerchantWidgetAggregateFields>;
  nodes: Array<MerchantWidget>;
};

/** aggregate fields of "merchant_widget" */
export type MerchantWidgetAggregateFields = {
  avg?: Maybe<MerchantWidgetAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MerchantWidgetMaxFields>;
  min?: Maybe<MerchantWidgetMinFields>;
  stddev?: Maybe<MerchantWidgetStddevFields>;
  stddev_pop?: Maybe<MerchantWidgetStddevPopFields>;
  stddev_samp?: Maybe<MerchantWidgetStddevSampFields>;
  sum?: Maybe<MerchantWidgetSumFields>;
  var_pop?: Maybe<MerchantWidgetVarPopFields>;
  var_samp?: Maybe<MerchantWidgetVarSampFields>;
  variance?: Maybe<MerchantWidgetVarianceFields>;
};


/** aggregate fields of "merchant_widget" */
export type MerchantWidgetAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MerchantWidgetSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "merchant_widget" */
export type MerchantWidgetAggregateOrderBy = {
  avg?: InputMaybe<MerchantWidgetAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MerchantWidgetMaxOrderBy>;
  min?: InputMaybe<MerchantWidgetMinOrderBy>;
  stddev?: InputMaybe<MerchantWidgetStddevOrderBy>;
  stddev_pop?: InputMaybe<MerchantWidgetStddevPopOrderBy>;
  stddev_samp?: InputMaybe<MerchantWidgetStddevSampOrderBy>;
  sum?: InputMaybe<MerchantWidgetSumOrderBy>;
  var_pop?: InputMaybe<MerchantWidgetVarPopOrderBy>;
  var_samp?: InputMaybe<MerchantWidgetVarSampOrderBy>;
  variance?: InputMaybe<MerchantWidgetVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type MerchantWidgetAppendInput = {
  params?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "merchant_widget" */
export type MerchantWidgetArrRelInsertInput = {
  data: Array<MerchantWidgetInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<MerchantWidgetOnConflict>;
};

/** aggregate avg on columns */
export type MerchantWidgetAvgFields = {
  merchant_id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "merchant_widget" */
export type MerchantWidgetAvgOrderBy = {
  merchant_id?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "merchant_widget". All fields are combined with a logical 'AND'. */
export type MerchantWidgetBoolExp = {
  _and?: InputMaybe<Array<MerchantWidgetBoolExp>>;
  _not?: InputMaybe<MerchantWidgetBoolExp>;
  _or?: InputMaybe<Array<MerchantWidgetBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  merchant?: InputMaybe<MerchantBoolExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  params?: InputMaybe<JsonbComparisonExp>;
  sort?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  widgetTypeByWidgetType?: InputMaybe<WidgetTypeBoolExp>;
  widget_type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "merchant_widget" */
export enum MerchantWidgetConstraint {
  /** unique or primary key constraint on columns "id" */
  MerchantWidgetPkey = 'merchant_widget_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type MerchantWidgetDeleteAtPathInput = {
  params?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type MerchantWidgetDeleteElemInput = {
  params?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type MerchantWidgetDeleteKeyInput = {
  params?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "merchant_widget" */
export type MerchantWidgetIncInput = {
  merchant_id?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "merchant_widget" */
export type MerchantWidgetInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  merchant?: InputMaybe<MerchantObjRelInsertInput>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  params?: InputMaybe<Scalars['jsonb']>;
  sort?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  widgetTypeByWidgetType?: InputMaybe<WidgetTypeObjRelInsertInput>;
  widget_type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type MerchantWidgetMaxFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  merchant_id?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  widget_type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "merchant_widget" */
export type MerchantWidgetMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  widget_type?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MerchantWidgetMinFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  merchant_id?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  widget_type?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "merchant_widget" */
export type MerchantWidgetMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  widget_type?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "merchant_widget" */
export type MerchantWidgetMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MerchantWidget>;
};

/** on_conflict condition type for table "merchant_widget" */
export type MerchantWidgetOnConflict = {
  constraint: MerchantWidgetConstraint;
  update_columns?: Array<MerchantWidgetUpdateColumn>;
  where?: InputMaybe<MerchantWidgetBoolExp>;
};

/** Ordering options when selecting data from "merchant_widget". */
export type MerchantWidgetOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant?: InputMaybe<MerchantOrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  params?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  widgetTypeByWidgetType?: InputMaybe<WidgetTypeOrderBy>;
  widget_type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: merchant_widget */
export type MerchantWidgetPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type MerchantWidgetPrependInput = {
  params?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "merchant_widget" */
export enum MerchantWidgetSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  Params = 'params',
  /** column name */
  Sort = 'sort',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WidgetType = 'widget_type'
}

/** input type for updating data in table "merchant_widget" */
export type MerchantWidgetSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  params?: InputMaybe<Scalars['jsonb']>;
  sort?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  widget_type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type MerchantWidgetStddevFields = {
  merchant_id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "merchant_widget" */
export type MerchantWidgetStddevOrderBy = {
  merchant_id?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type MerchantWidgetStddevPopFields = {
  merchant_id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "merchant_widget" */
export type MerchantWidgetStddevPopOrderBy = {
  merchant_id?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type MerchantWidgetStddevSampFields = {
  merchant_id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "merchant_widget" */
export type MerchantWidgetStddevSampOrderBy = {
  merchant_id?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type MerchantWidgetSumFields = {
  merchant_id?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "merchant_widget" */
export type MerchantWidgetSumOrderBy = {
  merchant_id?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
};

/** update columns of table "merchant_widget" */
export enum MerchantWidgetUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  Params = 'params',
  /** column name */
  Sort = 'sort',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WidgetType = 'widget_type'
}

export type MerchantWidgetUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<MerchantWidgetAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<MerchantWidgetDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<MerchantWidgetDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<MerchantWidgetDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MerchantWidgetIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<MerchantWidgetPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MerchantWidgetSetInput>;
  where: MerchantWidgetBoolExp;
};

/** aggregate var_pop on columns */
export type MerchantWidgetVarPopFields = {
  merchant_id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "merchant_widget" */
export type MerchantWidgetVarPopOrderBy = {
  merchant_id?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type MerchantWidgetVarSampFields = {
  merchant_id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "merchant_widget" */
export type MerchantWidgetVarSampOrderBy = {
  merchant_id?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type MerchantWidgetVarianceFields = {
  merchant_id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "merchant_widget" */
export type MerchantWidgetVarianceOrderBy = {
  merchant_id?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
};

/** mutation root */
export type MutationRoot = {
  ampH2hCreate: Scalars['json'];
  ampH2hInvoiceOrderInfo: Scalars['json'];
  ampInternalBalancesSync: Scalars['json'];
  ampInvoiceInfo: Scalars['json'];
  ampSyncInvoiceTransaction: Scalars['json'];
  ampV2Create: Scalars['json'];
  ampV2CreateH2h: Scalars['json'];
  ampV2InvoiceInfo: Scalars['json'];
  anH2HCreate: Scalars['json'];
  anH2HInvoiceInfo?: Maybe<AnH2HInfoOutput>;
  anH2HSyncInvoiceTransaction: Scalars['json'];
  anH2HSyncWithdrawTransaction: Scalars['json'];
  anP2PConfirm: Scalars['Boolean'];
  anP2PCreate: Scalars['json'];
  anpCreateInvoice: Scalars['json'];
  anpInvoiceInfo: Scalars['json'];
  anpSyncInvoiceTransaction: Scalars['json'];
  apH2HCreate?: Maybe<ApH2HCreateOutput>;
  apH2HCreateQiwiInvoice?: Maybe<ApH2HCreateQiwiInvoiceOutput>;
  apH2HInvoiceInfo?: Maybe<ApH2HInfoOutput>;
  apH2HSyncInvoiceTransaction: Scalars['json'];
  apH2HSyncWithdrawTransaction: Scalars['Boolean'];
  apInternalBalancesSync: Scalars['json'];
  authLogin?: Maybe<AuthLoginOutput>;
  authSingTokenByUserId?: Maybe<ResultOutput>;
  b2payTest?: Maybe<ResultOutput>;
  balanceCalculate: Scalars['Boolean'];
  balanceCalculateTotal: Scalars['Boolean'];
  /** balanceHoldCalculate */
  balanceHoldCalculate: Scalars['Boolean'];
  /** balanceHoldCalculateTotal */
  balanceHoldCalculateTotal: Scalars['Boolean'];
  balanceProviderInternalSync: Scalars['Boolean'];
  balanceTotal: Scalars['Boolean'];
  /** blacklistAdd */
  blacklistAdd: Scalars['json'];
  /** blacklistDelete */
  blacklistDelete: Scalars['json'];
  bvSyncWithdrawTransaction: Scalars['json'];
  bvWithdrawOrderInfo: Scalars['json'];
  bzTechSyncInvoiceTransaction: Scalars['json'];
  calculateBalanceToBalanceByMerchant: Scalars['Boolean'];
  calculateHoldBalanceToHoldBalanceByMerchant: Scalars['Boolean'];
  callbackInvoiceManualSend: Scalars['Boolean'];
  callbackWithdrawManualSend: Scalars['Boolean'];
  cascadeCreate: Scalars['Boolean'];
  cascadeDelete: Scalars['Boolean'];
  cascadeUpdate: Scalars['Boolean'];
  chargebackCancel: Scalars['Boolean'];
  chargebackCreate: Scalars['json'];
  chsPublicKeyGet: Scalars['json'];
  chsPublicKeyPut: Scalars['json'];
  chsSyncInvoiceTransaction: Scalars['json'];
  cleanHasuraCronEvents: Scalars['json'];
  cleanHasuraEvents: Scalars['json'];
  contactPaySyncInvoiceToken: Scalars['json'];
  contactPaySyncInvoiceTransaction: Scalars['json'];
  contactPaySyncWithdrawTransaction: Scalars['json'];
  cpH2HCreate?: Maybe<CpH2HCreateOutput>;
  cpH2HInvoiceInfo?: Maybe<CpH2HInfoOutput>;
  /** Создает для пользователя токен */
  createApiToken?: Maybe<CreateApiTokenOutput>;
  /** createNewProviderInFamily */
  createNewProviderInFamily: Scalars['Boolean'];
  /** create-unhold-and-withdraw */
  createUnholdAndWithdraw: Scalars['Boolean'];
  /** credentinalSet */
  credentinalSet: Scalars['Boolean'];
  /** credentinalUpdate */
  credentinalUpdate: Scalars['Boolean'];
  cryptoCheckPassword?: Maybe<ResultOutput>;
  cryptoGenPasswordHash?: Maybe<ResultOutput>;
  /** Переводит заявку на вывод в крипту в статус Cancel */
  cryptoWithdrawRequestCancel: CryptoWithdrawRequestCancelOutput;
  /** Выполняет вычисление деталей выплаты по запросу на вывод криптовалюты */
  cryptoWithdrawRequestComputePayoutDetails: CryptoWithdrawRequestComputePayoutDetailsOutput;
  /** Создает заявку на вывод в крипту */
  cryptoWithdrawRequestCreate: CryptoWithdrawRequestCreateOutput;
  /** Создает заявку на вывод в крипту (Для админов) */
  cryptoWithdrawRequestCreateAdmin: CryptoWithdrawRequestCreateAdminOutput;
  /** Переводит заявку на вывод в крипту в статус In Process */
  cryptoWithdrawRequestInProcess: CryptoWithdrawRequestInProcessOutput;
  /** Переводит заявку на вывод в крипту в статус Payout */
  cryptoWithdrawRequestPayout: CryptoWithdrawRequestPayoutOutput;
  /** Переводит заявку на вывод в крипту в статус Reject */
  cryptoWithdrawRequestReject: CryptoWithdrawRequestRejectOutput;
  csbH2HInvoiceInfo?: Maybe<CsbH2HInfoOutput>;
  /** csbWithdrawInfo */
  csbWithdrawInfo?: Maybe<CsbWithdrawInfoOutput>;
  currencyRateSync: Scalars['json'];
  dcH2HCreateInvoice?: Maybe<DcH2HCreateInvoiceOutput>;
  dcH2HInvoiceInfo?: Maybe<DcH2HInfoOutput>;
  dcH2HInvoiceOrderInfo: Scalars['json'];
  dcH2HWithdrawOrderInfo: Scalars['json'];
  dcInternalBalancesSync: Scalars['json'];
  dcSyncInvoiceTransaction: Scalars['json'];
  dcSyncWithdrawTransaction: Scalars['json'];
  dcWithdrawConfirm: Scalars['json'];
  /** delete data from the table: "audit" */
  delete_audit?: Maybe<AuditMutationResponse>;
  /** delete single row from the table: "audit" */
  delete_audit_by_pk?: Maybe<Audit>;
  /** delete data from the table: "blacklist" */
  delete_blacklist?: Maybe<BlacklistMutationResponse>;
  /** delete single row from the table: "blacklist" */
  delete_blacklist_by_pk?: Maybe<Blacklist>;
  /** delete data from the table: "card_system" */
  delete_card_system?: Maybe<CardSystemMutationResponse>;
  /** delete single row from the table: "card_system" */
  delete_card_system_by_pk?: Maybe<CardSystem>;
  /** delete data from the table: "cascade_item" */
  delete_cascade_item?: Maybe<CascadeItemMutationResponse>;
  /** delete single row from the table: "cascade_item" */
  delete_cascade_item_by_pk?: Maybe<CascadeItem>;
  /** delete data from the table: "cascade_request" */
  delete_cascade_request?: Maybe<CascadeRequestMutationResponse>;
  /** delete single row from the table: "cascade_request" */
  delete_cascade_request_by_pk?: Maybe<CascadeRequest>;
  /** delete data from the table: "cascades" */
  delete_cascades?: Maybe<CascadesMutationResponse>;
  /** delete single row from the table: "cascades" */
  delete_cascades_by_pk?: Maybe<Cascades>;
  /** delete data from the table: "country" */
  delete_country?: Maybe<CountryMutationResponse>;
  /** delete single row from the table: "country" */
  delete_country_by_pk?: Maybe<Country>;
  /** delete data from the table: "country_region" */
  delete_country_region?: Maybe<CountryRegionMutationResponse>;
  /** delete single row from the table: "country_region" */
  delete_country_region_by_pk?: Maybe<CountryRegion>;
  /** delete data from the table: "crypto_currency" */
  delete_crypto_currency?: Maybe<CryptoCurrencyMutationResponse>;
  /** delete single row from the table: "crypto_currency" */
  delete_crypto_currency_by_pk?: Maybe<CryptoCurrency>;
  /** delete data from the table: "crypto_withdraw_request" */
  delete_crypto_withdraw_request?: Maybe<CryptoWithdrawRequestMutationResponse>;
  /** delete single row from the table: "crypto_withdraw_request" */
  delete_crypto_withdraw_request_by_pk?: Maybe<CryptoWithdrawRequest>;
  /** delete data from the table: "crypto_withdraw_request_status" */
  delete_crypto_withdraw_request_status?: Maybe<CryptoWithdrawRequestStatusMutationResponse>;
  /** delete single row from the table: "crypto_withdraw_request_status" */
  delete_crypto_withdraw_request_status_by_pk?: Maybe<CryptoWithdrawRequestStatus>;
  /** delete data from the table: "currency" */
  delete_currency?: Maybe<CurrencyMutationResponse>;
  /** delete single row from the table: "currency" */
  delete_currency_by_pk?: Maybe<Currency>;
  /** delete data from the table: "gate" */
  delete_gate?: Maybe<GateMutationResponse>;
  /** delete single row from the table: "gate" */
  delete_gate_by_pk?: Maybe<Gate>;
  /** delete data from the table: "gate_group" */
  delete_gate_group?: Maybe<GateGroupMutationResponse>;
  /** delete single row from the table: "gate_group" */
  delete_gate_group_by_pk?: Maybe<GateGroup>;
  /** delete data from the table: "gate_type" */
  delete_gate_type?: Maybe<GateTypeMutationResponse>;
  /** delete single row from the table: "gate_type" */
  delete_gate_type_by_pk?: Maybe<GateType>;
  /** delete data from the table: "gender" */
  delete_gender?: Maybe<GenderMutationResponse>;
  /** delete single row from the table: "gender" */
  delete_gender_by_pk?: Maybe<Gender>;
  /** delete data from the table: "help" */
  delete_help?: Maybe<HelpMutationResponse>;
  /** delete single row from the table: "help" */
  delete_help_by_pk?: Maybe<Help>;
  /** delete data from the table: "help_section" */
  delete_help_section?: Maybe<HelpSectionMutationResponse>;
  /** delete single row from the table: "help_section" */
  delete_help_section_by_pk?: Maybe<HelpSection>;
  /** delete data from the table: "invoice" */
  delete_invoice?: Maybe<InvoiceMutationResponse>;
  /** delete single row from the table: "invoice" */
  delete_invoice_by_pk?: Maybe<Invoice>;
  /** delete data from the table: "language" */
  delete_language?: Maybe<LanguageMutationResponse>;
  /** delete single row from the table: "language" */
  delete_language_by_pk?: Maybe<Language>;
  /** delete data from the table: "merchant" */
  delete_merchant?: Maybe<MerchantMutationResponse>;
  /** delete data from the table: "merchant_api_token" */
  delete_merchant_api_token?: Maybe<MerchantApiTokenMutationResponse>;
  /** delete single row from the table: "merchant_api_token" */
  delete_merchant_api_token_by_pk?: Maybe<MerchantApiToken>;
  /** delete data from the table: "merchant_balance" */
  delete_merchant_balance?: Maybe<MerchantBalanceMutationResponse>;
  /** delete single row from the table: "merchant_balance" */
  delete_merchant_balance_by_pk?: Maybe<MerchantBalance>;
  /** delete single row from the table: "merchant" */
  delete_merchant_by_pk?: Maybe<Merchant>;
  /** delete data from the table: "merchant_currency" */
  delete_merchant_currency?: Maybe<MerchantCurrencyMutationResponse>;
  /** delete single row from the table: "merchant_currency" */
  delete_merchant_currency_by_pk?: Maybe<MerchantCurrency>;
  /** delete data from the table: "merchant_fee" */
  delete_merchant_fee?: Maybe<MerchantFeeMutationResponse>;
  /** delete single row from the table: "merchant_fee" */
  delete_merchant_fee_by_pk?: Maybe<MerchantFee>;
  /** delete data from the table: "merchant_file" */
  delete_merchant_file?: Maybe<MerchantFileMutationResponse>;
  /** delete single row from the table: "merchant_file" */
  delete_merchant_file_by_pk?: Maybe<MerchantFile>;
  /** delete data from the table: "merchant_info" */
  delete_merchant_info?: Maybe<MerchantInfoMutationResponse>;
  /** delete single row from the table: "merchant_info" */
  delete_merchant_info_by_pk?: Maybe<MerchantInfo>;
  /** delete data from the table: "merchant_notification" */
  delete_merchant_notification?: Maybe<MerchantNotificationMutationResponse>;
  /** delete single row from the table: "merchant_notification" */
  delete_merchant_notification_by_pk?: Maybe<MerchantNotification>;
  /** delete data from the table: "merchant_task" */
  delete_merchant_task?: Maybe<MerchantTaskMutationResponse>;
  /** delete single row from the table: "merchant_task" */
  delete_merchant_task_by_pk?: Maybe<MerchantTask>;
  /** delete data from the table: "merchant_task_status" */
  delete_merchant_task_status?: Maybe<MerchantTaskStatusMutationResponse>;
  /** delete single row from the table: "merchant_task_status" */
  delete_merchant_task_status_by_pk?: Maybe<MerchantTaskStatus>;
  /** delete data from the table: "merchant_task_type" */
  delete_merchant_task_type?: Maybe<MerchantTaskTypeMutationResponse>;
  /** delete single row from the table: "merchant_task_type" */
  delete_merchant_task_type_by_pk?: Maybe<MerchantTaskType>;
  /** delete data from the table: "merchant_type" */
  delete_merchant_type?: Maybe<MerchantTypeMutationResponse>;
  /** delete single row from the table: "merchant_type" */
  delete_merchant_type_by_pk?: Maybe<MerchantType>;
  /** delete data from the table: "merchant_user" */
  delete_merchant_user?: Maybe<MerchantUserMutationResponse>;
  /** delete single row from the table: "merchant_user" */
  delete_merchant_user_by_pk?: Maybe<MerchantUser>;
  /** delete data from the table: "merchant_user_role" */
  delete_merchant_user_role?: Maybe<MerchantUserRoleMutationResponse>;
  /** delete single row from the table: "merchant_user_role" */
  delete_merchant_user_role_by_pk?: Maybe<MerchantUserRole>;
  /** delete data from the table: "merchant_widget" */
  delete_merchant_widget?: Maybe<MerchantWidgetMutationResponse>;
  /** delete single row from the table: "merchant_widget" */
  delete_merchant_widget_by_pk?: Maybe<MerchantWidget>;
  /** delete data from the table: "mutex" */
  delete_mutex?: Maybe<MutexMutationResponse>;
  /** delete single row from the table: "mutex" */
  delete_mutex_by_pk?: Maybe<Mutex>;
  /** delete data from the table: "notification_type" */
  delete_notification_type?: Maybe<NotificationTypeMutationResponse>;
  /** delete single row from the table: "notification_type" */
  delete_notification_type_by_pk?: Maybe<NotificationType>;
  /** delete data from the table: "payment_system" */
  delete_payment_system?: Maybe<PaymentSystemMutationResponse>;
  /** delete single row from the table: "payment_system" */
  delete_payment_system_by_pk?: Maybe<PaymentSystem>;
  /** delete data from the table: "profit_provider" */
  delete_profit_provider?: Maybe<ProfitProviderMutationResponse>;
  /** delete single row from the table: "profit_provider" */
  delete_profit_provider_by_pk?: Maybe<ProfitProvider>;
  /** delete data from the table: "profit_withdraw" */
  delete_profit_withdraw?: Maybe<ProfitWithdrawMutationResponse>;
  /** delete single row from the table: "profit_withdraw" */
  delete_profit_withdraw_by_pk?: Maybe<ProfitWithdraw>;
  /** delete data from the table: "provider" */
  delete_provider?: Maybe<ProviderMutationResponse>;
  /** delete single row from the table: "provider" */
  delete_provider_by_pk?: Maybe<Provider>;
  /** delete data from the table: "provider_country" */
  delete_provider_country?: Maybe<ProviderCountryMutationResponse>;
  /** delete single row from the table: "provider_country" */
  delete_provider_country_by_pk?: Maybe<ProviderCountry>;
  /** delete data from the table: "provider_country_state" */
  delete_provider_country_state?: Maybe<ProviderCountryStateMutationResponse>;
  /** delete single row from the table: "provider_country_state" */
  delete_provider_country_state_by_pk?: Maybe<ProviderCountryState>;
  /** delete data from the table: "provider_family" */
  delete_provider_family?: Maybe<ProviderFamilyMutationResponse>;
  /** delete single row from the table: "provider_family" */
  delete_provider_family_by_pk?: Maybe<ProviderFamily>;
  /** delete data from the table: "provider_family_payment_system" */
  delete_provider_family_payment_system?: Maybe<ProviderFamilyPaymentSystemMutationResponse>;
  /** delete single row from the table: "provider_family_payment_system" */
  delete_provider_family_payment_system_by_pk?: Maybe<ProviderFamilyPaymentSystem>;
  /** delete data from the table: "provider_fee" */
  delete_provider_fee?: Maybe<ProviderFeeMutationResponse>;
  /** delete single row from the table: "provider_fee" */
  delete_provider_fee_by_pk?: Maybe<ProviderFee>;
  /** delete data from the table: "provider_limit" */
  delete_provider_limit?: Maybe<ProviderLimitMutationResponse>;
  /** delete single row from the table: "provider_limit" */
  delete_provider_limit_by_pk?: Maybe<ProviderLimit>;
  /** delete data from the table: "provider_payment_system" */
  delete_provider_payment_system?: Maybe<ProviderPaymentSystemMutationResponse>;
  /** delete single row from the table: "provider_payment_system" */
  delete_provider_payment_system_by_pk?: Maybe<ProviderPaymentSystem>;
  /** delete data from the table: "provider_status" */
  delete_provider_status?: Maybe<ProviderStatusMutationResponse>;
  /** delete single row from the table: "provider_status" */
  delete_provider_status_by_pk?: Maybe<ProviderStatus>;
  /** delete data from the table: "refund_request_status" */
  delete_refund_request_status?: Maybe<RefundRequestStatusMutationResponse>;
  /** delete single row from the table: "refund_request_status" */
  delete_refund_request_status_by_pk?: Maybe<RefundRequestStatus>;
  /** delete data from the table: "refund_table" */
  delete_refund_table?: Maybe<RefundTableMutationResponse>;
  /** delete single row from the table: "refund_table" */
  delete_refund_table_by_pk?: Maybe<RefundTable>;
  /** delete data from the table: "registration_info" */
  delete_registration_info?: Maybe<RegistrationInfoMutationResponse>;
  /** delete single row from the table: "registration_info" */
  delete_registration_info_by_pk?: Maybe<RegistrationInfo>;
  /** delete data from the table: "registration_status" */
  delete_registration_status?: Maybe<RegistrationStatusMutationResponse>;
  /** delete single row from the table: "registration_status" */
  delete_registration_status_by_pk?: Maybe<RegistrationStatus>;
  /** delete data from the table: "role" */
  delete_role?: Maybe<RoleMutationResponse>;
  /** delete single row from the table: "role" */
  delete_role_by_pk?: Maybe<Role>;
  /** delete data from the table: "rolling_reserve" */
  delete_rolling_reserve?: Maybe<RollingReserveMutationResponse>;
  /** delete single row from the table: "rolling_reserve" */
  delete_rolling_reserve_by_pk?: Maybe<RollingReserve>;
  /** delete data from the table: "setting" */
  delete_setting?: Maybe<SettingMutationResponse>;
  /** delete single row from the table: "setting" */
  delete_setting_by_pk?: Maybe<Setting>;
  /** delete data from the table: "settlement" */
  delete_settlement?: Maybe<SettlementMutationResponse>;
  /** delete single row from the table: "settlement" */
  delete_settlement_by_pk?: Maybe<Settlement>;
  /** delete data from the table: "traffic_type" */
  delete_traffic_type?: Maybe<TrafficTypeMutationResponse>;
  /** delete single row from the table: "traffic_type" */
  delete_traffic_type_by_pk?: Maybe<TrafficType>;
  /** delete data from the table: "transaction_history" */
  delete_transaction_history?: Maybe<TransactionHistoryMutationResponse>;
  /** delete single row from the table: "transaction_history" */
  delete_transaction_history_by_pk?: Maybe<TransactionHistory>;
  /** delete data from the table: "user" */
  delete_user?: Maybe<UserMutationResponse>;
  /** delete data from the table: "user_activate_token" */
  delete_user_activate_token?: Maybe<UserActivateTokenMutationResponse>;
  /** delete single row from the table: "user_activate_token" */
  delete_user_activate_token_by_pk?: Maybe<UserActivateToken>;
  /** delete data from the table: "user_audit" */
  delete_user_audit?: Maybe<UserAuditMutationResponse>;
  /** delete single row from the table: "user_audit" */
  delete_user_audit_by_pk?: Maybe<UserAudit>;
  /** delete single row from the table: "user" */
  delete_user_by_pk?: Maybe<User>;
  /** delete data from the table: "user_info" */
  delete_user_info?: Maybe<UserInfoMutationResponse>;
  /** delete single row from the table: "user_info" */
  delete_user_info_by_pk?: Maybe<UserInfo>;
  /** delete data from the table: "user_reports" */
  delete_user_reports?: Maybe<UserReportsMutationResponse>;
  /** delete single row from the table: "user_reports" */
  delete_user_reports_by_pk?: Maybe<UserReports>;
  /** delete data from the table: "v_active_gate" */
  delete_v_active_gate?: Maybe<VActiveGateMutationResponse>;
  /** delete data from the table: "v_active_provider" */
  delete_v_active_provider?: Maybe<VActiveProviderMutationResponse>;
  /** delete data from the table: "widget_type" */
  delete_widget_type?: Maybe<WidgetTypeMutationResponse>;
  /** delete single row from the table: "widget_type" */
  delete_widget_type_by_pk?: Maybe<WidgetType>;
  /** delete data from the table: "withdraw" */
  delete_withdraw?: Maybe<WithdrawMutationResponse>;
  /** delete single row from the table: "withdraw" */
  delete_withdraw_by_pk?: Maybe<Withdraw>;
  /** delete data from the table: "withdraw_request" */
  delete_withdraw_request?: Maybe<WithdrawRequestMutationResponse>;
  /** delete single row from the table: "withdraw_request" */
  delete_withdraw_request_by_pk?: Maybe<WithdrawRequest>;
  /** delete data from the table: "withdraw_request_status" */
  delete_withdraw_request_status?: Maybe<WithdrawRequestStatusMutationResponse>;
  /** delete single row from the table: "withdraw_request_status" */
  delete_withdraw_request_status_by_pk?: Maybe<WithdrawRequestStatus>;
  frozenBalanceRecalculate: Scalars['json'];
  gatePaymentLimitValue?: Maybe<GatePaymentLimitValueOutput>;
  gatesFill: Scalars['json'];
  gatesRecalculateGroupBalance: Scalars['Boolean'];
  /** generalCreateInvoice */
  generalCreateInvoice: Scalars['Boolean'];
  /** generalCreateWithdraw */
  generalCreateWithdraw: Scalars['Boolean'];
  hrzH2hCreate: Scalars['json'];
  hrzInvoiceInfo: Scalars['json'];
  hrzRefreshToken: Scalars['json'];
  hrzSyncInvoiceTransaction: Scalars['json'];
  /** insert data into the table: "audit" */
  insert_audit?: Maybe<AuditMutationResponse>;
  /** insert a single row into the table: "audit" */
  insert_audit_one?: Maybe<Audit>;
  /** insert data into the table: "blacklist" */
  insert_blacklist?: Maybe<BlacklistMutationResponse>;
  /** insert a single row into the table: "blacklist" */
  insert_blacklist_one?: Maybe<Blacklist>;
  /** insert data into the table: "card_system" */
  insert_card_system?: Maybe<CardSystemMutationResponse>;
  /** insert a single row into the table: "card_system" */
  insert_card_system_one?: Maybe<CardSystem>;
  /** insert data into the table: "cascade_item" */
  insert_cascade_item?: Maybe<CascadeItemMutationResponse>;
  /** insert a single row into the table: "cascade_item" */
  insert_cascade_item_one?: Maybe<CascadeItem>;
  /** insert data into the table: "cascade_request" */
  insert_cascade_request?: Maybe<CascadeRequestMutationResponse>;
  /** insert a single row into the table: "cascade_request" */
  insert_cascade_request_one?: Maybe<CascadeRequest>;
  /** insert data into the table: "cascades" */
  insert_cascades?: Maybe<CascadesMutationResponse>;
  /** insert a single row into the table: "cascades" */
  insert_cascades_one?: Maybe<Cascades>;
  /** insert data into the table: "country" */
  insert_country?: Maybe<CountryMutationResponse>;
  /** insert a single row into the table: "country" */
  insert_country_one?: Maybe<Country>;
  /** insert data into the table: "country_region" */
  insert_country_region?: Maybe<CountryRegionMutationResponse>;
  /** insert a single row into the table: "country_region" */
  insert_country_region_one?: Maybe<CountryRegion>;
  /** insert data into the table: "crypto_currency" */
  insert_crypto_currency?: Maybe<CryptoCurrencyMutationResponse>;
  /** insert a single row into the table: "crypto_currency" */
  insert_crypto_currency_one?: Maybe<CryptoCurrency>;
  /** insert data into the table: "crypto_withdraw_request" */
  insert_crypto_withdraw_request?: Maybe<CryptoWithdrawRequestMutationResponse>;
  /** insert a single row into the table: "crypto_withdraw_request" */
  insert_crypto_withdraw_request_one?: Maybe<CryptoWithdrawRequest>;
  /** insert data into the table: "crypto_withdraw_request_status" */
  insert_crypto_withdraw_request_status?: Maybe<CryptoWithdrawRequestStatusMutationResponse>;
  /** insert a single row into the table: "crypto_withdraw_request_status" */
  insert_crypto_withdraw_request_status_one?: Maybe<CryptoWithdrawRequestStatus>;
  /** insert data into the table: "currency" */
  insert_currency?: Maybe<CurrencyMutationResponse>;
  /** insert a single row into the table: "currency" */
  insert_currency_one?: Maybe<Currency>;
  /** insert data into the table: "gate" */
  insert_gate?: Maybe<GateMutationResponse>;
  /** insert data into the table: "gate_group" */
  insert_gate_group?: Maybe<GateGroupMutationResponse>;
  /** insert a single row into the table: "gate_group" */
  insert_gate_group_one?: Maybe<GateGroup>;
  /** insert a single row into the table: "gate" */
  insert_gate_one?: Maybe<Gate>;
  /** insert data into the table: "gate_type" */
  insert_gate_type?: Maybe<GateTypeMutationResponse>;
  /** insert a single row into the table: "gate_type" */
  insert_gate_type_one?: Maybe<GateType>;
  /** insert data into the table: "gender" */
  insert_gender?: Maybe<GenderMutationResponse>;
  /** insert a single row into the table: "gender" */
  insert_gender_one?: Maybe<Gender>;
  /** insert data into the table: "help" */
  insert_help?: Maybe<HelpMutationResponse>;
  /** insert a single row into the table: "help" */
  insert_help_one?: Maybe<Help>;
  /** insert data into the table: "help_section" */
  insert_help_section?: Maybe<HelpSectionMutationResponse>;
  /** insert a single row into the table: "help_section" */
  insert_help_section_one?: Maybe<HelpSection>;
  /** insert data into the table: "invoice" */
  insert_invoice?: Maybe<InvoiceMutationResponse>;
  /** insert a single row into the table: "invoice" */
  insert_invoice_one?: Maybe<Invoice>;
  /** insert data into the table: "language" */
  insert_language?: Maybe<LanguageMutationResponse>;
  /** insert a single row into the table: "language" */
  insert_language_one?: Maybe<Language>;
  /** insert data into the table: "merchant" */
  insert_merchant?: Maybe<MerchantMutationResponse>;
  /** insert data into the table: "merchant_api_token" */
  insert_merchant_api_token?: Maybe<MerchantApiTokenMutationResponse>;
  /** insert a single row into the table: "merchant_api_token" */
  insert_merchant_api_token_one?: Maybe<MerchantApiToken>;
  /** insert data into the table: "merchant_balance" */
  insert_merchant_balance?: Maybe<MerchantBalanceMutationResponse>;
  /** insert a single row into the table: "merchant_balance" */
  insert_merchant_balance_one?: Maybe<MerchantBalance>;
  /** insert data into the table: "merchant_currency" */
  insert_merchant_currency?: Maybe<MerchantCurrencyMutationResponse>;
  /** insert a single row into the table: "merchant_currency" */
  insert_merchant_currency_one?: Maybe<MerchantCurrency>;
  /** insert data into the table: "merchant_fee" */
  insert_merchant_fee?: Maybe<MerchantFeeMutationResponse>;
  /** insert a single row into the table: "merchant_fee" */
  insert_merchant_fee_one?: Maybe<MerchantFee>;
  /** insert data into the table: "merchant_file" */
  insert_merchant_file?: Maybe<MerchantFileMutationResponse>;
  /** insert a single row into the table: "merchant_file" */
  insert_merchant_file_one?: Maybe<MerchantFile>;
  /** insert data into the table: "merchant_info" */
  insert_merchant_info?: Maybe<MerchantInfoMutationResponse>;
  /** insert a single row into the table: "merchant_info" */
  insert_merchant_info_one?: Maybe<MerchantInfo>;
  /** insert data into the table: "merchant_notification" */
  insert_merchant_notification?: Maybe<MerchantNotificationMutationResponse>;
  /** insert a single row into the table: "merchant_notification" */
  insert_merchant_notification_one?: Maybe<MerchantNotification>;
  /** insert a single row into the table: "merchant" */
  insert_merchant_one?: Maybe<Merchant>;
  /** insert data into the table: "merchant_task" */
  insert_merchant_task?: Maybe<MerchantTaskMutationResponse>;
  /** insert a single row into the table: "merchant_task" */
  insert_merchant_task_one?: Maybe<MerchantTask>;
  /** insert data into the table: "merchant_task_status" */
  insert_merchant_task_status?: Maybe<MerchantTaskStatusMutationResponse>;
  /** insert a single row into the table: "merchant_task_status" */
  insert_merchant_task_status_one?: Maybe<MerchantTaskStatus>;
  /** insert data into the table: "merchant_task_type" */
  insert_merchant_task_type?: Maybe<MerchantTaskTypeMutationResponse>;
  /** insert a single row into the table: "merchant_task_type" */
  insert_merchant_task_type_one?: Maybe<MerchantTaskType>;
  /** insert data into the table: "merchant_type" */
  insert_merchant_type?: Maybe<MerchantTypeMutationResponse>;
  /** insert a single row into the table: "merchant_type" */
  insert_merchant_type_one?: Maybe<MerchantType>;
  /** insert data into the table: "merchant_user" */
  insert_merchant_user?: Maybe<MerchantUserMutationResponse>;
  /** insert a single row into the table: "merchant_user" */
  insert_merchant_user_one?: Maybe<MerchantUser>;
  /** insert data into the table: "merchant_user_role" */
  insert_merchant_user_role?: Maybe<MerchantUserRoleMutationResponse>;
  /** insert a single row into the table: "merchant_user_role" */
  insert_merchant_user_role_one?: Maybe<MerchantUserRole>;
  /** insert data into the table: "merchant_widget" */
  insert_merchant_widget?: Maybe<MerchantWidgetMutationResponse>;
  /** insert a single row into the table: "merchant_widget" */
  insert_merchant_widget_one?: Maybe<MerchantWidget>;
  /** insert data into the table: "mutex" */
  insert_mutex?: Maybe<MutexMutationResponse>;
  /** insert a single row into the table: "mutex" */
  insert_mutex_one?: Maybe<Mutex>;
  /** insert data into the table: "notification_type" */
  insert_notification_type?: Maybe<NotificationTypeMutationResponse>;
  /** insert a single row into the table: "notification_type" */
  insert_notification_type_one?: Maybe<NotificationType>;
  /** insert data into the table: "payment_system" */
  insert_payment_system?: Maybe<PaymentSystemMutationResponse>;
  /** insert a single row into the table: "payment_system" */
  insert_payment_system_one?: Maybe<PaymentSystem>;
  /** insert data into the table: "profit_provider" */
  insert_profit_provider?: Maybe<ProfitProviderMutationResponse>;
  /** insert a single row into the table: "profit_provider" */
  insert_profit_provider_one?: Maybe<ProfitProvider>;
  /** insert data into the table: "profit_withdraw" */
  insert_profit_withdraw?: Maybe<ProfitWithdrawMutationResponse>;
  /** insert a single row into the table: "profit_withdraw" */
  insert_profit_withdraw_one?: Maybe<ProfitWithdraw>;
  /** insert data into the table: "provider" */
  insert_provider?: Maybe<ProviderMutationResponse>;
  /** insert data into the table: "provider_country" */
  insert_provider_country?: Maybe<ProviderCountryMutationResponse>;
  /** insert a single row into the table: "provider_country" */
  insert_provider_country_one?: Maybe<ProviderCountry>;
  /** insert data into the table: "provider_country_state" */
  insert_provider_country_state?: Maybe<ProviderCountryStateMutationResponse>;
  /** insert a single row into the table: "provider_country_state" */
  insert_provider_country_state_one?: Maybe<ProviderCountryState>;
  /** insert data into the table: "provider_family" */
  insert_provider_family?: Maybe<ProviderFamilyMutationResponse>;
  /** insert a single row into the table: "provider_family" */
  insert_provider_family_one?: Maybe<ProviderFamily>;
  /** insert data into the table: "provider_family_payment_system" */
  insert_provider_family_payment_system?: Maybe<ProviderFamilyPaymentSystemMutationResponse>;
  /** insert a single row into the table: "provider_family_payment_system" */
  insert_provider_family_payment_system_one?: Maybe<ProviderFamilyPaymentSystem>;
  /** insert data into the table: "provider_fee" */
  insert_provider_fee?: Maybe<ProviderFeeMutationResponse>;
  /** insert a single row into the table: "provider_fee" */
  insert_provider_fee_one?: Maybe<ProviderFee>;
  /** insert data into the table: "provider_limit" */
  insert_provider_limit?: Maybe<ProviderLimitMutationResponse>;
  /** insert a single row into the table: "provider_limit" */
  insert_provider_limit_one?: Maybe<ProviderLimit>;
  /** insert a single row into the table: "provider" */
  insert_provider_one?: Maybe<Provider>;
  /** insert data into the table: "provider_payment_system" */
  insert_provider_payment_system?: Maybe<ProviderPaymentSystemMutationResponse>;
  /** insert a single row into the table: "provider_payment_system" */
  insert_provider_payment_system_one?: Maybe<ProviderPaymentSystem>;
  /** insert data into the table: "provider_status" */
  insert_provider_status?: Maybe<ProviderStatusMutationResponse>;
  /** insert a single row into the table: "provider_status" */
  insert_provider_status_one?: Maybe<ProviderStatus>;
  /** insert data into the table: "refund_request_status" */
  insert_refund_request_status?: Maybe<RefundRequestStatusMutationResponse>;
  /** insert a single row into the table: "refund_request_status" */
  insert_refund_request_status_one?: Maybe<RefundRequestStatus>;
  /** insert data into the table: "refund_table" */
  insert_refund_table?: Maybe<RefundTableMutationResponse>;
  /** insert a single row into the table: "refund_table" */
  insert_refund_table_one?: Maybe<RefundTable>;
  /** insert data into the table: "registration_info" */
  insert_registration_info?: Maybe<RegistrationInfoMutationResponse>;
  /** insert a single row into the table: "registration_info" */
  insert_registration_info_one?: Maybe<RegistrationInfo>;
  /** insert data into the table: "registration_status" */
  insert_registration_status?: Maybe<RegistrationStatusMutationResponse>;
  /** insert a single row into the table: "registration_status" */
  insert_registration_status_one?: Maybe<RegistrationStatus>;
  /** insert data into the table: "role" */
  insert_role?: Maybe<RoleMutationResponse>;
  /** insert a single row into the table: "role" */
  insert_role_one?: Maybe<Role>;
  /** insert data into the table: "rolling_reserve" */
  insert_rolling_reserve?: Maybe<RollingReserveMutationResponse>;
  /** insert a single row into the table: "rolling_reserve" */
  insert_rolling_reserve_one?: Maybe<RollingReserve>;
  /** insert data into the table: "setting" */
  insert_setting?: Maybe<SettingMutationResponse>;
  /** insert a single row into the table: "setting" */
  insert_setting_one?: Maybe<Setting>;
  /** insert data into the table: "settlement" */
  insert_settlement?: Maybe<SettlementMutationResponse>;
  /** insert a single row into the table: "settlement" */
  insert_settlement_one?: Maybe<Settlement>;
  /** insert data into the table: "traffic_type" */
  insert_traffic_type?: Maybe<TrafficTypeMutationResponse>;
  /** insert a single row into the table: "traffic_type" */
  insert_traffic_type_one?: Maybe<TrafficType>;
  /** insert data into the table: "transaction_history" */
  insert_transaction_history?: Maybe<TransactionHistoryMutationResponse>;
  /** insert a single row into the table: "transaction_history" */
  insert_transaction_history_one?: Maybe<TransactionHistory>;
  /** insert data into the table: "user" */
  insert_user?: Maybe<UserMutationResponse>;
  /** insert data into the table: "user_activate_token" */
  insert_user_activate_token?: Maybe<UserActivateTokenMutationResponse>;
  /** insert a single row into the table: "user_activate_token" */
  insert_user_activate_token_one?: Maybe<UserActivateToken>;
  /** insert data into the table: "user_audit" */
  insert_user_audit?: Maybe<UserAuditMutationResponse>;
  /** insert a single row into the table: "user_audit" */
  insert_user_audit_one?: Maybe<UserAudit>;
  /** insert data into the table: "user_info" */
  insert_user_info?: Maybe<UserInfoMutationResponse>;
  /** insert a single row into the table: "user_info" */
  insert_user_info_one?: Maybe<UserInfo>;
  /** insert a single row into the table: "user" */
  insert_user_one?: Maybe<User>;
  /** insert data into the table: "user_reports" */
  insert_user_reports?: Maybe<UserReportsMutationResponse>;
  /** insert a single row into the table: "user_reports" */
  insert_user_reports_one?: Maybe<UserReports>;
  /** insert data into the table: "v_active_gate" */
  insert_v_active_gate?: Maybe<VActiveGateMutationResponse>;
  /** insert a single row into the table: "v_active_gate" */
  insert_v_active_gate_one?: Maybe<VActiveGate>;
  /** insert data into the table: "v_active_provider" */
  insert_v_active_provider?: Maybe<VActiveProviderMutationResponse>;
  /** insert a single row into the table: "v_active_provider" */
  insert_v_active_provider_one?: Maybe<VActiveProvider>;
  /** insert data into the table: "widget_type" */
  insert_widget_type?: Maybe<WidgetTypeMutationResponse>;
  /** insert a single row into the table: "widget_type" */
  insert_widget_type_one?: Maybe<WidgetType>;
  /** insert data into the table: "withdraw" */
  insert_withdraw?: Maybe<WithdrawMutationResponse>;
  /** insert a single row into the table: "withdraw" */
  insert_withdraw_one?: Maybe<Withdraw>;
  /** insert data into the table: "withdraw_request" */
  insert_withdraw_request?: Maybe<WithdrawRequestMutationResponse>;
  /** insert a single row into the table: "withdraw_request" */
  insert_withdraw_request_one?: Maybe<WithdrawRequest>;
  /** insert data into the table: "withdraw_request_status" */
  insert_withdraw_request_status?: Maybe<WithdrawRequestStatusMutationResponse>;
  /** insert a single row into the table: "withdraw_request_status" */
  insert_withdraw_request_status_one?: Maybe<WithdrawRequestStatus>;
  invoiceCancelExpiredP2P: Scalars['Boolean'];
  invoiceCreate: InvoiceCreate;
  invoiceManualCreate: Scalars['Boolean'];
  kaH2HInvoiceInfo?: Maybe<KaH2HInfoOutput>;
  khmpSyncWithdrawTransaction: Scalars['json'];
  khmpWithdrawOrderInfo: Scalars['json'];
  /** manualDailyReconciliation */
  manualDailyReconciliation: Scalars['json'];
  /** manualTableSynchronization */
  manualTableSynchronization: Scalars['json'];
  /** удаление мерчанта */
  merchantDelete: Scalars['Boolean'];
  /** Создание задания на выгрузку отчета Rejected Transaction */
  merchantTaskCreateReportRejectedTransactionTask: MerchantTaskCreateReportRejectedTransactionTaskOutput;
  /** Создание задания на выгрузку отчета transaction management */
  merchantTaskCreateReportTransactionManagementTask: MerchantTaskCreateReportTransactionManagementTaskOutput;
  /** Создание задания на выгрузку отчета Withdrawals Payout */
  merchantTaskCreateReportWithdrawalsPayoutTask: MerchantTaskCreateReportWithdrawalsPayoutTaskOutput;
  mpcvipInvoiceOrderInfo: Scalars['json'];
  mpcvipSyncHistoryOrderInfo: Scalars['Boolean'];
  mpcvipSyncInvoiceFromHistory: Scalars['Boolean'];
  mpcvipSyncInvoiceOrderInfo: Scalars['json'];
  mpcvipSyncWithdrawOrderInfo: Scalars['json'];
  mvP2PConfirm: Scalars['Boolean'];
  mvP2PCreate?: Maybe<MvP2PCreateOutput>;
  mxCreateInvoiceApm: Scalars['json'];
  mxH2HCreate: Scalars['json'];
  mxH2HInvoiceInfo: Scalars['json'];
  mxInternalBalanceKzt: Scalars['json'];
  mxInternalBalanceSbp: Scalars['json'];
  mxInternalBalances: Scalars['json'];
  mxSyncInvoiceTransaction: Scalars['json'];
  okSyncWithdrawTransaction: Scalars['Boolean'];
  /** Активация 2FA */
  otpActivate: Scalars['Boolean'];
  /** Отключение 2FA */
  otpDisable: Scalars['Boolean'];
  /** Формирование запроса на подключение 2FA */
  otpRequestActivate: OtpRequestActivateRequest;
  p2proSyncCurrencyRate: Scalars['json'];
  p2proSyncWithdrawTransaction: Scalars['json'];
  paylamaGenerateInvoice?: Maybe<ResultOutput>;
  /** paylamaGetBalance */
  paylamaGetBalance?: Maybe<ResultOutput>;
  paylamaSyncActiveTransaction?: Maybe<ResultOutput>;
  paylamaTransactionUpdate: Scalars['Boolean'];
  payportSyncInvoiceOrderInfo: Scalars['json'];
  payportSyncWithdrawOrderInfo: Scalars['json'];
  pctCreateApmInvoice: Scalars['json'];
  pctH2HSyncInvoiceTransaction: Scalars['json'];
  pctInvoiceInfo?: Maybe<PctInfoOutput>;
  pdH2HCreate: Scalars['json'];
  pdH2HInvoiceInfo?: Maybe<PdH2hInfoOutput>;
  pdH2HSyncInvoiceTransaction: Scalars['json'];
  pdInternalBalancesSync: Scalars['json'];
  pdSyncWithdrawTransaction: Scalars['json'];
  pfgtSyncWithdrawTransaction: Scalars['json'];
  pftblSyncWithdrawTransaction: Scalars['json'];
  plgGetTools: Scalars['json'];
  plgInternalBalances: Scalars['json'];
  plgInvoiceOrderInfo: Scalars['json'];
  plgSyncWithdrawTransaction: Scalars['json'];
  plnmSyncWithdrawTransaction: Scalars['json'];
  pmtappawSyncWithdrawTransaction: Scalars['json'];
  pmtappawWithdrawOrderInfo: Scalars['json'];
  pncCreate: Scalars['json'];
  pncInvoiceInfo?: Maybe<PncInfoOutput>;
  pncInvoiceOrderInfo: Scalars['json'];
  pncSyncInvoiceTransaction: Scalars['json'];
  ppP2PCancel: Scalars['Boolean'];
  ppP2PConfirm: Scalars['Boolean'];
  ppP2PCreate: Scalars['json'];
  ppP2PInfo?: Maybe<PpP2PInfoOutput>;
  ppP2PRequest?: Maybe<Array<Maybe<PpP2PRequestOutOutput>>>;
  ppP2PSyncInvoiceFromHistory: Scalars['Boolean'];
  ppP2PSyncInvoiceHistoryOrderInfo: Scalars['Boolean'];
  ppP2PSyncInvoiceTransaction: Scalars['json'];
  ppP2PSyncWithdrawTransaction: Scalars['json'];
  ppP2PWithdrawCancel: Scalars['Boolean'];
  ppP2PWithdrawCreate: Scalars['Boolean'];
  ppP2PWithdrawRequest?: Maybe<Array<Maybe<PpP2PWithdrawRequestOutput>>>;
  /** pspFormData */
  pspFormData?: Maybe<PspFormDataOutput>;
  pspInvoiceInfo?: Maybe<PspInfoOutput>;
  /** pspInvoiceStatus */
  pspInvoiceStatus: Scalars['json'];
  /** pspPaymentConfirm */
  pspPaymentConfirm: Scalars['json'];
  ptGbSyncWithdrawTransaction: Scalars['Boolean'];
  qgInvoiceInfo: Scalars['json'];
  qgSyncInvoiceTransaction: Scalars['json'];
  reconciliationInvoiceByFamily: Scalars['Boolean'];
  reconciliationWithdrawByFamily: Scalars['Boolean'];
  recurentStatusInfo: Scalars['json'];
  recurentTokenInfo: Scalars['json'];
  recurrentCreateToken: Scalars['json'];
  refundCancel: Scalars['Boolean'];
  refundCancelRequest: Scalars['Boolean'];
  refundCreate: Scalars['json'];
  refundCreateRequest: Scalars['json'];
  refundPayoutRequest: Scalars['json'];
  refundRejectRequest: Scalars['Boolean'];
  refundResetRequest: Scalars['Boolean'];
  refundReviewRequest: Scalars['Boolean'];
  /** resolveReconciliationConflicts */
  resolveReconciliationConflicts: Scalars['Boolean'];
  rqInvoiceConfirm: Scalars['Boolean'];
  rqInvoiceCreate: Scalars['json'];
  rqInvoiceInfo?: Maybe<RqInvoiceInfoOutput>;
  rqInvoiceOrderInfo: Scalars['json'];
  rqSyncInvoiceTransaction: Scalars['json'];
  rqWithdrawOrderInfo: Scalars['json'];
  /** метод сохранения отчета All Reports */
  saveReports?: Maybe<SaveReportsOutput>;
  sendRejectNotification: Scalars['json'];
  /** setProviderFee */
  setProviderFee: Scalars['json'];
  /** update data of the table: "audit" */
  update_audit?: Maybe<AuditMutationResponse>;
  /** update single row of the table: "audit" */
  update_audit_by_pk?: Maybe<Audit>;
  /** update multiples rows of table: "audit" */
  update_audit_many?: Maybe<Array<Maybe<AuditMutationResponse>>>;
  /** update data of the table: "blacklist" */
  update_blacklist?: Maybe<BlacklistMutationResponse>;
  /** update single row of the table: "blacklist" */
  update_blacklist_by_pk?: Maybe<Blacklist>;
  /** update multiples rows of table: "blacklist" */
  update_blacklist_many?: Maybe<Array<Maybe<BlacklistMutationResponse>>>;
  /** update data of the table: "card_system" */
  update_card_system?: Maybe<CardSystemMutationResponse>;
  /** update single row of the table: "card_system" */
  update_card_system_by_pk?: Maybe<CardSystem>;
  /** update multiples rows of table: "card_system" */
  update_card_system_many?: Maybe<Array<Maybe<CardSystemMutationResponse>>>;
  /** update data of the table: "cascade_item" */
  update_cascade_item?: Maybe<CascadeItemMutationResponse>;
  /** update single row of the table: "cascade_item" */
  update_cascade_item_by_pk?: Maybe<CascadeItem>;
  /** update multiples rows of table: "cascade_item" */
  update_cascade_item_many?: Maybe<Array<Maybe<CascadeItemMutationResponse>>>;
  /** update data of the table: "cascade_request" */
  update_cascade_request?: Maybe<CascadeRequestMutationResponse>;
  /** update single row of the table: "cascade_request" */
  update_cascade_request_by_pk?: Maybe<CascadeRequest>;
  /** update multiples rows of table: "cascade_request" */
  update_cascade_request_many?: Maybe<Array<Maybe<CascadeRequestMutationResponse>>>;
  /** update data of the table: "cascades" */
  update_cascades?: Maybe<CascadesMutationResponse>;
  /** update single row of the table: "cascades" */
  update_cascades_by_pk?: Maybe<Cascades>;
  /** update multiples rows of table: "cascades" */
  update_cascades_many?: Maybe<Array<Maybe<CascadesMutationResponse>>>;
  /** update data of the table: "country" */
  update_country?: Maybe<CountryMutationResponse>;
  /** update single row of the table: "country" */
  update_country_by_pk?: Maybe<Country>;
  /** update multiples rows of table: "country" */
  update_country_many?: Maybe<Array<Maybe<CountryMutationResponse>>>;
  /** update data of the table: "country_region" */
  update_country_region?: Maybe<CountryRegionMutationResponse>;
  /** update single row of the table: "country_region" */
  update_country_region_by_pk?: Maybe<CountryRegion>;
  /** update multiples rows of table: "country_region" */
  update_country_region_many?: Maybe<Array<Maybe<CountryRegionMutationResponse>>>;
  /** update data of the table: "crypto_currency" */
  update_crypto_currency?: Maybe<CryptoCurrencyMutationResponse>;
  /** update single row of the table: "crypto_currency" */
  update_crypto_currency_by_pk?: Maybe<CryptoCurrency>;
  /** update multiples rows of table: "crypto_currency" */
  update_crypto_currency_many?: Maybe<Array<Maybe<CryptoCurrencyMutationResponse>>>;
  /** update data of the table: "crypto_withdraw_request" */
  update_crypto_withdraw_request?: Maybe<CryptoWithdrawRequestMutationResponse>;
  /** update single row of the table: "crypto_withdraw_request" */
  update_crypto_withdraw_request_by_pk?: Maybe<CryptoWithdrawRequest>;
  /** update multiples rows of table: "crypto_withdraw_request" */
  update_crypto_withdraw_request_many?: Maybe<Array<Maybe<CryptoWithdrawRequestMutationResponse>>>;
  /** update data of the table: "crypto_withdraw_request_status" */
  update_crypto_withdraw_request_status?: Maybe<CryptoWithdrawRequestStatusMutationResponse>;
  /** update single row of the table: "crypto_withdraw_request_status" */
  update_crypto_withdraw_request_status_by_pk?: Maybe<CryptoWithdrawRequestStatus>;
  /** update multiples rows of table: "crypto_withdraw_request_status" */
  update_crypto_withdraw_request_status_many?: Maybe<Array<Maybe<CryptoWithdrawRequestStatusMutationResponse>>>;
  /** update data of the table: "currency" */
  update_currency?: Maybe<CurrencyMutationResponse>;
  /** update single row of the table: "currency" */
  update_currency_by_pk?: Maybe<Currency>;
  /** update multiples rows of table: "currency" */
  update_currency_many?: Maybe<Array<Maybe<CurrencyMutationResponse>>>;
  /** update data of the table: "gate" */
  update_gate?: Maybe<GateMutationResponse>;
  /** update single row of the table: "gate" */
  update_gate_by_pk?: Maybe<Gate>;
  /** update data of the table: "gate_group" */
  update_gate_group?: Maybe<GateGroupMutationResponse>;
  /** update single row of the table: "gate_group" */
  update_gate_group_by_pk?: Maybe<GateGroup>;
  /** update multiples rows of table: "gate_group" */
  update_gate_group_many?: Maybe<Array<Maybe<GateGroupMutationResponse>>>;
  /** update multiples rows of table: "gate" */
  update_gate_many?: Maybe<Array<Maybe<GateMutationResponse>>>;
  /** update data of the table: "gate_type" */
  update_gate_type?: Maybe<GateTypeMutationResponse>;
  /** update single row of the table: "gate_type" */
  update_gate_type_by_pk?: Maybe<GateType>;
  /** update multiples rows of table: "gate_type" */
  update_gate_type_many?: Maybe<Array<Maybe<GateTypeMutationResponse>>>;
  /** update data of the table: "gender" */
  update_gender?: Maybe<GenderMutationResponse>;
  /** update single row of the table: "gender" */
  update_gender_by_pk?: Maybe<Gender>;
  /** update multiples rows of table: "gender" */
  update_gender_many?: Maybe<Array<Maybe<GenderMutationResponse>>>;
  /** update data of the table: "help" */
  update_help?: Maybe<HelpMutationResponse>;
  /** update single row of the table: "help" */
  update_help_by_pk?: Maybe<Help>;
  /** update multiples rows of table: "help" */
  update_help_many?: Maybe<Array<Maybe<HelpMutationResponse>>>;
  /** update data of the table: "help_section" */
  update_help_section?: Maybe<HelpSectionMutationResponse>;
  /** update single row of the table: "help_section" */
  update_help_section_by_pk?: Maybe<HelpSection>;
  /** update multiples rows of table: "help_section" */
  update_help_section_many?: Maybe<Array<Maybe<HelpSectionMutationResponse>>>;
  /** update data of the table: "invoice" */
  update_invoice?: Maybe<InvoiceMutationResponse>;
  /** update single row of the table: "invoice" */
  update_invoice_by_pk?: Maybe<Invoice>;
  /** update multiples rows of table: "invoice" */
  update_invoice_many?: Maybe<Array<Maybe<InvoiceMutationResponse>>>;
  /** update data of the table: "language" */
  update_language?: Maybe<LanguageMutationResponse>;
  /** update single row of the table: "language" */
  update_language_by_pk?: Maybe<Language>;
  /** update multiples rows of table: "language" */
  update_language_many?: Maybe<Array<Maybe<LanguageMutationResponse>>>;
  /** update data of the table: "merchant" */
  update_merchant?: Maybe<MerchantMutationResponse>;
  /** update data of the table: "merchant_api_token" */
  update_merchant_api_token?: Maybe<MerchantApiTokenMutationResponse>;
  /** update single row of the table: "merchant_api_token" */
  update_merchant_api_token_by_pk?: Maybe<MerchantApiToken>;
  /** update multiples rows of table: "merchant_api_token" */
  update_merchant_api_token_many?: Maybe<Array<Maybe<MerchantApiTokenMutationResponse>>>;
  /** update data of the table: "merchant_balance" */
  update_merchant_balance?: Maybe<MerchantBalanceMutationResponse>;
  /** update single row of the table: "merchant_balance" */
  update_merchant_balance_by_pk?: Maybe<MerchantBalance>;
  /** update multiples rows of table: "merchant_balance" */
  update_merchant_balance_many?: Maybe<Array<Maybe<MerchantBalanceMutationResponse>>>;
  /** update single row of the table: "merchant" */
  update_merchant_by_pk?: Maybe<Merchant>;
  /** update data of the table: "merchant_currency" */
  update_merchant_currency?: Maybe<MerchantCurrencyMutationResponse>;
  /** update single row of the table: "merchant_currency" */
  update_merchant_currency_by_pk?: Maybe<MerchantCurrency>;
  /** update multiples rows of table: "merchant_currency" */
  update_merchant_currency_many?: Maybe<Array<Maybe<MerchantCurrencyMutationResponse>>>;
  /** update data of the table: "merchant_fee" */
  update_merchant_fee?: Maybe<MerchantFeeMutationResponse>;
  /** update single row of the table: "merchant_fee" */
  update_merchant_fee_by_pk?: Maybe<MerchantFee>;
  /** update multiples rows of table: "merchant_fee" */
  update_merchant_fee_many?: Maybe<Array<Maybe<MerchantFeeMutationResponse>>>;
  /** update data of the table: "merchant_file" */
  update_merchant_file?: Maybe<MerchantFileMutationResponse>;
  /** update single row of the table: "merchant_file" */
  update_merchant_file_by_pk?: Maybe<MerchantFile>;
  /** update multiples rows of table: "merchant_file" */
  update_merchant_file_many?: Maybe<Array<Maybe<MerchantFileMutationResponse>>>;
  /** update data of the table: "merchant_info" */
  update_merchant_info?: Maybe<MerchantInfoMutationResponse>;
  /** update single row of the table: "merchant_info" */
  update_merchant_info_by_pk?: Maybe<MerchantInfo>;
  /** update multiples rows of table: "merchant_info" */
  update_merchant_info_many?: Maybe<Array<Maybe<MerchantInfoMutationResponse>>>;
  /** update multiples rows of table: "merchant" */
  update_merchant_many?: Maybe<Array<Maybe<MerchantMutationResponse>>>;
  /** update data of the table: "merchant_notification" */
  update_merchant_notification?: Maybe<MerchantNotificationMutationResponse>;
  /** update single row of the table: "merchant_notification" */
  update_merchant_notification_by_pk?: Maybe<MerchantNotification>;
  /** update multiples rows of table: "merchant_notification" */
  update_merchant_notification_many?: Maybe<Array<Maybe<MerchantNotificationMutationResponse>>>;
  /** update data of the table: "merchant_task" */
  update_merchant_task?: Maybe<MerchantTaskMutationResponse>;
  /** update single row of the table: "merchant_task" */
  update_merchant_task_by_pk?: Maybe<MerchantTask>;
  /** update multiples rows of table: "merchant_task" */
  update_merchant_task_many?: Maybe<Array<Maybe<MerchantTaskMutationResponse>>>;
  /** update data of the table: "merchant_task_status" */
  update_merchant_task_status?: Maybe<MerchantTaskStatusMutationResponse>;
  /** update single row of the table: "merchant_task_status" */
  update_merchant_task_status_by_pk?: Maybe<MerchantTaskStatus>;
  /** update multiples rows of table: "merchant_task_status" */
  update_merchant_task_status_many?: Maybe<Array<Maybe<MerchantTaskStatusMutationResponse>>>;
  /** update data of the table: "merchant_task_type" */
  update_merchant_task_type?: Maybe<MerchantTaskTypeMutationResponse>;
  /** update single row of the table: "merchant_task_type" */
  update_merchant_task_type_by_pk?: Maybe<MerchantTaskType>;
  /** update multiples rows of table: "merchant_task_type" */
  update_merchant_task_type_many?: Maybe<Array<Maybe<MerchantTaskTypeMutationResponse>>>;
  /** update data of the table: "merchant_type" */
  update_merchant_type?: Maybe<MerchantTypeMutationResponse>;
  /** update single row of the table: "merchant_type" */
  update_merchant_type_by_pk?: Maybe<MerchantType>;
  /** update multiples rows of table: "merchant_type" */
  update_merchant_type_many?: Maybe<Array<Maybe<MerchantTypeMutationResponse>>>;
  /** update data of the table: "merchant_user" */
  update_merchant_user?: Maybe<MerchantUserMutationResponse>;
  /** update single row of the table: "merchant_user" */
  update_merchant_user_by_pk?: Maybe<MerchantUser>;
  /** update multiples rows of table: "merchant_user" */
  update_merchant_user_many?: Maybe<Array<Maybe<MerchantUserMutationResponse>>>;
  /** update data of the table: "merchant_user_role" */
  update_merchant_user_role?: Maybe<MerchantUserRoleMutationResponse>;
  /** update single row of the table: "merchant_user_role" */
  update_merchant_user_role_by_pk?: Maybe<MerchantUserRole>;
  /** update multiples rows of table: "merchant_user_role" */
  update_merchant_user_role_many?: Maybe<Array<Maybe<MerchantUserRoleMutationResponse>>>;
  /** update data of the table: "merchant_widget" */
  update_merchant_widget?: Maybe<MerchantWidgetMutationResponse>;
  /** update single row of the table: "merchant_widget" */
  update_merchant_widget_by_pk?: Maybe<MerchantWidget>;
  /** update multiples rows of table: "merchant_widget" */
  update_merchant_widget_many?: Maybe<Array<Maybe<MerchantWidgetMutationResponse>>>;
  /** update data of the table: "mutex" */
  update_mutex?: Maybe<MutexMutationResponse>;
  /** update single row of the table: "mutex" */
  update_mutex_by_pk?: Maybe<Mutex>;
  /** update multiples rows of table: "mutex" */
  update_mutex_many?: Maybe<Array<Maybe<MutexMutationResponse>>>;
  /** update data of the table: "notification_type" */
  update_notification_type?: Maybe<NotificationTypeMutationResponse>;
  /** update single row of the table: "notification_type" */
  update_notification_type_by_pk?: Maybe<NotificationType>;
  /** update multiples rows of table: "notification_type" */
  update_notification_type_many?: Maybe<Array<Maybe<NotificationTypeMutationResponse>>>;
  /** update data of the table: "payment_system" */
  update_payment_system?: Maybe<PaymentSystemMutationResponse>;
  /** update single row of the table: "payment_system" */
  update_payment_system_by_pk?: Maybe<PaymentSystem>;
  /** update multiples rows of table: "payment_system" */
  update_payment_system_many?: Maybe<Array<Maybe<PaymentSystemMutationResponse>>>;
  /** update data of the table: "profit_provider" */
  update_profit_provider?: Maybe<ProfitProviderMutationResponse>;
  /** update single row of the table: "profit_provider" */
  update_profit_provider_by_pk?: Maybe<ProfitProvider>;
  /** update multiples rows of table: "profit_provider" */
  update_profit_provider_many?: Maybe<Array<Maybe<ProfitProviderMutationResponse>>>;
  /** update data of the table: "profit_withdraw" */
  update_profit_withdraw?: Maybe<ProfitWithdrawMutationResponse>;
  /** update single row of the table: "profit_withdraw" */
  update_profit_withdraw_by_pk?: Maybe<ProfitWithdraw>;
  /** update multiples rows of table: "profit_withdraw" */
  update_profit_withdraw_many?: Maybe<Array<Maybe<ProfitWithdrawMutationResponse>>>;
  /** update data of the table: "provider" */
  update_provider?: Maybe<ProviderMutationResponse>;
  /** update single row of the table: "provider" */
  update_provider_by_pk?: Maybe<Provider>;
  /** update data of the table: "provider_country" */
  update_provider_country?: Maybe<ProviderCountryMutationResponse>;
  /** update single row of the table: "provider_country" */
  update_provider_country_by_pk?: Maybe<ProviderCountry>;
  /** update multiples rows of table: "provider_country" */
  update_provider_country_many?: Maybe<Array<Maybe<ProviderCountryMutationResponse>>>;
  /** update data of the table: "provider_country_state" */
  update_provider_country_state?: Maybe<ProviderCountryStateMutationResponse>;
  /** update single row of the table: "provider_country_state" */
  update_provider_country_state_by_pk?: Maybe<ProviderCountryState>;
  /** update multiples rows of table: "provider_country_state" */
  update_provider_country_state_many?: Maybe<Array<Maybe<ProviderCountryStateMutationResponse>>>;
  /** update data of the table: "provider_family" */
  update_provider_family?: Maybe<ProviderFamilyMutationResponse>;
  /** update single row of the table: "provider_family" */
  update_provider_family_by_pk?: Maybe<ProviderFamily>;
  /** update multiples rows of table: "provider_family" */
  update_provider_family_many?: Maybe<Array<Maybe<ProviderFamilyMutationResponse>>>;
  /** update data of the table: "provider_family_payment_system" */
  update_provider_family_payment_system?: Maybe<ProviderFamilyPaymentSystemMutationResponse>;
  /** update single row of the table: "provider_family_payment_system" */
  update_provider_family_payment_system_by_pk?: Maybe<ProviderFamilyPaymentSystem>;
  /** update multiples rows of table: "provider_family_payment_system" */
  update_provider_family_payment_system_many?: Maybe<Array<Maybe<ProviderFamilyPaymentSystemMutationResponse>>>;
  /** update data of the table: "provider_fee" */
  update_provider_fee?: Maybe<ProviderFeeMutationResponse>;
  /** update single row of the table: "provider_fee" */
  update_provider_fee_by_pk?: Maybe<ProviderFee>;
  /** update multiples rows of table: "provider_fee" */
  update_provider_fee_many?: Maybe<Array<Maybe<ProviderFeeMutationResponse>>>;
  /** update data of the table: "provider_limit" */
  update_provider_limit?: Maybe<ProviderLimitMutationResponse>;
  /** update single row of the table: "provider_limit" */
  update_provider_limit_by_pk?: Maybe<ProviderLimit>;
  /** update multiples rows of table: "provider_limit" */
  update_provider_limit_many?: Maybe<Array<Maybe<ProviderLimitMutationResponse>>>;
  /** update multiples rows of table: "provider" */
  update_provider_many?: Maybe<Array<Maybe<ProviderMutationResponse>>>;
  /** update data of the table: "provider_payment_system" */
  update_provider_payment_system?: Maybe<ProviderPaymentSystemMutationResponse>;
  /** update single row of the table: "provider_payment_system" */
  update_provider_payment_system_by_pk?: Maybe<ProviderPaymentSystem>;
  /** update multiples rows of table: "provider_payment_system" */
  update_provider_payment_system_many?: Maybe<Array<Maybe<ProviderPaymentSystemMutationResponse>>>;
  /** update data of the table: "provider_status" */
  update_provider_status?: Maybe<ProviderStatusMutationResponse>;
  /** update single row of the table: "provider_status" */
  update_provider_status_by_pk?: Maybe<ProviderStatus>;
  /** update multiples rows of table: "provider_status" */
  update_provider_status_many?: Maybe<Array<Maybe<ProviderStatusMutationResponse>>>;
  /** update data of the table: "refund_request_status" */
  update_refund_request_status?: Maybe<RefundRequestStatusMutationResponse>;
  /** update single row of the table: "refund_request_status" */
  update_refund_request_status_by_pk?: Maybe<RefundRequestStatus>;
  /** update multiples rows of table: "refund_request_status" */
  update_refund_request_status_many?: Maybe<Array<Maybe<RefundRequestStatusMutationResponse>>>;
  /** update data of the table: "refund_table" */
  update_refund_table?: Maybe<RefundTableMutationResponse>;
  /** update single row of the table: "refund_table" */
  update_refund_table_by_pk?: Maybe<RefundTable>;
  /** update multiples rows of table: "refund_table" */
  update_refund_table_many?: Maybe<Array<Maybe<RefundTableMutationResponse>>>;
  /** update data of the table: "registration_info" */
  update_registration_info?: Maybe<RegistrationInfoMutationResponse>;
  /** update single row of the table: "registration_info" */
  update_registration_info_by_pk?: Maybe<RegistrationInfo>;
  /** update multiples rows of table: "registration_info" */
  update_registration_info_many?: Maybe<Array<Maybe<RegistrationInfoMutationResponse>>>;
  /** update data of the table: "registration_status" */
  update_registration_status?: Maybe<RegistrationStatusMutationResponse>;
  /** update single row of the table: "registration_status" */
  update_registration_status_by_pk?: Maybe<RegistrationStatus>;
  /** update multiples rows of table: "registration_status" */
  update_registration_status_many?: Maybe<Array<Maybe<RegistrationStatusMutationResponse>>>;
  /** update data of the table: "role" */
  update_role?: Maybe<RoleMutationResponse>;
  /** update single row of the table: "role" */
  update_role_by_pk?: Maybe<Role>;
  /** update multiples rows of table: "role" */
  update_role_many?: Maybe<Array<Maybe<RoleMutationResponse>>>;
  /** update data of the table: "rolling_reserve" */
  update_rolling_reserve?: Maybe<RollingReserveMutationResponse>;
  /** update single row of the table: "rolling_reserve" */
  update_rolling_reserve_by_pk?: Maybe<RollingReserve>;
  /** update multiples rows of table: "rolling_reserve" */
  update_rolling_reserve_many?: Maybe<Array<Maybe<RollingReserveMutationResponse>>>;
  /** update data of the table: "setting" */
  update_setting?: Maybe<SettingMutationResponse>;
  /** update single row of the table: "setting" */
  update_setting_by_pk?: Maybe<Setting>;
  /** update multiples rows of table: "setting" */
  update_setting_many?: Maybe<Array<Maybe<SettingMutationResponse>>>;
  /** update data of the table: "settlement" */
  update_settlement?: Maybe<SettlementMutationResponse>;
  /** update single row of the table: "settlement" */
  update_settlement_by_pk?: Maybe<Settlement>;
  /** update multiples rows of table: "settlement" */
  update_settlement_many?: Maybe<Array<Maybe<SettlementMutationResponse>>>;
  /** update data of the table: "traffic_type" */
  update_traffic_type?: Maybe<TrafficTypeMutationResponse>;
  /** update single row of the table: "traffic_type" */
  update_traffic_type_by_pk?: Maybe<TrafficType>;
  /** update multiples rows of table: "traffic_type" */
  update_traffic_type_many?: Maybe<Array<Maybe<TrafficTypeMutationResponse>>>;
  /** update data of the table: "transaction_history" */
  update_transaction_history?: Maybe<TransactionHistoryMutationResponse>;
  /** update single row of the table: "transaction_history" */
  update_transaction_history_by_pk?: Maybe<TransactionHistory>;
  /** update multiples rows of table: "transaction_history" */
  update_transaction_history_many?: Maybe<Array<Maybe<TransactionHistoryMutationResponse>>>;
  /** update data of the table: "user" */
  update_user?: Maybe<UserMutationResponse>;
  /** update data of the table: "user_activate_token" */
  update_user_activate_token?: Maybe<UserActivateTokenMutationResponse>;
  /** update single row of the table: "user_activate_token" */
  update_user_activate_token_by_pk?: Maybe<UserActivateToken>;
  /** update multiples rows of table: "user_activate_token" */
  update_user_activate_token_many?: Maybe<Array<Maybe<UserActivateTokenMutationResponse>>>;
  /** update data of the table: "user_audit" */
  update_user_audit?: Maybe<UserAuditMutationResponse>;
  /** update single row of the table: "user_audit" */
  update_user_audit_by_pk?: Maybe<UserAudit>;
  /** update multiples rows of table: "user_audit" */
  update_user_audit_many?: Maybe<Array<Maybe<UserAuditMutationResponse>>>;
  /** update single row of the table: "user" */
  update_user_by_pk?: Maybe<User>;
  /** update data of the table: "user_info" */
  update_user_info?: Maybe<UserInfoMutationResponse>;
  /** update single row of the table: "user_info" */
  update_user_info_by_pk?: Maybe<UserInfo>;
  /** update multiples rows of table: "user_info" */
  update_user_info_many?: Maybe<Array<Maybe<UserInfoMutationResponse>>>;
  /** update multiples rows of table: "user" */
  update_user_many?: Maybe<Array<Maybe<UserMutationResponse>>>;
  /** update data of the table: "user_reports" */
  update_user_reports?: Maybe<UserReportsMutationResponse>;
  /** update single row of the table: "user_reports" */
  update_user_reports_by_pk?: Maybe<UserReports>;
  /** update multiples rows of table: "user_reports" */
  update_user_reports_many?: Maybe<Array<Maybe<UserReportsMutationResponse>>>;
  /** update data of the table: "v_active_gate" */
  update_v_active_gate?: Maybe<VActiveGateMutationResponse>;
  /** update multiples rows of table: "v_active_gate" */
  update_v_active_gate_many?: Maybe<Array<Maybe<VActiveGateMutationResponse>>>;
  /** update data of the table: "v_active_provider" */
  update_v_active_provider?: Maybe<VActiveProviderMutationResponse>;
  /** update multiples rows of table: "v_active_provider" */
  update_v_active_provider_many?: Maybe<Array<Maybe<VActiveProviderMutationResponse>>>;
  /** update data of the table: "widget_type" */
  update_widget_type?: Maybe<WidgetTypeMutationResponse>;
  /** update single row of the table: "widget_type" */
  update_widget_type_by_pk?: Maybe<WidgetType>;
  /** update multiples rows of table: "widget_type" */
  update_widget_type_many?: Maybe<Array<Maybe<WidgetTypeMutationResponse>>>;
  /** update data of the table: "withdraw" */
  update_withdraw?: Maybe<WithdrawMutationResponse>;
  /** update single row of the table: "withdraw" */
  update_withdraw_by_pk?: Maybe<Withdraw>;
  /** update multiples rows of table: "withdraw" */
  update_withdraw_many?: Maybe<Array<Maybe<WithdrawMutationResponse>>>;
  /** update data of the table: "withdraw_request" */
  update_withdraw_request?: Maybe<WithdrawRequestMutationResponse>;
  /** update single row of the table: "withdraw_request" */
  update_withdraw_request_by_pk?: Maybe<WithdrawRequest>;
  /** update multiples rows of table: "withdraw_request" */
  update_withdraw_request_many?: Maybe<Array<Maybe<WithdrawRequestMutationResponse>>>;
  /** update data of the table: "withdraw_request_status" */
  update_withdraw_request_status?: Maybe<WithdrawRequestStatusMutationResponse>;
  /** update single row of the table: "withdraw_request_status" */
  update_withdraw_request_status_by_pk?: Maybe<WithdrawRequestStatus>;
  /** update multiples rows of table: "withdraw_request_status" */
  update_withdraw_request_status_many?: Maybe<Array<Maybe<WithdrawRequestStatusMutationResponse>>>;
  usersActivate?: Maybe<UsersActivateOutput>;
  /** Метод для изменения пароля */
  usersChangePassword: Scalars['Boolean'];
  /** Метод для изменения пароля манагеру */
  usersChangePasswordManager: Scalars['Boolean'];
  /** Создает partner-manager */
  usersCreatePartnerManager: Scalars['Boolean'];
  /** Метод регистрации токена восстановления пароля */
  usersRegisterRestorePassword: Scalars['Boolean'];
  usersRegistration?: Maybe<UsersRegistrationOutput>;
  usersRegistrationApprove: Scalars['Boolean'];
  usersRegistrationReject: Scalars['Boolean'];
  usersRegistrationReset: Scalars['Boolean'];
  /** Переводит заявку на регистрацию в статус Review */
  usersRegistrationReview: Scalars['Boolean'];
  /** Метод восстановления пароля для отправки токена вызовите метод usersRegisterRestorePassword */
  usersRestorePassword: Scalars['Boolean'];
  withdrawCancelExpiredP2P: Scalars['Boolean'];
  withdrawManualCreate: Scalars['Boolean'];
  withdrawMassWithdrawCreate?: Maybe<WithdrawMassWithdrawCreateOutput>;
  withdrawRefundCreate: Scalars['json'];
  /** Пофторяет указаный зафейленый withdraw */
  withdrawReply?: Maybe<WithdrawReplyOutput>;
  withdrawRequestApprove: Scalars['Boolean'];
  withdrawRequestCreate: Scalars['Boolean'];
  withdrawRequestPayout: Scalars['json'];
  withdrawRequestReject: Scalars['Boolean'];
  /** Метод сбрасывает заявку в состояние Create */
  withdrawRequestReset: Scalars['Boolean'];
  /** Переводит зафейленый withdraw в статус Pending */
  withdrawToPending: Scalars['Boolean'];
  wwAgsInvoiceInfo: Scalars['json'];
  wwAgsSyncInvoiceTransaction: Scalars['json'];
  wzrdInvoiceInfo?: Maybe<WzrdInfoOutput>;
  wzrdSyncInvoiceTransaction: Scalars['json'];
  wzrdpayCreate: Scalars['json'];
  xpH2hCreate: Scalars['json'];
  xpInvoiceInfo: Scalars['json'];
  xpSend3ds: Scalars['json'];
  xpaySyncInvoiceTransaction: Scalars['json'];
};


/** mutation root */
export type MutationRootAmpH2hCreateArgs = {
  card_cvv: Scalars['String'];
  card_month: Scalars['String'];
  card_number: Scalars['String'];
  card_year: Scalars['String'];
  cardholder: Scalars['String'];
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootAmpH2hInvoiceOrderInfoArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
  tracker_id: Scalars['String'];
};


/** mutation root */
export type MutationRootAmpInvoiceInfoArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootAmpV2CreateArgs = {
  address: Scalars['String'];
  card_cvv: Scalars['String'];
  card_month: Scalars['String'];
  card_number: Scalars['String'];
  card_year: Scalars['String'];
  cardholder: Scalars['String'];
  city: Scalars['String'];
  country_code: Scalars['String'];
  date_of_birth: Scalars['String'];
  email: Scalars['String'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  phone: Scalars['String'];
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootAmpV2CreateH2hArgs = {
  card_cvv: Scalars['String'];
  card_month: Scalars['String'];
  card_number: Scalars['String'];
  card_year: Scalars['String'];
  cardholder: Scalars['String'];
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootAmpV2InvoiceInfoArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootAnH2HCreateArgs = {
  card_cvv: Scalars['String'];
  card_month: Scalars['String'];
  card_number: Scalars['String'];
  card_year: Scalars['String'];
  cardholder: Scalars['String'];
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootAnH2HInvoiceInfoArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootAnP2PConfirmArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootAnP2PCreateArgs = {
  pay_source: Scalars['String'];
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootAnpCreateInvoiceArgs = {
  card_cvv: Scalars['String'];
  card_month: Scalars['String'];
  card_number: Scalars['String'];
  card_year: Scalars['String'];
  cardholder: Scalars['String'];
  email: Scalars['String'];
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootAnpInvoiceInfoArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootApH2HCreateArgs = {
  card_cvv: Scalars['String'];
  card_month: Scalars['String'];
  card_number: Scalars['String'];
  card_year: Scalars['String'];
  cardholder: Scalars['String'];
  request_data?: InputMaybe<ApH2HRequestData>;
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootApH2HCreateQiwiInvoiceArgs = {
  phone_number: Scalars['String'];
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootApH2HInvoiceInfoArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootAuthLoginArgs = {
  password: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
  username: Scalars['String'];
};


/** mutation root */
export type MutationRootAuthSingTokenByUserIdArgs = {
  user_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootBlacklistAddArgs = {
  cardholder: Scalars['String'];
  comment: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  sanitized_card: Scalars['String'];
};


/** mutation root */
export type MutationRootBlacklistDeleteArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootBvWithdrawOrderInfoArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootCalculateBalanceToBalanceByMerchantArgs = {
  merchant_id: Scalars['String'];
};


/** mutation root */
export type MutationRootCalculateHoldBalanceToHoldBalanceByMerchantArgs = {
  merchant_id: Scalars['String'];
};


/** mutation root */
export type MutationRootCallbackInvoiceManualSendArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootCallbackWithdrawManualSendArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootCascadeCreateArgs = {
  gate_group_ids: Array<Scalars['String']>;
  merchant_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootCascadeDeleteArgs = {
  cascade_id: Scalars['String'];
};


/** mutation root */
export type MutationRootCascadeUpdateArgs = {
  cascade_id: Scalars['String'];
  gate_group_ids: Array<Scalars['String']>;
};


/** mutation root */
export type MutationRootChargebackCancelArgs = {
  chargeback_id: Scalars['String'];
};


/** mutation root */
export type MutationRootChargebackCreateArgs = {
  chargeback_fee: Scalars['numeric'];
  comment: Scalars['String'];
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootChsPublicKeyGetArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
};


/** mutation root */
export type MutationRootChsPublicKeyPutArgs = {
  client_public_key: Scalars['String'];
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
};


/** mutation root */
export type MutationRootCpH2HCreateArgs = {
  card_cvv: Scalars['String'];
  card_month: Scalars['String'];
  card_number: Scalars['String'];
  card_year: Scalars['String'];
  cardholder: Scalars['String'];
  issue_payment_token?: InputMaybe<Scalars['Boolean']>;
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootCpH2HInvoiceInfoArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootCreateApiTokenArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type MutationRootCreateNewProviderInFamilyArgs = {
  api_key: Scalars['String'];
  constant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  constant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  currency_id: Scalars['String'];
  force?: InputMaybe<Scalars['Boolean']>;
  invoice_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  invoice_fee_percent?: InputMaybe<Scalars['numeric']>;
  invoice_max_limit?: InputMaybe<Scalars['numeric']>;
  invoice_min_limit?: InputMaybe<Scalars['numeric']>;
  invoice_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_constant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  merchant_constant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  provider_alias: Scalars['String'];
  provider_family: Scalars['String'];
  provider_family_payment_system?: InputMaybe<Scalars['String']>;
  provider_id: Scalars['String'];
  provider_name: Scalars['String'];
  rolling_reserve_duration?: InputMaybe<Scalars['Int']>;
  rolling_reserve_percent?: InputMaybe<Scalars['numeric']>;
  secret_key?: InputMaybe<Scalars['String']>;
  withdraw_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  withdraw_fee_percent?: InputMaybe<Scalars['numeric']>;
  withdraw_max_limit?: InputMaybe<Scalars['numeric']>;
  withdraw_min_limit?: InputMaybe<Scalars['numeric']>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  withdraw_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
};


/** mutation root */
export type MutationRootCreateUnholdAndWithdrawArgs = {
  amount: Scalars['Int'];
  comment: Scalars['String'];
  currency_id: Scalars['String'];
  gate_group_id: Scalars['String'];
  merchant_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootCredentinalSetArgs = {
  api_key: Scalars['String'];
  force?: InputMaybe<Scalars['Boolean']>;
  provider_id: Scalars['String'];
  secret_key: Scalars['String'];
};


/** mutation root */
export type MutationRootCredentinalUpdateArgs = {
  api_key: Scalars['String'];
  force?: InputMaybe<Scalars['Boolean']>;
  provider_id: Scalars['String'];
  secret_key: Scalars['String'];
};


/** mutation root */
export type MutationRootCryptoCheckPasswordArgs = {
  password: Scalars['String'];
  password_hash: Scalars['String'];
};


/** mutation root */
export type MutationRootCryptoGenPasswordHashArgs = {
  password: Scalars['String'];
};


/** mutation root */
export type MutationRootCryptoWithdrawRequestCancelArgs = {
  withdrawRequestId: Scalars['Int'];
};


/** mutation root */
export type MutationRootCryptoWithdrawRequestComputePayoutDetailsArgs = {
  fiat_amount: Scalars['numeric'];
  gate_group_id: Scalars['String'];
  merchant_settlement_fee_percent: Scalars['numeric'];
};


/** mutation root */
export type MutationRootCryptoWithdrawRequestCreateArgs = {
  account: Scalars['String'];
  crypto_currency: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  fiat_amount: Scalars['numeric'];
  fiat_currency: Scalars['String'];
  gate_id: Scalars['String'];
};


/** mutation root */
export type MutationRootCryptoWithdrawRequestCreateAdminArgs = {
  account: Scalars['String'];
  crypto_currency: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  fiat_amount: Scalars['numeric'];
  fiat_currency: Scalars['String'];
  gate_id: Scalars['String'];
  merchant_id: Scalars['Int'];
  merchant_settlement_fee_percent: Scalars['numeric'];
  payout_amount: Scalars['numeric'];
};


/** mutation root */
export type MutationRootCryptoWithdrawRequestInProcessArgs = {
  withdrawRequestId: Scalars['Int'];
};


/** mutation root */
export type MutationRootCryptoWithdrawRequestPayoutArgs = {
  crypto_amount: Scalars['numeric'];
  key_approve: Scalars['String'];
  rate: Scalars['Float'];
  withdrawRequestId: Scalars['Int'];
};


/** mutation root */
export type MutationRootCryptoWithdrawRequestRejectArgs = {
  withdrawRequestId: Scalars['Int'];
};


/** mutation root */
export type MutationRootCsbH2HInvoiceInfoArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootCsbWithdrawInfoArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootDcH2HCreateInvoiceArgs = {
  card_cvv?: InputMaybe<Scalars['String']>;
  card_month?: InputMaybe<Scalars['String']>;
  card_number?: InputMaybe<Scalars['String']>;
  card_year?: InputMaybe<Scalars['String']>;
  cardholder?: InputMaybe<Scalars['String']>;
  transaction_uid?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRootDcH2HInvoiceInfoArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootDcH2HInvoiceOrderInfoArgs = {
  currency_id: Scalars['String'];
  order_number: Scalars['String'];
  order_token: Scalars['String'];
  provider_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDcH2HWithdrawOrderInfoArgs = {
  currency_id: Scalars['String'];
  order_number: Scalars['String'];
  order_token: Scalars['String'];
};


/** mutation root */
export type MutationRootDcWithdrawConfirmArgs = {
  currency_id: Scalars['String'];
  order_token: Scalars['String'];
  provider_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteAuditArgs = {
  where: AuditBoolExp;
};


/** mutation root */
export type MutationRootDeleteAuditByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteBlacklistArgs = {
  where: BlacklistBoolExp;
};


/** mutation root */
export type MutationRootDeleteBlacklistByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteCardSystemArgs = {
  where: CardSystemBoolExp;
};


/** mutation root */
export type MutationRootDeleteCardSystemByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteCascadeItemArgs = {
  where: CascadeItemBoolExp;
};


/** mutation root */
export type MutationRootDeleteCascadeItemByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteCascadeRequestArgs = {
  where: CascadeRequestBoolExp;
};


/** mutation root */
export type MutationRootDeleteCascadeRequestByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteCascadesArgs = {
  where: CascadesBoolExp;
};


/** mutation root */
export type MutationRootDeleteCascadesByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteCountryArgs = {
  where: CountryBoolExp;
};


/** mutation root */
export type MutationRootDeleteCountryByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteCountryRegionArgs = {
  where: CountryRegionBoolExp;
};


/** mutation root */
export type MutationRootDeleteCountryRegionByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteCryptoCurrencyArgs = {
  where: CryptoCurrencyBoolExp;
};


/** mutation root */
export type MutationRootDeleteCryptoCurrencyByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteCryptoWithdrawRequestArgs = {
  where: CryptoWithdrawRequestBoolExp;
};


/** mutation root */
export type MutationRootDeleteCryptoWithdrawRequestByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteCryptoWithdrawRequestStatusArgs = {
  where: CryptoWithdrawRequestStatusBoolExp;
};


/** mutation root */
export type MutationRootDeleteCryptoWithdrawRequestStatusByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteCurrencyArgs = {
  where: CurrencyBoolExp;
};


/** mutation root */
export type MutationRootDeleteCurrencyByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGateArgs = {
  where: GateBoolExp;
};


/** mutation root */
export type MutationRootDeleteGateByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGateGroupArgs = {
  where: GateGroupBoolExp;
};


/** mutation root */
export type MutationRootDeleteGateGroupByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGateTypeArgs = {
  where: GateTypeBoolExp;
};


/** mutation root */
export type MutationRootDeleteGateTypeByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGenderArgs = {
  where: GenderBoolExp;
};


/** mutation root */
export type MutationRootDeleteGenderByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteHelpArgs = {
  where: HelpBoolExp;
};


/** mutation root */
export type MutationRootDeleteHelpByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteHelpSectionArgs = {
  where: HelpSectionBoolExp;
};


/** mutation root */
export type MutationRootDeleteHelpSectionByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteInvoiceArgs = {
  where: InvoiceBoolExp;
};


/** mutation root */
export type MutationRootDeleteInvoiceByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteLanguageArgs = {
  where: LanguageBoolExp;
};


/** mutation root */
export type MutationRootDeleteLanguageByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteMerchantArgs = {
  where: MerchantBoolExp;
};


/** mutation root */
export type MutationRootDeleteMerchantApiTokenArgs = {
  where: MerchantApiTokenBoolExp;
};


/** mutation root */
export type MutationRootDeleteMerchantApiTokenByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteMerchantBalanceArgs = {
  where: MerchantBalanceBoolExp;
};


/** mutation root */
export type MutationRootDeleteMerchantBalanceByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteMerchantByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteMerchantCurrencyArgs = {
  where: MerchantCurrencyBoolExp;
};


/** mutation root */
export type MutationRootDeleteMerchantCurrencyByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteMerchantFeeArgs = {
  where: MerchantFeeBoolExp;
};


/** mutation root */
export type MutationRootDeleteMerchantFeeByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteMerchantFileArgs = {
  where: MerchantFileBoolExp;
};


/** mutation root */
export type MutationRootDeleteMerchantFileByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteMerchantInfoArgs = {
  where: MerchantInfoBoolExp;
};


/** mutation root */
export type MutationRootDeleteMerchantInfoByPkArgs = {
  merchant_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteMerchantNotificationArgs = {
  where: MerchantNotificationBoolExp;
};


/** mutation root */
export type MutationRootDeleteMerchantNotificationByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteMerchantTaskArgs = {
  where: MerchantTaskBoolExp;
};


/** mutation root */
export type MutationRootDeleteMerchantTaskByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteMerchantTaskStatusArgs = {
  where: MerchantTaskStatusBoolExp;
};


/** mutation root */
export type MutationRootDeleteMerchantTaskStatusByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteMerchantTaskTypeArgs = {
  where: MerchantTaskTypeBoolExp;
};


/** mutation root */
export type MutationRootDeleteMerchantTaskTypeByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteMerchantTypeArgs = {
  where: MerchantTypeBoolExp;
};


/** mutation root */
export type MutationRootDeleteMerchantTypeByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteMerchantUserArgs = {
  where: MerchantUserBoolExp;
};


/** mutation root */
export type MutationRootDeleteMerchantUserByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteMerchantUserRoleArgs = {
  where: MerchantUserRoleBoolExp;
};


/** mutation root */
export type MutationRootDeleteMerchantUserRoleByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteMerchantWidgetArgs = {
  where: MerchantWidgetBoolExp;
};


/** mutation root */
export type MutationRootDeleteMerchantWidgetByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteMutexArgs = {
  where: MutexBoolExp;
};


/** mutation root */
export type MutationRootDeleteMutexByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteNotificationTypeArgs = {
  where: NotificationTypeBoolExp;
};


/** mutation root */
export type MutationRootDeleteNotificationTypeByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeletePaymentSystemArgs = {
  where: PaymentSystemBoolExp;
};


/** mutation root */
export type MutationRootDeletePaymentSystemByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteProfitProviderArgs = {
  where: ProfitProviderBoolExp;
};


/** mutation root */
export type MutationRootDeleteProfitProviderByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteProfitWithdrawArgs = {
  where: ProfitWithdrawBoolExp;
};


/** mutation root */
export type MutationRootDeleteProfitWithdrawByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteProviderArgs = {
  where: ProviderBoolExp;
};


/** mutation root */
export type MutationRootDeleteProviderByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteProviderCountryArgs = {
  where: ProviderCountryBoolExp;
};


/** mutation root */
export type MutationRootDeleteProviderCountryByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteProviderCountryStateArgs = {
  where: ProviderCountryStateBoolExp;
};


/** mutation root */
export type MutationRootDeleteProviderCountryStateByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteProviderFamilyArgs = {
  where: ProviderFamilyBoolExp;
};


/** mutation root */
export type MutationRootDeleteProviderFamilyByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteProviderFamilyPaymentSystemArgs = {
  where: ProviderFamilyPaymentSystemBoolExp;
};


/** mutation root */
export type MutationRootDeleteProviderFamilyPaymentSystemByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteProviderFeeArgs = {
  where: ProviderFeeBoolExp;
};


/** mutation root */
export type MutationRootDeleteProviderFeeByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteProviderLimitArgs = {
  where: ProviderLimitBoolExp;
};


/** mutation root */
export type MutationRootDeleteProviderLimitByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteProviderPaymentSystemArgs = {
  where: ProviderPaymentSystemBoolExp;
};


/** mutation root */
export type MutationRootDeleteProviderPaymentSystemByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteProviderStatusArgs = {
  where: ProviderStatusBoolExp;
};


/** mutation root */
export type MutationRootDeleteProviderStatusByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteRefundRequestStatusArgs = {
  where: RefundRequestStatusBoolExp;
};


/** mutation root */
export type MutationRootDeleteRefundRequestStatusByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteRefundTableArgs = {
  where: RefundTableBoolExp;
};


/** mutation root */
export type MutationRootDeleteRefundTableByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteRegistrationInfoArgs = {
  where: RegistrationInfoBoolExp;
};


/** mutation root */
export type MutationRootDeleteRegistrationInfoByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteRegistrationStatusArgs = {
  where: RegistrationStatusBoolExp;
};


/** mutation root */
export type MutationRootDeleteRegistrationStatusByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteRoleArgs = {
  where: RoleBoolExp;
};


/** mutation root */
export type MutationRootDeleteRoleByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteRollingReserveArgs = {
  where: RollingReserveBoolExp;
};


/** mutation root */
export type MutationRootDeleteRollingReserveByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteSettingArgs = {
  where: SettingBoolExp;
};


/** mutation root */
export type MutationRootDeleteSettingByPkArgs = {
  key: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteSettlementArgs = {
  where: SettlementBoolExp;
};


/** mutation root */
export type MutationRootDeleteSettlementByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteTrafficTypeArgs = {
  where: TrafficTypeBoolExp;
};


/** mutation root */
export type MutationRootDeleteTrafficTypeByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteTransactionHistoryArgs = {
  where: TransactionHistoryBoolExp;
};


/** mutation root */
export type MutationRootDeleteTransactionHistoryByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteUserArgs = {
  where: UserBoolExp;
};


/** mutation root */
export type MutationRootDeleteUserActivateTokenArgs = {
  where: UserActivateTokenBoolExp;
};


/** mutation root */
export type MutationRootDeleteUserActivateTokenByPkArgs = {
  token: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteUserAuditArgs = {
  where: UserAuditBoolExp;
};


/** mutation root */
export type MutationRootDeleteUserAuditByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteUserByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteUserInfoArgs = {
  where: UserInfoBoolExp;
};


/** mutation root */
export type MutationRootDeleteUserInfoByPkArgs = {
  user_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteUserReportsArgs = {
  where: UserReportsBoolExp;
};


/** mutation root */
export type MutationRootDeleteUserReportsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteVActiveGateArgs = {
  where: VActiveGateBoolExp;
};


/** mutation root */
export type MutationRootDeleteVActiveProviderArgs = {
  where: VActiveProviderBoolExp;
};


/** mutation root */
export type MutationRootDeleteWidgetTypeArgs = {
  where: WidgetTypeBoolExp;
};


/** mutation root */
export type MutationRootDeleteWidgetTypeByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteWithdrawArgs = {
  where: WithdrawBoolExp;
};


/** mutation root */
export type MutationRootDeleteWithdrawByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteWithdrawRequestArgs = {
  where: WithdrawRequestBoolExp;
};


/** mutation root */
export type MutationRootDeleteWithdrawRequestByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRootDeleteWithdrawRequestStatusArgs = {
  where: WithdrawRequestStatusBoolExp;
};


/** mutation root */
export type MutationRootDeleteWithdrawRequestStatusByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootFrozenBalanceRecalculateArgs = {
  currency_id: Scalars['String'];
  merchant_id: Scalars['Int'];
  provider_id: Scalars['String'];
  save?: InputMaybe<Scalars['Boolean']>;
};


/** mutation root */
export type MutationRootGatePaymentLimitValueArgs = {
  gate_id: Scalars['String'];
};


/** mutation root */
export type MutationRootGeneralCreateInvoiceArgs = {
  additional_data?: InputMaybe<AdditionalDataInput>;
  card_cvv?: InputMaybe<Scalars['String']>;
  card_month?: InputMaybe<Scalars['String']>;
  card_number?: InputMaybe<Scalars['String']>;
  card_year?: InputMaybe<Scalars['String']>;
  cardholder?: InputMaybe<Scalars['String']>;
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootGeneralCreateWithdrawArgs = {
  ad_id?: InputMaybe<Scalars['String']>;
  additional_data?: InputMaybe<AdditionalDataWithdrawInput>;
  bank_name?: InputMaybe<Scalars['String']>;
  card_number?: InputMaybe<Scalars['String']>;
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootHrzH2hCreateArgs = {
  card_cvv: Scalars['String'];
  card_month: Scalars['String'];
  card_number: Scalars['String'];
  card_year: Scalars['String'];
  cardholder: Scalars['String'];
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootHrzInvoiceInfoArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootHrzRefreshTokenArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
  refresh_token: Scalars['String'];
};


/** mutation root */
export type MutationRootInsertAuditArgs = {
  objects: Array<AuditInsertInput>;
  on_conflict?: InputMaybe<AuditOnConflict>;
};


/** mutation root */
export type MutationRootInsertAuditOneArgs = {
  object: AuditInsertInput;
  on_conflict?: InputMaybe<AuditOnConflict>;
};


/** mutation root */
export type MutationRootInsertBlacklistArgs = {
  objects: Array<BlacklistInsertInput>;
  on_conflict?: InputMaybe<BlacklistOnConflict>;
};


/** mutation root */
export type MutationRootInsertBlacklistOneArgs = {
  object: BlacklistInsertInput;
  on_conflict?: InputMaybe<BlacklistOnConflict>;
};


/** mutation root */
export type MutationRootInsertCardSystemArgs = {
  objects: Array<CardSystemInsertInput>;
  on_conflict?: InputMaybe<CardSystemOnConflict>;
};


/** mutation root */
export type MutationRootInsertCardSystemOneArgs = {
  object: CardSystemInsertInput;
  on_conflict?: InputMaybe<CardSystemOnConflict>;
};


/** mutation root */
export type MutationRootInsertCascadeItemArgs = {
  objects: Array<CascadeItemInsertInput>;
  on_conflict?: InputMaybe<CascadeItemOnConflict>;
};


/** mutation root */
export type MutationRootInsertCascadeItemOneArgs = {
  object: CascadeItemInsertInput;
  on_conflict?: InputMaybe<CascadeItemOnConflict>;
};


/** mutation root */
export type MutationRootInsertCascadeRequestArgs = {
  objects: Array<CascadeRequestInsertInput>;
  on_conflict?: InputMaybe<CascadeRequestOnConflict>;
};


/** mutation root */
export type MutationRootInsertCascadeRequestOneArgs = {
  object: CascadeRequestInsertInput;
  on_conflict?: InputMaybe<CascadeRequestOnConflict>;
};


/** mutation root */
export type MutationRootInsertCascadesArgs = {
  objects: Array<CascadesInsertInput>;
  on_conflict?: InputMaybe<CascadesOnConflict>;
};


/** mutation root */
export type MutationRootInsertCascadesOneArgs = {
  object: CascadesInsertInput;
  on_conflict?: InputMaybe<CascadesOnConflict>;
};


/** mutation root */
export type MutationRootInsertCountryArgs = {
  objects: Array<CountryInsertInput>;
  on_conflict?: InputMaybe<CountryOnConflict>;
};


/** mutation root */
export type MutationRootInsertCountryOneArgs = {
  object: CountryInsertInput;
  on_conflict?: InputMaybe<CountryOnConflict>;
};


/** mutation root */
export type MutationRootInsertCountryRegionArgs = {
  objects: Array<CountryRegionInsertInput>;
  on_conflict?: InputMaybe<CountryRegionOnConflict>;
};


/** mutation root */
export type MutationRootInsertCountryRegionOneArgs = {
  object: CountryRegionInsertInput;
  on_conflict?: InputMaybe<CountryRegionOnConflict>;
};


/** mutation root */
export type MutationRootInsertCryptoCurrencyArgs = {
  objects: Array<CryptoCurrencyInsertInput>;
  on_conflict?: InputMaybe<CryptoCurrencyOnConflict>;
};


/** mutation root */
export type MutationRootInsertCryptoCurrencyOneArgs = {
  object: CryptoCurrencyInsertInput;
  on_conflict?: InputMaybe<CryptoCurrencyOnConflict>;
};


/** mutation root */
export type MutationRootInsertCryptoWithdrawRequestArgs = {
  objects: Array<CryptoWithdrawRequestInsertInput>;
  on_conflict?: InputMaybe<CryptoWithdrawRequestOnConflict>;
};


/** mutation root */
export type MutationRootInsertCryptoWithdrawRequestOneArgs = {
  object: CryptoWithdrawRequestInsertInput;
  on_conflict?: InputMaybe<CryptoWithdrawRequestOnConflict>;
};


/** mutation root */
export type MutationRootInsertCryptoWithdrawRequestStatusArgs = {
  objects: Array<CryptoWithdrawRequestStatusInsertInput>;
  on_conflict?: InputMaybe<CryptoWithdrawRequestStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertCryptoWithdrawRequestStatusOneArgs = {
  object: CryptoWithdrawRequestStatusInsertInput;
  on_conflict?: InputMaybe<CryptoWithdrawRequestStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertCurrencyArgs = {
  objects: Array<CurrencyInsertInput>;
  on_conflict?: InputMaybe<CurrencyOnConflict>;
};


/** mutation root */
export type MutationRootInsertCurrencyOneArgs = {
  object: CurrencyInsertInput;
  on_conflict?: InputMaybe<CurrencyOnConflict>;
};


/** mutation root */
export type MutationRootInsertGateArgs = {
  objects: Array<GateInsertInput>;
  on_conflict?: InputMaybe<GateOnConflict>;
};


/** mutation root */
export type MutationRootInsertGateGroupArgs = {
  objects: Array<GateGroupInsertInput>;
  on_conflict?: InputMaybe<GateGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertGateGroupOneArgs = {
  object: GateGroupInsertInput;
  on_conflict?: InputMaybe<GateGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertGateOneArgs = {
  object: GateInsertInput;
  on_conflict?: InputMaybe<GateOnConflict>;
};


/** mutation root */
export type MutationRootInsertGateTypeArgs = {
  objects: Array<GateTypeInsertInput>;
  on_conflict?: InputMaybe<GateTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertGateTypeOneArgs = {
  object: GateTypeInsertInput;
  on_conflict?: InputMaybe<GateTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertGenderArgs = {
  objects: Array<GenderInsertInput>;
  on_conflict?: InputMaybe<GenderOnConflict>;
};


/** mutation root */
export type MutationRootInsertGenderOneArgs = {
  object: GenderInsertInput;
  on_conflict?: InputMaybe<GenderOnConflict>;
};


/** mutation root */
export type MutationRootInsertHelpArgs = {
  objects: Array<HelpInsertInput>;
  on_conflict?: InputMaybe<HelpOnConflict>;
};


/** mutation root */
export type MutationRootInsertHelpOneArgs = {
  object: HelpInsertInput;
  on_conflict?: InputMaybe<HelpOnConflict>;
};


/** mutation root */
export type MutationRootInsertHelpSectionArgs = {
  objects: Array<HelpSectionInsertInput>;
  on_conflict?: InputMaybe<HelpSectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertHelpSectionOneArgs = {
  object: HelpSectionInsertInput;
  on_conflict?: InputMaybe<HelpSectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertInvoiceArgs = {
  objects: Array<InvoiceInsertInput>;
  on_conflict?: InputMaybe<InvoiceOnConflict>;
};


/** mutation root */
export type MutationRootInsertInvoiceOneArgs = {
  object: InvoiceInsertInput;
  on_conflict?: InputMaybe<InvoiceOnConflict>;
};


/** mutation root */
export type MutationRootInsertLanguageArgs = {
  objects: Array<LanguageInsertInput>;
  on_conflict?: InputMaybe<LanguageOnConflict>;
};


/** mutation root */
export type MutationRootInsertLanguageOneArgs = {
  object: LanguageInsertInput;
  on_conflict?: InputMaybe<LanguageOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantArgs = {
  objects: Array<MerchantInsertInput>;
  on_conflict?: InputMaybe<MerchantOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantApiTokenArgs = {
  objects: Array<MerchantApiTokenInsertInput>;
  on_conflict?: InputMaybe<MerchantApiTokenOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantApiTokenOneArgs = {
  object: MerchantApiTokenInsertInput;
  on_conflict?: InputMaybe<MerchantApiTokenOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantBalanceArgs = {
  objects: Array<MerchantBalanceInsertInput>;
  on_conflict?: InputMaybe<MerchantBalanceOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantBalanceOneArgs = {
  object: MerchantBalanceInsertInput;
  on_conflict?: InputMaybe<MerchantBalanceOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantCurrencyArgs = {
  objects: Array<MerchantCurrencyInsertInput>;
  on_conflict?: InputMaybe<MerchantCurrencyOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantCurrencyOneArgs = {
  object: MerchantCurrencyInsertInput;
  on_conflict?: InputMaybe<MerchantCurrencyOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantFeeArgs = {
  objects: Array<MerchantFeeInsertInput>;
  on_conflict?: InputMaybe<MerchantFeeOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantFeeOneArgs = {
  object: MerchantFeeInsertInput;
  on_conflict?: InputMaybe<MerchantFeeOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantFileArgs = {
  objects: Array<MerchantFileInsertInput>;
  on_conflict?: InputMaybe<MerchantFileOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantFileOneArgs = {
  object: MerchantFileInsertInput;
  on_conflict?: InputMaybe<MerchantFileOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantInfoArgs = {
  objects: Array<MerchantInfoInsertInput>;
  on_conflict?: InputMaybe<MerchantInfoOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantInfoOneArgs = {
  object: MerchantInfoInsertInput;
  on_conflict?: InputMaybe<MerchantInfoOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantNotificationArgs = {
  objects: Array<MerchantNotificationInsertInput>;
  on_conflict?: InputMaybe<MerchantNotificationOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantNotificationOneArgs = {
  object: MerchantNotificationInsertInput;
  on_conflict?: InputMaybe<MerchantNotificationOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantOneArgs = {
  object: MerchantInsertInput;
  on_conflict?: InputMaybe<MerchantOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantTaskArgs = {
  objects: Array<MerchantTaskInsertInput>;
  on_conflict?: InputMaybe<MerchantTaskOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantTaskOneArgs = {
  object: MerchantTaskInsertInput;
  on_conflict?: InputMaybe<MerchantTaskOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantTaskStatusArgs = {
  objects: Array<MerchantTaskStatusInsertInput>;
  on_conflict?: InputMaybe<MerchantTaskStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantTaskStatusOneArgs = {
  object: MerchantTaskStatusInsertInput;
  on_conflict?: InputMaybe<MerchantTaskStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantTaskTypeArgs = {
  objects: Array<MerchantTaskTypeInsertInput>;
  on_conflict?: InputMaybe<MerchantTaskTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantTaskTypeOneArgs = {
  object: MerchantTaskTypeInsertInput;
  on_conflict?: InputMaybe<MerchantTaskTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantTypeArgs = {
  objects: Array<MerchantTypeInsertInput>;
  on_conflict?: InputMaybe<MerchantTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantTypeOneArgs = {
  object: MerchantTypeInsertInput;
  on_conflict?: InputMaybe<MerchantTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantUserArgs = {
  objects: Array<MerchantUserInsertInput>;
  on_conflict?: InputMaybe<MerchantUserOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantUserOneArgs = {
  object: MerchantUserInsertInput;
  on_conflict?: InputMaybe<MerchantUserOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantUserRoleArgs = {
  objects: Array<MerchantUserRoleInsertInput>;
  on_conflict?: InputMaybe<MerchantUserRoleOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantUserRoleOneArgs = {
  object: MerchantUserRoleInsertInput;
  on_conflict?: InputMaybe<MerchantUserRoleOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantWidgetArgs = {
  objects: Array<MerchantWidgetInsertInput>;
  on_conflict?: InputMaybe<MerchantWidgetOnConflict>;
};


/** mutation root */
export type MutationRootInsertMerchantWidgetOneArgs = {
  object: MerchantWidgetInsertInput;
  on_conflict?: InputMaybe<MerchantWidgetOnConflict>;
};


/** mutation root */
export type MutationRootInsertMutexArgs = {
  objects: Array<MutexInsertInput>;
  on_conflict?: InputMaybe<MutexOnConflict>;
};


/** mutation root */
export type MutationRootInsertMutexOneArgs = {
  object: MutexInsertInput;
  on_conflict?: InputMaybe<MutexOnConflict>;
};


/** mutation root */
export type MutationRootInsertNotificationTypeArgs = {
  objects: Array<NotificationTypeInsertInput>;
  on_conflict?: InputMaybe<NotificationTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertNotificationTypeOneArgs = {
  object: NotificationTypeInsertInput;
  on_conflict?: InputMaybe<NotificationTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertPaymentSystemArgs = {
  objects: Array<PaymentSystemInsertInput>;
  on_conflict?: InputMaybe<PaymentSystemOnConflict>;
};


/** mutation root */
export type MutationRootInsertPaymentSystemOneArgs = {
  object: PaymentSystemInsertInput;
  on_conflict?: InputMaybe<PaymentSystemOnConflict>;
};


/** mutation root */
export type MutationRootInsertProfitProviderArgs = {
  objects: Array<ProfitProviderInsertInput>;
  on_conflict?: InputMaybe<ProfitProviderOnConflict>;
};


/** mutation root */
export type MutationRootInsertProfitProviderOneArgs = {
  object: ProfitProviderInsertInput;
  on_conflict?: InputMaybe<ProfitProviderOnConflict>;
};


/** mutation root */
export type MutationRootInsertProfitWithdrawArgs = {
  objects: Array<ProfitWithdrawInsertInput>;
  on_conflict?: InputMaybe<ProfitWithdrawOnConflict>;
};


/** mutation root */
export type MutationRootInsertProfitWithdrawOneArgs = {
  object: ProfitWithdrawInsertInput;
  on_conflict?: InputMaybe<ProfitWithdrawOnConflict>;
};


/** mutation root */
export type MutationRootInsertProviderArgs = {
  objects: Array<ProviderInsertInput>;
  on_conflict?: InputMaybe<ProviderOnConflict>;
};


/** mutation root */
export type MutationRootInsertProviderCountryArgs = {
  objects: Array<ProviderCountryInsertInput>;
  on_conflict?: InputMaybe<ProviderCountryOnConflict>;
};


/** mutation root */
export type MutationRootInsertProviderCountryOneArgs = {
  object: ProviderCountryInsertInput;
  on_conflict?: InputMaybe<ProviderCountryOnConflict>;
};


/** mutation root */
export type MutationRootInsertProviderCountryStateArgs = {
  objects: Array<ProviderCountryStateInsertInput>;
  on_conflict?: InputMaybe<ProviderCountryStateOnConflict>;
};


/** mutation root */
export type MutationRootInsertProviderCountryStateOneArgs = {
  object: ProviderCountryStateInsertInput;
  on_conflict?: InputMaybe<ProviderCountryStateOnConflict>;
};


/** mutation root */
export type MutationRootInsertProviderFamilyArgs = {
  objects: Array<ProviderFamilyInsertInput>;
  on_conflict?: InputMaybe<ProviderFamilyOnConflict>;
};


/** mutation root */
export type MutationRootInsertProviderFamilyOneArgs = {
  object: ProviderFamilyInsertInput;
  on_conflict?: InputMaybe<ProviderFamilyOnConflict>;
};


/** mutation root */
export type MutationRootInsertProviderFamilyPaymentSystemArgs = {
  objects: Array<ProviderFamilyPaymentSystemInsertInput>;
  on_conflict?: InputMaybe<ProviderFamilyPaymentSystemOnConflict>;
};


/** mutation root */
export type MutationRootInsertProviderFamilyPaymentSystemOneArgs = {
  object: ProviderFamilyPaymentSystemInsertInput;
  on_conflict?: InputMaybe<ProviderFamilyPaymentSystemOnConflict>;
};


/** mutation root */
export type MutationRootInsertProviderFeeArgs = {
  objects: Array<ProviderFeeInsertInput>;
  on_conflict?: InputMaybe<ProviderFeeOnConflict>;
};


/** mutation root */
export type MutationRootInsertProviderFeeOneArgs = {
  object: ProviderFeeInsertInput;
  on_conflict?: InputMaybe<ProviderFeeOnConflict>;
};


/** mutation root */
export type MutationRootInsertProviderLimitArgs = {
  objects: Array<ProviderLimitInsertInput>;
  on_conflict?: InputMaybe<ProviderLimitOnConflict>;
};


/** mutation root */
export type MutationRootInsertProviderLimitOneArgs = {
  object: ProviderLimitInsertInput;
  on_conflict?: InputMaybe<ProviderLimitOnConflict>;
};


/** mutation root */
export type MutationRootInsertProviderOneArgs = {
  object: ProviderInsertInput;
  on_conflict?: InputMaybe<ProviderOnConflict>;
};


/** mutation root */
export type MutationRootInsertProviderPaymentSystemArgs = {
  objects: Array<ProviderPaymentSystemInsertInput>;
  on_conflict?: InputMaybe<ProviderPaymentSystemOnConflict>;
};


/** mutation root */
export type MutationRootInsertProviderPaymentSystemOneArgs = {
  object: ProviderPaymentSystemInsertInput;
  on_conflict?: InputMaybe<ProviderPaymentSystemOnConflict>;
};


/** mutation root */
export type MutationRootInsertProviderStatusArgs = {
  objects: Array<ProviderStatusInsertInput>;
  on_conflict?: InputMaybe<ProviderStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertProviderStatusOneArgs = {
  object: ProviderStatusInsertInput;
  on_conflict?: InputMaybe<ProviderStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertRefundRequestStatusArgs = {
  objects: Array<RefundRequestStatusInsertInput>;
  on_conflict?: InputMaybe<RefundRequestStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertRefundRequestStatusOneArgs = {
  object: RefundRequestStatusInsertInput;
  on_conflict?: InputMaybe<RefundRequestStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertRefundTableArgs = {
  objects: Array<RefundTableInsertInput>;
  on_conflict?: InputMaybe<RefundTableOnConflict>;
};


/** mutation root */
export type MutationRootInsertRefundTableOneArgs = {
  object: RefundTableInsertInput;
  on_conflict?: InputMaybe<RefundTableOnConflict>;
};


/** mutation root */
export type MutationRootInsertRegistrationInfoArgs = {
  objects: Array<RegistrationInfoInsertInput>;
  on_conflict?: InputMaybe<RegistrationInfoOnConflict>;
};


/** mutation root */
export type MutationRootInsertRegistrationInfoOneArgs = {
  object: RegistrationInfoInsertInput;
  on_conflict?: InputMaybe<RegistrationInfoOnConflict>;
};


/** mutation root */
export type MutationRootInsertRegistrationStatusArgs = {
  objects: Array<RegistrationStatusInsertInput>;
  on_conflict?: InputMaybe<RegistrationStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertRegistrationStatusOneArgs = {
  object: RegistrationStatusInsertInput;
  on_conflict?: InputMaybe<RegistrationStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertRoleArgs = {
  objects: Array<RoleInsertInput>;
  on_conflict?: InputMaybe<RoleOnConflict>;
};


/** mutation root */
export type MutationRootInsertRoleOneArgs = {
  object: RoleInsertInput;
  on_conflict?: InputMaybe<RoleOnConflict>;
};


/** mutation root */
export type MutationRootInsertRollingReserveArgs = {
  objects: Array<RollingReserveInsertInput>;
  on_conflict?: InputMaybe<RollingReserveOnConflict>;
};


/** mutation root */
export type MutationRootInsertRollingReserveOneArgs = {
  object: RollingReserveInsertInput;
  on_conflict?: InputMaybe<RollingReserveOnConflict>;
};


/** mutation root */
export type MutationRootInsertSettingArgs = {
  objects: Array<SettingInsertInput>;
  on_conflict?: InputMaybe<SettingOnConflict>;
};


/** mutation root */
export type MutationRootInsertSettingOneArgs = {
  object: SettingInsertInput;
  on_conflict?: InputMaybe<SettingOnConflict>;
};


/** mutation root */
export type MutationRootInsertSettlementArgs = {
  objects: Array<SettlementInsertInput>;
  on_conflict?: InputMaybe<SettlementOnConflict>;
};


/** mutation root */
export type MutationRootInsertSettlementOneArgs = {
  object: SettlementInsertInput;
  on_conflict?: InputMaybe<SettlementOnConflict>;
};


/** mutation root */
export type MutationRootInsertTrafficTypeArgs = {
  objects: Array<TrafficTypeInsertInput>;
  on_conflict?: InputMaybe<TrafficTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertTrafficTypeOneArgs = {
  object: TrafficTypeInsertInput;
  on_conflict?: InputMaybe<TrafficTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertTransactionHistoryArgs = {
  objects: Array<TransactionHistoryInsertInput>;
  on_conflict?: InputMaybe<TransactionHistoryOnConflict>;
};


/** mutation root */
export type MutationRootInsertTransactionHistoryOneArgs = {
  object: TransactionHistoryInsertInput;
  on_conflict?: InputMaybe<TransactionHistoryOnConflict>;
};


/** mutation root */
export type MutationRootInsertUserArgs = {
  objects: Array<UserInsertInput>;
  on_conflict?: InputMaybe<UserOnConflict>;
};


/** mutation root */
export type MutationRootInsertUserActivateTokenArgs = {
  objects: Array<UserActivateTokenInsertInput>;
  on_conflict?: InputMaybe<UserActivateTokenOnConflict>;
};


/** mutation root */
export type MutationRootInsertUserActivateTokenOneArgs = {
  object: UserActivateTokenInsertInput;
  on_conflict?: InputMaybe<UserActivateTokenOnConflict>;
};


/** mutation root */
export type MutationRootInsertUserAuditArgs = {
  objects: Array<UserAuditInsertInput>;
  on_conflict?: InputMaybe<UserAuditOnConflict>;
};


/** mutation root */
export type MutationRootInsertUserAuditOneArgs = {
  object: UserAuditInsertInput;
  on_conflict?: InputMaybe<UserAuditOnConflict>;
};


/** mutation root */
export type MutationRootInsertUserInfoArgs = {
  objects: Array<UserInfoInsertInput>;
  on_conflict?: InputMaybe<UserInfoOnConflict>;
};


/** mutation root */
export type MutationRootInsertUserInfoOneArgs = {
  object: UserInfoInsertInput;
  on_conflict?: InputMaybe<UserInfoOnConflict>;
};


/** mutation root */
export type MutationRootInsertUserOneArgs = {
  object: UserInsertInput;
  on_conflict?: InputMaybe<UserOnConflict>;
};


/** mutation root */
export type MutationRootInsertUserReportsArgs = {
  objects: Array<UserReportsInsertInput>;
  on_conflict?: InputMaybe<UserReportsOnConflict>;
};


/** mutation root */
export type MutationRootInsertUserReportsOneArgs = {
  object: UserReportsInsertInput;
  on_conflict?: InputMaybe<UserReportsOnConflict>;
};


/** mutation root */
export type MutationRootInsertVActiveGateArgs = {
  objects: Array<VActiveGateInsertInput>;
};


/** mutation root */
export type MutationRootInsertVActiveGateOneArgs = {
  object: VActiveGateInsertInput;
};


/** mutation root */
export type MutationRootInsertVActiveProviderArgs = {
  objects: Array<VActiveProviderInsertInput>;
};


/** mutation root */
export type MutationRootInsertVActiveProviderOneArgs = {
  object: VActiveProviderInsertInput;
};


/** mutation root */
export type MutationRootInsertWidgetTypeArgs = {
  objects: Array<WidgetTypeInsertInput>;
  on_conflict?: InputMaybe<WidgetTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertWidgetTypeOneArgs = {
  object: WidgetTypeInsertInput;
  on_conflict?: InputMaybe<WidgetTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertWithdrawArgs = {
  objects: Array<WithdrawInsertInput>;
  on_conflict?: InputMaybe<WithdrawOnConflict>;
};


/** mutation root */
export type MutationRootInsertWithdrawOneArgs = {
  object: WithdrawInsertInput;
  on_conflict?: InputMaybe<WithdrawOnConflict>;
};


/** mutation root */
export type MutationRootInsertWithdrawRequestArgs = {
  objects: Array<WithdrawRequestInsertInput>;
  on_conflict?: InputMaybe<WithdrawRequestOnConflict>;
};


/** mutation root */
export type MutationRootInsertWithdrawRequestOneArgs = {
  object: WithdrawRequestInsertInput;
  on_conflict?: InputMaybe<WithdrawRequestOnConflict>;
};


/** mutation root */
export type MutationRootInsertWithdrawRequestStatusArgs = {
  objects: Array<WithdrawRequestStatusInsertInput>;
  on_conflict?: InputMaybe<WithdrawRequestStatusOnConflict>;
};


/** mutation root */
export type MutationRootInsertWithdrawRequestStatusOneArgs = {
  object: WithdrawRequestStatusInsertInput;
  on_conflict?: InputMaybe<WithdrawRequestStatusOnConflict>;
};


/** mutation root */
export type MutationRootInvoiceCreateArgs = {
  amount: Scalars['numeric'];
  comment?: InputMaybe<Scalars['String']>;
  currency_id: Scalars['String'];
  external_id?: InputMaybe<Scalars['String']>;
  gate_id?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRootInvoiceManualCreateArgs = {
  amount: Scalars['numeric'];
  comment: Scalars['String'];
  currency_id: Scalars['String'];
  external_id: Scalars['String'];
  gate_id: Scalars['String'];
  merchant_id: Scalars['Int'];
  provider_id: Scalars['String'];
};


/** mutation root */
export type MutationRootKaH2HInvoiceInfoArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootKhmpWithdrawOrderInfoArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootManualTableSynchronizationArgs = {
  provider_transaction_uid: Scalars['String'];
  status: Scalars['String'];
};


/** mutation root */
export type MutationRootMerchantDeleteArgs = {
  merchantId: Scalars['Int'];
};


/** mutation root */
export type MutationRootMerchantTaskCreateReportRejectedTransactionTaskArgs = {
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  external_id?: InputMaybe<Scalars['String']>;
  gate_id?: InputMaybe<Scalars['String']>;
  is_manual?: InputMaybe<Scalars['Boolean']>;
  transaction_uid?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRootMerchantTaskCreateReportTransactionManagementTaskArgs = {
  currency_id?: InputMaybe<Scalars['String']>;
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  external_id?: InputMaybe<Scalars['String']>;
  gate_id?: InputMaybe<Scalars['String']>;
  is_manual?: InputMaybe<Scalars['Boolean']>;
  status_id?: InputMaybe<Scalars['String']>;
  transaction_uid?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRootMerchantTaskCreateReportWithdrawalsPayoutTaskArgs = {
  currency_id?: InputMaybe<Scalars['String']>;
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  external_id?: InputMaybe<Scalars['String']>;
  gate_id?: InputMaybe<Scalars['String']>;
  is_manual?: InputMaybe<Scalars['Boolean']>;
  status_id?: InputMaybe<Scalars['String']>;
  transaction_uid?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRootMpcvipInvoiceOrderInfoArgs = {
  externalID: Scalars['String'];
};


/** mutation root */
export type MutationRootMvP2PConfirmArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootMvP2PCreateArgs = {
  pay_source: Scalars['Int'];
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootMxCreateInvoiceApmArgs = {
  email: Scalars['String'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  phone: Scalars['String'];
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootMxH2HCreateArgs = {
  card_cvv: Scalars['String'];
  card_month: Scalars['String'];
  card_number: Scalars['String'];
  card_year: Scalars['String'];
  cardholder: Scalars['String'];
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootMxH2HInvoiceInfoArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootMxInternalBalancesArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
};


/** mutation root */
export type MutationRootOtpActivateArgs = {
  token: Scalars['String'];
};


/** mutation root */
export type MutationRootOtpDisableArgs = {
  token: Scalars['String'];
};


/** mutation root */
export type MutationRootPaylamaGenerateInvoiceArgs = {
  data: Scalars['json'];
};


/** mutation root */
export type MutationRootPaylamaSyncActiveTransactionArgs = {
  ID: Scalars['Int'];
  orderType: Scalars['String'];
};


/** mutation root */
export type MutationRootPaylamaTransactionUpdateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


/** mutation root */
export type MutationRootPctCreateApmInvoiceArgs = {
  address: Scalars['String'];
  card_cvv: Scalars['String'];
  card_month: Scalars['String'];
  card_number: Scalars['String'];
  card_year: Scalars['String'];
  city: Scalars['String'];
  country_code: Scalars['String'];
  date_of_birth: Scalars['String'];
  email: Scalars['String'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootPctInvoiceInfoArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootPdH2HCreateArgs = {
  card_cvv: Scalars['String'];
  card_month: Scalars['String'];
  card_number: Scalars['String'];
  card_year: Scalars['String'];
  cardholder: Scalars['String'];
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootPdH2HInvoiceInfoArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootPdInternalBalancesSyncArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
};


/** mutation root */
export type MutationRootPlgGetToolsArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
  service_id?: InputMaybe<Scalars['numeric']>;
};


/** mutation root */
export type MutationRootPlgInternalBalancesArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
};


/** mutation root */
export type MutationRootPlgInvoiceOrderInfoArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootPmtappawWithdrawOrderInfoArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
  provider_withdraw_id: Scalars['String'];
};


/** mutation root */
export type MutationRootPncCreateArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootPncInvoiceInfoArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootPncInvoiceOrderInfoArgs = {
  currency_id: Scalars['String'];
  guid: Scalars['String'];
  provider_id: Scalars['String'];
};


/** mutation root */
export type MutationRootPpP2PCancelArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootPpP2PConfirmArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootPpP2PCreateArgs = {
  ad_id: Scalars['String'];
  emirates_id?: InputMaybe<Scalars['String']>;
  payment_system_type: Scalars['String'];
  phone_number?: InputMaybe<Scalars['String']>;
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootPpP2PInfoArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootPpP2PRequestArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootPpP2PWithdrawCancelArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootPpP2PWithdrawCreateArgs = {
  ad_id: Scalars['String'];
  bank_name: Scalars['String'];
  card_number: Scalars['String'];
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootPpP2PWithdrawRequestArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootPspFormDataArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootPspInvoiceInfoArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootPspInvoiceStatusArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootPspPaymentConfirmArgs = {
  trans_type: Scalars['String'];
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootQgInvoiceInfoArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootReconciliationInvoiceByFamilyArgs = {
  created_at_gte?: InputMaybe<Scalars['date']>;
  created_at_lte?: InputMaybe<Scalars['date']>;
  provider_family: Scalars['String'];
};


/** mutation root */
export type MutationRootReconciliationWithdrawByFamilyArgs = {
  created_at_gte?: InputMaybe<Scalars['date']>;
  created_at_lte?: InputMaybe<Scalars['date']>;
  provider_family: Scalars['String'];
};


/** mutation root */
export type MutationRootRecurentStatusInfoArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
  request_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootRecurentTokenInfoArgs = {
  request_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootRecurrentCreateTokenArgs = {
  card_cvv?: InputMaybe<Scalars['String']>;
  card_month?: InputMaybe<Scalars['String']>;
  card_number?: InputMaybe<Scalars['String']>;
  card_year?: InputMaybe<Scalars['String']>;
  cardholder?: InputMaybe<Scalars['String']>;
  request_uid?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRootRefundCancelArgs = {
  refund_id: Scalars['String'];
};


/** mutation root */
export type MutationRootRefundCancelRequestArgs = {
  refund_id: Scalars['String'];
};


/** mutation root */
export type MutationRootRefundCreateArgs = {
  comment: Scalars['String'];
  refund_fee: Scalars['numeric'];
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootRefundCreateRequestArgs = {
  comment?: InputMaybe<Scalars['String']>;
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootRefundPayoutRequestArgs = {
  comment?: InputMaybe<Scalars['String']>;
  refund_fee: Scalars['numeric'];
  refund_id: Scalars['String'];
};


/** mutation root */
export type MutationRootRefundRejectRequestArgs = {
  comment?: InputMaybe<Scalars['String']>;
  refund_id: Scalars['String'];
};


/** mutation root */
export type MutationRootRefundResetRequestArgs = {
  refund_id: Scalars['String'];
};


/** mutation root */
export type MutationRootRefundReviewRequestArgs = {
  refund_id: Scalars['String'];
};


/** mutation root */
export type MutationRootResolveReconciliationConflictsArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootRqInvoiceConfirmArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootRqInvoiceCreateArgs = {
  pay_source: Scalars['String'];
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootRqInvoiceInfoArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootRqInvoiceOrderInfoArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootRqWithdrawOrderInfoArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootSaveReportsArgs = {
  currency_id: Scalars['String'];
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  gate_group_id?: InputMaybe<Scalars['String']>;
  gate_id?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRootSendRejectNotificationArgs = {
  email: Scalars['String'];
};


/** mutation root */
export type MutationRootSetProviderFeeArgs = {
  constant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  constant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  currency_id: Scalars['String'];
  invoice_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  invoice_fee_percent?: InputMaybe<Scalars['numeric']>;
  invoice_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_constant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  merchant_constant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  provider_id: Scalars['String'];
  rolling_reserve_percent?: InputMaybe<Scalars['numeric']>;
  withdraw_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  withdraw_fee_percent?: InputMaybe<Scalars['numeric']>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  withdraw_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
};


/** mutation root */
export type MutationRootUpdateAuditArgs = {
  _append?: InputMaybe<AuditAppendInput>;
  _delete_at_path?: InputMaybe<AuditDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AuditDeleteElemInput>;
  _delete_key?: InputMaybe<AuditDeleteKeyInput>;
  _inc?: InputMaybe<AuditIncInput>;
  _prepend?: InputMaybe<AuditPrependInput>;
  _set?: InputMaybe<AuditSetInput>;
  where: AuditBoolExp;
};


/** mutation root */
export type MutationRootUpdateAuditByPkArgs = {
  _append?: InputMaybe<AuditAppendInput>;
  _delete_at_path?: InputMaybe<AuditDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AuditDeleteElemInput>;
  _delete_key?: InputMaybe<AuditDeleteKeyInput>;
  _inc?: InputMaybe<AuditIncInput>;
  _prepend?: InputMaybe<AuditPrependInput>;
  _set?: InputMaybe<AuditSetInput>;
  pk_columns: AuditPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAuditManyArgs = {
  updates: Array<AuditUpdates>;
};


/** mutation root */
export type MutationRootUpdateBlacklistArgs = {
  _inc?: InputMaybe<BlacklistIncInput>;
  _set?: InputMaybe<BlacklistSetInput>;
  where: BlacklistBoolExp;
};


/** mutation root */
export type MutationRootUpdateBlacklistByPkArgs = {
  _inc?: InputMaybe<BlacklistIncInput>;
  _set?: InputMaybe<BlacklistSetInput>;
  pk_columns: BlacklistPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBlacklistManyArgs = {
  updates: Array<BlacklistUpdates>;
};


/** mutation root */
export type MutationRootUpdateCardSystemArgs = {
  _set?: InputMaybe<CardSystemSetInput>;
  where: CardSystemBoolExp;
};


/** mutation root */
export type MutationRootUpdateCardSystemByPkArgs = {
  _set?: InputMaybe<CardSystemSetInput>;
  pk_columns: CardSystemPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCardSystemManyArgs = {
  updates: Array<CardSystemUpdates>;
};


/** mutation root */
export type MutationRootUpdateCascadeItemArgs = {
  _inc?: InputMaybe<CascadeItemIncInput>;
  _set?: InputMaybe<CascadeItemSetInput>;
  where: CascadeItemBoolExp;
};


/** mutation root */
export type MutationRootUpdateCascadeItemByPkArgs = {
  _inc?: InputMaybe<CascadeItemIncInput>;
  _set?: InputMaybe<CascadeItemSetInput>;
  pk_columns: CascadeItemPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCascadeItemManyArgs = {
  updates: Array<CascadeItemUpdates>;
};


/** mutation root */
export type MutationRootUpdateCascadeRequestArgs = {
  _append?: InputMaybe<CascadeRequestAppendInput>;
  _delete_at_path?: InputMaybe<CascadeRequestDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CascadeRequestDeleteElemInput>;
  _delete_key?: InputMaybe<CascadeRequestDeleteKeyInput>;
  _prepend?: InputMaybe<CascadeRequestPrependInput>;
  _set?: InputMaybe<CascadeRequestSetInput>;
  where: CascadeRequestBoolExp;
};


/** mutation root */
export type MutationRootUpdateCascadeRequestByPkArgs = {
  _append?: InputMaybe<CascadeRequestAppendInput>;
  _delete_at_path?: InputMaybe<CascadeRequestDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CascadeRequestDeleteElemInput>;
  _delete_key?: InputMaybe<CascadeRequestDeleteKeyInput>;
  _prepend?: InputMaybe<CascadeRequestPrependInput>;
  _set?: InputMaybe<CascadeRequestSetInput>;
  pk_columns: CascadeRequestPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCascadeRequestManyArgs = {
  updates: Array<CascadeRequestUpdates>;
};


/** mutation root */
export type MutationRootUpdateCascadesArgs = {
  _inc?: InputMaybe<CascadesIncInput>;
  _set?: InputMaybe<CascadesSetInput>;
  where: CascadesBoolExp;
};


/** mutation root */
export type MutationRootUpdateCascadesByPkArgs = {
  _inc?: InputMaybe<CascadesIncInput>;
  _set?: InputMaybe<CascadesSetInput>;
  pk_columns: CascadesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCascadesManyArgs = {
  updates: Array<CascadesUpdates>;
};


/** mutation root */
export type MutationRootUpdateCountryArgs = {
  _set?: InputMaybe<CountrySetInput>;
  where: CountryBoolExp;
};


/** mutation root */
export type MutationRootUpdateCountryByPkArgs = {
  _set?: InputMaybe<CountrySetInput>;
  pk_columns: CountryPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCountryManyArgs = {
  updates: Array<CountryUpdates>;
};


/** mutation root */
export type MutationRootUpdateCountryRegionArgs = {
  _set?: InputMaybe<CountryRegionSetInput>;
  where: CountryRegionBoolExp;
};


/** mutation root */
export type MutationRootUpdateCountryRegionByPkArgs = {
  _set?: InputMaybe<CountryRegionSetInput>;
  pk_columns: CountryRegionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCountryRegionManyArgs = {
  updates: Array<CountryRegionUpdates>;
};


/** mutation root */
export type MutationRootUpdateCryptoCurrencyArgs = {
  _set?: InputMaybe<CryptoCurrencySetInput>;
  where: CryptoCurrencyBoolExp;
};


/** mutation root */
export type MutationRootUpdateCryptoCurrencyByPkArgs = {
  _set?: InputMaybe<CryptoCurrencySetInput>;
  pk_columns: CryptoCurrencyPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCryptoCurrencyManyArgs = {
  updates: Array<CryptoCurrencyUpdates>;
};


/** mutation root */
export type MutationRootUpdateCryptoWithdrawRequestArgs = {
  _inc?: InputMaybe<CryptoWithdrawRequestIncInput>;
  _set?: InputMaybe<CryptoWithdrawRequestSetInput>;
  where: CryptoWithdrawRequestBoolExp;
};


/** mutation root */
export type MutationRootUpdateCryptoWithdrawRequestByPkArgs = {
  _inc?: InputMaybe<CryptoWithdrawRequestIncInput>;
  _set?: InputMaybe<CryptoWithdrawRequestSetInput>;
  pk_columns: CryptoWithdrawRequestPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCryptoWithdrawRequestManyArgs = {
  updates: Array<CryptoWithdrawRequestUpdates>;
};


/** mutation root */
export type MutationRootUpdateCryptoWithdrawRequestStatusArgs = {
  _set?: InputMaybe<CryptoWithdrawRequestStatusSetInput>;
  where: CryptoWithdrawRequestStatusBoolExp;
};


/** mutation root */
export type MutationRootUpdateCryptoWithdrawRequestStatusByPkArgs = {
  _set?: InputMaybe<CryptoWithdrawRequestStatusSetInput>;
  pk_columns: CryptoWithdrawRequestStatusPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCryptoWithdrawRequestStatusManyArgs = {
  updates: Array<CryptoWithdrawRequestStatusUpdates>;
};


/** mutation root */
export type MutationRootUpdateCurrencyArgs = {
  _set?: InputMaybe<CurrencySetInput>;
  where: CurrencyBoolExp;
};


/** mutation root */
export type MutationRootUpdateCurrencyByPkArgs = {
  _set?: InputMaybe<CurrencySetInput>;
  pk_columns: CurrencyPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCurrencyManyArgs = {
  updates: Array<CurrencyUpdates>;
};


/** mutation root */
export type MutationRootUpdateGateArgs = {
  _append?: InputMaybe<GateAppendInput>;
  _delete_at_path?: InputMaybe<GateDeleteAtPathInput>;
  _delete_elem?: InputMaybe<GateDeleteElemInput>;
  _delete_key?: InputMaybe<GateDeleteKeyInput>;
  _inc?: InputMaybe<GateIncInput>;
  _prepend?: InputMaybe<GatePrependInput>;
  _set?: InputMaybe<GateSetInput>;
  where: GateBoolExp;
};


/** mutation root */
export type MutationRootUpdateGateByPkArgs = {
  _append?: InputMaybe<GateAppendInput>;
  _delete_at_path?: InputMaybe<GateDeleteAtPathInput>;
  _delete_elem?: InputMaybe<GateDeleteElemInput>;
  _delete_key?: InputMaybe<GateDeleteKeyInput>;
  _inc?: InputMaybe<GateIncInput>;
  _prepend?: InputMaybe<GatePrependInput>;
  _set?: InputMaybe<GateSetInput>;
  pk_columns: GatePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGateGroupArgs = {
  _inc?: InputMaybe<GateGroupIncInput>;
  _set?: InputMaybe<GateGroupSetInput>;
  where: GateGroupBoolExp;
};


/** mutation root */
export type MutationRootUpdateGateGroupByPkArgs = {
  _inc?: InputMaybe<GateGroupIncInput>;
  _set?: InputMaybe<GateGroupSetInput>;
  pk_columns: GateGroupPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGateGroupManyArgs = {
  updates: Array<GateGroupUpdates>;
};


/** mutation root */
export type MutationRootUpdateGateManyArgs = {
  updates: Array<GateUpdates>;
};


/** mutation root */
export type MutationRootUpdateGateTypeArgs = {
  _set?: InputMaybe<GateTypeSetInput>;
  where: GateTypeBoolExp;
};


/** mutation root */
export type MutationRootUpdateGateTypeByPkArgs = {
  _set?: InputMaybe<GateTypeSetInput>;
  pk_columns: GateTypePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGateTypeManyArgs = {
  updates: Array<GateTypeUpdates>;
};


/** mutation root */
export type MutationRootUpdateGenderArgs = {
  _set?: InputMaybe<GenderSetInput>;
  where: GenderBoolExp;
};


/** mutation root */
export type MutationRootUpdateGenderByPkArgs = {
  _set?: InputMaybe<GenderSetInput>;
  pk_columns: GenderPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGenderManyArgs = {
  updates: Array<GenderUpdates>;
};


/** mutation root */
export type MutationRootUpdateHelpArgs = {
  _inc?: InputMaybe<HelpIncInput>;
  _set?: InputMaybe<HelpSetInput>;
  where: HelpBoolExp;
};


/** mutation root */
export type MutationRootUpdateHelpByPkArgs = {
  _inc?: InputMaybe<HelpIncInput>;
  _set?: InputMaybe<HelpSetInput>;
  pk_columns: HelpPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateHelpManyArgs = {
  updates: Array<HelpUpdates>;
};


/** mutation root */
export type MutationRootUpdateHelpSectionArgs = {
  _set?: InputMaybe<HelpSectionSetInput>;
  where: HelpSectionBoolExp;
};


/** mutation root */
export type MutationRootUpdateHelpSectionByPkArgs = {
  _set?: InputMaybe<HelpSectionSetInput>;
  pk_columns: HelpSectionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateHelpSectionManyArgs = {
  updates: Array<HelpSectionUpdates>;
};


/** mutation root */
export type MutationRootUpdateInvoiceArgs = {
  _append?: InputMaybe<InvoiceAppendInput>;
  _delete_at_path?: InputMaybe<InvoiceDeleteAtPathInput>;
  _delete_elem?: InputMaybe<InvoiceDeleteElemInput>;
  _delete_key?: InputMaybe<InvoiceDeleteKeyInput>;
  _inc?: InputMaybe<InvoiceIncInput>;
  _prepend?: InputMaybe<InvoicePrependInput>;
  _set?: InputMaybe<InvoiceSetInput>;
  where: InvoiceBoolExp;
};


/** mutation root */
export type MutationRootUpdateInvoiceByPkArgs = {
  _append?: InputMaybe<InvoiceAppendInput>;
  _delete_at_path?: InputMaybe<InvoiceDeleteAtPathInput>;
  _delete_elem?: InputMaybe<InvoiceDeleteElemInput>;
  _delete_key?: InputMaybe<InvoiceDeleteKeyInput>;
  _inc?: InputMaybe<InvoiceIncInput>;
  _prepend?: InputMaybe<InvoicePrependInput>;
  _set?: InputMaybe<InvoiceSetInput>;
  pk_columns: InvoicePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateInvoiceManyArgs = {
  updates: Array<InvoiceUpdates>;
};


/** mutation root */
export type MutationRootUpdateLanguageArgs = {
  _set?: InputMaybe<LanguageSetInput>;
  where: LanguageBoolExp;
};


/** mutation root */
export type MutationRootUpdateLanguageByPkArgs = {
  _set?: InputMaybe<LanguageSetInput>;
  pk_columns: LanguagePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateLanguageManyArgs = {
  updates: Array<LanguageUpdates>;
};


/** mutation root */
export type MutationRootUpdateMerchantArgs = {
  _inc?: InputMaybe<MerchantIncInput>;
  _set?: InputMaybe<MerchantSetInput>;
  where: MerchantBoolExp;
};


/** mutation root */
export type MutationRootUpdateMerchantApiTokenArgs = {
  _inc?: InputMaybe<MerchantApiTokenIncInput>;
  _set?: InputMaybe<MerchantApiTokenSetInput>;
  where: MerchantApiTokenBoolExp;
};


/** mutation root */
export type MutationRootUpdateMerchantApiTokenByPkArgs = {
  _inc?: InputMaybe<MerchantApiTokenIncInput>;
  _set?: InputMaybe<MerchantApiTokenSetInput>;
  pk_columns: MerchantApiTokenPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateMerchantApiTokenManyArgs = {
  updates: Array<MerchantApiTokenUpdates>;
};


/** mutation root */
export type MutationRootUpdateMerchantBalanceArgs = {
  _inc?: InputMaybe<MerchantBalanceIncInput>;
  _set?: InputMaybe<MerchantBalanceSetInput>;
  where: MerchantBalanceBoolExp;
};


/** mutation root */
export type MutationRootUpdateMerchantBalanceByPkArgs = {
  _inc?: InputMaybe<MerchantBalanceIncInput>;
  _set?: InputMaybe<MerchantBalanceSetInput>;
  pk_columns: MerchantBalancePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateMerchantBalanceManyArgs = {
  updates: Array<MerchantBalanceUpdates>;
};


/** mutation root */
export type MutationRootUpdateMerchantByPkArgs = {
  _inc?: InputMaybe<MerchantIncInput>;
  _set?: InputMaybe<MerchantSetInput>;
  pk_columns: MerchantPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateMerchantCurrencyArgs = {
  _inc?: InputMaybe<MerchantCurrencyIncInput>;
  _set?: InputMaybe<MerchantCurrencySetInput>;
  where: MerchantCurrencyBoolExp;
};


/** mutation root */
export type MutationRootUpdateMerchantCurrencyByPkArgs = {
  _inc?: InputMaybe<MerchantCurrencyIncInput>;
  _set?: InputMaybe<MerchantCurrencySetInput>;
  pk_columns: MerchantCurrencyPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateMerchantCurrencyManyArgs = {
  updates: Array<MerchantCurrencyUpdates>;
};


/** mutation root */
export type MutationRootUpdateMerchantFeeArgs = {
  _inc?: InputMaybe<MerchantFeeIncInput>;
  _set?: InputMaybe<MerchantFeeSetInput>;
  where: MerchantFeeBoolExp;
};


/** mutation root */
export type MutationRootUpdateMerchantFeeByPkArgs = {
  _inc?: InputMaybe<MerchantFeeIncInput>;
  _set?: InputMaybe<MerchantFeeSetInput>;
  pk_columns: MerchantFeePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateMerchantFeeManyArgs = {
  updates: Array<MerchantFeeUpdates>;
};


/** mutation root */
export type MutationRootUpdateMerchantFileArgs = {
  _inc?: InputMaybe<MerchantFileIncInput>;
  _set?: InputMaybe<MerchantFileSetInput>;
  where: MerchantFileBoolExp;
};


/** mutation root */
export type MutationRootUpdateMerchantFileByPkArgs = {
  _inc?: InputMaybe<MerchantFileIncInput>;
  _set?: InputMaybe<MerchantFileSetInput>;
  pk_columns: MerchantFilePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateMerchantFileManyArgs = {
  updates: Array<MerchantFileUpdates>;
};


/** mutation root */
export type MutationRootUpdateMerchantInfoArgs = {
  _inc?: InputMaybe<MerchantInfoIncInput>;
  _set?: InputMaybe<MerchantInfoSetInput>;
  where: MerchantInfoBoolExp;
};


/** mutation root */
export type MutationRootUpdateMerchantInfoByPkArgs = {
  _inc?: InputMaybe<MerchantInfoIncInput>;
  _set?: InputMaybe<MerchantInfoSetInput>;
  pk_columns: MerchantInfoPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateMerchantInfoManyArgs = {
  updates: Array<MerchantInfoUpdates>;
};


/** mutation root */
export type MutationRootUpdateMerchantManyArgs = {
  updates: Array<MerchantUpdates>;
};


/** mutation root */
export type MutationRootUpdateMerchantNotificationArgs = {
  _inc?: InputMaybe<MerchantNotificationIncInput>;
  _set?: InputMaybe<MerchantNotificationSetInput>;
  where: MerchantNotificationBoolExp;
};


/** mutation root */
export type MutationRootUpdateMerchantNotificationByPkArgs = {
  _inc?: InputMaybe<MerchantNotificationIncInput>;
  _set?: InputMaybe<MerchantNotificationSetInput>;
  pk_columns: MerchantNotificationPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateMerchantNotificationManyArgs = {
  updates: Array<MerchantNotificationUpdates>;
};


/** mutation root */
export type MutationRootUpdateMerchantTaskArgs = {
  _append?: InputMaybe<MerchantTaskAppendInput>;
  _delete_at_path?: InputMaybe<MerchantTaskDeleteAtPathInput>;
  _delete_elem?: InputMaybe<MerchantTaskDeleteElemInput>;
  _delete_key?: InputMaybe<MerchantTaskDeleteKeyInput>;
  _inc?: InputMaybe<MerchantTaskIncInput>;
  _prepend?: InputMaybe<MerchantTaskPrependInput>;
  _set?: InputMaybe<MerchantTaskSetInput>;
  where: MerchantTaskBoolExp;
};


/** mutation root */
export type MutationRootUpdateMerchantTaskByPkArgs = {
  _append?: InputMaybe<MerchantTaskAppendInput>;
  _delete_at_path?: InputMaybe<MerchantTaskDeleteAtPathInput>;
  _delete_elem?: InputMaybe<MerchantTaskDeleteElemInput>;
  _delete_key?: InputMaybe<MerchantTaskDeleteKeyInput>;
  _inc?: InputMaybe<MerchantTaskIncInput>;
  _prepend?: InputMaybe<MerchantTaskPrependInput>;
  _set?: InputMaybe<MerchantTaskSetInput>;
  pk_columns: MerchantTaskPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateMerchantTaskManyArgs = {
  updates: Array<MerchantTaskUpdates>;
};


/** mutation root */
export type MutationRootUpdateMerchantTaskStatusArgs = {
  _set?: InputMaybe<MerchantTaskStatusSetInput>;
  where: MerchantTaskStatusBoolExp;
};


/** mutation root */
export type MutationRootUpdateMerchantTaskStatusByPkArgs = {
  _set?: InputMaybe<MerchantTaskStatusSetInput>;
  pk_columns: MerchantTaskStatusPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateMerchantTaskStatusManyArgs = {
  updates: Array<MerchantTaskStatusUpdates>;
};


/** mutation root */
export type MutationRootUpdateMerchantTaskTypeArgs = {
  _set?: InputMaybe<MerchantTaskTypeSetInput>;
  where: MerchantTaskTypeBoolExp;
};


/** mutation root */
export type MutationRootUpdateMerchantTaskTypeByPkArgs = {
  _set?: InputMaybe<MerchantTaskTypeSetInput>;
  pk_columns: MerchantTaskTypePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateMerchantTaskTypeManyArgs = {
  updates: Array<MerchantTaskTypeUpdates>;
};


/** mutation root */
export type MutationRootUpdateMerchantTypeArgs = {
  _set?: InputMaybe<MerchantTypeSetInput>;
  where: MerchantTypeBoolExp;
};


/** mutation root */
export type MutationRootUpdateMerchantTypeByPkArgs = {
  _set?: InputMaybe<MerchantTypeSetInput>;
  pk_columns: MerchantTypePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateMerchantTypeManyArgs = {
  updates: Array<MerchantTypeUpdates>;
};


/** mutation root */
export type MutationRootUpdateMerchantUserArgs = {
  _inc?: InputMaybe<MerchantUserIncInput>;
  _set?: InputMaybe<MerchantUserSetInput>;
  where: MerchantUserBoolExp;
};


/** mutation root */
export type MutationRootUpdateMerchantUserByPkArgs = {
  _inc?: InputMaybe<MerchantUserIncInput>;
  _set?: InputMaybe<MerchantUserSetInput>;
  pk_columns: MerchantUserPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateMerchantUserManyArgs = {
  updates: Array<MerchantUserUpdates>;
};


/** mutation root */
export type MutationRootUpdateMerchantUserRoleArgs = {
  _set?: InputMaybe<MerchantUserRoleSetInput>;
  where: MerchantUserRoleBoolExp;
};


/** mutation root */
export type MutationRootUpdateMerchantUserRoleByPkArgs = {
  _set?: InputMaybe<MerchantUserRoleSetInput>;
  pk_columns: MerchantUserRolePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateMerchantUserRoleManyArgs = {
  updates: Array<MerchantUserRoleUpdates>;
};


/** mutation root */
export type MutationRootUpdateMerchantWidgetArgs = {
  _append?: InputMaybe<MerchantWidgetAppendInput>;
  _delete_at_path?: InputMaybe<MerchantWidgetDeleteAtPathInput>;
  _delete_elem?: InputMaybe<MerchantWidgetDeleteElemInput>;
  _delete_key?: InputMaybe<MerchantWidgetDeleteKeyInput>;
  _inc?: InputMaybe<MerchantWidgetIncInput>;
  _prepend?: InputMaybe<MerchantWidgetPrependInput>;
  _set?: InputMaybe<MerchantWidgetSetInput>;
  where: MerchantWidgetBoolExp;
};


/** mutation root */
export type MutationRootUpdateMerchantWidgetByPkArgs = {
  _append?: InputMaybe<MerchantWidgetAppendInput>;
  _delete_at_path?: InputMaybe<MerchantWidgetDeleteAtPathInput>;
  _delete_elem?: InputMaybe<MerchantWidgetDeleteElemInput>;
  _delete_key?: InputMaybe<MerchantWidgetDeleteKeyInput>;
  _inc?: InputMaybe<MerchantWidgetIncInput>;
  _prepend?: InputMaybe<MerchantWidgetPrependInput>;
  _set?: InputMaybe<MerchantWidgetSetInput>;
  pk_columns: MerchantWidgetPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateMerchantWidgetManyArgs = {
  updates: Array<MerchantWidgetUpdates>;
};


/** mutation root */
export type MutationRootUpdateMutexArgs = {
  _inc?: InputMaybe<MutexIncInput>;
  _set?: InputMaybe<MutexSetInput>;
  where: MutexBoolExp;
};


/** mutation root */
export type MutationRootUpdateMutexByPkArgs = {
  _inc?: InputMaybe<MutexIncInput>;
  _set?: InputMaybe<MutexSetInput>;
  pk_columns: MutexPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateMutexManyArgs = {
  updates: Array<MutexUpdates>;
};


/** mutation root */
export type MutationRootUpdateNotificationTypeArgs = {
  _set?: InputMaybe<NotificationTypeSetInput>;
  where: NotificationTypeBoolExp;
};


/** mutation root */
export type MutationRootUpdateNotificationTypeByPkArgs = {
  _set?: InputMaybe<NotificationTypeSetInput>;
  pk_columns: NotificationTypePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateNotificationTypeManyArgs = {
  updates: Array<NotificationTypeUpdates>;
};


/** mutation root */
export type MutationRootUpdatePaymentSystemArgs = {
  _set?: InputMaybe<PaymentSystemSetInput>;
  where: PaymentSystemBoolExp;
};


/** mutation root */
export type MutationRootUpdatePaymentSystemByPkArgs = {
  _set?: InputMaybe<PaymentSystemSetInput>;
  pk_columns: PaymentSystemPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdatePaymentSystemManyArgs = {
  updates: Array<PaymentSystemUpdates>;
};


/** mutation root */
export type MutationRootUpdateProfitProviderArgs = {
  _inc?: InputMaybe<ProfitProviderIncInput>;
  _set?: InputMaybe<ProfitProviderSetInput>;
  where: ProfitProviderBoolExp;
};


/** mutation root */
export type MutationRootUpdateProfitProviderByPkArgs = {
  _inc?: InputMaybe<ProfitProviderIncInput>;
  _set?: InputMaybe<ProfitProviderSetInput>;
  pk_columns: ProfitProviderPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProfitProviderManyArgs = {
  updates: Array<ProfitProviderUpdates>;
};


/** mutation root */
export type MutationRootUpdateProfitWithdrawArgs = {
  _inc?: InputMaybe<ProfitWithdrawIncInput>;
  _set?: InputMaybe<ProfitWithdrawSetInput>;
  where: ProfitWithdrawBoolExp;
};


/** mutation root */
export type MutationRootUpdateProfitWithdrawByPkArgs = {
  _inc?: InputMaybe<ProfitWithdrawIncInput>;
  _set?: InputMaybe<ProfitWithdrawSetInput>;
  pk_columns: ProfitWithdrawPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProfitWithdrawManyArgs = {
  updates: Array<ProfitWithdrawUpdates>;
};


/** mutation root */
export type MutationRootUpdateProviderArgs = {
  _inc?: InputMaybe<ProviderIncInput>;
  _set?: InputMaybe<ProviderSetInput>;
  where: ProviderBoolExp;
};


/** mutation root */
export type MutationRootUpdateProviderByPkArgs = {
  _inc?: InputMaybe<ProviderIncInput>;
  _set?: InputMaybe<ProviderSetInput>;
  pk_columns: ProviderPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProviderCountryArgs = {
  _inc?: InputMaybe<ProviderCountryIncInput>;
  _set?: InputMaybe<ProviderCountrySetInput>;
  where: ProviderCountryBoolExp;
};


/** mutation root */
export type MutationRootUpdateProviderCountryByPkArgs = {
  _inc?: InputMaybe<ProviderCountryIncInput>;
  _set?: InputMaybe<ProviderCountrySetInput>;
  pk_columns: ProviderCountryPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProviderCountryManyArgs = {
  updates: Array<ProviderCountryUpdates>;
};


/** mutation root */
export type MutationRootUpdateProviderCountryStateArgs = {
  _set?: InputMaybe<ProviderCountryStateSetInput>;
  where: ProviderCountryStateBoolExp;
};


/** mutation root */
export type MutationRootUpdateProviderCountryStateByPkArgs = {
  _set?: InputMaybe<ProviderCountryStateSetInput>;
  pk_columns: ProviderCountryStatePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProviderCountryStateManyArgs = {
  updates: Array<ProviderCountryStateUpdates>;
};


/** mutation root */
export type MutationRootUpdateProviderFamilyArgs = {
  _inc?: InputMaybe<ProviderFamilyIncInput>;
  _set?: InputMaybe<ProviderFamilySetInput>;
  where: ProviderFamilyBoolExp;
};


/** mutation root */
export type MutationRootUpdateProviderFamilyByPkArgs = {
  _inc?: InputMaybe<ProviderFamilyIncInput>;
  _set?: InputMaybe<ProviderFamilySetInput>;
  pk_columns: ProviderFamilyPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProviderFamilyManyArgs = {
  updates: Array<ProviderFamilyUpdates>;
};


/** mutation root */
export type MutationRootUpdateProviderFamilyPaymentSystemArgs = {
  _inc?: InputMaybe<ProviderFamilyPaymentSystemIncInput>;
  _set?: InputMaybe<ProviderFamilyPaymentSystemSetInput>;
  where: ProviderFamilyPaymentSystemBoolExp;
};


/** mutation root */
export type MutationRootUpdateProviderFamilyPaymentSystemByPkArgs = {
  _inc?: InputMaybe<ProviderFamilyPaymentSystemIncInput>;
  _set?: InputMaybe<ProviderFamilyPaymentSystemSetInput>;
  pk_columns: ProviderFamilyPaymentSystemPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProviderFamilyPaymentSystemManyArgs = {
  updates: Array<ProviderFamilyPaymentSystemUpdates>;
};


/** mutation root */
export type MutationRootUpdateProviderFeeArgs = {
  _inc?: InputMaybe<ProviderFeeIncInput>;
  _set?: InputMaybe<ProviderFeeSetInput>;
  where: ProviderFeeBoolExp;
};


/** mutation root */
export type MutationRootUpdateProviderFeeByPkArgs = {
  _inc?: InputMaybe<ProviderFeeIncInput>;
  _set?: InputMaybe<ProviderFeeSetInput>;
  pk_columns: ProviderFeePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProviderFeeManyArgs = {
  updates: Array<ProviderFeeUpdates>;
};


/** mutation root */
export type MutationRootUpdateProviderLimitArgs = {
  _inc?: InputMaybe<ProviderLimitIncInput>;
  _set?: InputMaybe<ProviderLimitSetInput>;
  where: ProviderLimitBoolExp;
};


/** mutation root */
export type MutationRootUpdateProviderLimitByPkArgs = {
  _inc?: InputMaybe<ProviderLimitIncInput>;
  _set?: InputMaybe<ProviderLimitSetInput>;
  pk_columns: ProviderLimitPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProviderLimitManyArgs = {
  updates: Array<ProviderLimitUpdates>;
};


/** mutation root */
export type MutationRootUpdateProviderManyArgs = {
  updates: Array<ProviderUpdates>;
};


/** mutation root */
export type MutationRootUpdateProviderPaymentSystemArgs = {
  _inc?: InputMaybe<ProviderPaymentSystemIncInput>;
  _set?: InputMaybe<ProviderPaymentSystemSetInput>;
  where: ProviderPaymentSystemBoolExp;
};


/** mutation root */
export type MutationRootUpdateProviderPaymentSystemByPkArgs = {
  _inc?: InputMaybe<ProviderPaymentSystemIncInput>;
  _set?: InputMaybe<ProviderPaymentSystemSetInput>;
  pk_columns: ProviderPaymentSystemPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProviderPaymentSystemManyArgs = {
  updates: Array<ProviderPaymentSystemUpdates>;
};


/** mutation root */
export type MutationRootUpdateProviderStatusArgs = {
  _set?: InputMaybe<ProviderStatusSetInput>;
  where: ProviderStatusBoolExp;
};


/** mutation root */
export type MutationRootUpdateProviderStatusByPkArgs = {
  _set?: InputMaybe<ProviderStatusSetInput>;
  pk_columns: ProviderStatusPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProviderStatusManyArgs = {
  updates: Array<ProviderStatusUpdates>;
};


/** mutation root */
export type MutationRootUpdateRefundRequestStatusArgs = {
  _set?: InputMaybe<RefundRequestStatusSetInput>;
  where: RefundRequestStatusBoolExp;
};


/** mutation root */
export type MutationRootUpdateRefundRequestStatusByPkArgs = {
  _set?: InputMaybe<RefundRequestStatusSetInput>;
  pk_columns: RefundRequestStatusPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRefundRequestStatusManyArgs = {
  updates: Array<RefundRequestStatusUpdates>;
};


/** mutation root */
export type MutationRootUpdateRefundTableArgs = {
  _inc?: InputMaybe<RefundTableIncInput>;
  _set?: InputMaybe<RefundTableSetInput>;
  where: RefundTableBoolExp;
};


/** mutation root */
export type MutationRootUpdateRefundTableByPkArgs = {
  _inc?: InputMaybe<RefundTableIncInput>;
  _set?: InputMaybe<RefundTableSetInput>;
  pk_columns: RefundTablePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRefundTableManyArgs = {
  updates: Array<RefundTableUpdates>;
};


/** mutation root */
export type MutationRootUpdateRegistrationInfoArgs = {
  _append?: InputMaybe<RegistrationInfoAppendInput>;
  _delete_at_path?: InputMaybe<RegistrationInfoDeleteAtPathInput>;
  _delete_elem?: InputMaybe<RegistrationInfoDeleteElemInput>;
  _delete_key?: InputMaybe<RegistrationInfoDeleteKeyInput>;
  _prepend?: InputMaybe<RegistrationInfoPrependInput>;
  _set?: InputMaybe<RegistrationInfoSetInput>;
  where: RegistrationInfoBoolExp;
};


/** mutation root */
export type MutationRootUpdateRegistrationInfoByPkArgs = {
  _append?: InputMaybe<RegistrationInfoAppendInput>;
  _delete_at_path?: InputMaybe<RegistrationInfoDeleteAtPathInput>;
  _delete_elem?: InputMaybe<RegistrationInfoDeleteElemInput>;
  _delete_key?: InputMaybe<RegistrationInfoDeleteKeyInput>;
  _prepend?: InputMaybe<RegistrationInfoPrependInput>;
  _set?: InputMaybe<RegistrationInfoSetInput>;
  pk_columns: RegistrationInfoPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRegistrationInfoManyArgs = {
  updates: Array<RegistrationInfoUpdates>;
};


/** mutation root */
export type MutationRootUpdateRegistrationStatusArgs = {
  _set?: InputMaybe<RegistrationStatusSetInput>;
  where: RegistrationStatusBoolExp;
};


/** mutation root */
export type MutationRootUpdateRegistrationStatusByPkArgs = {
  _set?: InputMaybe<RegistrationStatusSetInput>;
  pk_columns: RegistrationStatusPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRegistrationStatusManyArgs = {
  updates: Array<RegistrationStatusUpdates>;
};


/** mutation root */
export type MutationRootUpdateRoleArgs = {
  _set?: InputMaybe<RoleSetInput>;
  where: RoleBoolExp;
};


/** mutation root */
export type MutationRootUpdateRoleByPkArgs = {
  _set?: InputMaybe<RoleSetInput>;
  pk_columns: RolePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRoleManyArgs = {
  updates: Array<RoleUpdates>;
};


/** mutation root */
export type MutationRootUpdateRollingReserveArgs = {
  _inc?: InputMaybe<RollingReserveIncInput>;
  _set?: InputMaybe<RollingReserveSetInput>;
  where: RollingReserveBoolExp;
};


/** mutation root */
export type MutationRootUpdateRollingReserveByPkArgs = {
  _inc?: InputMaybe<RollingReserveIncInput>;
  _set?: InputMaybe<RollingReserveSetInput>;
  pk_columns: RollingReservePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRollingReserveManyArgs = {
  updates: Array<RollingReserveUpdates>;
};


/** mutation root */
export type MutationRootUpdateSettingArgs = {
  _append?: InputMaybe<SettingAppendInput>;
  _delete_at_path?: InputMaybe<SettingDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SettingDeleteElemInput>;
  _delete_key?: InputMaybe<SettingDeleteKeyInput>;
  _prepend?: InputMaybe<SettingPrependInput>;
  _set?: InputMaybe<SettingSetInput>;
  where: SettingBoolExp;
};


/** mutation root */
export type MutationRootUpdateSettingByPkArgs = {
  _append?: InputMaybe<SettingAppendInput>;
  _delete_at_path?: InputMaybe<SettingDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SettingDeleteElemInput>;
  _delete_key?: InputMaybe<SettingDeleteKeyInput>;
  _prepend?: InputMaybe<SettingPrependInput>;
  _set?: InputMaybe<SettingSetInput>;
  pk_columns: SettingPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateSettingManyArgs = {
  updates: Array<SettingUpdates>;
};


/** mutation root */
export type MutationRootUpdateSettlementArgs = {
  _inc?: InputMaybe<SettlementIncInput>;
  _set?: InputMaybe<SettlementSetInput>;
  where: SettlementBoolExp;
};


/** mutation root */
export type MutationRootUpdateSettlementByPkArgs = {
  _inc?: InputMaybe<SettlementIncInput>;
  _set?: InputMaybe<SettlementSetInput>;
  pk_columns: SettlementPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateSettlementManyArgs = {
  updates: Array<SettlementUpdates>;
};


/** mutation root */
export type MutationRootUpdateTrafficTypeArgs = {
  _set?: InputMaybe<TrafficTypeSetInput>;
  where: TrafficTypeBoolExp;
};


/** mutation root */
export type MutationRootUpdateTrafficTypeByPkArgs = {
  _set?: InputMaybe<TrafficTypeSetInput>;
  pk_columns: TrafficTypePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateTrafficTypeManyArgs = {
  updates: Array<TrafficTypeUpdates>;
};


/** mutation root */
export type MutationRootUpdateTransactionHistoryArgs = {
  _inc?: InputMaybe<TransactionHistoryIncInput>;
  _set?: InputMaybe<TransactionHistorySetInput>;
  where: TransactionHistoryBoolExp;
};


/** mutation root */
export type MutationRootUpdateTransactionHistoryByPkArgs = {
  _inc?: InputMaybe<TransactionHistoryIncInput>;
  _set?: InputMaybe<TransactionHistorySetInput>;
  pk_columns: TransactionHistoryPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateTransactionHistoryManyArgs = {
  updates: Array<TransactionHistoryUpdates>;
};


/** mutation root */
export type MutationRootUpdateUserArgs = {
  _inc?: InputMaybe<UserIncInput>;
  _set?: InputMaybe<UserSetInput>;
  where: UserBoolExp;
};


/** mutation root */
export type MutationRootUpdateUserActivateTokenArgs = {
  _inc?: InputMaybe<UserActivateTokenIncInput>;
  _set?: InputMaybe<UserActivateTokenSetInput>;
  where: UserActivateTokenBoolExp;
};


/** mutation root */
export type MutationRootUpdateUserActivateTokenByPkArgs = {
  _inc?: InputMaybe<UserActivateTokenIncInput>;
  _set?: InputMaybe<UserActivateTokenSetInput>;
  pk_columns: UserActivateTokenPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateUserActivateTokenManyArgs = {
  updates: Array<UserActivateTokenUpdates>;
};


/** mutation root */
export type MutationRootUpdateUserAuditArgs = {
  _append?: InputMaybe<UserAuditAppendInput>;
  _delete_at_path?: InputMaybe<UserAuditDeleteAtPathInput>;
  _delete_elem?: InputMaybe<UserAuditDeleteElemInput>;
  _delete_key?: InputMaybe<UserAuditDeleteKeyInput>;
  _inc?: InputMaybe<UserAuditIncInput>;
  _prepend?: InputMaybe<UserAuditPrependInput>;
  _set?: InputMaybe<UserAuditSetInput>;
  where: UserAuditBoolExp;
};


/** mutation root */
export type MutationRootUpdateUserAuditByPkArgs = {
  _append?: InputMaybe<UserAuditAppendInput>;
  _delete_at_path?: InputMaybe<UserAuditDeleteAtPathInput>;
  _delete_elem?: InputMaybe<UserAuditDeleteElemInput>;
  _delete_key?: InputMaybe<UserAuditDeleteKeyInput>;
  _inc?: InputMaybe<UserAuditIncInput>;
  _prepend?: InputMaybe<UserAuditPrependInput>;
  _set?: InputMaybe<UserAuditSetInput>;
  pk_columns: UserAuditPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateUserAuditManyArgs = {
  updates: Array<UserAuditUpdates>;
};


/** mutation root */
export type MutationRootUpdateUserByPkArgs = {
  _inc?: InputMaybe<UserIncInput>;
  _set?: InputMaybe<UserSetInput>;
  pk_columns: UserPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateUserInfoArgs = {
  _inc?: InputMaybe<UserInfoIncInput>;
  _set?: InputMaybe<UserInfoSetInput>;
  where: UserInfoBoolExp;
};


/** mutation root */
export type MutationRootUpdateUserInfoByPkArgs = {
  _inc?: InputMaybe<UserInfoIncInput>;
  _set?: InputMaybe<UserInfoSetInput>;
  pk_columns: UserInfoPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateUserInfoManyArgs = {
  updates: Array<UserInfoUpdates>;
};


/** mutation root */
export type MutationRootUpdateUserManyArgs = {
  updates: Array<UserUpdates>;
};


/** mutation root */
export type MutationRootUpdateUserReportsArgs = {
  _inc?: InputMaybe<UserReportsIncInput>;
  _set?: InputMaybe<UserReportsSetInput>;
  where: UserReportsBoolExp;
};


/** mutation root */
export type MutationRootUpdateUserReportsByPkArgs = {
  _inc?: InputMaybe<UserReportsIncInput>;
  _set?: InputMaybe<UserReportsSetInput>;
  pk_columns: UserReportsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateUserReportsManyArgs = {
  updates: Array<UserReportsUpdates>;
};


/** mutation root */
export type MutationRootUpdateVActiveGateArgs = {
  _append?: InputMaybe<VActiveGateAppendInput>;
  _delete_at_path?: InputMaybe<VActiveGateDeleteAtPathInput>;
  _delete_elem?: InputMaybe<VActiveGateDeleteElemInput>;
  _delete_key?: InputMaybe<VActiveGateDeleteKeyInput>;
  _inc?: InputMaybe<VActiveGateIncInput>;
  _prepend?: InputMaybe<VActiveGatePrependInput>;
  _set?: InputMaybe<VActiveGateSetInput>;
  where: VActiveGateBoolExp;
};


/** mutation root */
export type MutationRootUpdateVActiveGateManyArgs = {
  updates: Array<VActiveGateUpdates>;
};


/** mutation root */
export type MutationRootUpdateVActiveProviderArgs = {
  _set?: InputMaybe<VActiveProviderSetInput>;
  where: VActiveProviderBoolExp;
};


/** mutation root */
export type MutationRootUpdateVActiveProviderManyArgs = {
  updates: Array<VActiveProviderUpdates>;
};


/** mutation root */
export type MutationRootUpdateWidgetTypeArgs = {
  _set?: InputMaybe<WidgetTypeSetInput>;
  where: WidgetTypeBoolExp;
};


/** mutation root */
export type MutationRootUpdateWidgetTypeByPkArgs = {
  _set?: InputMaybe<WidgetTypeSetInput>;
  pk_columns: WidgetTypePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateWidgetTypeManyArgs = {
  updates: Array<WidgetTypeUpdates>;
};


/** mutation root */
export type MutationRootUpdateWithdrawArgs = {
  _append?: InputMaybe<WithdrawAppendInput>;
  _delete_at_path?: InputMaybe<WithdrawDeleteAtPathInput>;
  _delete_elem?: InputMaybe<WithdrawDeleteElemInput>;
  _delete_key?: InputMaybe<WithdrawDeleteKeyInput>;
  _inc?: InputMaybe<WithdrawIncInput>;
  _prepend?: InputMaybe<WithdrawPrependInput>;
  _set?: InputMaybe<WithdrawSetInput>;
  where: WithdrawBoolExp;
};


/** mutation root */
export type MutationRootUpdateWithdrawByPkArgs = {
  _append?: InputMaybe<WithdrawAppendInput>;
  _delete_at_path?: InputMaybe<WithdrawDeleteAtPathInput>;
  _delete_elem?: InputMaybe<WithdrawDeleteElemInput>;
  _delete_key?: InputMaybe<WithdrawDeleteKeyInput>;
  _inc?: InputMaybe<WithdrawIncInput>;
  _prepend?: InputMaybe<WithdrawPrependInput>;
  _set?: InputMaybe<WithdrawSetInput>;
  pk_columns: WithdrawPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateWithdrawManyArgs = {
  updates: Array<WithdrawUpdates>;
};


/** mutation root */
export type MutationRootUpdateWithdrawRequestArgs = {
  _inc?: InputMaybe<WithdrawRequestIncInput>;
  _set?: InputMaybe<WithdrawRequestSetInput>;
  where: WithdrawRequestBoolExp;
};


/** mutation root */
export type MutationRootUpdateWithdrawRequestByPkArgs = {
  _inc?: InputMaybe<WithdrawRequestIncInput>;
  _set?: InputMaybe<WithdrawRequestSetInput>;
  pk_columns: WithdrawRequestPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateWithdrawRequestManyArgs = {
  updates: Array<WithdrawRequestUpdates>;
};


/** mutation root */
export type MutationRootUpdateWithdrawRequestStatusArgs = {
  _set?: InputMaybe<WithdrawRequestStatusSetInput>;
  where: WithdrawRequestStatusBoolExp;
};


/** mutation root */
export type MutationRootUpdateWithdrawRequestStatusByPkArgs = {
  _set?: InputMaybe<WithdrawRequestStatusSetInput>;
  pk_columns: WithdrawRequestStatusPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateWithdrawRequestStatusManyArgs = {
  updates: Array<WithdrawRequestStatusUpdates>;
};


/** mutation root */
export type MutationRootUsersActivateArgs = {
  token: Scalars['String'];
};


/** mutation root */
export type MutationRootUsersChangePasswordArgs = {
  old_password: Scalars['String'];
  password: Scalars['String'];
};


/** mutation root */
export type MutationRootUsersChangePasswordManagerArgs = {
  password: Scalars['String'];
  user_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootUsersCreatePartnerManagerArgs = {
  email: Scalars['String'];
  gender_id: Scalars['String'];
  merchant_id: Scalars['Int'];
  merchant_user_role_id: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  phone: Scalars['String'];
};


/** mutation root */
export type MutationRootUsersRegisterRestorePasswordArgs = {
  email: Scalars['String'];
};


/** mutation root */
export type MutationRootUsersRegistrationArgs = {
  data: UsersRegistrationInput;
};


/** mutation root */
export type MutationRootUsersRegistrationApproveArgs = {
  registration_info_id: Scalars['String'];
};


/** mutation root */
export type MutationRootUsersRegistrationRejectArgs = {
  reason: Scalars['String'];
  registration_info_id: Scalars['String'];
};


/** mutation root */
export type MutationRootUsersRegistrationResetArgs = {
  registration_info_id: Scalars['String'];
};


/** mutation root */
export type MutationRootUsersRegistrationReviewArgs = {
  registration_info_id: Scalars['String'];
};


/** mutation root */
export type MutationRootUsersRestorePasswordArgs = {
  password: Scalars['String'];
  token: Scalars['String'];
};


/** mutation root */
export type MutationRootWithdrawManualCreateArgs = {
  amount: Scalars['numeric'];
  comment: Scalars['String'];
  currency_id: Scalars['String'];
  external_id: Scalars['String'];
  gate_id: Scalars['String'];
  merchant_id: Scalars['Int'];
  provider_id: Scalars['String'];
};


/** mutation root */
export type MutationRootWithdrawMassWithdrawCreateArgs = {
  amount: Scalars['numeric'];
  callback_url?: InputMaybe<Scalars['String']>;
  card_expires: Scalars['String'];
  card_holder: Scalars['String'];
  card_number: Scalars['String'];
  comment: Scalars['String'];
  currency_id: Scalars['String'];
  external_id: Scalars['String'];
  gate_id?: InputMaybe<Scalars['String']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  withdraw_url?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRootWithdrawRefundCreateArgs = {
  amount: Scalars['Float'];
  card_expires: Scalars['String'];
  card_holder: Scalars['String'];
  card_number: Scalars['String'];
  comment: Scalars['String'];
  external_id: Scalars['String'];
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootWithdrawReplyArgs = {
  withdraw_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootWithdrawRequestApproveArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootWithdrawRequestCreateArgs = {
  amount: Scalars['numeric'];
  comment: Scalars['String'];
  currency_id: Scalars['String'];
  gate_id?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  sanitized_mask: Scalars['String'];
};


/** mutation root */
export type MutationRootWithdrawRequestPayoutArgs = {
  card_number: Scalars['String'];
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootWithdrawRequestRejectArgs = {
  id: Scalars['String'];
  reason: Scalars['String'];
};


/** mutation root */
export type MutationRootWithdrawRequestResetArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootWithdrawToPendingArgs = {
  withdraw_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootWwAgsInvoiceInfoArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootWzrdInvoiceInfoArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootWzrdpayCreateArgs = {
  card_cvv: Scalars['String'];
  card_month: Scalars['String'];
  card_number: Scalars['String'];
  card_year: Scalars['String'];
  cardholder: Scalars['String'];
  request_data: WzrdRequestData;
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootXpH2hCreateArgs = {
  card_cvv: Scalars['String'];
  card_month: Scalars['String'];
  card_number: Scalars['String'];
  card_year: Scalars['String'];
  cardholder: Scalars['String'];
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootXpInvoiceInfoArgs = {
  transaction_uid: Scalars['String'];
};


/** mutation root */
export type MutationRootXpSend3dsArgs = {
  code_3ds: Scalars['String'];
  transaction_uid: Scalars['String'];
};

/** columns and relationships of "mutex" */
export type Mutex = {
  created_at: Scalars['timestamptz'];
  id: Scalars['String'];
  merchant_id?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "mutex" */
export type MutexAggregate = {
  aggregate?: Maybe<MutexAggregateFields>;
  nodes: Array<Mutex>;
};

/** aggregate fields of "mutex" */
export type MutexAggregateFields = {
  avg?: Maybe<MutexAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MutexMaxFields>;
  min?: Maybe<MutexMinFields>;
  stddev?: Maybe<MutexStddevFields>;
  stddev_pop?: Maybe<MutexStddevPopFields>;
  stddev_samp?: Maybe<MutexStddevSampFields>;
  sum?: Maybe<MutexSumFields>;
  var_pop?: Maybe<MutexVarPopFields>;
  var_samp?: Maybe<MutexVarSampFields>;
  variance?: Maybe<MutexVarianceFields>;
};


/** aggregate fields of "mutex" */
export type MutexAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MutexSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type MutexAvgFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "mutex". All fields are combined with a logical 'AND'. */
export type MutexBoolExp = {
  _and?: InputMaybe<Array<MutexBoolExp>>;
  _not?: InputMaybe<MutexBoolExp>;
  _or?: InputMaybe<Array<MutexBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "mutex" */
export enum MutexConstraint {
  /** unique or primary key constraint on columns "id" */
  MutexPkey = 'mutex_pkey'
}

/** input type for incrementing numeric columns in table "mutex" */
export type MutexIncInput = {
  merchant_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "mutex" */
export type MutexInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type MutexMaxFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type MutexMinFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "mutex" */
export type MutexMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Mutex>;
};

/** on_conflict condition type for table "mutex" */
export type MutexOnConflict = {
  constraint: MutexConstraint;
  update_columns?: Array<MutexUpdateColumn>;
  where?: InputMaybe<MutexBoolExp>;
};

/** Ordering options when selecting data from "mutex". */
export type MutexOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: mutex */
export type MutexPkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "mutex" */
export enum MutexSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id'
}

/** input type for updating data in table "mutex" */
export type MutexSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type MutexStddevFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type MutexStddevPopFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type MutexStddevSampFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type MutexSumFields = {
  merchant_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "mutex" */
export enum MutexUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id'
}

export type MutexUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MutexIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MutexSetInput>;
  where: MutexBoolExp;
};

/** aggregate var_pop on columns */
export type MutexVarPopFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type MutexVarSampFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type MutexVarianceFields = {
  merchant_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "notification_type" */
export type NotificationType = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "notification_type" */
export type NotificationTypeAggregate = {
  aggregate?: Maybe<NotificationTypeAggregateFields>;
  nodes: Array<NotificationType>;
};

/** aggregate fields of "notification_type" */
export type NotificationTypeAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<NotificationTypeMaxFields>;
  min?: Maybe<NotificationTypeMinFields>;
};


/** aggregate fields of "notification_type" */
export type NotificationTypeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "notification_type". All fields are combined with a logical 'AND'. */
export type NotificationTypeBoolExp = {
  _and?: InputMaybe<Array<NotificationTypeBoolExp>>;
  _not?: InputMaybe<NotificationTypeBoolExp>;
  _or?: InputMaybe<Array<NotificationTypeBoolExp>>;
  id?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "notification_type" */
export enum NotificationTypeConstraint {
  /** unique or primary key constraint on columns "id" */
  NotificationTypePkey = 'notification_type_pkey'
}

/** input type for inserting data into table "notification_type" */
export type NotificationTypeInsertInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type NotificationTypeMaxFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type NotificationTypeMinFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "notification_type" */
export type NotificationTypeMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationType>;
};

/** input type for inserting object relation for remote table "notification_type" */
export type NotificationTypeObjRelInsertInput = {
  data: NotificationTypeInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<NotificationTypeOnConflict>;
};

/** on_conflict condition type for table "notification_type" */
export type NotificationTypeOnConflict = {
  constraint: NotificationTypeConstraint;
  update_columns?: Array<NotificationTypeUpdateColumn>;
  where?: InputMaybe<NotificationTypeBoolExp>;
};

/** Ordering options when selecting data from "notification_type". */
export type NotificationTypeOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: notification_type */
export type NotificationTypePkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "notification_type" */
export enum NotificationTypeSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "notification_type" */
export type NotificationTypeSetInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "notification_type" */
export enum NotificationTypeUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type NotificationTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NotificationTypeSetInput>;
  where: NotificationTypeBoolExp;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type NumericComparisonExp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum OrderBy {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "payment_system" */
export type PaymentSystem = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  provider_payment_systems: Array<ProviderPaymentSystem>;
  /** An aggregate relationship */
  provider_payment_systems_aggregate: ProviderPaymentSystemAggregate;
  /** An array relationship */
  providers: Array<Provider>;
  /** An aggregate relationship */
  providers_aggregate: ProviderAggregate;
};


/** columns and relationships of "payment_system" */
export type PaymentSystemProviderPaymentSystemsArgs = {
  distinct_on?: InputMaybe<Array<ProviderPaymentSystemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderPaymentSystemOrderBy>>;
  where?: InputMaybe<ProviderPaymentSystemBoolExp>;
};


/** columns and relationships of "payment_system" */
export type PaymentSystemProviderPaymentSystemsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderPaymentSystemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderPaymentSystemOrderBy>>;
  where?: InputMaybe<ProviderPaymentSystemBoolExp>;
};


/** columns and relationships of "payment_system" */
export type PaymentSystemProvidersArgs = {
  distinct_on?: InputMaybe<Array<ProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderOrderBy>>;
  where?: InputMaybe<ProviderBoolExp>;
};


/** columns and relationships of "payment_system" */
export type PaymentSystemProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderOrderBy>>;
  where?: InputMaybe<ProviderBoolExp>;
};

/** aggregated selection of "payment_system" */
export type PaymentSystemAggregate = {
  aggregate?: Maybe<PaymentSystemAggregateFields>;
  nodes: Array<PaymentSystem>;
};

/** aggregate fields of "payment_system" */
export type PaymentSystemAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<PaymentSystemMaxFields>;
  min?: Maybe<PaymentSystemMinFields>;
};


/** aggregate fields of "payment_system" */
export type PaymentSystemAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PaymentSystemSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "payment_system". All fields are combined with a logical 'AND'. */
export type PaymentSystemBoolExp = {
  _and?: InputMaybe<Array<PaymentSystemBoolExp>>;
  _not?: InputMaybe<PaymentSystemBoolExp>;
  _or?: InputMaybe<Array<PaymentSystemBoolExp>>;
  id?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  provider_payment_systems?: InputMaybe<ProviderPaymentSystemBoolExp>;
  providers?: InputMaybe<ProviderBoolExp>;
};

/** unique or primary key constraints on table "payment_system" */
export enum PaymentSystemConstraint {
  /** unique or primary key constraint on columns "id" */
  PaymentSystemPkey = 'payment_system_pkey'
}

/** input type for inserting data into table "payment_system" */
export type PaymentSystemInsertInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  provider_payment_systems?: InputMaybe<ProviderPaymentSystemArrRelInsertInput>;
  providers?: InputMaybe<ProviderArrRelInsertInput>;
};

/** aggregate max on columns */
export type PaymentSystemMaxFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PaymentSystemMinFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "payment_system" */
export type PaymentSystemMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PaymentSystem>;
};

/** input type for inserting object relation for remote table "payment_system" */
export type PaymentSystemObjRelInsertInput = {
  data: PaymentSystemInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<PaymentSystemOnConflict>;
};

/** on_conflict condition type for table "payment_system" */
export type PaymentSystemOnConflict = {
  constraint: PaymentSystemConstraint;
  update_columns?: Array<PaymentSystemUpdateColumn>;
  where?: InputMaybe<PaymentSystemBoolExp>;
};

/** Ordering options when selecting data from "payment_system". */
export type PaymentSystemOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  provider_payment_systems_aggregate?: InputMaybe<ProviderPaymentSystemAggregateOrderBy>;
  providers_aggregate?: InputMaybe<ProviderAggregateOrderBy>;
};

/** primary key columns input for table: payment_system */
export type PaymentSystemPkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "payment_system" */
export enum PaymentSystemSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "payment_system" */
export type PaymentSystemSetInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "payment_system" */
export enum PaymentSystemUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type PaymentSystemUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaymentSystemSetInput>;
  where: PaymentSystemBoolExp;
};

export type PayportInternalBalancesOutput = {
  balance: Scalars['Int'];
  currency_id: Scalars['String'];
};

/** columns and relationships of "profit_provider" */
export type ProfitProvider = {
  amount: Scalars['numeric'];
  created_at: Scalars['timestamptz'];
  currency_id: Scalars['String'];
  id: Scalars['Int'];
  provider_family_id: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "profit_provider" */
export type ProfitProviderAggregate = {
  aggregate?: Maybe<ProfitProviderAggregateFields>;
  nodes: Array<ProfitProvider>;
};

/** aggregate fields of "profit_provider" */
export type ProfitProviderAggregateFields = {
  avg?: Maybe<ProfitProviderAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProfitProviderMaxFields>;
  min?: Maybe<ProfitProviderMinFields>;
  stddev?: Maybe<ProfitProviderStddevFields>;
  stddev_pop?: Maybe<ProfitProviderStddevPopFields>;
  stddev_samp?: Maybe<ProfitProviderStddevSampFields>;
  sum?: Maybe<ProfitProviderSumFields>;
  var_pop?: Maybe<ProfitProviderVarPopFields>;
  var_samp?: Maybe<ProfitProviderVarSampFields>;
  variance?: Maybe<ProfitProviderVarianceFields>;
};


/** aggregate fields of "profit_provider" */
export type ProfitProviderAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProfitProviderSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ProfitProviderAvgFields = {
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "profit_provider". All fields are combined with a logical 'AND'. */
export type ProfitProviderBoolExp = {
  _and?: InputMaybe<Array<ProfitProviderBoolExp>>;
  _not?: InputMaybe<ProfitProviderBoolExp>;
  _or?: InputMaybe<Array<ProfitProviderBoolExp>>;
  amount?: InputMaybe<NumericComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  currency_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  provider_family_id?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "profit_provider" */
export enum ProfitProviderConstraint {
  /** unique or primary key constraint on columns "id" */
  ProfitProviderPkey = 'profit_provider_pkey'
}

/** input type for incrementing numeric columns in table "profit_provider" */
export type ProfitProviderIncInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "profit_provider" */
export type ProfitProviderInsertInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  provider_family_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ProfitProviderMaxFields = {
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  provider_family_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type ProfitProviderMinFields = {
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  provider_family_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "profit_provider" */
export type ProfitProviderMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProfitProvider>;
};

/** on_conflict condition type for table "profit_provider" */
export type ProfitProviderOnConflict = {
  constraint: ProfitProviderConstraint;
  update_columns?: Array<ProfitProviderUpdateColumn>;
  where?: InputMaybe<ProfitProviderBoolExp>;
};

/** Ordering options when selecting data from "profit_provider". */
export type ProfitProviderOrderBy = {
  amount?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  provider_family_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: profit_provider */
export type ProfitProviderPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "profit_provider" */
export enum ProfitProviderSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderFamilyId = 'provider_family_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "profit_provider" */
export type ProfitProviderSetInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  provider_family_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ProfitProviderStddevFields = {
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ProfitProviderStddevPopFields = {
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ProfitProviderStddevSampFields = {
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type ProfitProviderSumFields = {
  amount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "profit_provider" */
export enum ProfitProviderUpdateColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderFamilyId = 'provider_family_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type ProfitProviderUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProfitProviderIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProfitProviderSetInput>;
  where: ProfitProviderBoolExp;
};

/** aggregate var_pop on columns */
export type ProfitProviderVarPopFields = {
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ProfitProviderVarSampFields = {
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ProfitProviderVarianceFields = {
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "profit_withdraw" */
export type ProfitWithdraw = {
  amount: Scalars['numeric'];
  created_at: Scalars['timestamptz'];
  currency_id: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  fee: Scalars['numeric'];
  id: Scalars['Int'];
  provider_family_id: Scalars['String'];
  provider_id?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "profit_withdraw" */
export type ProfitWithdrawAggregate = {
  aggregate?: Maybe<ProfitWithdrawAggregateFields>;
  nodes: Array<ProfitWithdraw>;
};

/** aggregate fields of "profit_withdraw" */
export type ProfitWithdrawAggregateFields = {
  avg?: Maybe<ProfitWithdrawAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProfitWithdrawMaxFields>;
  min?: Maybe<ProfitWithdrawMinFields>;
  stddev?: Maybe<ProfitWithdrawStddevFields>;
  stddev_pop?: Maybe<ProfitWithdrawStddevPopFields>;
  stddev_samp?: Maybe<ProfitWithdrawStddevSampFields>;
  sum?: Maybe<ProfitWithdrawSumFields>;
  var_pop?: Maybe<ProfitWithdrawVarPopFields>;
  var_samp?: Maybe<ProfitWithdrawVarSampFields>;
  variance?: Maybe<ProfitWithdrawVarianceFields>;
};


/** aggregate fields of "profit_withdraw" */
export type ProfitWithdrawAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProfitWithdrawSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ProfitWithdrawAvgFields = {
  amount?: Maybe<Scalars['Float']>;
  fee?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "profit_withdraw". All fields are combined with a logical 'AND'. */
export type ProfitWithdrawBoolExp = {
  _and?: InputMaybe<Array<ProfitWithdrawBoolExp>>;
  _not?: InputMaybe<ProfitWithdrawBoolExp>;
  _or?: InputMaybe<Array<ProfitWithdrawBoolExp>>;
  amount?: InputMaybe<NumericComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  currency_id?: InputMaybe<StringComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  fee?: InputMaybe<NumericComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  provider_family_id?: InputMaybe<StringComparisonExp>;
  provider_id?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "profit_withdraw" */
export enum ProfitWithdrawConstraint {
  /** unique or primary key constraint on columns "id" */
  ProfitWithdrawPkey = 'profit_withdraw_pkey'
}

/** input type for incrementing numeric columns in table "profit_withdraw" */
export type ProfitWithdrawIncInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  fee?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "profit_withdraw" */
export type ProfitWithdrawInsertInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fee?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  provider_family_id?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ProfitWithdrawMaxFields = {
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  provider_family_id?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type ProfitWithdrawMinFields = {
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  provider_family_id?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "profit_withdraw" */
export type ProfitWithdrawMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProfitWithdraw>;
};

/** on_conflict condition type for table "profit_withdraw" */
export type ProfitWithdrawOnConflict = {
  constraint: ProfitWithdrawConstraint;
  update_columns?: Array<ProfitWithdrawUpdateColumn>;
  where?: InputMaybe<ProfitWithdrawBoolExp>;
};

/** Ordering options when selecting data from "profit_withdraw". */
export type ProfitWithdrawOrderBy = {
  amount?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  fee?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  provider_family_id?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: profit_withdraw */
export type ProfitWithdrawPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "profit_withdraw" */
export enum ProfitWithdrawSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  Description = 'description',
  /** column name */
  Fee = 'fee',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderFamilyId = 'provider_family_id',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "profit_withdraw" */
export type ProfitWithdrawSetInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fee?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  provider_family_id?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ProfitWithdrawStddevFields = {
  amount?: Maybe<Scalars['Float']>;
  fee?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ProfitWithdrawStddevPopFields = {
  amount?: Maybe<Scalars['Float']>;
  fee?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ProfitWithdrawStddevSampFields = {
  amount?: Maybe<Scalars['Float']>;
  fee?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type ProfitWithdrawSumFields = {
  amount?: Maybe<Scalars['numeric']>;
  fee?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "profit_withdraw" */
export enum ProfitWithdrawUpdateColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  Description = 'description',
  /** column name */
  Fee = 'fee',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderFamilyId = 'provider_family_id',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type ProfitWithdrawUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProfitWithdrawIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProfitWithdrawSetInput>;
  where: ProfitWithdrawBoolExp;
};

/** aggregate var_pop on columns */
export type ProfitWithdrawVarPopFields = {
  amount?: Maybe<Scalars['Float']>;
  fee?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ProfitWithdrawVarSampFields = {
  amount?: Maybe<Scalars['Float']>;
  fee?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ProfitWithdrawVarianceFields = {
  amount?: Maybe<Scalars['Float']>;
  fee?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "provider" */
export type Provider = {
  alias?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  default_date_column_analytics: Scalars['String'];
  default_payment_system?: Maybe<Scalars['String']>;
  default_traffic_type_id?: Maybe<Scalars['String']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  fort_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  gates: Array<Gate>;
  /** An aggregate relationship */
  gates_aggregate: GateAggregate;
  id: Scalars['String'];
  /** An array relationship */
  invoices: Array<Invoice>;
  /** An aggregate relationship */
  invoices_aggregate: InvoiceAggregate;
  is_new: Scalars['Boolean'];
  /** An array relationship */
  merchant_balances: Array<MerchantBalance>;
  /** An aggregate relationship */
  merchant_balances_aggregate: MerchantBalanceAggregate;
  /** An array relationship */
  merchant_fees: Array<MerchantFee>;
  /** An aggregate relationship */
  merchant_fees_aggregate: MerchantFeeAggregate;
  /** An array relationship */
  merchants: Array<Merchant>;
  /** An aggregate relationship */
  merchants_aggregate: MerchantAggregate;
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  payment_system?: Maybe<PaymentSystem>;
  /** An array relationship */
  provider_countries: Array<ProviderCountry>;
  /** An aggregate relationship */
  provider_countries_aggregate: ProviderCountryAggregate;
  provider_family: Scalars['String'];
  /** An object relationship */
  provider_family_object: ProviderFamily;
  provider_family_payment_system?: Maybe<Scalars['String']>;
  /** An array relationship */
  provider_fees: Array<ProviderFee>;
  /** An aggregate relationship */
  provider_fees_aggregate: ProviderFeeAggregate;
  /** An array relationship */
  provider_limits: Array<ProviderLimit>;
  /** An aggregate relationship */
  provider_limits_aggregate: ProviderLimitAggregate;
  /** An array relationship */
  provider_payment_systems: Array<ProviderPaymentSystem>;
  /** An aggregate relationship */
  provider_payment_systems_aggregate: ProviderPaymentSystemAggregate;
  provider_status_id: Scalars['String'];
  provider_type_id: Scalars['String'];
  /** An object relationship */
  traffic_type?: Maybe<TrafficType>;
  /** An array relationship */
  transaction_histories: Array<TransactionHistory>;
  /** An aggregate relationship */
  transaction_histories_aggregate: TransactionHistoryAggregate;
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  withdraw_requests: Array<WithdrawRequest>;
  /** An aggregate relationship */
  withdraw_requests_aggregate: WithdrawRequestAggregate;
  /** An array relationship */
  withdraws: Array<Withdraw>;
  /** An aggregate relationship */
  withdraws_aggregate: WithdrawAggregate;
};


/** columns and relationships of "provider" */
export type ProviderGatesArgs = {
  distinct_on?: InputMaybe<Array<GateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GateOrderBy>>;
  where?: InputMaybe<GateBoolExp>;
};


/** columns and relationships of "provider" */
export type ProviderGatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<GateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GateOrderBy>>;
  where?: InputMaybe<GateBoolExp>;
};


/** columns and relationships of "provider" */
export type ProviderInvoicesArgs = {
  distinct_on?: InputMaybe<Array<InvoiceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InvoiceOrderBy>>;
  where?: InputMaybe<InvoiceBoolExp>;
};


/** columns and relationships of "provider" */
export type ProviderInvoicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<InvoiceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InvoiceOrderBy>>;
  where?: InputMaybe<InvoiceBoolExp>;
};


/** columns and relationships of "provider" */
export type ProviderMerchantBalancesArgs = {
  distinct_on?: InputMaybe<Array<MerchantBalanceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantBalanceOrderBy>>;
  where?: InputMaybe<MerchantBalanceBoolExp>;
};


/** columns and relationships of "provider" */
export type ProviderMerchantBalancesAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantBalanceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantBalanceOrderBy>>;
  where?: InputMaybe<MerchantBalanceBoolExp>;
};


/** columns and relationships of "provider" */
export type ProviderMerchantFeesArgs = {
  distinct_on?: InputMaybe<Array<MerchantFeeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantFeeOrderBy>>;
  where?: InputMaybe<MerchantFeeBoolExp>;
};


/** columns and relationships of "provider" */
export type ProviderMerchantFeesAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantFeeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantFeeOrderBy>>;
  where?: InputMaybe<MerchantFeeBoolExp>;
};


/** columns and relationships of "provider" */
export type ProviderMerchantsArgs = {
  distinct_on?: InputMaybe<Array<MerchantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantOrderBy>>;
  where?: InputMaybe<MerchantBoolExp>;
};


/** columns and relationships of "provider" */
export type ProviderMerchantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantOrderBy>>;
  where?: InputMaybe<MerchantBoolExp>;
};


/** columns and relationships of "provider" */
export type ProviderProviderCountriesArgs = {
  distinct_on?: InputMaybe<Array<ProviderCountrySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderCountryOrderBy>>;
  where?: InputMaybe<ProviderCountryBoolExp>;
};


/** columns and relationships of "provider" */
export type ProviderProviderCountriesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderCountrySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderCountryOrderBy>>;
  where?: InputMaybe<ProviderCountryBoolExp>;
};


/** columns and relationships of "provider" */
export type ProviderProviderFeesArgs = {
  distinct_on?: InputMaybe<Array<ProviderFeeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderFeeOrderBy>>;
  where?: InputMaybe<ProviderFeeBoolExp>;
};


/** columns and relationships of "provider" */
export type ProviderProviderFeesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderFeeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderFeeOrderBy>>;
  where?: InputMaybe<ProviderFeeBoolExp>;
};


/** columns and relationships of "provider" */
export type ProviderProviderLimitsArgs = {
  distinct_on?: InputMaybe<Array<ProviderLimitSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderLimitOrderBy>>;
  where?: InputMaybe<ProviderLimitBoolExp>;
};


/** columns and relationships of "provider" */
export type ProviderProviderLimitsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderLimitSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderLimitOrderBy>>;
  where?: InputMaybe<ProviderLimitBoolExp>;
};


/** columns and relationships of "provider" */
export type ProviderProviderPaymentSystemsArgs = {
  distinct_on?: InputMaybe<Array<ProviderPaymentSystemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderPaymentSystemOrderBy>>;
  where?: InputMaybe<ProviderPaymentSystemBoolExp>;
};


/** columns and relationships of "provider" */
export type ProviderProviderPaymentSystemsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderPaymentSystemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderPaymentSystemOrderBy>>;
  where?: InputMaybe<ProviderPaymentSystemBoolExp>;
};


/** columns and relationships of "provider" */
export type ProviderTransactionHistoriesArgs = {
  distinct_on?: InputMaybe<Array<TransactionHistorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TransactionHistoryOrderBy>>;
  where?: InputMaybe<TransactionHistoryBoolExp>;
};


/** columns and relationships of "provider" */
export type ProviderTransactionHistoriesAggregateArgs = {
  distinct_on?: InputMaybe<Array<TransactionHistorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TransactionHistoryOrderBy>>;
  where?: InputMaybe<TransactionHistoryBoolExp>;
};


/** columns and relationships of "provider" */
export type ProviderWithdrawRequestsArgs = {
  distinct_on?: InputMaybe<Array<WithdrawRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WithdrawRequestOrderBy>>;
  where?: InputMaybe<WithdrawRequestBoolExp>;
};


/** columns and relationships of "provider" */
export type ProviderWithdrawRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<WithdrawRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WithdrawRequestOrderBy>>;
  where?: InputMaybe<WithdrawRequestBoolExp>;
};


/** columns and relationships of "provider" */
export type ProviderWithdrawsArgs = {
  distinct_on?: InputMaybe<Array<WithdrawSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WithdrawOrderBy>>;
  where?: InputMaybe<WithdrawBoolExp>;
};


/** columns and relationships of "provider" */
export type ProviderWithdrawsAggregateArgs = {
  distinct_on?: InputMaybe<Array<WithdrawSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WithdrawOrderBy>>;
  where?: InputMaybe<WithdrawBoolExp>;
};

/** aggregated selection of "provider" */
export type ProviderAggregate = {
  aggregate?: Maybe<ProviderAggregateFields>;
  nodes: Array<Provider>;
};

/** aggregate fields of "provider" */
export type ProviderAggregateFields = {
  avg?: Maybe<ProviderAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProviderMaxFields>;
  min?: Maybe<ProviderMinFields>;
  stddev?: Maybe<ProviderStddevFields>;
  stddev_pop?: Maybe<ProviderStddevPopFields>;
  stddev_samp?: Maybe<ProviderStddevSampFields>;
  sum?: Maybe<ProviderSumFields>;
  var_pop?: Maybe<ProviderVarPopFields>;
  var_samp?: Maybe<ProviderVarSampFields>;
  variance?: Maybe<ProviderVarianceFields>;
};


/** aggregate fields of "provider" */
export type ProviderAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProviderSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "provider" */
export type ProviderAggregateOrderBy = {
  avg?: InputMaybe<ProviderAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ProviderMaxOrderBy>;
  min?: InputMaybe<ProviderMinOrderBy>;
  stddev?: InputMaybe<ProviderStddevOrderBy>;
  stddev_pop?: InputMaybe<ProviderStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ProviderStddevSampOrderBy>;
  sum?: InputMaybe<ProviderSumOrderBy>;
  var_pop?: InputMaybe<ProviderVarPopOrderBy>;
  var_samp?: InputMaybe<ProviderVarSampOrderBy>;
  variance?: InputMaybe<ProviderVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "provider" */
export type ProviderArrRelInsertInput = {
  data: Array<ProviderInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProviderOnConflict>;
};

/** aggregate avg on columns */
export type ProviderAvgFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "provider" */
export type ProviderAvgOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "provider". All fields are combined with a logical 'AND'. */
export type ProviderBoolExp = {
  _and?: InputMaybe<Array<ProviderBoolExp>>;
  _not?: InputMaybe<ProviderBoolExp>;
  _or?: InputMaybe<Array<ProviderBoolExp>>;
  alias?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  default_date_column_analytics?: InputMaybe<StringComparisonExp>;
  default_payment_system?: InputMaybe<StringComparisonExp>;
  default_traffic_type_id?: InputMaybe<StringComparisonExp>;
  edit_user_id?: InputMaybe<IntComparisonExp>;
  fort_id?: InputMaybe<StringComparisonExp>;
  gates?: InputMaybe<GateBoolExp>;
  id?: InputMaybe<StringComparisonExp>;
  invoices?: InputMaybe<InvoiceBoolExp>;
  is_new?: InputMaybe<BooleanComparisonExp>;
  merchant_balances?: InputMaybe<MerchantBalanceBoolExp>;
  merchant_fees?: InputMaybe<MerchantFeeBoolExp>;
  merchants?: InputMaybe<MerchantBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  payment_system?: InputMaybe<PaymentSystemBoolExp>;
  provider_countries?: InputMaybe<ProviderCountryBoolExp>;
  provider_family?: InputMaybe<StringComparisonExp>;
  provider_family_object?: InputMaybe<ProviderFamilyBoolExp>;
  provider_family_payment_system?: InputMaybe<StringComparisonExp>;
  provider_fees?: InputMaybe<ProviderFeeBoolExp>;
  provider_limits?: InputMaybe<ProviderLimitBoolExp>;
  provider_payment_systems?: InputMaybe<ProviderPaymentSystemBoolExp>;
  provider_status_id?: InputMaybe<StringComparisonExp>;
  provider_type_id?: InputMaybe<StringComparisonExp>;
  traffic_type?: InputMaybe<TrafficTypeBoolExp>;
  transaction_histories?: InputMaybe<TransactionHistoryBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  withdraw_requests?: InputMaybe<WithdrawRequestBoolExp>;
  withdraws?: InputMaybe<WithdrawBoolExp>;
};

/** unique or primary key constraints on table "provider" */
export enum ProviderConstraint {
  /** unique or primary key constraint on columns "alias" */
  AliasUniqueConstraint = 'alias_unique_constraint',
  /** unique or primary key constraint on columns "id" */
  ProviderPkey = 'provider_pkey'
}

/** Связь провайдера и страны */
export type ProviderCountry = {
  /** An object relationship */
  country: Country;
  /** FK на страну */
  country_id: Scalars['String'];
  /** Идентификатор связи */
  id: Scalars['Int'];
  /** FK на статус связи */
  provider_country_state_id: Scalars['String'];
  /** FK на провайдера */
  provider_id: Scalars['String'];
};

/** aggregated selection of "provider_country" */
export type ProviderCountryAggregate = {
  aggregate?: Maybe<ProviderCountryAggregateFields>;
  nodes: Array<ProviderCountry>;
};

/** aggregate fields of "provider_country" */
export type ProviderCountryAggregateFields = {
  avg?: Maybe<ProviderCountryAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProviderCountryMaxFields>;
  min?: Maybe<ProviderCountryMinFields>;
  stddev?: Maybe<ProviderCountryStddevFields>;
  stddev_pop?: Maybe<ProviderCountryStddevPopFields>;
  stddev_samp?: Maybe<ProviderCountryStddevSampFields>;
  sum?: Maybe<ProviderCountrySumFields>;
  var_pop?: Maybe<ProviderCountryVarPopFields>;
  var_samp?: Maybe<ProviderCountryVarSampFields>;
  variance?: Maybe<ProviderCountryVarianceFields>;
};


/** aggregate fields of "provider_country" */
export type ProviderCountryAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProviderCountrySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "provider_country" */
export type ProviderCountryAggregateOrderBy = {
  avg?: InputMaybe<ProviderCountryAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ProviderCountryMaxOrderBy>;
  min?: InputMaybe<ProviderCountryMinOrderBy>;
  stddev?: InputMaybe<ProviderCountryStddevOrderBy>;
  stddev_pop?: InputMaybe<ProviderCountryStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ProviderCountryStddevSampOrderBy>;
  sum?: InputMaybe<ProviderCountrySumOrderBy>;
  var_pop?: InputMaybe<ProviderCountryVarPopOrderBy>;
  var_samp?: InputMaybe<ProviderCountryVarSampOrderBy>;
  variance?: InputMaybe<ProviderCountryVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "provider_country" */
export type ProviderCountryArrRelInsertInput = {
  data: Array<ProviderCountryInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProviderCountryOnConflict>;
};

/** aggregate avg on columns */
export type ProviderCountryAvgFields = {
  /** Идентификатор связи */
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "provider_country" */
export type ProviderCountryAvgOrderBy = {
  /** Идентификатор связи */
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "provider_country". All fields are combined with a logical 'AND'. */
export type ProviderCountryBoolExp = {
  _and?: InputMaybe<Array<ProviderCountryBoolExp>>;
  _not?: InputMaybe<ProviderCountryBoolExp>;
  _or?: InputMaybe<Array<ProviderCountryBoolExp>>;
  country?: InputMaybe<CountryBoolExp>;
  country_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  provider_country_state_id?: InputMaybe<StringComparisonExp>;
  provider_id?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "provider_country" */
export enum ProviderCountryConstraint {
  /** unique or primary key constraint on columns "id" */
  ProviderCountryPkey = 'provider_country_pkey',
  /** unique or primary key constraint on columns "provider_country_state_id", "provider_id", "country_id" */
  ProviderCountryProviderIdCountryIdKeyProviderCountrySt = 'provider_country_provider_id_country_id_key_provider_country_st'
}

/** input type for incrementing numeric columns in table "provider_country" */
export type ProviderCountryIncInput = {
  /** Идентификатор связи */
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "provider_country" */
export type ProviderCountryInsertInput = {
  country?: InputMaybe<CountryObjRelInsertInput>;
  /** FK на страну */
  country_id?: InputMaybe<Scalars['String']>;
  /** Идентификатор связи */
  id?: InputMaybe<Scalars['Int']>;
  /** FK на статус связи */
  provider_country_state_id?: InputMaybe<Scalars['String']>;
  /** FK на провайдера */
  provider_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ProviderCountryMaxFields = {
  /** FK на страну */
  country_id?: Maybe<Scalars['String']>;
  /** Идентификатор связи */
  id?: Maybe<Scalars['Int']>;
  /** FK на статус связи */
  provider_country_state_id?: Maybe<Scalars['String']>;
  /** FK на провайдера */
  provider_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "provider_country" */
export type ProviderCountryMaxOrderBy = {
  /** FK на страну */
  country_id?: InputMaybe<OrderBy>;
  /** Идентификатор связи */
  id?: InputMaybe<OrderBy>;
  /** FK на статус связи */
  provider_country_state_id?: InputMaybe<OrderBy>;
  /** FK на провайдера */
  provider_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ProviderCountryMinFields = {
  /** FK на страну */
  country_id?: Maybe<Scalars['String']>;
  /** Идентификатор связи */
  id?: Maybe<Scalars['Int']>;
  /** FK на статус связи */
  provider_country_state_id?: Maybe<Scalars['String']>;
  /** FK на провайдера */
  provider_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "provider_country" */
export type ProviderCountryMinOrderBy = {
  /** FK на страну */
  country_id?: InputMaybe<OrderBy>;
  /** Идентификатор связи */
  id?: InputMaybe<OrderBy>;
  /** FK на статус связи */
  provider_country_state_id?: InputMaybe<OrderBy>;
  /** FK на провайдера */
  provider_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "provider_country" */
export type ProviderCountryMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProviderCountry>;
};

/** on_conflict condition type for table "provider_country" */
export type ProviderCountryOnConflict = {
  constraint: ProviderCountryConstraint;
  update_columns?: Array<ProviderCountryUpdateColumn>;
  where?: InputMaybe<ProviderCountryBoolExp>;
};

/** Ordering options when selecting data from "provider_country". */
export type ProviderCountryOrderBy = {
  country?: InputMaybe<CountryOrderBy>;
  country_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  provider_country_state_id?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: provider_country */
export type ProviderCountryPkColumnsInput = {
  /** Идентификатор связи */
  id: Scalars['Int'];
};

/** select columns of table "provider_country" */
export enum ProviderCountrySelectColumn {
  /** column name */
  CountryId = 'country_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderCountryStateId = 'provider_country_state_id',
  /** column name */
  ProviderId = 'provider_id'
}

/** input type for updating data in table "provider_country" */
export type ProviderCountrySetInput = {
  /** FK на страну */
  country_id?: InputMaybe<Scalars['String']>;
  /** Идентификатор связи */
  id?: InputMaybe<Scalars['Int']>;
  /** FK на статус связи */
  provider_country_state_id?: InputMaybe<Scalars['String']>;
  /** FK на провайдера */
  provider_id?: InputMaybe<Scalars['String']>;
};

/** Справочник статусов стран для провайдеров */
export type ProviderCountryState = {
  id: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "provider_country_state" */
export type ProviderCountryStateAggregate = {
  aggregate?: Maybe<ProviderCountryStateAggregateFields>;
  nodes: Array<ProviderCountryState>;
};

/** aggregate fields of "provider_country_state" */
export type ProviderCountryStateAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<ProviderCountryStateMaxFields>;
  min?: Maybe<ProviderCountryStateMinFields>;
};


/** aggregate fields of "provider_country_state" */
export type ProviderCountryStateAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProviderCountryStateSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "provider_country_state". All fields are combined with a logical 'AND'. */
export type ProviderCountryStateBoolExp = {
  _and?: InputMaybe<Array<ProviderCountryStateBoolExp>>;
  _not?: InputMaybe<ProviderCountryStateBoolExp>;
  _or?: InputMaybe<Array<ProviderCountryStateBoolExp>>;
  id?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "provider_country_state" */
export enum ProviderCountryStateConstraint {
  /** unique or primary key constraint on columns "id" */
  ProviderCountryStatePkey = 'provider_country_state_pkey'
}

/** input type for inserting data into table "provider_country_state" */
export type ProviderCountryStateInsertInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ProviderCountryStateMaxFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ProviderCountryStateMinFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "provider_country_state" */
export type ProviderCountryStateMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProviderCountryState>;
};

/** on_conflict condition type for table "provider_country_state" */
export type ProviderCountryStateOnConflict = {
  constraint: ProviderCountryStateConstraint;
  update_columns?: Array<ProviderCountryStateUpdateColumn>;
  where?: InputMaybe<ProviderCountryStateBoolExp>;
};

/** Ordering options when selecting data from "provider_country_state". */
export type ProviderCountryStateOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: provider_country_state */
export type ProviderCountryStatePkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "provider_country_state" */
export enum ProviderCountryStateSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "provider_country_state" */
export type ProviderCountryStateSetInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "provider_country_state" */
export enum ProviderCountryStateUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type ProviderCountryStateUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProviderCountryStateSetInput>;
  where: ProviderCountryStateBoolExp;
};

/** aggregate stddev on columns */
export type ProviderCountryStddevFields = {
  /** Идентификатор связи */
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "provider_country" */
export type ProviderCountryStddevOrderBy = {
  /** Идентификатор связи */
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ProviderCountryStddevPopFields = {
  /** Идентификатор связи */
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "provider_country" */
export type ProviderCountryStddevPopOrderBy = {
  /** Идентификатор связи */
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ProviderCountryStddevSampFields = {
  /** Идентификатор связи */
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "provider_country" */
export type ProviderCountryStddevSampOrderBy = {
  /** Идентификатор связи */
  id?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type ProviderCountrySumFields = {
  /** Идентификатор связи */
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "provider_country" */
export type ProviderCountrySumOrderBy = {
  /** Идентификатор связи */
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "provider_country" */
export enum ProviderCountryUpdateColumn {
  /** column name */
  CountryId = 'country_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderCountryStateId = 'provider_country_state_id',
  /** column name */
  ProviderId = 'provider_id'
}

export type ProviderCountryUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProviderCountryIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProviderCountrySetInput>;
  where: ProviderCountryBoolExp;
};

/** aggregate var_pop on columns */
export type ProviderCountryVarPopFields = {
  /** Идентификатор связи */
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "provider_country" */
export type ProviderCountryVarPopOrderBy = {
  /** Идентификатор связи */
  id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ProviderCountryVarSampFields = {
  /** Идентификатор связи */
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "provider_country" */
export type ProviderCountryVarSampOrderBy = {
  /** Идентификатор связи */
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ProviderCountryVarianceFields = {
  /** Идентификатор связи */
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "provider_country" */
export type ProviderCountryVarianceOrderBy = {
  /** Идентификатор связи */
  id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "provider_family" */
export type ProviderFamily = {
  code?: Maybe<Scalars['Int']>;
  /** An array relationship */
  gate_group: Array<GateGroup>;
  /** An aggregate relationship */
  gate_group_aggregate: GateGroupAggregate;
  id: Scalars['String'];
  invoice_reconciliation?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  provider: Array<Provider>;
  /** An aggregate relationship */
  provider_aggregate: ProviderAggregate;
  withdraw_reconciliation?: Maybe<Scalars['Boolean']>;
};


/** columns and relationships of "provider_family" */
export type ProviderFamilyGateGroupArgs = {
  distinct_on?: InputMaybe<Array<GateGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GateGroupOrderBy>>;
  where?: InputMaybe<GateGroupBoolExp>;
};


/** columns and relationships of "provider_family" */
export type ProviderFamilyGateGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<GateGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GateGroupOrderBy>>;
  where?: InputMaybe<GateGroupBoolExp>;
};


/** columns and relationships of "provider_family" */
export type ProviderFamilyProviderArgs = {
  distinct_on?: InputMaybe<Array<ProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderOrderBy>>;
  where?: InputMaybe<ProviderBoolExp>;
};


/** columns and relationships of "provider_family" */
export type ProviderFamilyProviderAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderOrderBy>>;
  where?: InputMaybe<ProviderBoolExp>;
};

/** aggregated selection of "provider_family" */
export type ProviderFamilyAggregate = {
  aggregate?: Maybe<ProviderFamilyAggregateFields>;
  nodes: Array<ProviderFamily>;
};

/** aggregate fields of "provider_family" */
export type ProviderFamilyAggregateFields = {
  avg?: Maybe<ProviderFamilyAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProviderFamilyMaxFields>;
  min?: Maybe<ProviderFamilyMinFields>;
  stddev?: Maybe<ProviderFamilyStddevFields>;
  stddev_pop?: Maybe<ProviderFamilyStddevPopFields>;
  stddev_samp?: Maybe<ProviderFamilyStddevSampFields>;
  sum?: Maybe<ProviderFamilySumFields>;
  var_pop?: Maybe<ProviderFamilyVarPopFields>;
  var_samp?: Maybe<ProviderFamilyVarSampFields>;
  variance?: Maybe<ProviderFamilyVarianceFields>;
};


/** aggregate fields of "provider_family" */
export type ProviderFamilyAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProviderFamilySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ProviderFamilyAvgFields = {
  code?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "provider_family". All fields are combined with a logical 'AND'. */
export type ProviderFamilyBoolExp = {
  _and?: InputMaybe<Array<ProviderFamilyBoolExp>>;
  _not?: InputMaybe<ProviderFamilyBoolExp>;
  _or?: InputMaybe<Array<ProviderFamilyBoolExp>>;
  code?: InputMaybe<IntComparisonExp>;
  gate_group?: InputMaybe<GateGroupBoolExp>;
  id?: InputMaybe<StringComparisonExp>;
  invoice_reconciliation?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  provider?: InputMaybe<ProviderBoolExp>;
  withdraw_reconciliation?: InputMaybe<BooleanComparisonExp>;
};

/** unique or primary key constraints on table "provider_family" */
export enum ProviderFamilyConstraint {
  /** unique or primary key constraint on columns "code" */
  ProviderFamilyCodeKey = 'provider_family_code_key',
  /** unique or primary key constraint on columns "id" */
  ProviderFamilyPkey = 'provider_family_pkey'
}

/** input type for incrementing numeric columns in table "provider_family" */
export type ProviderFamilyIncInput = {
  code?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "provider_family" */
export type ProviderFamilyInsertInput = {
  code?: InputMaybe<Scalars['Int']>;
  gate_group?: InputMaybe<GateGroupArrRelInsertInput>;
  id?: InputMaybe<Scalars['String']>;
  invoice_reconciliation?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<ProviderArrRelInsertInput>;
  withdraw_reconciliation?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type ProviderFamilyMaxFields = {
  code?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ProviderFamilyMinFields = {
  code?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "provider_family" */
export type ProviderFamilyMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProviderFamily>;
};

/** input type for inserting object relation for remote table "provider_family" */
export type ProviderFamilyObjRelInsertInput = {
  data: ProviderFamilyInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<ProviderFamilyOnConflict>;
};

/** on_conflict condition type for table "provider_family" */
export type ProviderFamilyOnConflict = {
  constraint: ProviderFamilyConstraint;
  update_columns?: Array<ProviderFamilyUpdateColumn>;
  where?: InputMaybe<ProviderFamilyBoolExp>;
};

/** Ordering options when selecting data from "provider_family". */
export type ProviderFamilyOrderBy = {
  code?: InputMaybe<OrderBy>;
  gate_group_aggregate?: InputMaybe<GateGroupAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_reconciliation?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  provider_aggregate?: InputMaybe<ProviderAggregateOrderBy>;
  withdraw_reconciliation?: InputMaybe<OrderBy>;
};

/** columns and relationships of "provider_family_payment_system" */
export type ProviderFamilyPaymentSystem = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  payment_system?: Maybe<Scalars['String']>;
  provider_family_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "provider_family_payment_system" */
export type ProviderFamilyPaymentSystemAggregate = {
  aggregate?: Maybe<ProviderFamilyPaymentSystemAggregateFields>;
  nodes: Array<ProviderFamilyPaymentSystem>;
};

/** aggregate fields of "provider_family_payment_system" */
export type ProviderFamilyPaymentSystemAggregateFields = {
  avg?: Maybe<ProviderFamilyPaymentSystemAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProviderFamilyPaymentSystemMaxFields>;
  min?: Maybe<ProviderFamilyPaymentSystemMinFields>;
  stddev?: Maybe<ProviderFamilyPaymentSystemStddevFields>;
  stddev_pop?: Maybe<ProviderFamilyPaymentSystemStddevPopFields>;
  stddev_samp?: Maybe<ProviderFamilyPaymentSystemStddevSampFields>;
  sum?: Maybe<ProviderFamilyPaymentSystemSumFields>;
  var_pop?: Maybe<ProviderFamilyPaymentSystemVarPopFields>;
  var_samp?: Maybe<ProviderFamilyPaymentSystemVarSampFields>;
  variance?: Maybe<ProviderFamilyPaymentSystemVarianceFields>;
};


/** aggregate fields of "provider_family_payment_system" */
export type ProviderFamilyPaymentSystemAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProviderFamilyPaymentSystemSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ProviderFamilyPaymentSystemAvgFields = {
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "provider_family_payment_system". All fields are combined with a logical 'AND'. */
export type ProviderFamilyPaymentSystemBoolExp = {
  _and?: InputMaybe<Array<ProviderFamilyPaymentSystemBoolExp>>;
  _not?: InputMaybe<ProviderFamilyPaymentSystemBoolExp>;
  _or?: InputMaybe<Array<ProviderFamilyPaymentSystemBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  payment_system?: InputMaybe<StringComparisonExp>;
  provider_family_id?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "provider_family_payment_system" */
export enum ProviderFamilyPaymentSystemConstraint {
  /** unique or primary key constraint on columns "provider_family_id", "payment_system" */
  PaymentSystemProviderFamily = 'payment_system_provider_family',
  /** unique or primary key constraint on columns "id" */
  ProviderFamilyPaymentSystemPkey = 'provider_family_payment_system_pkey'
}

/** input type for incrementing numeric columns in table "provider_family_payment_system" */
export type ProviderFamilyPaymentSystemIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "provider_family_payment_system" */
export type ProviderFamilyPaymentSystemInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  payment_system?: InputMaybe<Scalars['String']>;
  provider_family_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ProviderFamilyPaymentSystemMaxFields = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  payment_system?: Maybe<Scalars['String']>;
  provider_family_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ProviderFamilyPaymentSystemMinFields = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  payment_system?: Maybe<Scalars['String']>;
  provider_family_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "provider_family_payment_system" */
export type ProviderFamilyPaymentSystemMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProviderFamilyPaymentSystem>;
};

/** on_conflict condition type for table "provider_family_payment_system" */
export type ProviderFamilyPaymentSystemOnConflict = {
  constraint: ProviderFamilyPaymentSystemConstraint;
  update_columns?: Array<ProviderFamilyPaymentSystemUpdateColumn>;
  where?: InputMaybe<ProviderFamilyPaymentSystemBoolExp>;
};

/** Ordering options when selecting data from "provider_family_payment_system". */
export type ProviderFamilyPaymentSystemOrderBy = {
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  payment_system?: InputMaybe<OrderBy>;
  provider_family_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: provider_family_payment_system */
export type ProviderFamilyPaymentSystemPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "provider_family_payment_system" */
export enum ProviderFamilyPaymentSystemSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentSystem = 'payment_system',
  /** column name */
  ProviderFamilyId = 'provider_family_id'
}

/** input type for updating data in table "provider_family_payment_system" */
export type ProviderFamilyPaymentSystemSetInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  payment_system?: InputMaybe<Scalars['String']>;
  provider_family_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ProviderFamilyPaymentSystemStddevFields = {
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ProviderFamilyPaymentSystemStddevPopFields = {
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ProviderFamilyPaymentSystemStddevSampFields = {
  id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type ProviderFamilyPaymentSystemSumFields = {
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "provider_family_payment_system" */
export enum ProviderFamilyPaymentSystemUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentSystem = 'payment_system',
  /** column name */
  ProviderFamilyId = 'provider_family_id'
}

export type ProviderFamilyPaymentSystemUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProviderFamilyPaymentSystemIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProviderFamilyPaymentSystemSetInput>;
  where: ProviderFamilyPaymentSystemBoolExp;
};

/** aggregate var_pop on columns */
export type ProviderFamilyPaymentSystemVarPopFields = {
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ProviderFamilyPaymentSystemVarSampFields = {
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ProviderFamilyPaymentSystemVarianceFields = {
  id?: Maybe<Scalars['Float']>;
};

/** primary key columns input for table: provider_family */
export type ProviderFamilyPkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "provider_family" */
export enum ProviderFamilySelectColumn {
  /** column name */
  Code = 'code',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceReconciliation = 'invoice_reconciliation',
  /** column name */
  Name = 'name',
  /** column name */
  WithdrawReconciliation = 'withdraw_reconciliation'
}

/** input type for updating data in table "provider_family" */
export type ProviderFamilySetInput = {
  code?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  invoice_reconciliation?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  withdraw_reconciliation?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type ProviderFamilyStddevFields = {
  code?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ProviderFamilyStddevPopFields = {
  code?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ProviderFamilyStddevSampFields = {
  code?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type ProviderFamilySumFields = {
  code?: Maybe<Scalars['Int']>;
};

/** update columns of table "provider_family" */
export enum ProviderFamilyUpdateColumn {
  /** column name */
  Code = 'code',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceReconciliation = 'invoice_reconciliation',
  /** column name */
  Name = 'name',
  /** column name */
  WithdrawReconciliation = 'withdraw_reconciliation'
}

export type ProviderFamilyUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProviderFamilyIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProviderFamilySetInput>;
  where: ProviderFamilyBoolExp;
};

/** aggregate var_pop on columns */
export type ProviderFamilyVarPopFields = {
  code?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ProviderFamilyVarSampFields = {
  code?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ProviderFamilyVarianceFields = {
  code?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "provider_fee" */
export type ProviderFee = {
  constant_invoice_fee: Scalars['numeric'];
  constant_withdraw_fee: Scalars['numeric'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  currency: Currency;
  currency_id: Scalars['String'];
  edit_user_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  invoice_fee_min_amount: Scalars['numeric'];
  invoice_fee_percent: Scalars['numeric'];
  invoice_transaction_fee_amount: Scalars['numeric'];
  merchant_constant_invoice_fee: Scalars['numeric'];
  merchant_constant_withdraw_fee: Scalars['numeric'];
  merchant_invoice_decline_transaction_fee_amount: Scalars['numeric'];
  merchant_invoice_fee_min_amount: Scalars['numeric'];
  merchant_invoice_fee_percent: Scalars['numeric'];
  merchant_invoice_transaction_fee_amount: Scalars['numeric'];
  merchant_withdraw_decline_transaction_fee_amount: Scalars['numeric'];
  merchant_withdraw_fee_min_amount: Scalars['numeric'];
  merchant_withdraw_fee_percent: Scalars['numeric'];
  merchant_withdraw_settlement_usdt_fee_percent: Scalars['numeric'];
  merchant_withdraw_transaction_fee_amount: Scalars['numeric'];
  /** An object relationship */
  provider: Provider;
  provider_family_code: Scalars['Int'];
  provider_family_id: Scalars['String'];
  provider_id: Scalars['String'];
  rolling_reserve_duration: Scalars['Int'];
  rolling_reserve_percent: Scalars['numeric'];
  updated_at: Scalars['timestamptz'];
  withdraw_fee_min_amount: Scalars['numeric'];
  withdraw_fee_percent: Scalars['numeric'];
  withdraw_settlement_usdt_fee_percent: Scalars['numeric'];
  withdraw_transaction_fee_amount: Scalars['numeric'];
};

/** aggregated selection of "provider_fee" */
export type ProviderFeeAggregate = {
  aggregate?: Maybe<ProviderFeeAggregateFields>;
  nodes: Array<ProviderFee>;
};

/** aggregate fields of "provider_fee" */
export type ProviderFeeAggregateFields = {
  avg?: Maybe<ProviderFeeAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProviderFeeMaxFields>;
  min?: Maybe<ProviderFeeMinFields>;
  stddev?: Maybe<ProviderFeeStddevFields>;
  stddev_pop?: Maybe<ProviderFeeStddevPopFields>;
  stddev_samp?: Maybe<ProviderFeeStddevSampFields>;
  sum?: Maybe<ProviderFeeSumFields>;
  var_pop?: Maybe<ProviderFeeVarPopFields>;
  var_samp?: Maybe<ProviderFeeVarSampFields>;
  variance?: Maybe<ProviderFeeVarianceFields>;
};


/** aggregate fields of "provider_fee" */
export type ProviderFeeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProviderFeeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "provider_fee" */
export type ProviderFeeAggregateOrderBy = {
  avg?: InputMaybe<ProviderFeeAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ProviderFeeMaxOrderBy>;
  min?: InputMaybe<ProviderFeeMinOrderBy>;
  stddev?: InputMaybe<ProviderFeeStddevOrderBy>;
  stddev_pop?: InputMaybe<ProviderFeeStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ProviderFeeStddevSampOrderBy>;
  sum?: InputMaybe<ProviderFeeSumOrderBy>;
  var_pop?: InputMaybe<ProviderFeeVarPopOrderBy>;
  var_samp?: InputMaybe<ProviderFeeVarSampOrderBy>;
  variance?: InputMaybe<ProviderFeeVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "provider_fee" */
export type ProviderFeeArrRelInsertInput = {
  data: Array<ProviderFeeInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProviderFeeOnConflict>;
};

/** aggregate avg on columns */
export type ProviderFeeAvgFields = {
  constant_invoice_fee?: Maybe<Scalars['Float']>;
  constant_withdraw_fee?: Maybe<Scalars['Float']>;
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  invoice_fee_percent?: Maybe<Scalars['Float']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  provider_family_code?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  withdraw_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "provider_fee" */
export type ProviderFeeAvgOrderBy = {
  constant_invoice_fee?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_fee_min_amount?: InputMaybe<OrderBy>;
  invoice_fee_percent?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  provider_family_code?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  withdraw_fee_percent?: InputMaybe<OrderBy>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "provider_fee". All fields are combined with a logical 'AND'. */
export type ProviderFeeBoolExp = {
  _and?: InputMaybe<Array<ProviderFeeBoolExp>>;
  _not?: InputMaybe<ProviderFeeBoolExp>;
  _or?: InputMaybe<Array<ProviderFeeBoolExp>>;
  constant_invoice_fee?: InputMaybe<NumericComparisonExp>;
  constant_withdraw_fee?: InputMaybe<NumericComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<CurrencyBoolExp>;
  currency_id?: InputMaybe<StringComparisonExp>;
  edit_user_id?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  invoice_fee_min_amount?: InputMaybe<NumericComparisonExp>;
  invoice_fee_percent?: InputMaybe<NumericComparisonExp>;
  invoice_transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
  merchant_constant_invoice_fee?: InputMaybe<NumericComparisonExp>;
  merchant_constant_withdraw_fee?: InputMaybe<NumericComparisonExp>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
  merchant_invoice_fee_min_amount?: InputMaybe<NumericComparisonExp>;
  merchant_invoice_fee_percent?: InputMaybe<NumericComparisonExp>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
  merchant_withdraw_fee_min_amount?: InputMaybe<NumericComparisonExp>;
  merchant_withdraw_fee_percent?: InputMaybe<NumericComparisonExp>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<NumericComparisonExp>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
  provider?: InputMaybe<ProviderBoolExp>;
  provider_family_code?: InputMaybe<IntComparisonExp>;
  provider_family_id?: InputMaybe<StringComparisonExp>;
  provider_id?: InputMaybe<StringComparisonExp>;
  rolling_reserve_duration?: InputMaybe<IntComparisonExp>;
  rolling_reserve_percent?: InputMaybe<NumericComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  withdraw_fee_min_amount?: InputMaybe<NumericComparisonExp>;
  withdraw_fee_percent?: InputMaybe<NumericComparisonExp>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<NumericComparisonExp>;
  withdraw_transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
};

/** unique or primary key constraints on table "provider_fee" */
export enum ProviderFeeConstraint {
  /** unique or primary key constraint on columns "provider_id", "currency_id" */
  ProviderFeeCurrencyIdProviderIdKey = 'provider_fee_currency_id_provider_id_key',
  /** unique or primary key constraint on columns "id" */
  ProviderFeePkey = 'provider_fee_pkey'
}

/** input type for incrementing numeric columns in table "provider_fee" */
export type ProviderFeeIncInput = {
  constant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  constant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  invoice_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  invoice_fee_percent?: InputMaybe<Scalars['numeric']>;
  invoice_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_constant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  merchant_constant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  provider_family_code?: InputMaybe<Scalars['Int']>;
  rolling_reserve_duration?: InputMaybe<Scalars['Int']>;
  rolling_reserve_percent?: InputMaybe<Scalars['numeric']>;
  withdraw_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  withdraw_fee_percent?: InputMaybe<Scalars['numeric']>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  withdraw_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "provider_fee" */
export type ProviderFeeInsertInput = {
  constant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  constant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<CurrencyObjRelInsertInput>;
  currency_id?: InputMaybe<Scalars['String']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  invoice_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  invoice_fee_percent?: InputMaybe<Scalars['numeric']>;
  invoice_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_constant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  merchant_constant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  provider?: InputMaybe<ProviderObjRelInsertInput>;
  provider_family_code?: InputMaybe<Scalars['Int']>;
  provider_family_id?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
  rolling_reserve_duration?: InputMaybe<Scalars['Int']>;
  rolling_reserve_percent?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  withdraw_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  withdraw_fee_percent?: InputMaybe<Scalars['numeric']>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  withdraw_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type ProviderFeeMaxFields = {
  constant_invoice_fee?: Maybe<Scalars['numeric']>;
  constant_withdraw_fee?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  invoice_fee_min_amount?: Maybe<Scalars['numeric']>;
  invoice_fee_percent?: Maybe<Scalars['numeric']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['numeric']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['numeric']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  provider_family_code?: Maybe<Scalars['Int']>;
  provider_family_id?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
  rolling_reserve_duration?: Maybe<Scalars['Int']>;
  rolling_reserve_percent?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  withdraw_fee_min_amount?: Maybe<Scalars['numeric']>;
  withdraw_fee_percent?: Maybe<Scalars['numeric']>;
  withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "provider_fee" */
export type ProviderFeeMaxOrderBy = {
  constant_invoice_fee?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_fee_min_amount?: InputMaybe<OrderBy>;
  invoice_fee_percent?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  provider_family_code?: InputMaybe<OrderBy>;
  provider_family_id?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  withdraw_fee_percent?: InputMaybe<OrderBy>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ProviderFeeMinFields = {
  constant_invoice_fee?: Maybe<Scalars['numeric']>;
  constant_withdraw_fee?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  invoice_fee_min_amount?: Maybe<Scalars['numeric']>;
  invoice_fee_percent?: Maybe<Scalars['numeric']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['numeric']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['numeric']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  provider_family_code?: Maybe<Scalars['Int']>;
  provider_family_id?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
  rolling_reserve_duration?: Maybe<Scalars['Int']>;
  rolling_reserve_percent?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  withdraw_fee_min_amount?: Maybe<Scalars['numeric']>;
  withdraw_fee_percent?: Maybe<Scalars['numeric']>;
  withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "provider_fee" */
export type ProviderFeeMinOrderBy = {
  constant_invoice_fee?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_fee_min_amount?: InputMaybe<OrderBy>;
  invoice_fee_percent?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  provider_family_code?: InputMaybe<OrderBy>;
  provider_family_id?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  withdraw_fee_percent?: InputMaybe<OrderBy>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "provider_fee" */
export type ProviderFeeMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProviderFee>;
};

/** on_conflict condition type for table "provider_fee" */
export type ProviderFeeOnConflict = {
  constraint: ProviderFeeConstraint;
  update_columns?: Array<ProviderFeeUpdateColumn>;
  where?: InputMaybe<ProviderFeeBoolExp>;
};

/** Ordering options when selecting data from "provider_fee". */
export type ProviderFeeOrderBy = {
  constant_invoice_fee?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency?: InputMaybe<CurrencyOrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_fee_min_amount?: InputMaybe<OrderBy>;
  invoice_fee_percent?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  provider?: InputMaybe<ProviderOrderBy>;
  provider_family_code?: InputMaybe<OrderBy>;
  provider_family_id?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  withdraw_fee_percent?: InputMaybe<OrderBy>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: provider_fee */
export type ProviderFeePkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "provider_fee" */
export enum ProviderFeeSelectColumn {
  /** column name */
  ConstantInvoiceFee = 'constant_invoice_fee',
  /** column name */
  ConstantWithdrawFee = 'constant_withdraw_fee',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  EditUserId = 'edit_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceFeeMinAmount = 'invoice_fee_min_amount',
  /** column name */
  InvoiceFeePercent = 'invoice_fee_percent',
  /** column name */
  InvoiceTransactionFeeAmount = 'invoice_transaction_fee_amount',
  /** column name */
  MerchantConstantInvoiceFee = 'merchant_constant_invoice_fee',
  /** column name */
  MerchantConstantWithdrawFee = 'merchant_constant_withdraw_fee',
  /** column name */
  MerchantInvoiceDeclineTransactionFeeAmount = 'merchant_invoice_decline_transaction_fee_amount',
  /** column name */
  MerchantInvoiceFeeMinAmount = 'merchant_invoice_fee_min_amount',
  /** column name */
  MerchantInvoiceFeePercent = 'merchant_invoice_fee_percent',
  /** column name */
  MerchantInvoiceTransactionFeeAmount = 'merchant_invoice_transaction_fee_amount',
  /** column name */
  MerchantWithdrawDeclineTransactionFeeAmount = 'merchant_withdraw_decline_transaction_fee_amount',
  /** column name */
  MerchantWithdrawFeeMinAmount = 'merchant_withdraw_fee_min_amount',
  /** column name */
  MerchantWithdrawFeePercent = 'merchant_withdraw_fee_percent',
  /** column name */
  MerchantWithdrawSettlementUsdtFeePercent = 'merchant_withdraw_settlement_usdt_fee_percent',
  /** column name */
  MerchantWithdrawTransactionFeeAmount = 'merchant_withdraw_transaction_fee_amount',
  /** column name */
  ProviderFamilyCode = 'provider_family_code',
  /** column name */
  ProviderFamilyId = 'provider_family_id',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  RollingReserveDuration = 'rolling_reserve_duration',
  /** column name */
  RollingReservePercent = 'rolling_reserve_percent',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WithdrawFeeMinAmount = 'withdraw_fee_min_amount',
  /** column name */
  WithdrawFeePercent = 'withdraw_fee_percent',
  /** column name */
  WithdrawSettlementUsdtFeePercent = 'withdraw_settlement_usdt_fee_percent',
  /** column name */
  WithdrawTransactionFeeAmount = 'withdraw_transaction_fee_amount'
}

/** input type for updating data in table "provider_fee" */
export type ProviderFeeSetInput = {
  constant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  constant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency_id?: InputMaybe<Scalars['String']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  invoice_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  invoice_fee_percent?: InputMaybe<Scalars['numeric']>;
  invoice_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_constant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  merchant_constant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  provider_family_code?: InputMaybe<Scalars['Int']>;
  provider_family_id?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
  rolling_reserve_duration?: InputMaybe<Scalars['Int']>;
  rolling_reserve_percent?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  withdraw_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  withdraw_fee_percent?: InputMaybe<Scalars['numeric']>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  withdraw_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type ProviderFeeStddevFields = {
  constant_invoice_fee?: Maybe<Scalars['Float']>;
  constant_withdraw_fee?: Maybe<Scalars['Float']>;
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  invoice_fee_percent?: Maybe<Scalars['Float']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  provider_family_code?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  withdraw_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "provider_fee" */
export type ProviderFeeStddevOrderBy = {
  constant_invoice_fee?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_fee_min_amount?: InputMaybe<OrderBy>;
  invoice_fee_percent?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  provider_family_code?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  withdraw_fee_percent?: InputMaybe<OrderBy>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ProviderFeeStddevPopFields = {
  constant_invoice_fee?: Maybe<Scalars['Float']>;
  constant_withdraw_fee?: Maybe<Scalars['Float']>;
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  invoice_fee_percent?: Maybe<Scalars['Float']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  provider_family_code?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  withdraw_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "provider_fee" */
export type ProviderFeeStddevPopOrderBy = {
  constant_invoice_fee?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_fee_min_amount?: InputMaybe<OrderBy>;
  invoice_fee_percent?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  provider_family_code?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  withdraw_fee_percent?: InputMaybe<OrderBy>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ProviderFeeStddevSampFields = {
  constant_invoice_fee?: Maybe<Scalars['Float']>;
  constant_withdraw_fee?: Maybe<Scalars['Float']>;
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  invoice_fee_percent?: Maybe<Scalars['Float']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  provider_family_code?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  withdraw_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "provider_fee" */
export type ProviderFeeStddevSampOrderBy = {
  constant_invoice_fee?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_fee_min_amount?: InputMaybe<OrderBy>;
  invoice_fee_percent?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  provider_family_code?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  withdraw_fee_percent?: InputMaybe<OrderBy>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type ProviderFeeSumFields = {
  constant_invoice_fee?: Maybe<Scalars['numeric']>;
  constant_withdraw_fee?: Maybe<Scalars['numeric']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  invoice_fee_min_amount?: Maybe<Scalars['numeric']>;
  invoice_fee_percent?: Maybe<Scalars['numeric']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['numeric']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['numeric']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  provider_family_code?: Maybe<Scalars['Int']>;
  rolling_reserve_duration?: Maybe<Scalars['Int']>;
  rolling_reserve_percent?: Maybe<Scalars['numeric']>;
  withdraw_fee_min_amount?: Maybe<Scalars['numeric']>;
  withdraw_fee_percent?: Maybe<Scalars['numeric']>;
  withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "provider_fee" */
export type ProviderFeeSumOrderBy = {
  constant_invoice_fee?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_fee_min_amount?: InputMaybe<OrderBy>;
  invoice_fee_percent?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  provider_family_code?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  withdraw_fee_percent?: InputMaybe<OrderBy>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** update columns of table "provider_fee" */
export enum ProviderFeeUpdateColumn {
  /** column name */
  ConstantInvoiceFee = 'constant_invoice_fee',
  /** column name */
  ConstantWithdrawFee = 'constant_withdraw_fee',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  EditUserId = 'edit_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceFeeMinAmount = 'invoice_fee_min_amount',
  /** column name */
  InvoiceFeePercent = 'invoice_fee_percent',
  /** column name */
  InvoiceTransactionFeeAmount = 'invoice_transaction_fee_amount',
  /** column name */
  MerchantConstantInvoiceFee = 'merchant_constant_invoice_fee',
  /** column name */
  MerchantConstantWithdrawFee = 'merchant_constant_withdraw_fee',
  /** column name */
  MerchantInvoiceDeclineTransactionFeeAmount = 'merchant_invoice_decline_transaction_fee_amount',
  /** column name */
  MerchantInvoiceFeeMinAmount = 'merchant_invoice_fee_min_amount',
  /** column name */
  MerchantInvoiceFeePercent = 'merchant_invoice_fee_percent',
  /** column name */
  MerchantInvoiceTransactionFeeAmount = 'merchant_invoice_transaction_fee_amount',
  /** column name */
  MerchantWithdrawDeclineTransactionFeeAmount = 'merchant_withdraw_decline_transaction_fee_amount',
  /** column name */
  MerchantWithdrawFeeMinAmount = 'merchant_withdraw_fee_min_amount',
  /** column name */
  MerchantWithdrawFeePercent = 'merchant_withdraw_fee_percent',
  /** column name */
  MerchantWithdrawSettlementUsdtFeePercent = 'merchant_withdraw_settlement_usdt_fee_percent',
  /** column name */
  MerchantWithdrawTransactionFeeAmount = 'merchant_withdraw_transaction_fee_amount',
  /** column name */
  ProviderFamilyCode = 'provider_family_code',
  /** column name */
  ProviderFamilyId = 'provider_family_id',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  RollingReserveDuration = 'rolling_reserve_duration',
  /** column name */
  RollingReservePercent = 'rolling_reserve_percent',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WithdrawFeeMinAmount = 'withdraw_fee_min_amount',
  /** column name */
  WithdrawFeePercent = 'withdraw_fee_percent',
  /** column name */
  WithdrawSettlementUsdtFeePercent = 'withdraw_settlement_usdt_fee_percent',
  /** column name */
  WithdrawTransactionFeeAmount = 'withdraw_transaction_fee_amount'
}

export type ProviderFeeUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProviderFeeIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProviderFeeSetInput>;
  where: ProviderFeeBoolExp;
};

/** aggregate var_pop on columns */
export type ProviderFeeVarPopFields = {
  constant_invoice_fee?: Maybe<Scalars['Float']>;
  constant_withdraw_fee?: Maybe<Scalars['Float']>;
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  invoice_fee_percent?: Maybe<Scalars['Float']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  provider_family_code?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  withdraw_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "provider_fee" */
export type ProviderFeeVarPopOrderBy = {
  constant_invoice_fee?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_fee_min_amount?: InputMaybe<OrderBy>;
  invoice_fee_percent?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  provider_family_code?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  withdraw_fee_percent?: InputMaybe<OrderBy>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ProviderFeeVarSampFields = {
  constant_invoice_fee?: Maybe<Scalars['Float']>;
  constant_withdraw_fee?: Maybe<Scalars['Float']>;
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  invoice_fee_percent?: Maybe<Scalars['Float']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  provider_family_code?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  withdraw_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "provider_fee" */
export type ProviderFeeVarSampOrderBy = {
  constant_invoice_fee?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_fee_min_amount?: InputMaybe<OrderBy>;
  invoice_fee_percent?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  provider_family_code?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  withdraw_fee_percent?: InputMaybe<OrderBy>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ProviderFeeVarianceFields = {
  constant_invoice_fee?: Maybe<Scalars['Float']>;
  constant_withdraw_fee?: Maybe<Scalars['Float']>;
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  invoice_fee_percent?: Maybe<Scalars['Float']>;
  invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_invoice_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  provider_family_code?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  withdraw_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "provider_fee" */
export type ProviderFeeVarianceOrderBy = {
  constant_invoice_fee?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_fee_min_amount?: InputMaybe<OrderBy>;
  invoice_fee_percent?: InputMaybe<OrderBy>;
  invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_invoice_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  provider_family_code?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  withdraw_fee_percent?: InputMaybe<OrderBy>;
  withdraw_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** input type for incrementing numeric columns in table "provider" */
export type ProviderIncInput = {
  edit_user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "provider" */
export type ProviderInsertInput = {
  alias?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  default_date_column_analytics?: InputMaybe<Scalars['String']>;
  default_payment_system?: InputMaybe<Scalars['String']>;
  default_traffic_type_id?: InputMaybe<Scalars['String']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  fort_id?: InputMaybe<Scalars['String']>;
  gates?: InputMaybe<GateArrRelInsertInput>;
  id?: InputMaybe<Scalars['String']>;
  invoices?: InputMaybe<InvoiceArrRelInsertInput>;
  is_new?: InputMaybe<Scalars['Boolean']>;
  merchant_balances?: InputMaybe<MerchantBalanceArrRelInsertInput>;
  merchant_fees?: InputMaybe<MerchantFeeArrRelInsertInput>;
  merchants?: InputMaybe<MerchantArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  payment_system?: InputMaybe<PaymentSystemObjRelInsertInput>;
  provider_countries?: InputMaybe<ProviderCountryArrRelInsertInput>;
  provider_family?: InputMaybe<Scalars['String']>;
  provider_family_object?: InputMaybe<ProviderFamilyObjRelInsertInput>;
  provider_family_payment_system?: InputMaybe<Scalars['String']>;
  provider_fees?: InputMaybe<ProviderFeeArrRelInsertInput>;
  provider_limits?: InputMaybe<ProviderLimitArrRelInsertInput>;
  provider_payment_systems?: InputMaybe<ProviderPaymentSystemArrRelInsertInput>;
  provider_status_id?: InputMaybe<Scalars['String']>;
  provider_type_id?: InputMaybe<Scalars['String']>;
  traffic_type?: InputMaybe<TrafficTypeObjRelInsertInput>;
  transaction_histories?: InputMaybe<TransactionHistoryArrRelInsertInput>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  withdraw_requests?: InputMaybe<WithdrawRequestArrRelInsertInput>;
  withdraws?: InputMaybe<WithdrawArrRelInsertInput>;
};

/** columns and relationships of "provider_limit" */
export type ProviderLimit = {
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  currency: Currency;
  currency_id: Scalars['String'];
  id: Scalars['Int'];
  max_limit: Scalars['numeric'];
  min_limit: Scalars['numeric'];
  /** An object relationship */
  provider: Provider;
  provider_id: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

/** aggregated selection of "provider_limit" */
export type ProviderLimitAggregate = {
  aggregate?: Maybe<ProviderLimitAggregateFields>;
  nodes: Array<ProviderLimit>;
};

/** aggregate fields of "provider_limit" */
export type ProviderLimitAggregateFields = {
  avg?: Maybe<ProviderLimitAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProviderLimitMaxFields>;
  min?: Maybe<ProviderLimitMinFields>;
  stddev?: Maybe<ProviderLimitStddevFields>;
  stddev_pop?: Maybe<ProviderLimitStddevPopFields>;
  stddev_samp?: Maybe<ProviderLimitStddevSampFields>;
  sum?: Maybe<ProviderLimitSumFields>;
  var_pop?: Maybe<ProviderLimitVarPopFields>;
  var_samp?: Maybe<ProviderLimitVarSampFields>;
  variance?: Maybe<ProviderLimitVarianceFields>;
};


/** aggregate fields of "provider_limit" */
export type ProviderLimitAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProviderLimitSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "provider_limit" */
export type ProviderLimitAggregateOrderBy = {
  avg?: InputMaybe<ProviderLimitAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ProviderLimitMaxOrderBy>;
  min?: InputMaybe<ProviderLimitMinOrderBy>;
  stddev?: InputMaybe<ProviderLimitStddevOrderBy>;
  stddev_pop?: InputMaybe<ProviderLimitStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ProviderLimitStddevSampOrderBy>;
  sum?: InputMaybe<ProviderLimitSumOrderBy>;
  var_pop?: InputMaybe<ProviderLimitVarPopOrderBy>;
  var_samp?: InputMaybe<ProviderLimitVarSampOrderBy>;
  variance?: InputMaybe<ProviderLimitVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "provider_limit" */
export type ProviderLimitArrRelInsertInput = {
  data: Array<ProviderLimitInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProviderLimitOnConflict>;
};

/** aggregate avg on columns */
export type ProviderLimitAvgFields = {
  id?: Maybe<Scalars['Float']>;
  max_limit?: Maybe<Scalars['Float']>;
  min_limit?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "provider_limit" */
export type ProviderLimitAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  max_limit?: InputMaybe<OrderBy>;
  min_limit?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "provider_limit". All fields are combined with a logical 'AND'. */
export type ProviderLimitBoolExp = {
  _and?: InputMaybe<Array<ProviderLimitBoolExp>>;
  _not?: InputMaybe<ProviderLimitBoolExp>;
  _or?: InputMaybe<Array<ProviderLimitBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<CurrencyBoolExp>;
  currency_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  max_limit?: InputMaybe<NumericComparisonExp>;
  min_limit?: InputMaybe<NumericComparisonExp>;
  provider?: InputMaybe<ProviderBoolExp>;
  provider_id?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "provider_limit" */
export enum ProviderLimitConstraint {
  /** unique or primary key constraint on columns "id" */
  ProviderLimitPkey = 'provider_limit_pkey',
  /** unique or primary key constraint on columns "type", "provider_id", "currency_id" */
  ProviderLimitProviderIdCurrencyIdTypeKey = 'provider_limit_provider_id_currency_id_type_key'
}

/** input type for incrementing numeric columns in table "provider_limit" */
export type ProviderLimitIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  max_limit?: InputMaybe<Scalars['numeric']>;
  min_limit?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "provider_limit" */
export type ProviderLimitInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<CurrencyObjRelInsertInput>;
  currency_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  max_limit?: InputMaybe<Scalars['numeric']>;
  min_limit?: InputMaybe<Scalars['numeric']>;
  provider?: InputMaybe<ProviderObjRelInsertInput>;
  provider_id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ProviderLimitMaxFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  max_limit?: Maybe<Scalars['numeric']>;
  min_limit?: Maybe<Scalars['numeric']>;
  provider_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "provider_limit" */
export type ProviderLimitMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  max_limit?: InputMaybe<OrderBy>;
  min_limit?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ProviderLimitMinFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  max_limit?: Maybe<Scalars['numeric']>;
  min_limit?: Maybe<Scalars['numeric']>;
  provider_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "provider_limit" */
export type ProviderLimitMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  max_limit?: InputMaybe<OrderBy>;
  min_limit?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "provider_limit" */
export type ProviderLimitMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProviderLimit>;
};

/** on_conflict condition type for table "provider_limit" */
export type ProviderLimitOnConflict = {
  constraint: ProviderLimitConstraint;
  update_columns?: Array<ProviderLimitUpdateColumn>;
  where?: InputMaybe<ProviderLimitBoolExp>;
};

/** Ordering options when selecting data from "provider_limit". */
export type ProviderLimitOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  currency?: InputMaybe<CurrencyOrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  max_limit?: InputMaybe<OrderBy>;
  min_limit?: InputMaybe<OrderBy>;
  provider?: InputMaybe<ProviderOrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: provider_limit */
export type ProviderLimitPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "provider_limit" */
export enum ProviderLimitSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaxLimit = 'max_limit',
  /** column name */
  MinLimit = 'min_limit',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "provider_limit" */
export type ProviderLimitSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  max_limit?: InputMaybe<Scalars['numeric']>;
  min_limit?: InputMaybe<Scalars['numeric']>;
  provider_id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ProviderLimitStddevFields = {
  id?: Maybe<Scalars['Float']>;
  max_limit?: Maybe<Scalars['Float']>;
  min_limit?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "provider_limit" */
export type ProviderLimitStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  max_limit?: InputMaybe<OrderBy>;
  min_limit?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ProviderLimitStddevPopFields = {
  id?: Maybe<Scalars['Float']>;
  max_limit?: Maybe<Scalars['Float']>;
  min_limit?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "provider_limit" */
export type ProviderLimitStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  max_limit?: InputMaybe<OrderBy>;
  min_limit?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ProviderLimitStddevSampFields = {
  id?: Maybe<Scalars['Float']>;
  max_limit?: Maybe<Scalars['Float']>;
  min_limit?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "provider_limit" */
export type ProviderLimitStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  max_limit?: InputMaybe<OrderBy>;
  min_limit?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type ProviderLimitSumFields = {
  id?: Maybe<Scalars['Int']>;
  max_limit?: Maybe<Scalars['numeric']>;
  min_limit?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "provider_limit" */
export type ProviderLimitSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  max_limit?: InputMaybe<OrderBy>;
  min_limit?: InputMaybe<OrderBy>;
};

/** update columns of table "provider_limit" */
export enum ProviderLimitUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaxLimit = 'max_limit',
  /** column name */
  MinLimit = 'min_limit',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  Type = 'type'
}

export type ProviderLimitUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProviderLimitIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProviderLimitSetInput>;
  where: ProviderLimitBoolExp;
};

/** aggregate var_pop on columns */
export type ProviderLimitVarPopFields = {
  id?: Maybe<Scalars['Float']>;
  max_limit?: Maybe<Scalars['Float']>;
  min_limit?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "provider_limit" */
export type ProviderLimitVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  max_limit?: InputMaybe<OrderBy>;
  min_limit?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ProviderLimitVarSampFields = {
  id?: Maybe<Scalars['Float']>;
  max_limit?: Maybe<Scalars['Float']>;
  min_limit?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "provider_limit" */
export type ProviderLimitVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  max_limit?: InputMaybe<OrderBy>;
  min_limit?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ProviderLimitVarianceFields = {
  id?: Maybe<Scalars['Float']>;
  max_limit?: Maybe<Scalars['Float']>;
  min_limit?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "provider_limit" */
export type ProviderLimitVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  max_limit?: InputMaybe<OrderBy>;
  min_limit?: InputMaybe<OrderBy>;
};

/** aggregate max on columns */
export type ProviderMaxFields = {
  alias?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  default_date_column_analytics?: Maybe<Scalars['String']>;
  default_payment_system?: Maybe<Scalars['String']>;
  default_traffic_type_id?: Maybe<Scalars['String']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  fort_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  provider_family?: Maybe<Scalars['String']>;
  provider_family_payment_system?: Maybe<Scalars['String']>;
  provider_status_id?: Maybe<Scalars['String']>;
  provider_type_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "provider" */
export type ProviderMaxOrderBy = {
  alias?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  default_date_column_analytics?: InputMaybe<OrderBy>;
  default_payment_system?: InputMaybe<OrderBy>;
  default_traffic_type_id?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  fort_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  provider_family?: InputMaybe<OrderBy>;
  provider_family_payment_system?: InputMaybe<OrderBy>;
  provider_status_id?: InputMaybe<OrderBy>;
  provider_type_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ProviderMinFields = {
  alias?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  default_date_column_analytics?: Maybe<Scalars['String']>;
  default_payment_system?: Maybe<Scalars['String']>;
  default_traffic_type_id?: Maybe<Scalars['String']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  fort_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  provider_family?: Maybe<Scalars['String']>;
  provider_family_payment_system?: Maybe<Scalars['String']>;
  provider_status_id?: Maybe<Scalars['String']>;
  provider_type_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "provider" */
export type ProviderMinOrderBy = {
  alias?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  default_date_column_analytics?: InputMaybe<OrderBy>;
  default_payment_system?: InputMaybe<OrderBy>;
  default_traffic_type_id?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  fort_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  provider_family?: InputMaybe<OrderBy>;
  provider_family_payment_system?: InputMaybe<OrderBy>;
  provider_status_id?: InputMaybe<OrderBy>;
  provider_type_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "provider" */
export type ProviderMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Provider>;
};

/** input type for inserting object relation for remote table "provider" */
export type ProviderObjRelInsertInput = {
  data: ProviderInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<ProviderOnConflict>;
};

/** on_conflict condition type for table "provider" */
export type ProviderOnConflict = {
  constraint: ProviderConstraint;
  update_columns?: Array<ProviderUpdateColumn>;
  where?: InputMaybe<ProviderBoolExp>;
};

/** Ordering options when selecting data from "provider". */
export type ProviderOrderBy = {
  alias?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  default_date_column_analytics?: InputMaybe<OrderBy>;
  default_payment_system?: InputMaybe<OrderBy>;
  default_traffic_type_id?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  fort_id?: InputMaybe<OrderBy>;
  gates_aggregate?: InputMaybe<GateAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  invoices_aggregate?: InputMaybe<InvoiceAggregateOrderBy>;
  is_new?: InputMaybe<OrderBy>;
  merchant_balances_aggregate?: InputMaybe<MerchantBalanceAggregateOrderBy>;
  merchant_fees_aggregate?: InputMaybe<MerchantFeeAggregateOrderBy>;
  merchants_aggregate?: InputMaybe<MerchantAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  payment_system?: InputMaybe<PaymentSystemOrderBy>;
  provider_countries_aggregate?: InputMaybe<ProviderCountryAggregateOrderBy>;
  provider_family?: InputMaybe<OrderBy>;
  provider_family_object?: InputMaybe<ProviderFamilyOrderBy>;
  provider_family_payment_system?: InputMaybe<OrderBy>;
  provider_fees_aggregate?: InputMaybe<ProviderFeeAggregateOrderBy>;
  provider_limits_aggregate?: InputMaybe<ProviderLimitAggregateOrderBy>;
  provider_payment_systems_aggregate?: InputMaybe<ProviderPaymentSystemAggregateOrderBy>;
  provider_status_id?: InputMaybe<OrderBy>;
  provider_type_id?: InputMaybe<OrderBy>;
  traffic_type?: InputMaybe<TrafficTypeOrderBy>;
  transaction_histories_aggregate?: InputMaybe<TransactionHistoryAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  withdraw_requests_aggregate?: InputMaybe<WithdrawRequestAggregateOrderBy>;
  withdraws_aggregate?: InputMaybe<WithdrawAggregateOrderBy>;
};

/** columns and relationships of "provider_payment_system" */
export type ProviderPaymentSystem = {
  id: Scalars['Int'];
  /** An object relationship */
  payment_system: PaymentSystem;
  payment_system_id: Scalars['String'];
  /** An object relationship */
  provider: Provider;
  provider_id: Scalars['String'];
};

/** aggregated selection of "provider_payment_system" */
export type ProviderPaymentSystemAggregate = {
  aggregate?: Maybe<ProviderPaymentSystemAggregateFields>;
  nodes: Array<ProviderPaymentSystem>;
};

/** aggregate fields of "provider_payment_system" */
export type ProviderPaymentSystemAggregateFields = {
  avg?: Maybe<ProviderPaymentSystemAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ProviderPaymentSystemMaxFields>;
  min?: Maybe<ProviderPaymentSystemMinFields>;
  stddev?: Maybe<ProviderPaymentSystemStddevFields>;
  stddev_pop?: Maybe<ProviderPaymentSystemStddevPopFields>;
  stddev_samp?: Maybe<ProviderPaymentSystemStddevSampFields>;
  sum?: Maybe<ProviderPaymentSystemSumFields>;
  var_pop?: Maybe<ProviderPaymentSystemVarPopFields>;
  var_samp?: Maybe<ProviderPaymentSystemVarSampFields>;
  variance?: Maybe<ProviderPaymentSystemVarianceFields>;
};


/** aggregate fields of "provider_payment_system" */
export type ProviderPaymentSystemAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProviderPaymentSystemSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "provider_payment_system" */
export type ProviderPaymentSystemAggregateOrderBy = {
  avg?: InputMaybe<ProviderPaymentSystemAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ProviderPaymentSystemMaxOrderBy>;
  min?: InputMaybe<ProviderPaymentSystemMinOrderBy>;
  stddev?: InputMaybe<ProviderPaymentSystemStddevOrderBy>;
  stddev_pop?: InputMaybe<ProviderPaymentSystemStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ProviderPaymentSystemStddevSampOrderBy>;
  sum?: InputMaybe<ProviderPaymentSystemSumOrderBy>;
  var_pop?: InputMaybe<ProviderPaymentSystemVarPopOrderBy>;
  var_samp?: InputMaybe<ProviderPaymentSystemVarSampOrderBy>;
  variance?: InputMaybe<ProviderPaymentSystemVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "provider_payment_system" */
export type ProviderPaymentSystemArrRelInsertInput = {
  data: Array<ProviderPaymentSystemInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProviderPaymentSystemOnConflict>;
};

/** aggregate avg on columns */
export type ProviderPaymentSystemAvgFields = {
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "provider_payment_system" */
export type ProviderPaymentSystemAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "provider_payment_system". All fields are combined with a logical 'AND'. */
export type ProviderPaymentSystemBoolExp = {
  _and?: InputMaybe<Array<ProviderPaymentSystemBoolExp>>;
  _not?: InputMaybe<ProviderPaymentSystemBoolExp>;
  _or?: InputMaybe<Array<ProviderPaymentSystemBoolExp>>;
  id?: InputMaybe<IntComparisonExp>;
  payment_system?: InputMaybe<PaymentSystemBoolExp>;
  payment_system_id?: InputMaybe<StringComparisonExp>;
  provider?: InputMaybe<ProviderBoolExp>;
  provider_id?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "provider_payment_system" */
export enum ProviderPaymentSystemConstraint {
  /** unique or primary key constraint on columns "id" */
  ProviderPaymentSystemPkey = 'provider_payment_system_pkey',
  /** unique or primary key constraint on columns "provider_id", "payment_system_id" */
  ProviderPaymentSystemProviderIdPaymentSystemIdKey = 'provider_payment_system_provider_id_payment_system_id_key'
}

/** input type for incrementing numeric columns in table "provider_payment_system" */
export type ProviderPaymentSystemIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "provider_payment_system" */
export type ProviderPaymentSystemInsertInput = {
  id?: InputMaybe<Scalars['Int']>;
  payment_system?: InputMaybe<PaymentSystemObjRelInsertInput>;
  payment_system_id?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<ProviderObjRelInsertInput>;
  provider_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ProviderPaymentSystemMaxFields = {
  id?: Maybe<Scalars['Int']>;
  payment_system_id?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "provider_payment_system" */
export type ProviderPaymentSystemMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  payment_system_id?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ProviderPaymentSystemMinFields = {
  id?: Maybe<Scalars['Int']>;
  payment_system_id?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "provider_payment_system" */
export type ProviderPaymentSystemMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  payment_system_id?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "provider_payment_system" */
export type ProviderPaymentSystemMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProviderPaymentSystem>;
};

/** on_conflict condition type for table "provider_payment_system" */
export type ProviderPaymentSystemOnConflict = {
  constraint: ProviderPaymentSystemConstraint;
  update_columns?: Array<ProviderPaymentSystemUpdateColumn>;
  where?: InputMaybe<ProviderPaymentSystemBoolExp>;
};

/** Ordering options when selecting data from "provider_payment_system". */
export type ProviderPaymentSystemOrderBy = {
  id?: InputMaybe<OrderBy>;
  payment_system?: InputMaybe<PaymentSystemOrderBy>;
  payment_system_id?: InputMaybe<OrderBy>;
  provider?: InputMaybe<ProviderOrderBy>;
  provider_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: provider_payment_system */
export type ProviderPaymentSystemPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "provider_payment_system" */
export enum ProviderPaymentSystemSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  PaymentSystemId = 'payment_system_id',
  /** column name */
  ProviderId = 'provider_id'
}

/** input type for updating data in table "provider_payment_system" */
export type ProviderPaymentSystemSetInput = {
  id?: InputMaybe<Scalars['Int']>;
  payment_system_id?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ProviderPaymentSystemStddevFields = {
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "provider_payment_system" */
export type ProviderPaymentSystemStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ProviderPaymentSystemStddevPopFields = {
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "provider_payment_system" */
export type ProviderPaymentSystemStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ProviderPaymentSystemStddevSampFields = {
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "provider_payment_system" */
export type ProviderPaymentSystemStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type ProviderPaymentSystemSumFields = {
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "provider_payment_system" */
export type ProviderPaymentSystemSumOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "provider_payment_system" */
export enum ProviderPaymentSystemUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  PaymentSystemId = 'payment_system_id',
  /** column name */
  ProviderId = 'provider_id'
}

export type ProviderPaymentSystemUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProviderPaymentSystemIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProviderPaymentSystemSetInput>;
  where: ProviderPaymentSystemBoolExp;
};

/** aggregate var_pop on columns */
export type ProviderPaymentSystemVarPopFields = {
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "provider_payment_system" */
export type ProviderPaymentSystemVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ProviderPaymentSystemVarSampFields = {
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "provider_payment_system" */
export type ProviderPaymentSystemVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ProviderPaymentSystemVarianceFields = {
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "provider_payment_system" */
export type ProviderPaymentSystemVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: provider */
export type ProviderPkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "provider" */
export enum ProviderSelectColumn {
  /** column name */
  Alias = 'alias',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DefaultDateColumnAnalytics = 'default_date_column_analytics',
  /** column name */
  DefaultPaymentSystem = 'default_payment_system',
  /** column name */
  DefaultTrafficTypeId = 'default_traffic_type_id',
  /** column name */
  EditUserId = 'edit_user_id',
  /** column name */
  FortId = 'fort_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsNew = 'is_new',
  /** column name */
  Name = 'name',
  /** column name */
  ProviderFamily = 'provider_family',
  /** column name */
  ProviderFamilyPaymentSystem = 'provider_family_payment_system',
  /** column name */
  ProviderStatusId = 'provider_status_id',
  /** column name */
  ProviderTypeId = 'provider_type_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "provider" */
export type ProviderSetInput = {
  alias?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  default_date_column_analytics?: InputMaybe<Scalars['String']>;
  default_payment_system?: InputMaybe<Scalars['String']>;
  default_traffic_type_id?: InputMaybe<Scalars['String']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  fort_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  is_new?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  provider_family?: InputMaybe<Scalars['String']>;
  provider_family_payment_system?: InputMaybe<Scalars['String']>;
  provider_status_id?: InputMaybe<Scalars['String']>;
  provider_type_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Справочник статусов провайдеров */
export type ProviderStatus = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "provider_status" */
export type ProviderStatusAggregate = {
  aggregate?: Maybe<ProviderStatusAggregateFields>;
  nodes: Array<ProviderStatus>;
};

/** aggregate fields of "provider_status" */
export type ProviderStatusAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<ProviderStatusMaxFields>;
  min?: Maybe<ProviderStatusMinFields>;
};


/** aggregate fields of "provider_status" */
export type ProviderStatusAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProviderStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "provider_status". All fields are combined with a logical 'AND'. */
export type ProviderStatusBoolExp = {
  _and?: InputMaybe<Array<ProviderStatusBoolExp>>;
  _not?: InputMaybe<ProviderStatusBoolExp>;
  _or?: InputMaybe<Array<ProviderStatusBoolExp>>;
  id?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "provider_status" */
export enum ProviderStatusConstraint {
  /** unique or primary key constraint on columns "id" */
  ProviderStatusPkey = 'provider_status_pkey'
}

/** input type for inserting data into table "provider_status" */
export type ProviderStatusInsertInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ProviderStatusMaxFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ProviderStatusMinFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "provider_status" */
export type ProviderStatusMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProviderStatus>;
};

/** on_conflict condition type for table "provider_status" */
export type ProviderStatusOnConflict = {
  constraint: ProviderStatusConstraint;
  update_columns?: Array<ProviderStatusUpdateColumn>;
  where?: InputMaybe<ProviderStatusBoolExp>;
};

/** Ordering options when selecting data from "provider_status". */
export type ProviderStatusOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: provider_status */
export type ProviderStatusPkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "provider_status" */
export enum ProviderStatusSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "provider_status" */
export type ProviderStatusSetInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "provider_status" */
export enum ProviderStatusUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type ProviderStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProviderStatusSetInput>;
  where: ProviderStatusBoolExp;
};

/** aggregate stddev on columns */
export type ProviderStddevFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "provider" */
export type ProviderStddevOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ProviderStddevPopFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "provider" */
export type ProviderStddevPopOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ProviderStddevSampFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "provider" */
export type ProviderStddevSampOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type ProviderSumFields = {
  edit_user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "provider" */
export type ProviderSumOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
};

/** update columns of table "provider" */
export enum ProviderUpdateColumn {
  /** column name */
  Alias = 'alias',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DefaultDateColumnAnalytics = 'default_date_column_analytics',
  /** column name */
  DefaultPaymentSystem = 'default_payment_system',
  /** column name */
  DefaultTrafficTypeId = 'default_traffic_type_id',
  /** column name */
  EditUserId = 'edit_user_id',
  /** column name */
  FortId = 'fort_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsNew = 'is_new',
  /** column name */
  Name = 'name',
  /** column name */
  ProviderFamily = 'provider_family',
  /** column name */
  ProviderFamilyPaymentSystem = 'provider_family_payment_system',
  /** column name */
  ProviderStatusId = 'provider_status_id',
  /** column name */
  ProviderTypeId = 'provider_type_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type ProviderUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProviderIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProviderSetInput>;
  where: ProviderBoolExp;
};

/** aggregate var_pop on columns */
export type ProviderVarPopFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "provider" */
export type ProviderVarPopOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ProviderVarSampFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "provider" */
export type ProviderVarSampOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ProviderVarianceFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "provider" */
export type ProviderVarianceOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
};

export type PspFormDataOutput = {
  params: FormData;
  url: Scalars['String'];
};

export type QueryRoot = {
  ampV2RequestApm: Scalars['json'];
  ampv2InvoiceInfo: Scalars['json'];
  anH2HInvoiceOrderInfo: Scalars['json'];
  anH2HWithdrawOrderInfo: Scalars['json'];
  anInternalBalances?: Maybe<Array<AnInternalBalancesOutput>>;
  anP2PRequest?: Maybe<AnP2PRequestOutOutput>;
  /** предоставляет данные для админки на вкладке "ANALYTICS" на карточке мерчанта */
  analyticsConsolidatedReport?: Maybe<AnalyticsConsolidatedReportResponse>;
  /** предоставляет данные для админки на вкладке "Consolidate report" */
  analyticsConsolidatedReportGeneral: AnalyticsConsolidatedReportGeneralResponse;
  /** Метод для получения данных о балансах семейства провайдеров. */
  analyticsProviderFamilyBalances?: Maybe<AnalyticsProviderFamilyBalancesOutput>;
  analyticsProviderInternalBalances: Scalars['json'];
  analyticsWidgetGeneralInfo?: Maybe<AnalyticsWidgetGeneralInfo>;
  /** предоставляет данные для виджета Payment Analitics в админку и ЛК */
  analyticsWidgetPaymentAnalytics?: Maybe<AnalyticsWidgetPaymentAnalytics>;
  analytycsProviderBalances: Scalars['json'];
  anpInvoiceOrderInfo: Scalars['json'];
  anyPaySyncActiveTransaction: Scalars['json'];
  apH2HInternalBalances?: Maybe<Array<ApH2HInternalBalancesOutput>>;
  apH2HInternalBalancesV2: Scalars['json'];
  apH2HInvoiceOrderInfo: Scalars['json'];
  /** fetch data from the table: "audit" */
  audit: Array<Audit>;
  /** Возвращает event для проекта */
  auditFromSentry?: Maybe<AuditFromSentryOutput>;
  /** fetch aggregated fields from the table: "audit" */
  audit_aggregate: AuditAggregate;
  /** fetch data from the table: "audit" using primary key columns */
  audit_by_pk?: Maybe<Audit>;
  /** fetch data from the table: "blacklist" */
  blacklist: Array<Blacklist>;
  /** fetch aggregated fields from the table: "blacklist" */
  blacklist_aggregate: BlacklistAggregate;
  /** fetch data from the table: "blacklist" using primary key columns */
  blacklist_by_pk?: Maybe<Blacklist>;
  bvInternalBalances: Scalars['json'];
  bzTechInvoiceOrderInfo: Scalars['json'];
  /** fetch data from the table: "card_system" */
  card_system: Array<CardSystem>;
  /** fetch aggregated fields from the table: "card_system" */
  card_system_aggregate: CardSystemAggregate;
  /** fetch data from the table: "card_system" using primary key columns */
  card_system_by_pk?: Maybe<CardSystem>;
  /** fetch data from the table: "cascade_item" */
  cascade_item: Array<CascadeItem>;
  /** fetch aggregated fields from the table: "cascade_item" */
  cascade_item_aggregate: CascadeItemAggregate;
  /** fetch data from the table: "cascade_item" using primary key columns */
  cascade_item_by_pk?: Maybe<CascadeItem>;
  /** fetch data from the table: "cascade_request" */
  cascade_request: Array<CascadeRequest>;
  /** fetch aggregated fields from the table: "cascade_request" */
  cascade_request_aggregate: CascadeRequestAggregate;
  /** fetch data from the table: "cascade_request" using primary key columns */
  cascade_request_by_pk?: Maybe<CascadeRequest>;
  /** fetch data from the table: "cascades" */
  cascades: Array<Cascades>;
  /** fetch aggregated fields from the table: "cascades" */
  cascades_aggregate: CascadesAggregate;
  /** fetch data from the table: "cascades" using primary key columns */
  cascades_by_pk?: Maybe<Cascades>;
  chsInvoiceOrderInfo: Scalars['json'];
  contactPayInternalBalances?: Maybe<Array<Maybe<ContactPayInternalBalances>>>;
  /** fetch data from the table: "country" */
  country: Array<Country>;
  /** fetch aggregated fields from the table: "country" */
  country_aggregate: CountryAggregate;
  /** fetch data from the table: "country" using primary key columns */
  country_by_pk?: Maybe<Country>;
  /** fetch data from the table: "country_region" */
  country_region: Array<CountryRegion>;
  /** fetch aggregated fields from the table: "country_region" */
  country_region_aggregate: CountryRegionAggregate;
  /** fetch data from the table: "country_region" using primary key columns */
  country_region_by_pk?: Maybe<CountryRegion>;
  /** fetch data from the table: "crypto_currency" */
  crypto_currency: Array<CryptoCurrency>;
  /** fetch aggregated fields from the table: "crypto_currency" */
  crypto_currency_aggregate: CryptoCurrencyAggregate;
  /** fetch data from the table: "crypto_currency" using primary key columns */
  crypto_currency_by_pk?: Maybe<CryptoCurrency>;
  /** fetch data from the table: "crypto_withdraw_request" */
  crypto_withdraw_request: Array<CryptoWithdrawRequest>;
  /** fetch aggregated fields from the table: "crypto_withdraw_request" */
  crypto_withdraw_request_aggregate: CryptoWithdrawRequestAggregate;
  /** fetch data from the table: "crypto_withdraw_request" using primary key columns */
  crypto_withdraw_request_by_pk?: Maybe<CryptoWithdrawRequest>;
  /** fetch data from the table: "crypto_withdraw_request_status" */
  crypto_withdraw_request_status: Array<CryptoWithdrawRequestStatus>;
  /** fetch aggregated fields from the table: "crypto_withdraw_request_status" */
  crypto_withdraw_request_status_aggregate: CryptoWithdrawRequestStatusAggregate;
  /** fetch data from the table: "crypto_withdraw_request_status" using primary key columns */
  crypto_withdraw_request_status_by_pk?: Maybe<CryptoWithdrawRequestStatus>;
  /** fetch data from the table: "currency" */
  currency: Array<Currency>;
  /** fetch aggregated fields from the table: "currency" */
  currency_aggregate: CurrencyAggregate;
  /** fetch data from the table: "currency" using primary key columns */
  currency_by_pk?: Maybe<Currency>;
  dashboardBalanceByCurrencyId?: Maybe<DashboardBalanceByCurrencyIdOutput>;
  dashboardBalanceDynamics: Scalars['json'];
  dashboardBalanceInHeader?: Maybe<Array<DashboardBalanceInHeaderOutput>>;
  /** Возвращает активных мерчантов за месяц */
  dashboardConvertationActiveMerchant?: Maybe<Array<Maybe<DashboardConvertationActiveMerchantOutput>>>;
  /** Возвращает текущий баланс по всем валютам (с конвертацией) */
  dashboardConvertationBalance?: Maybe<Array<Maybe<DashboardConvertationBalanceOutput>>>;
  dashboardConvertationBalanceProviders?: Maybe<Array<Maybe<DashboardConvertationBalanceProvidersOutput>>>;
  dashboardConvertationConversion?: Maybe<DashboardConvertationConversionOutput>;
  /** получение количество мерчантов MAIN */
  dashboardConvertationMerchantCount?: Maybe<DashboardConvertationMerchantCountOutput>;
  /** Возвращает весь профит за период ( с конвертацией) */
  dashboardConvertationProfit?: Maybe<Array<Maybe<DashboardConvertationProfitOutput>>>;
  /** Возвращает  профит за день, месяц, год ( с конвертацией) */
  dashboardConvertationProfitByPeriod?: Maybe<Array<Maybe<DashboardConvertationProfitByPeriodOutput>>>;
  /** Возвращает весь профит по провайдерам за все время */
  dashboardConvertationProfitByProviders?: Maybe<Array<Maybe<DashboardConvertationProfitByProvidersOutput>>>;
  /** получение количество провайдеров MAIN */
  dashboardConvertationProviderCount?: Maybe<DashboardConvertationProviderCountOutput>;
  /** Возвращает оборот за день, месяц, год ( с конвертацией) */
  dashboardConvertationTurnover?: Maybe<Array<Maybe<DashboardConvertationTurnoverOutput>>>;
  dashboardCurrencyWindowWidgets: Scalars['json'];
  dashboardMerchantFee: Scalars['json'];
  dashboardSucceedInvoiceCount: Scalars['json'];
  dashboardWallet?: Maybe<Array<Maybe<DashboardWidgetsWallet>>>;
  /** Возвращает данные для виджета creating payment в админку */
  dashboardWidgetsCreatingPayment?: Maybe<Array<Maybe<DashboardWidgetsCreatingPaymentOutput>>>;
  /** Возвращает данные для виджета invoice-chart */
  dashboardWidgetsInvoiceChart?: Maybe<DashboardWidgetsInvoiceChartOutput>;
  /** Возвращает данные для виджета Payment-Methods */
  dashboardWidgetsPaymentMethods?: Maybe<Array<Maybe<DashboardWidgetsPaymentMethodsOutput>>>;
  dashboardWidgetsProgressStatus?: Maybe<Array<Maybe<DashboardWidgetsStatusChart>>>;
  dashboardWidgetsRevenueChart?: Maybe<DashboardWidgetsRevenueChart>;
  dashboardWidgetsSalesChart?: Maybe<DashboardWidgetsSalesChart>;
  dashboardWidgetsSalesPerCurrencyChart: Scalars['json'];
  dashboardWidgetsStatusChart?: Maybe<Array<DashboardWidgetsStatusChart>>;
  /** Возвращает данные для виджета Withdraw-chart */
  dashboardWidgetsWithdrawlChart?: Maybe<DashboardWidgetsWithdrawlChartOutput>;
  decardInternalBalances: DecardInternalBalancesOutput;
  /** Получение комиссии для указанной суммы */
  feeMerchantFee?: Maybe<FeeMerchantFeeResult>;
  /** An array relationship */
  gate: Array<Gate>;
  /** Получение истории баланса по группе гейтов */
  gateAnalyticsBalanceHistory: GateAnalyticsBalanceHistoryResponse;
  /** Конверсия по гейту */
  gateAnalyticsConversion?: Maybe<Array<Maybe<GateAnalyticsConversionResponse>>>;
  gateAnalyticsLimits?: Maybe<GateAnalyticsConversionLimits>;
  /** Возвращает гейты и валюту по которым были транзакции в указанный период */
  gateFindActiveGateGroupAndCurrencies?: Maybe<FindActiveGateGroupAndCurrenciesOutput>;
  /** An aggregate relationship */
  gate_aggregate: GateAggregate;
  /** fetch data from the table: "gate" using primary key columns */
  gate_by_pk?: Maybe<Gate>;
  /** An array relationship */
  gate_group: Array<GateGroup>;
  /** An aggregate relationship */
  gate_group_aggregate: GateGroupAggregate;
  /** fetch data from the table: "gate_group" using primary key columns */
  gate_group_by_pk?: Maybe<GateGroup>;
  /** fetch data from the table: "gate_type" */
  gate_type: Array<GateType>;
  /** fetch aggregated fields from the table: "gate_type" */
  gate_type_aggregate: GateTypeAggregate;
  /** fetch data from the table: "gate_type" using primary key columns */
  gate_type_by_pk?: Maybe<GateType>;
  /** fetch data from the table: "gender" */
  gender: Array<Gender>;
  /** fetch aggregated fields from the table: "gender" */
  gender_aggregate: GenderAggregate;
  /** fetch data from the table: "gender" using primary key columns */
  gender_by_pk?: Maybe<Gender>;
  getDivergingBalance: Scalars['json'];
  getInfo?: Maybe<GetInfoOutput>;
  /** fetch data from the table: "help" */
  help: Array<Help>;
  /** fetch aggregated fields from the table: "help" */
  help_aggregate: HelpAggregate;
  /** fetch data from the table: "help" using primary key columns */
  help_by_pk?: Maybe<Help>;
  /** fetch data from the table: "help_section" */
  help_section: Array<HelpSection>;
  /** fetch aggregated fields from the table: "help_section" */
  help_section_aggregate: HelpSectionAggregate;
  /** fetch data from the table: "help_section" using primary key columns */
  help_section_by_pk?: Maybe<HelpSection>;
  hrzEncryptKey: Scalars['json'];
  hrzInvoiceOrderInfo: Scalars['json'];
  hrzWithdrawOrderInfo: Scalars['json'];
  invCurrencyRateInfo: Scalars['json'];
  /** fetch data from the table: "invoice" */
  invoice: Array<Invoice>;
  /** fetch aggregated fields from the table: "invoice" */
  invoice_aggregate: InvoiceAggregate;
  /** fetch data from the table: "invoice" using primary key columns */
  invoice_by_pk?: Maybe<Invoice>;
  khmpInternalBalances: Scalars['json'];
  /** fetch data from the table: "language" */
  language: Array<Language>;
  /** fetch aggregated fields from the table: "language" */
  language_aggregate: LanguageAggregate;
  /** fetch data from the table: "language" using primary key columns */
  language_by_pk?: Maybe<Language>;
  /** fetch data from the table: "merchant" */
  merchant: Array<Merchant>;
  /** fetch aggregated fields from the table: "merchant" */
  merchant_aggregate: MerchantAggregate;
  /** fetch data from the table: "merchant_api_token" */
  merchant_api_token: Array<MerchantApiToken>;
  /** fetch aggregated fields from the table: "merchant_api_token" */
  merchant_api_token_aggregate: MerchantApiTokenAggregate;
  /** fetch data from the table: "merchant_api_token" using primary key columns */
  merchant_api_token_by_pk?: Maybe<MerchantApiToken>;
  /** fetch data from the table: "merchant_balance" */
  merchant_balance: Array<MerchantBalance>;
  /** fetch aggregated fields from the table: "merchant_balance" */
  merchant_balance_aggregate: MerchantBalanceAggregate;
  /** fetch data from the table: "merchant_balance" using primary key columns */
  merchant_balance_by_pk?: Maybe<MerchantBalance>;
  /** fetch data from the table: "merchant" using primary key columns */
  merchant_by_pk?: Maybe<Merchant>;
  /** fetch data from the table: "merchant_currency" */
  merchant_currency: Array<MerchantCurrency>;
  /** fetch aggregated fields from the table: "merchant_currency" */
  merchant_currency_aggregate: MerchantCurrencyAggregate;
  /** fetch data from the table: "merchant_currency" using primary key columns */
  merchant_currency_by_pk?: Maybe<MerchantCurrency>;
  /** fetch data from the table: "merchant_fee" */
  merchant_fee: Array<MerchantFee>;
  /** fetch aggregated fields from the table: "merchant_fee" */
  merchant_fee_aggregate: MerchantFeeAggregate;
  /** fetch data from the table: "merchant_fee" using primary key columns */
  merchant_fee_by_pk?: Maybe<MerchantFee>;
  /** fetch data from the table: "merchant_file" */
  merchant_file: Array<MerchantFile>;
  /** fetch aggregated fields from the table: "merchant_file" */
  merchant_file_aggregate: MerchantFileAggregate;
  /** fetch data from the table: "merchant_file" using primary key columns */
  merchant_file_by_pk?: Maybe<MerchantFile>;
  /** fetch data from the table: "merchant_info" */
  merchant_info: Array<MerchantInfo>;
  /** fetch aggregated fields from the table: "merchant_info" */
  merchant_info_aggregate: MerchantInfoAggregate;
  /** fetch data from the table: "merchant_info" using primary key columns */
  merchant_info_by_pk?: Maybe<MerchantInfo>;
  /** fetch data from the table: "merchant_notification" */
  merchant_notification: Array<MerchantNotification>;
  /** fetch aggregated fields from the table: "merchant_notification" */
  merchant_notification_aggregate: MerchantNotificationAggregate;
  /** fetch data from the table: "merchant_notification" using primary key columns */
  merchant_notification_by_pk?: Maybe<MerchantNotification>;
  /** fetch data from the table: "merchant_task" */
  merchant_task: Array<MerchantTask>;
  /** fetch aggregated fields from the table: "merchant_task" */
  merchant_task_aggregate: MerchantTaskAggregate;
  /** fetch data from the table: "merchant_task" using primary key columns */
  merchant_task_by_pk?: Maybe<MerchantTask>;
  /** fetch data from the table: "merchant_task_status" */
  merchant_task_status: Array<MerchantTaskStatus>;
  /** fetch aggregated fields from the table: "merchant_task_status" */
  merchant_task_status_aggregate: MerchantTaskStatusAggregate;
  /** fetch data from the table: "merchant_task_status" using primary key columns */
  merchant_task_status_by_pk?: Maybe<MerchantTaskStatus>;
  /** fetch data from the table: "merchant_task_type" */
  merchant_task_type: Array<MerchantTaskType>;
  /** fetch aggregated fields from the table: "merchant_task_type" */
  merchant_task_type_aggregate: MerchantTaskTypeAggregate;
  /** fetch data from the table: "merchant_task_type" using primary key columns */
  merchant_task_type_by_pk?: Maybe<MerchantTaskType>;
  /** fetch data from the table: "merchant_type" */
  merchant_type: Array<MerchantType>;
  /** fetch aggregated fields from the table: "merchant_type" */
  merchant_type_aggregate: MerchantTypeAggregate;
  /** fetch data from the table: "merchant_type" using primary key columns */
  merchant_type_by_pk?: Maybe<MerchantType>;
  /** fetch data from the table: "merchant_user" */
  merchant_user: Array<MerchantUser>;
  /** fetch aggregated fields from the table: "merchant_user" */
  merchant_user_aggregate: MerchantUserAggregate;
  /** fetch data from the table: "merchant_user" using primary key columns */
  merchant_user_by_pk?: Maybe<MerchantUser>;
  /** fetch data from the table: "merchant_user_role" */
  merchant_user_role: Array<MerchantUserRole>;
  /** fetch aggregated fields from the table: "merchant_user_role" */
  merchant_user_role_aggregate: MerchantUserRoleAggregate;
  /** fetch data from the table: "merchant_user_role" using primary key columns */
  merchant_user_role_by_pk?: Maybe<MerchantUserRole>;
  /** fetch data from the table: "merchant_widget" */
  merchant_widget: Array<MerchantWidget>;
  /** fetch aggregated fields from the table: "merchant_widget" */
  merchant_widget_aggregate: MerchantWidgetAggregate;
  /** fetch data from the table: "merchant_widget" using primary key columns */
  merchant_widget_by_pk?: Maybe<MerchantWidget>;
  mpcvipInternalBalances?: Maybe<Array<Maybe<MpcvipInternalBalancesOutput>>>;
  /** fetch data from the table: "mutex" */
  mutex: Array<Mutex>;
  /** fetch aggregated fields from the table: "mutex" */
  mutex_aggregate: MutexAggregate;
  /** fetch data from the table: "mutex" using primary key columns */
  mutex_by_pk?: Maybe<Mutex>;
  mvP2PInfo?: Maybe<MvP2PInfoOutput>;
  mxH2HInvoiceOrderInfo: Scalars['json'];
  mxRequestApm: Scalars['json'];
  /** fetch data from the table: "notification_type" */
  notification_type: Array<NotificationType>;
  /** fetch aggregated fields from the table: "notification_type" */
  notification_type_aggregate: NotificationTypeAggregate;
  /** fetch data from the table: "notification_type" using primary key columns */
  notification_type_by_pk?: Maybe<NotificationType>;
  okInternalBalances: Scalars['json'];
  okoWithdrawOrderInfo: Scalars['json'];
  p2proCurrencyRateInfo: Scalars['json'];
  p2proGetSbpBankId: Scalars['json'];
  p2proWithdrawOrderInfo: Scalars['json'];
  paylamaClientFetchOrders?: Maybe<PaylamaClientFetchOrdersOutput>;
  paylamaInternalBalances?: Maybe<Array<Maybe<PaylamaInternalBalancesOutput>>>;
  paymentAppInternalBalances: Scalars['json'];
  /** fetch data from the table: "payment_system" */
  payment_system: Array<PaymentSystem>;
  /** fetch aggregated fields from the table: "payment_system" */
  payment_system_aggregate: PaymentSystemAggregate;
  /** fetch data from the table: "payment_system" using primary key columns */
  payment_system_by_pk?: Maybe<PaymentSystem>;
  /** Возвращает внутренний баланс для  payport */
  payportInternalBalances?: Maybe<PayportInternalBalancesOutput>;
  pctInvoiceOrderInfo: Scalars['json'];
  pdH2HInvoiceOrderInfo: Scalars['json'];
  pdInternalBalances: Scalars['json'];
  pdWithdrawOrderInfo: Scalars['json'];
  pfgtInternalBalances: Scalars['json'];
  pfgtInvoiceOrderInfo: Scalars['json'];
  pftblGetCheck: Scalars['json'];
  pftblInternalBalances: Scalars['json'];
  pftblWithdrawOrderInfo: Scalars['json'];
  plnmInternalBalances: Scalars['json'];
  plnmWithdrawOrderInfo: Scalars['json'];
  pncInternalBalances: Scalars['json'];
  ppP2PWithdrawInfo?: Maybe<PpP2PWithdrawInfoOutput>;
  /** fetch data from the table: "profit_provider" */
  profit_provider: Array<ProfitProvider>;
  /** fetch aggregated fields from the table: "profit_provider" */
  profit_provider_aggregate: ProfitProviderAggregate;
  /** fetch data from the table: "profit_provider" using primary key columns */
  profit_provider_by_pk?: Maybe<ProfitProvider>;
  /** fetch data from the table: "profit_withdraw" */
  profit_withdraw: Array<ProfitWithdraw>;
  /** fetch aggregated fields from the table: "profit_withdraw" */
  profit_withdraw_aggregate: ProfitWithdrawAggregate;
  /** fetch data from the table: "profit_withdraw" using primary key columns */
  profit_withdraw_by_pk?: Maybe<ProfitWithdraw>;
  /** An array relationship */
  provider: Array<Provider>;
  providerInvoiceInfo?: Maybe<ProviderInvoiceInfoOutput>;
  /** An aggregate relationship */
  provider_aggregate: ProviderAggregate;
  /** fetch data from the table: "provider" using primary key columns */
  provider_by_pk?: Maybe<Provider>;
  /** fetch data from the table: "provider_country" */
  provider_country: Array<ProviderCountry>;
  /** fetch aggregated fields from the table: "provider_country" */
  provider_country_aggregate: ProviderCountryAggregate;
  /** fetch data from the table: "provider_country" using primary key columns */
  provider_country_by_pk?: Maybe<ProviderCountry>;
  /** fetch data from the table: "provider_country_state" */
  provider_country_state: Array<ProviderCountryState>;
  /** fetch aggregated fields from the table: "provider_country_state" */
  provider_country_state_aggregate: ProviderCountryStateAggregate;
  /** fetch data from the table: "provider_country_state" using primary key columns */
  provider_country_state_by_pk?: Maybe<ProviderCountryState>;
  /** fetch data from the table: "provider_family" */
  provider_family: Array<ProviderFamily>;
  /** fetch aggregated fields from the table: "provider_family" */
  provider_family_aggregate: ProviderFamilyAggregate;
  /** fetch data from the table: "provider_family" using primary key columns */
  provider_family_by_pk?: Maybe<ProviderFamily>;
  /** fetch data from the table: "provider_family_payment_system" */
  provider_family_payment_system: Array<ProviderFamilyPaymentSystem>;
  /** fetch aggregated fields from the table: "provider_family_payment_system" */
  provider_family_payment_system_aggregate: ProviderFamilyPaymentSystemAggregate;
  /** fetch data from the table: "provider_family_payment_system" using primary key columns */
  provider_family_payment_system_by_pk?: Maybe<ProviderFamilyPaymentSystem>;
  /** fetch data from the table: "provider_fee" */
  provider_fee: Array<ProviderFee>;
  /** fetch aggregated fields from the table: "provider_fee" */
  provider_fee_aggregate: ProviderFeeAggregate;
  /** fetch data from the table: "provider_fee" using primary key columns */
  provider_fee_by_pk?: Maybe<ProviderFee>;
  /** fetch data from the table: "provider_limit" */
  provider_limit: Array<ProviderLimit>;
  /** fetch aggregated fields from the table: "provider_limit" */
  provider_limit_aggregate: ProviderLimitAggregate;
  /** fetch data from the table: "provider_limit" using primary key columns */
  provider_limit_by_pk?: Maybe<ProviderLimit>;
  /** fetch data from the table: "provider_payment_system" */
  provider_payment_system: Array<ProviderPaymentSystem>;
  /** fetch aggregated fields from the table: "provider_payment_system" */
  provider_payment_system_aggregate: ProviderPaymentSystemAggregate;
  /** fetch data from the table: "provider_payment_system" using primary key columns */
  provider_payment_system_by_pk?: Maybe<ProviderPaymentSystem>;
  /** fetch data from the table: "provider_status" */
  provider_status: Array<ProviderStatus>;
  /** fetch aggregated fields from the table: "provider_status" */
  provider_status_aggregate: ProviderStatusAggregate;
  /** fetch data from the table: "provider_status" using primary key columns */
  provider_status_by_pk?: Maybe<ProviderStatus>;
  pwH2HInvoiceInfo: Scalars['json'];
  pwH2HInvoiceOrderInfo: Scalars['json'];
  reconciliationInvoiceConflicts: Scalars['json'];
  reconciliationWithdrawConflicts: Scalars['json'];
  /** fetch data from the table: "refund_request_status" */
  refund_request_status: Array<RefundRequestStatus>;
  /** fetch aggregated fields from the table: "refund_request_status" */
  refund_request_status_aggregate: RefundRequestStatusAggregate;
  /** fetch data from the table: "refund_request_status" using primary key columns */
  refund_request_status_by_pk?: Maybe<RefundRequestStatus>;
  /** fetch data from the table: "refund_table" */
  refund_table: Array<RefundTable>;
  /** fetch aggregated fields from the table: "refund_table" */
  refund_table_aggregate: RefundTableAggregate;
  /** fetch data from the table: "refund_table" using primary key columns */
  refund_table_by_pk?: Maybe<RefundTable>;
  /** refundsFilter */
  refundsFilter?: Maybe<Array<Maybe<RefundsFilterOutput>>>;
  /** fetch data from the table: "registration_info" */
  registration_info: Array<RegistrationInfo>;
  /** fetch aggregated fields from the table: "registration_info" */
  registration_info_aggregate: RegistrationInfoAggregate;
  /** fetch data from the table: "registration_info" using primary key columns */
  registration_info_by_pk?: Maybe<RegistrationInfo>;
  /** fetch data from the table: "registration_status" */
  registration_status: Array<RegistrationStatus>;
  /** fetch aggregated fields from the table: "registration_status" */
  registration_status_aggregate: RegistrationStatusAggregate;
  /** fetch data from the table: "registration_status" using primary key columns */
  registration_status_by_pk?: Maybe<RegistrationStatus>;
  reportsChargebackDetails?: Maybe<ReportsChargebackDetailsOutput>;
  /** Метод возвращает данные в LK на страницу all-reports (Таблица Charges Details) */
  reportsChargesDetails?: Maybe<ReportsChargesDetailsOutput>;
  /** Метод возвращает данные в LK на страницу all-reports (Таблица Table(самая верхняя с общей информацией)) */
  reportsGeneralInfo?: Maybe<ReportsGeneralInfoOutput>;
  /** Метод возвращает данные в LK на страницу all-reports (Таблица Generated reserve details) */
  reportsGeneratedReserveDetails?: Maybe<ReportsGeneratedReserveDetailsOutput>;
  reportsRefundDetails?: Maybe<ReportsRefundDetailsOutput>;
  /** Метод возвращает данные в LK на страницу all-reports (Таблица Refunded reserve details) */
  reportsRefundedReserveDetails?: Maybe<ReportsRefundedReserveDetailsOutput>;
  /** Метод возвращает данные в LK на страницу all-reports (Таблица Summary) */
  reportsSummary?: Maybe<ReportsSummaryOutput>;
  /** Метод возвращает данные в LK на страницу all-reports (Таблица Total) */
  reportsTotal?: Maybe<ReportsTotalOutput>;
  reportsTransactionDetails?: Maybe<ReportsTransactionDetailsOutput>;
  /** fetch data from the table: "role" */
  role: Array<Role>;
  /** fetch aggregated fields from the table: "role" */
  role_aggregate: RoleAggregate;
  /** fetch data from the table: "role" using primary key columns */
  role_by_pk?: Maybe<Role>;
  /** fetch data from the table: "rolling_reserve" */
  rolling_reserve: Array<RollingReserve>;
  /** fetch aggregated fields from the table: "rolling_reserve" */
  rolling_reserve_aggregate: RollingReserveAggregate;
  /** fetch data from the table: "rolling_reserve" using primary key columns */
  rolling_reserve_by_pk?: Maybe<RollingReserve>;
  rqInternalBalances?: Maybe<Array<RqInternalBalancesOutput>>;
  rqInvoiceRequest?: Maybe<RqInvoiceRequestOutput>;
  /** fetch data from the table: "setting" */
  setting: Array<Setting>;
  /** fetch aggregated fields from the table: "setting" */
  setting_aggregate: SettingAggregate;
  /** fetch data from the table: "setting" using primary key columns */
  setting_by_pk?: Maybe<Setting>;
  /** fetch data from the table: "settlement" */
  settlement: Array<Settlement>;
  /** fetch aggregated fields from the table: "settlement" */
  settlement_aggregate: SettlementAggregate;
  /** fetch data from the table: "settlement" using primary key columns */
  settlement_by_pk?: Maybe<Settlement>;
  /** fetch data from the table: "traffic_type" */
  traffic_type: Array<TrafficType>;
  /** fetch aggregated fields from the table: "traffic_type" */
  traffic_type_aggregate: TrafficTypeAggregate;
  /** fetch data from the table: "traffic_type" using primary key columns */
  traffic_type_by_pk?: Maybe<TrafficType>;
  /** fetch data from the table: "transaction_history" */
  transaction_history: Array<TransactionHistory>;
  /** fetch aggregated fields from the table: "transaction_history" */
  transaction_history_aggregate: TransactionHistoryAggregate;
  /** fetch data from the table: "transaction_history" using primary key columns */
  transaction_history_by_pk?: Maybe<TransactionHistory>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch data from the table: "user_activate_token" */
  user_activate_token: Array<UserActivateToken>;
  /** fetch aggregated fields from the table: "user_activate_token" */
  user_activate_token_aggregate: UserActivateTokenAggregate;
  /** fetch data from the table: "user_activate_token" using primary key columns */
  user_activate_token_by_pk?: Maybe<UserActivateToken>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: UserAggregate;
  /** fetch data from the table: "user_audit" */
  user_audit: Array<UserAudit>;
  /** fetch aggregated fields from the table: "user_audit" */
  user_audit_aggregate: UserAuditAggregate;
  /** fetch data from the table: "user_audit" using primary key columns */
  user_audit_by_pk?: Maybe<UserAudit>;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table: "user_info" */
  user_info: Array<UserInfo>;
  /** fetch aggregated fields from the table: "user_info" */
  user_info_aggregate: UserInfoAggregate;
  /** fetch data from the table: "user_info" using primary key columns */
  user_info_by_pk?: Maybe<UserInfo>;
  /** fetch data from the table: "user_reports" */
  user_reports: Array<UserReports>;
  /** fetch aggregated fields from the table: "user_reports" */
  user_reports_aggregate: UserReportsAggregate;
  /** fetch data from the table: "user_reports" using primary key columns */
  user_reports_by_pk?: Maybe<UserReports>;
  /** fetch data from the table: "v_active_gate" */
  v_active_gate: Array<VActiveGate>;
  /** fetch aggregated fields from the table: "v_active_gate" */
  v_active_gate_aggregate: VActiveGateAggregate;
  /** fetch data from the table: "v_active_provider" */
  v_active_provider: Array<VActiveProvider>;
  /** fetch aggregated fields from the table: "v_active_provider" */
  v_active_provider_aggregate: VActiveProviderAggregate;
  /** fetch data from the table: "v_active_rolling_reserve" */
  v_active_rolling_reserve: Array<VActiveRollingReserve>;
  /** fetch aggregated fields from the table: "v_active_rolling_reserve" */
  v_active_rolling_reserve_aggregate: VActiveRollingReserveAggregate;
  /** fetch data from the table: "v_admin_chargeback" */
  v_admin_chargeback: Array<VAdminChargeback>;
  /** fetch aggregated fields from the table: "v_admin_chargeback" */
  v_admin_chargeback_aggregate: VAdminChargebackAggregate;
  /** fetch data from the table: "v_admin_gate_list" */
  v_admin_gate_list: Array<VAdminGateList>;
  /** fetch aggregated fields from the table: "v_admin_gate_list" */
  v_admin_gate_list_aggregate: VAdminGateListAggregate;
  /** fetch data from the table: "v_admin_merchant_list" */
  v_admin_merchant_list: Array<VAdminMerchantList>;
  /** fetch aggregated fields from the table: "v_admin_merchant_list" */
  v_admin_merchant_list_aggregate: VAdminMerchantListAggregate;
  /** fetch data from the table: "v_admin_monitoring" */
  v_admin_monitoring: Array<VAdminMonitoring>;
  /** fetch aggregated fields from the table: "v_admin_monitoring" */
  v_admin_monitoring_aggregate: VAdminMonitoringAggregate;
  /** fetch data from the table: "v_admin_payment_system_provider" */
  v_admin_payment_system_provider: Array<VAdminPaymentSystemProvider>;
  /** fetch aggregated fields from the table: "v_admin_payment_system_provider" */
  v_admin_payment_system_provider_aggregate: VAdminPaymentSystemProviderAggregate;
  /** fetch data from the table: "v_admin_refund" */
  v_admin_refund: Array<VAdminRefund>;
  /** fetch aggregated fields from the table: "v_admin_refund" */
  v_admin_refund_aggregate: VAdminRefundAggregate;
  /** fetch data from the table: "v_admin_withdraw_request" */
  v_admin_withdraw_request: Array<VAdminWithdrawRequest>;
  /** fetch aggregated fields from the table: "v_admin_withdraw_request" */
  v_admin_withdraw_request_aggregate: VAdminWithdrawRequestAggregate;
  /** fetch data from the table: "v_gate_group_balance" */
  v_gate_group_balance: Array<VGateGroupBalance>;
  /** fetch aggregated fields from the table: "v_gate_group_balance" */
  v_gate_group_balance_aggregate: VGateGroupBalanceAggregate;
  /** fetch data from the table: "v_hasura_permission" */
  v_hasura_permission: Array<VHasuraPermission>;
  /** fetch aggregated fields from the table: "v_hasura_permission" */
  v_hasura_permission_aggregate: VHasuraPermissionAggregate;
  /** fetch data from the table: "v_lk_chargeback" */
  v_lk_chargeback: Array<VLkChargeback>;
  /** fetch aggregated fields from the table: "v_lk_chargeback" */
  v_lk_chargeback_aggregate: VLkChargebackAggregate;
  /** fetch data from the table: "v_lk_gate_fee" */
  v_lk_gate_fee: Array<VLkGateFee>;
  /** fetch aggregated fields from the table: "v_lk_gate_fee" */
  v_lk_gate_fee_aggregate: VLkGateFeeAggregate;
  /** fetch data from the table: "widget_type" */
  widget_type: Array<WidgetType>;
  /** fetch aggregated fields from the table: "widget_type" */
  widget_type_aggregate: WidgetTypeAggregate;
  /** fetch data from the table: "widget_type" using primary key columns */
  widget_type_by_pk?: Maybe<WidgetType>;
  /** fetch data from the table: "withdraw" */
  withdraw: Array<Withdraw>;
  /** fetch aggregated fields from the table: "withdraw" */
  withdraw_aggregate: WithdrawAggregate;
  /** fetch data from the table: "withdraw" using primary key columns */
  withdraw_by_pk?: Maybe<Withdraw>;
  /** fetch data from the table: "withdraw_request" */
  withdraw_request: Array<WithdrawRequest>;
  /** fetch aggregated fields from the table: "withdraw_request" */
  withdraw_request_aggregate: WithdrawRequestAggregate;
  /** fetch data from the table: "withdraw_request" using primary key columns */
  withdraw_request_by_pk?: Maybe<WithdrawRequest>;
  /** fetch data from the table: "withdraw_request_status" */
  withdraw_request_status: Array<WithdrawRequestStatus>;
  /** fetch aggregated fields from the table: "withdraw_request_status" */
  withdraw_request_status_aggregate: WithdrawRequestStatusAggregate;
  /** fetch data from the table: "withdraw_request_status" using primary key columns */
  withdraw_request_status_by_pk?: Maybe<WithdrawRequestStatus>;
  wwAgsInvoiceOrderInfo: Scalars['json'];
  wzrdH2HInvoiceOrderInfo: Scalars['json'];
  wzrdInternalBalances: Scalars['json'];
  xpListWidgets: Scalars['json'];
  xpayInternalBalances?: Maybe<Array<XpayInternalBalancesOutput>>;
  xpayInvoiceOrderInfo: Scalars['json'];
};


export type QueryRootAmpV2RequestApmArgs = {
  transaction_uid: Scalars['String'];
};


export type QueryRootAmpv2InvoiceInfoArgs = {
  transaction_uid: Scalars['String'];
};


export type QueryRootAnH2HInvoiceOrderInfoArgs = {
  order_id: Scalars['String'];
};


export type QueryRootAnH2HWithdrawOrderInfoArgs = {
  order_id: Scalars['String'];
};


export type QueryRootAnP2PRequestArgs = {
  transaction_uid: Scalars['String'];
};


export type QueryRootAnalyticsConsolidatedReportArgs = {
  currency_id: Scalars['String'];
  date_column: Scalars['String'];
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  exclude_manual?: InputMaybe<Scalars['Boolean']>;
  gate_group_id?: InputMaybe<Scalars['String']>;
  gate_id?: InputMaybe<Scalars['String']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  provider_id?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAnalyticsConsolidatedReportGeneralArgs = {
  currency_id?: InputMaybe<Scalars['String']>;
  date_column: Scalars['String'];
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  exclude_manual?: InputMaybe<Scalars['Boolean']>;
  gate_group_id?: InputMaybe<Scalars['String']>;
  gate_id?: InputMaybe<Scalars['String']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  provider_family_id?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAnalyticsProviderFamilyBalancesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AnalyticsProviderFamilyBalancesWhereInput>;
};


export type QueryRootAnalyticsWidgetGeneralInfoArgs = {
  currency_id: Scalars['String'];
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  exclude_manual?: InputMaybe<Scalars['Boolean']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_type_id?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAnalyticsWidgetPaymentAnalyticsArgs = {
  currency_id: Scalars['String'];
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  exclude_manual?: InputMaybe<Scalars['Boolean']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_type_id?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAnalytycsProviderBalancesArgs = {
  merchant_type_id?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryRootAnpInvoiceOrderInfoArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
  transaction_uid: Scalars['String'];
};


export type QueryRootAnyPaySyncActiveTransactionArgs = {
  reference: Scalars['String'];
};


export type QueryRootApH2HInvoiceOrderInfoArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
  transaction_id: Scalars['String'];
};


export type QueryRootAuditArgs = {
  distinct_on?: InputMaybe<Array<AuditSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuditOrderBy>>;
  where?: InputMaybe<AuditBoolExp>;
};


export type QueryRootAuditAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuditSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuditOrderBy>>;
  where?: InputMaybe<AuditBoolExp>;
};


export type QueryRootAuditByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootBlacklistArgs = {
  distinct_on?: InputMaybe<Array<BlacklistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BlacklistOrderBy>>;
  where?: InputMaybe<BlacklistBoolExp>;
};


export type QueryRootBlacklistAggregateArgs = {
  distinct_on?: InputMaybe<Array<BlacklistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BlacklistOrderBy>>;
  where?: InputMaybe<BlacklistBoolExp>;
};


export type QueryRootBlacklistByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootBvInternalBalancesArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
};


export type QueryRootBzTechInvoiceOrderInfoArgs = {
  token: Scalars['String'];
};


export type QueryRootCardSystemArgs = {
  distinct_on?: InputMaybe<Array<CardSystemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CardSystemOrderBy>>;
  where?: InputMaybe<CardSystemBoolExp>;
};


export type QueryRootCardSystemAggregateArgs = {
  distinct_on?: InputMaybe<Array<CardSystemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CardSystemOrderBy>>;
  where?: InputMaybe<CardSystemBoolExp>;
};


export type QueryRootCardSystemByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootCascadeItemArgs = {
  distinct_on?: InputMaybe<Array<CascadeItemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CascadeItemOrderBy>>;
  where?: InputMaybe<CascadeItemBoolExp>;
};


export type QueryRootCascadeItemAggregateArgs = {
  distinct_on?: InputMaybe<Array<CascadeItemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CascadeItemOrderBy>>;
  where?: InputMaybe<CascadeItemBoolExp>;
};


export type QueryRootCascadeItemByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootCascadeRequestArgs = {
  distinct_on?: InputMaybe<Array<CascadeRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CascadeRequestOrderBy>>;
  where?: InputMaybe<CascadeRequestBoolExp>;
};


export type QueryRootCascadeRequestAggregateArgs = {
  distinct_on?: InputMaybe<Array<CascadeRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CascadeRequestOrderBy>>;
  where?: InputMaybe<CascadeRequestBoolExp>;
};


export type QueryRootCascadeRequestByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootCascadesArgs = {
  distinct_on?: InputMaybe<Array<CascadesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CascadesOrderBy>>;
  where?: InputMaybe<CascadesBoolExp>;
};


export type QueryRootCascadesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CascadesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CascadesOrderBy>>;
  where?: InputMaybe<CascadesBoolExp>;
};


export type QueryRootCascadesByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootChsInvoiceOrderInfoArgs = {
  currency_id: Scalars['String'];
  payment_id: Scalars['String'];
  provider_id: Scalars['String'];
};


export type QueryRootCountryArgs = {
  distinct_on?: InputMaybe<Array<CountrySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CountryOrderBy>>;
  where?: InputMaybe<CountryBoolExp>;
};


export type QueryRootCountryAggregateArgs = {
  distinct_on?: InputMaybe<Array<CountrySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CountryOrderBy>>;
  where?: InputMaybe<CountryBoolExp>;
};


export type QueryRootCountryByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootCountryRegionArgs = {
  distinct_on?: InputMaybe<Array<CountryRegionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CountryRegionOrderBy>>;
  where?: InputMaybe<CountryRegionBoolExp>;
};


export type QueryRootCountryRegionAggregateArgs = {
  distinct_on?: InputMaybe<Array<CountryRegionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CountryRegionOrderBy>>;
  where?: InputMaybe<CountryRegionBoolExp>;
};


export type QueryRootCountryRegionByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootCryptoCurrencyArgs = {
  distinct_on?: InputMaybe<Array<CryptoCurrencySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CryptoCurrencyOrderBy>>;
  where?: InputMaybe<CryptoCurrencyBoolExp>;
};


export type QueryRootCryptoCurrencyAggregateArgs = {
  distinct_on?: InputMaybe<Array<CryptoCurrencySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CryptoCurrencyOrderBy>>;
  where?: InputMaybe<CryptoCurrencyBoolExp>;
};


export type QueryRootCryptoCurrencyByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootCryptoWithdrawRequestArgs = {
  distinct_on?: InputMaybe<Array<CryptoWithdrawRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CryptoWithdrawRequestOrderBy>>;
  where?: InputMaybe<CryptoWithdrawRequestBoolExp>;
};


export type QueryRootCryptoWithdrawRequestAggregateArgs = {
  distinct_on?: InputMaybe<Array<CryptoWithdrawRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CryptoWithdrawRequestOrderBy>>;
  where?: InputMaybe<CryptoWithdrawRequestBoolExp>;
};


export type QueryRootCryptoWithdrawRequestByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootCryptoWithdrawRequestStatusArgs = {
  distinct_on?: InputMaybe<Array<CryptoWithdrawRequestStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CryptoWithdrawRequestStatusOrderBy>>;
  where?: InputMaybe<CryptoWithdrawRequestStatusBoolExp>;
};


export type QueryRootCryptoWithdrawRequestStatusAggregateArgs = {
  distinct_on?: InputMaybe<Array<CryptoWithdrawRequestStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CryptoWithdrawRequestStatusOrderBy>>;
  where?: InputMaybe<CryptoWithdrawRequestStatusBoolExp>;
};


export type QueryRootCryptoWithdrawRequestStatusByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootCurrencyArgs = {
  distinct_on?: InputMaybe<Array<CurrencySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CurrencyOrderBy>>;
  where?: InputMaybe<CurrencyBoolExp>;
};


export type QueryRootCurrencyAggregateArgs = {
  distinct_on?: InputMaybe<Array<CurrencySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CurrencyOrderBy>>;
  where?: InputMaybe<CurrencyBoolExp>;
};


export type QueryRootCurrencyByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootDashboardBalanceByCurrencyIdArgs = {
  currency_id: Scalars['String'];
};


export type QueryRootDashboardConvertationBalanceArgs = {
  convertation_currency_id: Scalars['String'];
};


export type QueryRootDashboardConvertationBalanceProvidersArgs = {
  convertation_currency_id: Scalars['String'];
};


export type QueryRootDashboardConvertationConversionArgs = {
  dateEnd: Scalars['date'];
  dateStart: Scalars['date'];
};


export type QueryRootDashboardConvertationProfitArgs = {
  convertation_currency_id: Scalars['String'];
  dateEnd: Scalars['date'];
  dateStart: Scalars['date'];
};


export type QueryRootDashboardConvertationProfitByPeriodArgs = {
  convertation_currency_id: Scalars['String'];
};


export type QueryRootDashboardConvertationTurnoverArgs = {
  convertation_currency_id: Scalars['String'];
};


export type QueryRootDashboardCurrencyWindowWidgetsArgs = {
  currency_id: Scalars['String'];
  days: Scalars['Int'];
};


export type QueryRootDashboardMerchantFeeArgs = {
  amount: Scalars['numeric'];
  currency_id: Scalars['String'];
};


export type QueryRootDashboardSucceedInvoiceCountArgs = {
  currency_id?: InputMaybe<Scalars['String']>;
};


export type QueryRootDashboardWalletArgs = {
  currency_id?: InputMaybe<Scalars['String']>;
};


export type QueryRootDashboardWidgetsCreatingPaymentArgs = {
  currency_id?: InputMaybe<Scalars['String']>;
  dateEnd?: InputMaybe<Scalars['date']>;
  dateStart: Scalars['date'];
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_type_id?: InputMaybe<Scalars['String']>;
  provider_family_id?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
};


export type QueryRootDashboardWidgetsInvoiceChartArgs = {
  currency_id?: InputMaybe<Scalars['String']>;
  dateEnd?: InputMaybe<Scalars['date']>;
  dateStart: Scalars['date'];
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_type_id?: InputMaybe<Scalars['String']>;
  provider_family_id?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
};


export type QueryRootDashboardWidgetsPaymentMethodsArgs = {
  dateEnd?: InputMaybe<Scalars['date']>;
  dateStart: Scalars['date'];
  merchant_type_id?: InputMaybe<Scalars['String']>;
};


export type QueryRootDashboardWidgetsRevenueChartArgs = {
  currency_id?: InputMaybe<Scalars['String']>;
};


export type QueryRootDashboardWidgetsSalesChartArgs = {
  currency_id?: InputMaybe<Scalars['String']>;
};


export type QueryRootDashboardWidgetsSalesPerCurrencyChartArgs = {
  currency_id: Scalars['String'];
  dateStart: Scalars['date'];
};


export type QueryRootDashboardWidgetsStatusChartArgs = {
  currency_id: Scalars['String'];
  dateStart: Scalars['date'];
};


export type QueryRootDashboardWidgetsWithdrawlChartArgs = {
  currency_id?: InputMaybe<Scalars['String']>;
  dateEnd?: InputMaybe<Scalars['date']>;
  dateStart: Scalars['date'];
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_type_id?: InputMaybe<Scalars['String']>;
  provider_family_id?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
};


export type QueryRootFeeMerchantFeeArgs = {
  amount: Scalars['numeric'];
  currency_id: Scalars['String'];
  gate_id?: InputMaybe<Scalars['String']>;
  gate_type_id: Scalars['String'];
  payment_system?: InputMaybe<Scalars['String']>;
};


export type QueryRootGateArgs = {
  distinct_on?: InputMaybe<Array<GateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GateOrderBy>>;
  where?: InputMaybe<GateBoolExp>;
};


export type QueryRootGateAnalyticsBalanceHistoryArgs = {
  gate_group_id: Scalars['String'];
};


export type QueryRootGateAnalyticsConversionArgs = {
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  gate_group_id: Scalars['String'];
};


export type QueryRootGateAnalyticsLimitsArgs = {
  gate_group_id: Scalars['String'];
};


export type QueryRootGateFindActiveGateGroupAndCurrenciesArgs = {
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  exclude_manual?: InputMaybe<Scalars['Boolean']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
};


export type QueryRootGateAggregateArgs = {
  distinct_on?: InputMaybe<Array<GateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GateOrderBy>>;
  where?: InputMaybe<GateBoolExp>;
};


export type QueryRootGateByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootGateGroupArgs = {
  distinct_on?: InputMaybe<Array<GateGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GateGroupOrderBy>>;
  where?: InputMaybe<GateGroupBoolExp>;
};


export type QueryRootGateGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<GateGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GateGroupOrderBy>>;
  where?: InputMaybe<GateGroupBoolExp>;
};


export type QueryRootGateGroupByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootGateTypeArgs = {
  distinct_on?: InputMaybe<Array<GateTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GateTypeOrderBy>>;
  where?: InputMaybe<GateTypeBoolExp>;
};


export type QueryRootGateTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<GateTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GateTypeOrderBy>>;
  where?: InputMaybe<GateTypeBoolExp>;
};


export type QueryRootGateTypeByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootGenderArgs = {
  distinct_on?: InputMaybe<Array<GenderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GenderOrderBy>>;
  where?: InputMaybe<GenderBoolExp>;
};


export type QueryRootGenderAggregateArgs = {
  distinct_on?: InputMaybe<Array<GenderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GenderOrderBy>>;
  where?: InputMaybe<GenderBoolExp>;
};


export type QueryRootGenderByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootHelpArgs = {
  distinct_on?: InputMaybe<Array<HelpSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<HelpOrderBy>>;
  where?: InputMaybe<HelpBoolExp>;
};


export type QueryRootHelpAggregateArgs = {
  distinct_on?: InputMaybe<Array<HelpSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<HelpOrderBy>>;
  where?: InputMaybe<HelpBoolExp>;
};


export type QueryRootHelpByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootHelpSectionArgs = {
  distinct_on?: InputMaybe<Array<HelpSectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<HelpSectionOrderBy>>;
  where?: InputMaybe<HelpSectionBoolExp>;
};


export type QueryRootHelpSectionAggregateArgs = {
  distinct_on?: InputMaybe<Array<HelpSectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<HelpSectionOrderBy>>;
  where?: InputMaybe<HelpSectionBoolExp>;
};


export type QueryRootHelpSectionByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootHrzInvoiceOrderInfoArgs = {
  currency_id: Scalars['String'];
  order_id: Scalars['String'];
  provider_id: Scalars['String'];
};


export type QueryRootHrzWithdrawOrderInfoArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
  withdraw_id: Scalars['String'];
};


export type QueryRootInvoiceArgs = {
  distinct_on?: InputMaybe<Array<InvoiceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InvoiceOrderBy>>;
  where?: InputMaybe<InvoiceBoolExp>;
};


export type QueryRootInvoiceAggregateArgs = {
  distinct_on?: InputMaybe<Array<InvoiceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InvoiceOrderBy>>;
  where?: InputMaybe<InvoiceBoolExp>;
};


export type QueryRootInvoiceByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootKhmpInternalBalancesArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
};


export type QueryRootLanguageArgs = {
  distinct_on?: InputMaybe<Array<LanguageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LanguageOrderBy>>;
  where?: InputMaybe<LanguageBoolExp>;
};


export type QueryRootLanguageAggregateArgs = {
  distinct_on?: InputMaybe<Array<LanguageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LanguageOrderBy>>;
  where?: InputMaybe<LanguageBoolExp>;
};


export type QueryRootLanguageByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootMerchantArgs = {
  distinct_on?: InputMaybe<Array<MerchantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantOrderBy>>;
  where?: InputMaybe<MerchantBoolExp>;
};


export type QueryRootMerchantAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantOrderBy>>;
  where?: InputMaybe<MerchantBoolExp>;
};


export type QueryRootMerchantApiTokenArgs = {
  distinct_on?: InputMaybe<Array<MerchantApiTokenSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantApiTokenOrderBy>>;
  where?: InputMaybe<MerchantApiTokenBoolExp>;
};


export type QueryRootMerchantApiTokenAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantApiTokenSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantApiTokenOrderBy>>;
  where?: InputMaybe<MerchantApiTokenBoolExp>;
};


export type QueryRootMerchantApiTokenByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootMerchantBalanceArgs = {
  distinct_on?: InputMaybe<Array<MerchantBalanceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantBalanceOrderBy>>;
  where?: InputMaybe<MerchantBalanceBoolExp>;
};


export type QueryRootMerchantBalanceAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantBalanceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantBalanceOrderBy>>;
  where?: InputMaybe<MerchantBalanceBoolExp>;
};


export type QueryRootMerchantBalanceByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootMerchantByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootMerchantCurrencyArgs = {
  distinct_on?: InputMaybe<Array<MerchantCurrencySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantCurrencyOrderBy>>;
  where?: InputMaybe<MerchantCurrencyBoolExp>;
};


export type QueryRootMerchantCurrencyAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantCurrencySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantCurrencyOrderBy>>;
  where?: InputMaybe<MerchantCurrencyBoolExp>;
};


export type QueryRootMerchantCurrencyByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootMerchantFeeArgs = {
  distinct_on?: InputMaybe<Array<MerchantFeeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantFeeOrderBy>>;
  where?: InputMaybe<MerchantFeeBoolExp>;
};


export type QueryRootMerchantFeeAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantFeeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantFeeOrderBy>>;
  where?: InputMaybe<MerchantFeeBoolExp>;
};


export type QueryRootMerchantFeeByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootMerchantFileArgs = {
  distinct_on?: InputMaybe<Array<MerchantFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantFileOrderBy>>;
  where?: InputMaybe<MerchantFileBoolExp>;
};


export type QueryRootMerchantFileAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantFileOrderBy>>;
  where?: InputMaybe<MerchantFileBoolExp>;
};


export type QueryRootMerchantFileByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootMerchantInfoArgs = {
  distinct_on?: InputMaybe<Array<MerchantInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantInfoOrderBy>>;
  where?: InputMaybe<MerchantInfoBoolExp>;
};


export type QueryRootMerchantInfoAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantInfoOrderBy>>;
  where?: InputMaybe<MerchantInfoBoolExp>;
};


export type QueryRootMerchantInfoByPkArgs = {
  merchant_id: Scalars['Int'];
};


export type QueryRootMerchantNotificationArgs = {
  distinct_on?: InputMaybe<Array<MerchantNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantNotificationOrderBy>>;
  where?: InputMaybe<MerchantNotificationBoolExp>;
};


export type QueryRootMerchantNotificationAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantNotificationOrderBy>>;
  where?: InputMaybe<MerchantNotificationBoolExp>;
};


export type QueryRootMerchantNotificationByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootMerchantTaskArgs = {
  distinct_on?: InputMaybe<Array<MerchantTaskSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantTaskOrderBy>>;
  where?: InputMaybe<MerchantTaskBoolExp>;
};


export type QueryRootMerchantTaskAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantTaskSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantTaskOrderBy>>;
  where?: InputMaybe<MerchantTaskBoolExp>;
};


export type QueryRootMerchantTaskByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootMerchantTaskStatusArgs = {
  distinct_on?: InputMaybe<Array<MerchantTaskStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantTaskStatusOrderBy>>;
  where?: InputMaybe<MerchantTaskStatusBoolExp>;
};


export type QueryRootMerchantTaskStatusAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantTaskStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantTaskStatusOrderBy>>;
  where?: InputMaybe<MerchantTaskStatusBoolExp>;
};


export type QueryRootMerchantTaskStatusByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootMerchantTaskTypeArgs = {
  distinct_on?: InputMaybe<Array<MerchantTaskTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantTaskTypeOrderBy>>;
  where?: InputMaybe<MerchantTaskTypeBoolExp>;
};


export type QueryRootMerchantTaskTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantTaskTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantTaskTypeOrderBy>>;
  where?: InputMaybe<MerchantTaskTypeBoolExp>;
};


export type QueryRootMerchantTaskTypeByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootMerchantTypeArgs = {
  distinct_on?: InputMaybe<Array<MerchantTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantTypeOrderBy>>;
  where?: InputMaybe<MerchantTypeBoolExp>;
};


export type QueryRootMerchantTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantTypeOrderBy>>;
  where?: InputMaybe<MerchantTypeBoolExp>;
};


export type QueryRootMerchantTypeByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootMerchantUserArgs = {
  distinct_on?: InputMaybe<Array<MerchantUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantUserOrderBy>>;
  where?: InputMaybe<MerchantUserBoolExp>;
};


export type QueryRootMerchantUserAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantUserOrderBy>>;
  where?: InputMaybe<MerchantUserBoolExp>;
};


export type QueryRootMerchantUserByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootMerchantUserRoleArgs = {
  distinct_on?: InputMaybe<Array<MerchantUserRoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantUserRoleOrderBy>>;
  where?: InputMaybe<MerchantUserRoleBoolExp>;
};


export type QueryRootMerchantUserRoleAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantUserRoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantUserRoleOrderBy>>;
  where?: InputMaybe<MerchantUserRoleBoolExp>;
};


export type QueryRootMerchantUserRoleByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootMerchantWidgetArgs = {
  distinct_on?: InputMaybe<Array<MerchantWidgetSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantWidgetOrderBy>>;
  where?: InputMaybe<MerchantWidgetBoolExp>;
};


export type QueryRootMerchantWidgetAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantWidgetSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantWidgetOrderBy>>;
  where?: InputMaybe<MerchantWidgetBoolExp>;
};


export type QueryRootMerchantWidgetByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootMutexArgs = {
  distinct_on?: InputMaybe<Array<MutexSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MutexOrderBy>>;
  where?: InputMaybe<MutexBoolExp>;
};


export type QueryRootMutexAggregateArgs = {
  distinct_on?: InputMaybe<Array<MutexSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MutexOrderBy>>;
  where?: InputMaybe<MutexBoolExp>;
};


export type QueryRootMutexByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootMvP2PInfoArgs = {
  transaction_uid: Scalars['String'];
};


export type QueryRootMxH2HInvoiceOrderInfoArgs = {
  currency_id: Scalars['String'];
  order_id: Scalars['String'];
  provider_id: Scalars['String'];
};


export type QueryRootMxRequestApmArgs = {
  transaction_uid: Scalars['String'];
};


export type QueryRootNotificationTypeArgs = {
  distinct_on?: InputMaybe<Array<NotificationTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationTypeOrderBy>>;
  where?: InputMaybe<NotificationTypeBoolExp>;
};


export type QueryRootNotificationTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationTypeOrderBy>>;
  where?: InputMaybe<NotificationTypeBoolExp>;
};


export type QueryRootNotificationTypeByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootOkoWithdrawOrderInfoArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
  transaction_uid: Scalars['String'];
};


export type QueryRootP2proCurrencyRateInfoArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
};


export type QueryRootP2proGetSbpBankIdArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
};


export type QueryRootP2proWithdrawOrderInfoArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
  transaction_uid: Scalars['String'];
};


export type QueryRootPaylamaClientFetchOrdersArgs = {
  ID?: InputMaybe<Scalars['String']>;
  amountFrom?: InputMaybe<Scalars['Int']>;
  amountTo?: InputMaybe<Scalars['Int']>;
  createdAtTo?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  mid?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderType?: InputMaybe<Scalars['String']>;
  statusGroupID?: InputMaybe<Scalars['Int']>;
};


export type QueryRootPaymentAppInternalBalancesArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
};


export type QueryRootPaymentSystemArgs = {
  distinct_on?: InputMaybe<Array<PaymentSystemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentSystemOrderBy>>;
  where?: InputMaybe<PaymentSystemBoolExp>;
};


export type QueryRootPaymentSystemAggregateArgs = {
  distinct_on?: InputMaybe<Array<PaymentSystemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentSystemOrderBy>>;
  where?: InputMaybe<PaymentSystemBoolExp>;
};


export type QueryRootPaymentSystemByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootPctInvoiceOrderInfoArgs = {
  currency_id: Scalars['String'];
  order_id: Scalars['String'];
  provider_id: Scalars['String'];
};


export type QueryRootPdH2HInvoiceOrderInfoArgs = {
  currency_id: Scalars['String'];
  order_id: Scalars['String'];
  provider_id: Scalars['String'];
};


export type QueryRootPdInternalBalancesArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
};


export type QueryRootPdWithdrawOrderInfoArgs = {
  transaction_uid: Scalars['String'];
};


export type QueryRootPfgtInternalBalancesArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
};


export type QueryRootPfgtInvoiceOrderInfoArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
  transaction_uid: Scalars['String'];
};


export type QueryRootPftblGetCheckArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
};


export type QueryRootPftblInternalBalancesArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
};


export type QueryRootPftblWithdrawOrderInfoArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
  provider_withdraw_id: Scalars['String'];
};


export type QueryRootPlnmInternalBalancesArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
};


export type QueryRootPlnmWithdrawOrderInfoArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
  transaction_uid: Scalars['String'];
};


export type QueryRootPpP2PWithdrawInfoArgs = {
  transaction_uid: Scalars['String'];
};


export type QueryRootProfitProviderArgs = {
  distinct_on?: InputMaybe<Array<ProfitProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProfitProviderOrderBy>>;
  where?: InputMaybe<ProfitProviderBoolExp>;
};


export type QueryRootProfitProviderAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProfitProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProfitProviderOrderBy>>;
  where?: InputMaybe<ProfitProviderBoolExp>;
};


export type QueryRootProfitProviderByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootProfitWithdrawArgs = {
  distinct_on?: InputMaybe<Array<ProfitWithdrawSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProfitWithdrawOrderBy>>;
  where?: InputMaybe<ProfitWithdrawBoolExp>;
};


export type QueryRootProfitWithdrawAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProfitWithdrawSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProfitWithdrawOrderBy>>;
  where?: InputMaybe<ProfitWithdrawBoolExp>;
};


export type QueryRootProfitWithdrawByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootProviderArgs = {
  distinct_on?: InputMaybe<Array<ProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderOrderBy>>;
  where?: InputMaybe<ProviderBoolExp>;
};


export type QueryRootProviderInvoiceInfoArgs = {
  transaction_uid: Scalars['String'];
};


export type QueryRootProviderAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderOrderBy>>;
  where?: InputMaybe<ProviderBoolExp>;
};


export type QueryRootProviderByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootProviderCountryArgs = {
  distinct_on?: InputMaybe<Array<ProviderCountrySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderCountryOrderBy>>;
  where?: InputMaybe<ProviderCountryBoolExp>;
};


export type QueryRootProviderCountryAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderCountrySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderCountryOrderBy>>;
  where?: InputMaybe<ProviderCountryBoolExp>;
};


export type QueryRootProviderCountryByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootProviderCountryStateArgs = {
  distinct_on?: InputMaybe<Array<ProviderCountryStateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderCountryStateOrderBy>>;
  where?: InputMaybe<ProviderCountryStateBoolExp>;
};


export type QueryRootProviderCountryStateAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderCountryStateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderCountryStateOrderBy>>;
  where?: InputMaybe<ProviderCountryStateBoolExp>;
};


export type QueryRootProviderCountryStateByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootProviderFamilyArgs = {
  distinct_on?: InputMaybe<Array<ProviderFamilySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderFamilyOrderBy>>;
  where?: InputMaybe<ProviderFamilyBoolExp>;
};


export type QueryRootProviderFamilyAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderFamilySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderFamilyOrderBy>>;
  where?: InputMaybe<ProviderFamilyBoolExp>;
};


export type QueryRootProviderFamilyByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootProviderFamilyPaymentSystemArgs = {
  distinct_on?: InputMaybe<Array<ProviderFamilyPaymentSystemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderFamilyPaymentSystemOrderBy>>;
  where?: InputMaybe<ProviderFamilyPaymentSystemBoolExp>;
};


export type QueryRootProviderFamilyPaymentSystemAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderFamilyPaymentSystemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderFamilyPaymentSystemOrderBy>>;
  where?: InputMaybe<ProviderFamilyPaymentSystemBoolExp>;
};


export type QueryRootProviderFamilyPaymentSystemByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootProviderFeeArgs = {
  distinct_on?: InputMaybe<Array<ProviderFeeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderFeeOrderBy>>;
  where?: InputMaybe<ProviderFeeBoolExp>;
};


export type QueryRootProviderFeeAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderFeeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderFeeOrderBy>>;
  where?: InputMaybe<ProviderFeeBoolExp>;
};


export type QueryRootProviderFeeByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootProviderLimitArgs = {
  distinct_on?: InputMaybe<Array<ProviderLimitSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderLimitOrderBy>>;
  where?: InputMaybe<ProviderLimitBoolExp>;
};


export type QueryRootProviderLimitAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderLimitSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderLimitOrderBy>>;
  where?: InputMaybe<ProviderLimitBoolExp>;
};


export type QueryRootProviderLimitByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootProviderPaymentSystemArgs = {
  distinct_on?: InputMaybe<Array<ProviderPaymentSystemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderPaymentSystemOrderBy>>;
  where?: InputMaybe<ProviderPaymentSystemBoolExp>;
};


export type QueryRootProviderPaymentSystemAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderPaymentSystemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderPaymentSystemOrderBy>>;
  where?: InputMaybe<ProviderPaymentSystemBoolExp>;
};


export type QueryRootProviderPaymentSystemByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootProviderStatusArgs = {
  distinct_on?: InputMaybe<Array<ProviderStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderStatusOrderBy>>;
  where?: InputMaybe<ProviderStatusBoolExp>;
};


export type QueryRootProviderStatusAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderStatusOrderBy>>;
  where?: InputMaybe<ProviderStatusBoolExp>;
};


export type QueryRootProviderStatusByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootPwH2HInvoiceInfoArgs = {
  transaction_uid: Scalars['String'];
};


export type QueryRootPwH2HInvoiceOrderInfoArgs = {
  order_id: Scalars['String'];
};


export type QueryRootRefundRequestStatusArgs = {
  distinct_on?: InputMaybe<Array<RefundRequestStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RefundRequestStatusOrderBy>>;
  where?: InputMaybe<RefundRequestStatusBoolExp>;
};


export type QueryRootRefundRequestStatusAggregateArgs = {
  distinct_on?: InputMaybe<Array<RefundRequestStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RefundRequestStatusOrderBy>>;
  where?: InputMaybe<RefundRequestStatusBoolExp>;
};


export type QueryRootRefundRequestStatusByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootRefundTableArgs = {
  distinct_on?: InputMaybe<Array<RefundTableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RefundTableOrderBy>>;
  where?: InputMaybe<RefundTableBoolExp>;
};


export type QueryRootRefundTableAggregateArgs = {
  distinct_on?: InputMaybe<Array<RefundTableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RefundTableOrderBy>>;
  where?: InputMaybe<RefundTableBoolExp>;
};


export type QueryRootRefundTableByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootRefundsFilterArgs = {
  currency_id?: InputMaybe<Scalars['String']>;
  date_from: Scalars['String'];
  date_to: Scalars['String'];
  gate_group_id?: InputMaybe<Scalars['String']>;
  invoice_transaction_uid?: InputMaybe<Scalars['String']>;
  withdraw_transaction_uid?: InputMaybe<Scalars['String']>;
};


export type QueryRootRegistrationInfoArgs = {
  distinct_on?: InputMaybe<Array<RegistrationInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RegistrationInfoOrderBy>>;
  where?: InputMaybe<RegistrationInfoBoolExp>;
};


export type QueryRootRegistrationInfoAggregateArgs = {
  distinct_on?: InputMaybe<Array<RegistrationInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RegistrationInfoOrderBy>>;
  where?: InputMaybe<RegistrationInfoBoolExp>;
};


export type QueryRootRegistrationInfoByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootRegistrationStatusArgs = {
  distinct_on?: InputMaybe<Array<RegistrationStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RegistrationStatusOrderBy>>;
  where?: InputMaybe<RegistrationStatusBoolExp>;
};


export type QueryRootRegistrationStatusAggregateArgs = {
  distinct_on?: InputMaybe<Array<RegistrationStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RegistrationStatusOrderBy>>;
  where?: InputMaybe<RegistrationStatusBoolExp>;
};


export type QueryRootRegistrationStatusByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootReportsChargebackDetailsArgs = {
  currency_id: Scalars['String'];
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  gate_group_id?: InputMaybe<Scalars['String']>;
  gate_id?: InputMaybe<Scalars['String']>;
};


export type QueryRootReportsChargesDetailsArgs = {
  currency_id: Scalars['String'];
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  gate_group_id?: InputMaybe<Scalars['String']>;
  gate_id?: InputMaybe<Scalars['String']>;
};


export type QueryRootReportsGeneralInfoArgs = {
  currency_id: Scalars['String'];
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  gate_group_id?: InputMaybe<Scalars['String']>;
  gate_id?: InputMaybe<Scalars['String']>;
};


export type QueryRootReportsGeneratedReserveDetailsArgs = {
  currency_id: Scalars['String'];
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  gate_group_id?: InputMaybe<Scalars['String']>;
  gate_id?: InputMaybe<Scalars['String']>;
};


export type QueryRootReportsRefundDetailsArgs = {
  currency_id: Scalars['String'];
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  gate_group_id?: InputMaybe<Scalars['String']>;
  gate_id?: InputMaybe<Scalars['String']>;
};


export type QueryRootReportsRefundedReserveDetailsArgs = {
  currency_id: Scalars['String'];
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  gate_group_id?: InputMaybe<Scalars['String']>;
  gate_id?: InputMaybe<Scalars['String']>;
};


export type QueryRootReportsSummaryArgs = {
  currency_id: Scalars['String'];
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  gate_group_id?: InputMaybe<Scalars['String']>;
  gate_id?: InputMaybe<Scalars['String']>;
};


export type QueryRootReportsTotalArgs = {
  currency_id: Scalars['String'];
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  gate_group_id?: InputMaybe<Scalars['String']>;
  gate_id?: InputMaybe<Scalars['String']>;
};


export type QueryRootReportsTransactionDetailsArgs = {
  currency_id: Scalars['String'];
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  gate_group_id?: InputMaybe<Scalars['String']>;
  gate_id?: InputMaybe<Scalars['String']>;
};


export type QueryRootRoleArgs = {
  distinct_on?: InputMaybe<Array<RoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RoleOrderBy>>;
  where?: InputMaybe<RoleBoolExp>;
};


export type QueryRootRoleAggregateArgs = {
  distinct_on?: InputMaybe<Array<RoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RoleOrderBy>>;
  where?: InputMaybe<RoleBoolExp>;
};


export type QueryRootRoleByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootRollingReserveArgs = {
  distinct_on?: InputMaybe<Array<RollingReserveSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RollingReserveOrderBy>>;
  where?: InputMaybe<RollingReserveBoolExp>;
};


export type QueryRootRollingReserveAggregateArgs = {
  distinct_on?: InputMaybe<Array<RollingReserveSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RollingReserveOrderBy>>;
  where?: InputMaybe<RollingReserveBoolExp>;
};


export type QueryRootRollingReserveByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootRqInvoiceRequestArgs = {
  transaction_uid: Scalars['String'];
};


export type QueryRootSettingArgs = {
  distinct_on?: InputMaybe<Array<SettingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SettingOrderBy>>;
  where?: InputMaybe<SettingBoolExp>;
};


export type QueryRootSettingAggregateArgs = {
  distinct_on?: InputMaybe<Array<SettingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SettingOrderBy>>;
  where?: InputMaybe<SettingBoolExp>;
};


export type QueryRootSettingByPkArgs = {
  key: Scalars['String'];
};


export type QueryRootSettlementArgs = {
  distinct_on?: InputMaybe<Array<SettlementSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SettlementOrderBy>>;
  where?: InputMaybe<SettlementBoolExp>;
};


export type QueryRootSettlementAggregateArgs = {
  distinct_on?: InputMaybe<Array<SettlementSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SettlementOrderBy>>;
  where?: InputMaybe<SettlementBoolExp>;
};


export type QueryRootSettlementByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootTrafficTypeArgs = {
  distinct_on?: InputMaybe<Array<TrafficTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TrafficTypeOrderBy>>;
  where?: InputMaybe<TrafficTypeBoolExp>;
};


export type QueryRootTrafficTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<TrafficTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TrafficTypeOrderBy>>;
  where?: InputMaybe<TrafficTypeBoolExp>;
};


export type QueryRootTrafficTypeByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootTransactionHistoryArgs = {
  distinct_on?: InputMaybe<Array<TransactionHistorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TransactionHistoryOrderBy>>;
  where?: InputMaybe<TransactionHistoryBoolExp>;
};


export type QueryRootTransactionHistoryAggregateArgs = {
  distinct_on?: InputMaybe<Array<TransactionHistorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TransactionHistoryOrderBy>>;
  where?: InputMaybe<TransactionHistoryBoolExp>;
};


export type QueryRootTransactionHistoryByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootUserArgs = {
  distinct_on?: InputMaybe<Array<UserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserOrderBy>>;
  where?: InputMaybe<UserBoolExp>;
};


export type QueryRootUserActivateTokenArgs = {
  distinct_on?: InputMaybe<Array<UserActivateTokenSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserActivateTokenOrderBy>>;
  where?: InputMaybe<UserActivateTokenBoolExp>;
};


export type QueryRootUserActivateTokenAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserActivateTokenSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserActivateTokenOrderBy>>;
  where?: InputMaybe<UserActivateTokenBoolExp>;
};


export type QueryRootUserActivateTokenByPkArgs = {
  token: Scalars['String'];
};


export type QueryRootUserAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserOrderBy>>;
  where?: InputMaybe<UserBoolExp>;
};


export type QueryRootUserAuditArgs = {
  distinct_on?: InputMaybe<Array<UserAuditSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserAuditOrderBy>>;
  where?: InputMaybe<UserAuditBoolExp>;
};


export type QueryRootUserAuditAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserAuditSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserAuditOrderBy>>;
  where?: InputMaybe<UserAuditBoolExp>;
};


export type QueryRootUserAuditByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootUserByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootUserInfoArgs = {
  distinct_on?: InputMaybe<Array<UserInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserInfoOrderBy>>;
  where?: InputMaybe<UserInfoBoolExp>;
};


export type QueryRootUserInfoAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserInfoOrderBy>>;
  where?: InputMaybe<UserInfoBoolExp>;
};


export type QueryRootUserInfoByPkArgs = {
  user_id: Scalars['Int'];
};


export type QueryRootUserReportsArgs = {
  distinct_on?: InputMaybe<Array<UserReportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserReportsOrderBy>>;
  where?: InputMaybe<UserReportsBoolExp>;
};


export type QueryRootUserReportsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserReportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserReportsOrderBy>>;
  where?: InputMaybe<UserReportsBoolExp>;
};


export type QueryRootUserReportsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootVActiveGateArgs = {
  distinct_on?: InputMaybe<Array<VActiveGateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VActiveGateOrderBy>>;
  where?: InputMaybe<VActiveGateBoolExp>;
};


export type QueryRootVActiveGateAggregateArgs = {
  distinct_on?: InputMaybe<Array<VActiveGateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VActiveGateOrderBy>>;
  where?: InputMaybe<VActiveGateBoolExp>;
};


export type QueryRootVActiveProviderArgs = {
  distinct_on?: InputMaybe<Array<VActiveProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VActiveProviderOrderBy>>;
  where?: InputMaybe<VActiveProviderBoolExp>;
};


export type QueryRootVActiveProviderAggregateArgs = {
  distinct_on?: InputMaybe<Array<VActiveProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VActiveProviderOrderBy>>;
  where?: InputMaybe<VActiveProviderBoolExp>;
};


export type QueryRootVActiveRollingReserveArgs = {
  distinct_on?: InputMaybe<Array<VActiveRollingReserveSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VActiveRollingReserveOrderBy>>;
  where?: InputMaybe<VActiveRollingReserveBoolExp>;
};


export type QueryRootVActiveRollingReserveAggregateArgs = {
  distinct_on?: InputMaybe<Array<VActiveRollingReserveSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VActiveRollingReserveOrderBy>>;
  where?: InputMaybe<VActiveRollingReserveBoolExp>;
};


export type QueryRootVAdminChargebackArgs = {
  distinct_on?: InputMaybe<Array<VAdminChargebackSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminChargebackOrderBy>>;
  where?: InputMaybe<VAdminChargebackBoolExp>;
};


export type QueryRootVAdminChargebackAggregateArgs = {
  distinct_on?: InputMaybe<Array<VAdminChargebackSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminChargebackOrderBy>>;
  where?: InputMaybe<VAdminChargebackBoolExp>;
};


export type QueryRootVAdminGateListArgs = {
  distinct_on?: InputMaybe<Array<VAdminGateListSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminGateListOrderBy>>;
  where?: InputMaybe<VAdminGateListBoolExp>;
};


export type QueryRootVAdminGateListAggregateArgs = {
  distinct_on?: InputMaybe<Array<VAdminGateListSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminGateListOrderBy>>;
  where?: InputMaybe<VAdminGateListBoolExp>;
};


export type QueryRootVAdminMerchantListArgs = {
  distinct_on?: InputMaybe<Array<VAdminMerchantListSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminMerchantListOrderBy>>;
  where?: InputMaybe<VAdminMerchantListBoolExp>;
};


export type QueryRootVAdminMerchantListAggregateArgs = {
  distinct_on?: InputMaybe<Array<VAdminMerchantListSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminMerchantListOrderBy>>;
  where?: InputMaybe<VAdminMerchantListBoolExp>;
};


export type QueryRootVAdminMonitoringArgs = {
  distinct_on?: InputMaybe<Array<VAdminMonitoringSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminMonitoringOrderBy>>;
  where?: InputMaybe<VAdminMonitoringBoolExp>;
};


export type QueryRootVAdminMonitoringAggregateArgs = {
  distinct_on?: InputMaybe<Array<VAdminMonitoringSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminMonitoringOrderBy>>;
  where?: InputMaybe<VAdminMonitoringBoolExp>;
};


export type QueryRootVAdminPaymentSystemProviderArgs = {
  distinct_on?: InputMaybe<Array<VAdminPaymentSystemProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminPaymentSystemProviderOrderBy>>;
  where?: InputMaybe<VAdminPaymentSystemProviderBoolExp>;
};


export type QueryRootVAdminPaymentSystemProviderAggregateArgs = {
  distinct_on?: InputMaybe<Array<VAdminPaymentSystemProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminPaymentSystemProviderOrderBy>>;
  where?: InputMaybe<VAdminPaymentSystemProviderBoolExp>;
};


export type QueryRootVAdminRefundArgs = {
  distinct_on?: InputMaybe<Array<VAdminRefundSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminRefundOrderBy>>;
  where?: InputMaybe<VAdminRefundBoolExp>;
};


export type QueryRootVAdminRefundAggregateArgs = {
  distinct_on?: InputMaybe<Array<VAdminRefundSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminRefundOrderBy>>;
  where?: InputMaybe<VAdminRefundBoolExp>;
};


export type QueryRootVAdminWithdrawRequestArgs = {
  distinct_on?: InputMaybe<Array<VAdminWithdrawRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminWithdrawRequestOrderBy>>;
  where?: InputMaybe<VAdminWithdrawRequestBoolExp>;
};


export type QueryRootVAdminWithdrawRequestAggregateArgs = {
  distinct_on?: InputMaybe<Array<VAdminWithdrawRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminWithdrawRequestOrderBy>>;
  where?: InputMaybe<VAdminWithdrawRequestBoolExp>;
};


export type QueryRootVGateGroupBalanceArgs = {
  distinct_on?: InputMaybe<Array<VGateGroupBalanceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VGateGroupBalanceOrderBy>>;
  where?: InputMaybe<VGateGroupBalanceBoolExp>;
};


export type QueryRootVGateGroupBalanceAggregateArgs = {
  distinct_on?: InputMaybe<Array<VGateGroupBalanceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VGateGroupBalanceOrderBy>>;
  where?: InputMaybe<VGateGroupBalanceBoolExp>;
};


export type QueryRootVHasuraPermissionArgs = {
  distinct_on?: InputMaybe<Array<VHasuraPermissionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VHasuraPermissionOrderBy>>;
  where?: InputMaybe<VHasuraPermissionBoolExp>;
};


export type QueryRootVHasuraPermissionAggregateArgs = {
  distinct_on?: InputMaybe<Array<VHasuraPermissionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VHasuraPermissionOrderBy>>;
  where?: InputMaybe<VHasuraPermissionBoolExp>;
};


export type QueryRootVLkChargebackArgs = {
  distinct_on?: InputMaybe<Array<VLkChargebackSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VLkChargebackOrderBy>>;
  where?: InputMaybe<VLkChargebackBoolExp>;
};


export type QueryRootVLkChargebackAggregateArgs = {
  distinct_on?: InputMaybe<Array<VLkChargebackSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VLkChargebackOrderBy>>;
  where?: InputMaybe<VLkChargebackBoolExp>;
};


export type QueryRootVLkGateFeeArgs = {
  distinct_on?: InputMaybe<Array<VLkGateFeeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VLkGateFeeOrderBy>>;
  where?: InputMaybe<VLkGateFeeBoolExp>;
};


export type QueryRootVLkGateFeeAggregateArgs = {
  distinct_on?: InputMaybe<Array<VLkGateFeeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VLkGateFeeOrderBy>>;
  where?: InputMaybe<VLkGateFeeBoolExp>;
};


export type QueryRootWidgetTypeArgs = {
  distinct_on?: InputMaybe<Array<WidgetTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WidgetTypeOrderBy>>;
  where?: InputMaybe<WidgetTypeBoolExp>;
};


export type QueryRootWidgetTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<WidgetTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WidgetTypeOrderBy>>;
  where?: InputMaybe<WidgetTypeBoolExp>;
};


export type QueryRootWidgetTypeByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootWithdrawArgs = {
  distinct_on?: InputMaybe<Array<WithdrawSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WithdrawOrderBy>>;
  where?: InputMaybe<WithdrawBoolExp>;
};


export type QueryRootWithdrawAggregateArgs = {
  distinct_on?: InputMaybe<Array<WithdrawSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WithdrawOrderBy>>;
  where?: InputMaybe<WithdrawBoolExp>;
};


export type QueryRootWithdrawByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootWithdrawRequestArgs = {
  distinct_on?: InputMaybe<Array<WithdrawRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WithdrawRequestOrderBy>>;
  where?: InputMaybe<WithdrawRequestBoolExp>;
};


export type QueryRootWithdrawRequestAggregateArgs = {
  distinct_on?: InputMaybe<Array<WithdrawRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WithdrawRequestOrderBy>>;
  where?: InputMaybe<WithdrawRequestBoolExp>;
};


export type QueryRootWithdrawRequestByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRootWithdrawRequestStatusArgs = {
  distinct_on?: InputMaybe<Array<WithdrawRequestStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WithdrawRequestStatusOrderBy>>;
  where?: InputMaybe<WithdrawRequestStatusBoolExp>;
};


export type QueryRootWithdrawRequestStatusAggregateArgs = {
  distinct_on?: InputMaybe<Array<WithdrawRequestStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WithdrawRequestStatusOrderBy>>;
  where?: InputMaybe<WithdrawRequestStatusBoolExp>;
};


export type QueryRootWithdrawRequestStatusByPkArgs = {
  id: Scalars['String'];
};


export type QueryRootWwAgsInvoiceOrderInfoArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
  transaction_uid: Scalars['String'];
};


export type QueryRootWzrdH2HInvoiceOrderInfoArgs = {
  currency_id: Scalars['String'];
  order_id: Scalars['String'];
  provider_id: Scalars['String'];
};


export type QueryRootWzrdInternalBalancesArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
};


export type QueryRootXpListWidgetsArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
};


export type QueryRootXpayInvoiceOrderInfoArgs = {
  currency_id: Scalars['String'];
  provider_id: Scalars['String'];
  transaction_id: Scalars['String'];
};

/** columns and relationships of "refund_request_status" */
export type RefundRequestStatus = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "refund_request_status" */
export type RefundRequestStatusAggregate = {
  aggregate?: Maybe<RefundRequestStatusAggregateFields>;
  nodes: Array<RefundRequestStatus>;
};

/** aggregate fields of "refund_request_status" */
export type RefundRequestStatusAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<RefundRequestStatusMaxFields>;
  min?: Maybe<RefundRequestStatusMinFields>;
};


/** aggregate fields of "refund_request_status" */
export type RefundRequestStatusAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RefundRequestStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "refund_request_status". All fields are combined with a logical 'AND'. */
export type RefundRequestStatusBoolExp = {
  _and?: InputMaybe<Array<RefundRequestStatusBoolExp>>;
  _not?: InputMaybe<RefundRequestStatusBoolExp>;
  _or?: InputMaybe<Array<RefundRequestStatusBoolExp>>;
  id?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "refund_request_status" */
export enum RefundRequestStatusConstraint {
  /** unique or primary key constraint on columns "id" */
  RefundRequestStatusPkey = 'refund_request_status_pkey'
}

/** input type for inserting data into table "refund_request_status" */
export type RefundRequestStatusInsertInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type RefundRequestStatusMaxFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type RefundRequestStatusMinFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "refund_request_status" */
export type RefundRequestStatusMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RefundRequestStatus>;
};

/** on_conflict condition type for table "refund_request_status" */
export type RefundRequestStatusOnConflict = {
  constraint: RefundRequestStatusConstraint;
  update_columns?: Array<RefundRequestStatusUpdateColumn>;
  where?: InputMaybe<RefundRequestStatusBoolExp>;
};

/** Ordering options when selecting data from "refund_request_status". */
export type RefundRequestStatusOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: refund_request_status */
export type RefundRequestStatusPkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "refund_request_status" */
export enum RefundRequestStatusSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "refund_request_status" */
export type RefundRequestStatusSetInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "refund_request_status" */
export enum RefundRequestStatusUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type RefundRequestStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RefundRequestStatusSetInput>;
  where: RefundRequestStatusBoolExp;
};

/** columns and relationships of "refund_table" */
export type RefundTable = {
  amount: Scalars['numeric'];
  comment?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['String'];
  /** An object relationship */
  invoice?: Maybe<Invoice>;
  invoice_transaction_uid?: Maybe<Scalars['String']>;
  is_paid?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  merchant?: Maybe<Merchant>;
  merchant_id?: Maybe<Scalars['Int']>;
  refund_fee: Scalars['numeric'];
  refund_reason?: Maybe<Scalars['String']>;
  refund_request_status_id?: Maybe<Scalars['String']>;
  reject_reason?: Maybe<Scalars['String']>;
  /** An object relationship */
  withdraw?: Maybe<Withdraw>;
  withdraw_transaction_uid?: Maybe<Scalars['String']>;
};

/** aggregated selection of "refund_table" */
export type RefundTableAggregate = {
  aggregate?: Maybe<RefundTableAggregateFields>;
  nodes: Array<RefundTable>;
};

/** aggregate fields of "refund_table" */
export type RefundTableAggregateFields = {
  avg?: Maybe<RefundTableAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<RefundTableMaxFields>;
  min?: Maybe<RefundTableMinFields>;
  stddev?: Maybe<RefundTableStddevFields>;
  stddev_pop?: Maybe<RefundTableStddevPopFields>;
  stddev_samp?: Maybe<RefundTableStddevSampFields>;
  sum?: Maybe<RefundTableSumFields>;
  var_pop?: Maybe<RefundTableVarPopFields>;
  var_samp?: Maybe<RefundTableVarSampFields>;
  variance?: Maybe<RefundTableVarianceFields>;
};


/** aggregate fields of "refund_table" */
export type RefundTableAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RefundTableSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type RefundTableAvgFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  refund_fee?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "refund_table". All fields are combined with a logical 'AND'. */
export type RefundTableBoolExp = {
  _and?: InputMaybe<Array<RefundTableBoolExp>>;
  _not?: InputMaybe<RefundTableBoolExp>;
  _or?: InputMaybe<Array<RefundTableBoolExp>>;
  amount?: InputMaybe<NumericComparisonExp>;
  comment?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  invoice?: InputMaybe<InvoiceBoolExp>;
  invoice_transaction_uid?: InputMaybe<StringComparisonExp>;
  is_paid?: InputMaybe<BooleanComparisonExp>;
  merchant?: InputMaybe<MerchantBoolExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  refund_fee?: InputMaybe<NumericComparisonExp>;
  refund_reason?: InputMaybe<StringComparisonExp>;
  refund_request_status_id?: InputMaybe<StringComparisonExp>;
  reject_reason?: InputMaybe<StringComparisonExp>;
  withdraw?: InputMaybe<WithdrawBoolExp>;
  withdraw_transaction_uid?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "refund_table" */
export enum RefundTableConstraint {
  /** unique or primary key constraint on columns "invoice_transaction_uid" */
  RefundTableInvoiceTransactionUidKey = 'refund_table_invoice_transaction_uid_key',
  /** unique or primary key constraint on columns "id" */
  RefundTablePkey = 'refund_table_pkey',
  /** unique or primary key constraint on columns "withdraw_transaction_uid" */
  RefundTableWithdrawTransactionUidKey = 'refund_table_withdraw_transaction_uid_key'
}

/** input type for incrementing numeric columns in table "refund_table" */
export type RefundTableIncInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  refund_fee?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "refund_table" */
export type RefundTableInsertInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  invoice?: InputMaybe<InvoiceObjRelInsertInput>;
  invoice_transaction_uid?: InputMaybe<Scalars['String']>;
  is_paid?: InputMaybe<Scalars['Boolean']>;
  merchant?: InputMaybe<MerchantObjRelInsertInput>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  refund_fee?: InputMaybe<Scalars['numeric']>;
  refund_reason?: InputMaybe<Scalars['String']>;
  refund_request_status_id?: InputMaybe<Scalars['String']>;
  reject_reason?: InputMaybe<Scalars['String']>;
  withdraw?: InputMaybe<WithdrawObjRelInsertInput>;
  withdraw_transaction_uid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type RefundTableMaxFields = {
  amount?: Maybe<Scalars['numeric']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  invoice_transaction_uid?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
  refund_fee?: Maybe<Scalars['numeric']>;
  refund_reason?: Maybe<Scalars['String']>;
  refund_request_status_id?: Maybe<Scalars['String']>;
  reject_reason?: Maybe<Scalars['String']>;
  withdraw_transaction_uid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type RefundTableMinFields = {
  amount?: Maybe<Scalars['numeric']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  invoice_transaction_uid?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
  refund_fee?: Maybe<Scalars['numeric']>;
  refund_reason?: Maybe<Scalars['String']>;
  refund_request_status_id?: Maybe<Scalars['String']>;
  reject_reason?: Maybe<Scalars['String']>;
  withdraw_transaction_uid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "refund_table" */
export type RefundTableMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RefundTable>;
};

/** on_conflict condition type for table "refund_table" */
export type RefundTableOnConflict = {
  constraint: RefundTableConstraint;
  update_columns?: Array<RefundTableUpdateColumn>;
  where?: InputMaybe<RefundTableBoolExp>;
};

/** Ordering options when selecting data from "refund_table". */
export type RefundTableOrderBy = {
  amount?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice?: InputMaybe<InvoiceOrderBy>;
  invoice_transaction_uid?: InputMaybe<OrderBy>;
  is_paid?: InputMaybe<OrderBy>;
  merchant?: InputMaybe<MerchantOrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  refund_fee?: InputMaybe<OrderBy>;
  refund_reason?: InputMaybe<OrderBy>;
  refund_request_status_id?: InputMaybe<OrderBy>;
  reject_reason?: InputMaybe<OrderBy>;
  withdraw?: InputMaybe<WithdrawOrderBy>;
  withdraw_transaction_uid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: refund_table */
export type RefundTablePkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "refund_table" */
export enum RefundTableSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceTransactionUid = 'invoice_transaction_uid',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  RefundFee = 'refund_fee',
  /** column name */
  RefundReason = 'refund_reason',
  /** column name */
  RefundRequestStatusId = 'refund_request_status_id',
  /** column name */
  RejectReason = 'reject_reason',
  /** column name */
  WithdrawTransactionUid = 'withdraw_transaction_uid'
}

/** input type for updating data in table "refund_table" */
export type RefundTableSetInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  invoice_transaction_uid?: InputMaybe<Scalars['String']>;
  is_paid?: InputMaybe<Scalars['Boolean']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  refund_fee?: InputMaybe<Scalars['numeric']>;
  refund_reason?: InputMaybe<Scalars['String']>;
  refund_request_status_id?: InputMaybe<Scalars['String']>;
  reject_reason?: InputMaybe<Scalars['String']>;
  withdraw_transaction_uid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type RefundTableStddevFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  refund_fee?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type RefundTableStddevPopFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  refund_fee?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type RefundTableStddevSampFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  refund_fee?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type RefundTableSumFields = {
  amount?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  refund_fee?: Maybe<Scalars['numeric']>;
};

/** update columns of table "refund_table" */
export enum RefundTableUpdateColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceTransactionUid = 'invoice_transaction_uid',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  RefundFee = 'refund_fee',
  /** column name */
  RefundReason = 'refund_reason',
  /** column name */
  RefundRequestStatusId = 'refund_request_status_id',
  /** column name */
  RejectReason = 'reject_reason',
  /** column name */
  WithdrawTransactionUid = 'withdraw_transaction_uid'
}

export type RefundTableUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RefundTableIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RefundTableSetInput>;
  where: RefundTableBoolExp;
};

/** aggregate var_pop on columns */
export type RefundTableVarPopFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  refund_fee?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type RefundTableVarSampFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  refund_fee?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type RefundTableVarianceFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  refund_fee?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "registration_info" */
export type RegistrationInfo = {
  approved_at?: Maybe<Scalars['timestamptz']>;
  business_address?: Maybe<Scalars['String']>;
  chargeback_ratio: Scalars['String'];
  company_name: Scalars['String'];
  company_website: Scalars['String'];
  created_at: Scalars['timestamptz'];
  email: Scalars['String'];
  email_test?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  meta: Scalars['jsonb'];
  month_turnover: Scalars['String'];
  password_hash: Scalars['String'];
  payments_currencies: Scalars['jsonb'];
  payments_geo: Scalars['String'];
  phone: Scalars['String'];
  registered_address?: Maybe<Scalars['String']>;
  registration_data?: Maybe<Scalars['date']>;
  registration_number?: Maybe<Scalars['String']>;
  /** An object relationship */
  registration_status: RegistrationStatus;
  registration_status_id: Scalars['String'];
  reject_reason?: Maybe<Scalars['String']>;
  reject_send_at?: Maybe<Scalars['timestamptz']>;
  rejected_at?: Maybe<Scalars['timestamptz']>;
  telegram?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<User>;
  whatsapp?: Maybe<Scalars['String']>;
};


/** columns and relationships of "registration_info" */
export type RegistrationInfoMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "registration_info" */
export type RegistrationInfoPaymentsCurrenciesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "registration_info" */
export type RegistrationInfoAggregate = {
  aggregate?: Maybe<RegistrationInfoAggregateFields>;
  nodes: Array<RegistrationInfo>;
};

/** aggregate fields of "registration_info" */
export type RegistrationInfoAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<RegistrationInfoMaxFields>;
  min?: Maybe<RegistrationInfoMinFields>;
};


/** aggregate fields of "registration_info" */
export type RegistrationInfoAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RegistrationInfoSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "registration_info" */
export type RegistrationInfoAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RegistrationInfoMaxOrderBy>;
  min?: InputMaybe<RegistrationInfoMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RegistrationInfoAppendInput = {
  meta?: InputMaybe<Scalars['jsonb']>;
  payments_currencies?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "registration_info" */
export type RegistrationInfoArrRelInsertInput = {
  data: Array<RegistrationInfoInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RegistrationInfoOnConflict>;
};

/** Boolean expression to filter rows from the table "registration_info". All fields are combined with a logical 'AND'. */
export type RegistrationInfoBoolExp = {
  _and?: InputMaybe<Array<RegistrationInfoBoolExp>>;
  _not?: InputMaybe<RegistrationInfoBoolExp>;
  _or?: InputMaybe<Array<RegistrationInfoBoolExp>>;
  approved_at?: InputMaybe<TimestamptzComparisonExp>;
  business_address?: InputMaybe<StringComparisonExp>;
  chargeback_ratio?: InputMaybe<StringComparisonExp>;
  company_name?: InputMaybe<StringComparisonExp>;
  company_website?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  email_test?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  meta?: InputMaybe<JsonbComparisonExp>;
  month_turnover?: InputMaybe<StringComparisonExp>;
  password_hash?: InputMaybe<StringComparisonExp>;
  payments_currencies?: InputMaybe<JsonbComparisonExp>;
  payments_geo?: InputMaybe<StringComparisonExp>;
  phone?: InputMaybe<StringComparisonExp>;
  registered_address?: InputMaybe<StringComparisonExp>;
  registration_data?: InputMaybe<DateComparisonExp>;
  registration_number?: InputMaybe<StringComparisonExp>;
  registration_status?: InputMaybe<RegistrationStatusBoolExp>;
  registration_status_id?: InputMaybe<StringComparisonExp>;
  reject_reason?: InputMaybe<StringComparisonExp>;
  reject_send_at?: InputMaybe<TimestamptzComparisonExp>;
  rejected_at?: InputMaybe<TimestamptzComparisonExp>;
  telegram?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UserBoolExp>;
  whatsapp?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "registration_info" */
export enum RegistrationInfoConstraint {
  /** unique or primary key constraint on columns "id" */
  RegistrationInfoPkey = 'registration_info_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RegistrationInfoDeleteAtPathInput = {
  meta?: InputMaybe<Array<Scalars['String']>>;
  payments_currencies?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RegistrationInfoDeleteElemInput = {
  meta?: InputMaybe<Scalars['Int']>;
  payments_currencies?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RegistrationInfoDeleteKeyInput = {
  meta?: InputMaybe<Scalars['String']>;
  payments_currencies?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "registration_info" */
export type RegistrationInfoInsertInput = {
  approved_at?: InputMaybe<Scalars['timestamptz']>;
  business_address?: InputMaybe<Scalars['String']>;
  chargeback_ratio?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  company_website?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  email_test?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  month_turnover?: InputMaybe<Scalars['String']>;
  password_hash?: InputMaybe<Scalars['String']>;
  payments_currencies?: InputMaybe<Scalars['jsonb']>;
  payments_geo?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  registered_address?: InputMaybe<Scalars['String']>;
  registration_data?: InputMaybe<Scalars['date']>;
  registration_number?: InputMaybe<Scalars['String']>;
  registration_status?: InputMaybe<RegistrationStatusObjRelInsertInput>;
  registration_status_id?: InputMaybe<Scalars['String']>;
  reject_reason?: InputMaybe<Scalars['String']>;
  reject_send_at?: InputMaybe<Scalars['timestamptz']>;
  rejected_at?: InputMaybe<Scalars['timestamptz']>;
  telegram?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UserObjRelInsertInput>;
  whatsapp?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type RegistrationInfoMaxFields = {
  approved_at?: Maybe<Scalars['timestamptz']>;
  business_address?: Maybe<Scalars['String']>;
  chargeback_ratio?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  company_website?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  email_test?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  month_turnover?: Maybe<Scalars['String']>;
  password_hash?: Maybe<Scalars['String']>;
  payments_geo?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  registered_address?: Maybe<Scalars['String']>;
  registration_data?: Maybe<Scalars['date']>;
  registration_number?: Maybe<Scalars['String']>;
  registration_status_id?: Maybe<Scalars['String']>;
  reject_reason?: Maybe<Scalars['String']>;
  reject_send_at?: Maybe<Scalars['timestamptz']>;
  rejected_at?: Maybe<Scalars['timestamptz']>;
  telegram?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  whatsapp?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "registration_info" */
export type RegistrationInfoMaxOrderBy = {
  approved_at?: InputMaybe<OrderBy>;
  business_address?: InputMaybe<OrderBy>;
  chargeback_ratio?: InputMaybe<OrderBy>;
  company_name?: InputMaybe<OrderBy>;
  company_website?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  email_test?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  month_turnover?: InputMaybe<OrderBy>;
  password_hash?: InputMaybe<OrderBy>;
  payments_geo?: InputMaybe<OrderBy>;
  phone?: InputMaybe<OrderBy>;
  registered_address?: InputMaybe<OrderBy>;
  registration_data?: InputMaybe<OrderBy>;
  registration_number?: InputMaybe<OrderBy>;
  registration_status_id?: InputMaybe<OrderBy>;
  reject_reason?: InputMaybe<OrderBy>;
  reject_send_at?: InputMaybe<OrderBy>;
  rejected_at?: InputMaybe<OrderBy>;
  telegram?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  whatsapp?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RegistrationInfoMinFields = {
  approved_at?: Maybe<Scalars['timestamptz']>;
  business_address?: Maybe<Scalars['String']>;
  chargeback_ratio?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  company_website?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  email_test?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  month_turnover?: Maybe<Scalars['String']>;
  password_hash?: Maybe<Scalars['String']>;
  payments_geo?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  registered_address?: Maybe<Scalars['String']>;
  registration_data?: Maybe<Scalars['date']>;
  registration_number?: Maybe<Scalars['String']>;
  registration_status_id?: Maybe<Scalars['String']>;
  reject_reason?: Maybe<Scalars['String']>;
  reject_send_at?: Maybe<Scalars['timestamptz']>;
  rejected_at?: Maybe<Scalars['timestamptz']>;
  telegram?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  whatsapp?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "registration_info" */
export type RegistrationInfoMinOrderBy = {
  approved_at?: InputMaybe<OrderBy>;
  business_address?: InputMaybe<OrderBy>;
  chargeback_ratio?: InputMaybe<OrderBy>;
  company_name?: InputMaybe<OrderBy>;
  company_website?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  email_test?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  month_turnover?: InputMaybe<OrderBy>;
  password_hash?: InputMaybe<OrderBy>;
  payments_geo?: InputMaybe<OrderBy>;
  phone?: InputMaybe<OrderBy>;
  registered_address?: InputMaybe<OrderBy>;
  registration_data?: InputMaybe<OrderBy>;
  registration_number?: InputMaybe<OrderBy>;
  registration_status_id?: InputMaybe<OrderBy>;
  reject_reason?: InputMaybe<OrderBy>;
  reject_send_at?: InputMaybe<OrderBy>;
  rejected_at?: InputMaybe<OrderBy>;
  telegram?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  whatsapp?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "registration_info" */
export type RegistrationInfoMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RegistrationInfo>;
};

/** input type for inserting object relation for remote table "registration_info" */
export type RegistrationInfoObjRelInsertInput = {
  data: RegistrationInfoInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RegistrationInfoOnConflict>;
};

/** on_conflict condition type for table "registration_info" */
export type RegistrationInfoOnConflict = {
  constraint: RegistrationInfoConstraint;
  update_columns?: Array<RegistrationInfoUpdateColumn>;
  where?: InputMaybe<RegistrationInfoBoolExp>;
};

/** Ordering options when selecting data from "registration_info". */
export type RegistrationInfoOrderBy = {
  approved_at?: InputMaybe<OrderBy>;
  business_address?: InputMaybe<OrderBy>;
  chargeback_ratio?: InputMaybe<OrderBy>;
  company_name?: InputMaybe<OrderBy>;
  company_website?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  email_test?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  meta?: InputMaybe<OrderBy>;
  month_turnover?: InputMaybe<OrderBy>;
  password_hash?: InputMaybe<OrderBy>;
  payments_currencies?: InputMaybe<OrderBy>;
  payments_geo?: InputMaybe<OrderBy>;
  phone?: InputMaybe<OrderBy>;
  registered_address?: InputMaybe<OrderBy>;
  registration_data?: InputMaybe<OrderBy>;
  registration_number?: InputMaybe<OrderBy>;
  registration_status?: InputMaybe<RegistrationStatusOrderBy>;
  registration_status_id?: InputMaybe<OrderBy>;
  reject_reason?: InputMaybe<OrderBy>;
  reject_send_at?: InputMaybe<OrderBy>;
  rejected_at?: InputMaybe<OrderBy>;
  telegram?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user?: InputMaybe<UserOrderBy>;
  whatsapp?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: registration_info */
export type RegistrationInfoPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RegistrationInfoPrependInput = {
  meta?: InputMaybe<Scalars['jsonb']>;
  payments_currencies?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "registration_info" */
export enum RegistrationInfoSelectColumn {
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  BusinessAddress = 'business_address',
  /** column name */
  ChargebackRatio = 'chargeback_ratio',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  CompanyWebsite = 'company_website',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  EmailTest = 'email_test',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  MonthTurnover = 'month_turnover',
  /** column name */
  PasswordHash = 'password_hash',
  /** column name */
  PaymentsCurrencies = 'payments_currencies',
  /** column name */
  PaymentsGeo = 'payments_geo',
  /** column name */
  Phone = 'phone',
  /** column name */
  RegisteredAddress = 'registered_address',
  /** column name */
  RegistrationData = 'registration_data',
  /** column name */
  RegistrationNumber = 'registration_number',
  /** column name */
  RegistrationStatusId = 'registration_status_id',
  /** column name */
  RejectReason = 'reject_reason',
  /** column name */
  RejectSendAt = 'reject_send_at',
  /** column name */
  RejectedAt = 'rejected_at',
  /** column name */
  Telegram = 'telegram',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Whatsapp = 'whatsapp'
}

/** input type for updating data in table "registration_info" */
export type RegistrationInfoSetInput = {
  approved_at?: InputMaybe<Scalars['timestamptz']>;
  business_address?: InputMaybe<Scalars['String']>;
  chargeback_ratio?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  company_website?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  email_test?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  month_turnover?: InputMaybe<Scalars['String']>;
  password_hash?: InputMaybe<Scalars['String']>;
  payments_currencies?: InputMaybe<Scalars['jsonb']>;
  payments_geo?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  registered_address?: InputMaybe<Scalars['String']>;
  registration_data?: InputMaybe<Scalars['date']>;
  registration_number?: InputMaybe<Scalars['String']>;
  registration_status_id?: InputMaybe<Scalars['String']>;
  reject_reason?: InputMaybe<Scalars['String']>;
  reject_send_at?: InputMaybe<Scalars['timestamptz']>;
  rejected_at?: InputMaybe<Scalars['timestamptz']>;
  telegram?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  whatsapp?: InputMaybe<Scalars['String']>;
};

/** update columns of table "registration_info" */
export enum RegistrationInfoUpdateColumn {
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  BusinessAddress = 'business_address',
  /** column name */
  ChargebackRatio = 'chargeback_ratio',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  CompanyWebsite = 'company_website',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  EmailTest = 'email_test',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  MonthTurnover = 'month_turnover',
  /** column name */
  PasswordHash = 'password_hash',
  /** column name */
  PaymentsCurrencies = 'payments_currencies',
  /** column name */
  PaymentsGeo = 'payments_geo',
  /** column name */
  Phone = 'phone',
  /** column name */
  RegisteredAddress = 'registered_address',
  /** column name */
  RegistrationData = 'registration_data',
  /** column name */
  RegistrationNumber = 'registration_number',
  /** column name */
  RegistrationStatusId = 'registration_status_id',
  /** column name */
  RejectReason = 'reject_reason',
  /** column name */
  RejectSendAt = 'reject_send_at',
  /** column name */
  RejectedAt = 'rejected_at',
  /** column name */
  Telegram = 'telegram',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Whatsapp = 'whatsapp'
}

export type RegistrationInfoUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RegistrationInfoAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<RegistrationInfoDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<RegistrationInfoDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<RegistrationInfoDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RegistrationInfoPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RegistrationInfoSetInput>;
  where: RegistrationInfoBoolExp;
};

/** columns and relationships of "registration_status" */
export type RegistrationStatus = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  registration_infos: Array<RegistrationInfo>;
  /** An aggregate relationship */
  registration_infos_aggregate: RegistrationInfoAggregate;
};


/** columns and relationships of "registration_status" */
export type RegistrationStatusRegistrationInfosArgs = {
  distinct_on?: InputMaybe<Array<RegistrationInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RegistrationInfoOrderBy>>;
  where?: InputMaybe<RegistrationInfoBoolExp>;
};


/** columns and relationships of "registration_status" */
export type RegistrationStatusRegistrationInfosAggregateArgs = {
  distinct_on?: InputMaybe<Array<RegistrationInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RegistrationInfoOrderBy>>;
  where?: InputMaybe<RegistrationInfoBoolExp>;
};

/** aggregated selection of "registration_status" */
export type RegistrationStatusAggregate = {
  aggregate?: Maybe<RegistrationStatusAggregateFields>;
  nodes: Array<RegistrationStatus>;
};

/** aggregate fields of "registration_status" */
export type RegistrationStatusAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<RegistrationStatusMaxFields>;
  min?: Maybe<RegistrationStatusMinFields>;
};


/** aggregate fields of "registration_status" */
export type RegistrationStatusAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RegistrationStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "registration_status". All fields are combined with a logical 'AND'. */
export type RegistrationStatusBoolExp = {
  _and?: InputMaybe<Array<RegistrationStatusBoolExp>>;
  _not?: InputMaybe<RegistrationStatusBoolExp>;
  _or?: InputMaybe<Array<RegistrationStatusBoolExp>>;
  id?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  registration_infos?: InputMaybe<RegistrationInfoBoolExp>;
};

/** unique or primary key constraints on table "registration_status" */
export enum RegistrationStatusConstraint {
  /** unique or primary key constraint on columns "id" */
  RegistrationStatusPkey = 'registration_status_pkey'
}

/** input type for inserting data into table "registration_status" */
export type RegistrationStatusInsertInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  registration_infos?: InputMaybe<RegistrationInfoArrRelInsertInput>;
};

/** aggregate max on columns */
export type RegistrationStatusMaxFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type RegistrationStatusMinFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "registration_status" */
export type RegistrationStatusMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RegistrationStatus>;
};

/** input type for inserting object relation for remote table "registration_status" */
export type RegistrationStatusObjRelInsertInput = {
  data: RegistrationStatusInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RegistrationStatusOnConflict>;
};

/** on_conflict condition type for table "registration_status" */
export type RegistrationStatusOnConflict = {
  constraint: RegistrationStatusConstraint;
  update_columns?: Array<RegistrationStatusUpdateColumn>;
  where?: InputMaybe<RegistrationStatusBoolExp>;
};

/** Ordering options when selecting data from "registration_status". */
export type RegistrationStatusOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  registration_infos_aggregate?: InputMaybe<RegistrationInfoAggregateOrderBy>;
};

/** primary key columns input for table: registration_status */
export type RegistrationStatusPkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "registration_status" */
export enum RegistrationStatusSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "registration_status" */
export type RegistrationStatusSetInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "registration_status" */
export enum RegistrationStatusUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type RegistrationStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RegistrationStatusSetInput>;
  where: RegistrationStatusBoolExp;
};

/** columns and relationships of "role" */
export type Role = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  users: Array<User>;
  /** An aggregate relationship */
  users_aggregate: UserAggregate;
};


/** columns and relationships of "role" */
export type RoleUsersArgs = {
  distinct_on?: InputMaybe<Array<UserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserOrderBy>>;
  where?: InputMaybe<UserBoolExp>;
};


/** columns and relationships of "role" */
export type RoleUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserOrderBy>>;
  where?: InputMaybe<UserBoolExp>;
};

/** aggregated selection of "role" */
export type RoleAggregate = {
  aggregate?: Maybe<RoleAggregateFields>;
  nodes: Array<Role>;
};

/** aggregate fields of "role" */
export type RoleAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<RoleMaxFields>;
  min?: Maybe<RoleMinFields>;
};


/** aggregate fields of "role" */
export type RoleAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RoleSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "role". All fields are combined with a logical 'AND'. */
export type RoleBoolExp = {
  _and?: InputMaybe<Array<RoleBoolExp>>;
  _not?: InputMaybe<RoleBoolExp>;
  _or?: InputMaybe<Array<RoleBoolExp>>;
  id?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  users?: InputMaybe<UserBoolExp>;
};

/** unique or primary key constraints on table "role" */
export enum RoleConstraint {
  /** unique or primary key constraint on columns "id" */
  RolePkey = 'role_pkey'
}

/** input type for inserting data into table "role" */
export type RoleInsertInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<UserArrRelInsertInput>;
};

/** aggregate max on columns */
export type RoleMaxFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type RoleMinFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "role" */
export type RoleMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Role>;
};

/** input type for inserting object relation for remote table "role" */
export type RoleObjRelInsertInput = {
  data: RoleInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RoleOnConflict>;
};

/** on_conflict condition type for table "role" */
export type RoleOnConflict = {
  constraint: RoleConstraint;
  update_columns?: Array<RoleUpdateColumn>;
  where?: InputMaybe<RoleBoolExp>;
};

/** Ordering options when selecting data from "role". */
export type RoleOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  users_aggregate?: InputMaybe<UserAggregateOrderBy>;
};

/** primary key columns input for table: role */
export type RolePkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "role" */
export enum RoleSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "role" */
export type RoleSetInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "role" */
export enum RoleUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type RoleUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RoleSetInput>;
  where: RoleBoolExp;
};

/** columns and relationships of "rolling_reserve" */
export type RollingReserve = {
  amount: Scalars['numeric'];
  comment: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['String'];
  /** An object relationship */
  invoice?: Maybe<Invoice>;
  invoice_transaction_uid?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  withdraw?: Maybe<Withdraw>;
  withdraw_transaction_uid?: Maybe<Scalars['String']>;
};

/** aggregated selection of "rolling_reserve" */
export type RollingReserveAggregate = {
  aggregate?: Maybe<RollingReserveAggregateFields>;
  nodes: Array<RollingReserve>;
};

/** aggregate fields of "rolling_reserve" */
export type RollingReserveAggregateFields = {
  avg?: Maybe<RollingReserveAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<RollingReserveMaxFields>;
  min?: Maybe<RollingReserveMinFields>;
  stddev?: Maybe<RollingReserveStddevFields>;
  stddev_pop?: Maybe<RollingReserveStddevPopFields>;
  stddev_samp?: Maybe<RollingReserveStddevSampFields>;
  sum?: Maybe<RollingReserveSumFields>;
  var_pop?: Maybe<RollingReserveVarPopFields>;
  var_samp?: Maybe<RollingReserveVarSampFields>;
  variance?: Maybe<RollingReserveVarianceFields>;
};


/** aggregate fields of "rolling_reserve" */
export type RollingReserveAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RollingReserveSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type RollingReserveAvgFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "rolling_reserve". All fields are combined with a logical 'AND'. */
export type RollingReserveBoolExp = {
  _and?: InputMaybe<Array<RollingReserveBoolExp>>;
  _not?: InputMaybe<RollingReserveBoolExp>;
  _or?: InputMaybe<Array<RollingReserveBoolExp>>;
  amount?: InputMaybe<NumericComparisonExp>;
  comment?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  invoice?: InputMaybe<InvoiceBoolExp>;
  invoice_transaction_uid?: InputMaybe<StringComparisonExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  withdraw?: InputMaybe<WithdrawBoolExp>;
  withdraw_transaction_uid?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "rolling_reserve" */
export enum RollingReserveConstraint {
  /** unique or primary key constraint on columns "invoice_transaction_uid" */
  RollingReserveInvoiceTransactionUidKey = 'rolling_reserve_invoice_transaction_uid_key',
  /** unique or primary key constraint on columns "id" */
  RollingReservePkey = 'rolling_reserve_pkey',
  /** unique or primary key constraint on columns "withdraw_transaction_uid" */
  RollingReserveWithdrawTransactionUidKey = 'rolling_reserve_withdraw_transaction_uid_key'
}

/** input type for incrementing numeric columns in table "rolling_reserve" */
export type RollingReserveIncInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "rolling_reserve" */
export type RollingReserveInsertInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  invoice?: InputMaybe<InvoiceObjRelInsertInput>;
  invoice_transaction_uid?: InputMaybe<Scalars['String']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  withdraw?: InputMaybe<WithdrawObjRelInsertInput>;
  withdraw_transaction_uid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type RollingReserveMaxFields = {
  amount?: Maybe<Scalars['numeric']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  invoice_transaction_uid?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
  withdraw_transaction_uid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type RollingReserveMinFields = {
  amount?: Maybe<Scalars['numeric']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  invoice_transaction_uid?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
  withdraw_transaction_uid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "rolling_reserve" */
export type RollingReserveMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RollingReserve>;
};

/** input type for inserting object relation for remote table "rolling_reserve" */
export type RollingReserveObjRelInsertInput = {
  data: RollingReserveInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RollingReserveOnConflict>;
};

/** on_conflict condition type for table "rolling_reserve" */
export type RollingReserveOnConflict = {
  constraint: RollingReserveConstraint;
  update_columns?: Array<RollingReserveUpdateColumn>;
  where?: InputMaybe<RollingReserveBoolExp>;
};

/** Ordering options when selecting data from "rolling_reserve". */
export type RollingReserveOrderBy = {
  amount?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice?: InputMaybe<InvoiceOrderBy>;
  invoice_transaction_uid?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  withdraw?: InputMaybe<WithdrawOrderBy>;
  withdraw_transaction_uid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: rolling_reserve */
export type RollingReservePkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "rolling_reserve" */
export enum RollingReserveSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceTransactionUid = 'invoice_transaction_uid',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  WithdrawTransactionUid = 'withdraw_transaction_uid'
}

/** input type for updating data in table "rolling_reserve" */
export type RollingReserveSetInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  invoice_transaction_uid?: InputMaybe<Scalars['String']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  withdraw_transaction_uid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type RollingReserveStddevFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type RollingReserveStddevPopFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type RollingReserveStddevSampFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type RollingReserveSumFields = {
  amount?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "rolling_reserve" */
export enum RollingReserveUpdateColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceTransactionUid = 'invoice_transaction_uid',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  WithdrawTransactionUid = 'withdraw_transaction_uid'
}

export type RollingReserveUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RollingReserveIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RollingReserveSetInput>;
  where: RollingReserveBoolExp;
};

/** aggregate var_pop on columns */
export type RollingReserveVarPopFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type RollingReserveVarSampFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type RollingReserveVarianceFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

export type SaveReportsOutput = {
  task_id: Scalars['String'];
};

/** columns and relationships of "setting" */
export type Setting = {
  key: Scalars['String'];
  type: Scalars['String'];
  value?: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "setting" */
export type SettingValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "setting" */
export type SettingAggregate = {
  aggregate?: Maybe<SettingAggregateFields>;
  nodes: Array<Setting>;
};

/** aggregate fields of "setting" */
export type SettingAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<SettingMaxFields>;
  min?: Maybe<SettingMinFields>;
};


/** aggregate fields of "setting" */
export type SettingAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SettingSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SettingAppendInput = {
  value?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "setting". All fields are combined with a logical 'AND'. */
export type SettingBoolExp = {
  _and?: InputMaybe<Array<SettingBoolExp>>;
  _not?: InputMaybe<SettingBoolExp>;
  _or?: InputMaybe<Array<SettingBoolExp>>;
  key?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "setting" */
export enum SettingConstraint {
  /** unique or primary key constraint on columns "key" */
  SettingPkey = 'setting_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SettingDeleteAtPathInput = {
  value?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SettingDeleteElemInput = {
  value?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SettingDeleteKeyInput = {
  value?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "setting" */
export type SettingInsertInput = {
  key?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type SettingMaxFields = {
  key?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type SettingMinFields = {
  key?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "setting" */
export type SettingMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Setting>;
};

/** on_conflict condition type for table "setting" */
export type SettingOnConflict = {
  constraint: SettingConstraint;
  update_columns?: Array<SettingUpdateColumn>;
  where?: InputMaybe<SettingBoolExp>;
};

/** Ordering options when selecting data from "setting". */
export type SettingOrderBy = {
  key?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: setting */
export type SettingPkColumnsInput = {
  key: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SettingPrependInput = {
  value?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "setting" */
export enum SettingSelectColumn {
  /** column name */
  Key = 'key',
  /** column name */
  Type = 'type',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "setting" */
export type SettingSetInput = {
  key?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** update columns of table "setting" */
export enum SettingUpdateColumn {
  /** column name */
  Key = 'key',
  /** column name */
  Type = 'type',
  /** column name */
  Value = 'value'
}

export type SettingUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SettingAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<SettingDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<SettingDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<SettingDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SettingPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SettingSetInput>;
  where: SettingBoolExp;
};

/** columns and relationships of "settlement" */
export type Settlement = {
  created_at: Scalars['timestamptz'];
  crypto_currency_id: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  fiat_amount: Scalars['numeric'];
  fiat_currency_id: Scalars['String'];
  gate_group_id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  merchant_crypto_account_number?: Maybe<Scalars['String']>;
  merchant_id: Scalars['Int'];
  merchant_settlement_amount: Scalars['numeric'];
  merchant_settlement_fee: Scalars['numeric'];
  withdraw_transaction_uid?: Maybe<Scalars['String']>;
};

/** aggregated selection of "settlement" */
export type SettlementAggregate = {
  aggregate?: Maybe<SettlementAggregateFields>;
  nodes: Array<Settlement>;
};

/** aggregate fields of "settlement" */
export type SettlementAggregateFields = {
  avg?: Maybe<SettlementAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SettlementMaxFields>;
  min?: Maybe<SettlementMinFields>;
  stddev?: Maybe<SettlementStddevFields>;
  stddev_pop?: Maybe<SettlementStddevPopFields>;
  stddev_samp?: Maybe<SettlementStddevSampFields>;
  sum?: Maybe<SettlementSumFields>;
  var_pop?: Maybe<SettlementVarPopFields>;
  var_samp?: Maybe<SettlementVarSampFields>;
  variance?: Maybe<SettlementVarianceFields>;
};


/** aggregate fields of "settlement" */
export type SettlementAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SettlementSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type SettlementAvgFields = {
  fiat_amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_amount?: Maybe<Scalars['Float']>;
  merchant_settlement_fee?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "settlement". All fields are combined with a logical 'AND'. */
export type SettlementBoolExp = {
  _and?: InputMaybe<Array<SettlementBoolExp>>;
  _not?: InputMaybe<SettlementBoolExp>;
  _or?: InputMaybe<Array<SettlementBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  crypto_currency_id?: InputMaybe<StringComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  fiat_amount?: InputMaybe<NumericComparisonExp>;
  fiat_currency_id?: InputMaybe<StringComparisonExp>;
  gate_group_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  merchant_crypto_account_number?: InputMaybe<StringComparisonExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  merchant_settlement_amount?: InputMaybe<NumericComparisonExp>;
  merchant_settlement_fee?: InputMaybe<NumericComparisonExp>;
  withdraw_transaction_uid?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "settlement" */
export enum SettlementConstraint {
  /** unique or primary key constraint on columns "id" */
  SettlementPkey = 'settlement_pkey',
  /** unique or primary key constraint on columns "withdraw_transaction_uid" */
  SettlementWithdrawTransactionUidKey = 'settlement_withdraw_transaction_uid_key'
}

/** input type for incrementing numeric columns in table "settlement" */
export type SettlementIncInput = {
  fiat_amount?: InputMaybe<Scalars['numeric']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_settlement_amount?: InputMaybe<Scalars['numeric']>;
  merchant_settlement_fee?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "settlement" */
export type SettlementInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  crypto_currency_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fiat_amount?: InputMaybe<Scalars['numeric']>;
  fiat_currency_id?: InputMaybe<Scalars['String']>;
  gate_group_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  merchant_crypto_account_number?: InputMaybe<Scalars['String']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_settlement_amount?: InputMaybe<Scalars['numeric']>;
  merchant_settlement_fee?: InputMaybe<Scalars['numeric']>;
  withdraw_transaction_uid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type SettlementMaxFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  crypto_currency_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fiat_amount?: Maybe<Scalars['numeric']>;
  fiat_currency_id?: Maybe<Scalars['String']>;
  gate_group_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  merchant_crypto_account_number?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_settlement_amount?: Maybe<Scalars['numeric']>;
  merchant_settlement_fee?: Maybe<Scalars['numeric']>;
  withdraw_transaction_uid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type SettlementMinFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  crypto_currency_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fiat_amount?: Maybe<Scalars['numeric']>;
  fiat_currency_id?: Maybe<Scalars['String']>;
  gate_group_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  merchant_crypto_account_number?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_settlement_amount?: Maybe<Scalars['numeric']>;
  merchant_settlement_fee?: Maybe<Scalars['numeric']>;
  withdraw_transaction_uid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "settlement" */
export type SettlementMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Settlement>;
};

/** on_conflict condition type for table "settlement" */
export type SettlementOnConflict = {
  constraint: SettlementConstraint;
  update_columns?: Array<SettlementUpdateColumn>;
  where?: InputMaybe<SettlementBoolExp>;
};

/** Ordering options when selecting data from "settlement". */
export type SettlementOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  crypto_currency_id?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  fiat_amount?: InputMaybe<OrderBy>;
  fiat_currency_id?: InputMaybe<OrderBy>;
  gate_group_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_crypto_account_number?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_settlement_amount?: InputMaybe<OrderBy>;
  merchant_settlement_fee?: InputMaybe<OrderBy>;
  withdraw_transaction_uid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: settlement */
export type SettlementPkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "settlement" */
export enum SettlementSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CryptoCurrencyId = 'crypto_currency_id',
  /** column name */
  Description = 'description',
  /** column name */
  FiatAmount = 'fiat_amount',
  /** column name */
  FiatCurrencyId = 'fiat_currency_id',
  /** column name */
  GateGroupId = 'gate_group_id',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantCryptoAccountNumber = 'merchant_crypto_account_number',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MerchantSettlementAmount = 'merchant_settlement_amount',
  /** column name */
  MerchantSettlementFee = 'merchant_settlement_fee',
  /** column name */
  WithdrawTransactionUid = 'withdraw_transaction_uid'
}

/** input type for updating data in table "settlement" */
export type SettlementSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  crypto_currency_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fiat_amount?: InputMaybe<Scalars['numeric']>;
  fiat_currency_id?: InputMaybe<Scalars['String']>;
  gate_group_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  merchant_crypto_account_number?: InputMaybe<Scalars['String']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_settlement_amount?: InputMaybe<Scalars['numeric']>;
  merchant_settlement_fee?: InputMaybe<Scalars['numeric']>;
  withdraw_transaction_uid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type SettlementStddevFields = {
  fiat_amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_amount?: Maybe<Scalars['Float']>;
  merchant_settlement_fee?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SettlementStddevPopFields = {
  fiat_amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_amount?: Maybe<Scalars['Float']>;
  merchant_settlement_fee?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SettlementStddevSampFields = {
  fiat_amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_amount?: Maybe<Scalars['Float']>;
  merchant_settlement_fee?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type SettlementSumFields = {
  fiat_amount?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_settlement_amount?: Maybe<Scalars['numeric']>;
  merchant_settlement_fee?: Maybe<Scalars['numeric']>;
};

/** update columns of table "settlement" */
export enum SettlementUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CryptoCurrencyId = 'crypto_currency_id',
  /** column name */
  Description = 'description',
  /** column name */
  FiatAmount = 'fiat_amount',
  /** column name */
  FiatCurrencyId = 'fiat_currency_id',
  /** column name */
  GateGroupId = 'gate_group_id',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantCryptoAccountNumber = 'merchant_crypto_account_number',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MerchantSettlementAmount = 'merchant_settlement_amount',
  /** column name */
  MerchantSettlementFee = 'merchant_settlement_fee',
  /** column name */
  WithdrawTransactionUid = 'withdraw_transaction_uid'
}

export type SettlementUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SettlementIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SettlementSetInput>;
  where: SettlementBoolExp;
};

/** aggregate var_pop on columns */
export type SettlementVarPopFields = {
  fiat_amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_amount?: Maybe<Scalars['Float']>;
  merchant_settlement_fee?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SettlementVarSampFields = {
  fiat_amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_amount?: Maybe<Scalars['Float']>;
  merchant_settlement_fee?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SettlementVarianceFields = {
  fiat_amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_amount?: Maybe<Scalars['Float']>;
  merchant_settlement_fee?: Maybe<Scalars['Float']>;
};

export type SubscriptionRoot = {
  /** fetch data from the table: "audit" */
  audit: Array<Audit>;
  /** fetch aggregated fields from the table: "audit" */
  audit_aggregate: AuditAggregate;
  /** fetch data from the table: "audit" using primary key columns */
  audit_by_pk?: Maybe<Audit>;
  /** fetch data from the table: "blacklist" */
  blacklist: Array<Blacklist>;
  /** fetch aggregated fields from the table: "blacklist" */
  blacklist_aggregate: BlacklistAggregate;
  /** fetch data from the table: "blacklist" using primary key columns */
  blacklist_by_pk?: Maybe<Blacklist>;
  /** fetch data from the table: "card_system" */
  card_system: Array<CardSystem>;
  /** fetch aggregated fields from the table: "card_system" */
  card_system_aggregate: CardSystemAggregate;
  /** fetch data from the table: "card_system" using primary key columns */
  card_system_by_pk?: Maybe<CardSystem>;
  /** fetch data from the table: "cascade_item" */
  cascade_item: Array<CascadeItem>;
  /** fetch aggregated fields from the table: "cascade_item" */
  cascade_item_aggregate: CascadeItemAggregate;
  /** fetch data from the table: "cascade_item" using primary key columns */
  cascade_item_by_pk?: Maybe<CascadeItem>;
  /** fetch data from the table: "cascade_request" */
  cascade_request: Array<CascadeRequest>;
  /** fetch aggregated fields from the table: "cascade_request" */
  cascade_request_aggregate: CascadeRequestAggregate;
  /** fetch data from the table: "cascade_request" using primary key columns */
  cascade_request_by_pk?: Maybe<CascadeRequest>;
  /** fetch data from the table: "cascades" */
  cascades: Array<Cascades>;
  /** fetch aggregated fields from the table: "cascades" */
  cascades_aggregate: CascadesAggregate;
  /** fetch data from the table: "cascades" using primary key columns */
  cascades_by_pk?: Maybe<Cascades>;
  /** fetch data from the table: "country" */
  country: Array<Country>;
  /** fetch aggregated fields from the table: "country" */
  country_aggregate: CountryAggregate;
  /** fetch data from the table: "country" using primary key columns */
  country_by_pk?: Maybe<Country>;
  /** fetch data from the table: "country_region" */
  country_region: Array<CountryRegion>;
  /** fetch aggregated fields from the table: "country_region" */
  country_region_aggregate: CountryRegionAggregate;
  /** fetch data from the table: "country_region" using primary key columns */
  country_region_by_pk?: Maybe<CountryRegion>;
  /** fetch data from the table: "crypto_currency" */
  crypto_currency: Array<CryptoCurrency>;
  /** fetch aggregated fields from the table: "crypto_currency" */
  crypto_currency_aggregate: CryptoCurrencyAggregate;
  /** fetch data from the table: "crypto_currency" using primary key columns */
  crypto_currency_by_pk?: Maybe<CryptoCurrency>;
  /** fetch data from the table: "crypto_withdraw_request" */
  crypto_withdraw_request: Array<CryptoWithdrawRequest>;
  /** fetch aggregated fields from the table: "crypto_withdraw_request" */
  crypto_withdraw_request_aggregate: CryptoWithdrawRequestAggregate;
  /** fetch data from the table: "crypto_withdraw_request" using primary key columns */
  crypto_withdraw_request_by_pk?: Maybe<CryptoWithdrawRequest>;
  /** fetch data from the table: "crypto_withdraw_request_status" */
  crypto_withdraw_request_status: Array<CryptoWithdrawRequestStatus>;
  /** fetch aggregated fields from the table: "crypto_withdraw_request_status" */
  crypto_withdraw_request_status_aggregate: CryptoWithdrawRequestStatusAggregate;
  /** fetch data from the table: "crypto_withdraw_request_status" using primary key columns */
  crypto_withdraw_request_status_by_pk?: Maybe<CryptoWithdrawRequestStatus>;
  /** fetch data from the table: "currency" */
  currency: Array<Currency>;
  /** fetch aggregated fields from the table: "currency" */
  currency_aggregate: CurrencyAggregate;
  /** fetch data from the table: "currency" using primary key columns */
  currency_by_pk?: Maybe<Currency>;
  /** An array relationship */
  gate: Array<Gate>;
  /** An aggregate relationship */
  gate_aggregate: GateAggregate;
  /** fetch data from the table: "gate" using primary key columns */
  gate_by_pk?: Maybe<Gate>;
  /** An array relationship */
  gate_group: Array<GateGroup>;
  /** An aggregate relationship */
  gate_group_aggregate: GateGroupAggregate;
  /** fetch data from the table: "gate_group" using primary key columns */
  gate_group_by_pk?: Maybe<GateGroup>;
  /** fetch data from the table: "gate_type" */
  gate_type: Array<GateType>;
  /** fetch aggregated fields from the table: "gate_type" */
  gate_type_aggregate: GateTypeAggregate;
  /** fetch data from the table: "gate_type" using primary key columns */
  gate_type_by_pk?: Maybe<GateType>;
  /** fetch data from the table: "gender" */
  gender: Array<Gender>;
  /** fetch aggregated fields from the table: "gender" */
  gender_aggregate: GenderAggregate;
  /** fetch data from the table: "gender" using primary key columns */
  gender_by_pk?: Maybe<Gender>;
  /** fetch data from the table: "help" */
  help: Array<Help>;
  /** fetch aggregated fields from the table: "help" */
  help_aggregate: HelpAggregate;
  /** fetch data from the table: "help" using primary key columns */
  help_by_pk?: Maybe<Help>;
  /** fetch data from the table: "help_section" */
  help_section: Array<HelpSection>;
  /** fetch aggregated fields from the table: "help_section" */
  help_section_aggregate: HelpSectionAggregate;
  /** fetch data from the table: "help_section" using primary key columns */
  help_section_by_pk?: Maybe<HelpSection>;
  /** fetch data from the table: "invoice" */
  invoice: Array<Invoice>;
  /** fetch aggregated fields from the table: "invoice" */
  invoice_aggregate: InvoiceAggregate;
  /** fetch data from the table: "invoice" using primary key columns */
  invoice_by_pk?: Maybe<Invoice>;
  /** fetch data from the table: "language" */
  language: Array<Language>;
  /** fetch aggregated fields from the table: "language" */
  language_aggregate: LanguageAggregate;
  /** fetch data from the table: "language" using primary key columns */
  language_by_pk?: Maybe<Language>;
  /** fetch data from the table: "merchant" */
  merchant: Array<Merchant>;
  /** fetch aggregated fields from the table: "merchant" */
  merchant_aggregate: MerchantAggregate;
  /** fetch data from the table: "merchant_api_token" */
  merchant_api_token: Array<MerchantApiToken>;
  /** fetch aggregated fields from the table: "merchant_api_token" */
  merchant_api_token_aggregate: MerchantApiTokenAggregate;
  /** fetch data from the table: "merchant_api_token" using primary key columns */
  merchant_api_token_by_pk?: Maybe<MerchantApiToken>;
  /** fetch data from the table: "merchant_balance" */
  merchant_balance: Array<MerchantBalance>;
  /** fetch aggregated fields from the table: "merchant_balance" */
  merchant_balance_aggregate: MerchantBalanceAggregate;
  /** fetch data from the table: "merchant_balance" using primary key columns */
  merchant_balance_by_pk?: Maybe<MerchantBalance>;
  /** fetch data from the table: "merchant" using primary key columns */
  merchant_by_pk?: Maybe<Merchant>;
  /** fetch data from the table: "merchant_currency" */
  merchant_currency: Array<MerchantCurrency>;
  /** fetch aggregated fields from the table: "merchant_currency" */
  merchant_currency_aggregate: MerchantCurrencyAggregate;
  /** fetch data from the table: "merchant_currency" using primary key columns */
  merchant_currency_by_pk?: Maybe<MerchantCurrency>;
  /** fetch data from the table: "merchant_fee" */
  merchant_fee: Array<MerchantFee>;
  /** fetch aggregated fields from the table: "merchant_fee" */
  merchant_fee_aggregate: MerchantFeeAggregate;
  /** fetch data from the table: "merchant_fee" using primary key columns */
  merchant_fee_by_pk?: Maybe<MerchantFee>;
  /** fetch data from the table: "merchant_file" */
  merchant_file: Array<MerchantFile>;
  /** fetch aggregated fields from the table: "merchant_file" */
  merchant_file_aggregate: MerchantFileAggregate;
  /** fetch data from the table: "merchant_file" using primary key columns */
  merchant_file_by_pk?: Maybe<MerchantFile>;
  /** fetch data from the table: "merchant_info" */
  merchant_info: Array<MerchantInfo>;
  /** fetch aggregated fields from the table: "merchant_info" */
  merchant_info_aggregate: MerchantInfoAggregate;
  /** fetch data from the table: "merchant_info" using primary key columns */
  merchant_info_by_pk?: Maybe<MerchantInfo>;
  /** fetch data from the table: "merchant_notification" */
  merchant_notification: Array<MerchantNotification>;
  /** fetch aggregated fields from the table: "merchant_notification" */
  merchant_notification_aggregate: MerchantNotificationAggregate;
  /** fetch data from the table: "merchant_notification" using primary key columns */
  merchant_notification_by_pk?: Maybe<MerchantNotification>;
  /** fetch data from the table: "merchant_task" */
  merchant_task: Array<MerchantTask>;
  /** fetch aggregated fields from the table: "merchant_task" */
  merchant_task_aggregate: MerchantTaskAggregate;
  /** fetch data from the table: "merchant_task" using primary key columns */
  merchant_task_by_pk?: Maybe<MerchantTask>;
  /** fetch data from the table: "merchant_task_status" */
  merchant_task_status: Array<MerchantTaskStatus>;
  /** fetch aggregated fields from the table: "merchant_task_status" */
  merchant_task_status_aggregate: MerchantTaskStatusAggregate;
  /** fetch data from the table: "merchant_task_status" using primary key columns */
  merchant_task_status_by_pk?: Maybe<MerchantTaskStatus>;
  /** fetch data from the table: "merchant_task_type" */
  merchant_task_type: Array<MerchantTaskType>;
  /** fetch aggregated fields from the table: "merchant_task_type" */
  merchant_task_type_aggregate: MerchantTaskTypeAggregate;
  /** fetch data from the table: "merchant_task_type" using primary key columns */
  merchant_task_type_by_pk?: Maybe<MerchantTaskType>;
  /** fetch data from the table: "merchant_type" */
  merchant_type: Array<MerchantType>;
  /** fetch aggregated fields from the table: "merchant_type" */
  merchant_type_aggregate: MerchantTypeAggregate;
  /** fetch data from the table: "merchant_type" using primary key columns */
  merchant_type_by_pk?: Maybe<MerchantType>;
  /** fetch data from the table: "merchant_user" */
  merchant_user: Array<MerchantUser>;
  /** fetch aggregated fields from the table: "merchant_user" */
  merchant_user_aggregate: MerchantUserAggregate;
  /** fetch data from the table: "merchant_user" using primary key columns */
  merchant_user_by_pk?: Maybe<MerchantUser>;
  /** fetch data from the table: "merchant_user_role" */
  merchant_user_role: Array<MerchantUserRole>;
  /** fetch aggregated fields from the table: "merchant_user_role" */
  merchant_user_role_aggregate: MerchantUserRoleAggregate;
  /** fetch data from the table: "merchant_user_role" using primary key columns */
  merchant_user_role_by_pk?: Maybe<MerchantUserRole>;
  /** fetch data from the table: "merchant_widget" */
  merchant_widget: Array<MerchantWidget>;
  /** fetch aggregated fields from the table: "merchant_widget" */
  merchant_widget_aggregate: MerchantWidgetAggregate;
  /** fetch data from the table: "merchant_widget" using primary key columns */
  merchant_widget_by_pk?: Maybe<MerchantWidget>;
  /** fetch data from the table: "mutex" */
  mutex: Array<Mutex>;
  /** fetch aggregated fields from the table: "mutex" */
  mutex_aggregate: MutexAggregate;
  /** fetch data from the table: "mutex" using primary key columns */
  mutex_by_pk?: Maybe<Mutex>;
  /** fetch data from the table: "notification_type" */
  notification_type: Array<NotificationType>;
  /** fetch aggregated fields from the table: "notification_type" */
  notification_type_aggregate: NotificationTypeAggregate;
  /** fetch data from the table: "notification_type" using primary key columns */
  notification_type_by_pk?: Maybe<NotificationType>;
  /** fetch data from the table: "payment_system" */
  payment_system: Array<PaymentSystem>;
  /** fetch aggregated fields from the table: "payment_system" */
  payment_system_aggregate: PaymentSystemAggregate;
  /** fetch data from the table: "payment_system" using primary key columns */
  payment_system_by_pk?: Maybe<PaymentSystem>;
  /** fetch data from the table: "profit_provider" */
  profit_provider: Array<ProfitProvider>;
  /** fetch aggregated fields from the table: "profit_provider" */
  profit_provider_aggregate: ProfitProviderAggregate;
  /** fetch data from the table: "profit_provider" using primary key columns */
  profit_provider_by_pk?: Maybe<ProfitProvider>;
  /** fetch data from the table: "profit_withdraw" */
  profit_withdraw: Array<ProfitWithdraw>;
  /** fetch aggregated fields from the table: "profit_withdraw" */
  profit_withdraw_aggregate: ProfitWithdrawAggregate;
  /** fetch data from the table: "profit_withdraw" using primary key columns */
  profit_withdraw_by_pk?: Maybe<ProfitWithdraw>;
  /** An array relationship */
  provider: Array<Provider>;
  /** An aggregate relationship */
  provider_aggregate: ProviderAggregate;
  /** fetch data from the table: "provider" using primary key columns */
  provider_by_pk?: Maybe<Provider>;
  /** fetch data from the table: "provider_country" */
  provider_country: Array<ProviderCountry>;
  /** fetch aggregated fields from the table: "provider_country" */
  provider_country_aggregate: ProviderCountryAggregate;
  /** fetch data from the table: "provider_country" using primary key columns */
  provider_country_by_pk?: Maybe<ProviderCountry>;
  /** fetch data from the table: "provider_country_state" */
  provider_country_state: Array<ProviderCountryState>;
  /** fetch aggregated fields from the table: "provider_country_state" */
  provider_country_state_aggregate: ProviderCountryStateAggregate;
  /** fetch data from the table: "provider_country_state" using primary key columns */
  provider_country_state_by_pk?: Maybe<ProviderCountryState>;
  /** fetch data from the table: "provider_family" */
  provider_family: Array<ProviderFamily>;
  /** fetch aggregated fields from the table: "provider_family" */
  provider_family_aggregate: ProviderFamilyAggregate;
  /** fetch data from the table: "provider_family" using primary key columns */
  provider_family_by_pk?: Maybe<ProviderFamily>;
  /** fetch data from the table: "provider_family_payment_system" */
  provider_family_payment_system: Array<ProviderFamilyPaymentSystem>;
  /** fetch aggregated fields from the table: "provider_family_payment_system" */
  provider_family_payment_system_aggregate: ProviderFamilyPaymentSystemAggregate;
  /** fetch data from the table: "provider_family_payment_system" using primary key columns */
  provider_family_payment_system_by_pk?: Maybe<ProviderFamilyPaymentSystem>;
  /** fetch data from the table: "provider_fee" */
  provider_fee: Array<ProviderFee>;
  /** fetch aggregated fields from the table: "provider_fee" */
  provider_fee_aggregate: ProviderFeeAggregate;
  /** fetch data from the table: "provider_fee" using primary key columns */
  provider_fee_by_pk?: Maybe<ProviderFee>;
  /** fetch data from the table: "provider_limit" */
  provider_limit: Array<ProviderLimit>;
  /** fetch aggregated fields from the table: "provider_limit" */
  provider_limit_aggregate: ProviderLimitAggregate;
  /** fetch data from the table: "provider_limit" using primary key columns */
  provider_limit_by_pk?: Maybe<ProviderLimit>;
  /** fetch data from the table: "provider_payment_system" */
  provider_payment_system: Array<ProviderPaymentSystem>;
  /** fetch aggregated fields from the table: "provider_payment_system" */
  provider_payment_system_aggregate: ProviderPaymentSystemAggregate;
  /** fetch data from the table: "provider_payment_system" using primary key columns */
  provider_payment_system_by_pk?: Maybe<ProviderPaymentSystem>;
  /** fetch data from the table: "provider_status" */
  provider_status: Array<ProviderStatus>;
  /** fetch aggregated fields from the table: "provider_status" */
  provider_status_aggregate: ProviderStatusAggregate;
  /** fetch data from the table: "provider_status" using primary key columns */
  provider_status_by_pk?: Maybe<ProviderStatus>;
  /** fetch data from the table: "refund_request_status" */
  refund_request_status: Array<RefundRequestStatus>;
  /** fetch aggregated fields from the table: "refund_request_status" */
  refund_request_status_aggregate: RefundRequestStatusAggregate;
  /** fetch data from the table: "refund_request_status" using primary key columns */
  refund_request_status_by_pk?: Maybe<RefundRequestStatus>;
  /** fetch data from the table: "refund_table" */
  refund_table: Array<RefundTable>;
  /** fetch aggregated fields from the table: "refund_table" */
  refund_table_aggregate: RefundTableAggregate;
  /** fetch data from the table: "refund_table" using primary key columns */
  refund_table_by_pk?: Maybe<RefundTable>;
  /** fetch data from the table: "registration_info" */
  registration_info: Array<RegistrationInfo>;
  /** fetch aggregated fields from the table: "registration_info" */
  registration_info_aggregate: RegistrationInfoAggregate;
  /** fetch data from the table: "registration_info" using primary key columns */
  registration_info_by_pk?: Maybe<RegistrationInfo>;
  /** fetch data from the table: "registration_status" */
  registration_status: Array<RegistrationStatus>;
  /** fetch aggregated fields from the table: "registration_status" */
  registration_status_aggregate: RegistrationStatusAggregate;
  /** fetch data from the table: "registration_status" using primary key columns */
  registration_status_by_pk?: Maybe<RegistrationStatus>;
  /** fetch data from the table: "role" */
  role: Array<Role>;
  /** fetch aggregated fields from the table: "role" */
  role_aggregate: RoleAggregate;
  /** fetch data from the table: "role" using primary key columns */
  role_by_pk?: Maybe<Role>;
  /** fetch data from the table: "rolling_reserve" */
  rolling_reserve: Array<RollingReserve>;
  /** fetch aggregated fields from the table: "rolling_reserve" */
  rolling_reserve_aggregate: RollingReserveAggregate;
  /** fetch data from the table: "rolling_reserve" using primary key columns */
  rolling_reserve_by_pk?: Maybe<RollingReserve>;
  /** fetch data from the table: "setting" */
  setting: Array<Setting>;
  /** fetch aggregated fields from the table: "setting" */
  setting_aggregate: SettingAggregate;
  /** fetch data from the table: "setting" using primary key columns */
  setting_by_pk?: Maybe<Setting>;
  /** fetch data from the table: "settlement" */
  settlement: Array<Settlement>;
  /** fetch aggregated fields from the table: "settlement" */
  settlement_aggregate: SettlementAggregate;
  /** fetch data from the table: "settlement" using primary key columns */
  settlement_by_pk?: Maybe<Settlement>;
  /** fetch data from the table: "traffic_type" */
  traffic_type: Array<TrafficType>;
  /** fetch aggregated fields from the table: "traffic_type" */
  traffic_type_aggregate: TrafficTypeAggregate;
  /** fetch data from the table: "traffic_type" using primary key columns */
  traffic_type_by_pk?: Maybe<TrafficType>;
  /** fetch data from the table: "transaction_history" */
  transaction_history: Array<TransactionHistory>;
  /** fetch aggregated fields from the table: "transaction_history" */
  transaction_history_aggregate: TransactionHistoryAggregate;
  /** fetch data from the table: "transaction_history" using primary key columns */
  transaction_history_by_pk?: Maybe<TransactionHistory>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch data from the table: "user_activate_token" */
  user_activate_token: Array<UserActivateToken>;
  /** fetch aggregated fields from the table: "user_activate_token" */
  user_activate_token_aggregate: UserActivateTokenAggregate;
  /** fetch data from the table: "user_activate_token" using primary key columns */
  user_activate_token_by_pk?: Maybe<UserActivateToken>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: UserAggregate;
  /** fetch data from the table: "user_audit" */
  user_audit: Array<UserAudit>;
  /** fetch aggregated fields from the table: "user_audit" */
  user_audit_aggregate: UserAuditAggregate;
  /** fetch data from the table: "user_audit" using primary key columns */
  user_audit_by_pk?: Maybe<UserAudit>;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table: "user_info" */
  user_info: Array<UserInfo>;
  /** fetch aggregated fields from the table: "user_info" */
  user_info_aggregate: UserInfoAggregate;
  /** fetch data from the table: "user_info" using primary key columns */
  user_info_by_pk?: Maybe<UserInfo>;
  /** fetch data from the table: "user_reports" */
  user_reports: Array<UserReports>;
  /** fetch aggregated fields from the table: "user_reports" */
  user_reports_aggregate: UserReportsAggregate;
  /** fetch data from the table: "user_reports" using primary key columns */
  user_reports_by_pk?: Maybe<UserReports>;
  /** fetch data from the table: "v_active_gate" */
  v_active_gate: Array<VActiveGate>;
  /** fetch aggregated fields from the table: "v_active_gate" */
  v_active_gate_aggregate: VActiveGateAggregate;
  /** fetch data from the table: "v_active_provider" */
  v_active_provider: Array<VActiveProvider>;
  /** fetch aggregated fields from the table: "v_active_provider" */
  v_active_provider_aggregate: VActiveProviderAggregate;
  /** fetch data from the table: "v_active_rolling_reserve" */
  v_active_rolling_reserve: Array<VActiveRollingReserve>;
  /** fetch aggregated fields from the table: "v_active_rolling_reserve" */
  v_active_rolling_reserve_aggregate: VActiveRollingReserveAggregate;
  /** fetch data from the table: "v_admin_chargeback" */
  v_admin_chargeback: Array<VAdminChargeback>;
  /** fetch aggregated fields from the table: "v_admin_chargeback" */
  v_admin_chargeback_aggregate: VAdminChargebackAggregate;
  /** fetch data from the table: "v_admin_gate_list" */
  v_admin_gate_list: Array<VAdminGateList>;
  /** fetch aggregated fields from the table: "v_admin_gate_list" */
  v_admin_gate_list_aggregate: VAdminGateListAggregate;
  /** fetch data from the table: "v_admin_merchant_list" */
  v_admin_merchant_list: Array<VAdminMerchantList>;
  /** fetch aggregated fields from the table: "v_admin_merchant_list" */
  v_admin_merchant_list_aggregate: VAdminMerchantListAggregate;
  /** fetch data from the table: "v_admin_monitoring" */
  v_admin_monitoring: Array<VAdminMonitoring>;
  /** fetch aggregated fields from the table: "v_admin_monitoring" */
  v_admin_monitoring_aggregate: VAdminMonitoringAggregate;
  /** fetch data from the table: "v_admin_payment_system_provider" */
  v_admin_payment_system_provider: Array<VAdminPaymentSystemProvider>;
  /** fetch aggregated fields from the table: "v_admin_payment_system_provider" */
  v_admin_payment_system_provider_aggregate: VAdminPaymentSystemProviderAggregate;
  /** fetch data from the table: "v_admin_refund" */
  v_admin_refund: Array<VAdminRefund>;
  /** fetch aggregated fields from the table: "v_admin_refund" */
  v_admin_refund_aggregate: VAdminRefundAggregate;
  /** fetch data from the table: "v_admin_withdraw_request" */
  v_admin_withdraw_request: Array<VAdminWithdrawRequest>;
  /** fetch aggregated fields from the table: "v_admin_withdraw_request" */
  v_admin_withdraw_request_aggregate: VAdminWithdrawRequestAggregate;
  /** fetch data from the table: "v_gate_group_balance" */
  v_gate_group_balance: Array<VGateGroupBalance>;
  /** fetch aggregated fields from the table: "v_gate_group_balance" */
  v_gate_group_balance_aggregate: VGateGroupBalanceAggregate;
  /** fetch data from the table: "v_hasura_permission" */
  v_hasura_permission: Array<VHasuraPermission>;
  /** fetch aggregated fields from the table: "v_hasura_permission" */
  v_hasura_permission_aggregate: VHasuraPermissionAggregate;
  /** fetch data from the table: "v_lk_chargeback" */
  v_lk_chargeback: Array<VLkChargeback>;
  /** fetch aggregated fields from the table: "v_lk_chargeback" */
  v_lk_chargeback_aggregate: VLkChargebackAggregate;
  /** fetch data from the table: "v_lk_gate_fee" */
  v_lk_gate_fee: Array<VLkGateFee>;
  /** fetch aggregated fields from the table: "v_lk_gate_fee" */
  v_lk_gate_fee_aggregate: VLkGateFeeAggregate;
  /** fetch data from the table: "widget_type" */
  widget_type: Array<WidgetType>;
  /** fetch aggregated fields from the table: "widget_type" */
  widget_type_aggregate: WidgetTypeAggregate;
  /** fetch data from the table: "widget_type" using primary key columns */
  widget_type_by_pk?: Maybe<WidgetType>;
  /** fetch data from the table: "withdraw" */
  withdraw: Array<Withdraw>;
  /** fetch aggregated fields from the table: "withdraw" */
  withdraw_aggregate: WithdrawAggregate;
  /** fetch data from the table: "withdraw" using primary key columns */
  withdraw_by_pk?: Maybe<Withdraw>;
  /** fetch data from the table: "withdraw_request" */
  withdraw_request: Array<WithdrawRequest>;
  /** fetch aggregated fields from the table: "withdraw_request" */
  withdraw_request_aggregate: WithdrawRequestAggregate;
  /** fetch data from the table: "withdraw_request" using primary key columns */
  withdraw_request_by_pk?: Maybe<WithdrawRequest>;
  /** fetch data from the table: "withdraw_request_status" */
  withdraw_request_status: Array<WithdrawRequestStatus>;
  /** fetch aggregated fields from the table: "withdraw_request_status" */
  withdraw_request_status_aggregate: WithdrawRequestStatusAggregate;
  /** fetch data from the table: "withdraw_request_status" using primary key columns */
  withdraw_request_status_by_pk?: Maybe<WithdrawRequestStatus>;
};


export type SubscriptionRootAuditArgs = {
  distinct_on?: InputMaybe<Array<AuditSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuditOrderBy>>;
  where?: InputMaybe<AuditBoolExp>;
};


export type SubscriptionRootAuditAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuditSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuditOrderBy>>;
  where?: InputMaybe<AuditBoolExp>;
};


export type SubscriptionRootAuditByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootBlacklistArgs = {
  distinct_on?: InputMaybe<Array<BlacklistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BlacklistOrderBy>>;
  where?: InputMaybe<BlacklistBoolExp>;
};


export type SubscriptionRootBlacklistAggregateArgs = {
  distinct_on?: InputMaybe<Array<BlacklistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BlacklistOrderBy>>;
  where?: InputMaybe<BlacklistBoolExp>;
};


export type SubscriptionRootBlacklistByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootCardSystemArgs = {
  distinct_on?: InputMaybe<Array<CardSystemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CardSystemOrderBy>>;
  where?: InputMaybe<CardSystemBoolExp>;
};


export type SubscriptionRootCardSystemAggregateArgs = {
  distinct_on?: InputMaybe<Array<CardSystemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CardSystemOrderBy>>;
  where?: InputMaybe<CardSystemBoolExp>;
};


export type SubscriptionRootCardSystemByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootCascadeItemArgs = {
  distinct_on?: InputMaybe<Array<CascadeItemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CascadeItemOrderBy>>;
  where?: InputMaybe<CascadeItemBoolExp>;
};


export type SubscriptionRootCascadeItemAggregateArgs = {
  distinct_on?: InputMaybe<Array<CascadeItemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CascadeItemOrderBy>>;
  where?: InputMaybe<CascadeItemBoolExp>;
};


export type SubscriptionRootCascadeItemByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootCascadeRequestArgs = {
  distinct_on?: InputMaybe<Array<CascadeRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CascadeRequestOrderBy>>;
  where?: InputMaybe<CascadeRequestBoolExp>;
};


export type SubscriptionRootCascadeRequestAggregateArgs = {
  distinct_on?: InputMaybe<Array<CascadeRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CascadeRequestOrderBy>>;
  where?: InputMaybe<CascadeRequestBoolExp>;
};


export type SubscriptionRootCascadeRequestByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootCascadesArgs = {
  distinct_on?: InputMaybe<Array<CascadesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CascadesOrderBy>>;
  where?: InputMaybe<CascadesBoolExp>;
};


export type SubscriptionRootCascadesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CascadesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CascadesOrderBy>>;
  where?: InputMaybe<CascadesBoolExp>;
};


export type SubscriptionRootCascadesByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootCountryArgs = {
  distinct_on?: InputMaybe<Array<CountrySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CountryOrderBy>>;
  where?: InputMaybe<CountryBoolExp>;
};


export type SubscriptionRootCountryAggregateArgs = {
  distinct_on?: InputMaybe<Array<CountrySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CountryOrderBy>>;
  where?: InputMaybe<CountryBoolExp>;
};


export type SubscriptionRootCountryByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootCountryRegionArgs = {
  distinct_on?: InputMaybe<Array<CountryRegionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CountryRegionOrderBy>>;
  where?: InputMaybe<CountryRegionBoolExp>;
};


export type SubscriptionRootCountryRegionAggregateArgs = {
  distinct_on?: InputMaybe<Array<CountryRegionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CountryRegionOrderBy>>;
  where?: InputMaybe<CountryRegionBoolExp>;
};


export type SubscriptionRootCountryRegionByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootCryptoCurrencyArgs = {
  distinct_on?: InputMaybe<Array<CryptoCurrencySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CryptoCurrencyOrderBy>>;
  where?: InputMaybe<CryptoCurrencyBoolExp>;
};


export type SubscriptionRootCryptoCurrencyAggregateArgs = {
  distinct_on?: InputMaybe<Array<CryptoCurrencySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CryptoCurrencyOrderBy>>;
  where?: InputMaybe<CryptoCurrencyBoolExp>;
};


export type SubscriptionRootCryptoCurrencyByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootCryptoWithdrawRequestArgs = {
  distinct_on?: InputMaybe<Array<CryptoWithdrawRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CryptoWithdrawRequestOrderBy>>;
  where?: InputMaybe<CryptoWithdrawRequestBoolExp>;
};


export type SubscriptionRootCryptoWithdrawRequestAggregateArgs = {
  distinct_on?: InputMaybe<Array<CryptoWithdrawRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CryptoWithdrawRequestOrderBy>>;
  where?: InputMaybe<CryptoWithdrawRequestBoolExp>;
};


export type SubscriptionRootCryptoWithdrawRequestByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootCryptoWithdrawRequestStatusArgs = {
  distinct_on?: InputMaybe<Array<CryptoWithdrawRequestStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CryptoWithdrawRequestStatusOrderBy>>;
  where?: InputMaybe<CryptoWithdrawRequestStatusBoolExp>;
};


export type SubscriptionRootCryptoWithdrawRequestStatusAggregateArgs = {
  distinct_on?: InputMaybe<Array<CryptoWithdrawRequestStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CryptoWithdrawRequestStatusOrderBy>>;
  where?: InputMaybe<CryptoWithdrawRequestStatusBoolExp>;
};


export type SubscriptionRootCryptoWithdrawRequestStatusByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootCurrencyArgs = {
  distinct_on?: InputMaybe<Array<CurrencySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CurrencyOrderBy>>;
  where?: InputMaybe<CurrencyBoolExp>;
};


export type SubscriptionRootCurrencyAggregateArgs = {
  distinct_on?: InputMaybe<Array<CurrencySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CurrencyOrderBy>>;
  where?: InputMaybe<CurrencyBoolExp>;
};


export type SubscriptionRootCurrencyByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootGateArgs = {
  distinct_on?: InputMaybe<Array<GateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GateOrderBy>>;
  where?: InputMaybe<GateBoolExp>;
};


export type SubscriptionRootGateAggregateArgs = {
  distinct_on?: InputMaybe<Array<GateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GateOrderBy>>;
  where?: InputMaybe<GateBoolExp>;
};


export type SubscriptionRootGateByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootGateGroupArgs = {
  distinct_on?: InputMaybe<Array<GateGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GateGroupOrderBy>>;
  where?: InputMaybe<GateGroupBoolExp>;
};


export type SubscriptionRootGateGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<GateGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GateGroupOrderBy>>;
  where?: InputMaybe<GateGroupBoolExp>;
};


export type SubscriptionRootGateGroupByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootGateTypeArgs = {
  distinct_on?: InputMaybe<Array<GateTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GateTypeOrderBy>>;
  where?: InputMaybe<GateTypeBoolExp>;
};


export type SubscriptionRootGateTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<GateTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GateTypeOrderBy>>;
  where?: InputMaybe<GateTypeBoolExp>;
};


export type SubscriptionRootGateTypeByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootGenderArgs = {
  distinct_on?: InputMaybe<Array<GenderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GenderOrderBy>>;
  where?: InputMaybe<GenderBoolExp>;
};


export type SubscriptionRootGenderAggregateArgs = {
  distinct_on?: InputMaybe<Array<GenderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GenderOrderBy>>;
  where?: InputMaybe<GenderBoolExp>;
};


export type SubscriptionRootGenderByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootHelpArgs = {
  distinct_on?: InputMaybe<Array<HelpSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<HelpOrderBy>>;
  where?: InputMaybe<HelpBoolExp>;
};


export type SubscriptionRootHelpAggregateArgs = {
  distinct_on?: InputMaybe<Array<HelpSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<HelpOrderBy>>;
  where?: InputMaybe<HelpBoolExp>;
};


export type SubscriptionRootHelpByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootHelpSectionArgs = {
  distinct_on?: InputMaybe<Array<HelpSectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<HelpSectionOrderBy>>;
  where?: InputMaybe<HelpSectionBoolExp>;
};


export type SubscriptionRootHelpSectionAggregateArgs = {
  distinct_on?: InputMaybe<Array<HelpSectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<HelpSectionOrderBy>>;
  where?: InputMaybe<HelpSectionBoolExp>;
};


export type SubscriptionRootHelpSectionByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootInvoiceArgs = {
  distinct_on?: InputMaybe<Array<InvoiceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InvoiceOrderBy>>;
  where?: InputMaybe<InvoiceBoolExp>;
};


export type SubscriptionRootInvoiceAggregateArgs = {
  distinct_on?: InputMaybe<Array<InvoiceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InvoiceOrderBy>>;
  where?: InputMaybe<InvoiceBoolExp>;
};


export type SubscriptionRootInvoiceByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootLanguageArgs = {
  distinct_on?: InputMaybe<Array<LanguageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LanguageOrderBy>>;
  where?: InputMaybe<LanguageBoolExp>;
};


export type SubscriptionRootLanguageAggregateArgs = {
  distinct_on?: InputMaybe<Array<LanguageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LanguageOrderBy>>;
  where?: InputMaybe<LanguageBoolExp>;
};


export type SubscriptionRootLanguageByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootMerchantArgs = {
  distinct_on?: InputMaybe<Array<MerchantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantOrderBy>>;
  where?: InputMaybe<MerchantBoolExp>;
};


export type SubscriptionRootMerchantAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantOrderBy>>;
  where?: InputMaybe<MerchantBoolExp>;
};


export type SubscriptionRootMerchantApiTokenArgs = {
  distinct_on?: InputMaybe<Array<MerchantApiTokenSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantApiTokenOrderBy>>;
  where?: InputMaybe<MerchantApiTokenBoolExp>;
};


export type SubscriptionRootMerchantApiTokenAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantApiTokenSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantApiTokenOrderBy>>;
  where?: InputMaybe<MerchantApiTokenBoolExp>;
};


export type SubscriptionRootMerchantApiTokenByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootMerchantBalanceArgs = {
  distinct_on?: InputMaybe<Array<MerchantBalanceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantBalanceOrderBy>>;
  where?: InputMaybe<MerchantBalanceBoolExp>;
};


export type SubscriptionRootMerchantBalanceAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantBalanceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantBalanceOrderBy>>;
  where?: InputMaybe<MerchantBalanceBoolExp>;
};


export type SubscriptionRootMerchantBalanceByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootMerchantByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootMerchantCurrencyArgs = {
  distinct_on?: InputMaybe<Array<MerchantCurrencySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantCurrencyOrderBy>>;
  where?: InputMaybe<MerchantCurrencyBoolExp>;
};


export type SubscriptionRootMerchantCurrencyAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantCurrencySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantCurrencyOrderBy>>;
  where?: InputMaybe<MerchantCurrencyBoolExp>;
};


export type SubscriptionRootMerchantCurrencyByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootMerchantFeeArgs = {
  distinct_on?: InputMaybe<Array<MerchantFeeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantFeeOrderBy>>;
  where?: InputMaybe<MerchantFeeBoolExp>;
};


export type SubscriptionRootMerchantFeeAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantFeeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantFeeOrderBy>>;
  where?: InputMaybe<MerchantFeeBoolExp>;
};


export type SubscriptionRootMerchantFeeByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootMerchantFileArgs = {
  distinct_on?: InputMaybe<Array<MerchantFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantFileOrderBy>>;
  where?: InputMaybe<MerchantFileBoolExp>;
};


export type SubscriptionRootMerchantFileAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantFileOrderBy>>;
  where?: InputMaybe<MerchantFileBoolExp>;
};


export type SubscriptionRootMerchantFileByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootMerchantInfoArgs = {
  distinct_on?: InputMaybe<Array<MerchantInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantInfoOrderBy>>;
  where?: InputMaybe<MerchantInfoBoolExp>;
};


export type SubscriptionRootMerchantInfoAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantInfoOrderBy>>;
  where?: InputMaybe<MerchantInfoBoolExp>;
};


export type SubscriptionRootMerchantInfoByPkArgs = {
  merchant_id: Scalars['Int'];
};


export type SubscriptionRootMerchantNotificationArgs = {
  distinct_on?: InputMaybe<Array<MerchantNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantNotificationOrderBy>>;
  where?: InputMaybe<MerchantNotificationBoolExp>;
};


export type SubscriptionRootMerchantNotificationAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantNotificationOrderBy>>;
  where?: InputMaybe<MerchantNotificationBoolExp>;
};


export type SubscriptionRootMerchantNotificationByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootMerchantTaskArgs = {
  distinct_on?: InputMaybe<Array<MerchantTaskSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantTaskOrderBy>>;
  where?: InputMaybe<MerchantTaskBoolExp>;
};


export type SubscriptionRootMerchantTaskAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantTaskSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantTaskOrderBy>>;
  where?: InputMaybe<MerchantTaskBoolExp>;
};


export type SubscriptionRootMerchantTaskByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootMerchantTaskStatusArgs = {
  distinct_on?: InputMaybe<Array<MerchantTaskStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantTaskStatusOrderBy>>;
  where?: InputMaybe<MerchantTaskStatusBoolExp>;
};


export type SubscriptionRootMerchantTaskStatusAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantTaskStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantTaskStatusOrderBy>>;
  where?: InputMaybe<MerchantTaskStatusBoolExp>;
};


export type SubscriptionRootMerchantTaskStatusByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootMerchantTaskTypeArgs = {
  distinct_on?: InputMaybe<Array<MerchantTaskTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantTaskTypeOrderBy>>;
  where?: InputMaybe<MerchantTaskTypeBoolExp>;
};


export type SubscriptionRootMerchantTaskTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantTaskTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantTaskTypeOrderBy>>;
  where?: InputMaybe<MerchantTaskTypeBoolExp>;
};


export type SubscriptionRootMerchantTaskTypeByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootMerchantTypeArgs = {
  distinct_on?: InputMaybe<Array<MerchantTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantTypeOrderBy>>;
  where?: InputMaybe<MerchantTypeBoolExp>;
};


export type SubscriptionRootMerchantTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantTypeOrderBy>>;
  where?: InputMaybe<MerchantTypeBoolExp>;
};


export type SubscriptionRootMerchantTypeByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootMerchantUserArgs = {
  distinct_on?: InputMaybe<Array<MerchantUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantUserOrderBy>>;
  where?: InputMaybe<MerchantUserBoolExp>;
};


export type SubscriptionRootMerchantUserAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantUserOrderBy>>;
  where?: InputMaybe<MerchantUserBoolExp>;
};


export type SubscriptionRootMerchantUserByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootMerchantUserRoleArgs = {
  distinct_on?: InputMaybe<Array<MerchantUserRoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantUserRoleOrderBy>>;
  where?: InputMaybe<MerchantUserRoleBoolExp>;
};


export type SubscriptionRootMerchantUserRoleAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantUserRoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantUserRoleOrderBy>>;
  where?: InputMaybe<MerchantUserRoleBoolExp>;
};


export type SubscriptionRootMerchantUserRoleByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootMerchantWidgetArgs = {
  distinct_on?: InputMaybe<Array<MerchantWidgetSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantWidgetOrderBy>>;
  where?: InputMaybe<MerchantWidgetBoolExp>;
};


export type SubscriptionRootMerchantWidgetAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantWidgetSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantWidgetOrderBy>>;
  where?: InputMaybe<MerchantWidgetBoolExp>;
};


export type SubscriptionRootMerchantWidgetByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootMutexArgs = {
  distinct_on?: InputMaybe<Array<MutexSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MutexOrderBy>>;
  where?: InputMaybe<MutexBoolExp>;
};


export type SubscriptionRootMutexAggregateArgs = {
  distinct_on?: InputMaybe<Array<MutexSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MutexOrderBy>>;
  where?: InputMaybe<MutexBoolExp>;
};


export type SubscriptionRootMutexByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootNotificationTypeArgs = {
  distinct_on?: InputMaybe<Array<NotificationTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationTypeOrderBy>>;
  where?: InputMaybe<NotificationTypeBoolExp>;
};


export type SubscriptionRootNotificationTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationTypeOrderBy>>;
  where?: InputMaybe<NotificationTypeBoolExp>;
};


export type SubscriptionRootNotificationTypeByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootPaymentSystemArgs = {
  distinct_on?: InputMaybe<Array<PaymentSystemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentSystemOrderBy>>;
  where?: InputMaybe<PaymentSystemBoolExp>;
};


export type SubscriptionRootPaymentSystemAggregateArgs = {
  distinct_on?: InputMaybe<Array<PaymentSystemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentSystemOrderBy>>;
  where?: InputMaybe<PaymentSystemBoolExp>;
};


export type SubscriptionRootPaymentSystemByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootProfitProviderArgs = {
  distinct_on?: InputMaybe<Array<ProfitProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProfitProviderOrderBy>>;
  where?: InputMaybe<ProfitProviderBoolExp>;
};


export type SubscriptionRootProfitProviderAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProfitProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProfitProviderOrderBy>>;
  where?: InputMaybe<ProfitProviderBoolExp>;
};


export type SubscriptionRootProfitProviderByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootProfitWithdrawArgs = {
  distinct_on?: InputMaybe<Array<ProfitWithdrawSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProfitWithdrawOrderBy>>;
  where?: InputMaybe<ProfitWithdrawBoolExp>;
};


export type SubscriptionRootProfitWithdrawAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProfitWithdrawSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProfitWithdrawOrderBy>>;
  where?: InputMaybe<ProfitWithdrawBoolExp>;
};


export type SubscriptionRootProfitWithdrawByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootProviderArgs = {
  distinct_on?: InputMaybe<Array<ProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderOrderBy>>;
  where?: InputMaybe<ProviderBoolExp>;
};


export type SubscriptionRootProviderAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderOrderBy>>;
  where?: InputMaybe<ProviderBoolExp>;
};


export type SubscriptionRootProviderByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootProviderCountryArgs = {
  distinct_on?: InputMaybe<Array<ProviderCountrySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderCountryOrderBy>>;
  where?: InputMaybe<ProviderCountryBoolExp>;
};


export type SubscriptionRootProviderCountryAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderCountrySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderCountryOrderBy>>;
  where?: InputMaybe<ProviderCountryBoolExp>;
};


export type SubscriptionRootProviderCountryByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootProviderCountryStateArgs = {
  distinct_on?: InputMaybe<Array<ProviderCountryStateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderCountryStateOrderBy>>;
  where?: InputMaybe<ProviderCountryStateBoolExp>;
};


export type SubscriptionRootProviderCountryStateAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderCountryStateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderCountryStateOrderBy>>;
  where?: InputMaybe<ProviderCountryStateBoolExp>;
};


export type SubscriptionRootProviderCountryStateByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootProviderFamilyArgs = {
  distinct_on?: InputMaybe<Array<ProviderFamilySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderFamilyOrderBy>>;
  where?: InputMaybe<ProviderFamilyBoolExp>;
};


export type SubscriptionRootProviderFamilyAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderFamilySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderFamilyOrderBy>>;
  where?: InputMaybe<ProviderFamilyBoolExp>;
};


export type SubscriptionRootProviderFamilyByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootProviderFamilyPaymentSystemArgs = {
  distinct_on?: InputMaybe<Array<ProviderFamilyPaymentSystemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderFamilyPaymentSystemOrderBy>>;
  where?: InputMaybe<ProviderFamilyPaymentSystemBoolExp>;
};


export type SubscriptionRootProviderFamilyPaymentSystemAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderFamilyPaymentSystemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderFamilyPaymentSystemOrderBy>>;
  where?: InputMaybe<ProviderFamilyPaymentSystemBoolExp>;
};


export type SubscriptionRootProviderFamilyPaymentSystemByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootProviderFeeArgs = {
  distinct_on?: InputMaybe<Array<ProviderFeeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderFeeOrderBy>>;
  where?: InputMaybe<ProviderFeeBoolExp>;
};


export type SubscriptionRootProviderFeeAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderFeeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderFeeOrderBy>>;
  where?: InputMaybe<ProviderFeeBoolExp>;
};


export type SubscriptionRootProviderFeeByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootProviderLimitArgs = {
  distinct_on?: InputMaybe<Array<ProviderLimitSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderLimitOrderBy>>;
  where?: InputMaybe<ProviderLimitBoolExp>;
};


export type SubscriptionRootProviderLimitAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderLimitSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderLimitOrderBy>>;
  where?: InputMaybe<ProviderLimitBoolExp>;
};


export type SubscriptionRootProviderLimitByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootProviderPaymentSystemArgs = {
  distinct_on?: InputMaybe<Array<ProviderPaymentSystemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderPaymentSystemOrderBy>>;
  where?: InputMaybe<ProviderPaymentSystemBoolExp>;
};


export type SubscriptionRootProviderPaymentSystemAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderPaymentSystemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderPaymentSystemOrderBy>>;
  where?: InputMaybe<ProviderPaymentSystemBoolExp>;
};


export type SubscriptionRootProviderPaymentSystemByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootProviderStatusArgs = {
  distinct_on?: InputMaybe<Array<ProviderStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderStatusOrderBy>>;
  where?: InputMaybe<ProviderStatusBoolExp>;
};


export type SubscriptionRootProviderStatusAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderStatusOrderBy>>;
  where?: InputMaybe<ProviderStatusBoolExp>;
};


export type SubscriptionRootProviderStatusByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootRefundRequestStatusArgs = {
  distinct_on?: InputMaybe<Array<RefundRequestStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RefundRequestStatusOrderBy>>;
  where?: InputMaybe<RefundRequestStatusBoolExp>;
};


export type SubscriptionRootRefundRequestStatusAggregateArgs = {
  distinct_on?: InputMaybe<Array<RefundRequestStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RefundRequestStatusOrderBy>>;
  where?: InputMaybe<RefundRequestStatusBoolExp>;
};


export type SubscriptionRootRefundRequestStatusByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootRefundTableArgs = {
  distinct_on?: InputMaybe<Array<RefundTableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RefundTableOrderBy>>;
  where?: InputMaybe<RefundTableBoolExp>;
};


export type SubscriptionRootRefundTableAggregateArgs = {
  distinct_on?: InputMaybe<Array<RefundTableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RefundTableOrderBy>>;
  where?: InputMaybe<RefundTableBoolExp>;
};


export type SubscriptionRootRefundTableByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootRegistrationInfoArgs = {
  distinct_on?: InputMaybe<Array<RegistrationInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RegistrationInfoOrderBy>>;
  where?: InputMaybe<RegistrationInfoBoolExp>;
};


export type SubscriptionRootRegistrationInfoAggregateArgs = {
  distinct_on?: InputMaybe<Array<RegistrationInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RegistrationInfoOrderBy>>;
  where?: InputMaybe<RegistrationInfoBoolExp>;
};


export type SubscriptionRootRegistrationInfoByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootRegistrationStatusArgs = {
  distinct_on?: InputMaybe<Array<RegistrationStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RegistrationStatusOrderBy>>;
  where?: InputMaybe<RegistrationStatusBoolExp>;
};


export type SubscriptionRootRegistrationStatusAggregateArgs = {
  distinct_on?: InputMaybe<Array<RegistrationStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RegistrationStatusOrderBy>>;
  where?: InputMaybe<RegistrationStatusBoolExp>;
};


export type SubscriptionRootRegistrationStatusByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootRoleArgs = {
  distinct_on?: InputMaybe<Array<RoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RoleOrderBy>>;
  where?: InputMaybe<RoleBoolExp>;
};


export type SubscriptionRootRoleAggregateArgs = {
  distinct_on?: InputMaybe<Array<RoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RoleOrderBy>>;
  where?: InputMaybe<RoleBoolExp>;
};


export type SubscriptionRootRoleByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootRollingReserveArgs = {
  distinct_on?: InputMaybe<Array<RollingReserveSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RollingReserveOrderBy>>;
  where?: InputMaybe<RollingReserveBoolExp>;
};


export type SubscriptionRootRollingReserveAggregateArgs = {
  distinct_on?: InputMaybe<Array<RollingReserveSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RollingReserveOrderBy>>;
  where?: InputMaybe<RollingReserveBoolExp>;
};


export type SubscriptionRootRollingReserveByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootSettingArgs = {
  distinct_on?: InputMaybe<Array<SettingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SettingOrderBy>>;
  where?: InputMaybe<SettingBoolExp>;
};


export type SubscriptionRootSettingAggregateArgs = {
  distinct_on?: InputMaybe<Array<SettingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SettingOrderBy>>;
  where?: InputMaybe<SettingBoolExp>;
};


export type SubscriptionRootSettingByPkArgs = {
  key: Scalars['String'];
};


export type SubscriptionRootSettlementArgs = {
  distinct_on?: InputMaybe<Array<SettlementSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SettlementOrderBy>>;
  where?: InputMaybe<SettlementBoolExp>;
};


export type SubscriptionRootSettlementAggregateArgs = {
  distinct_on?: InputMaybe<Array<SettlementSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SettlementOrderBy>>;
  where?: InputMaybe<SettlementBoolExp>;
};


export type SubscriptionRootSettlementByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootTrafficTypeArgs = {
  distinct_on?: InputMaybe<Array<TrafficTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TrafficTypeOrderBy>>;
  where?: InputMaybe<TrafficTypeBoolExp>;
};


export type SubscriptionRootTrafficTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<TrafficTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TrafficTypeOrderBy>>;
  where?: InputMaybe<TrafficTypeBoolExp>;
};


export type SubscriptionRootTrafficTypeByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootTransactionHistoryArgs = {
  distinct_on?: InputMaybe<Array<TransactionHistorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TransactionHistoryOrderBy>>;
  where?: InputMaybe<TransactionHistoryBoolExp>;
};


export type SubscriptionRootTransactionHistoryAggregateArgs = {
  distinct_on?: InputMaybe<Array<TransactionHistorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TransactionHistoryOrderBy>>;
  where?: InputMaybe<TransactionHistoryBoolExp>;
};


export type SubscriptionRootTransactionHistoryByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootUserArgs = {
  distinct_on?: InputMaybe<Array<UserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserOrderBy>>;
  where?: InputMaybe<UserBoolExp>;
};


export type SubscriptionRootUserActivateTokenArgs = {
  distinct_on?: InputMaybe<Array<UserActivateTokenSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserActivateTokenOrderBy>>;
  where?: InputMaybe<UserActivateTokenBoolExp>;
};


export type SubscriptionRootUserActivateTokenAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserActivateTokenSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserActivateTokenOrderBy>>;
  where?: InputMaybe<UserActivateTokenBoolExp>;
};


export type SubscriptionRootUserActivateTokenByPkArgs = {
  token: Scalars['String'];
};


export type SubscriptionRootUserAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserOrderBy>>;
  where?: InputMaybe<UserBoolExp>;
};


export type SubscriptionRootUserAuditArgs = {
  distinct_on?: InputMaybe<Array<UserAuditSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserAuditOrderBy>>;
  where?: InputMaybe<UserAuditBoolExp>;
};


export type SubscriptionRootUserAuditAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserAuditSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserAuditOrderBy>>;
  where?: InputMaybe<UserAuditBoolExp>;
};


export type SubscriptionRootUserAuditByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootUserByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootUserInfoArgs = {
  distinct_on?: InputMaybe<Array<UserInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserInfoOrderBy>>;
  where?: InputMaybe<UserInfoBoolExp>;
};


export type SubscriptionRootUserInfoAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserInfoOrderBy>>;
  where?: InputMaybe<UserInfoBoolExp>;
};


export type SubscriptionRootUserInfoByPkArgs = {
  user_id: Scalars['Int'];
};


export type SubscriptionRootUserReportsArgs = {
  distinct_on?: InputMaybe<Array<UserReportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserReportsOrderBy>>;
  where?: InputMaybe<UserReportsBoolExp>;
};


export type SubscriptionRootUserReportsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserReportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserReportsOrderBy>>;
  where?: InputMaybe<UserReportsBoolExp>;
};


export type SubscriptionRootUserReportsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootVActiveGateArgs = {
  distinct_on?: InputMaybe<Array<VActiveGateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VActiveGateOrderBy>>;
  where?: InputMaybe<VActiveGateBoolExp>;
};


export type SubscriptionRootVActiveGateAggregateArgs = {
  distinct_on?: InputMaybe<Array<VActiveGateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VActiveGateOrderBy>>;
  where?: InputMaybe<VActiveGateBoolExp>;
};


export type SubscriptionRootVActiveProviderArgs = {
  distinct_on?: InputMaybe<Array<VActiveProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VActiveProviderOrderBy>>;
  where?: InputMaybe<VActiveProviderBoolExp>;
};


export type SubscriptionRootVActiveProviderAggregateArgs = {
  distinct_on?: InputMaybe<Array<VActiveProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VActiveProviderOrderBy>>;
  where?: InputMaybe<VActiveProviderBoolExp>;
};


export type SubscriptionRootVActiveRollingReserveArgs = {
  distinct_on?: InputMaybe<Array<VActiveRollingReserveSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VActiveRollingReserveOrderBy>>;
  where?: InputMaybe<VActiveRollingReserveBoolExp>;
};


export type SubscriptionRootVActiveRollingReserveAggregateArgs = {
  distinct_on?: InputMaybe<Array<VActiveRollingReserveSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VActiveRollingReserveOrderBy>>;
  where?: InputMaybe<VActiveRollingReserveBoolExp>;
};


export type SubscriptionRootVAdminChargebackArgs = {
  distinct_on?: InputMaybe<Array<VAdminChargebackSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminChargebackOrderBy>>;
  where?: InputMaybe<VAdminChargebackBoolExp>;
};


export type SubscriptionRootVAdminChargebackAggregateArgs = {
  distinct_on?: InputMaybe<Array<VAdminChargebackSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminChargebackOrderBy>>;
  where?: InputMaybe<VAdminChargebackBoolExp>;
};


export type SubscriptionRootVAdminGateListArgs = {
  distinct_on?: InputMaybe<Array<VAdminGateListSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminGateListOrderBy>>;
  where?: InputMaybe<VAdminGateListBoolExp>;
};


export type SubscriptionRootVAdminGateListAggregateArgs = {
  distinct_on?: InputMaybe<Array<VAdminGateListSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminGateListOrderBy>>;
  where?: InputMaybe<VAdminGateListBoolExp>;
};


export type SubscriptionRootVAdminMerchantListArgs = {
  distinct_on?: InputMaybe<Array<VAdminMerchantListSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminMerchantListOrderBy>>;
  where?: InputMaybe<VAdminMerchantListBoolExp>;
};


export type SubscriptionRootVAdminMerchantListAggregateArgs = {
  distinct_on?: InputMaybe<Array<VAdminMerchantListSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminMerchantListOrderBy>>;
  where?: InputMaybe<VAdminMerchantListBoolExp>;
};


export type SubscriptionRootVAdminMonitoringArgs = {
  distinct_on?: InputMaybe<Array<VAdminMonitoringSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminMonitoringOrderBy>>;
  where?: InputMaybe<VAdminMonitoringBoolExp>;
};


export type SubscriptionRootVAdminMonitoringAggregateArgs = {
  distinct_on?: InputMaybe<Array<VAdminMonitoringSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminMonitoringOrderBy>>;
  where?: InputMaybe<VAdminMonitoringBoolExp>;
};


export type SubscriptionRootVAdminPaymentSystemProviderArgs = {
  distinct_on?: InputMaybe<Array<VAdminPaymentSystemProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminPaymentSystemProviderOrderBy>>;
  where?: InputMaybe<VAdminPaymentSystemProviderBoolExp>;
};


export type SubscriptionRootVAdminPaymentSystemProviderAggregateArgs = {
  distinct_on?: InputMaybe<Array<VAdminPaymentSystemProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminPaymentSystemProviderOrderBy>>;
  where?: InputMaybe<VAdminPaymentSystemProviderBoolExp>;
};


export type SubscriptionRootVAdminRefundArgs = {
  distinct_on?: InputMaybe<Array<VAdminRefundSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminRefundOrderBy>>;
  where?: InputMaybe<VAdminRefundBoolExp>;
};


export type SubscriptionRootVAdminRefundAggregateArgs = {
  distinct_on?: InputMaybe<Array<VAdminRefundSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminRefundOrderBy>>;
  where?: InputMaybe<VAdminRefundBoolExp>;
};


export type SubscriptionRootVAdminWithdrawRequestArgs = {
  distinct_on?: InputMaybe<Array<VAdminWithdrawRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminWithdrawRequestOrderBy>>;
  where?: InputMaybe<VAdminWithdrawRequestBoolExp>;
};


export type SubscriptionRootVAdminWithdrawRequestAggregateArgs = {
  distinct_on?: InputMaybe<Array<VAdminWithdrawRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VAdminWithdrawRequestOrderBy>>;
  where?: InputMaybe<VAdminWithdrawRequestBoolExp>;
};


export type SubscriptionRootVGateGroupBalanceArgs = {
  distinct_on?: InputMaybe<Array<VGateGroupBalanceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VGateGroupBalanceOrderBy>>;
  where?: InputMaybe<VGateGroupBalanceBoolExp>;
};


export type SubscriptionRootVGateGroupBalanceAggregateArgs = {
  distinct_on?: InputMaybe<Array<VGateGroupBalanceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VGateGroupBalanceOrderBy>>;
  where?: InputMaybe<VGateGroupBalanceBoolExp>;
};


export type SubscriptionRootVHasuraPermissionArgs = {
  distinct_on?: InputMaybe<Array<VHasuraPermissionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VHasuraPermissionOrderBy>>;
  where?: InputMaybe<VHasuraPermissionBoolExp>;
};


export type SubscriptionRootVHasuraPermissionAggregateArgs = {
  distinct_on?: InputMaybe<Array<VHasuraPermissionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VHasuraPermissionOrderBy>>;
  where?: InputMaybe<VHasuraPermissionBoolExp>;
};


export type SubscriptionRootVLkChargebackArgs = {
  distinct_on?: InputMaybe<Array<VLkChargebackSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VLkChargebackOrderBy>>;
  where?: InputMaybe<VLkChargebackBoolExp>;
};


export type SubscriptionRootVLkChargebackAggregateArgs = {
  distinct_on?: InputMaybe<Array<VLkChargebackSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VLkChargebackOrderBy>>;
  where?: InputMaybe<VLkChargebackBoolExp>;
};


export type SubscriptionRootVLkGateFeeArgs = {
  distinct_on?: InputMaybe<Array<VLkGateFeeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VLkGateFeeOrderBy>>;
  where?: InputMaybe<VLkGateFeeBoolExp>;
};


export type SubscriptionRootVLkGateFeeAggregateArgs = {
  distinct_on?: InputMaybe<Array<VLkGateFeeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VLkGateFeeOrderBy>>;
  where?: InputMaybe<VLkGateFeeBoolExp>;
};


export type SubscriptionRootWidgetTypeArgs = {
  distinct_on?: InputMaybe<Array<WidgetTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WidgetTypeOrderBy>>;
  where?: InputMaybe<WidgetTypeBoolExp>;
};


export type SubscriptionRootWidgetTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<WidgetTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WidgetTypeOrderBy>>;
  where?: InputMaybe<WidgetTypeBoolExp>;
};


export type SubscriptionRootWidgetTypeByPkArgs = {
  id: Scalars['String'];
};


export type SubscriptionRootWithdrawArgs = {
  distinct_on?: InputMaybe<Array<WithdrawSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WithdrawOrderBy>>;
  where?: InputMaybe<WithdrawBoolExp>;
};


export type SubscriptionRootWithdrawAggregateArgs = {
  distinct_on?: InputMaybe<Array<WithdrawSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WithdrawOrderBy>>;
  where?: InputMaybe<WithdrawBoolExp>;
};


export type SubscriptionRootWithdrawByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootWithdrawRequestArgs = {
  distinct_on?: InputMaybe<Array<WithdrawRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WithdrawRequestOrderBy>>;
  where?: InputMaybe<WithdrawRequestBoolExp>;
};


export type SubscriptionRootWithdrawRequestAggregateArgs = {
  distinct_on?: InputMaybe<Array<WithdrawRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WithdrawRequestOrderBy>>;
  where?: InputMaybe<WithdrawRequestBoolExp>;
};


export type SubscriptionRootWithdrawRequestByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRootWithdrawRequestStatusArgs = {
  distinct_on?: InputMaybe<Array<WithdrawRequestStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WithdrawRequestStatusOrderBy>>;
  where?: InputMaybe<WithdrawRequestStatusBoolExp>;
};


export type SubscriptionRootWithdrawRequestStatusAggregateArgs = {
  distinct_on?: InputMaybe<Array<WithdrawRequestStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WithdrawRequestStatusOrderBy>>;
  where?: InputMaybe<WithdrawRequestStatusBoolExp>;
};


export type SubscriptionRootWithdrawRequestStatusByPkArgs = {
  id: Scalars['String'];
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TimestamptzComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "traffic_type" */
export type TrafficType = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  providers: Array<Provider>;
  /** An aggregate relationship */
  providers_aggregate: ProviderAggregate;
};


/** columns and relationships of "traffic_type" */
export type TrafficTypeProvidersArgs = {
  distinct_on?: InputMaybe<Array<ProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderOrderBy>>;
  where?: InputMaybe<ProviderBoolExp>;
};


/** columns and relationships of "traffic_type" */
export type TrafficTypeProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProviderOrderBy>>;
  where?: InputMaybe<ProviderBoolExp>;
};

/** aggregated selection of "traffic_type" */
export type TrafficTypeAggregate = {
  aggregate?: Maybe<TrafficTypeAggregateFields>;
  nodes: Array<TrafficType>;
};

/** aggregate fields of "traffic_type" */
export type TrafficTypeAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<TrafficTypeMaxFields>;
  min?: Maybe<TrafficTypeMinFields>;
};


/** aggregate fields of "traffic_type" */
export type TrafficTypeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TrafficTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "traffic_type". All fields are combined with a logical 'AND'. */
export type TrafficTypeBoolExp = {
  _and?: InputMaybe<Array<TrafficTypeBoolExp>>;
  _not?: InputMaybe<TrafficTypeBoolExp>;
  _or?: InputMaybe<Array<TrafficTypeBoolExp>>;
  id?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  providers?: InputMaybe<ProviderBoolExp>;
};

/** unique or primary key constraints on table "traffic_type" */
export enum TrafficTypeConstraint {
  /** unique or primary key constraint on columns "id" */
  TrafficTypePkey = 'traffic_type_pkey'
}

/** input type for inserting data into table "traffic_type" */
export type TrafficTypeInsertInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  providers?: InputMaybe<ProviderArrRelInsertInput>;
};

/** aggregate max on columns */
export type TrafficTypeMaxFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type TrafficTypeMinFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "traffic_type" */
export type TrafficTypeMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TrafficType>;
};

/** input type for inserting object relation for remote table "traffic_type" */
export type TrafficTypeObjRelInsertInput = {
  data: TrafficTypeInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TrafficTypeOnConflict>;
};

/** on_conflict condition type for table "traffic_type" */
export type TrafficTypeOnConflict = {
  constraint: TrafficTypeConstraint;
  update_columns?: Array<TrafficTypeUpdateColumn>;
  where?: InputMaybe<TrafficTypeBoolExp>;
};

/** Ordering options when selecting data from "traffic_type". */
export type TrafficTypeOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  providers_aggregate?: InputMaybe<ProviderAggregateOrderBy>;
};

/** primary key columns input for table: traffic_type */
export type TrafficTypePkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "traffic_type" */
export enum TrafficTypeSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "traffic_type" */
export type TrafficTypeSetInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "traffic_type" */
export enum TrafficTypeUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type TrafficTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TrafficTypeSetInput>;
  where: TrafficTypeBoolExp;
};

/** columns and relationships of "transaction_history" */
export type TransactionHistory = {
  amount: Scalars['numeric'];
  balance: Scalars['numeric'];
  bank_id?: Maybe<Scalars['String']>;
  card_system_id?: Maybe<Scalars['String']>;
  constant_invoice_fee?: Maybe<Scalars['numeric']>;
  constant_withdraw_fee?: Maybe<Scalars['numeric']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  currency: Currency;
  currency_id: Scalars['String'];
  currency_rate: Scalars['numeric'];
  currency_rate_provider_id?: Maybe<Scalars['String']>;
  frozen_withdraw_balance: Scalars['numeric'];
  gate_currency_amount: Scalars['numeric'];
  gate_currency_rate: Scalars['numeric'];
  gate_id?: Maybe<Scalars['String']>;
  hold_amount: Scalars['numeric'];
  hold_balance: Scalars['numeric'];
  id: Scalars['Int'];
  input_currency_amount: Scalars['numeric'];
  input_currency_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  merchant: Merchant;
  merchant_constant_invoice_fee?: Maybe<Scalars['numeric']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['numeric']>;
  merchant_fee: Scalars['numeric'];
  merchant_id: Scalars['Int'];
  merchant_invoice_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount: Scalars['numeric'];
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount: Scalars['numeric'];
  /** An object relationship */
  provider?: Maybe<Provider>;
  provider_fee: Scalars['numeric'];
  provider_id?: Maybe<Scalars['String']>;
  provider_transaction_uid?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  sanitized_mask?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  status_updated_at: Scalars['timestamptz'];
  transaction_uid?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

/** aggregated selection of "transaction_history" */
export type TransactionHistoryAggregate = {
  aggregate?: Maybe<TransactionHistoryAggregateFields>;
  nodes: Array<TransactionHistory>;
};

/** aggregate fields of "transaction_history" */
export type TransactionHistoryAggregateFields = {
  avg?: Maybe<TransactionHistoryAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TransactionHistoryMaxFields>;
  min?: Maybe<TransactionHistoryMinFields>;
  stddev?: Maybe<TransactionHistoryStddevFields>;
  stddev_pop?: Maybe<TransactionHistoryStddevPopFields>;
  stddev_samp?: Maybe<TransactionHistoryStddevSampFields>;
  sum?: Maybe<TransactionHistorySumFields>;
  var_pop?: Maybe<TransactionHistoryVarPopFields>;
  var_samp?: Maybe<TransactionHistoryVarSampFields>;
  variance?: Maybe<TransactionHistoryVarianceFields>;
};


/** aggregate fields of "transaction_history" */
export type TransactionHistoryAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TransactionHistorySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "transaction_history" */
export type TransactionHistoryAggregateOrderBy = {
  avg?: InputMaybe<TransactionHistoryAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<TransactionHistoryMaxOrderBy>;
  min?: InputMaybe<TransactionHistoryMinOrderBy>;
  stddev?: InputMaybe<TransactionHistoryStddevOrderBy>;
  stddev_pop?: InputMaybe<TransactionHistoryStddevPopOrderBy>;
  stddev_samp?: InputMaybe<TransactionHistoryStddevSampOrderBy>;
  sum?: InputMaybe<TransactionHistorySumOrderBy>;
  var_pop?: InputMaybe<TransactionHistoryVarPopOrderBy>;
  var_samp?: InputMaybe<TransactionHistoryVarSampOrderBy>;
  variance?: InputMaybe<TransactionHistoryVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "transaction_history" */
export type TransactionHistoryArrRelInsertInput = {
  data: Array<TransactionHistoryInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TransactionHistoryOnConflict>;
};

/** aggregate avg on columns */
export type TransactionHistoryAvgFields = {
  amount?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
  constant_invoice_fee?: Maybe<Scalars['Float']>;
  constant_withdraw_fee?: Maybe<Scalars['Float']>;
  currency_rate?: Maybe<Scalars['Float']>;
  frozen_withdraw_balance?: Maybe<Scalars['Float']>;
  gate_currency_amount?: Maybe<Scalars['Float']>;
  gate_currency_rate?: Maybe<Scalars['Float']>;
  hold_amount?: Maybe<Scalars['Float']>;
  hold_balance?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_currency_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  provider_fee?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "transaction_history" */
export type TransactionHistoryAvgOrderBy = {
  amount?: InputMaybe<OrderBy>;
  balance?: InputMaybe<OrderBy>;
  constant_invoice_fee?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  frozen_withdraw_balance?: InputMaybe<OrderBy>;
  gate_currency_amount?: InputMaybe<OrderBy>;
  gate_currency_rate?: InputMaybe<OrderBy>;
  hold_amount?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  provider_fee?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "transaction_history". All fields are combined with a logical 'AND'. */
export type TransactionHistoryBoolExp = {
  _and?: InputMaybe<Array<TransactionHistoryBoolExp>>;
  _not?: InputMaybe<TransactionHistoryBoolExp>;
  _or?: InputMaybe<Array<TransactionHistoryBoolExp>>;
  amount?: InputMaybe<NumericComparisonExp>;
  balance?: InputMaybe<NumericComparisonExp>;
  bank_id?: InputMaybe<StringComparisonExp>;
  card_system_id?: InputMaybe<StringComparisonExp>;
  constant_invoice_fee?: InputMaybe<NumericComparisonExp>;
  constant_withdraw_fee?: InputMaybe<NumericComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<CurrencyBoolExp>;
  currency_id?: InputMaybe<StringComparisonExp>;
  currency_rate?: InputMaybe<NumericComparisonExp>;
  currency_rate_provider_id?: InputMaybe<StringComparisonExp>;
  frozen_withdraw_balance?: InputMaybe<NumericComparisonExp>;
  gate_currency_amount?: InputMaybe<NumericComparisonExp>;
  gate_currency_rate?: InputMaybe<NumericComparisonExp>;
  gate_id?: InputMaybe<StringComparisonExp>;
  hold_amount?: InputMaybe<NumericComparisonExp>;
  hold_balance?: InputMaybe<NumericComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  input_currency_amount?: InputMaybe<NumericComparisonExp>;
  input_currency_id?: InputMaybe<StringComparisonExp>;
  merchant?: InputMaybe<MerchantBoolExp>;
  merchant_constant_invoice_fee?: InputMaybe<NumericComparisonExp>;
  merchant_constant_withdraw_fee?: InputMaybe<NumericComparisonExp>;
  merchant_fee?: InputMaybe<NumericComparisonExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  merchant_invoice_fee_min_amount?: InputMaybe<NumericComparisonExp>;
  merchant_invoice_fee_percent?: InputMaybe<NumericComparisonExp>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
  merchant_withdraw_fee_min_amount?: InputMaybe<NumericComparisonExp>;
  merchant_withdraw_fee_percent?: InputMaybe<NumericComparisonExp>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
  provider?: InputMaybe<ProviderBoolExp>;
  provider_fee?: InputMaybe<NumericComparisonExp>;
  provider_id?: InputMaybe<StringComparisonExp>;
  provider_transaction_uid?: InputMaybe<StringComparisonExp>;
  remark?: InputMaybe<StringComparisonExp>;
  sanitized_mask?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  status_updated_at?: InputMaybe<TimestamptzComparisonExp>;
  transaction_uid?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "transaction_history" */
export enum TransactionHistoryConstraint {
  /** unique or primary key constraint on columns "id" */
  TransactionPkey = 'transaction_pkey'
}

/** input type for incrementing numeric columns in table "transaction_history" */
export type TransactionHistoryIncInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  balance?: InputMaybe<Scalars['numeric']>;
  constant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  constant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  currency_rate?: InputMaybe<Scalars['numeric']>;
  frozen_withdraw_balance?: InputMaybe<Scalars['numeric']>;
  gate_currency_amount?: InputMaybe<Scalars['numeric']>;
  gate_currency_rate?: InputMaybe<Scalars['numeric']>;
  hold_amount?: InputMaybe<Scalars['numeric']>;
  hold_balance?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  input_currency_amount?: InputMaybe<Scalars['numeric']>;
  merchant_constant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  merchant_constant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  merchant_fee?: InputMaybe<Scalars['numeric']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_invoice_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  provider_fee?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "transaction_history" */
export type TransactionHistoryInsertInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  balance?: InputMaybe<Scalars['numeric']>;
  bank_id?: InputMaybe<Scalars['String']>;
  card_system_id?: InputMaybe<Scalars['String']>;
  constant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  constant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<CurrencyObjRelInsertInput>;
  currency_id?: InputMaybe<Scalars['String']>;
  currency_rate?: InputMaybe<Scalars['numeric']>;
  currency_rate_provider_id?: InputMaybe<Scalars['String']>;
  frozen_withdraw_balance?: InputMaybe<Scalars['numeric']>;
  gate_currency_amount?: InputMaybe<Scalars['numeric']>;
  gate_currency_rate?: InputMaybe<Scalars['numeric']>;
  gate_id?: InputMaybe<Scalars['String']>;
  hold_amount?: InputMaybe<Scalars['numeric']>;
  hold_balance?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  input_currency_amount?: InputMaybe<Scalars['numeric']>;
  input_currency_id?: InputMaybe<Scalars['String']>;
  merchant?: InputMaybe<MerchantObjRelInsertInput>;
  merchant_constant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  merchant_constant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  merchant_fee?: InputMaybe<Scalars['numeric']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_invoice_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  provider?: InputMaybe<ProviderObjRelInsertInput>;
  provider_fee?: InputMaybe<Scalars['numeric']>;
  provider_id?: InputMaybe<Scalars['String']>;
  provider_transaction_uid?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  sanitized_mask?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_updated_at?: InputMaybe<Scalars['timestamptz']>;
  transaction_uid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type TransactionHistoryMaxFields = {
  amount?: Maybe<Scalars['numeric']>;
  balance?: Maybe<Scalars['numeric']>;
  bank_id?: Maybe<Scalars['String']>;
  card_system_id?: Maybe<Scalars['String']>;
  constant_invoice_fee?: Maybe<Scalars['numeric']>;
  constant_withdraw_fee?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  currency_rate?: Maybe<Scalars['numeric']>;
  currency_rate_provider_id?: Maybe<Scalars['String']>;
  frozen_withdraw_balance?: Maybe<Scalars['numeric']>;
  gate_currency_amount?: Maybe<Scalars['numeric']>;
  gate_currency_rate?: Maybe<Scalars['numeric']>;
  gate_id?: Maybe<Scalars['String']>;
  hold_amount?: Maybe<Scalars['numeric']>;
  hold_balance?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  input_currency_amount?: Maybe<Scalars['numeric']>;
  input_currency_id?: Maybe<Scalars['String']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['numeric']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['numeric']>;
  merchant_fee?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  provider_fee?: Maybe<Scalars['numeric']>;
  provider_id?: Maybe<Scalars['String']>;
  provider_transaction_uid?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  sanitized_mask?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  status_updated_at?: Maybe<Scalars['timestamptz']>;
  transaction_uid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "transaction_history" */
export type TransactionHistoryMaxOrderBy = {
  amount?: InputMaybe<OrderBy>;
  balance?: InputMaybe<OrderBy>;
  bank_id?: InputMaybe<OrderBy>;
  card_system_id?: InputMaybe<OrderBy>;
  constant_invoice_fee?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  currency_rate_provider_id?: InputMaybe<OrderBy>;
  frozen_withdraw_balance?: InputMaybe<OrderBy>;
  gate_currency_amount?: InputMaybe<OrderBy>;
  gate_currency_rate?: InputMaybe<OrderBy>;
  gate_id?: InputMaybe<OrderBy>;
  hold_amount?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_amount?: InputMaybe<OrderBy>;
  input_currency_id?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  provider_fee?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  provider_transaction_uid?: InputMaybe<OrderBy>;
  remark?: InputMaybe<OrderBy>;
  sanitized_mask?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  status_updated_at?: InputMaybe<OrderBy>;
  transaction_uid?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type TransactionHistoryMinFields = {
  amount?: Maybe<Scalars['numeric']>;
  balance?: Maybe<Scalars['numeric']>;
  bank_id?: Maybe<Scalars['String']>;
  card_system_id?: Maybe<Scalars['String']>;
  constant_invoice_fee?: Maybe<Scalars['numeric']>;
  constant_withdraw_fee?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  currency_rate?: Maybe<Scalars['numeric']>;
  currency_rate_provider_id?: Maybe<Scalars['String']>;
  frozen_withdraw_balance?: Maybe<Scalars['numeric']>;
  gate_currency_amount?: Maybe<Scalars['numeric']>;
  gate_currency_rate?: Maybe<Scalars['numeric']>;
  gate_id?: Maybe<Scalars['String']>;
  hold_amount?: Maybe<Scalars['numeric']>;
  hold_balance?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  input_currency_amount?: Maybe<Scalars['numeric']>;
  input_currency_id?: Maybe<Scalars['String']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['numeric']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['numeric']>;
  merchant_fee?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  provider_fee?: Maybe<Scalars['numeric']>;
  provider_id?: Maybe<Scalars['String']>;
  provider_transaction_uid?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  sanitized_mask?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  status_updated_at?: Maybe<Scalars['timestamptz']>;
  transaction_uid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "transaction_history" */
export type TransactionHistoryMinOrderBy = {
  amount?: InputMaybe<OrderBy>;
  balance?: InputMaybe<OrderBy>;
  bank_id?: InputMaybe<OrderBy>;
  card_system_id?: InputMaybe<OrderBy>;
  constant_invoice_fee?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  currency_rate_provider_id?: InputMaybe<OrderBy>;
  frozen_withdraw_balance?: InputMaybe<OrderBy>;
  gate_currency_amount?: InputMaybe<OrderBy>;
  gate_currency_rate?: InputMaybe<OrderBy>;
  gate_id?: InputMaybe<OrderBy>;
  hold_amount?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_amount?: InputMaybe<OrderBy>;
  input_currency_id?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  provider_fee?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  provider_transaction_uid?: InputMaybe<OrderBy>;
  remark?: InputMaybe<OrderBy>;
  sanitized_mask?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  status_updated_at?: InputMaybe<OrderBy>;
  transaction_uid?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "transaction_history" */
export type TransactionHistoryMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TransactionHistory>;
};

/** on_conflict condition type for table "transaction_history" */
export type TransactionHistoryOnConflict = {
  constraint: TransactionHistoryConstraint;
  update_columns?: Array<TransactionHistoryUpdateColumn>;
  where?: InputMaybe<TransactionHistoryBoolExp>;
};

/** Ordering options when selecting data from "transaction_history". */
export type TransactionHistoryOrderBy = {
  amount?: InputMaybe<OrderBy>;
  balance?: InputMaybe<OrderBy>;
  bank_id?: InputMaybe<OrderBy>;
  card_system_id?: InputMaybe<OrderBy>;
  constant_invoice_fee?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency?: InputMaybe<CurrencyOrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  currency_rate_provider_id?: InputMaybe<OrderBy>;
  frozen_withdraw_balance?: InputMaybe<OrderBy>;
  gate_currency_amount?: InputMaybe<OrderBy>;
  gate_currency_rate?: InputMaybe<OrderBy>;
  gate_id?: InputMaybe<OrderBy>;
  hold_amount?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_amount?: InputMaybe<OrderBy>;
  input_currency_id?: InputMaybe<OrderBy>;
  merchant?: InputMaybe<MerchantOrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  provider?: InputMaybe<ProviderOrderBy>;
  provider_fee?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  provider_transaction_uid?: InputMaybe<OrderBy>;
  remark?: InputMaybe<OrderBy>;
  sanitized_mask?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  status_updated_at?: InputMaybe<OrderBy>;
  transaction_uid?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: transaction_history */
export type TransactionHistoryPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "transaction_history" */
export enum TransactionHistorySelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  Balance = 'balance',
  /** column name */
  BankId = 'bank_id',
  /** column name */
  CardSystemId = 'card_system_id',
  /** column name */
  ConstantInvoiceFee = 'constant_invoice_fee',
  /** column name */
  ConstantWithdrawFee = 'constant_withdraw_fee',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  CurrencyRate = 'currency_rate',
  /** column name */
  CurrencyRateProviderId = 'currency_rate_provider_id',
  /** column name */
  FrozenWithdrawBalance = 'frozen_withdraw_balance',
  /** column name */
  GateCurrencyAmount = 'gate_currency_amount',
  /** column name */
  GateCurrencyRate = 'gate_currency_rate',
  /** column name */
  GateId = 'gate_id',
  /** column name */
  HoldAmount = 'hold_amount',
  /** column name */
  HoldBalance = 'hold_balance',
  /** column name */
  Id = 'id',
  /** column name */
  InputCurrencyAmount = 'input_currency_amount',
  /** column name */
  InputCurrencyId = 'input_currency_id',
  /** column name */
  MerchantConstantInvoiceFee = 'merchant_constant_invoice_fee',
  /** column name */
  MerchantConstantWithdrawFee = 'merchant_constant_withdraw_fee',
  /** column name */
  MerchantFee = 'merchant_fee',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MerchantInvoiceFeeMinAmount = 'merchant_invoice_fee_min_amount',
  /** column name */
  MerchantInvoiceFeePercent = 'merchant_invoice_fee_percent',
  /** column name */
  MerchantInvoiceTransactionFeeAmount = 'merchant_invoice_transaction_fee_amount',
  /** column name */
  MerchantWithdrawFeeMinAmount = 'merchant_withdraw_fee_min_amount',
  /** column name */
  MerchantWithdrawFeePercent = 'merchant_withdraw_fee_percent',
  /** column name */
  MerchantWithdrawTransactionFeeAmount = 'merchant_withdraw_transaction_fee_amount',
  /** column name */
  ProviderFee = 'provider_fee',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  ProviderTransactionUid = 'provider_transaction_uid',
  /** column name */
  Remark = 'remark',
  /** column name */
  SanitizedMask = 'sanitized_mask',
  /** column name */
  Status = 'status',
  /** column name */
  StatusUpdatedAt = 'status_updated_at',
  /** column name */
  TransactionUid = 'transaction_uid',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "transaction_history" */
export type TransactionHistorySetInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  balance?: InputMaybe<Scalars['numeric']>;
  bank_id?: InputMaybe<Scalars['String']>;
  card_system_id?: InputMaybe<Scalars['String']>;
  constant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  constant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency_id?: InputMaybe<Scalars['String']>;
  currency_rate?: InputMaybe<Scalars['numeric']>;
  currency_rate_provider_id?: InputMaybe<Scalars['String']>;
  frozen_withdraw_balance?: InputMaybe<Scalars['numeric']>;
  gate_currency_amount?: InputMaybe<Scalars['numeric']>;
  gate_currency_rate?: InputMaybe<Scalars['numeric']>;
  gate_id?: InputMaybe<Scalars['String']>;
  hold_amount?: InputMaybe<Scalars['numeric']>;
  hold_balance?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  input_currency_amount?: InputMaybe<Scalars['numeric']>;
  input_currency_id?: InputMaybe<Scalars['String']>;
  merchant_constant_invoice_fee?: InputMaybe<Scalars['numeric']>;
  merchant_constant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  merchant_fee?: InputMaybe<Scalars['numeric']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_invoice_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  provider_fee?: InputMaybe<Scalars['numeric']>;
  provider_id?: InputMaybe<Scalars['String']>;
  provider_transaction_uid?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  sanitized_mask?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_updated_at?: InputMaybe<Scalars['timestamptz']>;
  transaction_uid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type TransactionHistoryStddevFields = {
  amount?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
  constant_invoice_fee?: Maybe<Scalars['Float']>;
  constant_withdraw_fee?: Maybe<Scalars['Float']>;
  currency_rate?: Maybe<Scalars['Float']>;
  frozen_withdraw_balance?: Maybe<Scalars['Float']>;
  gate_currency_amount?: Maybe<Scalars['Float']>;
  gate_currency_rate?: Maybe<Scalars['Float']>;
  hold_amount?: Maybe<Scalars['Float']>;
  hold_balance?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_currency_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  provider_fee?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "transaction_history" */
export type TransactionHistoryStddevOrderBy = {
  amount?: InputMaybe<OrderBy>;
  balance?: InputMaybe<OrderBy>;
  constant_invoice_fee?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  frozen_withdraw_balance?: InputMaybe<OrderBy>;
  gate_currency_amount?: InputMaybe<OrderBy>;
  gate_currency_rate?: InputMaybe<OrderBy>;
  hold_amount?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  provider_fee?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type TransactionHistoryStddevPopFields = {
  amount?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
  constant_invoice_fee?: Maybe<Scalars['Float']>;
  constant_withdraw_fee?: Maybe<Scalars['Float']>;
  currency_rate?: Maybe<Scalars['Float']>;
  frozen_withdraw_balance?: Maybe<Scalars['Float']>;
  gate_currency_amount?: Maybe<Scalars['Float']>;
  gate_currency_rate?: Maybe<Scalars['Float']>;
  hold_amount?: Maybe<Scalars['Float']>;
  hold_balance?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_currency_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  provider_fee?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "transaction_history" */
export type TransactionHistoryStddevPopOrderBy = {
  amount?: InputMaybe<OrderBy>;
  balance?: InputMaybe<OrderBy>;
  constant_invoice_fee?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  frozen_withdraw_balance?: InputMaybe<OrderBy>;
  gate_currency_amount?: InputMaybe<OrderBy>;
  gate_currency_rate?: InputMaybe<OrderBy>;
  hold_amount?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  provider_fee?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type TransactionHistoryStddevSampFields = {
  amount?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
  constant_invoice_fee?: Maybe<Scalars['Float']>;
  constant_withdraw_fee?: Maybe<Scalars['Float']>;
  currency_rate?: Maybe<Scalars['Float']>;
  frozen_withdraw_balance?: Maybe<Scalars['Float']>;
  gate_currency_amount?: Maybe<Scalars['Float']>;
  gate_currency_rate?: Maybe<Scalars['Float']>;
  hold_amount?: Maybe<Scalars['Float']>;
  hold_balance?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_currency_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  provider_fee?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "transaction_history" */
export type TransactionHistoryStddevSampOrderBy = {
  amount?: InputMaybe<OrderBy>;
  balance?: InputMaybe<OrderBy>;
  constant_invoice_fee?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  frozen_withdraw_balance?: InputMaybe<OrderBy>;
  gate_currency_amount?: InputMaybe<OrderBy>;
  gate_currency_rate?: InputMaybe<OrderBy>;
  hold_amount?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  provider_fee?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type TransactionHistorySumFields = {
  amount?: Maybe<Scalars['numeric']>;
  balance?: Maybe<Scalars['numeric']>;
  constant_invoice_fee?: Maybe<Scalars['numeric']>;
  constant_withdraw_fee?: Maybe<Scalars['numeric']>;
  currency_rate?: Maybe<Scalars['numeric']>;
  frozen_withdraw_balance?: Maybe<Scalars['numeric']>;
  gate_currency_amount?: Maybe<Scalars['numeric']>;
  gate_currency_rate?: Maybe<Scalars['numeric']>;
  hold_amount?: Maybe<Scalars['numeric']>;
  hold_balance?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  input_currency_amount?: Maybe<Scalars['numeric']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['numeric']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['numeric']>;
  merchant_fee?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  provider_fee?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "transaction_history" */
export type TransactionHistorySumOrderBy = {
  amount?: InputMaybe<OrderBy>;
  balance?: InputMaybe<OrderBy>;
  constant_invoice_fee?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  frozen_withdraw_balance?: InputMaybe<OrderBy>;
  gate_currency_amount?: InputMaybe<OrderBy>;
  gate_currency_rate?: InputMaybe<OrderBy>;
  hold_amount?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  provider_fee?: InputMaybe<OrderBy>;
};

/** update columns of table "transaction_history" */
export enum TransactionHistoryUpdateColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  Balance = 'balance',
  /** column name */
  BankId = 'bank_id',
  /** column name */
  CardSystemId = 'card_system_id',
  /** column name */
  ConstantInvoiceFee = 'constant_invoice_fee',
  /** column name */
  ConstantWithdrawFee = 'constant_withdraw_fee',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  CurrencyRate = 'currency_rate',
  /** column name */
  CurrencyRateProviderId = 'currency_rate_provider_id',
  /** column name */
  FrozenWithdrawBalance = 'frozen_withdraw_balance',
  /** column name */
  GateCurrencyAmount = 'gate_currency_amount',
  /** column name */
  GateCurrencyRate = 'gate_currency_rate',
  /** column name */
  GateId = 'gate_id',
  /** column name */
  HoldAmount = 'hold_amount',
  /** column name */
  HoldBalance = 'hold_balance',
  /** column name */
  Id = 'id',
  /** column name */
  InputCurrencyAmount = 'input_currency_amount',
  /** column name */
  InputCurrencyId = 'input_currency_id',
  /** column name */
  MerchantConstantInvoiceFee = 'merchant_constant_invoice_fee',
  /** column name */
  MerchantConstantWithdrawFee = 'merchant_constant_withdraw_fee',
  /** column name */
  MerchantFee = 'merchant_fee',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MerchantInvoiceFeeMinAmount = 'merchant_invoice_fee_min_amount',
  /** column name */
  MerchantInvoiceFeePercent = 'merchant_invoice_fee_percent',
  /** column name */
  MerchantInvoiceTransactionFeeAmount = 'merchant_invoice_transaction_fee_amount',
  /** column name */
  MerchantWithdrawFeeMinAmount = 'merchant_withdraw_fee_min_amount',
  /** column name */
  MerchantWithdrawFeePercent = 'merchant_withdraw_fee_percent',
  /** column name */
  MerchantWithdrawTransactionFeeAmount = 'merchant_withdraw_transaction_fee_amount',
  /** column name */
  ProviderFee = 'provider_fee',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  ProviderTransactionUid = 'provider_transaction_uid',
  /** column name */
  Remark = 'remark',
  /** column name */
  SanitizedMask = 'sanitized_mask',
  /** column name */
  Status = 'status',
  /** column name */
  StatusUpdatedAt = 'status_updated_at',
  /** column name */
  TransactionUid = 'transaction_uid',
  /** column name */
  Type = 'type'
}

export type TransactionHistoryUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TransactionHistoryIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TransactionHistorySetInput>;
  where: TransactionHistoryBoolExp;
};

/** aggregate var_pop on columns */
export type TransactionHistoryVarPopFields = {
  amount?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
  constant_invoice_fee?: Maybe<Scalars['Float']>;
  constant_withdraw_fee?: Maybe<Scalars['Float']>;
  currency_rate?: Maybe<Scalars['Float']>;
  frozen_withdraw_balance?: Maybe<Scalars['Float']>;
  gate_currency_amount?: Maybe<Scalars['Float']>;
  gate_currency_rate?: Maybe<Scalars['Float']>;
  hold_amount?: Maybe<Scalars['Float']>;
  hold_balance?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_currency_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  provider_fee?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "transaction_history" */
export type TransactionHistoryVarPopOrderBy = {
  amount?: InputMaybe<OrderBy>;
  balance?: InputMaybe<OrderBy>;
  constant_invoice_fee?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  frozen_withdraw_balance?: InputMaybe<OrderBy>;
  gate_currency_amount?: InputMaybe<OrderBy>;
  gate_currency_rate?: InputMaybe<OrderBy>;
  hold_amount?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  provider_fee?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type TransactionHistoryVarSampFields = {
  amount?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
  constant_invoice_fee?: Maybe<Scalars['Float']>;
  constant_withdraw_fee?: Maybe<Scalars['Float']>;
  currency_rate?: Maybe<Scalars['Float']>;
  frozen_withdraw_balance?: Maybe<Scalars['Float']>;
  gate_currency_amount?: Maybe<Scalars['Float']>;
  gate_currency_rate?: Maybe<Scalars['Float']>;
  hold_amount?: Maybe<Scalars['Float']>;
  hold_balance?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_currency_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  provider_fee?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "transaction_history" */
export type TransactionHistoryVarSampOrderBy = {
  amount?: InputMaybe<OrderBy>;
  balance?: InputMaybe<OrderBy>;
  constant_invoice_fee?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  frozen_withdraw_balance?: InputMaybe<OrderBy>;
  gate_currency_amount?: InputMaybe<OrderBy>;
  gate_currency_rate?: InputMaybe<OrderBy>;
  hold_amount?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  provider_fee?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type TransactionHistoryVarianceFields = {
  amount?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
  constant_invoice_fee?: Maybe<Scalars['Float']>;
  constant_withdraw_fee?: Maybe<Scalars['Float']>;
  currency_rate?: Maybe<Scalars['Float']>;
  frozen_withdraw_balance?: Maybe<Scalars['Float']>;
  gate_currency_amount?: Maybe<Scalars['Float']>;
  gate_currency_rate?: Maybe<Scalars['Float']>;
  hold_amount?: Maybe<Scalars['Float']>;
  hold_balance?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_currency_amount?: Maybe<Scalars['Float']>;
  merchant_constant_invoice_fee?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_invoice_fee_percent?: Maybe<Scalars['Float']>;
  merchant_invoice_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  provider_fee?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "transaction_history" */
export type TransactionHistoryVarianceOrderBy = {
  amount?: InputMaybe<OrderBy>;
  balance?: InputMaybe<OrderBy>;
  constant_invoice_fee?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  frozen_withdraw_balance?: InputMaybe<OrderBy>;
  gate_currency_amount?: InputMaybe<OrderBy>;
  gate_currency_rate?: InputMaybe<OrderBy>;
  hold_amount?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_amount?: InputMaybe<OrderBy>;
  merchant_constant_invoice_fee?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_invoice_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_invoice_fee_percent?: InputMaybe<OrderBy>;
  merchant_invoice_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  provider_fee?: InputMaybe<OrderBy>;
};

/** columns and relationships of "user" */
export type User = {
  activated_at?: Maybe<Scalars['timestamptz']>;
  created_at: Scalars['timestamptz'];
  edit_user_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  /** An object relationship */
  merchant_user?: Maybe<MerchantUser>;
  /** An array relationship */
  merchant_users: Array<MerchantUser>;
  /** An aggregate relationship */
  merchant_users_aggregate: MerchantUserAggregate;
  otp_enable?: Maybe<Scalars['Boolean']>;
  password_hash?: Maybe<Scalars['String']>;
  /** An array relationship */
  permissions: Array<VHasuraPermission>;
  /** An aggregate relationship */
  permissions_aggregate: VHasuraPermissionAggregate;
  /** An object relationship */
  registration_info?: Maybe<RegistrationInfo>;
  registration_info_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  role: Role;
  role_id: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_activate_tokens: Array<UserActivateToken>;
  /** An aggregate relationship */
  user_activate_tokens_aggregate: UserActivateTokenAggregate;
  /** An object relationship */
  user_info?: Maybe<UserInfo>;
  user_secret_id?: Maybe<Scalars['String']>;
  username: Scalars['String'];
};


/** columns and relationships of "user" */
export type UserMerchantUsersArgs = {
  distinct_on?: InputMaybe<Array<MerchantUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantUserOrderBy>>;
  where?: InputMaybe<MerchantUserBoolExp>;
};


/** columns and relationships of "user" */
export type UserMerchantUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantUserOrderBy>>;
  where?: InputMaybe<MerchantUserBoolExp>;
};


/** columns and relationships of "user" */
export type UserPermissionsArgs = {
  distinct_on?: InputMaybe<Array<VHasuraPermissionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VHasuraPermissionOrderBy>>;
  where?: InputMaybe<VHasuraPermissionBoolExp>;
};


/** columns and relationships of "user" */
export type UserPermissionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<VHasuraPermissionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VHasuraPermissionOrderBy>>;
  where?: InputMaybe<VHasuraPermissionBoolExp>;
};


/** columns and relationships of "user" */
export type UserUserActivateTokensArgs = {
  distinct_on?: InputMaybe<Array<UserActivateTokenSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserActivateTokenOrderBy>>;
  where?: InputMaybe<UserActivateTokenBoolExp>;
};


/** columns and relationships of "user" */
export type UserUserActivateTokensAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserActivateTokenSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserActivateTokenOrderBy>>;
  where?: InputMaybe<UserActivateTokenBoolExp>;
};

/** columns and relationships of "user_activate_token" */
export type UserActivateToken = {
  created_at: Scalars['timestamptz'];
  expired_at: Scalars['timestamptz'];
  sent_at?: Maybe<Scalars['timestamptz']>;
  token: Scalars['String'];
  /** An object relationship */
  user: User;
  user_activate_token_type_id?: Maybe<Scalars['String']>;
  user_id: Scalars['Int'];
};

/** aggregated selection of "user_activate_token" */
export type UserActivateTokenAggregate = {
  aggregate?: Maybe<UserActivateTokenAggregateFields>;
  nodes: Array<UserActivateToken>;
};

/** aggregate fields of "user_activate_token" */
export type UserActivateTokenAggregateFields = {
  avg?: Maybe<UserActivateTokenAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UserActivateTokenMaxFields>;
  min?: Maybe<UserActivateTokenMinFields>;
  stddev?: Maybe<UserActivateTokenStddevFields>;
  stddev_pop?: Maybe<UserActivateTokenStddevPopFields>;
  stddev_samp?: Maybe<UserActivateTokenStddevSampFields>;
  sum?: Maybe<UserActivateTokenSumFields>;
  var_pop?: Maybe<UserActivateTokenVarPopFields>;
  var_samp?: Maybe<UserActivateTokenVarSampFields>;
  variance?: Maybe<UserActivateTokenVarianceFields>;
};


/** aggregate fields of "user_activate_token" */
export type UserActivateTokenAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserActivateTokenSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_activate_token" */
export type UserActivateTokenAggregateOrderBy = {
  avg?: InputMaybe<UserActivateTokenAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserActivateTokenMaxOrderBy>;
  min?: InputMaybe<UserActivateTokenMinOrderBy>;
  stddev?: InputMaybe<UserActivateTokenStddevOrderBy>;
  stddev_pop?: InputMaybe<UserActivateTokenStddevPopOrderBy>;
  stddev_samp?: InputMaybe<UserActivateTokenStddevSampOrderBy>;
  sum?: InputMaybe<UserActivateTokenSumOrderBy>;
  var_pop?: InputMaybe<UserActivateTokenVarPopOrderBy>;
  var_samp?: InputMaybe<UserActivateTokenVarSampOrderBy>;
  variance?: InputMaybe<UserActivateTokenVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "user_activate_token" */
export type UserActivateTokenArrRelInsertInput = {
  data: Array<UserActivateTokenInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<UserActivateTokenOnConflict>;
};

/** aggregate avg on columns */
export type UserActivateTokenAvgFields = {
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_activate_token" */
export type UserActivateTokenAvgOrderBy = {
  user_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user_activate_token". All fields are combined with a logical 'AND'. */
export type UserActivateTokenBoolExp = {
  _and?: InputMaybe<Array<UserActivateTokenBoolExp>>;
  _not?: InputMaybe<UserActivateTokenBoolExp>;
  _or?: InputMaybe<Array<UserActivateTokenBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  expired_at?: InputMaybe<TimestamptzComparisonExp>;
  sent_at?: InputMaybe<TimestamptzComparisonExp>;
  token?: InputMaybe<StringComparisonExp>;
  user?: InputMaybe<UserBoolExp>;
  user_activate_token_type_id?: InputMaybe<StringComparisonExp>;
  user_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "user_activate_token" */
export enum UserActivateTokenConstraint {
  /** unique or primary key constraint on columns "token" */
  UserActivateTokenPkey = 'user_activate_token_pkey',
  /** unique or primary key constraint on columns "token" */
  UserActivateTokenTokenKey = 'user_activate_token_token_key'
}

/** input type for incrementing numeric columns in table "user_activate_token" */
export type UserActivateTokenIncInput = {
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_activate_token" */
export type UserActivateTokenInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expired_at?: InputMaybe<Scalars['timestamptz']>;
  sent_at?: InputMaybe<Scalars['timestamptz']>;
  token?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<UserObjRelInsertInput>;
  user_activate_token_type_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type UserActivateTokenMaxFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  expired_at?: Maybe<Scalars['timestamptz']>;
  sent_at?: Maybe<Scalars['timestamptz']>;
  token?: Maybe<Scalars['String']>;
  user_activate_token_type_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "user_activate_token" */
export type UserActivateTokenMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  expired_at?: InputMaybe<OrderBy>;
  sent_at?: InputMaybe<OrderBy>;
  token?: InputMaybe<OrderBy>;
  user_activate_token_type_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserActivateTokenMinFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  expired_at?: Maybe<Scalars['timestamptz']>;
  sent_at?: Maybe<Scalars['timestamptz']>;
  token?: Maybe<Scalars['String']>;
  user_activate_token_type_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "user_activate_token" */
export type UserActivateTokenMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  expired_at?: InputMaybe<OrderBy>;
  sent_at?: InputMaybe<OrderBy>;
  token?: InputMaybe<OrderBy>;
  user_activate_token_type_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_activate_token" */
export type UserActivateTokenMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserActivateToken>;
};

/** on_conflict condition type for table "user_activate_token" */
export type UserActivateTokenOnConflict = {
  constraint: UserActivateTokenConstraint;
  update_columns?: Array<UserActivateTokenUpdateColumn>;
  where?: InputMaybe<UserActivateTokenBoolExp>;
};

/** Ordering options when selecting data from "user_activate_token". */
export type UserActivateTokenOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  expired_at?: InputMaybe<OrderBy>;
  sent_at?: InputMaybe<OrderBy>;
  token?: InputMaybe<OrderBy>;
  user?: InputMaybe<UserOrderBy>;
  user_activate_token_type_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_activate_token */
export type UserActivateTokenPkColumnsInput = {
  token: Scalars['String'];
};

/** select columns of table "user_activate_token" */
export enum UserActivateTokenSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiredAt = 'expired_at',
  /** column name */
  SentAt = 'sent_at',
  /** column name */
  Token = 'token',
  /** column name */
  UserActivateTokenTypeId = 'user_activate_token_type_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_activate_token" */
export type UserActivateTokenSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expired_at?: InputMaybe<Scalars['timestamptz']>;
  sent_at?: InputMaybe<Scalars['timestamptz']>;
  token?: InputMaybe<Scalars['String']>;
  user_activate_token_type_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type UserActivateTokenStddevFields = {
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_activate_token" */
export type UserActivateTokenStddevOrderBy = {
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type UserActivateTokenStddevPopFields = {
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_activate_token" */
export type UserActivateTokenStddevPopOrderBy = {
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type UserActivateTokenStddevSampFields = {
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_activate_token" */
export type UserActivateTokenStddevSampOrderBy = {
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type UserActivateTokenSumFields = {
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_activate_token" */
export type UserActivateTokenSumOrderBy = {
  user_id?: InputMaybe<OrderBy>;
};

/** update columns of table "user_activate_token" */
export enum UserActivateTokenUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiredAt = 'expired_at',
  /** column name */
  SentAt = 'sent_at',
  /** column name */
  Token = 'token',
  /** column name */
  UserActivateTokenTypeId = 'user_activate_token_type_id',
  /** column name */
  UserId = 'user_id'
}

export type UserActivateTokenUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserActivateTokenIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserActivateTokenSetInput>;
  where: UserActivateTokenBoolExp;
};

/** aggregate var_pop on columns */
export type UserActivateTokenVarPopFields = {
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_activate_token" */
export type UserActivateTokenVarPopOrderBy = {
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type UserActivateTokenVarSampFields = {
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_activate_token" */
export type UserActivateTokenVarSampOrderBy = {
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type UserActivateTokenVarianceFields = {
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_activate_token" */
export type UserActivateTokenVarianceOrderBy = {
  user_id?: InputMaybe<OrderBy>;
};

/** aggregated selection of "user" */
export type UserAggregate = {
  aggregate?: Maybe<UserAggregateFields>;
  nodes: Array<User>;
};

/** aggregate fields of "user" */
export type UserAggregateFields = {
  avg?: Maybe<UserAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UserMaxFields>;
  min?: Maybe<UserMinFields>;
  stddev?: Maybe<UserStddevFields>;
  stddev_pop?: Maybe<UserStddevPopFields>;
  stddev_samp?: Maybe<UserStddevSampFields>;
  sum?: Maybe<UserSumFields>;
  var_pop?: Maybe<UserVarPopFields>;
  var_samp?: Maybe<UserVarSampFields>;
  variance?: Maybe<UserVarianceFields>;
};


/** aggregate fields of "user" */
export type UserAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user" */
export type UserAggregateOrderBy = {
  avg?: InputMaybe<UserAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserMaxOrderBy>;
  min?: InputMaybe<UserMinOrderBy>;
  stddev?: InputMaybe<UserStddevOrderBy>;
  stddev_pop?: InputMaybe<UserStddevPopOrderBy>;
  stddev_samp?: InputMaybe<UserStddevSampOrderBy>;
  sum?: InputMaybe<UserSumOrderBy>;
  var_pop?: InputMaybe<UserVarPopOrderBy>;
  var_samp?: InputMaybe<UserVarSampOrderBy>;
  variance?: InputMaybe<UserVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "user" */
export type UserArrRelInsertInput = {
  data: Array<UserInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<UserOnConflict>;
};

/** columns and relationships of "user_audit" */
export type UserAudit = {
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  message?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  user: User;
  user_id: Scalars['Int'];
};


/** columns and relationships of "user_audit" */
export type UserAuditPayloadArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "user_audit" */
export type UserAuditAggregate = {
  aggregate?: Maybe<UserAuditAggregateFields>;
  nodes: Array<UserAudit>;
};

/** aggregate fields of "user_audit" */
export type UserAuditAggregateFields = {
  avg?: Maybe<UserAuditAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UserAuditMaxFields>;
  min?: Maybe<UserAuditMinFields>;
  stddev?: Maybe<UserAuditStddevFields>;
  stddev_pop?: Maybe<UserAuditStddevPopFields>;
  stddev_samp?: Maybe<UserAuditStddevSampFields>;
  sum?: Maybe<UserAuditSumFields>;
  var_pop?: Maybe<UserAuditVarPopFields>;
  var_samp?: Maybe<UserAuditVarSampFields>;
  variance?: Maybe<UserAuditVarianceFields>;
};


/** aggregate fields of "user_audit" */
export type UserAuditAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserAuditSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type UserAuditAppendInput = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type UserAuditAvgFields = {
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_audit". All fields are combined with a logical 'AND'. */
export type UserAuditBoolExp = {
  _and?: InputMaybe<Array<UserAuditBoolExp>>;
  _not?: InputMaybe<UserAuditBoolExp>;
  _or?: InputMaybe<Array<UserAuditBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<StringComparisonExp>;
  payload?: InputMaybe<JsonbComparisonExp>;
  user?: InputMaybe<UserBoolExp>;
  user_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "user_audit" */
export enum UserAuditConstraint {
  /** unique or primary key constraint on columns "id" */
  UserAuditPkey = 'user_audit_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type UserAuditDeleteAtPathInput = {
  payload?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type UserAuditDeleteElemInput = {
  payload?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type UserAuditDeleteKeyInput = {
  payload?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "user_audit" */
export type UserAuditIncInput = {
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_audit" */
export type UserAuditInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  user?: InputMaybe<UserObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type UserAuditMaxFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type UserAuditMinFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "user_audit" */
export type UserAuditMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserAudit>;
};

/** on_conflict condition type for table "user_audit" */
export type UserAuditOnConflict = {
  constraint: UserAuditConstraint;
  update_columns?: Array<UserAuditUpdateColumn>;
  where?: InputMaybe<UserAuditBoolExp>;
};

/** Ordering options when selecting data from "user_audit". */
export type UserAuditOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message?: InputMaybe<OrderBy>;
  payload?: InputMaybe<OrderBy>;
  user?: InputMaybe<UserOrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_audit */
export type UserAuditPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type UserAuditPrependInput = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "user_audit" */
export enum UserAuditSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Payload = 'payload',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_audit" */
export type UserAuditSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type UserAuditStddevFields = {
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type UserAuditStddevPopFields = {
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type UserAuditStddevSampFields = {
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type UserAuditSumFields = {
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "user_audit" */
export enum UserAuditUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Payload = 'payload',
  /** column name */
  UserId = 'user_id'
}

export type UserAuditUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<UserAuditAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<UserAuditDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<UserAuditDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<UserAuditDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserAuditIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<UserAuditPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserAuditSetInput>;
  where: UserAuditBoolExp;
};

/** aggregate var_pop on columns */
export type UserAuditVarPopFields = {
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type UserAuditVarSampFields = {
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type UserAuditVarianceFields = {
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate avg on columns */
export type UserAvgFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user" */
export type UserAvgOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user". All fields are combined with a logical 'AND'. */
export type UserBoolExp = {
  _and?: InputMaybe<Array<UserBoolExp>>;
  _not?: InputMaybe<UserBoolExp>;
  _or?: InputMaybe<Array<UserBoolExp>>;
  activated_at?: InputMaybe<TimestamptzComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  edit_user_id?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  merchant_user?: InputMaybe<MerchantUserBoolExp>;
  merchant_users?: InputMaybe<MerchantUserBoolExp>;
  otp_enable?: InputMaybe<BooleanComparisonExp>;
  password_hash?: InputMaybe<StringComparisonExp>;
  permissions?: InputMaybe<VHasuraPermissionBoolExp>;
  registration_info?: InputMaybe<RegistrationInfoBoolExp>;
  registration_info_id?: InputMaybe<UuidComparisonExp>;
  role?: InputMaybe<RoleBoolExp>;
  role_id?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user_activate_tokens?: InputMaybe<UserActivateTokenBoolExp>;
  user_info?: InputMaybe<UserInfoBoolExp>;
  user_secret_id?: InputMaybe<StringComparisonExp>;
  username?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "user" */
export enum UserConstraint {
  /** unique or primary key constraint on columns "id" */
  UserPkey = 'user_pkey',
  /** unique or primary key constraint on columns "username" */
  UserUsernameKey = 'user_username_key'
}

/** input type for incrementing numeric columns in table "user" */
export type UserIncInput = {
  edit_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** columns and relationships of "user_info" */
export type UserInfo = {
  birthday?: Maybe<Scalars['date']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  email: Scalars['String'];
  gender_id?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  telegram?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  user_id: Scalars['Int'];
  whatsapp?: Maybe<Scalars['String']>;
};

/** aggregated selection of "user_info" */
export type UserInfoAggregate = {
  aggregate?: Maybe<UserInfoAggregateFields>;
  nodes: Array<UserInfo>;
};

/** aggregate fields of "user_info" */
export type UserInfoAggregateFields = {
  avg?: Maybe<UserInfoAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UserInfoMaxFields>;
  min?: Maybe<UserInfoMinFields>;
  stddev?: Maybe<UserInfoStddevFields>;
  stddev_pop?: Maybe<UserInfoStddevPopFields>;
  stddev_samp?: Maybe<UserInfoStddevSampFields>;
  sum?: Maybe<UserInfoSumFields>;
  var_pop?: Maybe<UserInfoVarPopFields>;
  var_samp?: Maybe<UserInfoVarSampFields>;
  variance?: Maybe<UserInfoVarianceFields>;
};


/** aggregate fields of "user_info" */
export type UserInfoAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserInfoSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type UserInfoAvgFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_info". All fields are combined with a logical 'AND'. */
export type UserInfoBoolExp = {
  _and?: InputMaybe<Array<UserInfoBoolExp>>;
  _not?: InputMaybe<UserInfoBoolExp>;
  _or?: InputMaybe<Array<UserInfoBoolExp>>;
  birthday?: InputMaybe<DateComparisonExp>;
  edit_user_id?: InputMaybe<IntComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  gender_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  phone?: InputMaybe<StringComparisonExp>;
  telegram?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UserBoolExp>;
  user_id?: InputMaybe<IntComparisonExp>;
  whatsapp?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "user_info" */
export enum UserInfoConstraint {
  /** unique or primary key constraint on columns "user_id" */
  UserInfoPkey = 'user_info_pkey'
}

/** input type for incrementing numeric columns in table "user_info" */
export type UserInfoIncInput = {
  edit_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_info" */
export type UserInfoInsertInput = {
  birthday?: InputMaybe<Scalars['date']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  gender_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  telegram?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UserObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['Int']>;
  whatsapp?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type UserInfoMaxFields = {
  birthday?: Maybe<Scalars['date']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  gender_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  telegram?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  whatsapp?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type UserInfoMinFields = {
  birthday?: Maybe<Scalars['date']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  gender_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  telegram?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  whatsapp?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_info" */
export type UserInfoMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserInfo>;
};

/** input type for inserting object relation for remote table "user_info" */
export type UserInfoObjRelInsertInput = {
  data: UserInfoInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<UserInfoOnConflict>;
};

/** on_conflict condition type for table "user_info" */
export type UserInfoOnConflict = {
  constraint: UserInfoConstraint;
  update_columns?: Array<UserInfoUpdateColumn>;
  where?: InputMaybe<UserInfoBoolExp>;
};

/** Ordering options when selecting data from "user_info". */
export type UserInfoOrderBy = {
  birthday?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  gender_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  phone?: InputMaybe<OrderBy>;
  telegram?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user?: InputMaybe<UserOrderBy>;
  user_id?: InputMaybe<OrderBy>;
  whatsapp?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_info */
export type UserInfoPkColumnsInput = {
  user_id: Scalars['Int'];
};

/** select columns of table "user_info" */
export enum UserInfoSelectColumn {
  /** column name */
  Birthday = 'birthday',
  /** column name */
  EditUserId = 'edit_user_id',
  /** column name */
  Email = 'email',
  /** column name */
  GenderId = 'gender_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  Telegram = 'telegram',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Whatsapp = 'whatsapp'
}

/** input type for updating data in table "user_info" */
export type UserInfoSetInput = {
  birthday?: InputMaybe<Scalars['date']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  gender_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  telegram?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  whatsapp?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type UserInfoStddevFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type UserInfoStddevPopFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type UserInfoStddevSampFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type UserInfoSumFields = {
  edit_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "user_info" */
export enum UserInfoUpdateColumn {
  /** column name */
  Birthday = 'birthday',
  /** column name */
  EditUserId = 'edit_user_id',
  /** column name */
  Email = 'email',
  /** column name */
  GenderId = 'gender_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  Telegram = 'telegram',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Whatsapp = 'whatsapp'
}

export type UserInfoUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserInfoIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserInfoSetInput>;
  where: UserInfoBoolExp;
};

/** aggregate var_pop on columns */
export type UserInfoVarPopFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type UserInfoVarSampFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type UserInfoVarianceFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** input type for inserting data into table "user" */
export type UserInsertInput = {
  activated_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  merchant_user?: InputMaybe<MerchantUserObjRelInsertInput>;
  merchant_users?: InputMaybe<MerchantUserArrRelInsertInput>;
  otp_enable?: InputMaybe<Scalars['Boolean']>;
  password_hash?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<VHasuraPermissionArrRelInsertInput>;
  registration_info?: InputMaybe<RegistrationInfoObjRelInsertInput>;
  registration_info_id?: InputMaybe<Scalars['uuid']>;
  role?: InputMaybe<RoleObjRelInsertInput>;
  role_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_activate_tokens?: InputMaybe<UserActivateTokenArrRelInsertInput>;
  user_info?: InputMaybe<UserInfoObjRelInsertInput>;
  user_secret_id?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type UserMaxFields = {
  activated_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  password_hash?: Maybe<Scalars['String']>;
  registration_info_id?: Maybe<Scalars['uuid']>;
  role_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_secret_id?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user" */
export type UserMaxOrderBy = {
  activated_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  password_hash?: InputMaybe<OrderBy>;
  registration_info_id?: InputMaybe<OrderBy>;
  role_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_secret_id?: InputMaybe<OrderBy>;
  username?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserMinFields = {
  activated_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  password_hash?: Maybe<Scalars['String']>;
  registration_info_id?: Maybe<Scalars['uuid']>;
  role_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_secret_id?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user" */
export type UserMinOrderBy = {
  activated_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  password_hash?: InputMaybe<OrderBy>;
  registration_info_id?: InputMaybe<OrderBy>;
  role_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_secret_id?: InputMaybe<OrderBy>;
  username?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user" */
export type UserMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User>;
};

/** input type for inserting object relation for remote table "user" */
export type UserObjRelInsertInput = {
  data: UserInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<UserOnConflict>;
};

/** on_conflict condition type for table "user" */
export type UserOnConflict = {
  constraint: UserConstraint;
  update_columns?: Array<UserUpdateColumn>;
  where?: InputMaybe<UserBoolExp>;
};

/** Ordering options when selecting data from "user". */
export type UserOrderBy = {
  activated_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_user?: InputMaybe<MerchantUserOrderBy>;
  merchant_users_aggregate?: InputMaybe<MerchantUserAggregateOrderBy>;
  otp_enable?: InputMaybe<OrderBy>;
  password_hash?: InputMaybe<OrderBy>;
  permissions_aggregate?: InputMaybe<VHasuraPermissionAggregateOrderBy>;
  registration_info?: InputMaybe<RegistrationInfoOrderBy>;
  registration_info_id?: InputMaybe<OrderBy>;
  role?: InputMaybe<RoleOrderBy>;
  role_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_activate_tokens_aggregate?: InputMaybe<UserActivateTokenAggregateOrderBy>;
  user_info?: InputMaybe<UserInfoOrderBy>;
  user_secret_id?: InputMaybe<OrderBy>;
  username?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user */
export type UserPkColumnsInput = {
  id: Scalars['Int'];
};

/** columns and relationships of "user_reports" */
export type UserReports = {
  data?: Maybe<Scalars['json']>;
  date_from?: Maybe<Scalars['date']>;
  date_to?: Maybe<Scalars['date']>;
  id: Scalars['Int'];
  merchant_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "user_reports" */
export type UserReportsDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "user_reports" */
export type UserReportsAggregate = {
  aggregate?: Maybe<UserReportsAggregateFields>;
  nodes: Array<UserReports>;
};

/** aggregate fields of "user_reports" */
export type UserReportsAggregateFields = {
  avg?: Maybe<UserReportsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UserReportsMaxFields>;
  min?: Maybe<UserReportsMinFields>;
  stddev?: Maybe<UserReportsStddevFields>;
  stddev_pop?: Maybe<UserReportsStddevPopFields>;
  stddev_samp?: Maybe<UserReportsStddevSampFields>;
  sum?: Maybe<UserReportsSumFields>;
  var_pop?: Maybe<UserReportsVarPopFields>;
  var_samp?: Maybe<UserReportsVarSampFields>;
  variance?: Maybe<UserReportsVarianceFields>;
};


/** aggregate fields of "user_reports" */
export type UserReportsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserReportsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type UserReportsAvgFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_reports". All fields are combined with a logical 'AND'. */
export type UserReportsBoolExp = {
  _and?: InputMaybe<Array<UserReportsBoolExp>>;
  _not?: InputMaybe<UserReportsBoolExp>;
  _or?: InputMaybe<Array<UserReportsBoolExp>>;
  data?: InputMaybe<JsonComparisonExp>;
  date_from?: InputMaybe<DateComparisonExp>;
  date_to?: InputMaybe<DateComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  user_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "user_reports" */
export enum UserReportsConstraint {
  /** unique or primary key constraint on columns "id" */
  UserReportsPkey = 'user_reports_pkey'
}

/** input type for incrementing numeric columns in table "user_reports" */
export type UserReportsIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_reports" */
export type UserReportsInsertInput = {
  data?: InputMaybe<Scalars['json']>;
  date_from?: InputMaybe<Scalars['date']>;
  date_to?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type UserReportsMaxFields = {
  date_from?: Maybe<Scalars['date']>;
  date_to?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  merchant_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type UserReportsMinFields = {
  date_from?: Maybe<Scalars['date']>;
  date_to?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  merchant_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "user_reports" */
export type UserReportsMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserReports>;
};

/** on_conflict condition type for table "user_reports" */
export type UserReportsOnConflict = {
  constraint: UserReportsConstraint;
  update_columns?: Array<UserReportsUpdateColumn>;
  where?: InputMaybe<UserReportsBoolExp>;
};

/** Ordering options when selecting data from "user_reports". */
export type UserReportsOrderBy = {
  data?: InputMaybe<OrderBy>;
  date_from?: InputMaybe<OrderBy>;
  date_to?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_reports */
export type UserReportsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "user_reports" */
export enum UserReportsSelectColumn {
  /** column name */
  Data = 'data',
  /** column name */
  DateFrom = 'date_from',
  /** column name */
  DateTo = 'date_to',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  Name = 'name',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_reports" */
export type UserReportsSetInput = {
  data?: InputMaybe<Scalars['json']>;
  date_from?: InputMaybe<Scalars['date']>;
  date_to?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type UserReportsStddevFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type UserReportsStddevPopFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type UserReportsStddevSampFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type UserReportsSumFields = {
  id?: Maybe<Scalars['Int']>;
  merchant_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "user_reports" */
export enum UserReportsUpdateColumn {
  /** column name */
  Data = 'data',
  /** column name */
  DateFrom = 'date_from',
  /** column name */
  DateTo = 'date_to',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  Name = 'name',
  /** column name */
  UserId = 'user_id'
}

export type UserReportsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserReportsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserReportsSetInput>;
  where: UserReportsBoolExp;
};

/** aggregate var_pop on columns */
export type UserReportsVarPopFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type UserReportsVarSampFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type UserReportsVarianceFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** select columns of table "user" */
export enum UserSelectColumn {
  /** column name */
  ActivatedAt = 'activated_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EditUserId = 'edit_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  OtpEnable = 'otp_enable',
  /** column name */
  PasswordHash = 'password_hash',
  /** column name */
  RegistrationInfoId = 'registration_info_id',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserSecretId = 'user_secret_id',
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "user" */
export type UserSetInput = {
  activated_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  otp_enable?: InputMaybe<Scalars['Boolean']>;
  password_hash?: InputMaybe<Scalars['String']>;
  registration_info_id?: InputMaybe<Scalars['uuid']>;
  role_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_secret_id?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type UserStddevFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user" */
export type UserStddevOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type UserStddevPopFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user" */
export type UserStddevPopOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type UserStddevSampFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user" */
export type UserStddevSampOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type UserSumFields = {
  edit_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user" */
export type UserSumOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "user" */
export enum UserUpdateColumn {
  /** column name */
  ActivatedAt = 'activated_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EditUserId = 'edit_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  OtpEnable = 'otp_enable',
  /** column name */
  PasswordHash = 'password_hash',
  /** column name */
  RegistrationInfoId = 'registration_info_id',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserSecretId = 'user_secret_id',
  /** column name */
  Username = 'username'
}

export type UserUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserSetInput>;
  where: UserBoolExp;
};

/** aggregate var_pop on columns */
export type UserVarPopFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user" */
export type UserVarPopOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type UserVarSampFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user" */
export type UserVarSampOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type UserVarianceFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user" */
export type UserVarianceOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidComparisonExp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "v_active_gate" */
export type VActiveGate = {
  alias?: Maybe<Scalars['String']>;
  blocked_at?: Maybe<Scalars['timestamptz']>;
  card_system?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  fee?: Maybe<VLkGateFee>;
  /** An object relationship */
  gate_group?: Maybe<GateGroup>;
  gate_group_id?: Maybe<Scalars['String']>;
  gate_type_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  input_currency_id?: Maybe<Scalars['String']>;
  merchant_constant_fee?: Maybe<Scalars['numeric']>;
  merchant_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  payment_system?: Maybe<Scalars['String']>;
  /** An array relationship */
  permissions: Array<VHasuraPermission>;
  /** An aggregate relationship */
  permissions_aggregate: VHasuraPermissionAggregate;
  /** An object relationship */
  provider?: Maybe<Provider>;
  provider_id?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['timestamptz']>;
  rolling_reserve_duration?: Maybe<Scalars['Int']>;
  rolling_reserve_percent?: Maybe<Scalars['numeric']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  sort?: Maybe<Scalars['Int']>;
  traffic_type_id?: Maybe<Scalars['String']>;
  transaction_fee_amount?: Maybe<Scalars['numeric']>;
  unlocked_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  v_admin_gate_list?: Maybe<VAdminGateList>;
};


/** columns and relationships of "v_active_gate" */
export type VActiveGateCardSystemArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "v_active_gate" */
export type VActiveGatePermissionsArgs = {
  distinct_on?: InputMaybe<Array<VHasuraPermissionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VHasuraPermissionOrderBy>>;
  where?: InputMaybe<VHasuraPermissionBoolExp>;
};


/** columns and relationships of "v_active_gate" */
export type VActiveGatePermissionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<VHasuraPermissionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VHasuraPermissionOrderBy>>;
  where?: InputMaybe<VHasuraPermissionBoolExp>;
};

/** aggregated selection of "v_active_gate" */
export type VActiveGateAggregate = {
  aggregate?: Maybe<VActiveGateAggregateFields>;
  nodes: Array<VActiveGate>;
};

/** aggregate fields of "v_active_gate" */
export type VActiveGateAggregateFields = {
  avg?: Maybe<VActiveGateAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<VActiveGateMaxFields>;
  min?: Maybe<VActiveGateMinFields>;
  stddev?: Maybe<VActiveGateStddevFields>;
  stddev_pop?: Maybe<VActiveGateStddevPopFields>;
  stddev_samp?: Maybe<VActiveGateStddevSampFields>;
  sum?: Maybe<VActiveGateSumFields>;
  var_pop?: Maybe<VActiveGateVarPopFields>;
  var_samp?: Maybe<VActiveGateVarSampFields>;
  variance?: Maybe<VActiveGateVarianceFields>;
};


/** aggregate fields of "v_active_gate" */
export type VActiveGateAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VActiveGateSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "v_active_gate" */
export type VActiveGateAggregateOrderBy = {
  avg?: InputMaybe<VActiveGateAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VActiveGateMaxOrderBy>;
  min?: InputMaybe<VActiveGateMinOrderBy>;
  stddev?: InputMaybe<VActiveGateStddevOrderBy>;
  stddev_pop?: InputMaybe<VActiveGateStddevPopOrderBy>;
  stddev_samp?: InputMaybe<VActiveGateStddevSampOrderBy>;
  sum?: InputMaybe<VActiveGateSumOrderBy>;
  var_pop?: InputMaybe<VActiveGateVarPopOrderBy>;
  var_samp?: InputMaybe<VActiveGateVarSampOrderBy>;
  variance?: InputMaybe<VActiveGateVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type VActiveGateAppendInput = {
  card_system?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "v_active_gate" */
export type VActiveGateArrRelInsertInput = {
  data: Array<VActiveGateInsertInput>;
};

/** aggregate avg on columns */
export type VActiveGateAvgFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "v_active_gate" */
export type VActiveGateAvgOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  merchant_constant_fee?: InputMaybe<OrderBy>;
  merchant_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_fee_percent?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_transaction_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
  transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "v_active_gate". All fields are combined with a logical 'AND'. */
export type VActiveGateBoolExp = {
  _and?: InputMaybe<Array<VActiveGateBoolExp>>;
  _not?: InputMaybe<VActiveGateBoolExp>;
  _or?: InputMaybe<Array<VActiveGateBoolExp>>;
  alias?: InputMaybe<StringComparisonExp>;
  blocked_at?: InputMaybe<TimestamptzComparisonExp>;
  card_system?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  currency_id?: InputMaybe<StringComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  edit_user_id?: InputMaybe<IntComparisonExp>;
  fee?: InputMaybe<VLkGateFeeBoolExp>;
  gate_group?: InputMaybe<GateGroupBoolExp>;
  gate_group_id?: InputMaybe<StringComparisonExp>;
  gate_type_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  input_currency_id?: InputMaybe<StringComparisonExp>;
  merchant_constant_fee?: InputMaybe<NumericComparisonExp>;
  merchant_fee_min_amount?: InputMaybe<NumericComparisonExp>;
  merchant_fee_percent?: InputMaybe<NumericComparisonExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<NumericComparisonExp>;
  merchant_transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
  payment_system?: InputMaybe<StringComparisonExp>;
  permissions?: InputMaybe<VHasuraPermissionBoolExp>;
  provider?: InputMaybe<ProviderBoolExp>;
  provider_id?: InputMaybe<StringComparisonExp>;
  published_at?: InputMaybe<TimestamptzComparisonExp>;
  rolling_reserve_duration?: InputMaybe<IntComparisonExp>;
  rolling_reserve_percent?: InputMaybe<NumericComparisonExp>;
  settlement_usdt_fee_percent?: InputMaybe<NumericComparisonExp>;
  sort?: InputMaybe<IntComparisonExp>;
  traffic_type_id?: InputMaybe<StringComparisonExp>;
  transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
  unlocked_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  v_admin_gate_list?: InputMaybe<VAdminGateListBoolExp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type VActiveGateDeleteAtPathInput = {
  card_system?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type VActiveGateDeleteElemInput = {
  card_system?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type VActiveGateDeleteKeyInput = {
  card_system?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "v_active_gate" */
export type VActiveGateIncInput = {
  edit_user_id?: InputMaybe<Scalars['Int']>;
  merchant_constant_fee?: InputMaybe<Scalars['numeric']>;
  merchant_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  rolling_reserve_duration?: InputMaybe<Scalars['Int']>;
  rolling_reserve_percent?: InputMaybe<Scalars['numeric']>;
  settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  sort?: InputMaybe<Scalars['Int']>;
  transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "v_active_gate" */
export type VActiveGateInsertInput = {
  alias?: InputMaybe<Scalars['String']>;
  blocked_at?: InputMaybe<Scalars['timestamptz']>;
  card_system?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency_id?: InputMaybe<Scalars['String']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  fee?: InputMaybe<VLkGateFeeObjRelInsertInput>;
  gate_group?: InputMaybe<GateGroupObjRelInsertInput>;
  gate_group_id?: InputMaybe<Scalars['String']>;
  gate_type_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  input_currency_id?: InputMaybe<Scalars['String']>;
  merchant_constant_fee?: InputMaybe<Scalars['numeric']>;
  merchant_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  payment_system?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<VHasuraPermissionArrRelInsertInput>;
  provider?: InputMaybe<ProviderObjRelInsertInput>;
  provider_id?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['timestamptz']>;
  rolling_reserve_duration?: InputMaybe<Scalars['Int']>;
  rolling_reserve_percent?: InputMaybe<Scalars['numeric']>;
  settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  sort?: InputMaybe<Scalars['Int']>;
  traffic_type_id?: InputMaybe<Scalars['String']>;
  transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  unlocked_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  v_admin_gate_list?: InputMaybe<VAdminGateListObjRelInsertInput>;
};

/** aggregate max on columns */
export type VActiveGateMaxFields = {
  alias?: Maybe<Scalars['String']>;
  blocked_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  gate_group_id?: Maybe<Scalars['String']>;
  gate_type_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  input_currency_id?: Maybe<Scalars['String']>;
  merchant_constant_fee?: Maybe<Scalars['numeric']>;
  merchant_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  payment_system?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['timestamptz']>;
  rolling_reserve_duration?: Maybe<Scalars['Int']>;
  rolling_reserve_percent?: Maybe<Scalars['numeric']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  sort?: Maybe<Scalars['Int']>;
  traffic_type_id?: Maybe<Scalars['String']>;
  transaction_fee_amount?: Maybe<Scalars['numeric']>;
  unlocked_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "v_active_gate" */
export type VActiveGateMaxOrderBy = {
  alias?: InputMaybe<OrderBy>;
  blocked_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  gate_group_id?: InputMaybe<OrderBy>;
  gate_type_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_id?: InputMaybe<OrderBy>;
  merchant_constant_fee?: InputMaybe<OrderBy>;
  merchant_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_fee_percent?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_transaction_fee_amount?: InputMaybe<OrderBy>;
  payment_system?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  published_at?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
  traffic_type_id?: InputMaybe<OrderBy>;
  transaction_fee_amount?: InputMaybe<OrderBy>;
  unlocked_at?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VActiveGateMinFields = {
  alias?: Maybe<Scalars['String']>;
  blocked_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  edit_user_id?: Maybe<Scalars['Int']>;
  gate_group_id?: Maybe<Scalars['String']>;
  gate_type_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  input_currency_id?: Maybe<Scalars['String']>;
  merchant_constant_fee?: Maybe<Scalars['numeric']>;
  merchant_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  payment_system?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['timestamptz']>;
  rolling_reserve_duration?: Maybe<Scalars['Int']>;
  rolling_reserve_percent?: Maybe<Scalars['numeric']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  sort?: Maybe<Scalars['Int']>;
  traffic_type_id?: Maybe<Scalars['String']>;
  transaction_fee_amount?: Maybe<Scalars['numeric']>;
  unlocked_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "v_active_gate" */
export type VActiveGateMinOrderBy = {
  alias?: InputMaybe<OrderBy>;
  blocked_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  gate_group_id?: InputMaybe<OrderBy>;
  gate_type_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_id?: InputMaybe<OrderBy>;
  merchant_constant_fee?: InputMaybe<OrderBy>;
  merchant_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_fee_percent?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_transaction_fee_amount?: InputMaybe<OrderBy>;
  payment_system?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  published_at?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
  traffic_type_id?: InputMaybe<OrderBy>;
  transaction_fee_amount?: InputMaybe<OrderBy>;
  unlocked_at?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "v_active_gate" */
export type VActiveGateMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VActiveGate>;
};

/** input type for inserting object relation for remote table "v_active_gate" */
export type VActiveGateObjRelInsertInput = {
  data: VActiveGateInsertInput;
};

/** Ordering options when selecting data from "v_active_gate". */
export type VActiveGateOrderBy = {
  alias?: InputMaybe<OrderBy>;
  blocked_at?: InputMaybe<OrderBy>;
  card_system?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  edit_user_id?: InputMaybe<OrderBy>;
  fee?: InputMaybe<VLkGateFeeOrderBy>;
  gate_group?: InputMaybe<GateGroupOrderBy>;
  gate_group_id?: InputMaybe<OrderBy>;
  gate_type_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_id?: InputMaybe<OrderBy>;
  merchant_constant_fee?: InputMaybe<OrderBy>;
  merchant_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_fee_percent?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_transaction_fee_amount?: InputMaybe<OrderBy>;
  payment_system?: InputMaybe<OrderBy>;
  permissions_aggregate?: InputMaybe<VHasuraPermissionAggregateOrderBy>;
  provider?: InputMaybe<ProviderOrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  published_at?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
  traffic_type_id?: InputMaybe<OrderBy>;
  transaction_fee_amount?: InputMaybe<OrderBy>;
  unlocked_at?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  v_admin_gate_list?: InputMaybe<VAdminGateListOrderBy>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type VActiveGatePrependInput = {
  card_system?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "v_active_gate" */
export enum VActiveGateSelectColumn {
  /** column name */
  Alias = 'alias',
  /** column name */
  BlockedAt = 'blocked_at',
  /** column name */
  CardSystem = 'card_system',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EditUserId = 'edit_user_id',
  /** column name */
  GateGroupId = 'gate_group_id',
  /** column name */
  GateTypeId = 'gate_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  InputCurrencyId = 'input_currency_id',
  /** column name */
  MerchantConstantFee = 'merchant_constant_fee',
  /** column name */
  MerchantFeeMinAmount = 'merchant_fee_min_amount',
  /** column name */
  MerchantFeePercent = 'merchant_fee_percent',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MerchantSettlementUsdtFeePercent = 'merchant_settlement_usdt_fee_percent',
  /** column name */
  MerchantTransactionFeeAmount = 'merchant_transaction_fee_amount',
  /** column name */
  PaymentSystem = 'payment_system',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  PublishedAt = 'published_at',
  /** column name */
  RollingReserveDuration = 'rolling_reserve_duration',
  /** column name */
  RollingReservePercent = 'rolling_reserve_percent',
  /** column name */
  SettlementUsdtFeePercent = 'settlement_usdt_fee_percent',
  /** column name */
  Sort = 'sort',
  /** column name */
  TrafficTypeId = 'traffic_type_id',
  /** column name */
  TransactionFeeAmount = 'transaction_fee_amount',
  /** column name */
  UnlockedAt = 'unlocked_at',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "v_active_gate" */
export type VActiveGateSetInput = {
  alias?: InputMaybe<Scalars['String']>;
  blocked_at?: InputMaybe<Scalars['timestamptz']>;
  card_system?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency_id?: InputMaybe<Scalars['String']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  edit_user_id?: InputMaybe<Scalars['Int']>;
  gate_group_id?: InputMaybe<Scalars['String']>;
  gate_type_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  input_currency_id?: InputMaybe<Scalars['String']>;
  merchant_constant_fee?: InputMaybe<Scalars['numeric']>;
  merchant_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  payment_system?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['timestamptz']>;
  rolling_reserve_duration?: InputMaybe<Scalars['Int']>;
  rolling_reserve_percent?: InputMaybe<Scalars['numeric']>;
  settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  sort?: InputMaybe<Scalars['Int']>;
  traffic_type_id?: InputMaybe<Scalars['String']>;
  transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  unlocked_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type VActiveGateStddevFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "v_active_gate" */
export type VActiveGateStddevOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  merchant_constant_fee?: InputMaybe<OrderBy>;
  merchant_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_fee_percent?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_transaction_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
  transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type VActiveGateStddevPopFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "v_active_gate" */
export type VActiveGateStddevPopOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  merchant_constant_fee?: InputMaybe<OrderBy>;
  merchant_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_fee_percent?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_transaction_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
  transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type VActiveGateStddevSampFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "v_active_gate" */
export type VActiveGateStddevSampOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  merchant_constant_fee?: InputMaybe<OrderBy>;
  merchant_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_fee_percent?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_transaction_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
  transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type VActiveGateSumFields = {
  edit_user_id?: Maybe<Scalars['Int']>;
  merchant_constant_fee?: Maybe<Scalars['numeric']>;
  merchant_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  rolling_reserve_duration?: Maybe<Scalars['Int']>;
  rolling_reserve_percent?: Maybe<Scalars['numeric']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  sort?: Maybe<Scalars['Int']>;
  transaction_fee_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "v_active_gate" */
export type VActiveGateSumOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  merchant_constant_fee?: InputMaybe<OrderBy>;
  merchant_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_fee_percent?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_transaction_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
  transaction_fee_amount?: InputMaybe<OrderBy>;
};

export type VActiveGateUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<VActiveGateAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<VActiveGateDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<VActiveGateDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<VActiveGateDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VActiveGateIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<VActiveGatePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VActiveGateSetInput>;
  where: VActiveGateBoolExp;
};

/** aggregate var_pop on columns */
export type VActiveGateVarPopFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "v_active_gate" */
export type VActiveGateVarPopOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  merchant_constant_fee?: InputMaybe<OrderBy>;
  merchant_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_fee_percent?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_transaction_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
  transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type VActiveGateVarSampFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "v_active_gate" */
export type VActiveGateVarSampOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  merchant_constant_fee?: InputMaybe<OrderBy>;
  merchant_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_fee_percent?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_transaction_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
  transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type VActiveGateVarianceFields = {
  edit_user_id?: Maybe<Scalars['Float']>;
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "v_active_gate" */
export type VActiveGateVarianceOrderBy = {
  edit_user_id?: InputMaybe<OrderBy>;
  merchant_constant_fee?: InputMaybe<OrderBy>;
  merchant_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_fee_percent?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_transaction_fee_amount?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
  transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "v_active_provider" */
export type VActiveProvider = {
  /** An array relationship */
  active_gate: Array<VActiveGate>;
  /** An aggregate relationship */
  active_gate_aggregate: VActiveGateAggregate;
  alias?: Maybe<Scalars['String']>;
  default_payment_system?: Maybe<Scalars['String']>;
  default_traffic_type_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  provider_status_id?: Maybe<Scalars['String']>;
  provider_type_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "v_active_provider" */
export type VActiveProviderActiveGateArgs = {
  distinct_on?: InputMaybe<Array<VActiveGateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VActiveGateOrderBy>>;
  where?: InputMaybe<VActiveGateBoolExp>;
};


/** columns and relationships of "v_active_provider" */
export type VActiveProviderActiveGateAggregateArgs = {
  distinct_on?: InputMaybe<Array<VActiveGateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VActiveGateOrderBy>>;
  where?: InputMaybe<VActiveGateBoolExp>;
};

/** aggregated selection of "v_active_provider" */
export type VActiveProviderAggregate = {
  aggregate?: Maybe<VActiveProviderAggregateFields>;
  nodes: Array<VActiveProvider>;
};

/** aggregate fields of "v_active_provider" */
export type VActiveProviderAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<VActiveProviderMaxFields>;
  min?: Maybe<VActiveProviderMinFields>;
};


/** aggregate fields of "v_active_provider" */
export type VActiveProviderAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VActiveProviderSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "v_active_provider". All fields are combined with a logical 'AND'. */
export type VActiveProviderBoolExp = {
  _and?: InputMaybe<Array<VActiveProviderBoolExp>>;
  _not?: InputMaybe<VActiveProviderBoolExp>;
  _or?: InputMaybe<Array<VActiveProviderBoolExp>>;
  active_gate?: InputMaybe<VActiveGateBoolExp>;
  alias?: InputMaybe<StringComparisonExp>;
  default_payment_system?: InputMaybe<StringComparisonExp>;
  default_traffic_type_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  provider_status_id?: InputMaybe<StringComparisonExp>;
  provider_type_id?: InputMaybe<StringComparisonExp>;
};

/** input type for inserting data into table "v_active_provider" */
export type VActiveProviderInsertInput = {
  active_gate?: InputMaybe<VActiveGateArrRelInsertInput>;
  alias?: InputMaybe<Scalars['String']>;
  default_payment_system?: InputMaybe<Scalars['String']>;
  default_traffic_type_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  provider_status_id?: InputMaybe<Scalars['String']>;
  provider_type_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type VActiveProviderMaxFields = {
  alias?: Maybe<Scalars['String']>;
  default_payment_system?: Maybe<Scalars['String']>;
  default_traffic_type_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  provider_status_id?: Maybe<Scalars['String']>;
  provider_type_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VActiveProviderMinFields = {
  alias?: Maybe<Scalars['String']>;
  default_payment_system?: Maybe<Scalars['String']>;
  default_traffic_type_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  provider_status_id?: Maybe<Scalars['String']>;
  provider_type_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "v_active_provider" */
export type VActiveProviderMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VActiveProvider>;
};

/** Ordering options when selecting data from "v_active_provider". */
export type VActiveProviderOrderBy = {
  active_gate_aggregate?: InputMaybe<VActiveGateAggregateOrderBy>;
  alias?: InputMaybe<OrderBy>;
  default_payment_system?: InputMaybe<OrderBy>;
  default_traffic_type_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  provider_status_id?: InputMaybe<OrderBy>;
  provider_type_id?: InputMaybe<OrderBy>;
};

/** select columns of table "v_active_provider" */
export enum VActiveProviderSelectColumn {
  /** column name */
  Alias = 'alias',
  /** column name */
  DefaultPaymentSystem = 'default_payment_system',
  /** column name */
  DefaultTrafficTypeId = 'default_traffic_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProviderStatusId = 'provider_status_id',
  /** column name */
  ProviderTypeId = 'provider_type_id'
}

/** input type for updating data in table "v_active_provider" */
export type VActiveProviderSetInput = {
  alias?: InputMaybe<Scalars['String']>;
  default_payment_system?: InputMaybe<Scalars['String']>;
  default_traffic_type_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  provider_status_id?: InputMaybe<Scalars['String']>;
  provider_type_id?: InputMaybe<Scalars['String']>;
};

export type VActiveProviderUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VActiveProviderSetInput>;
  where: VActiveProviderBoolExp;
};

/** columns and relationships of "v_active_rolling_reserve" */
export type VActiveRollingReserve = {
  currency_id?: Maybe<Scalars['String']>;
  gate_id?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  permissions: Array<VHasuraPermission>;
  /** An aggregate relationship */
  permissions_aggregate: VHasuraPermissionAggregate;
  provider_id?: Maybe<Scalars['String']>;
  rolling_reserve_amount?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "v_active_rolling_reserve" */
export type VActiveRollingReservePermissionsArgs = {
  distinct_on?: InputMaybe<Array<VHasuraPermissionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VHasuraPermissionOrderBy>>;
  where?: InputMaybe<VHasuraPermissionBoolExp>;
};


/** columns and relationships of "v_active_rolling_reserve" */
export type VActiveRollingReservePermissionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<VHasuraPermissionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VHasuraPermissionOrderBy>>;
  where?: InputMaybe<VHasuraPermissionBoolExp>;
};

/** aggregated selection of "v_active_rolling_reserve" */
export type VActiveRollingReserveAggregate = {
  aggregate?: Maybe<VActiveRollingReserveAggregateFields>;
  nodes: Array<VActiveRollingReserve>;
};

/** aggregate fields of "v_active_rolling_reserve" */
export type VActiveRollingReserveAggregateFields = {
  avg?: Maybe<VActiveRollingReserveAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<VActiveRollingReserveMaxFields>;
  min?: Maybe<VActiveRollingReserveMinFields>;
  stddev?: Maybe<VActiveRollingReserveStddevFields>;
  stddev_pop?: Maybe<VActiveRollingReserveStddevPopFields>;
  stddev_samp?: Maybe<VActiveRollingReserveStddevSampFields>;
  sum?: Maybe<VActiveRollingReserveSumFields>;
  var_pop?: Maybe<VActiveRollingReserveVarPopFields>;
  var_samp?: Maybe<VActiveRollingReserveVarSampFields>;
  variance?: Maybe<VActiveRollingReserveVarianceFields>;
};


/** aggregate fields of "v_active_rolling_reserve" */
export type VActiveRollingReserveAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VActiveRollingReserveSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type VActiveRollingReserveAvgFields = {
  merchant_id?: Maybe<Scalars['Float']>;
  rolling_reserve_amount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "v_active_rolling_reserve". All fields are combined with a logical 'AND'. */
export type VActiveRollingReserveBoolExp = {
  _and?: InputMaybe<Array<VActiveRollingReserveBoolExp>>;
  _not?: InputMaybe<VActiveRollingReserveBoolExp>;
  _or?: InputMaybe<Array<VActiveRollingReserveBoolExp>>;
  currency_id?: InputMaybe<StringComparisonExp>;
  gate_id?: InputMaybe<StringComparisonExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  permissions?: InputMaybe<VHasuraPermissionBoolExp>;
  provider_id?: InputMaybe<StringComparisonExp>;
  rolling_reserve_amount?: InputMaybe<NumericComparisonExp>;
};

/** aggregate max on columns */
export type VActiveRollingReserveMaxFields = {
  currency_id?: Maybe<Scalars['String']>;
  gate_id?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
  provider_id?: Maybe<Scalars['String']>;
  rolling_reserve_amount?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type VActiveRollingReserveMinFields = {
  currency_id?: Maybe<Scalars['String']>;
  gate_id?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
  provider_id?: Maybe<Scalars['String']>;
  rolling_reserve_amount?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "v_active_rolling_reserve". */
export type VActiveRollingReserveOrderBy = {
  currency_id?: InputMaybe<OrderBy>;
  gate_id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  permissions_aggregate?: InputMaybe<VHasuraPermissionAggregateOrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  rolling_reserve_amount?: InputMaybe<OrderBy>;
};

/** select columns of table "v_active_rolling_reserve" */
export enum VActiveRollingReserveSelectColumn {
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  GateId = 'gate_id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  RollingReserveAmount = 'rolling_reserve_amount'
}

/** aggregate stddev on columns */
export type VActiveRollingReserveStddevFields = {
  merchant_id?: Maybe<Scalars['Float']>;
  rolling_reserve_amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VActiveRollingReserveStddevPopFields = {
  merchant_id?: Maybe<Scalars['Float']>;
  rolling_reserve_amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VActiveRollingReserveStddevSampFields = {
  merchant_id?: Maybe<Scalars['Float']>;
  rolling_reserve_amount?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type VActiveRollingReserveSumFields = {
  merchant_id?: Maybe<Scalars['Int']>;
  rolling_reserve_amount?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type VActiveRollingReserveVarPopFields = {
  merchant_id?: Maybe<Scalars['Float']>;
  rolling_reserve_amount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VActiveRollingReserveVarSampFields = {
  merchant_id?: Maybe<Scalars['Float']>;
  rolling_reserve_amount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VActiveRollingReserveVarianceFields = {
  merchant_id?: Maybe<Scalars['Float']>;
  rolling_reserve_amount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "v_admin_chargeback" */
export type VAdminChargeback = {
  amount?: Maybe<Scalars['numeric']>;
  chargeback_fee?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  gate_group_name?: Maybe<Scalars['String']>;
  gate_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoice_transaction_uid?: Maybe<Scalars['String']>;
  is_paid?: Maybe<Scalars['Boolean']>;
  merchant_id?: Maybe<Scalars['Int']>;
  provider_id?: Maybe<Scalars['String']>;
  withdraw_transaction_uid?: Maybe<Scalars['String']>;
};

/** aggregated selection of "v_admin_chargeback" */
export type VAdminChargebackAggregate = {
  aggregate?: Maybe<VAdminChargebackAggregateFields>;
  nodes: Array<VAdminChargeback>;
};

/** aggregate fields of "v_admin_chargeback" */
export type VAdminChargebackAggregateFields = {
  avg?: Maybe<VAdminChargebackAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<VAdminChargebackMaxFields>;
  min?: Maybe<VAdminChargebackMinFields>;
  stddev?: Maybe<VAdminChargebackStddevFields>;
  stddev_pop?: Maybe<VAdminChargebackStddevPopFields>;
  stddev_samp?: Maybe<VAdminChargebackStddevSampFields>;
  sum?: Maybe<VAdminChargebackSumFields>;
  var_pop?: Maybe<VAdminChargebackVarPopFields>;
  var_samp?: Maybe<VAdminChargebackVarSampFields>;
  variance?: Maybe<VAdminChargebackVarianceFields>;
};


/** aggregate fields of "v_admin_chargeback" */
export type VAdminChargebackAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VAdminChargebackSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type VAdminChargebackAvgFields = {
  amount?: Maybe<Scalars['Float']>;
  chargeback_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "v_admin_chargeback". All fields are combined with a logical 'AND'. */
export type VAdminChargebackBoolExp = {
  _and?: InputMaybe<Array<VAdminChargebackBoolExp>>;
  _not?: InputMaybe<VAdminChargebackBoolExp>;
  _or?: InputMaybe<Array<VAdminChargebackBoolExp>>;
  amount?: InputMaybe<NumericComparisonExp>;
  chargeback_fee?: InputMaybe<NumericComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  currency_id?: InputMaybe<StringComparisonExp>;
  gate_group_name?: InputMaybe<StringComparisonExp>;
  gate_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  invoice_transaction_uid?: InputMaybe<StringComparisonExp>;
  is_paid?: InputMaybe<BooleanComparisonExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  provider_id?: InputMaybe<StringComparisonExp>;
  withdraw_transaction_uid?: InputMaybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type VAdminChargebackMaxFields = {
  amount?: Maybe<Scalars['numeric']>;
  chargeback_fee?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  gate_group_name?: Maybe<Scalars['String']>;
  gate_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoice_transaction_uid?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
  provider_id?: Maybe<Scalars['String']>;
  withdraw_transaction_uid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VAdminChargebackMinFields = {
  amount?: Maybe<Scalars['numeric']>;
  chargeback_fee?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  gate_group_name?: Maybe<Scalars['String']>;
  gate_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoice_transaction_uid?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
  provider_id?: Maybe<Scalars['String']>;
  withdraw_transaction_uid?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "v_admin_chargeback". */
export type VAdminChargebackOrderBy = {
  amount?: InputMaybe<OrderBy>;
  chargeback_fee?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  gate_group_name?: InputMaybe<OrderBy>;
  gate_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_transaction_uid?: InputMaybe<OrderBy>;
  is_paid?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  withdraw_transaction_uid?: InputMaybe<OrderBy>;
};

/** select columns of table "v_admin_chargeback" */
export enum VAdminChargebackSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  ChargebackFee = 'chargeback_fee',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  GateGroupName = 'gate_group_name',
  /** column name */
  GateId = 'gate_id',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceTransactionUid = 'invoice_transaction_uid',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  WithdrawTransactionUid = 'withdraw_transaction_uid'
}

/** aggregate stddev on columns */
export type VAdminChargebackStddevFields = {
  amount?: Maybe<Scalars['Float']>;
  chargeback_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VAdminChargebackStddevPopFields = {
  amount?: Maybe<Scalars['Float']>;
  chargeback_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VAdminChargebackStddevSampFields = {
  amount?: Maybe<Scalars['Float']>;
  chargeback_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type VAdminChargebackSumFields = {
  amount?: Maybe<Scalars['numeric']>;
  chargeback_fee?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type VAdminChargebackVarPopFields = {
  amount?: Maybe<Scalars['Float']>;
  chargeback_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VAdminChargebackVarSampFields = {
  amount?: Maybe<Scalars['Float']>;
  chargeback_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VAdminChargebackVarianceFields = {
  amount?: Maybe<Scalars['Float']>;
  chargeback_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "v_admin_gate_list" */
export type VAdminGateList = {
  alias?: Maybe<Scalars['String']>;
  card_system?: Maybe<Scalars['jsonb']>;
  currency_id?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  gate_group_name?: Maybe<Scalars['String']>;
  gate_type_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  merchant_constant_fee?: Maybe<Scalars['numeric']>;
  merchant_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  payment_limit_amount?: Maybe<Scalars['numeric']>;
  payment_limit_duration?: Maybe<Scalars['Int']>;
  payment_system?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['timestamptz']>;
  rolling_reserve_duration?: Maybe<Scalars['Int']>;
  rolling_reserve_percent?: Maybe<Scalars['numeric']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  transaction_fee_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  v_active_gate?: Maybe<VActiveGate>;
};


/** columns and relationships of "v_admin_gate_list" */
export type VAdminGateListCardSystemArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "v_admin_gate_list" */
export type VAdminGateListAggregate = {
  aggregate?: Maybe<VAdminGateListAggregateFields>;
  nodes: Array<VAdminGateList>;
};

/** aggregate fields of "v_admin_gate_list" */
export type VAdminGateListAggregateFields = {
  avg?: Maybe<VAdminGateListAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<VAdminGateListMaxFields>;
  min?: Maybe<VAdminGateListMinFields>;
  stddev?: Maybe<VAdminGateListStddevFields>;
  stddev_pop?: Maybe<VAdminGateListStddevPopFields>;
  stddev_samp?: Maybe<VAdminGateListStddevSampFields>;
  sum?: Maybe<VAdminGateListSumFields>;
  var_pop?: Maybe<VAdminGateListVarPopFields>;
  var_samp?: Maybe<VAdminGateListVarSampFields>;
  variance?: Maybe<VAdminGateListVarianceFields>;
};


/** aggregate fields of "v_admin_gate_list" */
export type VAdminGateListAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VAdminGateListSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type VAdminGateListAvgFields = {
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
  payment_limit_amount?: Maybe<Scalars['Float']>;
  payment_limit_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "v_admin_gate_list". All fields are combined with a logical 'AND'. */
export type VAdminGateListBoolExp = {
  _and?: InputMaybe<Array<VAdminGateListBoolExp>>;
  _not?: InputMaybe<VAdminGateListBoolExp>;
  _or?: InputMaybe<Array<VAdminGateListBoolExp>>;
  alias?: InputMaybe<StringComparisonExp>;
  card_system?: InputMaybe<JsonbComparisonExp>;
  currency_id?: InputMaybe<StringComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  gate_group_name?: InputMaybe<StringComparisonExp>;
  gate_type_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  merchant_constant_fee?: InputMaybe<NumericComparisonExp>;
  merchant_fee_min_amount?: InputMaybe<NumericComparisonExp>;
  merchant_fee_percent?: InputMaybe<NumericComparisonExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<NumericComparisonExp>;
  merchant_transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
  payment_limit_amount?: InputMaybe<NumericComparisonExp>;
  payment_limit_duration?: InputMaybe<IntComparisonExp>;
  payment_system?: InputMaybe<StringComparisonExp>;
  provider_id?: InputMaybe<StringComparisonExp>;
  published_at?: InputMaybe<TimestamptzComparisonExp>;
  rolling_reserve_duration?: InputMaybe<IntComparisonExp>;
  rolling_reserve_percent?: InputMaybe<NumericComparisonExp>;
  settlement_usdt_fee_percent?: InputMaybe<NumericComparisonExp>;
  transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  v_active_gate?: InputMaybe<VActiveGateBoolExp>;
};

/** input type for inserting data into table "v_admin_gate_list" */
export type VAdminGateListInsertInput = {
  alias?: InputMaybe<Scalars['String']>;
  card_system?: InputMaybe<Scalars['jsonb']>;
  currency_id?: InputMaybe<Scalars['String']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  gate_group_name?: InputMaybe<Scalars['String']>;
  gate_type_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  merchant_constant_fee?: InputMaybe<Scalars['numeric']>;
  merchant_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  payment_limit_amount?: InputMaybe<Scalars['numeric']>;
  payment_limit_duration?: InputMaybe<Scalars['Int']>;
  payment_system?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['timestamptz']>;
  rolling_reserve_duration?: InputMaybe<Scalars['Int']>;
  rolling_reserve_percent?: InputMaybe<Scalars['numeric']>;
  settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  v_active_gate?: InputMaybe<VActiveGateObjRelInsertInput>;
};

/** aggregate max on columns */
export type VAdminGateListMaxFields = {
  alias?: Maybe<Scalars['String']>;
  currency_id?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  gate_group_name?: Maybe<Scalars['String']>;
  gate_type_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  merchant_constant_fee?: Maybe<Scalars['numeric']>;
  merchant_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  payment_limit_amount?: Maybe<Scalars['numeric']>;
  payment_limit_duration?: Maybe<Scalars['Int']>;
  payment_system?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['timestamptz']>;
  rolling_reserve_duration?: Maybe<Scalars['Int']>;
  rolling_reserve_percent?: Maybe<Scalars['numeric']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  transaction_fee_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type VAdminGateListMinFields = {
  alias?: Maybe<Scalars['String']>;
  currency_id?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  gate_group_name?: Maybe<Scalars['String']>;
  gate_type_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  merchant_constant_fee?: Maybe<Scalars['numeric']>;
  merchant_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  payment_limit_amount?: Maybe<Scalars['numeric']>;
  payment_limit_duration?: Maybe<Scalars['Int']>;
  payment_system?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['timestamptz']>;
  rolling_reserve_duration?: Maybe<Scalars['Int']>;
  rolling_reserve_percent?: Maybe<Scalars['numeric']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  transaction_fee_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** input type for inserting object relation for remote table "v_admin_gate_list" */
export type VAdminGateListObjRelInsertInput = {
  data: VAdminGateListInsertInput;
};

/** Ordering options when selecting data from "v_admin_gate_list". */
export type VAdminGateListOrderBy = {
  alias?: InputMaybe<OrderBy>;
  card_system?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  gate_group_name?: InputMaybe<OrderBy>;
  gate_type_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_constant_fee?: InputMaybe<OrderBy>;
  merchant_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_fee_percent?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_transaction_fee_amount?: InputMaybe<OrderBy>;
  payment_limit_amount?: InputMaybe<OrderBy>;
  payment_limit_duration?: InputMaybe<OrderBy>;
  payment_system?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  published_at?: InputMaybe<OrderBy>;
  rolling_reserve_duration?: InputMaybe<OrderBy>;
  rolling_reserve_percent?: InputMaybe<OrderBy>;
  settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  transaction_fee_amount?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  v_active_gate?: InputMaybe<VActiveGateOrderBy>;
};

/** select columns of table "v_admin_gate_list" */
export enum VAdminGateListSelectColumn {
  /** column name */
  Alias = 'alias',
  /** column name */
  CardSystem = 'card_system',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  GateGroupName = 'gate_group_name',
  /** column name */
  GateTypeId = 'gate_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantConstantFee = 'merchant_constant_fee',
  /** column name */
  MerchantFeeMinAmount = 'merchant_fee_min_amount',
  /** column name */
  MerchantFeePercent = 'merchant_fee_percent',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MerchantSettlementUsdtFeePercent = 'merchant_settlement_usdt_fee_percent',
  /** column name */
  MerchantTransactionFeeAmount = 'merchant_transaction_fee_amount',
  /** column name */
  PaymentLimitAmount = 'payment_limit_amount',
  /** column name */
  PaymentLimitDuration = 'payment_limit_duration',
  /** column name */
  PaymentSystem = 'payment_system',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  PublishedAt = 'published_at',
  /** column name */
  RollingReserveDuration = 'rolling_reserve_duration',
  /** column name */
  RollingReservePercent = 'rolling_reserve_percent',
  /** column name */
  SettlementUsdtFeePercent = 'settlement_usdt_fee_percent',
  /** column name */
  TransactionFeeAmount = 'transaction_fee_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type VAdminGateListStddevFields = {
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
  payment_limit_amount?: Maybe<Scalars['Float']>;
  payment_limit_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VAdminGateListStddevPopFields = {
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
  payment_limit_amount?: Maybe<Scalars['Float']>;
  payment_limit_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VAdminGateListStddevSampFields = {
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
  payment_limit_amount?: Maybe<Scalars['Float']>;
  payment_limit_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type VAdminGateListSumFields = {
  merchant_constant_fee?: Maybe<Scalars['numeric']>;
  merchant_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  payment_limit_amount?: Maybe<Scalars['numeric']>;
  payment_limit_duration?: Maybe<Scalars['Int']>;
  rolling_reserve_duration?: Maybe<Scalars['Int']>;
  rolling_reserve_percent?: Maybe<Scalars['numeric']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  transaction_fee_amount?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type VAdminGateListVarPopFields = {
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
  payment_limit_amount?: Maybe<Scalars['Float']>;
  payment_limit_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VAdminGateListVarSampFields = {
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
  payment_limit_amount?: Maybe<Scalars['Float']>;
  payment_limit_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VAdminGateListVarianceFields = {
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
  payment_limit_amount?: Maybe<Scalars['Float']>;
  payment_limit_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_duration?: Maybe<Scalars['Float']>;
  rolling_reserve_percent?: Maybe<Scalars['Float']>;
  settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "v_admin_merchant_list" */
export type VAdminMerchantList = {
  balances?: Maybe<Scalars['json']>;
  comment?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  gate_info?: Maybe<Scalars['json']>;
  hold_balance?: Maybe<Scalars['json']>;
  id?: Maybe<Scalars['Int']>;
  merchant_status_id?: Maybe<Scalars['String']>;
  merchant_type_id?: Maybe<Scalars['String']>;
  usernames?: Maybe<Scalars['String']>;
};


/** columns and relationships of "v_admin_merchant_list" */
export type VAdminMerchantListBalancesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "v_admin_merchant_list" */
export type VAdminMerchantListGateInfoArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "v_admin_merchant_list" */
export type VAdminMerchantListHoldBalanceArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "v_admin_merchant_list" */
export type VAdminMerchantListAggregate = {
  aggregate?: Maybe<VAdminMerchantListAggregateFields>;
  nodes: Array<VAdminMerchantList>;
};

/** aggregate fields of "v_admin_merchant_list" */
export type VAdminMerchantListAggregateFields = {
  avg?: Maybe<VAdminMerchantListAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<VAdminMerchantListMaxFields>;
  min?: Maybe<VAdminMerchantListMinFields>;
  stddev?: Maybe<VAdminMerchantListStddevFields>;
  stddev_pop?: Maybe<VAdminMerchantListStddevPopFields>;
  stddev_samp?: Maybe<VAdminMerchantListStddevSampFields>;
  sum?: Maybe<VAdminMerchantListSumFields>;
  var_pop?: Maybe<VAdminMerchantListVarPopFields>;
  var_samp?: Maybe<VAdminMerchantListVarSampFields>;
  variance?: Maybe<VAdminMerchantListVarianceFields>;
};


/** aggregate fields of "v_admin_merchant_list" */
export type VAdminMerchantListAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VAdminMerchantListSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type VAdminMerchantListAvgFields = {
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "v_admin_merchant_list". All fields are combined with a logical 'AND'. */
export type VAdminMerchantListBoolExp = {
  _and?: InputMaybe<Array<VAdminMerchantListBoolExp>>;
  _not?: InputMaybe<VAdminMerchantListBoolExp>;
  _or?: InputMaybe<Array<VAdminMerchantListBoolExp>>;
  balances?: InputMaybe<JsonComparisonExp>;
  comment?: InputMaybe<StringComparisonExp>;
  company_name?: InputMaybe<StringComparisonExp>;
  gate_info?: InputMaybe<JsonComparisonExp>;
  hold_balance?: InputMaybe<JsonComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  merchant_status_id?: InputMaybe<StringComparisonExp>;
  merchant_type_id?: InputMaybe<StringComparisonExp>;
  usernames?: InputMaybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type VAdminMerchantListMaxFields = {
  comment?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  merchant_status_id?: Maybe<Scalars['String']>;
  merchant_type_id?: Maybe<Scalars['String']>;
  usernames?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VAdminMerchantListMinFields = {
  comment?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  merchant_status_id?: Maybe<Scalars['String']>;
  merchant_type_id?: Maybe<Scalars['String']>;
  usernames?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "v_admin_merchant_list". */
export type VAdminMerchantListOrderBy = {
  balances?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  company_name?: InputMaybe<OrderBy>;
  gate_info?: InputMaybe<OrderBy>;
  hold_balance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_status_id?: InputMaybe<OrderBy>;
  merchant_type_id?: InputMaybe<OrderBy>;
  usernames?: InputMaybe<OrderBy>;
};

/** select columns of table "v_admin_merchant_list" */
export enum VAdminMerchantListSelectColumn {
  /** column name */
  Balances = 'balances',
  /** column name */
  Comment = 'comment',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  GateInfo = 'gate_info',
  /** column name */
  HoldBalance = 'hold_balance',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantStatusId = 'merchant_status_id',
  /** column name */
  MerchantTypeId = 'merchant_type_id',
  /** column name */
  Usernames = 'usernames'
}

/** aggregate stddev on columns */
export type VAdminMerchantListStddevFields = {
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VAdminMerchantListStddevPopFields = {
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VAdminMerchantListStddevSampFields = {
  id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type VAdminMerchantListSumFields = {
  id?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type VAdminMerchantListVarPopFields = {
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VAdminMerchantListVarSampFields = {
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VAdminMerchantListVarianceFields = {
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "v_admin_monitoring" */
export type VAdminMonitoring = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  event_type?: Maybe<Scalars['String']>;
  gate_group_id?: Maybe<Scalars['String']>;
  gate_group_name?: Maybe<Scalars['String']>;
  gate_group_provider_family?: Maybe<Scalars['String']>;
  gate_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  merchant_id?: Maybe<Scalars['Int']>;
  transaction_uid?: Maybe<Scalars['String']>;
};

/** aggregated selection of "v_admin_monitoring" */
export type VAdminMonitoringAggregate = {
  aggregate?: Maybe<VAdminMonitoringAggregateFields>;
  nodes: Array<VAdminMonitoring>;
};

/** aggregate fields of "v_admin_monitoring" */
export type VAdminMonitoringAggregateFields = {
  avg?: Maybe<VAdminMonitoringAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<VAdminMonitoringMaxFields>;
  min?: Maybe<VAdminMonitoringMinFields>;
  stddev?: Maybe<VAdminMonitoringStddevFields>;
  stddev_pop?: Maybe<VAdminMonitoringStddevPopFields>;
  stddev_samp?: Maybe<VAdminMonitoringStddevSampFields>;
  sum?: Maybe<VAdminMonitoringSumFields>;
  var_pop?: Maybe<VAdminMonitoringVarPopFields>;
  var_samp?: Maybe<VAdminMonitoringVarSampFields>;
  variance?: Maybe<VAdminMonitoringVarianceFields>;
};


/** aggregate fields of "v_admin_monitoring" */
export type VAdminMonitoringAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VAdminMonitoringSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type VAdminMonitoringAvgFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "v_admin_monitoring". All fields are combined with a logical 'AND'. */
export type VAdminMonitoringBoolExp = {
  _and?: InputMaybe<Array<VAdminMonitoringBoolExp>>;
  _not?: InputMaybe<VAdminMonitoringBoolExp>;
  _or?: InputMaybe<Array<VAdminMonitoringBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  event_type?: InputMaybe<StringComparisonExp>;
  gate_group_id?: InputMaybe<StringComparisonExp>;
  gate_group_name?: InputMaybe<StringComparisonExp>;
  gate_group_provider_family?: InputMaybe<StringComparisonExp>;
  gate_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  transaction_uid?: InputMaybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type VAdminMonitoringMaxFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  event_type?: Maybe<Scalars['String']>;
  gate_group_id?: Maybe<Scalars['String']>;
  gate_group_name?: Maybe<Scalars['String']>;
  gate_group_provider_family?: Maybe<Scalars['String']>;
  gate_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  merchant_id?: Maybe<Scalars['Int']>;
  transaction_uid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VAdminMonitoringMinFields = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  event_type?: Maybe<Scalars['String']>;
  gate_group_id?: Maybe<Scalars['String']>;
  gate_group_name?: Maybe<Scalars['String']>;
  gate_group_provider_family?: Maybe<Scalars['String']>;
  gate_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  merchant_id?: Maybe<Scalars['Int']>;
  transaction_uid?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "v_admin_monitoring". */
export type VAdminMonitoringOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  event_type?: InputMaybe<OrderBy>;
  gate_group_id?: InputMaybe<OrderBy>;
  gate_group_name?: InputMaybe<OrderBy>;
  gate_group_provider_family?: InputMaybe<OrderBy>;
  gate_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  transaction_uid?: InputMaybe<OrderBy>;
};

/** select columns of table "v_admin_monitoring" */
export enum VAdminMonitoringSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  EventType = 'event_type',
  /** column name */
  GateGroupId = 'gate_group_id',
  /** column name */
  GateGroupName = 'gate_group_name',
  /** column name */
  GateGroupProviderFamily = 'gate_group_provider_family',
  /** column name */
  GateId = 'gate_id',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  TransactionUid = 'transaction_uid'
}

/** aggregate stddev on columns */
export type VAdminMonitoringStddevFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VAdminMonitoringStddevPopFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VAdminMonitoringStddevSampFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type VAdminMonitoringSumFields = {
  id?: Maybe<Scalars['bigint']>;
  merchant_id?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type VAdminMonitoringVarPopFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VAdminMonitoringVarSampFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VAdminMonitoringVarianceFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "v_admin_payment_system_provider" */
export type VAdminPaymentSystemProvider = {
  id?: Maybe<Scalars['String']>;
  payment_system_name?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "v_admin_payment_system_provider" */
export type VAdminPaymentSystemProviderAggregate = {
  aggregate?: Maybe<VAdminPaymentSystemProviderAggregateFields>;
  nodes: Array<VAdminPaymentSystemProvider>;
};

/** aggregate fields of "v_admin_payment_system_provider" */
export type VAdminPaymentSystemProviderAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<VAdminPaymentSystemProviderMaxFields>;
  min?: Maybe<VAdminPaymentSystemProviderMinFields>;
};


/** aggregate fields of "v_admin_payment_system_provider" */
export type VAdminPaymentSystemProviderAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VAdminPaymentSystemProviderSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "v_admin_payment_system_provider". All fields are combined with a logical 'AND'. */
export type VAdminPaymentSystemProviderBoolExp = {
  _and?: InputMaybe<Array<VAdminPaymentSystemProviderBoolExp>>;
  _not?: InputMaybe<VAdminPaymentSystemProviderBoolExp>;
  _or?: InputMaybe<Array<VAdminPaymentSystemProviderBoolExp>>;
  id?: InputMaybe<StringComparisonExp>;
  payment_system_name?: InputMaybe<StringComparisonExp>;
  provider_id?: InputMaybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type VAdminPaymentSystemProviderMaxFields = {
  id?: Maybe<Scalars['String']>;
  payment_system_name?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VAdminPaymentSystemProviderMinFields = {
  id?: Maybe<Scalars['String']>;
  payment_system_name?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "v_admin_payment_system_provider". */
export type VAdminPaymentSystemProviderOrderBy = {
  id?: InputMaybe<OrderBy>;
  payment_system_name?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
};

/** select columns of table "v_admin_payment_system_provider" */
export enum VAdminPaymentSystemProviderSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  PaymentSystemName = 'payment_system_name',
  /** column name */
  ProviderId = 'provider_id'
}

/** columns and relationships of "v_admin_refund" */
export type VAdminRefund = {
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  gate_group_name?: Maybe<Scalars['String']>;
  gate_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoice_transaction_uid?: Maybe<Scalars['String']>;
  is_paid?: Maybe<Scalars['Boolean']>;
  merchant_id?: Maybe<Scalars['Int']>;
  provider_id?: Maybe<Scalars['String']>;
  refund_fee?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  refund_table?: Maybe<RefundTable>;
  withdraw_transaction_uid?: Maybe<Scalars['String']>;
};

/** aggregated selection of "v_admin_refund" */
export type VAdminRefundAggregate = {
  aggregate?: Maybe<VAdminRefundAggregateFields>;
  nodes: Array<VAdminRefund>;
};

/** aggregate fields of "v_admin_refund" */
export type VAdminRefundAggregateFields = {
  avg?: Maybe<VAdminRefundAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<VAdminRefundMaxFields>;
  min?: Maybe<VAdminRefundMinFields>;
  stddev?: Maybe<VAdminRefundStddevFields>;
  stddev_pop?: Maybe<VAdminRefundStddevPopFields>;
  stddev_samp?: Maybe<VAdminRefundStddevSampFields>;
  sum?: Maybe<VAdminRefundSumFields>;
  var_pop?: Maybe<VAdminRefundVarPopFields>;
  var_samp?: Maybe<VAdminRefundVarSampFields>;
  variance?: Maybe<VAdminRefundVarianceFields>;
};


/** aggregate fields of "v_admin_refund" */
export type VAdminRefundAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VAdminRefundSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type VAdminRefundAvgFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  refund_fee?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "v_admin_refund". All fields are combined with a logical 'AND'. */
export type VAdminRefundBoolExp = {
  _and?: InputMaybe<Array<VAdminRefundBoolExp>>;
  _not?: InputMaybe<VAdminRefundBoolExp>;
  _or?: InputMaybe<Array<VAdminRefundBoolExp>>;
  amount?: InputMaybe<NumericComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  currency_id?: InputMaybe<StringComparisonExp>;
  gate_group_name?: InputMaybe<StringComparisonExp>;
  gate_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  invoice_transaction_uid?: InputMaybe<StringComparisonExp>;
  is_paid?: InputMaybe<BooleanComparisonExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  provider_id?: InputMaybe<StringComparisonExp>;
  refund_fee?: InputMaybe<NumericComparisonExp>;
  refund_table?: InputMaybe<RefundTableBoolExp>;
  withdraw_transaction_uid?: InputMaybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type VAdminRefundMaxFields = {
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  gate_group_name?: Maybe<Scalars['String']>;
  gate_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoice_transaction_uid?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
  provider_id?: Maybe<Scalars['String']>;
  refund_fee?: Maybe<Scalars['numeric']>;
  withdraw_transaction_uid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VAdminRefundMinFields = {
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  gate_group_name?: Maybe<Scalars['String']>;
  gate_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoice_transaction_uid?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
  provider_id?: Maybe<Scalars['String']>;
  refund_fee?: Maybe<Scalars['numeric']>;
  withdraw_transaction_uid?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "v_admin_refund". */
export type VAdminRefundOrderBy = {
  amount?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  gate_group_name?: InputMaybe<OrderBy>;
  gate_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_transaction_uid?: InputMaybe<OrderBy>;
  is_paid?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  refund_fee?: InputMaybe<OrderBy>;
  refund_table?: InputMaybe<RefundTableOrderBy>;
  withdraw_transaction_uid?: InputMaybe<OrderBy>;
};

/** select columns of table "v_admin_refund" */
export enum VAdminRefundSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  GateGroupName = 'gate_group_name',
  /** column name */
  GateId = 'gate_id',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceTransactionUid = 'invoice_transaction_uid',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  RefundFee = 'refund_fee',
  /** column name */
  WithdrawTransactionUid = 'withdraw_transaction_uid'
}

/** aggregate stddev on columns */
export type VAdminRefundStddevFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  refund_fee?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VAdminRefundStddevPopFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  refund_fee?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VAdminRefundStddevSampFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  refund_fee?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type VAdminRefundSumFields = {
  amount?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  refund_fee?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type VAdminRefundVarPopFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  refund_fee?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VAdminRefundVarSampFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  refund_fee?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VAdminRefundVarianceFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  refund_fee?: Maybe<Scalars['Float']>;
};

/** Представление для админки, отображение списка заявок на вывод с доп информацией */
export type VAdminWithdrawRequest = {
  amount?: Maybe<Scalars['numeric']>;
  approved_at?: Maybe<Scalars['timestamptz']>;
  client_ip?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  gate_group_balance?: Maybe<Scalars['numeric']>;
  gate_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_withdraw_fee_amount?: Maybe<Scalars['numeric']>;
  phone?: Maybe<Scalars['String']>;
  provider_balance?: Maybe<Scalars['numeric']>;
  provider_id?: Maybe<Scalars['String']>;
  reject_reason?: Maybe<Scalars['String']>;
  sanitized_mask?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  total_balance?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "v_admin_withdraw_request" */
export type VAdminWithdrawRequestAggregate = {
  aggregate?: Maybe<VAdminWithdrawRequestAggregateFields>;
  nodes: Array<VAdminWithdrawRequest>;
};

/** aggregate fields of "v_admin_withdraw_request" */
export type VAdminWithdrawRequestAggregateFields = {
  avg?: Maybe<VAdminWithdrawRequestAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<VAdminWithdrawRequestMaxFields>;
  min?: Maybe<VAdminWithdrawRequestMinFields>;
  stddev?: Maybe<VAdminWithdrawRequestStddevFields>;
  stddev_pop?: Maybe<VAdminWithdrawRequestStddevPopFields>;
  stddev_samp?: Maybe<VAdminWithdrawRequestStddevSampFields>;
  sum?: Maybe<VAdminWithdrawRequestSumFields>;
  var_pop?: Maybe<VAdminWithdrawRequestVarPopFields>;
  var_samp?: Maybe<VAdminWithdrawRequestVarSampFields>;
  variance?: Maybe<VAdminWithdrawRequestVarianceFields>;
};


/** aggregate fields of "v_admin_withdraw_request" */
export type VAdminWithdrawRequestAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VAdminWithdrawRequestSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type VAdminWithdrawRequestAvgFields = {
  amount?: Maybe<Scalars['Float']>;
  gate_group_balance?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_amount?: Maybe<Scalars['Float']>;
  provider_balance?: Maybe<Scalars['Float']>;
  total_balance?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "v_admin_withdraw_request". All fields are combined with a logical 'AND'. */
export type VAdminWithdrawRequestBoolExp = {
  _and?: InputMaybe<Array<VAdminWithdrawRequestBoolExp>>;
  _not?: InputMaybe<VAdminWithdrawRequestBoolExp>;
  _or?: InputMaybe<Array<VAdminWithdrawRequestBoolExp>>;
  amount?: InputMaybe<NumericComparisonExp>;
  approved_at?: InputMaybe<TimestamptzComparisonExp>;
  client_ip?: InputMaybe<StringComparisonExp>;
  comment?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  currency_id?: InputMaybe<StringComparisonExp>;
  gate_group_balance?: InputMaybe<NumericComparisonExp>;
  gate_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  merchant_withdraw_fee_amount?: InputMaybe<NumericComparisonExp>;
  phone?: InputMaybe<StringComparisonExp>;
  provider_balance?: InputMaybe<NumericComparisonExp>;
  provider_id?: InputMaybe<StringComparisonExp>;
  reject_reason?: InputMaybe<StringComparisonExp>;
  sanitized_mask?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  total_balance?: InputMaybe<NumericComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** aggregate max on columns */
export type VAdminWithdrawRequestMaxFields = {
  amount?: Maybe<Scalars['numeric']>;
  approved_at?: Maybe<Scalars['timestamptz']>;
  client_ip?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  gate_group_balance?: Maybe<Scalars['numeric']>;
  gate_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_withdraw_fee_amount?: Maybe<Scalars['numeric']>;
  phone?: Maybe<Scalars['String']>;
  provider_balance?: Maybe<Scalars['numeric']>;
  provider_id?: Maybe<Scalars['String']>;
  reject_reason?: Maybe<Scalars['String']>;
  sanitized_mask?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  total_balance?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type VAdminWithdrawRequestMinFields = {
  amount?: Maybe<Scalars['numeric']>;
  approved_at?: Maybe<Scalars['timestamptz']>;
  client_ip?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  gate_group_balance?: Maybe<Scalars['numeric']>;
  gate_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_withdraw_fee_amount?: Maybe<Scalars['numeric']>;
  phone?: Maybe<Scalars['String']>;
  provider_balance?: Maybe<Scalars['numeric']>;
  provider_id?: Maybe<Scalars['String']>;
  reject_reason?: Maybe<Scalars['String']>;
  sanitized_mask?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  total_balance?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "v_admin_withdraw_request". */
export type VAdminWithdrawRequestOrderBy = {
  amount?: InputMaybe<OrderBy>;
  approved_at?: InputMaybe<OrderBy>;
  client_ip?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  gate_group_balance?: InputMaybe<OrderBy>;
  gate_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_amount?: InputMaybe<OrderBy>;
  phone?: InputMaybe<OrderBy>;
  provider_balance?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  reject_reason?: InputMaybe<OrderBy>;
  sanitized_mask?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  total_balance?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** select columns of table "v_admin_withdraw_request" */
export enum VAdminWithdrawRequestSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  ClientIp = 'client_ip',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  GateGroupBalance = 'gate_group_balance',
  /** column name */
  GateId = 'gate_id',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MerchantWithdrawFeeAmount = 'merchant_withdraw_fee_amount',
  /** column name */
  Phone = 'phone',
  /** column name */
  ProviderBalance = 'provider_balance',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  RejectReason = 'reject_reason',
  /** column name */
  SanitizedMask = 'sanitized_mask',
  /** column name */
  Status = 'status',
  /** column name */
  TotalBalance = 'total_balance',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type VAdminWithdrawRequestStddevFields = {
  amount?: Maybe<Scalars['Float']>;
  gate_group_balance?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_amount?: Maybe<Scalars['Float']>;
  provider_balance?: Maybe<Scalars['Float']>;
  total_balance?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VAdminWithdrawRequestStddevPopFields = {
  amount?: Maybe<Scalars['Float']>;
  gate_group_balance?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_amount?: Maybe<Scalars['Float']>;
  provider_balance?: Maybe<Scalars['Float']>;
  total_balance?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VAdminWithdrawRequestStddevSampFields = {
  amount?: Maybe<Scalars['Float']>;
  gate_group_balance?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_amount?: Maybe<Scalars['Float']>;
  provider_balance?: Maybe<Scalars['Float']>;
  total_balance?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type VAdminWithdrawRequestSumFields = {
  amount?: Maybe<Scalars['numeric']>;
  gate_group_balance?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_withdraw_fee_amount?: Maybe<Scalars['numeric']>;
  provider_balance?: Maybe<Scalars['numeric']>;
  total_balance?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type VAdminWithdrawRequestVarPopFields = {
  amount?: Maybe<Scalars['Float']>;
  gate_group_balance?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_amount?: Maybe<Scalars['Float']>;
  provider_balance?: Maybe<Scalars['Float']>;
  total_balance?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VAdminWithdrawRequestVarSampFields = {
  amount?: Maybe<Scalars['Float']>;
  gate_group_balance?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_amount?: Maybe<Scalars['Float']>;
  provider_balance?: Maybe<Scalars['Float']>;
  total_balance?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VAdminWithdrawRequestVarianceFields = {
  amount?: Maybe<Scalars['Float']>;
  gate_group_balance?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_amount?: Maybe<Scalars['Float']>;
  provider_balance?: Maybe<Scalars['Float']>;
  total_balance?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "v_gate_group_balance" */
export type VGateGroupBalance = {
  /** An array relationship */
  active_gate: Array<VActiveGate>;
  /** An aggregate relationship */
  active_gate_aggregate: VActiveGateAggregate;
  calculated_balance?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  invoice_gate_id?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  provider_family?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  withdraw_gate_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "v_gate_group_balance" */
export type VGateGroupBalanceActiveGateArgs = {
  distinct_on?: InputMaybe<Array<VActiveGateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VActiveGateOrderBy>>;
  where?: InputMaybe<VActiveGateBoolExp>;
};


/** columns and relationships of "v_gate_group_balance" */
export type VGateGroupBalanceActiveGateAggregateArgs = {
  distinct_on?: InputMaybe<Array<VActiveGateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VActiveGateOrderBy>>;
  where?: InputMaybe<VActiveGateBoolExp>;
};

/** aggregated selection of "v_gate_group_balance" */
export type VGateGroupBalanceAggregate = {
  aggregate?: Maybe<VGateGroupBalanceAggregateFields>;
  nodes: Array<VGateGroupBalance>;
};

/** aggregate fields of "v_gate_group_balance" */
export type VGateGroupBalanceAggregateFields = {
  avg?: Maybe<VGateGroupBalanceAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<VGateGroupBalanceMaxFields>;
  min?: Maybe<VGateGroupBalanceMinFields>;
  stddev?: Maybe<VGateGroupBalanceStddevFields>;
  stddev_pop?: Maybe<VGateGroupBalanceStddevPopFields>;
  stddev_samp?: Maybe<VGateGroupBalanceStddevSampFields>;
  sum?: Maybe<VGateGroupBalanceSumFields>;
  var_pop?: Maybe<VGateGroupBalanceVarPopFields>;
  var_samp?: Maybe<VGateGroupBalanceVarSampFields>;
  variance?: Maybe<VGateGroupBalanceVarianceFields>;
};


/** aggregate fields of "v_gate_group_balance" */
export type VGateGroupBalanceAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VGateGroupBalanceSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type VGateGroupBalanceAvgFields = {
  calculated_balance?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "v_gate_group_balance". All fields are combined with a logical 'AND'. */
export type VGateGroupBalanceBoolExp = {
  _and?: InputMaybe<Array<VGateGroupBalanceBoolExp>>;
  _not?: InputMaybe<VGateGroupBalanceBoolExp>;
  _or?: InputMaybe<Array<VGateGroupBalanceBoolExp>>;
  active_gate?: InputMaybe<VActiveGateBoolExp>;
  calculated_balance?: InputMaybe<NumericComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  currency_id?: InputMaybe<StringComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  invoice_gate_id?: InputMaybe<StringComparisonExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  provider_family?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  withdraw_gate_id?: InputMaybe<StringComparisonExp>;
};

/** input type for inserting data into table "v_gate_group_balance" */
export type VGateGroupBalanceInsertInput = {
  active_gate?: InputMaybe<VActiveGateArrRelInsertInput>;
  calculated_balance?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency_id?: InputMaybe<Scalars['String']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  invoice_gate_id?: InputMaybe<Scalars['String']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  provider_family?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  withdraw_gate_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type VGateGroupBalanceMaxFields = {
  calculated_balance?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  invoice_gate_id?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  provider_family?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  withdraw_gate_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VGateGroupBalanceMinFields = {
  calculated_balance?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  invoice_gate_id?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  provider_family?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  withdraw_gate_id?: Maybe<Scalars['String']>;
};

/** input type for inserting object relation for remote table "v_gate_group_balance" */
export type VGateGroupBalanceObjRelInsertInput = {
  data: VGateGroupBalanceInsertInput;
};

/** Ordering options when selecting data from "v_gate_group_balance". */
export type VGateGroupBalanceOrderBy = {
  active_gate_aggregate?: InputMaybe<VActiveGateAggregateOrderBy>;
  calculated_balance?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_gate_id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  provider_family?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  withdraw_gate_id?: InputMaybe<OrderBy>;
};

/** select columns of table "v_gate_group_balance" */
export enum VGateGroupBalanceSelectColumn {
  /** column name */
  CalculatedBalance = 'calculated_balance',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceGateId = 'invoice_gate_id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  Name = 'name',
  /** column name */
  ProviderFamily = 'provider_family',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WithdrawGateId = 'withdraw_gate_id'
}

/** aggregate stddev on columns */
export type VGateGroupBalanceStddevFields = {
  calculated_balance?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VGateGroupBalanceStddevPopFields = {
  calculated_balance?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VGateGroupBalanceStddevSampFields = {
  calculated_balance?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type VGateGroupBalanceSumFields = {
  calculated_balance?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type VGateGroupBalanceVarPopFields = {
  calculated_balance?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VGateGroupBalanceVarSampFields = {
  calculated_balance?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VGateGroupBalanceVarianceFields = {
  calculated_balance?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "v_hasura_permission" */
export type VHasuraPermission = {
  id?: Maybe<Scalars['Int']>;
  merchant_id?: Maybe<Scalars['Int']>;
  role?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "v_hasura_permission" */
export type VHasuraPermissionAggregate = {
  aggregate?: Maybe<VHasuraPermissionAggregateFields>;
  nodes: Array<VHasuraPermission>;
};

/** aggregate fields of "v_hasura_permission" */
export type VHasuraPermissionAggregateFields = {
  avg?: Maybe<VHasuraPermissionAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<VHasuraPermissionMaxFields>;
  min?: Maybe<VHasuraPermissionMinFields>;
  stddev?: Maybe<VHasuraPermissionStddevFields>;
  stddev_pop?: Maybe<VHasuraPermissionStddevPopFields>;
  stddev_samp?: Maybe<VHasuraPermissionStddevSampFields>;
  sum?: Maybe<VHasuraPermissionSumFields>;
  var_pop?: Maybe<VHasuraPermissionVarPopFields>;
  var_samp?: Maybe<VHasuraPermissionVarSampFields>;
  variance?: Maybe<VHasuraPermissionVarianceFields>;
};


/** aggregate fields of "v_hasura_permission" */
export type VHasuraPermissionAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VHasuraPermissionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "v_hasura_permission" */
export type VHasuraPermissionAggregateOrderBy = {
  avg?: InputMaybe<VHasuraPermissionAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VHasuraPermissionMaxOrderBy>;
  min?: InputMaybe<VHasuraPermissionMinOrderBy>;
  stddev?: InputMaybe<VHasuraPermissionStddevOrderBy>;
  stddev_pop?: InputMaybe<VHasuraPermissionStddevPopOrderBy>;
  stddev_samp?: InputMaybe<VHasuraPermissionStddevSampOrderBy>;
  sum?: InputMaybe<VHasuraPermissionSumOrderBy>;
  var_pop?: InputMaybe<VHasuraPermissionVarPopOrderBy>;
  var_samp?: InputMaybe<VHasuraPermissionVarSampOrderBy>;
  variance?: InputMaybe<VHasuraPermissionVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "v_hasura_permission" */
export type VHasuraPermissionArrRelInsertInput = {
  data: Array<VHasuraPermissionInsertInput>;
};

/** aggregate avg on columns */
export type VHasuraPermissionAvgFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "v_hasura_permission" */
export type VHasuraPermissionAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "v_hasura_permission". All fields are combined with a logical 'AND'. */
export type VHasuraPermissionBoolExp = {
  _and?: InputMaybe<Array<VHasuraPermissionBoolExp>>;
  _not?: InputMaybe<VHasuraPermissionBoolExp>;
  _or?: InputMaybe<Array<VHasuraPermissionBoolExp>>;
  id?: InputMaybe<IntComparisonExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  role?: InputMaybe<StringComparisonExp>;
  user_id?: InputMaybe<IntComparisonExp>;
};

/** input type for inserting data into table "v_hasura_permission" */
export type VHasuraPermissionInsertInput = {
  id?: InputMaybe<Scalars['Int']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type VHasuraPermissionMaxFields = {
  id?: Maybe<Scalars['Int']>;
  merchant_id?: Maybe<Scalars['Int']>;
  role?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "v_hasura_permission" */
export type VHasuraPermissionMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  role?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VHasuraPermissionMinFields = {
  id?: Maybe<Scalars['Int']>;
  merchant_id?: Maybe<Scalars['Int']>;
  role?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "v_hasura_permission" */
export type VHasuraPermissionMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  role?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "v_hasura_permission". */
export type VHasuraPermissionOrderBy = {
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  role?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** select columns of table "v_hasura_permission" */
export enum VHasuraPermissionSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'user_id'
}

/** aggregate stddev on columns */
export type VHasuraPermissionStddevFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "v_hasura_permission" */
export type VHasuraPermissionStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type VHasuraPermissionStddevPopFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "v_hasura_permission" */
export type VHasuraPermissionStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type VHasuraPermissionStddevSampFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "v_hasura_permission" */
export type VHasuraPermissionStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type VHasuraPermissionSumFields = {
  id?: Maybe<Scalars['Int']>;
  merchant_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "v_hasura_permission" */
export type VHasuraPermissionSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type VHasuraPermissionVarPopFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "v_hasura_permission" */
export type VHasuraPermissionVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type VHasuraPermissionVarSampFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "v_hasura_permission" */
export type VHasuraPermissionVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type VHasuraPermissionVarianceFields = {
  id?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "v_hasura_permission" */
export type VHasuraPermissionVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "v_lk_chargeback" */
export type VLkChargeback = {
  amount?: Maybe<Scalars['numeric']>;
  chargeback_fee?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  gate?: Maybe<Gate>;
  gate_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoice_transaction_uid?: Maybe<Scalars['String']>;
  /** An object relationship */
  merchant?: Maybe<Merchant>;
  merchant_id?: Maybe<Scalars['Int']>;
  withdraw_transaction_uid?: Maybe<Scalars['String']>;
};

/** aggregated selection of "v_lk_chargeback" */
export type VLkChargebackAggregate = {
  aggregate?: Maybe<VLkChargebackAggregateFields>;
  nodes: Array<VLkChargeback>;
};

/** aggregate fields of "v_lk_chargeback" */
export type VLkChargebackAggregateFields = {
  avg?: Maybe<VLkChargebackAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<VLkChargebackMaxFields>;
  min?: Maybe<VLkChargebackMinFields>;
  stddev?: Maybe<VLkChargebackStddevFields>;
  stddev_pop?: Maybe<VLkChargebackStddevPopFields>;
  stddev_samp?: Maybe<VLkChargebackStddevSampFields>;
  sum?: Maybe<VLkChargebackSumFields>;
  var_pop?: Maybe<VLkChargebackVarPopFields>;
  var_samp?: Maybe<VLkChargebackVarSampFields>;
  variance?: Maybe<VLkChargebackVarianceFields>;
};


/** aggregate fields of "v_lk_chargeback" */
export type VLkChargebackAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VLkChargebackSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type VLkChargebackAvgFields = {
  amount?: Maybe<Scalars['Float']>;
  chargeback_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "v_lk_chargeback". All fields are combined with a logical 'AND'. */
export type VLkChargebackBoolExp = {
  _and?: InputMaybe<Array<VLkChargebackBoolExp>>;
  _not?: InputMaybe<VLkChargebackBoolExp>;
  _or?: InputMaybe<Array<VLkChargebackBoolExp>>;
  amount?: InputMaybe<NumericComparisonExp>;
  chargeback_fee?: InputMaybe<NumericComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  currency_id?: InputMaybe<StringComparisonExp>;
  gate?: InputMaybe<GateBoolExp>;
  gate_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  invoice_transaction_uid?: InputMaybe<StringComparisonExp>;
  merchant?: InputMaybe<MerchantBoolExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  withdraw_transaction_uid?: InputMaybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type VLkChargebackMaxFields = {
  amount?: Maybe<Scalars['numeric']>;
  chargeback_fee?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  gate_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoice_transaction_uid?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
  withdraw_transaction_uid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VLkChargebackMinFields = {
  amount?: Maybe<Scalars['numeric']>;
  chargeback_fee?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  gate_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoice_transaction_uid?: Maybe<Scalars['String']>;
  merchant_id?: Maybe<Scalars['Int']>;
  withdraw_transaction_uid?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "v_lk_chargeback". */
export type VLkChargebackOrderBy = {
  amount?: InputMaybe<OrderBy>;
  chargeback_fee?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  gate?: InputMaybe<GateOrderBy>;
  gate_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoice_transaction_uid?: InputMaybe<OrderBy>;
  merchant?: InputMaybe<MerchantOrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  withdraw_transaction_uid?: InputMaybe<OrderBy>;
};

/** select columns of table "v_lk_chargeback" */
export enum VLkChargebackSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  ChargebackFee = 'chargeback_fee',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  GateId = 'gate_id',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceTransactionUid = 'invoice_transaction_uid',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  WithdrawTransactionUid = 'withdraw_transaction_uid'
}

/** aggregate stddev on columns */
export type VLkChargebackStddevFields = {
  amount?: Maybe<Scalars['Float']>;
  chargeback_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VLkChargebackStddevPopFields = {
  amount?: Maybe<Scalars['Float']>;
  chargeback_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VLkChargebackStddevSampFields = {
  amount?: Maybe<Scalars['Float']>;
  chargeback_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type VLkChargebackSumFields = {
  amount?: Maybe<Scalars['numeric']>;
  chargeback_fee?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type VLkChargebackVarPopFields = {
  amount?: Maybe<Scalars['Float']>;
  chargeback_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VLkChargebackVarSampFields = {
  amount?: Maybe<Scalars['Float']>;
  chargeback_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VLkChargebackVarianceFields = {
  amount?: Maybe<Scalars['Float']>;
  chargeback_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "v_lk_gate_fee" */
export type VLkGateFee = {
  /** An object relationship */
  active_gate?: Maybe<VActiveGate>;
  id?: Maybe<Scalars['String']>;
  merchant_constant_fee?: Maybe<Scalars['numeric']>;
  merchant_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "v_lk_gate_fee" */
export type VLkGateFeeAggregate = {
  aggregate?: Maybe<VLkGateFeeAggregateFields>;
  nodes: Array<VLkGateFee>;
};

/** aggregate fields of "v_lk_gate_fee" */
export type VLkGateFeeAggregateFields = {
  avg?: Maybe<VLkGateFeeAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<VLkGateFeeMaxFields>;
  min?: Maybe<VLkGateFeeMinFields>;
  stddev?: Maybe<VLkGateFeeStddevFields>;
  stddev_pop?: Maybe<VLkGateFeeStddevPopFields>;
  stddev_samp?: Maybe<VLkGateFeeStddevSampFields>;
  sum?: Maybe<VLkGateFeeSumFields>;
  var_pop?: Maybe<VLkGateFeeVarPopFields>;
  var_samp?: Maybe<VLkGateFeeVarSampFields>;
  variance?: Maybe<VLkGateFeeVarianceFields>;
};


/** aggregate fields of "v_lk_gate_fee" */
export type VLkGateFeeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VLkGateFeeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type VLkGateFeeAvgFields = {
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "v_lk_gate_fee". All fields are combined with a logical 'AND'. */
export type VLkGateFeeBoolExp = {
  _and?: InputMaybe<Array<VLkGateFeeBoolExp>>;
  _not?: InputMaybe<VLkGateFeeBoolExp>;
  _or?: InputMaybe<Array<VLkGateFeeBoolExp>>;
  active_gate?: InputMaybe<VActiveGateBoolExp>;
  id?: InputMaybe<StringComparisonExp>;
  merchant_constant_fee?: InputMaybe<NumericComparisonExp>;
  merchant_fee_min_amount?: InputMaybe<NumericComparisonExp>;
  merchant_fee_percent?: InputMaybe<NumericComparisonExp>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<NumericComparisonExp>;
  merchant_transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
};

/** input type for inserting data into table "v_lk_gate_fee" */
export type VLkGateFeeInsertInput = {
  active_gate?: InputMaybe<VActiveGateObjRelInsertInput>;
  id?: InputMaybe<Scalars['String']>;
  merchant_constant_fee?: InputMaybe<Scalars['numeric']>;
  merchant_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type VLkGateFeeMaxFields = {
  id?: Maybe<Scalars['String']>;
  merchant_constant_fee?: Maybe<Scalars['numeric']>;
  merchant_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type VLkGateFeeMinFields = {
  id?: Maybe<Scalars['String']>;
  merchant_constant_fee?: Maybe<Scalars['numeric']>;
  merchant_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['numeric']>;
};

/** input type for inserting object relation for remote table "v_lk_gate_fee" */
export type VLkGateFeeObjRelInsertInput = {
  data: VLkGateFeeInsertInput;
};

/** Ordering options when selecting data from "v_lk_gate_fee". */
export type VLkGateFeeOrderBy = {
  active_gate?: InputMaybe<VActiveGateOrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_constant_fee?: InputMaybe<OrderBy>;
  merchant_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_fee_percent?: InputMaybe<OrderBy>;
  merchant_settlement_usdt_fee_percent?: InputMaybe<OrderBy>;
  merchant_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** select columns of table "v_lk_gate_fee" */
export enum VLkGateFeeSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  MerchantConstantFee = 'merchant_constant_fee',
  /** column name */
  MerchantFeeMinAmount = 'merchant_fee_min_amount',
  /** column name */
  MerchantFeePercent = 'merchant_fee_percent',
  /** column name */
  MerchantSettlementUsdtFeePercent = 'merchant_settlement_usdt_fee_percent',
  /** column name */
  MerchantTransactionFeeAmount = 'merchant_transaction_fee_amount'
}

/** aggregate stddev on columns */
export type VLkGateFeeStddevFields = {
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VLkGateFeeStddevPopFields = {
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VLkGateFeeStddevSampFields = {
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type VLkGateFeeSumFields = {
  merchant_constant_fee?: Maybe<Scalars['numeric']>;
  merchant_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type VLkGateFeeVarPopFields = {
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VLkGateFeeVarSampFields = {
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VLkGateFeeVarianceFields = {
  merchant_constant_fee?: Maybe<Scalars['Float']>;
  merchant_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_fee_percent?: Maybe<Scalars['Float']>;
  merchant_settlement_usdt_fee_percent?: Maybe<Scalars['Float']>;
  merchant_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "widget_type" */
export type WidgetType = {
  id: Scalars['String'];
  /** An array relationship */
  merchant_widgets: Array<MerchantWidget>;
  /** An aggregate relationship */
  merchant_widgets_aggregate: MerchantWidgetAggregate;
  name?: Maybe<Scalars['String']>;
};


/** columns and relationships of "widget_type" */
export type WidgetTypeMerchantWidgetsArgs = {
  distinct_on?: InputMaybe<Array<MerchantWidgetSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantWidgetOrderBy>>;
  where?: InputMaybe<MerchantWidgetBoolExp>;
};


/** columns and relationships of "widget_type" */
export type WidgetTypeMerchantWidgetsAggregateArgs = {
  distinct_on?: InputMaybe<Array<MerchantWidgetSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MerchantWidgetOrderBy>>;
  where?: InputMaybe<MerchantWidgetBoolExp>;
};

/** aggregated selection of "widget_type" */
export type WidgetTypeAggregate = {
  aggregate?: Maybe<WidgetTypeAggregateFields>;
  nodes: Array<WidgetType>;
};

/** aggregate fields of "widget_type" */
export type WidgetTypeAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<WidgetTypeMaxFields>;
  min?: Maybe<WidgetTypeMinFields>;
};


/** aggregate fields of "widget_type" */
export type WidgetTypeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<WidgetTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "widget_type". All fields are combined with a logical 'AND'. */
export type WidgetTypeBoolExp = {
  _and?: InputMaybe<Array<WidgetTypeBoolExp>>;
  _not?: InputMaybe<WidgetTypeBoolExp>;
  _or?: InputMaybe<Array<WidgetTypeBoolExp>>;
  id?: InputMaybe<StringComparisonExp>;
  merchant_widgets?: InputMaybe<MerchantWidgetBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "widget_type" */
export enum WidgetTypeConstraint {
  /** unique or primary key constraint on columns "id" */
  WidgetTypePkey = 'widget_type_pkey'
}

/** input type for inserting data into table "widget_type" */
export type WidgetTypeInsertInput = {
  id?: InputMaybe<Scalars['String']>;
  merchant_widgets?: InputMaybe<MerchantWidgetArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type WidgetTypeMaxFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type WidgetTypeMinFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "widget_type" */
export type WidgetTypeMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<WidgetType>;
};

/** input type for inserting object relation for remote table "widget_type" */
export type WidgetTypeObjRelInsertInput = {
  data: WidgetTypeInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<WidgetTypeOnConflict>;
};

/** on_conflict condition type for table "widget_type" */
export type WidgetTypeOnConflict = {
  constraint: WidgetTypeConstraint;
  update_columns?: Array<WidgetTypeUpdateColumn>;
  where?: InputMaybe<WidgetTypeBoolExp>;
};

/** Ordering options when selecting data from "widget_type". */
export type WidgetTypeOrderBy = {
  id?: InputMaybe<OrderBy>;
  merchant_widgets_aggregate?: InputMaybe<MerchantWidgetAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: widget_type */
export type WidgetTypePkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "widget_type" */
export enum WidgetTypeSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "widget_type" */
export type WidgetTypeSetInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "widget_type" */
export enum WidgetTypeUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type WidgetTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WidgetTypeSetInput>;
  where: WidgetTypeBoolExp;
};

/** columns and relationships of "withdraw" */
export type Withdraw = {
  additional_data: Scalars['jsonb'];
  amount: Scalars['numeric'];
  bank_id?: Maybe<Scalars['String']>;
  callback_url?: Maybe<Scalars['String']>;
  card_system_id?: Maybe<Scalars['String']>;
  client_ip?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  constant_withdraw_fee?: Maybe<Scalars['numeric']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  currency: Currency;
  currency_id: Scalars['String'];
  currency_rate: Scalars['numeric'];
  currency_rate_provider_id?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  fort_store_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  gate?: Maybe<Gate>;
  gate_currency_amount: Scalars['numeric'];
  gate_currency_rate: Scalars['numeric'];
  gate_id?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  input_currency_amount: Scalars['numeric'];
  input_currency_id?: Maybe<Scalars['String']>;
  is_chargeback: Scalars['Boolean'];
  is_manual: Scalars['Boolean'];
  is_refund: Scalars['Boolean'];
  is_settlement?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  merchant: Merchant;
  merchant_constant_withdraw_fee?: Maybe<Scalars['numeric']>;
  merchant_id: Scalars['Int'];
  merchant_withdraw_decline_transaction_fee_amount: Scalars['numeric'];
  merchant_withdraw_decline_transaction_fee_is_payed: Scalars['Boolean'];
  merchant_withdraw_fee: Scalars['numeric'];
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount: Scalars['numeric'];
  merchant_withdraw_transaction_fee_is_payed: Scalars['Boolean'];
  payment_source_id: Scalars['String'];
  payment_system?: Maybe<Scalars['String']>;
  profit: Scalars['numeric'];
  /** An object relationship */
  provider: Provider;
  provider_amount: Scalars['numeric'];
  provider_id: Scalars['String'];
  provider_payload?: Maybe<Scalars['jsonb']>;
  provider_status?: Maybe<Scalars['String']>;
  provider_transaction_uid?: Maybe<Scalars['String']>;
  provider_withdraw_fee: Scalars['numeric'];
  provider_withdraw_fee_percent: Scalars['numeric'];
  provider_withdraw_id?: Maybe<Scalars['String']>;
  reconciliated_at?: Maybe<Scalars['timestamptz']>;
  refund: Scalars['Boolean'];
  refund_transaction_uid?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  rolling_reserve?: Maybe<RollingReserve>;
  sanitized_mask?: Maybe<Scalars['String']>;
  smart_remark?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  status_updated_at: Scalars['timestamptz'];
  transaction_uid?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  withdraw_transaction_fee_amount: Scalars['numeric'];
  withdraw_url?: Maybe<Scalars['String']>;
};


/** columns and relationships of "withdraw" */
export type WithdrawAdditionalDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "withdraw" */
export type WithdrawProviderPayloadArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "withdraw" */
export type WithdrawAggregate = {
  aggregate?: Maybe<WithdrawAggregateFields>;
  nodes: Array<Withdraw>;
};

/** aggregate fields of "withdraw" */
export type WithdrawAggregateFields = {
  avg?: Maybe<WithdrawAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<WithdrawMaxFields>;
  min?: Maybe<WithdrawMinFields>;
  stddev?: Maybe<WithdrawStddevFields>;
  stddev_pop?: Maybe<WithdrawStddevPopFields>;
  stddev_samp?: Maybe<WithdrawStddevSampFields>;
  sum?: Maybe<WithdrawSumFields>;
  var_pop?: Maybe<WithdrawVarPopFields>;
  var_samp?: Maybe<WithdrawVarSampFields>;
  variance?: Maybe<WithdrawVarianceFields>;
};


/** aggregate fields of "withdraw" */
export type WithdrawAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<WithdrawSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "withdraw" */
export type WithdrawAggregateOrderBy = {
  avg?: InputMaybe<WithdrawAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<WithdrawMaxOrderBy>;
  min?: InputMaybe<WithdrawMinOrderBy>;
  stddev?: InputMaybe<WithdrawStddevOrderBy>;
  stddev_pop?: InputMaybe<WithdrawStddevPopOrderBy>;
  stddev_samp?: InputMaybe<WithdrawStddevSampOrderBy>;
  sum?: InputMaybe<WithdrawSumOrderBy>;
  var_pop?: InputMaybe<WithdrawVarPopOrderBy>;
  var_samp?: InputMaybe<WithdrawVarSampOrderBy>;
  variance?: InputMaybe<WithdrawVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type WithdrawAppendInput = {
  additional_data?: InputMaybe<Scalars['jsonb']>;
  provider_payload?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "withdraw" */
export type WithdrawArrRelInsertInput = {
  data: Array<WithdrawInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<WithdrawOnConflict>;
};

/** aggregate avg on columns */
export type WithdrawAvgFields = {
  amount?: Maybe<Scalars['Float']>;
  constant_withdraw_fee?: Maybe<Scalars['Float']>;
  currency_rate?: Maybe<Scalars['Float']>;
  gate_currency_amount?: Maybe<Scalars['Float']>;
  gate_currency_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_currency_amount?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  provider_amount?: Maybe<Scalars['Float']>;
  provider_withdraw_fee?: Maybe<Scalars['Float']>;
  provider_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "withdraw" */
export type WithdrawAvgOrderBy = {
  amount?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  gate_currency_amount?: InputMaybe<OrderBy>;
  gate_currency_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_amount?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  profit?: InputMaybe<OrderBy>;
  provider_amount?: InputMaybe<OrderBy>;
  provider_withdraw_fee?: InputMaybe<OrderBy>;
  provider_withdraw_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "withdraw". All fields are combined with a logical 'AND'. */
export type WithdrawBoolExp = {
  _and?: InputMaybe<Array<WithdrawBoolExp>>;
  _not?: InputMaybe<WithdrawBoolExp>;
  _or?: InputMaybe<Array<WithdrawBoolExp>>;
  additional_data?: InputMaybe<JsonbComparisonExp>;
  amount?: InputMaybe<NumericComparisonExp>;
  bank_id?: InputMaybe<StringComparisonExp>;
  callback_url?: InputMaybe<StringComparisonExp>;
  card_system_id?: InputMaybe<StringComparisonExp>;
  client_ip?: InputMaybe<StringComparisonExp>;
  comment?: InputMaybe<StringComparisonExp>;
  constant_withdraw_fee?: InputMaybe<NumericComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<CurrencyBoolExp>;
  currency_id?: InputMaybe<StringComparisonExp>;
  currency_rate?: InputMaybe<NumericComparisonExp>;
  currency_rate_provider_id?: InputMaybe<StringComparisonExp>;
  external_id?: InputMaybe<StringComparisonExp>;
  fort_store_id?: InputMaybe<StringComparisonExp>;
  gate?: InputMaybe<GateBoolExp>;
  gate_currency_amount?: InputMaybe<NumericComparisonExp>;
  gate_currency_rate?: InputMaybe<NumericComparisonExp>;
  gate_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  input_currency_amount?: InputMaybe<NumericComparisonExp>;
  input_currency_id?: InputMaybe<StringComparisonExp>;
  is_chargeback?: InputMaybe<BooleanComparisonExp>;
  is_manual?: InputMaybe<BooleanComparisonExp>;
  is_refund?: InputMaybe<BooleanComparisonExp>;
  is_settlement?: InputMaybe<BooleanComparisonExp>;
  merchant?: InputMaybe<MerchantBoolExp>;
  merchant_constant_withdraw_fee?: InputMaybe<NumericComparisonExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
  merchant_withdraw_decline_transaction_fee_is_payed?: InputMaybe<BooleanComparisonExp>;
  merchant_withdraw_fee?: InputMaybe<NumericComparisonExp>;
  merchant_withdraw_fee_min_amount?: InputMaybe<NumericComparisonExp>;
  merchant_withdraw_fee_percent?: InputMaybe<NumericComparisonExp>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
  merchant_withdraw_transaction_fee_is_payed?: InputMaybe<BooleanComparisonExp>;
  payment_source_id?: InputMaybe<StringComparisonExp>;
  payment_system?: InputMaybe<StringComparisonExp>;
  profit?: InputMaybe<NumericComparisonExp>;
  provider?: InputMaybe<ProviderBoolExp>;
  provider_amount?: InputMaybe<NumericComparisonExp>;
  provider_id?: InputMaybe<StringComparisonExp>;
  provider_payload?: InputMaybe<JsonbComparisonExp>;
  provider_status?: InputMaybe<StringComparisonExp>;
  provider_transaction_uid?: InputMaybe<StringComparisonExp>;
  provider_withdraw_fee?: InputMaybe<NumericComparisonExp>;
  provider_withdraw_fee_percent?: InputMaybe<NumericComparisonExp>;
  provider_withdraw_id?: InputMaybe<StringComparisonExp>;
  reconciliated_at?: InputMaybe<TimestamptzComparisonExp>;
  refund?: InputMaybe<BooleanComparisonExp>;
  refund_transaction_uid?: InputMaybe<StringComparisonExp>;
  remark?: InputMaybe<StringComparisonExp>;
  rolling_reserve?: InputMaybe<RollingReserveBoolExp>;
  sanitized_mask?: InputMaybe<StringComparisonExp>;
  smart_remark?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  status_updated_at?: InputMaybe<TimestamptzComparisonExp>;
  transaction_uid?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  withdraw_transaction_fee_amount?: InputMaybe<NumericComparisonExp>;
  withdraw_url?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "withdraw" */
export enum WithdrawConstraint {
  /** unique or primary key constraint on columns "external_id", "merchant_id", "gate_id" */
  WithdrawMerchantIdExternalIdGateIdKey = 'withdraw_merchant_id_external_id_gate_id_key',
  /** unique or primary key constraint on columns "id" */
  WithdrawPkey = 'withdraw_pkey',
  /** unique or primary key constraint on columns "provider_transaction_uid" */
  WithdrawProviderTransactionUidKey = 'withdraw_provider_transaction_uid_key',
  /** unique or primary key constraint on columns "transaction_uid" */
  WithdrawTransactionUidKey = 'withdraw_transaction_uid_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type WithdrawDeleteAtPathInput = {
  additional_data?: InputMaybe<Array<Scalars['String']>>;
  provider_payload?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type WithdrawDeleteElemInput = {
  additional_data?: InputMaybe<Scalars['Int']>;
  provider_payload?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type WithdrawDeleteKeyInput = {
  additional_data?: InputMaybe<Scalars['String']>;
  provider_payload?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "withdraw" */
export type WithdrawIncInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  constant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  currency_rate?: InputMaybe<Scalars['numeric']>;
  gate_currency_amount?: InputMaybe<Scalars['numeric']>;
  gate_currency_rate?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  input_currency_amount?: InputMaybe<Scalars['numeric']>;
  merchant_constant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  profit?: InputMaybe<Scalars['numeric']>;
  provider_amount?: InputMaybe<Scalars['numeric']>;
  provider_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  provider_withdraw_fee_percent?: InputMaybe<Scalars['numeric']>;
  withdraw_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "withdraw" */
export type WithdrawInsertInput = {
  additional_data?: InputMaybe<Scalars['jsonb']>;
  amount?: InputMaybe<Scalars['numeric']>;
  bank_id?: InputMaybe<Scalars['String']>;
  callback_url?: InputMaybe<Scalars['String']>;
  card_system_id?: InputMaybe<Scalars['String']>;
  client_ip?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  constant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<CurrencyObjRelInsertInput>;
  currency_id?: InputMaybe<Scalars['String']>;
  currency_rate?: InputMaybe<Scalars['numeric']>;
  currency_rate_provider_id?: InputMaybe<Scalars['String']>;
  external_id?: InputMaybe<Scalars['String']>;
  fort_store_id?: InputMaybe<Scalars['String']>;
  gate?: InputMaybe<GateObjRelInsertInput>;
  gate_currency_amount?: InputMaybe<Scalars['numeric']>;
  gate_currency_rate?: InputMaybe<Scalars['numeric']>;
  gate_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  input_currency_amount?: InputMaybe<Scalars['numeric']>;
  input_currency_id?: InputMaybe<Scalars['String']>;
  is_chargeback?: InputMaybe<Scalars['Boolean']>;
  is_manual?: InputMaybe<Scalars['Boolean']>;
  is_refund?: InputMaybe<Scalars['Boolean']>;
  is_settlement?: InputMaybe<Scalars['Boolean']>;
  merchant?: InputMaybe<MerchantObjRelInsertInput>;
  merchant_constant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_decline_transaction_fee_is_payed?: InputMaybe<Scalars['Boolean']>;
  merchant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_is_payed?: InputMaybe<Scalars['Boolean']>;
  payment_source_id?: InputMaybe<Scalars['String']>;
  payment_system?: InputMaybe<Scalars['String']>;
  profit?: InputMaybe<Scalars['numeric']>;
  provider?: InputMaybe<ProviderObjRelInsertInput>;
  provider_amount?: InputMaybe<Scalars['numeric']>;
  provider_id?: InputMaybe<Scalars['String']>;
  provider_payload?: InputMaybe<Scalars['jsonb']>;
  provider_status?: InputMaybe<Scalars['String']>;
  provider_transaction_uid?: InputMaybe<Scalars['String']>;
  provider_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  provider_withdraw_fee_percent?: InputMaybe<Scalars['numeric']>;
  provider_withdraw_id?: InputMaybe<Scalars['String']>;
  reconciliated_at?: InputMaybe<Scalars['timestamptz']>;
  refund?: InputMaybe<Scalars['Boolean']>;
  refund_transaction_uid?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  rolling_reserve?: InputMaybe<RollingReserveObjRelInsertInput>;
  sanitized_mask?: InputMaybe<Scalars['String']>;
  smart_remark?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_updated_at?: InputMaybe<Scalars['timestamptz']>;
  transaction_uid?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  withdraw_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  withdraw_url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type WithdrawMaxFields = {
  amount?: Maybe<Scalars['numeric']>;
  bank_id?: Maybe<Scalars['String']>;
  callback_url?: Maybe<Scalars['String']>;
  card_system_id?: Maybe<Scalars['String']>;
  client_ip?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  constant_withdraw_fee?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  currency_rate?: Maybe<Scalars['numeric']>;
  currency_rate_provider_id?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  fort_store_id?: Maybe<Scalars['String']>;
  gate_currency_amount?: Maybe<Scalars['numeric']>;
  gate_currency_rate?: Maybe<Scalars['numeric']>;
  gate_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  input_currency_amount?: Maybe<Scalars['numeric']>;
  input_currency_id?: Maybe<Scalars['String']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  payment_source_id?: Maybe<Scalars['String']>;
  payment_system?: Maybe<Scalars['String']>;
  profit?: Maybe<Scalars['numeric']>;
  provider_amount?: Maybe<Scalars['numeric']>;
  provider_id?: Maybe<Scalars['String']>;
  provider_status?: Maybe<Scalars['String']>;
  provider_transaction_uid?: Maybe<Scalars['String']>;
  provider_withdraw_fee?: Maybe<Scalars['numeric']>;
  provider_withdraw_fee_percent?: Maybe<Scalars['numeric']>;
  provider_withdraw_id?: Maybe<Scalars['String']>;
  reconciliated_at?: Maybe<Scalars['timestamptz']>;
  refund_transaction_uid?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  sanitized_mask?: Maybe<Scalars['String']>;
  smart_remark?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  status_updated_at?: Maybe<Scalars['timestamptz']>;
  transaction_uid?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  withdraw_url?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "withdraw" */
export type WithdrawMaxOrderBy = {
  amount?: InputMaybe<OrderBy>;
  bank_id?: InputMaybe<OrderBy>;
  callback_url?: InputMaybe<OrderBy>;
  card_system_id?: InputMaybe<OrderBy>;
  client_ip?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  currency_rate_provider_id?: InputMaybe<OrderBy>;
  external_id?: InputMaybe<OrderBy>;
  fort_store_id?: InputMaybe<OrderBy>;
  gate_currency_amount?: InputMaybe<OrderBy>;
  gate_currency_rate?: InputMaybe<OrderBy>;
  gate_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_amount?: InputMaybe<OrderBy>;
  input_currency_id?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  payment_source_id?: InputMaybe<OrderBy>;
  payment_system?: InputMaybe<OrderBy>;
  profit?: InputMaybe<OrderBy>;
  provider_amount?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  provider_status?: InputMaybe<OrderBy>;
  provider_transaction_uid?: InputMaybe<OrderBy>;
  provider_withdraw_fee?: InputMaybe<OrderBy>;
  provider_withdraw_fee_percent?: InputMaybe<OrderBy>;
  provider_withdraw_id?: InputMaybe<OrderBy>;
  reconciliated_at?: InputMaybe<OrderBy>;
  refund_transaction_uid?: InputMaybe<OrderBy>;
  remark?: InputMaybe<OrderBy>;
  sanitized_mask?: InputMaybe<OrderBy>;
  smart_remark?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  status_updated_at?: InputMaybe<OrderBy>;
  transaction_uid?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  withdraw_url?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type WithdrawMinFields = {
  amount?: Maybe<Scalars['numeric']>;
  bank_id?: Maybe<Scalars['String']>;
  callback_url?: Maybe<Scalars['String']>;
  card_system_id?: Maybe<Scalars['String']>;
  client_ip?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  constant_withdraw_fee?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  currency_rate?: Maybe<Scalars['numeric']>;
  currency_rate_provider_id?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  fort_store_id?: Maybe<Scalars['String']>;
  gate_currency_amount?: Maybe<Scalars['numeric']>;
  gate_currency_rate?: Maybe<Scalars['numeric']>;
  gate_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  input_currency_amount?: Maybe<Scalars['numeric']>;
  input_currency_id?: Maybe<Scalars['String']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  payment_source_id?: Maybe<Scalars['String']>;
  payment_system?: Maybe<Scalars['String']>;
  profit?: Maybe<Scalars['numeric']>;
  provider_amount?: Maybe<Scalars['numeric']>;
  provider_id?: Maybe<Scalars['String']>;
  provider_status?: Maybe<Scalars['String']>;
  provider_transaction_uid?: Maybe<Scalars['String']>;
  provider_withdraw_fee?: Maybe<Scalars['numeric']>;
  provider_withdraw_fee_percent?: Maybe<Scalars['numeric']>;
  provider_withdraw_id?: Maybe<Scalars['String']>;
  reconciliated_at?: Maybe<Scalars['timestamptz']>;
  refund_transaction_uid?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  sanitized_mask?: Maybe<Scalars['String']>;
  smart_remark?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  status_updated_at?: Maybe<Scalars['timestamptz']>;
  transaction_uid?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  withdraw_url?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "withdraw" */
export type WithdrawMinOrderBy = {
  amount?: InputMaybe<OrderBy>;
  bank_id?: InputMaybe<OrderBy>;
  callback_url?: InputMaybe<OrderBy>;
  card_system_id?: InputMaybe<OrderBy>;
  client_ip?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  currency_rate_provider_id?: InputMaybe<OrderBy>;
  external_id?: InputMaybe<OrderBy>;
  fort_store_id?: InputMaybe<OrderBy>;
  gate_currency_amount?: InputMaybe<OrderBy>;
  gate_currency_rate?: InputMaybe<OrderBy>;
  gate_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_amount?: InputMaybe<OrderBy>;
  input_currency_id?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  payment_source_id?: InputMaybe<OrderBy>;
  payment_system?: InputMaybe<OrderBy>;
  profit?: InputMaybe<OrderBy>;
  provider_amount?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  provider_status?: InputMaybe<OrderBy>;
  provider_transaction_uid?: InputMaybe<OrderBy>;
  provider_withdraw_fee?: InputMaybe<OrderBy>;
  provider_withdraw_fee_percent?: InputMaybe<OrderBy>;
  provider_withdraw_id?: InputMaybe<OrderBy>;
  reconciliated_at?: InputMaybe<OrderBy>;
  refund_transaction_uid?: InputMaybe<OrderBy>;
  remark?: InputMaybe<OrderBy>;
  sanitized_mask?: InputMaybe<OrderBy>;
  smart_remark?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  status_updated_at?: InputMaybe<OrderBy>;
  transaction_uid?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  withdraw_url?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "withdraw" */
export type WithdrawMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Withdraw>;
};

/** input type for inserting object relation for remote table "withdraw" */
export type WithdrawObjRelInsertInput = {
  data: WithdrawInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<WithdrawOnConflict>;
};

/** on_conflict condition type for table "withdraw" */
export type WithdrawOnConflict = {
  constraint: WithdrawConstraint;
  update_columns?: Array<WithdrawUpdateColumn>;
  where?: InputMaybe<WithdrawBoolExp>;
};

/** Ordering options when selecting data from "withdraw". */
export type WithdrawOrderBy = {
  additional_data?: InputMaybe<OrderBy>;
  amount?: InputMaybe<OrderBy>;
  bank_id?: InputMaybe<OrderBy>;
  callback_url?: InputMaybe<OrderBy>;
  card_system_id?: InputMaybe<OrderBy>;
  client_ip?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency?: InputMaybe<CurrencyOrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  currency_rate_provider_id?: InputMaybe<OrderBy>;
  external_id?: InputMaybe<OrderBy>;
  fort_store_id?: InputMaybe<OrderBy>;
  gate?: InputMaybe<GateOrderBy>;
  gate_currency_amount?: InputMaybe<OrderBy>;
  gate_currency_rate?: InputMaybe<OrderBy>;
  gate_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_amount?: InputMaybe<OrderBy>;
  input_currency_id?: InputMaybe<OrderBy>;
  is_chargeback?: InputMaybe<OrderBy>;
  is_manual?: InputMaybe<OrderBy>;
  is_refund?: InputMaybe<OrderBy>;
  is_settlement?: InputMaybe<OrderBy>;
  merchant?: InputMaybe<MerchantOrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_is_payed?: InputMaybe<OrderBy>;
  merchant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_is_payed?: InputMaybe<OrderBy>;
  payment_source_id?: InputMaybe<OrderBy>;
  payment_system?: InputMaybe<OrderBy>;
  profit?: InputMaybe<OrderBy>;
  provider?: InputMaybe<ProviderOrderBy>;
  provider_amount?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  provider_payload?: InputMaybe<OrderBy>;
  provider_status?: InputMaybe<OrderBy>;
  provider_transaction_uid?: InputMaybe<OrderBy>;
  provider_withdraw_fee?: InputMaybe<OrderBy>;
  provider_withdraw_fee_percent?: InputMaybe<OrderBy>;
  provider_withdraw_id?: InputMaybe<OrderBy>;
  reconciliated_at?: InputMaybe<OrderBy>;
  refund?: InputMaybe<OrderBy>;
  refund_transaction_uid?: InputMaybe<OrderBy>;
  remark?: InputMaybe<OrderBy>;
  rolling_reserve?: InputMaybe<RollingReserveOrderBy>;
  sanitized_mask?: InputMaybe<OrderBy>;
  smart_remark?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  status_updated_at?: InputMaybe<OrderBy>;
  transaction_uid?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  withdraw_url?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: withdraw */
export type WithdrawPkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type WithdrawPrependInput = {
  additional_data?: InputMaybe<Scalars['jsonb']>;
  provider_payload?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "withdraw_request" */
export type WithdrawRequest = {
  amount: Scalars['numeric'];
  approved_at?: Maybe<Scalars['timestamptz']>;
  client_ip: Scalars['String'];
  comment: Scalars['String'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  currency?: Maybe<Currency>;
  currency_id?: Maybe<Scalars['String']>;
  gate_id?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An object relationship */
  merchant: Merchant;
  merchant_id: Scalars['Int'];
  merchant_withdraw_fee_amount: Scalars['numeric'];
  payment_source_id: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  /** An object relationship */
  provider: Provider;
  provider_id: Scalars['String'];
  reject_reason?: Maybe<Scalars['String']>;
  sanitized_mask: Scalars['String'];
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  withdraw_request_status: WithdrawRequestStatus;
};

/** aggregated selection of "withdraw_request" */
export type WithdrawRequestAggregate = {
  aggregate?: Maybe<WithdrawRequestAggregateFields>;
  nodes: Array<WithdrawRequest>;
};

/** aggregate fields of "withdraw_request" */
export type WithdrawRequestAggregateFields = {
  avg?: Maybe<WithdrawRequestAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<WithdrawRequestMaxFields>;
  min?: Maybe<WithdrawRequestMinFields>;
  stddev?: Maybe<WithdrawRequestStddevFields>;
  stddev_pop?: Maybe<WithdrawRequestStddevPopFields>;
  stddev_samp?: Maybe<WithdrawRequestStddevSampFields>;
  sum?: Maybe<WithdrawRequestSumFields>;
  var_pop?: Maybe<WithdrawRequestVarPopFields>;
  var_samp?: Maybe<WithdrawRequestVarSampFields>;
  variance?: Maybe<WithdrawRequestVarianceFields>;
};


/** aggregate fields of "withdraw_request" */
export type WithdrawRequestAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<WithdrawRequestSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "withdraw_request" */
export type WithdrawRequestAggregateOrderBy = {
  avg?: InputMaybe<WithdrawRequestAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<WithdrawRequestMaxOrderBy>;
  min?: InputMaybe<WithdrawRequestMinOrderBy>;
  stddev?: InputMaybe<WithdrawRequestStddevOrderBy>;
  stddev_pop?: InputMaybe<WithdrawRequestStddevPopOrderBy>;
  stddev_samp?: InputMaybe<WithdrawRequestStddevSampOrderBy>;
  sum?: InputMaybe<WithdrawRequestSumOrderBy>;
  var_pop?: InputMaybe<WithdrawRequestVarPopOrderBy>;
  var_samp?: InputMaybe<WithdrawRequestVarSampOrderBy>;
  variance?: InputMaybe<WithdrawRequestVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "withdraw_request" */
export type WithdrawRequestArrRelInsertInput = {
  data: Array<WithdrawRequestInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<WithdrawRequestOnConflict>;
};

/** aggregate avg on columns */
export type WithdrawRequestAvgFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "withdraw_request" */
export type WithdrawRequestAvgOrderBy = {
  amount?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_amount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "withdraw_request". All fields are combined with a logical 'AND'. */
export type WithdrawRequestBoolExp = {
  _and?: InputMaybe<Array<WithdrawRequestBoolExp>>;
  _not?: InputMaybe<WithdrawRequestBoolExp>;
  _or?: InputMaybe<Array<WithdrawRequestBoolExp>>;
  amount?: InputMaybe<NumericComparisonExp>;
  approved_at?: InputMaybe<TimestamptzComparisonExp>;
  client_ip?: InputMaybe<StringComparisonExp>;
  comment?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<CurrencyBoolExp>;
  currency_id?: InputMaybe<StringComparisonExp>;
  gate_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  merchant?: InputMaybe<MerchantBoolExp>;
  merchant_id?: InputMaybe<IntComparisonExp>;
  merchant_withdraw_fee_amount?: InputMaybe<NumericComparisonExp>;
  payment_source_id?: InputMaybe<StringComparisonExp>;
  phone?: InputMaybe<StringComparisonExp>;
  provider?: InputMaybe<ProviderBoolExp>;
  provider_id?: InputMaybe<StringComparisonExp>;
  reject_reason?: InputMaybe<StringComparisonExp>;
  sanitized_mask?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  withdraw_request_status?: InputMaybe<WithdrawRequestStatusBoolExp>;
};

/** unique or primary key constraints on table "withdraw_request" */
export enum WithdrawRequestConstraint {
  /** unique or primary key constraint on columns "id" */
  WithdrawRequestPkey = 'withdraw_request_pkey'
}

/** input type for incrementing numeric columns in table "withdraw_request" */
export type WithdrawRequestIncInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_withdraw_fee_amount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "withdraw_request" */
export type WithdrawRequestInsertInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  approved_at?: InputMaybe<Scalars['timestamptz']>;
  client_ip?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<CurrencyObjRelInsertInput>;
  currency_id?: InputMaybe<Scalars['String']>;
  gate_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  merchant?: InputMaybe<MerchantObjRelInsertInput>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_withdraw_fee_amount?: InputMaybe<Scalars['numeric']>;
  payment_source_id?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<ProviderObjRelInsertInput>;
  provider_id?: InputMaybe<Scalars['String']>;
  reject_reason?: InputMaybe<Scalars['String']>;
  sanitized_mask?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  withdraw_request_status?: InputMaybe<WithdrawRequestStatusObjRelInsertInput>;
};

/** aggregate max on columns */
export type WithdrawRequestMaxFields = {
  amount?: Maybe<Scalars['numeric']>;
  approved_at?: Maybe<Scalars['timestamptz']>;
  client_ip?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  gate_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_withdraw_fee_amount?: Maybe<Scalars['numeric']>;
  payment_source_id?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
  reject_reason?: Maybe<Scalars['String']>;
  sanitized_mask?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "withdraw_request" */
export type WithdrawRequestMaxOrderBy = {
  amount?: InputMaybe<OrderBy>;
  approved_at?: InputMaybe<OrderBy>;
  client_ip?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  gate_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_amount?: InputMaybe<OrderBy>;
  payment_source_id?: InputMaybe<OrderBy>;
  phone?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  reject_reason?: InputMaybe<OrderBy>;
  sanitized_mask?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type WithdrawRequestMinFields = {
  amount?: Maybe<Scalars['numeric']>;
  approved_at?: Maybe<Scalars['timestamptz']>;
  client_ip?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['String']>;
  gate_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_withdraw_fee_amount?: Maybe<Scalars['numeric']>;
  payment_source_id?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
  reject_reason?: Maybe<Scalars['String']>;
  sanitized_mask?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "withdraw_request" */
export type WithdrawRequestMinOrderBy = {
  amount?: InputMaybe<OrderBy>;
  approved_at?: InputMaybe<OrderBy>;
  client_ip?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  gate_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_amount?: InputMaybe<OrderBy>;
  payment_source_id?: InputMaybe<OrderBy>;
  phone?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  reject_reason?: InputMaybe<OrderBy>;
  sanitized_mask?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "withdraw_request" */
export type WithdrawRequestMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<WithdrawRequest>;
};

/** on_conflict condition type for table "withdraw_request" */
export type WithdrawRequestOnConflict = {
  constraint: WithdrawRequestConstraint;
  update_columns?: Array<WithdrawRequestUpdateColumn>;
  where?: InputMaybe<WithdrawRequestBoolExp>;
};

/** Ordering options when selecting data from "withdraw_request". */
export type WithdrawRequestOrderBy = {
  amount?: InputMaybe<OrderBy>;
  approved_at?: InputMaybe<OrderBy>;
  client_ip?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency?: InputMaybe<CurrencyOrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  gate_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merchant?: InputMaybe<MerchantOrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_amount?: InputMaybe<OrderBy>;
  payment_source_id?: InputMaybe<OrderBy>;
  phone?: InputMaybe<OrderBy>;
  provider?: InputMaybe<ProviderOrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  reject_reason?: InputMaybe<OrderBy>;
  sanitized_mask?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  withdraw_request_status?: InputMaybe<WithdrawRequestStatusOrderBy>;
};

/** primary key columns input for table: withdraw_request */
export type WithdrawRequestPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "withdraw_request" */
export enum WithdrawRequestSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  ClientIp = 'client_ip',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  GateId = 'gate_id',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MerchantWithdrawFeeAmount = 'merchant_withdraw_fee_amount',
  /** column name */
  PaymentSourceId = 'payment_source_id',
  /** column name */
  Phone = 'phone',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  RejectReason = 'reject_reason',
  /** column name */
  SanitizedMask = 'sanitized_mask',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "withdraw_request" */
export type WithdrawRequestSetInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  approved_at?: InputMaybe<Scalars['timestamptz']>;
  client_ip?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency_id?: InputMaybe<Scalars['String']>;
  gate_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_withdraw_fee_amount?: InputMaybe<Scalars['numeric']>;
  payment_source_id?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
  reject_reason?: InputMaybe<Scalars['String']>;
  sanitized_mask?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "withdraw_request_status" */
export type WithdrawRequestStatus = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  withdraw_requests: Array<WithdrawRequest>;
  /** An aggregate relationship */
  withdraw_requests_aggregate: WithdrawRequestAggregate;
};


/** columns and relationships of "withdraw_request_status" */
export type WithdrawRequestStatusWithdrawRequestsArgs = {
  distinct_on?: InputMaybe<Array<WithdrawRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WithdrawRequestOrderBy>>;
  where?: InputMaybe<WithdrawRequestBoolExp>;
};


/** columns and relationships of "withdraw_request_status" */
export type WithdrawRequestStatusWithdrawRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<WithdrawRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WithdrawRequestOrderBy>>;
  where?: InputMaybe<WithdrawRequestBoolExp>;
};

/** aggregated selection of "withdraw_request_status" */
export type WithdrawRequestStatusAggregate = {
  aggregate?: Maybe<WithdrawRequestStatusAggregateFields>;
  nodes: Array<WithdrawRequestStatus>;
};

/** aggregate fields of "withdraw_request_status" */
export type WithdrawRequestStatusAggregateFields = {
  count: Scalars['Int'];
  max?: Maybe<WithdrawRequestStatusMaxFields>;
  min?: Maybe<WithdrawRequestStatusMinFields>;
};


/** aggregate fields of "withdraw_request_status" */
export type WithdrawRequestStatusAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<WithdrawRequestStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "withdraw_request_status". All fields are combined with a logical 'AND'. */
export type WithdrawRequestStatusBoolExp = {
  _and?: InputMaybe<Array<WithdrawRequestStatusBoolExp>>;
  _not?: InputMaybe<WithdrawRequestStatusBoolExp>;
  _or?: InputMaybe<Array<WithdrawRequestStatusBoolExp>>;
  id?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  withdraw_requests?: InputMaybe<WithdrawRequestBoolExp>;
};

/** unique or primary key constraints on table "withdraw_request_status" */
export enum WithdrawRequestStatusConstraint {
  /** unique or primary key constraint on columns "id" */
  WithdrawRequestStatusPkey = 'withdraw_request_status_pkey'
}

/** input type for inserting data into table "withdraw_request_status" */
export type WithdrawRequestStatusInsertInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  withdraw_requests?: InputMaybe<WithdrawRequestArrRelInsertInput>;
};

/** aggregate max on columns */
export type WithdrawRequestStatusMaxFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type WithdrawRequestStatusMinFields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "withdraw_request_status" */
export type WithdrawRequestStatusMutationResponse = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<WithdrawRequestStatus>;
};

/** input type for inserting object relation for remote table "withdraw_request_status" */
export type WithdrawRequestStatusObjRelInsertInput = {
  data: WithdrawRequestStatusInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<WithdrawRequestStatusOnConflict>;
};

/** on_conflict condition type for table "withdraw_request_status" */
export type WithdrawRequestStatusOnConflict = {
  constraint: WithdrawRequestStatusConstraint;
  update_columns?: Array<WithdrawRequestStatusUpdateColumn>;
  where?: InputMaybe<WithdrawRequestStatusBoolExp>;
};

/** Ordering options when selecting data from "withdraw_request_status". */
export type WithdrawRequestStatusOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  withdraw_requests_aggregate?: InputMaybe<WithdrawRequestAggregateOrderBy>;
};

/** primary key columns input for table: withdraw_request_status */
export type WithdrawRequestStatusPkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "withdraw_request_status" */
export enum WithdrawRequestStatusSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "withdraw_request_status" */
export type WithdrawRequestStatusSetInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "withdraw_request_status" */
export enum WithdrawRequestStatusUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type WithdrawRequestStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WithdrawRequestStatusSetInput>;
  where: WithdrawRequestStatusBoolExp;
};

/** aggregate stddev on columns */
export type WithdrawRequestStddevFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "withdraw_request" */
export type WithdrawRequestStddevOrderBy = {
  amount?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type WithdrawRequestStddevPopFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "withdraw_request" */
export type WithdrawRequestStddevPopOrderBy = {
  amount?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type WithdrawRequestStddevSampFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "withdraw_request" */
export type WithdrawRequestStddevSampOrderBy = {
  amount?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type WithdrawRequestSumFields = {
  amount?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_withdraw_fee_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "withdraw_request" */
export type WithdrawRequestSumOrderBy = {
  amount?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_amount?: InputMaybe<OrderBy>;
};

/** update columns of table "withdraw_request" */
export enum WithdrawRequestUpdateColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  ClientIp = 'client_ip',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  GateId = 'gate_id',
  /** column name */
  Id = 'id',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MerchantWithdrawFeeAmount = 'merchant_withdraw_fee_amount',
  /** column name */
  PaymentSourceId = 'payment_source_id',
  /** column name */
  Phone = 'phone',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  RejectReason = 'reject_reason',
  /** column name */
  SanitizedMask = 'sanitized_mask',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type WithdrawRequestUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<WithdrawRequestIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WithdrawRequestSetInput>;
  where: WithdrawRequestBoolExp;
};

/** aggregate var_pop on columns */
export type WithdrawRequestVarPopFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "withdraw_request" */
export type WithdrawRequestVarPopOrderBy = {
  amount?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type WithdrawRequestVarSampFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "withdraw_request" */
export type WithdrawRequestVarSampOrderBy = {
  amount?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type WithdrawRequestVarianceFields = {
  amount?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "withdraw_request" */
export type WithdrawRequestVarianceOrderBy = {
  amount?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_amount?: InputMaybe<OrderBy>;
};

/** select columns of table "withdraw" */
export enum WithdrawSelectColumn {
  /** column name */
  AdditionalData = 'additional_data',
  /** column name */
  Amount = 'amount',
  /** column name */
  BankId = 'bank_id',
  /** column name */
  CallbackUrl = 'callback_url',
  /** column name */
  CardSystemId = 'card_system_id',
  /** column name */
  ClientIp = 'client_ip',
  /** column name */
  Comment = 'comment',
  /** column name */
  ConstantWithdrawFee = 'constant_withdraw_fee',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  CurrencyRate = 'currency_rate',
  /** column name */
  CurrencyRateProviderId = 'currency_rate_provider_id',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  FortStoreId = 'fort_store_id',
  /** column name */
  GateCurrencyAmount = 'gate_currency_amount',
  /** column name */
  GateCurrencyRate = 'gate_currency_rate',
  /** column name */
  GateId = 'gate_id',
  /** column name */
  Id = 'id',
  /** column name */
  InputCurrencyAmount = 'input_currency_amount',
  /** column name */
  InputCurrencyId = 'input_currency_id',
  /** column name */
  IsChargeback = 'is_chargeback',
  /** column name */
  IsManual = 'is_manual',
  /** column name */
  IsRefund = 'is_refund',
  /** column name */
  IsSettlement = 'is_settlement',
  /** column name */
  MerchantConstantWithdrawFee = 'merchant_constant_withdraw_fee',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MerchantWithdrawDeclineTransactionFeeAmount = 'merchant_withdraw_decline_transaction_fee_amount',
  /** column name */
  MerchantWithdrawDeclineTransactionFeeIsPayed = 'merchant_withdraw_decline_transaction_fee_is_payed',
  /** column name */
  MerchantWithdrawFee = 'merchant_withdraw_fee',
  /** column name */
  MerchantWithdrawFeeMinAmount = 'merchant_withdraw_fee_min_amount',
  /** column name */
  MerchantWithdrawFeePercent = 'merchant_withdraw_fee_percent',
  /** column name */
  MerchantWithdrawTransactionFeeAmount = 'merchant_withdraw_transaction_fee_amount',
  /** column name */
  MerchantWithdrawTransactionFeeIsPayed = 'merchant_withdraw_transaction_fee_is_payed',
  /** column name */
  PaymentSourceId = 'payment_source_id',
  /** column name */
  PaymentSystem = 'payment_system',
  /** column name */
  Profit = 'profit',
  /** column name */
  ProviderAmount = 'provider_amount',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  ProviderPayload = 'provider_payload',
  /** column name */
  ProviderStatus = 'provider_status',
  /** column name */
  ProviderTransactionUid = 'provider_transaction_uid',
  /** column name */
  ProviderWithdrawFee = 'provider_withdraw_fee',
  /** column name */
  ProviderWithdrawFeePercent = 'provider_withdraw_fee_percent',
  /** column name */
  ProviderWithdrawId = 'provider_withdraw_id',
  /** column name */
  ReconciliatedAt = 'reconciliated_at',
  /** column name */
  Refund = 'refund',
  /** column name */
  RefundTransactionUid = 'refund_transaction_uid',
  /** column name */
  Remark = 'remark',
  /** column name */
  SanitizedMask = 'sanitized_mask',
  /** column name */
  SmartRemark = 'smart_remark',
  /** column name */
  Status = 'status',
  /** column name */
  StatusUpdatedAt = 'status_updated_at',
  /** column name */
  TransactionUid = 'transaction_uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WithdrawTransactionFeeAmount = 'withdraw_transaction_fee_amount',
  /** column name */
  WithdrawUrl = 'withdraw_url'
}

/** input type for updating data in table "withdraw" */
export type WithdrawSetInput = {
  additional_data?: InputMaybe<Scalars['jsonb']>;
  amount?: InputMaybe<Scalars['numeric']>;
  bank_id?: InputMaybe<Scalars['String']>;
  callback_url?: InputMaybe<Scalars['String']>;
  card_system_id?: InputMaybe<Scalars['String']>;
  client_ip?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  constant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency_id?: InputMaybe<Scalars['String']>;
  currency_rate?: InputMaybe<Scalars['numeric']>;
  currency_rate_provider_id?: InputMaybe<Scalars['String']>;
  external_id?: InputMaybe<Scalars['String']>;
  fort_store_id?: InputMaybe<Scalars['String']>;
  gate_currency_amount?: InputMaybe<Scalars['numeric']>;
  gate_currency_rate?: InputMaybe<Scalars['numeric']>;
  gate_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  input_currency_amount?: InputMaybe<Scalars['numeric']>;
  input_currency_id?: InputMaybe<Scalars['String']>;
  is_chargeback?: InputMaybe<Scalars['Boolean']>;
  is_manual?: InputMaybe<Scalars['Boolean']>;
  is_refund?: InputMaybe<Scalars['Boolean']>;
  is_settlement?: InputMaybe<Scalars['Boolean']>;
  merchant_constant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  merchant_id?: InputMaybe<Scalars['Int']>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_decline_transaction_fee_is_payed?: InputMaybe<Scalars['Boolean']>;
  merchant_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_is_payed?: InputMaybe<Scalars['Boolean']>;
  payment_source_id?: InputMaybe<Scalars['String']>;
  payment_system?: InputMaybe<Scalars['String']>;
  profit?: InputMaybe<Scalars['numeric']>;
  provider_amount?: InputMaybe<Scalars['numeric']>;
  provider_id?: InputMaybe<Scalars['String']>;
  provider_payload?: InputMaybe<Scalars['jsonb']>;
  provider_status?: InputMaybe<Scalars['String']>;
  provider_transaction_uid?: InputMaybe<Scalars['String']>;
  provider_withdraw_fee?: InputMaybe<Scalars['numeric']>;
  provider_withdraw_fee_percent?: InputMaybe<Scalars['numeric']>;
  provider_withdraw_id?: InputMaybe<Scalars['String']>;
  reconciliated_at?: InputMaybe<Scalars['timestamptz']>;
  refund?: InputMaybe<Scalars['Boolean']>;
  refund_transaction_uid?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  sanitized_mask?: InputMaybe<Scalars['String']>;
  smart_remark?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_updated_at?: InputMaybe<Scalars['timestamptz']>;
  transaction_uid?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  withdraw_transaction_fee_amount?: InputMaybe<Scalars['numeric']>;
  withdraw_url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type WithdrawStddevFields = {
  amount?: Maybe<Scalars['Float']>;
  constant_withdraw_fee?: Maybe<Scalars['Float']>;
  currency_rate?: Maybe<Scalars['Float']>;
  gate_currency_amount?: Maybe<Scalars['Float']>;
  gate_currency_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_currency_amount?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  provider_amount?: Maybe<Scalars['Float']>;
  provider_withdraw_fee?: Maybe<Scalars['Float']>;
  provider_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "withdraw" */
export type WithdrawStddevOrderBy = {
  amount?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  gate_currency_amount?: InputMaybe<OrderBy>;
  gate_currency_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_amount?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  profit?: InputMaybe<OrderBy>;
  provider_amount?: InputMaybe<OrderBy>;
  provider_withdraw_fee?: InputMaybe<OrderBy>;
  provider_withdraw_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type WithdrawStddevPopFields = {
  amount?: Maybe<Scalars['Float']>;
  constant_withdraw_fee?: Maybe<Scalars['Float']>;
  currency_rate?: Maybe<Scalars['Float']>;
  gate_currency_amount?: Maybe<Scalars['Float']>;
  gate_currency_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_currency_amount?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  provider_amount?: Maybe<Scalars['Float']>;
  provider_withdraw_fee?: Maybe<Scalars['Float']>;
  provider_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "withdraw" */
export type WithdrawStddevPopOrderBy = {
  amount?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  gate_currency_amount?: InputMaybe<OrderBy>;
  gate_currency_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_amount?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  profit?: InputMaybe<OrderBy>;
  provider_amount?: InputMaybe<OrderBy>;
  provider_withdraw_fee?: InputMaybe<OrderBy>;
  provider_withdraw_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type WithdrawStddevSampFields = {
  amount?: Maybe<Scalars['Float']>;
  constant_withdraw_fee?: Maybe<Scalars['Float']>;
  currency_rate?: Maybe<Scalars['Float']>;
  gate_currency_amount?: Maybe<Scalars['Float']>;
  gate_currency_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_currency_amount?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  provider_amount?: Maybe<Scalars['Float']>;
  provider_withdraw_fee?: Maybe<Scalars['Float']>;
  provider_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "withdraw" */
export type WithdrawStddevSampOrderBy = {
  amount?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  gate_currency_amount?: InputMaybe<OrderBy>;
  gate_currency_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_amount?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  profit?: InputMaybe<OrderBy>;
  provider_amount?: InputMaybe<OrderBy>;
  provider_withdraw_fee?: InputMaybe<OrderBy>;
  provider_withdraw_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type WithdrawSumFields = {
  amount?: Maybe<Scalars['numeric']>;
  constant_withdraw_fee?: Maybe<Scalars['numeric']>;
  currency_rate?: Maybe<Scalars['numeric']>;
  gate_currency_amount?: Maybe<Scalars['numeric']>;
  gate_currency_rate?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  input_currency_amount?: Maybe<Scalars['numeric']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['numeric']>;
  merchant_id?: Maybe<Scalars['Int']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['numeric']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['numeric']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['numeric']>;
  profit?: Maybe<Scalars['numeric']>;
  provider_amount?: Maybe<Scalars['numeric']>;
  provider_withdraw_fee?: Maybe<Scalars['numeric']>;
  provider_withdraw_fee_percent?: Maybe<Scalars['numeric']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "withdraw" */
export type WithdrawSumOrderBy = {
  amount?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  gate_currency_amount?: InputMaybe<OrderBy>;
  gate_currency_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_amount?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  profit?: InputMaybe<OrderBy>;
  provider_amount?: InputMaybe<OrderBy>;
  provider_withdraw_fee?: InputMaybe<OrderBy>;
  provider_withdraw_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** update columns of table "withdraw" */
export enum WithdrawUpdateColumn {
  /** column name */
  AdditionalData = 'additional_data',
  /** column name */
  Amount = 'amount',
  /** column name */
  BankId = 'bank_id',
  /** column name */
  CallbackUrl = 'callback_url',
  /** column name */
  CardSystemId = 'card_system_id',
  /** column name */
  ClientIp = 'client_ip',
  /** column name */
  Comment = 'comment',
  /** column name */
  ConstantWithdrawFee = 'constant_withdraw_fee',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  CurrencyRate = 'currency_rate',
  /** column name */
  CurrencyRateProviderId = 'currency_rate_provider_id',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  FortStoreId = 'fort_store_id',
  /** column name */
  GateCurrencyAmount = 'gate_currency_amount',
  /** column name */
  GateCurrencyRate = 'gate_currency_rate',
  /** column name */
  GateId = 'gate_id',
  /** column name */
  Id = 'id',
  /** column name */
  InputCurrencyAmount = 'input_currency_amount',
  /** column name */
  InputCurrencyId = 'input_currency_id',
  /** column name */
  IsChargeback = 'is_chargeback',
  /** column name */
  IsManual = 'is_manual',
  /** column name */
  IsRefund = 'is_refund',
  /** column name */
  IsSettlement = 'is_settlement',
  /** column name */
  MerchantConstantWithdrawFee = 'merchant_constant_withdraw_fee',
  /** column name */
  MerchantId = 'merchant_id',
  /** column name */
  MerchantWithdrawDeclineTransactionFeeAmount = 'merchant_withdraw_decline_transaction_fee_amount',
  /** column name */
  MerchantWithdrawDeclineTransactionFeeIsPayed = 'merchant_withdraw_decline_transaction_fee_is_payed',
  /** column name */
  MerchantWithdrawFee = 'merchant_withdraw_fee',
  /** column name */
  MerchantWithdrawFeeMinAmount = 'merchant_withdraw_fee_min_amount',
  /** column name */
  MerchantWithdrawFeePercent = 'merchant_withdraw_fee_percent',
  /** column name */
  MerchantWithdrawTransactionFeeAmount = 'merchant_withdraw_transaction_fee_amount',
  /** column name */
  MerchantWithdrawTransactionFeeIsPayed = 'merchant_withdraw_transaction_fee_is_payed',
  /** column name */
  PaymentSourceId = 'payment_source_id',
  /** column name */
  PaymentSystem = 'payment_system',
  /** column name */
  Profit = 'profit',
  /** column name */
  ProviderAmount = 'provider_amount',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  ProviderPayload = 'provider_payload',
  /** column name */
  ProviderStatus = 'provider_status',
  /** column name */
  ProviderTransactionUid = 'provider_transaction_uid',
  /** column name */
  ProviderWithdrawFee = 'provider_withdraw_fee',
  /** column name */
  ProviderWithdrawFeePercent = 'provider_withdraw_fee_percent',
  /** column name */
  ProviderWithdrawId = 'provider_withdraw_id',
  /** column name */
  ReconciliatedAt = 'reconciliated_at',
  /** column name */
  Refund = 'refund',
  /** column name */
  RefundTransactionUid = 'refund_transaction_uid',
  /** column name */
  Remark = 'remark',
  /** column name */
  SanitizedMask = 'sanitized_mask',
  /** column name */
  SmartRemark = 'smart_remark',
  /** column name */
  Status = 'status',
  /** column name */
  StatusUpdatedAt = 'status_updated_at',
  /** column name */
  TransactionUid = 'transaction_uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WithdrawTransactionFeeAmount = 'withdraw_transaction_fee_amount',
  /** column name */
  WithdrawUrl = 'withdraw_url'
}

export type WithdrawUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<WithdrawAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<WithdrawDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<WithdrawDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<WithdrawDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<WithdrawIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<WithdrawPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WithdrawSetInput>;
  where: WithdrawBoolExp;
};

/** aggregate var_pop on columns */
export type WithdrawVarPopFields = {
  amount?: Maybe<Scalars['Float']>;
  constant_withdraw_fee?: Maybe<Scalars['Float']>;
  currency_rate?: Maybe<Scalars['Float']>;
  gate_currency_amount?: Maybe<Scalars['Float']>;
  gate_currency_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_currency_amount?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  provider_amount?: Maybe<Scalars['Float']>;
  provider_withdraw_fee?: Maybe<Scalars['Float']>;
  provider_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "withdraw" */
export type WithdrawVarPopOrderBy = {
  amount?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  gate_currency_amount?: InputMaybe<OrderBy>;
  gate_currency_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_amount?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  profit?: InputMaybe<OrderBy>;
  provider_amount?: InputMaybe<OrderBy>;
  provider_withdraw_fee?: InputMaybe<OrderBy>;
  provider_withdraw_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type WithdrawVarSampFields = {
  amount?: Maybe<Scalars['Float']>;
  constant_withdraw_fee?: Maybe<Scalars['Float']>;
  currency_rate?: Maybe<Scalars['Float']>;
  gate_currency_amount?: Maybe<Scalars['Float']>;
  gate_currency_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_currency_amount?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  provider_amount?: Maybe<Scalars['Float']>;
  provider_withdraw_fee?: Maybe<Scalars['Float']>;
  provider_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "withdraw" */
export type WithdrawVarSampOrderBy = {
  amount?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  gate_currency_amount?: InputMaybe<OrderBy>;
  gate_currency_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_amount?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  profit?: InputMaybe<OrderBy>;
  provider_amount?: InputMaybe<OrderBy>;
  provider_withdraw_fee?: InputMaybe<OrderBy>;
  provider_withdraw_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type WithdrawVarianceFields = {
  amount?: Maybe<Scalars['Float']>;
  constant_withdraw_fee?: Maybe<Scalars['Float']>;
  currency_rate?: Maybe<Scalars['Float']>;
  gate_currency_amount?: Maybe<Scalars['Float']>;
  gate_currency_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_currency_amount?: Maybe<Scalars['Float']>;
  merchant_constant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_id?: Maybe<Scalars['Float']>;
  merchant_withdraw_decline_transaction_fee_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_min_amount?: Maybe<Scalars['Float']>;
  merchant_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  merchant_withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  provider_amount?: Maybe<Scalars['Float']>;
  provider_withdraw_fee?: Maybe<Scalars['Float']>;
  provider_withdraw_fee_percent?: Maybe<Scalars['Float']>;
  withdraw_transaction_fee_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "withdraw" */
export type WithdrawVarianceOrderBy = {
  amount?: InputMaybe<OrderBy>;
  constant_withdraw_fee?: InputMaybe<OrderBy>;
  currency_rate?: InputMaybe<OrderBy>;
  gate_currency_amount?: InputMaybe<OrderBy>;
  gate_currency_rate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input_currency_amount?: InputMaybe<OrderBy>;
  merchant_constant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_id?: InputMaybe<OrderBy>;
  merchant_withdraw_decline_transaction_fee_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_min_amount?: InputMaybe<OrderBy>;
  merchant_withdraw_fee_percent?: InputMaybe<OrderBy>;
  merchant_withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
  profit?: InputMaybe<OrderBy>;
  provider_amount?: InputMaybe<OrderBy>;
  provider_withdraw_fee?: InputMaybe<OrderBy>;
  provider_withdraw_fee_percent?: InputMaybe<OrderBy>;
  withdraw_transaction_fee_amount?: InputMaybe<OrderBy>;
};

export type GetDashboardWalletsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardWalletsQuery = { dashboardWallet?: Array<{ currency_id?: string | null, total?: string | null } | null> | null };

export type MerchantTaskCreateReportRejectedTransactionTaskMutationVariables = Exact<{
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  gate_id?: InputMaybe<Scalars['String']>;
  external_id?: InputMaybe<Scalars['String']>;
  transaction_uid?: InputMaybe<Scalars['String']>;
  is_manual?: InputMaybe<Scalars['Boolean']>;
}>;


export type MerchantTaskCreateReportRejectedTransactionTaskMutation = { merchantTaskCreateReportRejectedTransactionTask: { id: string } };

export type Disable2FaMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type Disable2FaMutation = { otpDisable: boolean };

export type OrganizationMerchantInfoQueryVariables = Exact<{
  where?: InputMaybe<MerchantInfoBoolExp>;
}>;


export type OrganizationMerchantInfoQuery = { merchant_info: Array<{ business_address?: string | null, chargeback_ratio?: string | null, company_name?: string | null, company_website?: string | null, created_at: any, month_turnover?: string | null, payments_geo?: string | null, registered_address?: string | null, registration_data?: any | null, registration_number?: string | null }> };

export type GetTokensQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTokensQuery = { merchant_api_token: Array<{ name?: string | null, id: any, created_at?: any | null }> };

export type CreateApiTokenMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type CreateApiTokenMutation = { createApiToken?: { api_token: string } | null };

export type DeleteApiTokenMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteApiTokenMutation = { delete_merchant_api_token?: { affected_rows: number } | null };

export type GetWhitelistQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWhitelistQuery = { merchant_file: Array<{ id: any, status: string, type: string, upload_file_name?: string | null, created_at: any }> };

export type MerchantTaskCreateReportTransactionManagementTaskMutationVariables = Exact<{
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  gate_id?: InputMaybe<Scalars['String']>;
  status_id?: InputMaybe<Scalars['String']>;
  currency_id?: InputMaybe<Scalars['String']>;
  external_id?: InputMaybe<Scalars['String']>;
  transaction_uid?: InputMaybe<Scalars['String']>;
  is_manual?: InputMaybe<Scalars['Boolean']>;
}>;


export type MerchantTaskCreateReportTransactionManagementTaskMutation = { merchantTaskCreateReportTransactionManagementTask: { id: string } };

export type GetChargebackQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where: VLkChargebackBoolExp;
}>;


export type GetChargebackQuery = { v_lk_chargeback: Array<{ id?: string | null, created_at?: any | null, currency_id?: string | null, amount?: any | null, chargeback_fee?: any | null, invoice_transaction_uid?: string | null, withdraw_transaction_uid?: string | null, gate?: { id: string, gate_group?: { id: string, name?: string | null } | null } | null }>, v_lk_chargeback_aggregate: { aggregate?: { count: number } | null } };

export type CreateInvoiceMutationVariables = Exact<{
  amount: Scalars['numeric'];
  comment?: InputMaybe<Scalars['String']>;
  currency_id: Scalars['String'];
  external_id?: InputMaybe<Scalars['String']>;
  gate_id?: InputMaybe<Scalars['String']>;
}>;


export type CreateInvoiceMutation = { invoiceCreate: { invoice_url: string } };

export type RefundCreateRequestMutationVariables = Exact<{
  transaction_uid: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
}>;


export type RefundCreateRequestMutation = { refundCreateRequest: any };

export type GetRefundsQueryVariables = Exact<{
  date_from: Scalars['String'];
  date_to: Scalars['String'];
  currency_id?: InputMaybe<Scalars['String']>;
  gate_group_id?: InputMaybe<Scalars['String']>;
  invoice_transaction_uid?: InputMaybe<Scalars['String']>;
  withdraw_transaction_uid?: InputMaybe<Scalars['String']>;
  refund_table_where?: InputMaybe<RefundTableBoolExp>;
}>;


export type GetRefundsQuery = { refundsFilter?: Array<{ refund_id: string, amount: any, fee: any, created_at: string, currency: string, gate_group_name: string, invoice_transaction_uid: string, withdraw_transaction_uid: string } | null> | null, refund_table: Array<{ amount: any, comment?: string | null, created_at: any, id: string, invoice_transaction_uid?: string | null, refund_request_status_id?: string | null, refund_reason?: string | null, refund_fee: any, reject_reason?: string | null, withdraw_transaction_uid?: string | null, invoice?: { currency_id: string, gate?: { gate_group?: { id: string, name?: string | null } | null } | null } | null }> };

export type WithdrawRequestCreateMutationVariables = Exact<{
  amount: Scalars['numeric'];
  comment: Scalars['String'];
  currency_id: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  gate_id?: InputMaybe<Scalars['String']>;
  sanitized_mask: Scalars['String'];
}>;


export type WithdrawRequestCreateMutation = { withdrawRequestCreate: boolean };

export type GetAllWithdrawRequestQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetAllWithdrawRequestQuery = { withdraw_request: Array<{ amount: any, comment: string, approved_at?: any | null, client_ip: string, created_at: any, currency_id?: string | null, merchant_id: number, merchant_withdraw_fee_amount: any, phone?: string | null, provider_id: string, sanitized_mask: string, status: string, updated_at: any, id: any }>, withdraw_request_aggregate: { aggregate?: { count: number } | null } };

export type MerchantTaskCreateReportWithdrawalsPayoutTaskMutationVariables = Exact<{
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  gate_id?: InputMaybe<Scalars['String']>;
  currency_id?: InputMaybe<Scalars['String']>;
  status_id?: InputMaybe<Scalars['String']>;
  external_id?: InputMaybe<Scalars['String']>;
  transaction_uid?: InputMaybe<Scalars['String']>;
  is_manual?: InputMaybe<Scalars['Boolean']>;
}>;


export type MerchantTaskCreateReportWithdrawalsPayoutTaskMutation = { merchantTaskCreateReportWithdrawalsPayoutTask: { id: string } };

export type GetAllWithdrawsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WithdrawBoolExp>;
}>;


export type GetAllWithdrawsQuery = { withdraw: Array<{ amount: any, gate_id?: string | null, currency_id: string, card_system_id?: string | null, status?: string | null, transaction_uid?: string | null, merchant_id: number, id: number, sanitized_mask?: string | null, merchant_withdraw_fee: any, created_at: any, status_updated_at: any, is_manual: boolean, remark?: string | null, comment?: string | null }>, withdraw_aggregate: { aggregate?: { count: number } | null } };

export type CryptoWithdrawRequestCreateMutationVariables = Exact<{
  account: Scalars['String'];
  crypto_currency: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  fiat_amount: Scalars['numeric'];
  fiat_currency: Scalars['String'];
  gate_id: Scalars['String'];
}>;


export type CryptoWithdrawRequestCreateMutation = { cryptoWithdrawRequestCreate: { result: { id: number } } };

export type GetAllCryptoWithdrawRequestQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetAllCryptoWithdrawRequestQuery = { crypto_withdraw_request: Array<{ fiat_amount: any, crypto_amount?: any | null, created_at: any, fiat_currency_id: string, description?: string | null, account_number?: string | null, crypto_withdraw_request_status_id: string, updated_at: any, id: number, merchant_fee_percent?: any | null, rate?: any | null, key_approve?: string | null, merchant_settlement_fee_amount: any, merchant_settlement_fee_percent: any }>, crypto_withdraw_request_aggregate: { aggregate?: { count: number } | null } };

export type RegistrationMutationVariables = Exact<{
  data: UsersRegistrationInput;
}>;


export type RegistrationMutation = { usersRegistration?: { id: string } | null };

export type RequestQrMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestQrMutation = { otpRequestActivate: { qr_code_data: string } };

export type Activate_2FaMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type Activate_2FaMutation = { otpActivate: boolean };

export type CurrenciesQueryVariables = Exact<{
  currency_id: Scalars['String'];
  period: Scalars['Int'];
}>;


export type CurrenciesQuery = { dashboardCurrencyWindowWidgets: any };

export type PaymentAnalyticsQueryVariables = Exact<{
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  currency_id: Scalars['String'];
}>;


export type PaymentAnalyticsQuery = { analyticsWidgetPaymentAnalytics?: { averageBill?: { value: number, data?: Array<{ date: any, value: number } | null> | null } | null, count?: { value: number, data?: Array<{ value: number, date: any } | null> | null } | null, return?: { value: number, data?: Array<{ date: any, value: number } | null> | null } | null, balance?: { value: number, data?: Array<{ value: number, date: any } | null> | null } | null } | null };

export type GetDashboardProgressStatusQueryVariables = Exact<{
  dateStart: Scalars['date'];
  currency_id: Scalars['String'];
}>;


export type GetDashboardProgressStatusQuery = { dashboardWidgetsStatusChart?: Array<{ count: number, status: string }> | null };

export type GetDashboardSalesPerCurrencyQueryVariables = Exact<{
  currency_id_1: Scalars['String'];
  currency_id_2: Scalars['String'];
  dateStart: Scalars['date'];
}>;


export type GetDashboardSalesPerCurrencyQuery = { currency_id_1: any, currency_id_2: any };

export type GetDashboardStatusQueryVariables = Exact<{
  dateStart: Scalars['date'];
  currency_id: Scalars['String'];
}>;


export type GetDashboardStatusQuery = { dashboardWidgetsStatusChart?: Array<{ count: number, status: string }> | null };

export type GetDashboardSalesQueryVariables = Exact<{
  currency_id: Scalars['String'];
}>;


export type GetDashboardSalesQuery = { dashboardWidgetsSalesChart?: { last_week?: Array<{ amount: any, date: any }> | null, this_week?: Array<{ amount: any, date: any }> | null } | null };

export type GetWithdrawalStatusQueryVariables = Exact<{
  currency_id: Scalars['String'];
  dateStart: Scalars['date'];
  dateEnd?: InputMaybe<Scalars['date']>;
}>;


export type GetWithdrawalStatusQuery = { dashboardWidgetsWithdrawlChart?: { data?: Array<{ _count: number, status: string } | null> | null } | null };

export type GateGroupBalanceDynamicsQueryVariables = Exact<{
  gate_group_id: Scalars['String'];
}>;


export type GateGroupBalanceDynamicsQuery = { gateAnalyticsBalanceHistory: { invoice?: Array<{ created_at: any, sum: any }> | null, withdraw?: Array<{ created_at: any, sum: any }> | null } };

export type ConversionQueryVariables = Exact<{
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  gate_group_id: Scalars['String'];
}>;


export type ConversionQuery = { gateAnalyticsConversion?: Array<{ type: string, status: string, count: number } | null> | null };

export type GateGroupInfoQueryVariables = Exact<{
  where?: InputMaybe<GateGroupBoolExp>;
}>;


export type GateGroupInfoQuery = { gate_group: Array<{ id: string, name?: string | null, balance?: { calculated_balance?: any | null } | null, active_gate: Array<{ id?: string | null, gate_type_id?: string | null, payment_system?: string | null, currency_id?: string | null, rolling_reserve_duration?: number | null, rolling_reserve_percent?: any | null, fee?: { merchant_constant_fee?: any | null, merchant_fee_min_amount?: any | null, merchant_fee_percent?: any | null, merchant_transaction_fee_amount?: any | null, merchant_settlement_usdt_fee_percent?: any | null } | null }> }> };

export type RollingReserveQueryVariables = Exact<{
  where: VActiveRollingReserveBoolExp;
}>;


export type RollingReserveQuery = { v_active_rolling_reserve: Array<{ rolling_reserve_amount?: any | null }> };

export type GateAnalyticsLimitsQueryVariables = Exact<{
  gate_group_id: Scalars['String'];
}>;


export type GateAnalyticsLimitsQuery = { gateAnalyticsLimits?: { invoice?: { payment_limit_amount: any, payment_limit_duration: number, payment_limit_reset_date: any, processing_amount: any } | null, withdraw?: { payment_limit_amount: any, payment_limit_duration: number, payment_limit_reset_date: any, processing_amount: any } | null } | null };

export type RejectedTransactionsQueryVariables = Exact<{
  invoiceWhere?: InputMaybe<InvoiceBoolExp>;
  withdrawWhere?: InputMaybe<WithdrawBoolExp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type RejectedTransactionsQuery = { invoice: Array<{ id: number, created_at: any, transaction_uid?: string | null, remark?: string | null, gate?: { gate_group_id?: string | null } | null }>, invoice_aggregate: { aggregate?: { count: number } | null }, withdraw: Array<{ id: number, created_at: any, transaction_uid?: string | null, remark?: string | null }>, withdraw_aggregate: { aggregate?: { count: number } | null } };

export type GetGateGroupsQueryVariables = Exact<{
  where?: InputMaybe<GateGroupBoolExp>;
}>;


export type GetGateGroupsQuery = { gate_group: Array<{ id: string, name?: string | null, balance?: { calculated_balance?: any | null } | null, active_gate: Array<{ currency_id?: string | null, gate_type_id?: string | null, payment_system?: string | null, traffic_type_id?: string | null, provider?: { default_traffic_type_id?: string | null, provider_countries: Array<{ country: { country_region_id?: string | null } }> } | null }> }> };

export type AddUserMutationVariables = Exact<{
  email: Scalars['String'];
  gender_id: Scalars['String'];
  merchant_id: Scalars['Int'];
  merchant_user_role_id: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  phone: Scalars['String'];
}>;


export type AddUserMutation = { usersCreatePartnerManager: boolean };

export type ChangeOtherEmployeePasswordMutationVariables = Exact<{
  user_id: Scalars['Int'];
  password: Scalars['String'];
}>;


export type ChangeOtherEmployeePasswordMutation = { usersChangePasswordManager: boolean };

export type DeleteUserInfoMutationVariables = Exact<{
  where: MerchantUserBoolExp;
}>;


export type DeleteUserInfoMutation = { delete_merchant_user?: { affected_rows: number } | null };

export type MerchantInfoQueryVariables = Exact<{
  where?: InputMaybe<MerchantBoolExp>;
}>;


export type MerchantInfoQuery = { merchant: Array<{ redirect_failed_url?: string | null, redirect_success_url?: string | null }> };

export type GetMerchantUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMerchantUsersQuery = { merchant_user: Array<{ id: number, merchant_user_role_id: string, user?: { id: number, user_info?: { name?: string | null, gender_id?: string | null, phone: string, email: string } | null } | null }> };

export type WithdrawPayoutMutationVariables = Exact<{
  card_number: Scalars['String'];
  id: Scalars['String'];
}>;


export type WithdrawPayoutMutation = { withdrawRequestPayout: any };

export type ChangeOwnEmployeePasswordMutationVariables = Exact<{
  old_password: Scalars['String'];
  password: Scalars['String'];
}>;


export type ChangeOwnEmployeePasswordMutation = { usersChangePassword: boolean };

export type UserInvoicesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where: InvoiceBoolExp;
}>;


export type UserInvoicesQuery = { invoice: Array<{ id: number, created_at: any, status_updated_at: any, external_id?: string | null, currency_id: string, amount: any, merchant_invoice_fee: any, sanitized_mask?: string | null, status?: string | null, gate_id?: string | null, remark?: string | null, is_chargeback: boolean, is_refund: boolean, is_manual: boolean, comment?: string | null, transaction_uid?: string | null, gate?: { gate_group?: { name?: string | null } | null } | null }>, invoice_aggregate: { aggregate?: { count: number } | null } };

export type GetMerchantTaskQueryVariables = Exact<{
  where?: InputMaybe<MerchantTaskBoolExp>;
}>;


export type GetMerchantTaskQuery = { merchant_task: Array<{ id: any, merchant_task_status: { id: string } }> };

export type UpdateUserInfoMutationVariables = Exact<{
  _set: UserInfoSetInput;
  where: UserInfoBoolExp;
}>;


export type UpdateUserInfoMutation = { update_user_info?: { returning: Array<{ __typename: 'user_info', birthday?: any | null, email: string, gender_id?: string | null, name?: string | null, phone: string, telegram?: string | null, whatsapp?: string | null, user_id: number }> } | null };

export type AuthLoginMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
}>;


export type AuthLoginMutation = { authLogin?: { access_token?: string | null, error_code?: string | null } | null };

export type AuthLogin2FaMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
}>;


export type AuthLogin2FaMutation = { authLogin?: { access_token?: string | null, error_code?: string | null } | null };

export type UsersActivateMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type UsersActivateMutation = { usersActivate?: { access_token: string } | null };

export type RegisterRestorePasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type RegisterRestorePasswordMutation = { usersRegisterRestorePassword: boolean };

export type RestorePasswordMutationVariables = Exact<{
  token: Scalars['String'];
  password: Scalars['String'];
}>;


export type RestorePasswordMutation = { usersRestorePassword: boolean };

export type GetUserBaseInfoQueryVariables = Exact<{
  user_id?: InputMaybe<Scalars['Int']>;
}>;


export type GetUserBaseInfoQuery = { user_info: Array<{ email: string, name?: string | null }>, merchant_user: Array<{ merchant_id?: number | null, merchant_user_role_id: string }> };

export type GetUser2FaQueryVariables = Exact<{
  where?: InputMaybe<UserBoolExp>;
}>;


export type GetUser2FaQuery = { user: Array<{ otp_enable?: boolean | null }> };

export type GetActiveGateGroupQueryVariables = Exact<{
  whereGateGroup?: InputMaybe<GateGroupBoolExp>;
  whereActiveGate?: InputMaybe<VActiveGateBoolExp>;
}>;


export type GetActiveGateGroupQuery = { gate_group: Array<{ id: string, name?: string | null, active_gate: Array<{ id?: string | null, gate_type_id?: string | null, currency_id?: string | null, alias?: string | null }> }> };

export type BalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type BalanceQuery = { merchant_balance: Array<{ currency_id: string, balance: any, hold_balance: any }> };

export type MassWithdrawCreateMutationVariables = Exact<{
  amount: Scalars['numeric'];
  callback_url?: InputMaybe<Scalars['String']>;
  card_expires: Scalars['String'];
  card_holder: Scalars['String'];
  card_number: Scalars['String'];
  comment: Scalars['String'];
  currency_id: Scalars['String'];
  external_id: Scalars['String'];
  withdraw_url?: InputMaybe<Scalars['String']>;
  gate_id?: InputMaybe<Scalars['String']>;
}>;


export type MassWithdrawCreateMutation = { withdrawMassWithdrawCreate?: { comment?: string | null, withdraw_url?: string | null } | null };

export type WithdrawRefundMutationVariables = Exact<{
  amount: Scalars['Float'];
  card_expires: Scalars['String'];
  card_holder: Scalars['String'];
  card_number: Scalars['String'];
  comment: Scalars['String'];
  external_id: Scalars['String'];
  transaction_uid: Scalars['String'];
}>;


export type WithdrawRefundMutation = { withdrawRefundCreate: any };

export type CryptoWithdrawRequestStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type CryptoWithdrawRequestStatusQuery = { crypto_withdraw_request_status: Array<{ name?: string | null, id: string }> };

export type GetAllCurrencyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCurrencyQuery = { currency: Array<{ id: string, icon?: string | null }> };

export type GetMerchantCurrencyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMerchantCurrencyQuery = { merchant_currency: Array<{ currency: { id: string, icon?: string | null } }> };

export type DashboardBalanceInHeaderQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardBalanceInHeaderQuery = { dashboardBalanceInHeader?: Array<{ balance: any, currency_id: string }> | null };

export type BalanceDynamicsQueryVariables = Exact<{ [key: string]: never; }>;


export type BalanceDynamicsQuery = { dashboardBalanceDynamics: any };

export type GetSettingsQueryVariables = Exact<{
  where: SettingBoolExp;
}>;


export type GetSettingsQuery = { setting: Array<{ key: string, value?: any | null }> };

export type DashboardMerchantFeeQueryVariables = Exact<{
  amount: Scalars['numeric'];
  currency_id: Scalars['String'];
  gate_id?: InputMaybe<Scalars['String']>;
  gate_type_id: Scalars['String'];
  payment_system?: InputMaybe<Scalars['String']>;
}>;


export type DashboardMerchantFeeQuery = { feeMerchantFee?: { fee: any } | null };

export type GetAllActiveGateQueryVariables = Exact<{
  where?: InputMaybe<VActiveGateBoolExp>;
}>;


export type GetAllActiveGateQuery = { v_active_gate: Array<{ id?: string | null, alias?: string | null }> };

export type GetAllGenderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllGenderQuery = { gender: Array<{ id: string }> };

export type GetAllGeoRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllGeoRegionsQuery = { country_region: Array<{ id: string }> };

export type GetHelpQueryVariables = Exact<{
  language_id_eq: Scalars['String'];
}>;


export type GetHelpQuery = { help: Array<{ question: string, answer: string, id: number, help_section: { name?: string | null } }> };

export type UpdateMerchantInfoMutationVariables = Exact<{
  _set?: InputMaybe<MerchantSetInput>;
  where: MerchantBoolExp;
}>;


export type UpdateMerchantInfoMutation = { update_merchant?: { returning: Array<{ __typename: 'merchant', redirect_success_url?: string | null, redirect_failed_url?: string | null }> } | null };

export type GetMerchantQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMerchantQuery = { merchant: Array<{ mass_withdraw_enabled: boolean, withdraw_enabled?: boolean | null, refund_enabled: boolean }> };

export type UpdateNotificationMutationVariables = Exact<{
  where: MerchantNotificationBoolExp;
  _set?: InputMaybe<MerchantNotificationSetInput>;
}>;


export type UpdateNotificationMutation = { update_merchant_notification?: { returning: Array<{ id: number, value?: string | null, merchant_id?: number | null }> } | null };

export type InsertNotificationMutationVariables = Exact<{
  objects: Array<MerchantNotificationInsertInput> | MerchantNotificationInsertInput;
}>;


export type InsertNotificationMutation = { insert_merchant_notification?: { returning: Array<{ id: number, notification_type_id?: string | null, value?: string | null, merchant_id?: number | null }> } | null };

export type DeleteNotificationMutationVariables = Exact<{
  where: MerchantNotificationBoolExp;
}>;


export type DeleteNotificationMutation = { delete_merchant_notification?: { __typename: 'merchant_notification_mutation_response' } | null };

export type NotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsQuery = { merchant_notification: Array<{ merchant_id?: number | null, id: number, notification_type_id?: string | null, updated_at: any, value?: string | null, created_at: any, active?: boolean | null }> };

export type SaveReportMutationVariables = Exact<{
  currency_id: Scalars['String'];
  date_from: Scalars['date'];
  date_to: Scalars['date'];
  gate_id?: InputMaybe<Scalars['String']>;
  gate_group_id?: InputMaybe<Scalars['String']>;
}>;


export type SaveReportMutation = { saveReports?: { task_id: string } | null };

export type GetReportQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReportQuery = { user_reports: Array<{ id: number, name?: string | null, user_id?: number | null, merchant_id?: number | null, date_from?: any | null, date_to?: any | null, data?: any | null }> };

export type GetSavedReportsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MerchantFileBoolExp>;
}>;


export type GetSavedReportsQuery = { merchant_file: Array<{ id: any, type: string, created_at: any, merchant_task?: { payload?: any | null } | null }>, merchant_file_aggregate: { aggregate?: { count: number } | null } };

export type DeleteReportMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteReportMutation = { delete_merchant_file_by_pk?: { id: any } | null };

export type CryptoRejectRequestMutationVariables = Exact<{
  withdrawRequestId: Scalars['Int'];
}>;


export type CryptoRejectRequestMutation = { cryptoWithdrawRequestCancel: { result: { id: number } } };

export type RejectRequestMutationVariables = Exact<{
  id: Scalars['String'];
  reason: Scalars['String'];
}>;


export type RejectRequestMutation = { withdrawRequestReject: boolean };

export type GetSpecificBalanceQueryVariables = Exact<{
  currency_id: Scalars['String'];
}>;


export type GetSpecificBalanceQuery = { dashboardBalanceByCurrencyId?: { balance?: string | null, currency_id?: string | null } | null };

export type GetAllTrafficTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTrafficTypeQuery = { traffic_type: Array<{ id: string }> };

export type GetUserInfoQueryVariables = Exact<{
  where?: InputMaybe<UserInfoBoolExp>;
}>;


export type GetUserInfoQuery = { user_info: Array<{ __typename: 'user_info', birthday?: any | null, email: string, gender_id?: string | null, name?: string | null, phone: string, telegram?: string | null, whatsapp?: string | null, user_id: number }> };

export type GetWidgetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWidgetsQuery = { merchant_widget: Array<{ params: any, sort?: number | null, widget_type?: string | null }> };

export type WithdrawRequestStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type WithdrawRequestStatusQuery = { withdraw_request_status: Array<{ name?: string | null, id: string }> };

export type GetReportDataQueryVariables = Exact<{
  date_to: Scalars['date'];
  date_from: Scalars['date'];
  currency_id: Scalars['String'];
  gate_id?: InputMaybe<Scalars['String']>;
  gate_group_id?: InputMaybe<Scalars['String']>;
}>;


export type GetReportDataQuery = { reportsTotal?: { items: Array<{ amount: number, chargesName: string, counter?: number | null, rateFee: number, total: number } | null> } | null, reportsSummary?: { items: Array<{ key: string, value: number } | null> } | null, reportsRefundedReserveDetails?: { items: Array<{ amount: number, chargesName: string, counter?: number | null, rateFee: number, total: number } | null> } | null, reportsGeneratedReserveDetails?: { items: Array<{ amount: number, chargesName: string, counter?: number | null, rateFee: number, total: number } | null> } | null, reportsTransactionDetails?: { items: Array<{ amount: number, chargesName: string, counter?: number | null, rateFee: number, total: number } | null> } | null, reportsRefundDetails?: { items: Array<{ amount: number, chargesName: string, counter?: number | null, rateFee: number, total: number } | null> } | null, reportsChargebackDetails?: { items: Array<{ amount: number, chargesName: string, counter?: number | null, rateFee: number, total: number } | null> } | null, reportsChargesDetails?: { items: Array<{ amount: number, chargesName: string, counter?: number | null, rateFee: number, total: number } | null> } | null, reportsGeneralInfo?: { items: Array<{ key: string, value?: string | null } | null> } | null };


export const GetDashboardWalletsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDashboardWallets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboardWallet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency_id"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<GetDashboardWalletsQuery, GetDashboardWalletsQueryVariables>;
export const MerchantTaskCreateReportRejectedTransactionTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MerchantTaskCreateReportRejectedTransactionTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"external_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transaction_uid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"is_manual"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchantTaskCreateReportRejectedTransactionTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"date_from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_from"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_to"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"external_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"external_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"transaction_uid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transaction_uid"}}},{"kind":"Argument","name":{"kind":"Name","value":"is_manual"},"value":{"kind":"Variable","name":{"kind":"Name","value":"is_manual"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<MerchantTaskCreateReportRejectedTransactionTaskMutation, MerchantTaskCreateReportRejectedTransactionTaskMutationVariables>;
export const Disable2FaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Disable2Fa"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"otpDisable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}]}]}}]} as unknown as DocumentNode<Disable2FaMutation, Disable2FaMutationVariables>;
export const OrganizationMerchantInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizationMerchantInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"merchant_info_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchant_info"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"business_address"}},{"kind":"Field","name":{"kind":"Name","value":"chargeback_ratio"}},{"kind":"Field","name":{"kind":"Name","value":"company_name"}},{"kind":"Field","name":{"kind":"Name","value":"company_website"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"month_turnover"}},{"kind":"Field","name":{"kind":"Name","value":"payments_geo"}},{"kind":"Field","name":{"kind":"Name","value":"registered_address"}},{"kind":"Field","name":{"kind":"Name","value":"registration_data"}},{"kind":"Field","name":{"kind":"Name","value":"registration_number"}}]}}]}}]} as unknown as DocumentNode<OrganizationMerchantInfoQuery, OrganizationMerchantInfoQueryVariables>;
export const GetTokensDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchant_api_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<GetTokensQuery, GetTokensQueryVariables>;
export const CreateApiTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateApiToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createApiToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"api_token"}}]}}]}}]} as unknown as DocumentNode<CreateApiTokenMutation, CreateApiTokenMutationVariables>;
export const DeleteApiTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteApiToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_merchant_api_token"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteApiTokenMutation, DeleteApiTokenMutationVariables>;
export const GetWhitelistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWhitelist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchant_file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"whitelist_card","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"upload_file_name"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<GetWhitelistQuery, GetWhitelistQueryVariables>;
export const MerchantTaskCreateReportTransactionManagementTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MerchantTaskCreateReportTransactionManagementTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"external_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transaction_uid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"is_manual"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchantTaskCreateReportTransactionManagementTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"date_from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_from"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_to"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"status_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"currency_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"external_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"external_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"transaction_uid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transaction_uid"}}},{"kind":"Argument","name":{"kind":"Name","value":"is_manual"},"value":{"kind":"Variable","name":{"kind":"Name","value":"is_manual"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<MerchantTaskCreateReportTransactionManagementTaskMutation, MerchantTaskCreateReportTransactionManagementTaskMutationVariables>;
export const GetChargebackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetChargeback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"v_lk_chargeback_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"v_lk_chargeback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"currency_id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"chargeback_fee"}},{"kind":"Field","name":{"kind":"Name","value":"invoice_transaction_uid"}},{"kind":"Field","name":{"kind":"Name","value":"withdraw_transaction_uid"}},{"kind":"Field","name":{"kind":"Name","value":"gate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gate_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"v_lk_chargeback_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetChargebackQuery, GetChargebackQueryVariables>;
export const CreateInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"external_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}},{"kind":"Argument","name":{"kind":"Name","value":"currency_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"external_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"external_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice_url"}}]}}]}}]} as unknown as DocumentNode<CreateInvoiceMutation, CreateInvoiceMutationVariables>;
export const RefundCreateRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RefundCreateRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transaction_uid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refundCreateRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"transaction_uid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transaction_uid"}}},{"kind":"Argument","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}}]}]}}]} as unknown as DocumentNode<RefundCreateRequestMutation, RefundCreateRequestMutationVariables>;
export const GetRefundsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRefunds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gate_group_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invoice_transaction_uid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withdraw_transaction_uid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refund_table_where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"refund_table_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refundsFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"date_from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_from"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_to"}}},{"kind":"Argument","name":{"kind":"Name","value":"currency_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_group_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_group_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"invoice_transaction_uid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoice_transaction_uid"}}},{"kind":"Argument","name":{"kind":"Name","value":"withdraw_transaction_uid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withdraw_transaction_uid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refund_id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"gate_group_name"}},{"kind":"Field","name":{"kind":"Name","value":"invoice_transaction_uid"}},{"kind":"Field","name":{"kind":"Name","value":"withdraw_transaction_uid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"refund_table"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refund_table_where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invoice_transaction_uid"}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency_id"}},{"kind":"Field","name":{"kind":"Name","value":"gate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gate_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"refund_request_status_id"}},{"kind":"Field","name":{"kind":"Name","value":"refund_reason"}},{"kind":"Field","name":{"kind":"Name","value":"refund_fee"}},{"kind":"Field","name":{"kind":"Name","value":"reject_reason"}},{"kind":"Field","name":{"kind":"Name","value":"withdraw_transaction_uid"}}]}}]}}]} as unknown as DocumentNode<GetRefundsQuery, GetRefundsQueryVariables>;
export const WithdrawRequestCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"WithdrawRequestCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sanitized_mask"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"withdrawRequestCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}},{"kind":"Argument","name":{"kind":"Name","value":"currency_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"sanitized_mask"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sanitized_mask"}}}]}]}}]} as unknown as DocumentNode<WithdrawRequestCreateMutation, WithdrawRequestCreateMutationVariables>;
export const GetAllWithdrawRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllWithdrawRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"withdraw_request"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"approved_at"}},{"kind":"Field","name":{"kind":"Name","value":"client_ip"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"currency_id"}},{"kind":"Field","name":{"kind":"Name","value":"merchant_id"}},{"kind":"Field","name":{"kind":"Name","value":"merchant_withdraw_fee_amount"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"provider_id"}},{"kind":"Field","name":{"kind":"Name","value":"sanitized_mask"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"withdraw_request_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllWithdrawRequestQuery, GetAllWithdrawRequestQueryVariables>;
export const MerchantTaskCreateReportWithdrawalsPayoutTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MerchantTaskCreateReportWithdrawalsPayoutTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"external_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transaction_uid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"is_manual"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchantTaskCreateReportWithdrawalsPayoutTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"date_from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_from"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_to"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"currency_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"status_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"external_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"external_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"transaction_uid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transaction_uid"}}},{"kind":"Argument","name":{"kind":"Name","value":"is_manual"},"value":{"kind":"Variable","name":{"kind":"Name","value":"is_manual"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<MerchantTaskCreateReportWithdrawalsPayoutTaskMutation, MerchantTaskCreateReportWithdrawalsPayoutTaskMutationVariables>;
export const GetAllWithdrawsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllWithdraws"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"withdraw_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"withdraw"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status_updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"gate_id"}},{"kind":"Field","name":{"kind":"Name","value":"currency_id"}},{"kind":"Field","name":{"kind":"Name","value":"card_system_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_uid"}},{"kind":"Field","name":{"kind":"Name","value":"merchant_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sanitized_mask"}},{"kind":"Field","name":{"kind":"Name","value":"merchant_withdraw_fee"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"status_updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"is_manual"}},{"kind":"Field","name":{"kind":"Name","value":"remark"}},{"kind":"Field","name":{"kind":"Name","value":"sanitized_mask"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"withdraw_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllWithdrawsQuery, GetAllWithdrawsQueryVariables>;
export const CryptoWithdrawRequestCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CryptoWithdrawRequestCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"account"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"crypto_currency"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fiat_amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fiat_currency"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cryptoWithdrawRequestCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"account"},"value":{"kind":"Variable","name":{"kind":"Name","value":"account"}}},{"kind":"Argument","name":{"kind":"Name","value":"crypto_currency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"crypto_currency"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"fiat_amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fiat_amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"fiat_currency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fiat_currency"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CryptoWithdrawRequestCreateMutation, CryptoWithdrawRequestCreateMutationVariables>;
export const GetAllCryptoWithdrawRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllCryptoWithdrawRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crypto_withdraw_request"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fiat_amount"}},{"kind":"Field","name":{"kind":"Name","value":"crypto_amount"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"fiat_currency_id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"account_number"}},{"kind":"Field","name":{"kind":"Name","value":"crypto_withdraw_request_status_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"merchant_fee_percent"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"key_approve"}},{"kind":"Field","name":{"kind":"Name","value":"merchant_settlement_fee_amount"}},{"kind":"Field","name":{"kind":"Name","value":"merchant_settlement_fee_percent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"crypto_withdraw_request_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllCryptoWithdrawRequestQuery, GetAllCryptoWithdrawRequestQueryVariables>;
export const RegistrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Registration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersRegistrationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usersRegistration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RegistrationMutation, RegistrationMutationVariables>;
export const RequestQrDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"REQUEST_QR"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"otpRequestActivate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qr_code_data"}}]}}]}}]} as unknown as DocumentNode<RequestQrMutation, RequestQrMutationVariables>;
export const Activate_2FaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ACTIVATE_2FA"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"otpActivate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}]}]}}]} as unknown as DocumentNode<Activate_2FaMutation, Activate_2FaMutationVariables>;
export const CurrenciesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Currencies"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"period"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboardCurrencyWindowWidgets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"currency_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"days"},"value":{"kind":"Variable","name":{"kind":"Name","value":"period"}}}]}]}}]} as unknown as DocumentNode<CurrenciesQuery, CurrenciesQueryVariables>;
export const PaymentAnalyticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaymentAnalytics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"analyticsWidgetPaymentAnalytics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"currency_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_from"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_to"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"averageBill"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"return"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"balance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<PaymentAnalyticsQuery, PaymentAnalyticsQueryVariables>;
export const GetDashboardProgressStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDashboardProgressStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateStart"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboardWidgetsStatusChart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"currency_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateStart"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<GetDashboardProgressStatusQuery, GetDashboardProgressStatusQueryVariables>;
export const GetDashboardSalesPerCurrencyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDashboardSalesPerCurrency"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency_id_1"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency_id_2"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateStart"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"currency_id_1"},"name":{"kind":"Name","value":"dashboardWidgetsSalesPerCurrencyChart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"currency_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency_id_1"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateStart"}}}]},{"kind":"Field","alias":{"kind":"Name","value":"currency_id_2"},"name":{"kind":"Name","value":"dashboardWidgetsSalesPerCurrencyChart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"currency_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency_id_2"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateStart"}}}]}]}}]} as unknown as DocumentNode<GetDashboardSalesPerCurrencyQuery, GetDashboardSalesPerCurrencyQueryVariables>;
export const GetDashboardStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDashboardStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateStart"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboardWidgetsStatusChart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"currency_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateStart"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<GetDashboardStatusQuery, GetDashboardStatusQueryVariables>;
export const GetDashboardSalesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDashboardSales"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboardWidgetsSalesChart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"currency_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"last_week"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"this_week"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}}]}}]} as unknown as DocumentNode<GetDashboardSalesQuery, GetDashboardSalesQueryVariables>;
export const GetWithdrawalStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWithdrawalStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateStart"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateEnd"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboardWidgetsWithdrawlChart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"currency_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateStart"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateEnd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateEnd"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<GetWithdrawalStatusQuery, GetWithdrawalStatusQueryVariables>;
export const GateGroupBalanceDynamicsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GATE_GROUP_BALANCE_DYNAMICS"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gate_group_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gateAnalyticsBalanceHistory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"gate_group_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_group_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"sum"}}]}},{"kind":"Field","name":{"kind":"Name","value":"withdraw"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"sum"}}]}}]}}]}}]} as unknown as DocumentNode<GateGroupBalanceDynamicsQuery, GateGroupBalanceDynamicsQueryVariables>;
export const ConversionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CONVERSION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gate_group_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gateAnalyticsConversion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"date_from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_from"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_to"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_group_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_group_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<ConversionQuery, ConversionQueryVariables>;
export const GateGroupInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GATE_GROUP_INFO"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"gate_group_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gate_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"balance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculated_balance"}}]}},{"kind":"Field","name":{"kind":"Name","value":"active_gate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gate_type_id"}},{"kind":"Field","name":{"kind":"Name","value":"payment_system"}},{"kind":"Field","name":{"kind":"Name","value":"currency_id"}},{"kind":"Field","name":{"kind":"Name","value":"rolling_reserve_duration"}},{"kind":"Field","name":{"kind":"Name","value":"rolling_reserve_percent"}},{"kind":"Field","name":{"kind":"Name","value":"fee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchant_constant_fee"}},{"kind":"Field","name":{"kind":"Name","value":"merchant_fee_min_amount"}},{"kind":"Field","name":{"kind":"Name","value":"merchant_fee_percent"}},{"kind":"Field","name":{"kind":"Name","value":"merchant_transaction_fee_amount"}},{"kind":"Field","name":{"kind":"Name","value":"merchant_settlement_usdt_fee_percent"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GateGroupInfoQuery, GateGroupInfoQueryVariables>;
export const RollingReserveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ROLLING_RESERVE"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"v_active_rolling_reserve_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"v_active_rolling_reserve"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rolling_reserve_amount"}}]}}]}}]} as unknown as DocumentNode<RollingReserveQuery, RollingReserveQueryVariables>;
export const GateAnalyticsLimitsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"gateAnalyticsLimits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gate_group_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gateAnalyticsLimits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"gate_group_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_group_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payment_limit_amount"}},{"kind":"Field","name":{"kind":"Name","value":"payment_limit_duration"}},{"kind":"Field","name":{"kind":"Name","value":"payment_limit_reset_date"}},{"kind":"Field","name":{"kind":"Name","value":"processing_amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"withdraw"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payment_limit_amount"}},{"kind":"Field","name":{"kind":"Name","value":"payment_limit_duration"}},{"kind":"Field","name":{"kind":"Name","value":"payment_limit_reset_date"}},{"kind":"Field","name":{"kind":"Name","value":"processing_amount"}}]}}]}}]}}]} as unknown as DocumentNode<GateAnalyticsLimitsQuery, GateAnalyticsLimitsQueryVariables>;
export const RejectedTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"REJECTED_TRANSACTIONS"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invoiceWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"invoice_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withdrawWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"withdraw_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoiceWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_uid"}},{"kind":"Field","name":{"kind":"Name","value":"remark"}},{"kind":"Field","name":{"kind":"Name","value":"gate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gate_group_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoice_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoiceWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"withdraw"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withdrawWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_uid"}},{"kind":"Field","name":{"kind":"Name","value":"remark"}}]}},{"kind":"Field","name":{"kind":"Name","value":"withdraw_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withdrawWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<RejectedTransactionsQuery, RejectedTransactionsQueryVariables>;
export const GetGateGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_GATE_GROUPS"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"gate_group_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gate_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"balance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculated_balance"}}]}},{"kind":"Field","name":{"kind":"Name","value":"active_gate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency_id"}},{"kind":"Field","name":{"kind":"Name","value":"gate_type_id"}},{"kind":"Field","name":{"kind":"Name","value":"payment_system"}},{"kind":"Field","name":{"kind":"Name","value":"traffic_type_id"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default_traffic_type_id"}},{"kind":"Field","name":{"kind":"Name","value":"provider_countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country_region_id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetGateGroupsQuery, GetGateGroupsQueryVariables>;
export const AddUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gender_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"merchant_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"merchant_user_role_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usersCreatePartnerManager"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"gender_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gender_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"merchant_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"merchant_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"merchant_user_role_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"merchant_user_role_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}}]}]}}]} as unknown as DocumentNode<AddUserMutation, AddUserMutationVariables>;
export const ChangeOtherEmployeePasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeOtherEmployeePassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usersChangePasswordManager"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}]}]}}]} as unknown as DocumentNode<ChangeOtherEmployeePasswordMutation, ChangeOtherEmployeePasswordMutationVariables>;
export const DeleteUserInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUserInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"merchant_user_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_merchant_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteUserInfoMutation, DeleteUserInfoMutationVariables>;
export const MerchantInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MerchantInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"merchant_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redirect_failed_url"}},{"kind":"Field","name":{"kind":"Name","value":"redirect_success_url"}}]}}]}}]} as unknown as DocumentNode<MerchantInfoQuery, MerchantInfoQueryVariables>;
export const GetMerchantUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMerchantUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchant_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"merchant_user_role_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"gender_id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMerchantUsersQuery, GetMerchantUsersQueryVariables>;
export const WithdrawPayoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"WithdrawPayout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"card_number"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"withdrawRequestPayout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"card_number"},"value":{"kind":"Variable","name":{"kind":"Name","value":"card_number"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<WithdrawPayoutMutation, WithdrawPayoutMutationVariables>;
export const ChangeOwnEmployeePasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeOwnEmployeePassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"old_password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usersChangePassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"old_password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"old_password"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}]}]}}]} as unknown as DocumentNode<ChangeOwnEmployeePasswordMutation, ChangeOwnEmployeePasswordMutationVariables>;
export const UserInvoicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserInvoices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"invoice_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status_updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"status_updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"external_id"}},{"kind":"Field","name":{"kind":"Name","value":"currency_id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"merchant_invoice_fee"}},{"kind":"Field","name":{"kind":"Name","value":"sanitized_mask"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"gate_id"}},{"kind":"Field","name":{"kind":"Name","value":"gate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gate_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"remark"}},{"kind":"Field","name":{"kind":"Name","value":"is_chargeback"}},{"kind":"Field","name":{"kind":"Name","value":"is_refund"}},{"kind":"Field","name":{"kind":"Name","value":"is_manual"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_uid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoice_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<UserInvoicesQuery, UserInvoicesQueryVariables>;
export const GetMerchantTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMerchantTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"merchant_task_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchant_task"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"merchant_task_status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetMerchantTaskQuery, GetMerchantTaskQueryVariables>;
export const UpdateUserInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_info_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_info_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_user_info"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_set"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"whatsapp"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserInfoMutation, UpdateUserInfoMutationVariables>;
export const AuthLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AuthLogin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authLogin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"access_token"}},{"kind":"Field","name":{"kind":"Name","value":"error_code"}}]}}]}}]} as unknown as DocumentNode<AuthLoginMutation, AuthLoginMutationVariables>;
export const AuthLogin2FaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AuthLogin2FA"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authLogin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"access_token"}},{"kind":"Field","name":{"kind":"Name","value":"error_code"}}]}}]}}]} as unknown as DocumentNode<AuthLogin2FaMutation, AuthLogin2FaMutationVariables>;
export const UsersActivateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"usersActivate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usersActivate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"access_token"}}]}}]}}]} as unknown as DocumentNode<UsersActivateMutation, UsersActivateMutationVariables>;
export const RegisterRestorePasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RegisterRestorePassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usersRegisterRestorePassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}]}}]} as unknown as DocumentNode<RegisterRestorePasswordMutation, RegisterRestorePasswordMutationVariables>;
export const RestorePasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RestorePassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usersRestorePassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}]}]}}]} as unknown as DocumentNode<RestorePasswordMutation, RestorePasswordMutationVariables>;
export const GetUserBaseInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserBaseInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_info"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"merchant_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchant_id"}},{"kind":"Field","name":{"kind":"Name","value":"merchant_user_role_id"}}]}}]}}]} as unknown as DocumentNode<GetUserBaseInfoQuery, GetUserBaseInfoQueryVariables>;
export const GetUser2FaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUser2FA"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"user_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"otp_enable"}}]}}]}}]} as unknown as DocumentNode<GetUser2FaQuery, GetUser2FaQueryVariables>;
export const GetActiveGateGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActiveGateGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereGateGroup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"gate_group_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereActiveGate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"v_active_gate_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gate_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereGateGroup"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active_gate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereActiveGate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gate_type_id"}},{"kind":"Field","name":{"kind":"Name","value":"currency_id"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}}]}}]} as unknown as DocumentNode<GetActiveGateGroupQuery, GetActiveGateGroupQueryVariables>;
export const BalanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Balance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchant_balance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"currency"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"merchant_currencies"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"show_in_header"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency_id"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"hold_balance"}}]}}]}}]} as unknown as DocumentNode<BalanceQuery, BalanceQueryVariables>;
export const MassWithdrawCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MASS_WITHDRAW_CREATE"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"callback_url"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"card_expires"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"card_holder"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"card_number"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"external_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withdraw_url"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"withdrawMassWithdrawCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"card_expires"},"value":{"kind":"Variable","name":{"kind":"Name","value":"card_expires"}}},{"kind":"Argument","name":{"kind":"Name","value":"card_holder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"card_holder"}}},{"kind":"Argument","name":{"kind":"Name","value":"card_number"},"value":{"kind":"Variable","name":{"kind":"Name","value":"card_number"}}},{"kind":"Argument","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}},{"kind":"Argument","name":{"kind":"Name","value":"currency_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"external_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"external_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"callback_url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"callback_url"}}},{"kind":"Argument","name":{"kind":"Name","value":"withdraw_url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withdraw_url"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"withdraw_url"}}]}}]}}]} as unknown as DocumentNode<MassWithdrawCreateMutation, MassWithdrawCreateMutationVariables>;
export const WithdrawRefundDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"WITHDRAW_REFUND"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"card_expires"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"card_holder"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"card_number"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"external_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transaction_uid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"withdrawRefundCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"card_expires"},"value":{"kind":"Variable","name":{"kind":"Name","value":"card_expires"}}},{"kind":"Argument","name":{"kind":"Name","value":"external_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"external_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}},{"kind":"Argument","name":{"kind":"Name","value":"card_number"},"value":{"kind":"Variable","name":{"kind":"Name","value":"card_number"}}},{"kind":"Argument","name":{"kind":"Name","value":"card_holder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"card_holder"}}},{"kind":"Argument","name":{"kind":"Name","value":"transaction_uid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transaction_uid"}}}]}]}}]} as unknown as DocumentNode<WithdrawRefundMutation, WithdrawRefundMutationVariables>;
export const CryptoWithdrawRequestStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CryptoWithdrawRequestStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crypto_withdraw_request_status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CryptoWithdrawRequestStatusQuery, CryptoWithdrawRequestStatusQueryVariables>;
export const GetAllCurrencyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllCurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}}]}}]} as unknown as DocumentNode<GetAllCurrencyQuery, GetAllCurrencyQueryVariables>;
export const GetMerchantCurrencyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMerchantCurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchant_currency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"currency"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}}]}}]}}]} as unknown as DocumentNode<GetMerchantCurrencyQuery, GetMerchantCurrencyQueryVariables>;
export const DashboardBalanceInHeaderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dashboardBalanceInHeader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboardBalanceInHeader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"currency_id"}}]}}]}}]} as unknown as DocumentNode<DashboardBalanceInHeaderQuery, DashboardBalanceInHeaderQueryVariables>;
export const BalanceDynamicsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BalanceDynamics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboardBalanceDynamics"}}]}}]} as unknown as DocumentNode<BalanceDynamicsQuery, BalanceDynamicsQueryVariables>;
export const GetSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"setting_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<GetSettingsQuery, GetSettingsQueryVariables>;
export const DashboardMerchantFeeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DashboardMerchantFee"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gate_type_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payment_system"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeMerchantFee"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"currency_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_type_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_type_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"payment_system"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payment_system"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fee"}}]}}]}}]} as unknown as DocumentNode<DashboardMerchantFeeQuery, DashboardMerchantFeeQueryVariables>;
export const GetAllActiveGateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllActiveGate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"v_active_gate_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"v_active_gate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}}]} as unknown as DocumentNode<GetAllActiveGateQuery, GetAllActiveGateQueryVariables>;
export const GetAllGenderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllGENDER"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetAllGenderQuery, GetAllGenderQueryVariables>;
export const GetAllGeoRegionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllGeoRegions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country_region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetAllGeoRegionsQuery, GetAllGeoRegionsQueryVariables>;
export const GetHelpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getHelp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language_id_eq"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"help"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"help_section"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"language_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language_id_eq"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"help_section"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetHelpQuery, GetHelpQueryVariables>;
export const UpdateMerchantInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMerchantInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_set"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"merchant_set_input"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"merchant_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_merchant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_set"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redirect_success_url"}},{"kind":"Field","name":{"kind":"Name","value":"redirect_failed_url"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateMerchantInfoMutation, UpdateMerchantInfoMutationVariables>;
export const GetMerchantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_MERCHANT"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mass_withdraw_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"withdraw_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"refund_enabled"}}]}}]}}]} as unknown as DocumentNode<GetMerchantQuery, GetMerchantQueryVariables>;
export const UpdateNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"merchant_notification_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_set"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"merchant_notification_set_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_merchant_notification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"merchant_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateNotificationMutation, UpdateNotificationMutationVariables>;
export const InsertNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"merchant_notification_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_merchant_notification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notification_type_id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"merchant_id"}}]}}]}}]}}]} as unknown as DocumentNode<InsertNotificationMutation, InsertNotificationMutationVariables>;
export const DeleteNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"merchant_notification_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_merchant_notification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<DeleteNotificationMutation, DeleteNotificationMutationVariables>;
export const NotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchant_notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchant_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notification_type_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<NotificationsQuery, NotificationsQueryVariables>;
export const SaveReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gate_group_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveReports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"currency_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_from"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_to"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_group_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_group_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task_id"}}]}}]}}]} as unknown as DocumentNode<SaveReportMutation, SaveReportMutationVariables>;
export const GetReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_reports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"merchant_id"}},{"kind":"Field","name":{"kind":"Name","value":"date_from"}},{"kind":"Field","name":{"kind":"Name","value":"date_to"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]} as unknown as DocumentNode<GetReportQuery, GetReportQueryVariables>;
export const GetSavedReportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSavedReports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"merchant_file_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchant_file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"merchant_task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payload"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"merchant_file_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetSavedReportsQuery, GetSavedReportsQueryVariables>;
export const DeleteReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_merchant_file_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteReportMutation, DeleteReportMutationVariables>;
export const CryptoRejectRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CryptoRejectRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withdrawRequestId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cryptoWithdrawRequestCancel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"withdrawRequestId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withdrawRequestId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CryptoRejectRequestMutation, CryptoRejectRequestMutationVariables>;
export const RejectRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RejectRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reason"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"withdrawRequestReject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"reason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reason"}}}]}]}}]} as unknown as DocumentNode<RejectRequestMutation, RejectRequestMutationVariables>;
export const GetSpecificBalanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSpecificBalance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboardBalanceByCurrencyId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"currency_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"currency_id"}}]}}]}}]} as unknown as DocumentNode<GetSpecificBalanceQuery, GetSpecificBalanceQueryVariables>;
export const GetAllTrafficTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllTrafficType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"traffic_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetAllTrafficTypeQuery, GetAllTrafficTypeQueryVariables>;
export const GetUserInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"user_info_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_info"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"whatsapp"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<GetUserInfoQuery, GetUserInfoQueryVariables>;
export const GetWidgetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWidgets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchant_widget"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"params"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"widget_type"}}]}}]}}]} as unknown as DocumentNode<GetWidgetsQuery, GetWidgetsQueryVariables>;
export const WithdrawRequestStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WithdrawRequestStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"withdraw_request_status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<WithdrawRequestStatusQuery, WithdrawRequestStatusQueryVariables>;
export const GetReportDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReportData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gate_group_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportsTotal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"date_from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_from"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_to"}}},{"kind":"Argument","name":{"kind":"Name","value":"currency_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_group_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_group_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"chargesName"}},{"kind":"Field","name":{"kind":"Name","value":"counter"}},{"kind":"Field","name":{"kind":"Name","value":"rateFee"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportsSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"date_from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_from"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_to"}}},{"kind":"Argument","name":{"kind":"Name","value":"currency_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_group_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_group_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportsRefundedReserveDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"date_from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_from"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_to"}}},{"kind":"Argument","name":{"kind":"Name","value":"currency_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_group_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_group_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"chargesName"}},{"kind":"Field","name":{"kind":"Name","value":"counter"}},{"kind":"Field","name":{"kind":"Name","value":"rateFee"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportsGeneratedReserveDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"date_from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_from"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_to"}}},{"kind":"Argument","name":{"kind":"Name","value":"currency_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_group_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_group_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"chargesName"}},{"kind":"Field","name":{"kind":"Name","value":"counter"}},{"kind":"Field","name":{"kind":"Name","value":"rateFee"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportsTransactionDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"date_from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_from"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_to"}}},{"kind":"Argument","name":{"kind":"Name","value":"currency_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_group_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_group_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"chargesName"}},{"kind":"Field","name":{"kind":"Name","value":"counter"}},{"kind":"Field","name":{"kind":"Name","value":"rateFee"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportsRefundDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"date_from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_from"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_to"}}},{"kind":"Argument","name":{"kind":"Name","value":"currency_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_group_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_group_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"chargesName"}},{"kind":"Field","name":{"kind":"Name","value":"counter"}},{"kind":"Field","name":{"kind":"Name","value":"rateFee"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportsChargebackDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"date_from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_from"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_to"}}},{"kind":"Argument","name":{"kind":"Name","value":"currency_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_group_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_group_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"chargesName"}},{"kind":"Field","name":{"kind":"Name","value":"counter"}},{"kind":"Field","name":{"kind":"Name","value":"rateFee"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportsChargesDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"date_from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_from"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_to"}}},{"kind":"Argument","name":{"kind":"Name","value":"currency_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_group_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_group_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"chargesName"}},{"kind":"Field","name":{"kind":"Name","value":"counter"}},{"kind":"Field","name":{"kind":"Name","value":"rateFee"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportsGeneralInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"date_from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_from"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_to"}}},{"kind":"Argument","name":{"kind":"Name","value":"currency_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"gate_group_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gate_group_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<GetReportDataQuery, GetReportDataQueryVariables>;